
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return import.meta.resolve($parcel$distDir + url);
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0d6f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0d6f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7rM61", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ho8Ig"));

});
parcelRegister("ho8Ig", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $ca8b6fc20fde6bea$export$ffb0004e005737fa, (v) => $ca8b6fc20fde6bea$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $ca8b6fc20fde6bea$export$34b9dba7ce09269b, (v) => $ca8b6fc20fde6bea$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $ca8b6fc20fde6bea$export$25062201e9e25d76, (v) => $ca8b6fc20fde6bea$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ca8b6fc20fde6bea$export$ffb0004e005737fa;
var $ca8b6fc20fde6bea$export$34b9dba7ce09269b;
var $ca8b6fc20fde6bea$export$25062201e9e25d76;
"use strict";
var $ca8b6fc20fde6bea$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $ca8b6fc20fde6bea$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $ca8b6fc20fde6bea$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $ca8b6fc20fde6bea$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$ca8b6fc20fde6bea$export$ffb0004e005737fa = $ca8b6fc20fde6bea$var$REACT_FRAGMENT_TYPE;
$ca8b6fc20fde6bea$export$34b9dba7ce09269b = $ca8b6fc20fde6bea$var$jsxProd;
$ca8b6fc20fde6bea$export$25062201e9e25d76 = $ca8b6fc20fde6bea$var$jsxProd;

});


parcelRegister("jXEQt", function(module, exports) {
'use strict';

module.exports = (parcelRequire("j7kdz"));

});
parcelRegister("j7kdz", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $deae5a9825218b42$export$9c16c1426311996d, (v) => $deae5a9825218b42$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $deae5a9825218b42$export$dca3b0875bd9a954, (v) => $deae5a9825218b42$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $deae5a9825218b42$export$16fa2f45be04daa8, (v) => $deae5a9825218b42$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $deae5a9825218b42$export$ffb0004e005737fa, (v) => $deae5a9825218b42$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $deae5a9825218b42$export$e2c29f18771995cb, (v) => $deae5a9825218b42$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $deae5a9825218b42$export$221d75b3f55bb0bd, (v) => $deae5a9825218b42$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $deae5a9825218b42$export$5f8d39834fd61797, (v) => $deae5a9825218b42$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $deae5a9825218b42$export$74bf444e3cd11ea5, (v) => $deae5a9825218b42$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $deae5a9825218b42$export$1ced07cd6b1985ce, (v) => $deae5a9825218b42$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $deae5a9825218b42$export$abd8e32b826d7ea7, (v) => $deae5a9825218b42$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $deae5a9825218b42$export$69a3209f1a06c04d, (v) => $deae5a9825218b42$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $deae5a9825218b42$export$8c538325882c7eec, (v) => $deae5a9825218b42$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $deae5a9825218b42$export$e530037191fcd5d7, (v) => $deae5a9825218b42$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $deae5a9825218b42$export$fd42f52fd3ae1109, (v) => $deae5a9825218b42$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $deae5a9825218b42$export$c8a8987d4410bf2d, (v) => $deae5a9825218b42$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $deae5a9825218b42$export$7d1e3a5e95ceca43, (v) => $deae5a9825218b42$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $deae5a9825218b42$export$257a8862b851cb5b, (v) => $deae5a9825218b42$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $deae5a9825218b42$export$a8257692ac88316c, (v) => $deae5a9825218b42$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $deae5a9825218b42$export$488013bae63b21da, (v) => $deae5a9825218b42$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $deae5a9825218b42$export$7c73462e0d25e514, (v) => $deae5a9825218b42$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $deae5a9825218b42$export$7568632d0d33d16d, (v) => $deae5a9825218b42$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $deae5a9825218b42$export$f93f40ac0ca7e3a8, (v) => $deae5a9825218b42$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $deae5a9825218b42$export$1f96ae73734a86cc, (v) => $deae5a9825218b42$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $deae5a9825218b42$export$9a47ced3238df325, (v) => $deae5a9825218b42$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $deae5a9825218b42$export$35808ee640e87ca7, (v) => $deae5a9825218b42$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $deae5a9825218b42$export$fae74005e78b1a27, (v) => $deae5a9825218b42$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $deae5a9825218b42$export$dc8fbce3eb94dc1e, (v) => $deae5a9825218b42$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $deae5a9825218b42$export$6a7bc4e911dc01cf, (v) => $deae5a9825218b42$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $deae5a9825218b42$export$6d9c69b0de29b591, (v) => $deae5a9825218b42$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $deae5a9825218b42$export$7f54fc3180508a52, (v) => $deae5a9825218b42$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $deae5a9825218b42$export$f680877a34711e37, (v) => $deae5a9825218b42$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $deae5a9825218b42$export$d5a552a76deda3c2, (v) => $deae5a9825218b42$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $deae5a9825218b42$export$aaabe4eda9ed9969, (v) => $deae5a9825218b42$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $deae5a9825218b42$export$e5c5a5f917a5871c, (v) => $deae5a9825218b42$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $deae5a9825218b42$export$1538c33de8887b59, (v) => $deae5a9825218b42$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $deae5a9825218b42$export$fca7f784ae7a249a, (v) => $deae5a9825218b42$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $deae5a9825218b42$export$13e3392192263954, (v) => $deae5a9825218b42$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $deae5a9825218b42$export$b8f5890fc79d6aca, (v) => $deae5a9825218b42$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $deae5a9825218b42$export$60241385465d0a34, (v) => $deae5a9825218b42$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $deae5a9825218b42$export$306c0aa65ff9ec16, (v) => $deae5a9825218b42$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $deae5a9825218b42$export$7b286972b8d8ccbf, (v) => $deae5a9825218b42$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $deae5a9825218b42$export$83d89fbfd8236492, (v) => $deae5a9825218b42$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $deae5a9825218b42$export$9c16c1426311996d;
var $deae5a9825218b42$export$dca3b0875bd9a954;
var $deae5a9825218b42$export$16fa2f45be04daa8;
var $deae5a9825218b42$export$ffb0004e005737fa;
var $deae5a9825218b42$export$e2c29f18771995cb;
var $deae5a9825218b42$export$221d75b3f55bb0bd;
var $deae5a9825218b42$export$5f8d39834fd61797;
var $deae5a9825218b42$export$74bf444e3cd11ea5;
var $deae5a9825218b42$export$1ced07cd6b1985ce;
var $deae5a9825218b42$export$abd8e32b826d7ea7;
var $deae5a9825218b42$export$69a3209f1a06c04d;
var $deae5a9825218b42$export$8c538325882c7eec;
var $deae5a9825218b42$export$e530037191fcd5d7;
var $deae5a9825218b42$export$fd42f52fd3ae1109;
var $deae5a9825218b42$export$c8a8987d4410bf2d;
var $deae5a9825218b42$export$7d1e3a5e95ceca43;
var $deae5a9825218b42$export$257a8862b851cb5b;
var $deae5a9825218b42$export$a8257692ac88316c;
var $deae5a9825218b42$export$488013bae63b21da;
var $deae5a9825218b42$export$7c73462e0d25e514;
var $deae5a9825218b42$export$7568632d0d33d16d;
var $deae5a9825218b42$export$f93f40ac0ca7e3a8;
var $deae5a9825218b42$export$1f96ae73734a86cc;
var $deae5a9825218b42$export$9a47ced3238df325;
var $deae5a9825218b42$export$35808ee640e87ca7;
var $deae5a9825218b42$export$fae74005e78b1a27;
var $deae5a9825218b42$export$dc8fbce3eb94dc1e;
var $deae5a9825218b42$export$6a7bc4e911dc01cf;
var $deae5a9825218b42$export$6d9c69b0de29b591;
var $deae5a9825218b42$export$7f54fc3180508a52;
var $deae5a9825218b42$export$f680877a34711e37;
var $deae5a9825218b42$export$d5a552a76deda3c2;
var $deae5a9825218b42$export$aaabe4eda9ed9969;
var $deae5a9825218b42$export$e5c5a5f917a5871c;
var $deae5a9825218b42$export$1538c33de8887b59;
var $deae5a9825218b42$export$fca7f784ae7a249a;
var $deae5a9825218b42$export$13e3392192263954;
var $deae5a9825218b42$export$b8f5890fc79d6aca;
var $deae5a9825218b42$export$60241385465d0a34;
var $deae5a9825218b42$export$306c0aa65ff9ec16;
var $deae5a9825218b42$export$7b286972b8d8ccbf;
var $deae5a9825218b42$export$83d89fbfd8236492;
"use strict";
var $deae5a9825218b42$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $deae5a9825218b42$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $deae5a9825218b42$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $deae5a9825218b42$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $deae5a9825218b42$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $deae5a9825218b42$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $deae5a9825218b42$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $deae5a9825218b42$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $deae5a9825218b42$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $deae5a9825218b42$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $deae5a9825218b42$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $deae5a9825218b42$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $deae5a9825218b42$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $deae5a9825218b42$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $deae5a9825218b42$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$deae5a9825218b42$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $deae5a9825218b42$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $deae5a9825218b42$var$assign = Object.assign, $deae5a9825218b42$var$emptyObject = {};
function $deae5a9825218b42$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $deae5a9825218b42$var$emptyObject;
    this.updater = updater || $deae5a9825218b42$var$ReactNoopUpdateQueue;
}
$deae5a9825218b42$var$Component.prototype.isReactComponent = {};
$deae5a9825218b42$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$deae5a9825218b42$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $deae5a9825218b42$var$ComponentDummy() {}
$deae5a9825218b42$var$ComponentDummy.prototype = $deae5a9825218b42$var$Component.prototype;
function $deae5a9825218b42$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $deae5a9825218b42$var$emptyObject;
    this.updater = updater || $deae5a9825218b42$var$ReactNoopUpdateQueue;
}
var $deae5a9825218b42$var$pureComponentPrototype = $deae5a9825218b42$var$PureComponent.prototype = new $deae5a9825218b42$var$ComponentDummy();
$deae5a9825218b42$var$pureComponentPrototype.constructor = $deae5a9825218b42$var$PureComponent;
$deae5a9825218b42$var$assign($deae5a9825218b42$var$pureComponentPrototype, $deae5a9825218b42$var$Component.prototype);
$deae5a9825218b42$var$pureComponentPrototype.isPureReactComponent = !0;
var $deae5a9825218b42$var$isArrayImpl = Array.isArray;
function $deae5a9825218b42$var$noop() {}
var $deae5a9825218b42$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $deae5a9825218b42$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $deae5a9825218b42$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $deae5a9825218b42$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $deae5a9825218b42$var$cloneAndReplaceKey(oldElement, newKey) {
    return $deae5a9825218b42$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $deae5a9825218b42$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $deae5a9825218b42$var$REACT_ELEMENT_TYPE;
}
function $deae5a9825218b42$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $deae5a9825218b42$var$userProvidedKeyEscapeRegex = /\/+/g;
function $deae5a9825218b42$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $deae5a9825218b42$var$escape("" + element.key) : index.toString(36);
}
function $deae5a9825218b42$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($deae5a9825218b42$var$noop, $deae5a9825218b42$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $deae5a9825218b42$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $deae5a9825218b42$var$REACT_ELEMENT_TYPE:
                case $deae5a9825218b42$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $deae5a9825218b42$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $deae5a9825218b42$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $deae5a9825218b42$var$getElementKey(children, 0) : nameSoFar, $deae5a9825218b42$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($deae5a9825218b42$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $deae5a9825218b42$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($deae5a9825218b42$var$isValidElement(callback) && (callback = $deae5a9825218b42$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($deae5a9825218b42$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($deae5a9825218b42$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $deae5a9825218b42$var$getElementKey(nameSoFar, i), invokeCallback += $deae5a9825218b42$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $deae5a9825218b42$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $deae5a9825218b42$var$getElementKey(nameSoFar, i++), invokeCallback += $deae5a9825218b42$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $deae5a9825218b42$var$mapIntoArray($deae5a9825218b42$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $deae5a9825218b42$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $deae5a9825218b42$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $deae5a9825218b42$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $deae5a9825218b42$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $deae5a9825218b42$var$Children = {
    map: $deae5a9825218b42$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $deae5a9825218b42$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $deae5a9825218b42$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $deae5a9825218b42$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$deae5a9825218b42$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$deae5a9825218b42$export$9c16c1426311996d = $deae5a9825218b42$var$REACT_ACTIVITY_TYPE;
$deae5a9825218b42$export$dca3b0875bd9a954 = $deae5a9825218b42$var$Children;
$deae5a9825218b42$export$16fa2f45be04daa8 = $deae5a9825218b42$var$Component;
$deae5a9825218b42$export$ffb0004e005737fa = $deae5a9825218b42$var$REACT_FRAGMENT_TYPE;
$deae5a9825218b42$export$e2c29f18771995cb = $deae5a9825218b42$var$REACT_PROFILER_TYPE;
$deae5a9825218b42$export$221d75b3f55bb0bd = $deae5a9825218b42$var$PureComponent;
$deae5a9825218b42$export$5f8d39834fd61797 = $deae5a9825218b42$var$REACT_STRICT_MODE_TYPE;
$deae5a9825218b42$export$74bf444e3cd11ea5 = $deae5a9825218b42$var$REACT_SUSPENSE_TYPE;
$deae5a9825218b42$export$1ced07cd6b1985ce = $deae5a9825218b42$var$ReactSharedInternals;
$deae5a9825218b42$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $deae5a9825218b42$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$deae5a9825218b42$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$deae5a9825218b42$export$8c538325882c7eec = function() {
    return null;
};
$deae5a9825218b42$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $deae5a9825218b42$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$deae5a9825218b42$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $deae5a9825218b42$var$ReactElement(element.type, key, props);
};
$deae5a9825218b42$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $deae5a9825218b42$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $deae5a9825218b42$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$deae5a9825218b42$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$deae5a9825218b42$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $deae5a9825218b42$var$ReactElement(type, key, props);
};
$deae5a9825218b42$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$deae5a9825218b42$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $deae5a9825218b42$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$deae5a9825218b42$export$a8257692ac88316c = $deae5a9825218b42$var$isValidElement;
$deae5a9825218b42$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $deae5a9825218b42$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $deae5a9825218b42$var$lazyInitializer
    };
};
$deae5a9825218b42$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $deae5a9825218b42$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$deae5a9825218b42$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $deae5a9825218b42$var$ReactSharedInternals.T, currentTransition = {};
    $deae5a9825218b42$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $deae5a9825218b42$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($deae5a9825218b42$var$noop, $deae5a9825218b42$var$reportGlobalError);
    } catch (error) {
        $deae5a9825218b42$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $deae5a9825218b42$var$ReactSharedInternals.T = prevTransition;
    }
};
$deae5a9825218b42$export$f93f40ac0ca7e3a8 = function() {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useCacheRefresh();
};
$deae5a9825218b42$export$1f96ae73734a86cc = function(usable) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.use(usable);
};
$deae5a9825218b42$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$deae5a9825218b42$export$35808ee640e87ca7 = function(callback, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$deae5a9825218b42$export$fae74005e78b1a27 = function(Context) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useContext(Context);
};
$deae5a9825218b42$export$dc8fbce3eb94dc1e = function() {};
$deae5a9825218b42$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$deae5a9825218b42$export$6d9c69b0de29b591 = function(create, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useEffect(create, deps);
};
$deae5a9825218b42$export$7f54fc3180508a52 = function(callback) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$deae5a9825218b42$export$f680877a34711e37 = function() {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useId();
};
$deae5a9825218b42$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$deae5a9825218b42$export$aaabe4eda9ed9969 = function(create, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$deae5a9825218b42$export$e5c5a5f917a5871c = function(create, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$deae5a9825218b42$export$1538c33de8887b59 = function(create, deps) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useMemo(create, deps);
};
$deae5a9825218b42$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$deae5a9825218b42$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$deae5a9825218b42$export$b8f5890fc79d6aca = function(initialValue) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useRef(initialValue);
};
$deae5a9825218b42$export$60241385465d0a34 = function(initialState) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useState(initialState);
};
$deae5a9825218b42$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$deae5a9825218b42$export$7b286972b8d8ccbf = function() {
    return $deae5a9825218b42$var$ReactSharedInternals.H.useTransition();
};
$deae5a9825218b42$export$83d89fbfd8236492 = "19.2.3";

});


parcelRegister("fbV55", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $b0f42935ea826c41$export$882461b6382ed46c, (v) => $b0f42935ea826c41$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $b0f42935ea826c41$export$757ceba2d55c277e, (v) => $b0f42935ea826c41$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $b0f42935ea826c41$export$83d89fbfd8236492, (v) => $b0f42935ea826c41$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b0f42935ea826c41$export$882461b6382ed46c;
var $b0f42935ea826c41$export$757ceba2d55c277e;
var $b0f42935ea826c41$export$83d89fbfd8236492;
"use strict";

var $bIbqH = parcelRequire("bIbqH");

var $jXEQt = parcelRequire("jXEQt");

var $8vWo2 = parcelRequire("8vWo2");
function $b0f42935ea826c41$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $b0f42935ea826c41$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $b0f42935ea826c41$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $b0f42935ea826c41$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $b0f42935ea826c41$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $b0f42935ea826c41$var$assertIsMounted(fiber) {
    if ($b0f42935ea826c41$var$getNearestMountedFiber(fiber) !== fiber) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(188));
}
function $b0f42935ea826c41$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $b0f42935ea826c41$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $b0f42935ea826c41$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $b0f42935ea826c41$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $b0f42935ea826c41$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $b0f42935ea826c41$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $b0f42935ea826c41$var$assign = Object.assign, $b0f42935ea826c41$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $b0f42935ea826c41$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b0f42935ea826c41$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b0f42935ea826c41$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b0f42935ea826c41$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b0f42935ea826c41$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b0f42935ea826c41$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b0f42935ea826c41$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b0f42935ea826c41$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b0f42935ea826c41$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $b0f42935ea826c41$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b0f42935ea826c41$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $b0f42935ea826c41$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $b0f42935ea826c41$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $b0f42935ea826c41$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b0f42935ea826c41$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b0f42935ea826c41$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b0f42935ea826c41$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b0f42935ea826c41$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $b0f42935ea826c41$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $b0f42935ea826c41$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $b0f42935ea826c41$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $b0f42935ea826c41$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $b0f42935ea826c41$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $b0f42935ea826c41$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $b0f42935ea826c41$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $b0f42935ea826c41$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $b0f42935ea826c41$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $b0f42935ea826c41$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $b0f42935ea826c41$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $b0f42935ea826c41$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $b0f42935ea826c41$var$getComponentNameFromType(type.type) || "Memo";
        case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $b0f42935ea826c41$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $b0f42935ea826c41$var$isArrayImpl = Array.isArray, $b0f42935ea826c41$var$ReactSharedInternals = $jXEQt.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b0f42935ea826c41$var$ReactDOMSharedInternals = $8vWo2.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $b0f42935ea826c41$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $b0f42935ea826c41$var$valueStack = [], $b0f42935ea826c41$var$index = -1;
function $b0f42935ea826c41$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $b0f42935ea826c41$var$pop(cursor) {
    0 > $b0f42935ea826c41$var$index || (cursor.current = $b0f42935ea826c41$var$valueStack[$b0f42935ea826c41$var$index], $b0f42935ea826c41$var$valueStack[$b0f42935ea826c41$var$index] = null, $b0f42935ea826c41$var$index--);
}
function $b0f42935ea826c41$var$push(cursor, value) {
    $b0f42935ea826c41$var$index++;
    $b0f42935ea826c41$var$valueStack[$b0f42935ea826c41$var$index] = cursor.current;
    cursor.current = value;
}
var $b0f42935ea826c41$var$contextStackCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$contextFiberStackCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$rootInstanceStackCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$hostTransitionProviderCursor = $b0f42935ea826c41$var$createCursor(null);
function $b0f42935ea826c41$var$pushHostContainer(fiber, nextRootInstance) {
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$rootInstanceStackCursor, nextRootInstance);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$contextFiberStackCursor, fiber);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $b0f42935ea826c41$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $b0f42935ea826c41$var$getOwnHostContext(nextRootInstance), fiber = $b0f42935ea826c41$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$contextStackCursor);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$contextStackCursor, fiber);
}
function $b0f42935ea826c41$var$popHostContainer() {
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$contextStackCursor);
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$contextFiberStackCursor);
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$rootInstanceStackCursor);
}
function $b0f42935ea826c41$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $b0f42935ea826c41$var$push($b0f42935ea826c41$var$hostTransitionProviderCursor, fiber);
    var context = $b0f42935ea826c41$var$contextStackCursor.current;
    var JSCompiler_inline_result = $b0f42935ea826c41$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($b0f42935ea826c41$var$push($b0f42935ea826c41$var$contextFiberStackCursor, fiber), $b0f42935ea826c41$var$push($b0f42935ea826c41$var$contextStackCursor, JSCompiler_inline_result));
}
function $b0f42935ea826c41$var$popHostContext(fiber) {
    $b0f42935ea826c41$var$contextFiberStackCursor.current === fiber && ($b0f42935ea826c41$var$pop($b0f42935ea826c41$var$contextStackCursor), $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$contextFiberStackCursor));
    $b0f42935ea826c41$var$hostTransitionProviderCursor.current === fiber && ($b0f42935ea826c41$var$pop($b0f42935ea826c41$var$hostTransitionProviderCursor), $b0f42935ea826c41$var$HostTransitionContext._currentValue = $b0f42935ea826c41$var$sharedNotPendingObject);
}
var $b0f42935ea826c41$var$prefix, $b0f42935ea826c41$var$suffix;
function $b0f42935ea826c41$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $b0f42935ea826c41$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $b0f42935ea826c41$var$prefix = match && match[1] || "";
        $b0f42935ea826c41$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $b0f42935ea826c41$var$prefix + name + $b0f42935ea826c41$var$suffix;
}
var $b0f42935ea826c41$var$reentry = !1;
function $b0f42935ea826c41$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $b0f42935ea826c41$var$reentry) return "";
    $b0f42935ea826c41$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $b0f42935ea826c41$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $b0f42935ea826c41$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $b0f42935ea826c41$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $b0f42935ea826c41$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $b0f42935ea826c41$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $b0f42935ea826c41$var$describeBuiltInComponentFrame("Suspense Fallback") : $b0f42935ea826c41$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $b0f42935ea826c41$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $b0f42935ea826c41$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $b0f42935ea826c41$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $b0f42935ea826c41$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $b0f42935ea826c41$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $b0f42935ea826c41$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $b0f42935ea826c41$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $b0f42935ea826c41$var$hasOwnProperty = Object.prototype.hasOwnProperty, $b0f42935ea826c41$var$scheduleCallback$3 = $bIbqH.unstable_scheduleCallback, $b0f42935ea826c41$var$cancelCallback$1 = $bIbqH.unstable_cancelCallback, $b0f42935ea826c41$var$shouldYield = $bIbqH.unstable_shouldYield, $b0f42935ea826c41$var$requestPaint = $bIbqH.unstable_requestPaint, $b0f42935ea826c41$var$now = $bIbqH.unstable_now, $b0f42935ea826c41$var$getCurrentPriorityLevel = $bIbqH.unstable_getCurrentPriorityLevel, $b0f42935ea826c41$var$ImmediatePriority = $bIbqH.unstable_ImmediatePriority, $b0f42935ea826c41$var$UserBlockingPriority = $bIbqH.unstable_UserBlockingPriority, $b0f42935ea826c41$var$NormalPriority$1 = $bIbqH.unstable_NormalPriority, $b0f42935ea826c41$var$LowPriority = $bIbqH.unstable_LowPriority, $b0f42935ea826c41$var$IdlePriority = $bIbqH.unstable_IdlePriority, $b0f42935ea826c41$var$log$1 = $bIbqH.log, $b0f42935ea826c41$var$unstable_setDisableYieldValue = $bIbqH.unstable_setDisableYieldValue, $b0f42935ea826c41$var$rendererID = null, $b0f42935ea826c41$var$injectedHook = null;
function $b0f42935ea826c41$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $b0f42935ea826c41$var$log$1 && $b0f42935ea826c41$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($b0f42935ea826c41$var$injectedHook && "function" === typeof $b0f42935ea826c41$var$injectedHook.setStrictMode) try {
        $b0f42935ea826c41$var$injectedHook.setStrictMode($b0f42935ea826c41$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $b0f42935ea826c41$var$clz32 = Math.clz32 ? Math.clz32 : $b0f42935ea826c41$var$clz32Fallback, $b0f42935ea826c41$var$log = Math.log, $b0f42935ea826c41$var$LN2 = Math.LN2;
function $b0f42935ea826c41$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($b0f42935ea826c41$var$log(x) / $b0f42935ea826c41$var$LN2 | 0) | 0;
}
var $b0f42935ea826c41$var$nextTransitionUpdateLane = 256, $b0f42935ea826c41$var$nextTransitionDeferredLane = 262144, $b0f42935ea826c41$var$nextRetryLane = 4194304;
function $b0f42935ea826c41$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $b0f42935ea826c41$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $b0f42935ea826c41$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $b0f42935ea826c41$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $b0f42935ea826c41$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b0f42935ea826c41$var$claimNextRetryLane() {
    var lane = $b0f42935ea826c41$var$nextRetryLane;
    $b0f42935ea826c41$var$nextRetryLane <<= 1;
    0 === ($b0f42935ea826c41$var$nextRetryLane & 62914560) && ($b0f42935ea826c41$var$nextRetryLane = 4194304);
    return lane;
}
function $b0f42935ea826c41$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $b0f42935ea826c41$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $b0f42935ea826c41$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $b0f42935ea826c41$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $b0f42935ea826c41$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $b0f42935ea826c41$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $b0f42935ea826c41$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $b0f42935ea826c41$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $b0f42935ea826c41$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $b0f42935ea826c41$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $b0f42935ea826c41$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $b0f42935ea826c41$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $b0f42935ea826c41$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $b0f42935ea826c41$var$resolveUpdatePriority() {
    var updatePriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $b0f42935ea826c41$var$getEventPriority(updatePriority.type);
}
function $b0f42935ea826c41$var$runWithPriority(priority, fn) {
    var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    try {
        return $b0f42935ea826c41$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $b0f42935ea826c41$var$randomKey = Math.random().toString(36).slice(2), $b0f42935ea826c41$var$internalInstanceKey = "__reactFiber$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalPropsKey = "__reactProps$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalContainerInstanceKey = "__reactContainer$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalEventHandlersKey = "__reactEvents$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalEventHandlerListenersKey = "__reactListeners$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalEventHandlesSetKey = "__reactHandles$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalRootNodeResourcesKey = "__reactResources$" + $b0f42935ea826c41$var$randomKey, $b0f42935ea826c41$var$internalHoistableMarker = "__reactMarker$" + $b0f42935ea826c41$var$randomKey;
function $b0f42935ea826c41$var$detachDeletedInstance(node) {
    delete node[$b0f42935ea826c41$var$internalInstanceKey];
    delete node[$b0f42935ea826c41$var$internalPropsKey];
    delete node[$b0f42935ea826c41$var$internalEventHandlersKey];
    delete node[$b0f42935ea826c41$var$internalEventHandlerListenersKey];
    delete node[$b0f42935ea826c41$var$internalEventHandlesSetKey];
}
function $b0f42935ea826c41$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$b0f42935ea826c41$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$b0f42935ea826c41$var$internalContainerInstanceKey] || parentNode[$b0f42935ea826c41$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $b0f42935ea826c41$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$b0f42935ea826c41$var$internalInstanceKey]) return parentNode;
                targetNode = $b0f42935ea826c41$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $b0f42935ea826c41$var$getInstanceFromNode(node) {
    if (node = node[$b0f42935ea826c41$var$internalInstanceKey] || node[$b0f42935ea826c41$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $b0f42935ea826c41$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(33));
}
function $b0f42935ea826c41$var$getResourcesFromRoot(root) {
    var resources = root[$b0f42935ea826c41$var$internalRootNodeResourcesKey];
    resources || (resources = root[$b0f42935ea826c41$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $b0f42935ea826c41$var$markNodeAsHoistable(node) {
    node[$b0f42935ea826c41$var$internalHoistableMarker] = !0;
}
var $b0f42935ea826c41$var$allNativeEvents = new Set(), $b0f42935ea826c41$var$registrationNameDependencies = {};
function $b0f42935ea826c41$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $b0f42935ea826c41$var$registerDirectEvent(registrationName, dependencies);
    $b0f42935ea826c41$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $b0f42935ea826c41$var$registerDirectEvent(registrationName, dependencies) {
    $b0f42935ea826c41$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$b0f42935ea826c41$var$allNativeEvents.add(dependencies[registrationName]);
}
var $b0f42935ea826c41$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $b0f42935ea826c41$var$illegalAttributeNameCache = {}, $b0f42935ea826c41$var$validatedAttributeNameCache = {};
function $b0f42935ea826c41$var$isAttributeNameSafe(attributeName) {
    if ($b0f42935ea826c41$var$hasOwnProperty.call($b0f42935ea826c41$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($b0f42935ea826c41$var$hasOwnProperty.call($b0f42935ea826c41$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($b0f42935ea826c41$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $b0f42935ea826c41$var$validatedAttributeNameCache[attributeName] = !0;
    $b0f42935ea826c41$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $b0f42935ea826c41$var$setValueForAttribute(node, name, value) {
    if ($b0f42935ea826c41$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $b0f42935ea826c41$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $b0f42935ea826c41$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $b0f42935ea826c41$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $b0f42935ea826c41$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $b0f42935ea826c41$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $b0f42935ea826c41$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $b0f42935ea826c41$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $b0f42935ea826c41$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $b0f42935ea826c41$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $b0f42935ea826c41$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $b0f42935ea826c41$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $b0f42935ea826c41$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $b0f42935ea826c41$var$getToStringValue(value);
        } else element.value !== "" + $b0f42935ea826c41$var$getToStringValue(value) && (element.value = "" + $b0f42935ea826c41$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $b0f42935ea826c41$var$setDefaultValue(element, type, $b0f42935ea826c41$var$getToStringValue(value)) : null != defaultValue ? $b0f42935ea826c41$var$setDefaultValue(element, type, $b0f42935ea826c41$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $b0f42935ea826c41$var$getToStringValue(name) : element.removeAttribute("name");
}
function $b0f42935ea826c41$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $b0f42935ea826c41$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $b0f42935ea826c41$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $b0f42935ea826c41$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $b0f42935ea826c41$var$track(element);
}
function $b0f42935ea826c41$var$setDefaultValue(node, type, value) {
    "number" === type && $b0f42935ea826c41$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $b0f42935ea826c41$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $b0f42935ea826c41$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $b0f42935ea826c41$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $b0f42935ea826c41$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $b0f42935ea826c41$var$getToStringValue(defaultValue) : "";
}
function $b0f42935ea826c41$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(92));
            if ($b0f42935ea826c41$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $b0f42935ea826c41$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $b0f42935ea826c41$var$track(element);
}
function $b0f42935ea826c41$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $b0f42935ea826c41$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $b0f42935ea826c41$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $b0f42935ea826c41$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $b0f42935ea826c41$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $b0f42935ea826c41$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $b0f42935ea826c41$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $b0f42935ea826c41$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b0f42935ea826c41$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $b0f42935ea826c41$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $b0f42935ea826c41$var$sanitizeURL(url) {
    return $b0f42935ea826c41$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $b0f42935ea826c41$var$noop$1() {}
var $b0f42935ea826c41$var$currentReplayingEvent = null;
function $b0f42935ea826c41$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $b0f42935ea826c41$var$restoreTarget = null, $b0f42935ea826c41$var$restoreQueue = null;
function $b0f42935ea826c41$var$restoreStateOfTarget(target) {
    var internalInstance = $b0f42935ea826c41$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$b0f42935ea826c41$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $b0f42935ea826c41$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$b0f42935ea826c41$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(90));
                            $b0f42935ea826c41$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $b0f42935ea826c41$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $b0f42935ea826c41$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $b0f42935ea826c41$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $b0f42935ea826c41$var$isInsideEventHandler = !1;
function $b0f42935ea826c41$var$batchedUpdates$1(fn, a, b) {
    if ($b0f42935ea826c41$var$isInsideEventHandler) return fn(a, b);
    $b0f42935ea826c41$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($b0f42935ea826c41$var$isInsideEventHandler = !1, null !== $b0f42935ea826c41$var$restoreTarget || null !== $b0f42935ea826c41$var$restoreQueue) {
            if ($b0f42935ea826c41$var$flushSyncWork$1(), $b0f42935ea826c41$var$restoreTarget && (a = $b0f42935ea826c41$var$restoreTarget, fn = $b0f42935ea826c41$var$restoreQueue, $b0f42935ea826c41$var$restoreQueue = $b0f42935ea826c41$var$restoreTarget = null, $b0f42935ea826c41$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$b0f42935ea826c41$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $b0f42935ea826c41$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$b0f42935ea826c41$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $b0f42935ea826c41$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b0f42935ea826c41$var$passiveBrowserEventsSupported = !1;
if ($b0f42935ea826c41$var$canUseDOM) try {
    var $b0f42935ea826c41$var$options = {};
    Object.defineProperty($b0f42935ea826c41$var$options, "passive", {
        get: function() {
            $b0f42935ea826c41$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $b0f42935ea826c41$var$options, $b0f42935ea826c41$var$options);
    window.removeEventListener("test", $b0f42935ea826c41$var$options, $b0f42935ea826c41$var$options);
} catch (e) {
    $b0f42935ea826c41$var$passiveBrowserEventsSupported = !1;
}
var $b0f42935ea826c41$var$root = null, $b0f42935ea826c41$var$startText = null, $b0f42935ea826c41$var$fallbackText = null;
function $b0f42935ea826c41$var$getData() {
    if ($b0f42935ea826c41$var$fallbackText) return $b0f42935ea826c41$var$fallbackText;
    var start, startValue = $b0f42935ea826c41$var$startText, startLength = startValue.length, end, endValue = "value" in $b0f42935ea826c41$var$root ? $b0f42935ea826c41$var$root.value : $b0f42935ea826c41$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $b0f42935ea826c41$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $b0f42935ea826c41$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $b0f42935ea826c41$var$functionThatReturnsTrue() {
    return !0;
}
function $b0f42935ea826c41$var$functionThatReturnsFalse() {
    return !1;
}
function $b0f42935ea826c41$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $b0f42935ea826c41$var$functionThatReturnsTrue : $b0f42935ea826c41$var$functionThatReturnsFalse;
        this.isPropagationStopped = $b0f42935ea826c41$var$functionThatReturnsFalse;
        return this;
    }
    $b0f42935ea826c41$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $b0f42935ea826c41$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $b0f42935ea826c41$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $b0f42935ea826c41$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $b0f42935ea826c41$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b0f42935ea826c41$var$SyntheticEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$EventInterface), $b0f42935ea826c41$var$UIEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    view: 0,
    detail: 0
}), $b0f42935ea826c41$var$SyntheticUIEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$UIEventInterface), $b0f42935ea826c41$var$lastMovementX, $b0f42935ea826c41$var$lastMovementY, $b0f42935ea826c41$var$lastMouseEvent, $b0f42935ea826c41$var$MouseEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b0f42935ea826c41$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $b0f42935ea826c41$var$lastMouseEvent && ($b0f42935ea826c41$var$lastMouseEvent && "mousemove" === event.type ? ($b0f42935ea826c41$var$lastMovementX = event.screenX - $b0f42935ea826c41$var$lastMouseEvent.screenX, $b0f42935ea826c41$var$lastMovementY = event.screenY - $b0f42935ea826c41$var$lastMouseEvent.screenY) : $b0f42935ea826c41$var$lastMovementY = $b0f42935ea826c41$var$lastMovementX = 0, $b0f42935ea826c41$var$lastMouseEvent = event);
        return $b0f42935ea826c41$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $b0f42935ea826c41$var$lastMovementY;
    }
}), $b0f42935ea826c41$var$SyntheticMouseEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$MouseEventInterface), $b0f42935ea826c41$var$DragEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$MouseEventInterface, {
    dataTransfer: 0
}), $b0f42935ea826c41$var$SyntheticDragEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$DragEventInterface), $b0f42935ea826c41$var$FocusEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$UIEventInterface, {
    relatedTarget: 0
}), $b0f42935ea826c41$var$SyntheticFocusEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$FocusEventInterface), $b0f42935ea826c41$var$AnimationEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b0f42935ea826c41$var$SyntheticAnimationEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$AnimationEventInterface), $b0f42935ea826c41$var$ClipboardEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $b0f42935ea826c41$var$SyntheticClipboardEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$ClipboardEventInterface), $b0f42935ea826c41$var$CompositionEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    data: 0
}), $b0f42935ea826c41$var$SyntheticCompositionEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$CompositionEventInterface), $b0f42935ea826c41$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b0f42935ea826c41$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b0f42935ea826c41$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b0f42935ea826c41$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $b0f42935ea826c41$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $b0f42935ea826c41$var$getEventModifierState() {
    return $b0f42935ea826c41$var$modifierStateGetter;
}
var $b0f42935ea826c41$var$KeyboardEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $b0f42935ea826c41$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $b0f42935ea826c41$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $b0f42935ea826c41$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b0f42935ea826c41$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $b0f42935ea826c41$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $b0f42935ea826c41$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $b0f42935ea826c41$var$SyntheticKeyboardEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$KeyboardEventInterface), $b0f42935ea826c41$var$PointerEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b0f42935ea826c41$var$SyntheticPointerEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$PointerEventInterface), $b0f42935ea826c41$var$TouchEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b0f42935ea826c41$var$getEventModifierState
}), $b0f42935ea826c41$var$SyntheticTouchEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$TouchEventInterface), $b0f42935ea826c41$var$TransitionEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b0f42935ea826c41$var$SyntheticTransitionEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$TransitionEventInterface), $b0f42935ea826c41$var$WheelEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b0f42935ea826c41$var$SyntheticWheelEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$WheelEventInterface), $b0f42935ea826c41$var$ToggleEventInterface = $b0f42935ea826c41$var$assign({}, $b0f42935ea826c41$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $b0f42935ea826c41$var$SyntheticToggleEvent = $b0f42935ea826c41$var$createSyntheticEvent($b0f42935ea826c41$var$ToggleEventInterface), $b0f42935ea826c41$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $b0f42935ea826c41$var$canUseCompositionEvent = $b0f42935ea826c41$var$canUseDOM && "CompositionEvent" in window, $b0f42935ea826c41$var$documentMode = null;
$b0f42935ea826c41$var$canUseDOM && "documentMode" in document && ($b0f42935ea826c41$var$documentMode = document.documentMode);
var $b0f42935ea826c41$var$canUseTextInputEvent = $b0f42935ea826c41$var$canUseDOM && "TextEvent" in window && !$b0f42935ea826c41$var$documentMode, $b0f42935ea826c41$var$useFallbackCompositionData = $b0f42935ea826c41$var$canUseDOM && (!$b0f42935ea826c41$var$canUseCompositionEvent || $b0f42935ea826c41$var$documentMode && 8 < $b0f42935ea826c41$var$documentMode && 11 >= $b0f42935ea826c41$var$documentMode), $b0f42935ea826c41$var$SPACEBAR_CHAR = String.fromCharCode(32), $b0f42935ea826c41$var$hasSpaceKeypress = !1;
function $b0f42935ea826c41$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $b0f42935ea826c41$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b0f42935ea826c41$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $b0f42935ea826c41$var$isComposing = !1;
function $b0f42935ea826c41$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $b0f42935ea826c41$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $b0f42935ea826c41$var$hasSpaceKeypress = !0;
            return $b0f42935ea826c41$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $b0f42935ea826c41$var$SPACEBAR_CHAR && $b0f42935ea826c41$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $b0f42935ea826c41$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($b0f42935ea826c41$var$isComposing) return "compositionend" === domEventName || !$b0f42935ea826c41$var$canUseCompositionEvent && $b0f42935ea826c41$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $b0f42935ea826c41$var$getData(), $b0f42935ea826c41$var$fallbackText = $b0f42935ea826c41$var$startText = $b0f42935ea826c41$var$root = null, $b0f42935ea826c41$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $b0f42935ea826c41$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $b0f42935ea826c41$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b0f42935ea826c41$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$b0f42935ea826c41$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $b0f42935ea826c41$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $b0f42935ea826c41$var$restoreTarget ? $b0f42935ea826c41$var$restoreQueue ? $b0f42935ea826c41$var$restoreQueue.push(target) : $b0f42935ea826c41$var$restoreQueue = [
        target
    ] : $b0f42935ea826c41$var$restoreTarget = target;
    inst = $b0f42935ea826c41$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $b0f42935ea826c41$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $b0f42935ea826c41$var$activeElement$1 = null, $b0f42935ea826c41$var$activeElementInst$1 = null;
function $b0f42935ea826c41$var$runEventInBatch(dispatchQueue) {
    $b0f42935ea826c41$var$processDispatchQueue(dispatchQueue, 0);
}
function $b0f42935ea826c41$var$getInstIfValueChanged(targetInst) {
    var targetNode = $b0f42935ea826c41$var$getNodeFromInstance(targetInst);
    if ($b0f42935ea826c41$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $b0f42935ea826c41$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $b0f42935ea826c41$var$isInputEventSupported = !1;
if ($b0f42935ea826c41$var$canUseDOM) {
    var $b0f42935ea826c41$var$JSCompiler_inline_result$jscomp$286;
    if ($b0f42935ea826c41$var$canUseDOM) {
        var $b0f42935ea826c41$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$b0f42935ea826c41$var$isSupported$jscomp$inline_427) {
            var $b0f42935ea826c41$var$element$jscomp$inline_428 = document.createElement("div");
            $b0f42935ea826c41$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $b0f42935ea826c41$var$isSupported$jscomp$inline_427 = "function" === typeof $b0f42935ea826c41$var$element$jscomp$inline_428.oninput;
        }
        $b0f42935ea826c41$var$JSCompiler_inline_result$jscomp$286 = $b0f42935ea826c41$var$isSupported$jscomp$inline_427;
    } else $b0f42935ea826c41$var$JSCompiler_inline_result$jscomp$286 = !1;
    $b0f42935ea826c41$var$isInputEventSupported = $b0f42935ea826c41$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $b0f42935ea826c41$var$stopWatchingForValueChange() {
    $b0f42935ea826c41$var$activeElement$1 && ($b0f42935ea826c41$var$activeElement$1.detachEvent("onpropertychange", $b0f42935ea826c41$var$handlePropertyChange), $b0f42935ea826c41$var$activeElementInst$1 = $b0f42935ea826c41$var$activeElement$1 = null);
}
function $b0f42935ea826c41$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $b0f42935ea826c41$var$getInstIfValueChanged($b0f42935ea826c41$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $b0f42935ea826c41$var$createAndAccumulateChangeEvent(dispatchQueue, $b0f42935ea826c41$var$activeElementInst$1, nativeEvent, $b0f42935ea826c41$var$getEventTarget(nativeEvent));
        $b0f42935ea826c41$var$batchedUpdates$1($b0f42935ea826c41$var$runEventInBatch, dispatchQueue);
    }
}
function $b0f42935ea826c41$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($b0f42935ea826c41$var$stopWatchingForValueChange(), $b0f42935ea826c41$var$activeElement$1 = target, $b0f42935ea826c41$var$activeElementInst$1 = targetInst, $b0f42935ea826c41$var$activeElement$1.attachEvent("onpropertychange", $b0f42935ea826c41$var$handlePropertyChange)) : "focusout" === domEventName && $b0f42935ea826c41$var$stopWatchingForValueChange();
}
function $b0f42935ea826c41$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $b0f42935ea826c41$var$getInstIfValueChanged($b0f42935ea826c41$var$activeElementInst$1);
}
function $b0f42935ea826c41$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $b0f42935ea826c41$var$getInstIfValueChanged(targetInst);
}
function $b0f42935ea826c41$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $b0f42935ea826c41$var$getInstIfValueChanged(targetInst);
}
function $b0f42935ea826c41$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $b0f42935ea826c41$var$objectIs = "function" === typeof Object.is ? Object.is : $b0f42935ea826c41$var$is;
function $b0f42935ea826c41$var$shallowEqual(objA, objB) {
    if ($b0f42935ea826c41$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$b0f42935ea826c41$var$hasOwnProperty.call(objB, currentKey) || !$b0f42935ea826c41$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $b0f42935ea826c41$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $b0f42935ea826c41$var$getNodeForCharacterOffset(root, offset) {
    var node = $b0f42935ea826c41$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $b0f42935ea826c41$var$getLeafNode(node);
    }
}
function $b0f42935ea826c41$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $b0f42935ea826c41$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $b0f42935ea826c41$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $b0f42935ea826c41$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $b0f42935ea826c41$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $b0f42935ea826c41$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $b0f42935ea826c41$var$skipSelectionChangeEvent = $b0f42935ea826c41$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $b0f42935ea826c41$var$activeElement = null, $b0f42935ea826c41$var$activeElementInst = null, $b0f42935ea826c41$var$lastSelection = null, $b0f42935ea826c41$var$mouseDown = !1;
function $b0f42935ea826c41$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $b0f42935ea826c41$var$mouseDown || null == $b0f42935ea826c41$var$activeElement || $b0f42935ea826c41$var$activeElement !== $b0f42935ea826c41$var$getActiveElement(doc) || (doc = $b0f42935ea826c41$var$activeElement, "selectionStart" in doc && $b0f42935ea826c41$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $b0f42935ea826c41$var$lastSelection && $b0f42935ea826c41$var$shallowEqual($b0f42935ea826c41$var$lastSelection, doc) || ($b0f42935ea826c41$var$lastSelection = doc, doc = $b0f42935ea826c41$var$accumulateTwoPhaseListeners($b0f42935ea826c41$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $b0f42935ea826c41$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $b0f42935ea826c41$var$activeElement)));
}
function $b0f42935ea826c41$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $b0f42935ea826c41$var$vendorPrefixes = {
    animationend: $b0f42935ea826c41$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $b0f42935ea826c41$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $b0f42935ea826c41$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $b0f42935ea826c41$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $b0f42935ea826c41$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $b0f42935ea826c41$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $b0f42935ea826c41$var$makePrefixMap("Transition", "TransitionEnd")
}, $b0f42935ea826c41$var$prefixedEventNames = {}, $b0f42935ea826c41$var$style = {};
$b0f42935ea826c41$var$canUseDOM && ($b0f42935ea826c41$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $b0f42935ea826c41$var$vendorPrefixes.animationend.animation, delete $b0f42935ea826c41$var$vendorPrefixes.animationiteration.animation, delete $b0f42935ea826c41$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $b0f42935ea826c41$var$vendorPrefixes.transitionend.transition);
function $b0f42935ea826c41$var$getVendorPrefixedEventName(eventName) {
    if ($b0f42935ea826c41$var$prefixedEventNames[eventName]) return $b0f42935ea826c41$var$prefixedEventNames[eventName];
    if (!$b0f42935ea826c41$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $b0f42935ea826c41$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $b0f42935ea826c41$var$style) return $b0f42935ea826c41$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $b0f42935ea826c41$var$ANIMATION_END = $b0f42935ea826c41$var$getVendorPrefixedEventName("animationend"), $b0f42935ea826c41$var$ANIMATION_ITERATION = $b0f42935ea826c41$var$getVendorPrefixedEventName("animationiteration"), $b0f42935ea826c41$var$ANIMATION_START = $b0f42935ea826c41$var$getVendorPrefixedEventName("animationstart"), $b0f42935ea826c41$var$TRANSITION_RUN = $b0f42935ea826c41$var$getVendorPrefixedEventName("transitionrun"), $b0f42935ea826c41$var$TRANSITION_START = $b0f42935ea826c41$var$getVendorPrefixedEventName("transitionstart"), $b0f42935ea826c41$var$TRANSITION_CANCEL = $b0f42935ea826c41$var$getVendorPrefixedEventName("transitioncancel"), $b0f42935ea826c41$var$TRANSITION_END = $b0f42935ea826c41$var$getVendorPrefixedEventName("transitionend"), $b0f42935ea826c41$var$topLevelEventsToReactNames = new Map(), $b0f42935ea826c41$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$b0f42935ea826c41$var$simpleEventPluginEvents.push("scrollEnd");
function $b0f42935ea826c41$var$registerSimpleEvent(domEventName, reactName) {
    $b0f42935ea826c41$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $b0f42935ea826c41$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $b0f42935ea826c41$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $b0f42935ea826c41$var$concurrentQueues = [], $b0f42935ea826c41$var$concurrentQueuesIndex = 0, $b0f42935ea826c41$var$concurrentlyUpdatedLanes = 0;
function $b0f42935ea826c41$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $b0f42935ea826c41$var$concurrentQueuesIndex, i = $b0f42935ea826c41$var$concurrentlyUpdatedLanes = $b0f42935ea826c41$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $b0f42935ea826c41$var$concurrentQueues[i];
        $b0f42935ea826c41$var$concurrentQueues[i++] = null;
        var queue = $b0f42935ea826c41$var$concurrentQueues[i];
        $b0f42935ea826c41$var$concurrentQueues[i++] = null;
        var update = $b0f42935ea826c41$var$concurrentQueues[i];
        $b0f42935ea826c41$var$concurrentQueues[i++] = null;
        var lane = $b0f42935ea826c41$var$concurrentQueues[i];
        $b0f42935ea826c41$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $b0f42935ea826c41$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $b0f42935ea826c41$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $b0f42935ea826c41$var$concurrentQueues[$b0f42935ea826c41$var$concurrentQueuesIndex++] = fiber;
    $b0f42935ea826c41$var$concurrentQueues[$b0f42935ea826c41$var$concurrentQueuesIndex++] = queue;
    $b0f42935ea826c41$var$concurrentQueues[$b0f42935ea826c41$var$concurrentQueuesIndex++] = update;
    $b0f42935ea826c41$var$concurrentQueues[$b0f42935ea826c41$var$concurrentQueuesIndex++] = lane;
    $b0f42935ea826c41$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $b0f42935ea826c41$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $b0f42935ea826c41$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $b0f42935ea826c41$var$getRootForUpdatedFiber(fiber);
}
function $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $b0f42935ea826c41$var$enqueueUpdate$1(fiber, null, null, lane);
    return $b0f42935ea826c41$var$getRootForUpdatedFiber(fiber);
}
function $b0f42935ea826c41$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $b0f42935ea826c41$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $b0f42935ea826c41$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $b0f42935ea826c41$var$nestedUpdateCount) throw $b0f42935ea826c41$var$nestedUpdateCount = 0, $b0f42935ea826c41$var$rootWithNestedUpdates = null, Error($b0f42935ea826c41$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $b0f42935ea826c41$var$emptyContextObject = {};
function $b0f42935ea826c41$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b0f42935ea826c41$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $b0f42935ea826c41$var$FiberNode(tag, pendingProps, key, mode);
}
function $b0f42935ea826c41$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $b0f42935ea826c41$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $b0f42935ea826c41$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $b0f42935ea826c41$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $b0f42935ea826c41$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $b0f42935ea826c41$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $b0f42935ea826c41$var$isHostHoistableType(type, pendingProps, $b0f42935ea826c41$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $b0f42935ea826c41$var$REACT_ACTIVITY_TYPE:
            return type = $b0f42935ea826c41$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $b0f42935ea826c41$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE:
            return $b0f42935ea826c41$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $b0f42935ea826c41$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $b0f42935ea826c41$var$REACT_PROFILER_TYPE:
            return type = $b0f42935ea826c41$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $b0f42935ea826c41$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $b0f42935ea826c41$var$REACT_SUSPENSE_TYPE:
            return type = $b0f42935ea826c41$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $b0f42935ea826c41$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $b0f42935ea826c41$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $b0f42935ea826c41$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $b0f42935ea826c41$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $b0f42935ea826c41$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $b0f42935ea826c41$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $b0f42935ea826c41$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $b0f42935ea826c41$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($b0f42935ea826c41$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $b0f42935ea826c41$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $b0f42935ea826c41$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $b0f42935ea826c41$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $b0f42935ea826c41$var$createFiberFromText(content, mode, lanes) {
    content = $b0f42935ea826c41$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $b0f42935ea826c41$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $b0f42935ea826c41$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $b0f42935ea826c41$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $b0f42935ea826c41$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $b0f42935ea826c41$var$CapturedStacks = new WeakMap();
function $b0f42935ea826c41$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $b0f42935ea826c41$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $b0f42935ea826c41$var$getStackByFiberInDevAndProd(source)
        };
        $b0f42935ea826c41$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $b0f42935ea826c41$var$getStackByFiberInDevAndProd(source)
    };
}
var $b0f42935ea826c41$var$forkStack = [], $b0f42935ea826c41$var$forkStackIndex = 0, $b0f42935ea826c41$var$treeForkProvider = null, $b0f42935ea826c41$var$treeForkCount = 0, $b0f42935ea826c41$var$idStack = [], $b0f42935ea826c41$var$idStackIndex = 0, $b0f42935ea826c41$var$treeContextProvider = null, $b0f42935ea826c41$var$treeContextId = 1, $b0f42935ea826c41$var$treeContextOverflow = "";
function $b0f42935ea826c41$var$pushTreeFork(workInProgress, totalChildren) {
    $b0f42935ea826c41$var$forkStack[$b0f42935ea826c41$var$forkStackIndex++] = $b0f42935ea826c41$var$treeForkCount;
    $b0f42935ea826c41$var$forkStack[$b0f42935ea826c41$var$forkStackIndex++] = $b0f42935ea826c41$var$treeForkProvider;
    $b0f42935ea826c41$var$treeForkProvider = workInProgress;
    $b0f42935ea826c41$var$treeForkCount = totalChildren;
}
function $b0f42935ea826c41$var$pushTreeId(workInProgress, totalChildren, index) {
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextId;
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextOverflow;
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextProvider;
    $b0f42935ea826c41$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $b0f42935ea826c41$var$treeContextId;
    workInProgress = $b0f42935ea826c41$var$treeContextOverflow;
    var baseLength = 32 - $b0f42935ea826c41$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $b0f42935ea826c41$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $b0f42935ea826c41$var$treeContextId = 1 << 32 - $b0f42935ea826c41$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $b0f42935ea826c41$var$treeContextOverflow = length + workInProgress;
    } else $b0f42935ea826c41$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $b0f42935ea826c41$var$treeContextOverflow = workInProgress;
}
function $b0f42935ea826c41$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($b0f42935ea826c41$var$pushTreeFork(workInProgress, 1), $b0f42935ea826c41$var$pushTreeId(workInProgress, 1, 0));
}
function $b0f42935ea826c41$var$popTreeContext(workInProgress) {
    for(; workInProgress === $b0f42935ea826c41$var$treeForkProvider;)$b0f42935ea826c41$var$treeForkProvider = $b0f42935ea826c41$var$forkStack[--$b0f42935ea826c41$var$forkStackIndex], $b0f42935ea826c41$var$forkStack[$b0f42935ea826c41$var$forkStackIndex] = null, $b0f42935ea826c41$var$treeForkCount = $b0f42935ea826c41$var$forkStack[--$b0f42935ea826c41$var$forkStackIndex], $b0f42935ea826c41$var$forkStack[$b0f42935ea826c41$var$forkStackIndex] = null;
    for(; workInProgress === $b0f42935ea826c41$var$treeContextProvider;)$b0f42935ea826c41$var$treeContextProvider = $b0f42935ea826c41$var$idStack[--$b0f42935ea826c41$var$idStackIndex], $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex] = null, $b0f42935ea826c41$var$treeContextOverflow = $b0f42935ea826c41$var$idStack[--$b0f42935ea826c41$var$idStackIndex], $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex] = null, $b0f42935ea826c41$var$treeContextId = $b0f42935ea826c41$var$idStack[--$b0f42935ea826c41$var$idStackIndex], $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex] = null;
}
function $b0f42935ea826c41$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextId;
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextOverflow;
    $b0f42935ea826c41$var$idStack[$b0f42935ea826c41$var$idStackIndex++] = $b0f42935ea826c41$var$treeContextProvider;
    $b0f42935ea826c41$var$treeContextId = suspendedContext.id;
    $b0f42935ea826c41$var$treeContextOverflow = suspendedContext.overflow;
    $b0f42935ea826c41$var$treeContextProvider = workInProgress;
}
var $b0f42935ea826c41$var$hydrationParentFiber = null, $b0f42935ea826c41$var$nextHydratableInstance = null, $b0f42935ea826c41$var$isHydrating = !1, $b0f42935ea826c41$var$hydrationErrors = null, $b0f42935ea826c41$var$rootOrSingletonContext = !1, $b0f42935ea826c41$var$HydrationMismatchException = Error($b0f42935ea826c41$var$formatProdErrorMessage(519));
function $b0f42935ea826c41$var$throwOnHydrationMismatch(fiber) {
    var error = Error($b0f42935ea826c41$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $b0f42935ea826c41$var$queueHydrationError($b0f42935ea826c41$var$createCapturedValueAtFiber(error, fiber));
    throw $b0f42935ea826c41$var$HydrationMismatchException;
}
function $b0f42935ea826c41$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$b0f42935ea826c41$var$internalInstanceKey] = fiber;
    instance[$b0f42935ea826c41$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("cancel", instance);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $b0f42935ea826c41$var$mediaEventTypes.length; type++)$b0f42935ea826c41$var$listenToNonDelegatedEvent($b0f42935ea826c41$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("error", instance);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", instance);
            $b0f42935ea826c41$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", instance), $b0f42935ea826c41$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $b0f42935ea826c41$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($b0f42935ea826c41$var$listenToNonDelegatedEvent("beforetoggle", instance), $b0f42935ea826c41$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $b0f42935ea826c41$var$noop$1), instance = !0) : instance = !1;
    instance || $b0f42935ea826c41$var$throwOnHydrationMismatch(fiber, !0);
}
function $b0f42935ea826c41$var$popToNextHostParent(fiber) {
    for($b0f42935ea826c41$var$hydrationParentFiber = fiber.return; $b0f42935ea826c41$var$hydrationParentFiber;)switch($b0f42935ea826c41$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $b0f42935ea826c41$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $b0f42935ea826c41$var$rootOrSingletonContext = !0;
            return;
        default:
            $b0f42935ea826c41$var$hydrationParentFiber = $b0f42935ea826c41$var$hydrationParentFiber.return;
    }
}
function $b0f42935ea826c41$var$popHydrationState(fiber) {
    if (fiber !== $b0f42935ea826c41$var$hydrationParentFiber) return !1;
    if (!$b0f42935ea826c41$var$isHydrating) return $b0f42935ea826c41$var$popToNextHostParent(fiber), $b0f42935ea826c41$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $b0f42935ea826c41$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $b0f42935ea826c41$var$nextHydratableInstance && $b0f42935ea826c41$var$throwOnHydrationMismatch(fiber);
    $b0f42935ea826c41$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(317));
        $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(317));
        $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $b0f42935ea826c41$var$nextHydratableInstance, $b0f42935ea826c41$var$isSingletonScope(fiber.type) ? (fiber = $b0f42935ea826c41$var$previousHydratableOnEnteringScopedSingleton, $b0f42935ea826c41$var$previousHydratableOnEnteringScopedSingleton = null, $b0f42935ea826c41$var$nextHydratableInstance = fiber) : $b0f42935ea826c41$var$nextHydratableInstance = tag) : $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$hydrationParentFiber ? $b0f42935ea826c41$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $b0f42935ea826c41$var$resetHydrationState() {
    $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$hydrationParentFiber = null;
    $b0f42935ea826c41$var$isHydrating = !1;
}
function $b0f42935ea826c41$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $b0f42935ea826c41$var$hydrationErrors;
    null !== queuedErrors && (null === $b0f42935ea826c41$var$workInProgressRootRecoverableErrors ? $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = queuedErrors : $b0f42935ea826c41$var$workInProgressRootRecoverableErrors.push.apply($b0f42935ea826c41$var$workInProgressRootRecoverableErrors, queuedErrors), $b0f42935ea826c41$var$hydrationErrors = null);
    return queuedErrors;
}
function $b0f42935ea826c41$var$queueHydrationError(error) {
    null === $b0f42935ea826c41$var$hydrationErrors ? $b0f42935ea826c41$var$hydrationErrors = [
        error
    ] : $b0f42935ea826c41$var$hydrationErrors.push(error);
}
var $b0f42935ea826c41$var$valueCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$currentlyRenderingFiber$1 = null, $b0f42935ea826c41$var$lastContextDependency = null;
function $b0f42935ea826c41$var$pushProvider(providerFiber, context, nextValue) {
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $b0f42935ea826c41$var$popProvider(context) {
    context._currentValue = $b0f42935ea826c41$var$valueCursor.current;
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$valueCursor);
}
function $b0f42935ea826c41$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $b0f42935ea826c41$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $b0f42935ea826c41$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $b0f42935ea826c41$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $b0f42935ea826c41$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $b0f42935ea826c41$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($b0f42935ea826c41$var$HostTransitionContext) : current = [
                $b0f42935ea826c41$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $b0f42935ea826c41$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $b0f42935ea826c41$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$b0f42935ea826c41$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $b0f42935ea826c41$var$prepareToReadContext(workInProgress) {
    $b0f42935ea826c41$var$currentlyRenderingFiber$1 = workInProgress;
    $b0f42935ea826c41$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $b0f42935ea826c41$var$readContext(context) {
    return $b0f42935ea826c41$var$readContextForConsumer($b0f42935ea826c41$var$currentlyRenderingFiber$1, context);
}
function $b0f42935ea826c41$var$readContextDuringReconciliation(consumer, context) {
    null === $b0f42935ea826c41$var$currentlyRenderingFiber$1 && $b0f42935ea826c41$var$prepareToReadContext(consumer);
    return $b0f42935ea826c41$var$readContextForConsumer(consumer, context);
}
function $b0f42935ea826c41$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $b0f42935ea826c41$var$lastContextDependency) {
        if (null === consumer) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(308));
        $b0f42935ea826c41$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $b0f42935ea826c41$var$lastContextDependency = $b0f42935ea826c41$var$lastContextDependency.next = context;
    return value;
}
var $b0f42935ea826c41$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $b0f42935ea826c41$var$scheduleCallback$2 = $bIbqH.unstable_scheduleCallback, $b0f42935ea826c41$var$NormalPriority = $bIbqH.unstable_NormalPriority, $b0f42935ea826c41$var$CacheContext = {
    $$typeof: $b0f42935ea826c41$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $b0f42935ea826c41$var$createCache() {
    return {
        controller: new $b0f42935ea826c41$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $b0f42935ea826c41$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $b0f42935ea826c41$var$scheduleCallback$2($b0f42935ea826c41$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $b0f42935ea826c41$var$currentEntangledListeners = null, $b0f42935ea826c41$var$currentEntangledPendingCount = 0, $b0f42935ea826c41$var$currentEntangledLane = 0, $b0f42935ea826c41$var$currentEntangledActionThenable = null;
function $b0f42935ea826c41$var$entangleAsyncAction(transition, thenable) {
    if (null === $b0f42935ea826c41$var$currentEntangledListeners) {
        var entangledListeners = $b0f42935ea826c41$var$currentEntangledListeners = [];
        $b0f42935ea826c41$var$currentEntangledPendingCount = 0;
        $b0f42935ea826c41$var$currentEntangledLane = $b0f42935ea826c41$var$requestTransitionLane();
        $b0f42935ea826c41$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $b0f42935ea826c41$var$currentEntangledPendingCount++;
    thenable.then($b0f42935ea826c41$var$pingEngtangledActionScope, $b0f42935ea826c41$var$pingEngtangledActionScope);
    return thenable;
}
function $b0f42935ea826c41$var$pingEngtangledActionScope() {
    if (0 === --$b0f42935ea826c41$var$currentEntangledPendingCount && null !== $b0f42935ea826c41$var$currentEntangledListeners) {
        null !== $b0f42935ea826c41$var$currentEntangledActionThenable && ($b0f42935ea826c41$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $b0f42935ea826c41$var$currentEntangledListeners;
        $b0f42935ea826c41$var$currentEntangledListeners = null;
        $b0f42935ea826c41$var$currentEntangledLane = 0;
        $b0f42935ea826c41$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $b0f42935ea826c41$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $b0f42935ea826c41$var$prevOnStartTransitionFinish = $b0f42935ea826c41$var$ReactSharedInternals.S;
$b0f42935ea826c41$var$ReactSharedInternals.S = function(transition, returnValue) {
    $b0f42935ea826c41$var$globalMostRecentTransitionTime = $b0f42935ea826c41$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $b0f42935ea826c41$var$entangleAsyncAction(transition, returnValue);
    null !== $b0f42935ea826c41$var$prevOnStartTransitionFinish && $b0f42935ea826c41$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $b0f42935ea826c41$var$resumedCache = $b0f42935ea826c41$var$createCursor(null);
function $b0f42935ea826c41$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $b0f42935ea826c41$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $b0f42935ea826c41$var$workInProgressRoot.pooledCache;
}
function $b0f42935ea826c41$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $b0f42935ea826c41$var$push($b0f42935ea826c41$var$resumedCache, $b0f42935ea826c41$var$resumedCache.current) : $b0f42935ea826c41$var$push($b0f42935ea826c41$var$resumedCache, prevCachePool.pool);
}
function $b0f42935ea826c41$var$getSuspendedCache() {
    var cacheFromPool = $b0f42935ea826c41$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $b0f42935ea826c41$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $b0f42935ea826c41$var$SuspenseException = Error($b0f42935ea826c41$var$formatProdErrorMessage(460)), $b0f42935ea826c41$var$SuspenseyCommitException = Error($b0f42935ea826c41$var$formatProdErrorMessage(474)), $b0f42935ea826c41$var$SuspenseActionException = Error($b0f42935ea826c41$var$formatProdErrorMessage(542)), $b0f42935ea826c41$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $b0f42935ea826c41$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $b0f42935ea826c41$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($b0f42935ea826c41$var$noop$1, $b0f42935ea826c41$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $b0f42935ea826c41$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($b0f42935ea826c41$var$noop$1, $b0f42935ea826c41$var$noop$1);
            else {
                thenableState = $b0f42935ea826c41$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $b0f42935ea826c41$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $b0f42935ea826c41$var$suspendedThenable = thenable;
            throw $b0f42935ea826c41$var$SuspenseException;
    }
}
function $b0f42935ea826c41$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $b0f42935ea826c41$var$suspendedThenable = x, $b0f42935ea826c41$var$SuspenseException;
        throw x;
    }
}
var $b0f42935ea826c41$var$suspendedThenable = null;
function $b0f42935ea826c41$var$getSuspendedThenable() {
    if (null === $b0f42935ea826c41$var$suspendedThenable) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(459));
    var thenable = $b0f42935ea826c41$var$suspendedThenable;
    $b0f42935ea826c41$var$suspendedThenable = null;
    return thenable;
}
function $b0f42935ea826c41$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $b0f42935ea826c41$var$SuspenseException || rejectedReason === $b0f42935ea826c41$var$SuspenseActionException) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(483));
}
var $b0f42935ea826c41$var$thenableState$1 = null, $b0f42935ea826c41$var$thenableIndexCounter$1 = 0;
function $b0f42935ea826c41$var$unwrapThenable(thenable) {
    var index = $b0f42935ea826c41$var$thenableIndexCounter$1;
    $b0f42935ea826c41$var$thenableIndexCounter$1 += 1;
    null === $b0f42935ea826c41$var$thenableState$1 && ($b0f42935ea826c41$var$thenableState$1 = []);
    return $b0f42935ea826c41$var$trackUsedThenable($b0f42935ea826c41$var$thenableState$1, thenable, index);
}
function $b0f42935ea826c41$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $b0f42935ea826c41$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $b0f42935ea826c41$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $b0f42935ea826c41$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $b0f42935ea826c41$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $b0f42935ea826c41$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $b0f42935ea826c41$var$REACT_LAZY_TYPE && $b0f42935ea826c41$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $b0f42935ea826c41$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $b0f42935ea826c41$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $b0f42935ea826c41$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $b0f42935ea826c41$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $b0f42935ea826c41$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $b0f42935ea826c41$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b0f42935ea826c41$var$REACT_ELEMENT_TYPE:
                    return lanes = $b0f42935ea826c41$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b0f42935ea826c41$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $b0f42935ea826c41$var$REACT_PORTAL_TYPE:
                    return newChild = $b0f42935ea826c41$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
                    return newChild = $b0f42935ea826c41$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($b0f42935ea826c41$var$isArrayImpl(newChild) || $b0f42935ea826c41$var$getIteratorFn(newChild)) return newChild = $b0f42935ea826c41$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $b0f42935ea826c41$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b0f42935ea826c41$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $b0f42935ea826c41$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b0f42935ea826c41$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b0f42935ea826c41$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $b0f42935ea826c41$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
                    return newChild = $b0f42935ea826c41$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($b0f42935ea826c41$var$isArrayImpl(newChild) || $b0f42935ea826c41$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $b0f42935ea826c41$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b0f42935ea826c41$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $b0f42935ea826c41$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b0f42935ea826c41$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b0f42935ea826c41$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $b0f42935ea826c41$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
                    return newChild = $b0f42935ea826c41$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($b0f42935ea826c41$var$isArrayImpl(newChild) || $b0f42935ea826c41$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $b0f42935ea826c41$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b0f42935ea826c41$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $b0f42935ea826c41$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b0f42935ea826c41$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $b0f42935ea826c41$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $b0f42935ea826c41$var$REACT_LAZY_TYPE && $b0f42935ea826c41$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $b0f42935ea826c41$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $b0f42935ea826c41$var$REACT_FRAGMENT_TYPE ? (lanes = $b0f42935ea826c41$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $b0f42935ea826c41$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $b0f42935ea826c41$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $b0f42935ea826c41$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $b0f42935ea826c41$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $b0f42935ea826c41$var$REACT_LAZY_TYPE:
                    return newChild = $b0f42935ea826c41$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($b0f42935ea826c41$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($b0f42935ea826c41$var$getIteratorFn(newChild)) {
                key = $b0f42935ea826c41$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b0f42935ea826c41$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $b0f42935ea826c41$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $b0f42935ea826c41$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $b0f42935ea826c41$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $b0f42935ea826c41$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $b0f42935ea826c41$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $b0f42935ea826c41$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $b0f42935ea826c41$var$SuspenseException || x === $b0f42935ea826c41$var$SuspenseActionException) throw x;
            var fiber = $b0f42935ea826c41$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $b0f42935ea826c41$var$reconcileChildFibers = $b0f42935ea826c41$var$createChildReconciler(!0), $b0f42935ea826c41$var$mountChildFibers = $b0f42935ea826c41$var$createChildReconciler(!1), $b0f42935ea826c41$var$hasForceUpdate = !1;
function $b0f42935ea826c41$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $b0f42935ea826c41$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $b0f42935ea826c41$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b0f42935ea826c41$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($b0f42935ea826c41$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $b0f42935ea826c41$var$getRootForUpdatedFiber(fiber);
        $b0f42935ea826c41$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $b0f42935ea826c41$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $b0f42935ea826c41$var$getRootForUpdatedFiber(fiber);
}
function $b0f42935ea826c41$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $b0f42935ea826c41$var$markRootEntangled(root, lane);
    }
}
function $b0f42935ea826c41$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $b0f42935ea826c41$var$didReadFromEntangledAsyncAction = !1;
function $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($b0f42935ea826c41$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $b0f42935ea826c41$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $b0f42935ea826c41$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $b0f42935ea826c41$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $b0f42935ea826c41$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($b0f42935ea826c41$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $b0f42935ea826c41$var$currentEntangledLane && ($b0f42935ea826c41$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $b0f42935ea826c41$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $b0f42935ea826c41$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $b0f42935ea826c41$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $b0f42935ea826c41$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$b0f42935ea826c41$var$callCallback(callbacks[updateQueue], context);
}
var $b0f42935ea826c41$var$currentTreeHiddenStackCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$prevEntangledRenderLanesCursor = $b0f42935ea826c41$var$createCursor(0);
function $b0f42935ea826c41$var$pushHiddenContext(fiber, context) {
    fiber = $b0f42935ea826c41$var$entangledRenderLanes;
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$prevEntangledRenderLanesCursor, fiber);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$currentTreeHiddenStackCursor, context);
    $b0f42935ea826c41$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $b0f42935ea826c41$var$reuseHiddenContextOnStack() {
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$prevEntangledRenderLanesCursor, $b0f42935ea826c41$var$entangledRenderLanes);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$currentTreeHiddenStackCursor, $b0f42935ea826c41$var$currentTreeHiddenStackCursor.current);
}
function $b0f42935ea826c41$var$popHiddenContext() {
    $b0f42935ea826c41$var$entangledRenderLanes = $b0f42935ea826c41$var$prevEntangledRenderLanesCursor.current;
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$currentTreeHiddenStackCursor);
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$prevEntangledRenderLanesCursor);
}
var $b0f42935ea826c41$var$suspenseHandlerStackCursor = $b0f42935ea826c41$var$createCursor(null), $b0f42935ea826c41$var$shellBoundary = null;
function $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current & 1);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseHandlerStackCursor, handler);
    null === $b0f42935ea826c41$var$shellBoundary && (null === current || null !== $b0f42935ea826c41$var$currentTreeHiddenStackCursor.current ? $b0f42935ea826c41$var$shellBoundary = handler : null !== current.memoizedState && ($b0f42935ea826c41$var$shellBoundary = handler));
}
function $b0f42935ea826c41$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseHandlerStackCursor, fiber);
    null === $b0f42935ea826c41$var$shellBoundary && ($b0f42935ea826c41$var$shellBoundary = fiber);
}
function $b0f42935ea826c41$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current), $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseHandlerStackCursor, fiber), null === $b0f42935ea826c41$var$shellBoundary && ($b0f42935ea826c41$var$shellBoundary = fiber)) : $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(fiber);
}
function $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack() {
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current);
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseHandlerStackCursor, $b0f42935ea826c41$var$suspenseHandlerStackCursor.current);
}
function $b0f42935ea826c41$var$popSuspenseHandler(fiber) {
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$suspenseHandlerStackCursor);
    $b0f42935ea826c41$var$shellBoundary === fiber && ($b0f42935ea826c41$var$shellBoundary = null);
    $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$suspenseStackCursor);
}
var $b0f42935ea826c41$var$suspenseStackCursor = $b0f42935ea826c41$var$createCursor(0);
function $b0f42935ea826c41$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $b0f42935ea826c41$var$isSuspenseInstancePending(state) || $b0f42935ea826c41$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $b0f42935ea826c41$var$renderLanes = 0, $b0f42935ea826c41$var$currentlyRenderingFiber = null, $b0f42935ea826c41$var$currentHook = null, $b0f42935ea826c41$var$workInProgressHook = null, $b0f42935ea826c41$var$didScheduleRenderPhaseUpdate = !1, $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $b0f42935ea826c41$var$localIdCounter = 0, $b0f42935ea826c41$var$thenableIndexCounter = 0, $b0f42935ea826c41$var$thenableState = null, $b0f42935ea826c41$var$globalClientIdCounter = 0;
function $b0f42935ea826c41$var$throwInvalidHookError() {
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(321));
}
function $b0f42935ea826c41$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$b0f42935ea826c41$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $b0f42935ea826c41$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $b0f42935ea826c41$var$renderLanes = nextRenderLanes;
    $b0f42935ea826c41$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $b0f42935ea826c41$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $b0f42935ea826c41$var$HooksDispatcherOnMount : $b0f42935ea826c41$var$HooksDispatcherOnUpdate;
    $b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $b0f42935ea826c41$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $b0f42935ea826c41$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $b0f42935ea826c41$var$finishRenderingHooks(current) {
    $b0f42935ea826c41$var$ReactSharedInternals.H = $b0f42935ea826c41$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $b0f42935ea826c41$var$currentHook && null !== $b0f42935ea826c41$var$currentHook.next;
    $b0f42935ea826c41$var$renderLanes = 0;
    $b0f42935ea826c41$var$workInProgressHook = $b0f42935ea826c41$var$currentHook = $b0f42935ea826c41$var$currentlyRenderingFiber = null;
    $b0f42935ea826c41$var$didScheduleRenderPhaseUpdate = !1;
    $b0f42935ea826c41$var$thenableIndexCounter = 0;
    $b0f42935ea826c41$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(300));
    null === current || $b0f42935ea826c41$var$didReceiveUpdate || (current = current.dependencies, null !== current && $b0f42935ea826c41$var$checkIfContextChanged(current) && ($b0f42935ea826c41$var$didReceiveUpdate = !0));
}
function $b0f42935ea826c41$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $b0f42935ea826c41$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass && ($b0f42935ea826c41$var$thenableState = null);
        $b0f42935ea826c41$var$thenableIndexCounter = 0;
        $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $b0f42935ea826c41$var$workInProgressHook = $b0f42935ea826c41$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $b0f42935ea826c41$var$ReactSharedInternals.H = $b0f42935ea826c41$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $b0f42935ea826c41$var$TransitionAwareHostComponent() {
    var dispatcher = $b0f42935ea826c41$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $b0f42935ea826c41$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $b0f42935ea826c41$var$currentHook ? $b0f42935ea826c41$var$currentHook.memoizedState : null) !== dispatcher && ($b0f42935ea826c41$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $b0f42935ea826c41$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $b0f42935ea826c41$var$localIdCounter;
    $b0f42935ea826c41$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $b0f42935ea826c41$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $b0f42935ea826c41$var$resetHooksOnUnwind(workInProgress) {
    if ($b0f42935ea826c41$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $b0f42935ea826c41$var$didScheduleRenderPhaseUpdate = !1;
    }
    $b0f42935ea826c41$var$renderLanes = 0;
    $b0f42935ea826c41$var$workInProgressHook = $b0f42935ea826c41$var$currentHook = $b0f42935ea826c41$var$currentlyRenderingFiber = null;
    $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $b0f42935ea826c41$var$thenableIndexCounter = $b0f42935ea826c41$var$localIdCounter = 0;
    $b0f42935ea826c41$var$thenableState = null;
}
function $b0f42935ea826c41$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b0f42935ea826c41$var$workInProgressHook ? $b0f42935ea826c41$var$currentlyRenderingFiber.memoizedState = $b0f42935ea826c41$var$workInProgressHook = hook : $b0f42935ea826c41$var$workInProgressHook = $b0f42935ea826c41$var$workInProgressHook.next = hook;
    return $b0f42935ea826c41$var$workInProgressHook;
}
function $b0f42935ea826c41$var$updateWorkInProgressHook() {
    if (null === $b0f42935ea826c41$var$currentHook) {
        var nextCurrentHook = $b0f42935ea826c41$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $b0f42935ea826c41$var$currentHook.next;
    var nextWorkInProgressHook = null === $b0f42935ea826c41$var$workInProgressHook ? $b0f42935ea826c41$var$currentlyRenderingFiber.memoizedState : $b0f42935ea826c41$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $b0f42935ea826c41$var$workInProgressHook = nextWorkInProgressHook, $b0f42935ea826c41$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $b0f42935ea826c41$var$currentlyRenderingFiber.alternate) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(467));
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(310));
        }
        $b0f42935ea826c41$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $b0f42935ea826c41$var$currentHook.memoizedState,
            baseState: $b0f42935ea826c41$var$currentHook.baseState,
            baseQueue: $b0f42935ea826c41$var$currentHook.baseQueue,
            queue: $b0f42935ea826c41$var$currentHook.queue,
            next: null
        };
        null === $b0f42935ea826c41$var$workInProgressHook ? $b0f42935ea826c41$var$currentlyRenderingFiber.memoizedState = $b0f42935ea826c41$var$workInProgressHook = nextCurrentHook : $b0f42935ea826c41$var$workInProgressHook = $b0f42935ea826c41$var$workInProgressHook.next = nextCurrentHook;
    }
    return $b0f42935ea826c41$var$workInProgressHook;
}
function $b0f42935ea826c41$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $b0f42935ea826c41$var$useThenable(thenable) {
    var index = $b0f42935ea826c41$var$thenableIndexCounter;
    $b0f42935ea826c41$var$thenableIndexCounter += 1;
    null === $b0f42935ea826c41$var$thenableState && ($b0f42935ea826c41$var$thenableState = []);
    thenable = $b0f42935ea826c41$var$trackUsedThenable($b0f42935ea826c41$var$thenableState, thenable, index);
    index = $b0f42935ea826c41$var$currentlyRenderingFiber;
    null === (null === $b0f42935ea826c41$var$workInProgressHook ? index.memoizedState : $b0f42935ea826c41$var$workInProgressHook.next) && (index = index.alternate, $b0f42935ea826c41$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $b0f42935ea826c41$var$HooksDispatcherOnMount : $b0f42935ea826c41$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $b0f42935ea826c41$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $b0f42935ea826c41$var$useThenable(usable);
        if (usable.$$typeof === $b0f42935ea826c41$var$REACT_CONTEXT_TYPE) return $b0f42935ea826c41$var$readContext(usable);
    }
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(438, String(usable)));
}
function $b0f42935ea826c41$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $b0f42935ea826c41$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $b0f42935ea826c41$var$createFunctionComponentUpdateQueue(), $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $b0f42935ea826c41$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $b0f42935ea826c41$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $b0f42935ea826c41$var$updateReducer(reducer) {
    var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    return $b0f42935ea826c41$var$updateReducerImpl(hook, $b0f42935ea826c41$var$currentHook, reducer);
}
function $b0f42935ea826c41$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($b0f42935ea826c41$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($b0f42935ea826c41$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $b0f42935ea826c41$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($b0f42935ea826c41$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $b0f42935ea826c41$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $b0f42935ea826c41$var$currentlyRenderingFiber.lanes |= revertLane, $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $b0f42935ea826c41$var$currentlyRenderingFiber.lanes |= updateLane, $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$b0f42935ea826c41$var$objectIs(pendingQueue, hook.memoizedState) && ($b0f42935ea826c41$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $b0f42935ea826c41$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $b0f42935ea826c41$var$rerenderReducer(reducer) {
    var hook = $b0f42935ea826c41$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $b0f42935ea826c41$var$objectIs(newState, hook.memoizedState) || ($b0f42935ea826c41$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $b0f42935ea826c41$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $b0f42935ea826c41$var$currentlyRenderingFiber, hook = $b0f42935ea826c41$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $b0f42935ea826c41$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$b0f42935ea826c41$var$objectIs(($b0f42935ea826c41$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $b0f42935ea826c41$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $b0f42935ea826c41$var$updateEffect($b0f42935ea826c41$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $b0f42935ea826c41$var$workInProgressHook && $b0f42935ea826c41$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $b0f42935ea826c41$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b0f42935ea826c41$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $b0f42935ea826c41$var$workInProgressRoot) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($b0f42935ea826c41$var$renderLanes & 127) || $b0f42935ea826c41$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $b0f42935ea826c41$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $b0f42935ea826c41$var$createFunctionComponentUpdateQueue(), $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $b0f42935ea826c41$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $b0f42935ea826c41$var$checkIfSnapshotChanged(inst) && $b0f42935ea826c41$var$forceStoreRerender(fiber);
}
function $b0f42935ea826c41$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $b0f42935ea826c41$var$checkIfSnapshotChanged(inst) && $b0f42935ea826c41$var$forceStoreRerender(fiber);
    });
}
function $b0f42935ea826c41$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$b0f42935ea826c41$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $b0f42935ea826c41$var$forceStoreRerender(fiber) {
    var root = $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $b0f42935ea826c41$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $b0f42935ea826c41$var$mountStateImpl(initialState) {
    var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b0f42935ea826c41$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $b0f42935ea826c41$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b0f42935ea826c41$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $b0f42935ea826c41$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $b0f42935ea826c41$var$updateReducerImpl(hook, $b0f42935ea826c41$var$currentHook, "function" === typeof reducer ? reducer : $b0f42935ea826c41$var$basicStateReducer);
}
function $b0f42935ea826c41$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($b0f42935ea826c41$var$isRenderPhaseUpdate(fiber)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $b0f42935ea826c41$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $b0f42935ea826c41$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $b0f42935ea826c41$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $b0f42935ea826c41$var$ReactSharedInternals.T, currentTransition = {};
        $b0f42935ea826c41$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $b0f42935ea826c41$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $b0f42935ea826c41$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $b0f42935ea826c41$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b0f42935ea826c41$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $b0f42935ea826c41$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $b0f42935ea826c41$var$onActionError(actionQueue, node, error$66);
    }
}
function $b0f42935ea826c41$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $b0f42935ea826c41$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $b0f42935ea826c41$var$onActionError(actionQueue, node, error);
    }) : $b0f42935ea826c41$var$onActionSuccess(actionQueue, node, returnValue);
}
function $b0f42935ea826c41$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $b0f42935ea826c41$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $b0f42935ea826c41$var$runActionStateAction(actionQueue, nextState)));
}
function $b0f42935ea826c41$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $b0f42935ea826c41$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $b0f42935ea826c41$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $b0f42935ea826c41$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $b0f42935ea826c41$var$mountActionState(action, initialStateProp) {
    if ($b0f42935ea826c41$var$isHydrating) {
        var ssrFormState = $b0f42935ea826c41$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $b0f42935ea826c41$var$currentlyRenderingFiber;
                if ($b0f42935ea826c41$var$isHydrating) {
                    if ($b0f42935ea826c41$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $b0f42935ea826c41$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $b0f42935ea826c41$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $b0f42935ea826c41$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $b0f42935ea826c41$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $b0f42935ea826c41$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b0f42935ea826c41$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $b0f42935ea826c41$var$dispatchSetState.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $b0f42935ea826c41$var$mountStateImpl(!1);
    inRootOrSingleton = $b0f42935ea826c41$var$dispatchOptimisticSetState.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $b0f42935ea826c41$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $b0f42935ea826c41$var$dispatchActionState.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $b0f42935ea826c41$var$updateActionState(action) {
    var stateHook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    return $b0f42935ea826c41$var$updateActionStateImpl(stateHook, $b0f42935ea826c41$var$currentHook, action);
}
function $b0f42935ea826c41$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $b0f42935ea826c41$var$updateReducerImpl(stateHook, currentStateHook, $b0f42935ea826c41$var$actionStateReducer)[0];
    stateHook = $b0f42935ea826c41$var$updateReducer($b0f42935ea826c41$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $b0f42935ea826c41$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $b0f42935ea826c41$var$SuspenseException) throw $b0f42935ea826c41$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($b0f42935ea826c41$var$currentlyRenderingFiber.flags |= 2048, $b0f42935ea826c41$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $b0f42935ea826c41$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $b0f42935ea826c41$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $b0f42935ea826c41$var$rerenderActionState(action) {
    var stateHook = $b0f42935ea826c41$var$updateWorkInProgressHook(), currentStateHook = $b0f42935ea826c41$var$currentHook;
    if (null !== currentStateHook) return $b0f42935ea826c41$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $b0f42935ea826c41$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $b0f42935ea826c41$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $b0f42935ea826c41$var$createFunctionComponentUpdateQueue(), $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $b0f42935ea826c41$var$updateRef() {
    return $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
}
function $b0f42935ea826c41$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
    $b0f42935ea826c41$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $b0f42935ea826c41$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $b0f42935ea826c41$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $b0f42935ea826c41$var$currentHook && null !== deps && $b0f42935ea826c41$var$areHookInputsEqual(deps, $b0f42935ea826c41$var$currentHook.memoizedState.deps) ? hook.memoizedState = $b0f42935ea826c41$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($b0f42935ea826c41$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $b0f42935ea826c41$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $b0f42935ea826c41$var$mountEffect(create, deps) {
    $b0f42935ea826c41$var$mountEffectImpl(8390656, 8, create, deps);
}
function $b0f42935ea826c41$var$updateEffect(create, deps) {
    $b0f42935ea826c41$var$updateEffectImpl(2048, 8, create, deps);
}
function $b0f42935ea826c41$var$useEffectEventImpl(payload) {
    $b0f42935ea826c41$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $b0f42935ea826c41$var$createFunctionComponentUpdateQueue(), $b0f42935ea826c41$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $b0f42935ea826c41$var$updateEvent(callback) {
    var ref = $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
    $b0f42935ea826c41$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($b0f42935ea826c41$var$executionContext & 2)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $b0f42935ea826c41$var$updateInsertionEffect(create, deps) {
    return $b0f42935ea826c41$var$updateEffectImpl(4, 2, create, deps);
}
function $b0f42935ea826c41$var$updateLayoutEffect(create, deps) {
    return $b0f42935ea826c41$var$updateEffectImpl(4, 4, create, deps);
}
function $b0f42935ea826c41$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $b0f42935ea826c41$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $b0f42935ea826c41$var$updateEffectImpl(4, 4, $b0f42935ea826c41$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $b0f42935ea826c41$var$mountDebugValue() {}
function $b0f42935ea826c41$var$updateCallback(callback, deps) {
    var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b0f42935ea826c41$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $b0f42935ea826c41$var$updateMemo(nextCreate, deps) {
    var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $b0f42935ea826c41$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $b0f42935ea826c41$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $b0f42935ea826c41$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $b0f42935ea826c41$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($b0f42935ea826c41$var$renderLanes & 1073741824) && 0 === ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $b0f42935ea826c41$var$requestDeferredLane();
    $b0f42935ea826c41$var$currentlyRenderingFiber.lanes |= hook;
    $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $b0f42935ea826c41$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($b0f42935ea826c41$var$objectIs(value, prevValue)) return value;
    if (null !== $b0f42935ea826c41$var$currentTreeHiddenStackCursor.current) return hook = $b0f42935ea826c41$var$mountDeferredValueImpl(hook, value, initialValue), $b0f42935ea826c41$var$objectIs(hook, prevValue) || ($b0f42935ea826c41$var$didReceiveUpdate = !0), hook;
    if (0 === ($b0f42935ea826c41$var$renderLanes & 42) || 0 !== ($b0f42935ea826c41$var$renderLanes & 1073741824) && 0 === ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 261930)) return $b0f42935ea826c41$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $b0f42935ea826c41$var$requestDeferredLane();
    $b0f42935ea826c41$var$currentlyRenderingFiber.lanes |= hook;
    $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $b0f42935ea826c41$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $b0f42935ea826c41$var$ReactSharedInternals.T, currentTransition = {};
    $b0f42935ea826c41$var$ReactSharedInternals.T = currentTransition;
    $b0f42935ea826c41$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $b0f42935ea826c41$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $b0f42935ea826c41$var$chainThenableValue(returnValue, finishedState);
            $b0f42935ea826c41$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $b0f42935ea826c41$var$requestUpdateLane(fiber));
        } else $b0f42935ea826c41$var$dispatchSetStateInternal(fiber, queue, finishedState, $b0f42935ea826c41$var$requestUpdateLane(fiber));
    } catch (error) {
        $b0f42935ea826c41$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $b0f42935ea826c41$var$requestUpdateLane());
    } finally{
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b0f42935ea826c41$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b0f42935ea826c41$var$noop() {}
function $b0f42935ea826c41$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(476));
    var queue = $b0f42935ea826c41$var$ensureFormComponentIsStateful(formFiber).queue;
    $b0f42935ea826c41$var$startTransition(formFiber, queue, pendingState, $b0f42935ea826c41$var$sharedNotPendingObject, null === action ? $b0f42935ea826c41$var$noop : function() {
        $b0f42935ea826c41$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $b0f42935ea826c41$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $b0f42935ea826c41$var$sharedNotPendingObject,
        baseState: $b0f42935ea826c41$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b0f42935ea826c41$var$basicStateReducer,
            lastRenderedState: $b0f42935ea826c41$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $b0f42935ea826c41$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $b0f42935ea826c41$var$requestFormReset$1(formFiber) {
    var stateHook = $b0f42935ea826c41$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $b0f42935ea826c41$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $b0f42935ea826c41$var$requestUpdateLane());
}
function $b0f42935ea826c41$var$useHostTransitionStatus() {
    return $b0f42935ea826c41$var$readContext($b0f42935ea826c41$var$HostTransitionContext);
}
function $b0f42935ea826c41$var$updateId() {
    return $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
}
function $b0f42935ea826c41$var$updateRefresh() {
    return $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
}
function $b0f42935ea826c41$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $b0f42935ea826c41$var$requestUpdateLane();
                fiber = $b0f42935ea826c41$var$createUpdate(lane);
                var root$69 = $b0f42935ea826c41$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(root$69, provider, lane), $b0f42935ea826c41$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $b0f42935ea826c41$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $b0f42935ea826c41$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $b0f42935ea826c41$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $b0f42935ea826c41$var$isRenderPhaseUpdate(fiber) ? $b0f42935ea826c41$var$enqueueRenderPhaseUpdate(queue, action) : (action = $b0f42935ea826c41$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(action, fiber, lane), $b0f42935ea826c41$var$entangleTransitionUpdate(action, queue, lane)));
}
function $b0f42935ea826c41$var$dispatchSetState(fiber, queue, action) {
    var lane = $b0f42935ea826c41$var$requestUpdateLane();
    $b0f42935ea826c41$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $b0f42935ea826c41$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b0f42935ea826c41$var$isRenderPhaseUpdate(fiber)) $b0f42935ea826c41$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($b0f42935ea826c41$var$objectIs(eagerState, currentState)) return $b0f42935ea826c41$var$enqueueUpdate$1(fiber, queue, update, 0), null === $b0f42935ea826c41$var$workInProgressRoot && $b0f42935ea826c41$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $b0f42935ea826c41$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $b0f42935ea826c41$var$scheduleUpdateOnFiber(action, fiber, lane), $b0f42935ea826c41$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $b0f42935ea826c41$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $b0f42935ea826c41$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b0f42935ea826c41$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $b0f42935ea826c41$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $b0f42935ea826c41$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $b0f42935ea826c41$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $b0f42935ea826c41$var$currentlyRenderingFiber || null !== alternate && alternate === $b0f42935ea826c41$var$currentlyRenderingFiber;
}
function $b0f42935ea826c41$var$enqueueRenderPhaseUpdate(queue, update) {
    $b0f42935ea826c41$var$didScheduleRenderPhaseUpdateDuringThisPass = $b0f42935ea826c41$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $b0f42935ea826c41$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $b0f42935ea826c41$var$markRootEntangled(root, lane);
    }
}
var $b0f42935ea826c41$var$ContextOnlyDispatcher = {
    readContext: $b0f42935ea826c41$var$readContext,
    use: $b0f42935ea826c41$var$use,
    useCallback: $b0f42935ea826c41$var$throwInvalidHookError,
    useContext: $b0f42935ea826c41$var$throwInvalidHookError,
    useEffect: $b0f42935ea826c41$var$throwInvalidHookError,
    useImperativeHandle: $b0f42935ea826c41$var$throwInvalidHookError,
    useLayoutEffect: $b0f42935ea826c41$var$throwInvalidHookError,
    useInsertionEffect: $b0f42935ea826c41$var$throwInvalidHookError,
    useMemo: $b0f42935ea826c41$var$throwInvalidHookError,
    useReducer: $b0f42935ea826c41$var$throwInvalidHookError,
    useRef: $b0f42935ea826c41$var$throwInvalidHookError,
    useState: $b0f42935ea826c41$var$throwInvalidHookError,
    useDebugValue: $b0f42935ea826c41$var$throwInvalidHookError,
    useDeferredValue: $b0f42935ea826c41$var$throwInvalidHookError,
    useTransition: $b0f42935ea826c41$var$throwInvalidHookError,
    useSyncExternalStore: $b0f42935ea826c41$var$throwInvalidHookError,
    useId: $b0f42935ea826c41$var$throwInvalidHookError,
    useHostTransitionStatus: $b0f42935ea826c41$var$throwInvalidHookError,
    useFormState: $b0f42935ea826c41$var$throwInvalidHookError,
    useActionState: $b0f42935ea826c41$var$throwInvalidHookError,
    useOptimistic: $b0f42935ea826c41$var$throwInvalidHookError,
    useMemoCache: $b0f42935ea826c41$var$throwInvalidHookError,
    useCacheRefresh: $b0f42935ea826c41$var$throwInvalidHookError
};
$b0f42935ea826c41$var$ContextOnlyDispatcher.useEffectEvent = $b0f42935ea826c41$var$throwInvalidHookError;
var $b0f42935ea826c41$var$HooksDispatcherOnMount = {
    readContext: $b0f42935ea826c41$var$readContext,
    use: $b0f42935ea826c41$var$use,
    useCallback: function(callback, deps) {
        $b0f42935ea826c41$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $b0f42935ea826c41$var$readContext,
    useEffect: $b0f42935ea826c41$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $b0f42935ea826c41$var$mountEffectImpl(4194308, 4, $b0f42935ea826c41$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $b0f42935ea826c41$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $b0f42935ea826c41$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $b0f42935ea826c41$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $b0f42935ea826c41$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($b0f42935ea826c41$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $b0f42935ea826c41$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $b0f42935ea826c41$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $b0f42935ea826c41$var$dispatchReducerAction.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $b0f42935ea826c41$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $b0f42935ea826c41$var$dispatchSetState.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $b0f42935ea826c41$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        return $b0f42935ea826c41$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $b0f42935ea826c41$var$mountStateImpl(!1);
        stateHook = $b0f42935ea826c41$var$startTransition.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $b0f42935ea826c41$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $b0f42935ea826c41$var$currentlyRenderingFiber, hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        if ($b0f42935ea826c41$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $b0f42935ea826c41$var$workInProgressRoot) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(349));
            0 !== ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 127) || $b0f42935ea826c41$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $b0f42935ea826c41$var$mountEffect($b0f42935ea826c41$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $b0f42935ea826c41$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $b0f42935ea826c41$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook(), identifierPrefix = $b0f42935ea826c41$var$workInProgressRoot.identifierPrefix;
        if ($b0f42935ea826c41$var$isHydrating) {
            var JSCompiler_inline_result = $b0f42935ea826c41$var$treeContextOverflow;
            var idWithLeadingBit = $b0f42935ea826c41$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $b0f42935ea826c41$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $b0f42935ea826c41$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $b0f42935ea826c41$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $b0f42935ea826c41$var$useHostTransitionStatus,
    useFormState: $b0f42935ea826c41$var$mountActionState,
    useActionState: $b0f42935ea826c41$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $b0f42935ea826c41$var$dispatchOptimisticSetState.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $b0f42935ea826c41$var$useMemoCache,
    useCacheRefresh: function() {
        return $b0f42935ea826c41$var$mountWorkInProgressHook().memoizedState = $b0f42935ea826c41$var$refreshCache.bind(null, $b0f42935ea826c41$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $b0f42935ea826c41$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($b0f42935ea826c41$var$executionContext & 2)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $b0f42935ea826c41$var$HooksDispatcherOnUpdate = {
    readContext: $b0f42935ea826c41$var$readContext,
    use: $b0f42935ea826c41$var$use,
    useCallback: $b0f42935ea826c41$var$updateCallback,
    useContext: $b0f42935ea826c41$var$readContext,
    useEffect: $b0f42935ea826c41$var$updateEffect,
    useImperativeHandle: $b0f42935ea826c41$var$updateImperativeHandle,
    useInsertionEffect: $b0f42935ea826c41$var$updateInsertionEffect,
    useLayoutEffect: $b0f42935ea826c41$var$updateLayoutEffect,
    useMemo: $b0f42935ea826c41$var$updateMemo,
    useReducer: $b0f42935ea826c41$var$updateReducer,
    useRef: $b0f42935ea826c41$var$updateRef,
    useState: function() {
        return $b0f42935ea826c41$var$updateReducer($b0f42935ea826c41$var$basicStateReducer);
    },
    useDebugValue: $b0f42935ea826c41$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
        return $b0f42935ea826c41$var$updateDeferredValueImpl(hook, $b0f42935ea826c41$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b0f42935ea826c41$var$updateReducer($b0f42935ea826c41$var$basicStateReducer)[0], start = $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b0f42935ea826c41$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b0f42935ea826c41$var$updateSyncExternalStore,
    useId: $b0f42935ea826c41$var$updateId,
    useHostTransitionStatus: $b0f42935ea826c41$var$useHostTransitionStatus,
    useFormState: $b0f42935ea826c41$var$updateActionState,
    useActionState: $b0f42935ea826c41$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
        return $b0f42935ea826c41$var$updateOptimisticImpl(hook, $b0f42935ea826c41$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $b0f42935ea826c41$var$useMemoCache,
    useCacheRefresh: $b0f42935ea826c41$var$updateRefresh
};
$b0f42935ea826c41$var$HooksDispatcherOnUpdate.useEffectEvent = $b0f42935ea826c41$var$updateEvent;
var $b0f42935ea826c41$var$HooksDispatcherOnRerender = {
    readContext: $b0f42935ea826c41$var$readContext,
    use: $b0f42935ea826c41$var$use,
    useCallback: $b0f42935ea826c41$var$updateCallback,
    useContext: $b0f42935ea826c41$var$readContext,
    useEffect: $b0f42935ea826c41$var$updateEffect,
    useImperativeHandle: $b0f42935ea826c41$var$updateImperativeHandle,
    useInsertionEffect: $b0f42935ea826c41$var$updateInsertionEffect,
    useLayoutEffect: $b0f42935ea826c41$var$updateLayoutEffect,
    useMemo: $b0f42935ea826c41$var$updateMemo,
    useReducer: $b0f42935ea826c41$var$rerenderReducer,
    useRef: $b0f42935ea826c41$var$updateRef,
    useState: function() {
        return $b0f42935ea826c41$var$rerenderReducer($b0f42935ea826c41$var$basicStateReducer);
    },
    useDebugValue: $b0f42935ea826c41$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
        return null === $b0f42935ea826c41$var$currentHook ? $b0f42935ea826c41$var$mountDeferredValueImpl(hook, value, initialValue) : $b0f42935ea826c41$var$updateDeferredValueImpl(hook, $b0f42935ea826c41$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $b0f42935ea826c41$var$rerenderReducer($b0f42935ea826c41$var$basicStateReducer)[0], start = $b0f42935ea826c41$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $b0f42935ea826c41$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $b0f42935ea826c41$var$updateSyncExternalStore,
    useId: $b0f42935ea826c41$var$updateId,
    useHostTransitionStatus: $b0f42935ea826c41$var$useHostTransitionStatus,
    useFormState: $b0f42935ea826c41$var$rerenderActionState,
    useActionState: $b0f42935ea826c41$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $b0f42935ea826c41$var$updateWorkInProgressHook();
        if (null !== $b0f42935ea826c41$var$currentHook) return $b0f42935ea826c41$var$updateOptimisticImpl(hook, $b0f42935ea826c41$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $b0f42935ea826c41$var$useMemoCache,
    useCacheRefresh: $b0f42935ea826c41$var$updateRefresh
};
$b0f42935ea826c41$var$HooksDispatcherOnRerender.useEffectEvent = $b0f42935ea826c41$var$updateEvent;
function $b0f42935ea826c41$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $b0f42935ea826c41$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $b0f42935ea826c41$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b0f42935ea826c41$var$requestUpdateLane(), update = $b0f42935ea826c41$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b0f42935ea826c41$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(payload, inst, lane), $b0f42935ea826c41$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $b0f42935ea826c41$var$requestUpdateLane(), update = $b0f42935ea826c41$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $b0f42935ea826c41$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(payload, inst, lane), $b0f42935ea826c41$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $b0f42935ea826c41$var$requestUpdateLane(), update = $b0f42935ea826c41$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $b0f42935ea826c41$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(callback, inst, lane), $b0f42935ea826c41$var$entangleTransitions(callback, inst, lane));
    }
};
function $b0f42935ea826c41$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$b0f42935ea826c41$var$shallowEqual(oldProps, newProps) || !$b0f42935ea826c41$var$shallowEqual(oldState, newState) : !0;
}
function $b0f42935ea826c41$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $b0f42935ea826c41$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $b0f42935ea826c41$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $b0f42935ea826c41$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $b0f42935ea826c41$var$defaultOnUncaughtError(error) {
    $b0f42935ea826c41$var$reportGlobalError(error);
}
function $b0f42935ea826c41$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $b0f42935ea826c41$var$defaultOnRecoverableError(error) {
    $b0f42935ea826c41$var$reportGlobalError(error);
}
function $b0f42935ea826c41$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $b0f42935ea826c41$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $b0f42935ea826c41$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $b0f42935ea826c41$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $b0f42935ea826c41$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $b0f42935ea826c41$var$createClassErrorUpdate(lane) {
    lane = $b0f42935ea826c41$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $b0f42935ea826c41$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $b0f42935ea826c41$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $b0f42935ea826c41$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed ? $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $b0f42935ea826c41$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $b0f42935ea826c41$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $b0f42935ea826c41$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $b0f42935ea826c41$var$shellBoundary ? $b0f42935ea826c41$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $b0f42935ea826c41$var$workInProgressRootExitStatus && ($b0f42935ea826c41$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $b0f42935ea826c41$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $b0f42935ea826c41$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $b0f42935ea826c41$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $b0f42935ea826c41$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $b0f42935ea826c41$var$attachPingListener(root, value, rootRenderLanes);
        $b0f42935ea826c41$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($b0f42935ea826c41$var$isHydrating) return returnFiber = $b0f42935ea826c41$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $b0f42935ea826c41$var$HydrationMismatchException && (root = Error($b0f42935ea826c41$var$formatProdErrorMessage(422), {
        cause: value
    }), $b0f42935ea826c41$var$queueHydrationError($b0f42935ea826c41$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $b0f42935ea826c41$var$HydrationMismatchException && (returnFiber = Error($b0f42935ea826c41$var$formatProdErrorMessage(423), {
        cause: value
    }), $b0f42935ea826c41$var$queueHydrationError($b0f42935ea826c41$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $b0f42935ea826c41$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $b0f42935ea826c41$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $b0f42935ea826c41$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $b0f42935ea826c41$var$workInProgressRootExitStatus && ($b0f42935ea826c41$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($b0f42935ea826c41$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $b0f42935ea826c41$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $b0f42935ea826c41$var$workInProgressRootConcurrentErrors ? $b0f42935ea826c41$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $b0f42935ea826c41$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $b0f42935ea826c41$var$workInProgressRootExitStatus && ($b0f42935ea826c41$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $b0f42935ea826c41$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $b0f42935ea826c41$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $b0f42935ea826c41$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed || !$b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $b0f42935ea826c41$var$createClassErrorUpdate(rootRenderLanes), $b0f42935ea826c41$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $b0f42935ea826c41$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $b0f42935ea826c41$var$SelectiveHydrationException = Error($b0f42935ea826c41$var$formatProdErrorMessage(461)), $b0f42935ea826c41$var$didReceiveUpdate = !1;
function $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $b0f42935ea826c41$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $b0f42935ea826c41$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $b0f42935ea826c41$var$prepareToReadContext(workInProgress);
    nextProps = $b0f42935ea826c41$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $b0f42935ea826c41$var$checkDidRenderIdHook();
    if (null !== current && !$b0f42935ea826c41$var$didReceiveUpdate) return $b0f42935ea826c41$var$bailoutHooks(current, workInProgress, renderLanes), $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b0f42935ea826c41$var$isHydrating && key && $b0f42935ea826c41$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b0f42935ea826c41$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$b0f42935ea826c41$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $b0f42935ea826c41$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $b0f42935ea826c41$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$b0f42935ea826c41$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $b0f42935ea826c41$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $b0f42935ea826c41$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $b0f42935ea826c41$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($b0f42935ea826c41$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($b0f42935ea826c41$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $b0f42935ea826c41$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($b0f42935ea826c41$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $b0f42935ea826c41$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $b0f42935ea826c41$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $b0f42935ea826c41$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $b0f42935ea826c41$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $b0f42935ea826c41$var$pushHiddenContext(workInProgress, prevState) : $b0f42935ea826c41$var$reuseHiddenContextOnStack(), $b0f42935ea826c41$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $b0f42935ea826c41$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($b0f42935ea826c41$var$pushTransition(workInProgress, prevState.cachePool), $b0f42935ea826c41$var$pushHiddenContext(workInProgress, prevState), $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $b0f42935ea826c41$var$pushTransition(workInProgress, null), $b0f42935ea826c41$var$reuseHiddenContextOnStack(), $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress));
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $b0f42935ea826c41$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $b0f42935ea826c41$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $b0f42935ea826c41$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $b0f42935ea826c41$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $b0f42935ea826c41$var$pushTransition(workInProgress, null);
    $b0f42935ea826c41$var$reuseHiddenContextOnStack();
    $b0f42935ea826c41$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $b0f42935ea826c41$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $b0f42935ea826c41$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $b0f42935ea826c41$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b0f42935ea826c41$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $b0f42935ea826c41$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($b0f42935ea826c41$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $b0f42935ea826c41$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $b0f42935ea826c41$var$bailoutOffscreenComponent(null, current);
            $b0f42935ea826c41$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $b0f42935ea826c41$var$nextHydratableInstance) ? (current = $b0f42935ea826c41$var$canHydrateHydrationBoundary(current, $b0f42935ea826c41$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b0f42935ea826c41$var$treeContextProvider ? {
                    id: $b0f42935ea826c41$var$treeContextId,
                    overflow: $b0f42935ea826c41$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b0f42935ea826c41$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b0f42935ea826c41$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $b0f42935ea826c41$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $b0f42935ea826c41$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $b0f42935ea826c41$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($b0f42935ea826c41$var$formatProdErrorMessage(558));
        } else if ($b0f42935ea826c41$var$didReceiveUpdate || $b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $b0f42935ea826c41$var$didReceiveUpdate || didSuspend) {
            nextProps = $b0f42935ea826c41$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $b0f42935ea826c41$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(current, dehydrated), $b0f42935ea826c41$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $b0f42935ea826c41$var$SelectiveHydrationException;
            $b0f42935ea826c41$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b0f42935ea826c41$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(dehydrated.nextSibling), $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$isHydrating = !0, $b0f42935ea826c41$var$hydrationErrors = null, $b0f42935ea826c41$var$rootOrSingletonContext = !1, null !== current && $b0f42935ea826c41$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b0f42935ea826c41$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $b0f42935ea826c41$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $b0f42935ea826c41$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $b0f42935ea826c41$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b0f42935ea826c41$var$prepareToReadContext(workInProgress);
    Component = $b0f42935ea826c41$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $b0f42935ea826c41$var$checkDidRenderIdHook();
    if (null !== current && !$b0f42935ea826c41$var$didReceiveUpdate) return $b0f42935ea826c41$var$bailoutHooks(current, workInProgress, renderLanes), $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b0f42935ea826c41$var$isHydrating && nextProps && $b0f42935ea826c41$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $b0f42935ea826c41$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $b0f42935ea826c41$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $b0f42935ea826c41$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $b0f42935ea826c41$var$finishRenderingHooks(current);
    Component = $b0f42935ea826c41$var$checkDidRenderIdHook();
    if (null !== current && !$b0f42935ea826c41$var$didReceiveUpdate) return $b0f42935ea826c41$var$bailoutHooks(current, workInProgress, renderLanes), $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $b0f42935ea826c41$var$isHydrating && Component && $b0f42935ea826c41$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $b0f42935ea826c41$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $b0f42935ea826c41$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $b0f42935ea826c41$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $b0f42935ea826c41$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $b0f42935ea826c41$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $b0f42935ea826c41$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $b0f42935ea826c41$var$readContext(contextType) : $b0f42935ea826c41$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($b0f42935ea826c41$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $b0f42935ea826c41$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $b0f42935ea826c41$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $b0f42935ea826c41$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $b0f42935ea826c41$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $b0f42935ea826c41$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $b0f42935ea826c41$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $b0f42935ea826c41$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b0f42935ea826c41$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $b0f42935ea826c41$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($b0f42935ea826c41$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $b0f42935ea826c41$var$hasForceUpdate || $b0f42935ea826c41$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $b0f42935ea826c41$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $b0f42935ea826c41$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $b0f42935ea826c41$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $b0f42935ea826c41$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $b0f42935ea826c41$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $b0f42935ea826c41$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $b0f42935ea826c41$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $b0f42935ea826c41$var$hasForceUpdate || null !== current && null !== current.dependencies && $b0f42935ea826c41$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($b0f42935ea826c41$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $b0f42935ea826c41$var$hasForceUpdate || $b0f42935ea826c41$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $b0f42935ea826c41$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $b0f42935ea826c41$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $b0f42935ea826c41$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $b0f42935ea826c41$var$resetHydrationState();
    workInProgress.flags |= 256;
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $b0f42935ea826c41$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $b0f42935ea826c41$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $b0f42935ea826c41$var$getSuspendedCache()
    };
}
function $b0f42935ea826c41$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $b0f42935ea826c41$var$workInProgressDeferredLane);
    return current;
}
function $b0f42935ea826c41$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($b0f42935ea826c41$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($b0f42935ea826c41$var$isHydrating) {
            showFallback ? $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $b0f42935ea826c41$var$nextHydratableInstance) ? (current = $b0f42935ea826c41$var$canHydrateHydrationBoundary(current, $b0f42935ea826c41$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $b0f42935ea826c41$var$treeContextProvider ? {
                    id: $b0f42935ea826c41$var$treeContextId,
                    overflow: $b0f42935ea826c41$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $b0f42935ea826c41$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $b0f42935ea826c41$var$throwOnHydrationMismatch(workInProgress);
            $b0f42935ea826c41$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $b0f42935ea826c41$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $b0f42935ea826c41$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $b0f42935ea826c41$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b0f42935ea826c41$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b0f42935ea826c41$var$SUSPENDED_MARKER, $b0f42935ea826c41$var$bailoutOffscreenComponent(null, nextProps);
        $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $b0f42935ea826c41$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $b0f42935ea826c41$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $b0f42935ea826c41$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $b0f42935ea826c41$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $b0f42935ea826c41$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $b0f42935ea826c41$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b0f42935ea826c41$var$SUSPENDED_MARKER, workInProgress = $b0f42935ea826c41$var$bailoutOffscreenComponent(null, nextProps));
        else if ($b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress), $b0f42935ea826c41$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($b0f42935ea826c41$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $b0f42935ea826c41$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $b0f42935ea826c41$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($b0f42935ea826c41$var$didReceiveUpdate || $b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $b0f42935ea826c41$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $b0f42935ea826c41$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $b0f42935ea826c41$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(current, nextProps), $b0f42935ea826c41$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $b0f42935ea826c41$var$SelectiveHydrationException;
            $b0f42935ea826c41$var$isSuspenseInstancePending(nextPrimaryChildren) || $b0f42935ea826c41$var$renderDidSuspendDelayIfPossible();
            workInProgress = $b0f42935ea826c41$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $b0f42935ea826c41$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(nextPrimaryChildren.nextSibling), $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$isHydrating = !0, $b0f42935ea826c41$var$hydrationErrors = null, $b0f42935ea826c41$var$rootOrSingletonContext = !1, null !== current && $b0f42935ea826c41$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $b0f42935ea826c41$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $b0f42935ea826c41$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $b0f42935ea826c41$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $b0f42935ea826c41$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $b0f42935ea826c41$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $b0f42935ea826c41$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $b0f42935ea826c41$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $b0f42935ea826c41$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $b0f42935ea826c41$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $b0f42935ea826c41$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $b0f42935ea826c41$var$SUSPENDED_MARKER, $b0f42935ea826c41$var$bailoutOffscreenComponent(current.child, nextProps);
    $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $b0f42935ea826c41$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $b0f42935ea826c41$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $b0f42935ea826c41$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $b0f42935ea826c41$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $b0f42935ea826c41$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $b0f42935ea826c41$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $b0f42935ea826c41$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $b0f42935ea826c41$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $b0f42935ea826c41$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $b0f42935ea826c41$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $b0f42935ea826c41$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $b0f42935ea826c41$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, suspenseContext);
    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $b0f42935ea826c41$var$isHydrating ? $b0f42935ea826c41$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $b0f42935ea826c41$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $b0f42935ea826c41$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $b0f42935ea826c41$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $b0f42935ea826c41$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $b0f42935ea826c41$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $b0f42935ea826c41$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $b0f42935ea826c41$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $b0f42935ea826c41$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $b0f42935ea826c41$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $b0f42935ea826c41$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $b0f42935ea826c41$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $b0f42935ea826c41$var$checkIfContextChanged(current) ? !0 : !1;
}
function $b0f42935ea826c41$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $b0f42935ea826c41$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, current.memoizedState.cache);
            $b0f42935ea826c41$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $b0f42935ea826c41$var$pushHostContext(workInProgress);
            break;
        case 4:
            $b0f42935ea826c41$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $b0f42935ea826c41$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $b0f42935ea826c41$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $b0f42935ea826c41$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $b0f42935ea826c41$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($b0f42935ea826c41$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $b0f42935ea826c41$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $b0f42935ea826c41$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, current.memoizedState.cache);
    }
    return $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $b0f42935ea826c41$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $b0f42935ea826c41$var$didReceiveUpdate = !0;
        else {
            if (!$b0f42935ea826c41$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $b0f42935ea826c41$var$didReceiveUpdate = !1, $b0f42935ea826c41$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $b0f42935ea826c41$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $b0f42935ea826c41$var$didReceiveUpdate = !1, $b0f42935ea826c41$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $b0f42935ea826c41$var$pushTreeId(workInProgress, $b0f42935ea826c41$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $b0f42935ea826c41$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $b0f42935ea826c41$var$shouldConstruct(current) ? (props = $b0f42935ea826c41$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $b0f42935ea826c41$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $b0f42935ea826c41$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $b0f42935ea826c41$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $b0f42935ea826c41$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $b0f42935ea826c41$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $b0f42935ea826c41$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $b0f42935ea826c41$var$getComponentNameFromType(current) || current;
                    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $b0f42935ea826c41$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $b0f42935ea826c41$var$resolveClassComponentProps(props, workInProgress.pendingProps), $b0f42935ea826c41$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $b0f42935ea826c41$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $b0f42935ea826c41$var$cloneUpdateQueue(current, workInProgress);
                $b0f42935ea826c41$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, props);
                props !== prevState.cache && $b0f42935ea826c41$var$propagateContextChanges(workInProgress, [
                    $b0f42935ea826c41$var$CacheContext
                ], renderLanes, !0);
                $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $b0f42935ea826c41$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $b0f42935ea826c41$var$createCapturedValueAtFiber(Error($b0f42935ea826c41$var$formatProdErrorMessage(424)), workInProgress);
                        $b0f42935ea826c41$var$queueHydrationError($$typeof);
                        workInProgress = $b0f42935ea826c41$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(current.firstChild);
                        $b0f42935ea826c41$var$hydrationParentFiber = workInProgress;
                        $b0f42935ea826c41$var$isHydrating = !0;
                        $b0f42935ea826c41$var$hydrationErrors = null;
                        $b0f42935ea826c41$var$rootOrSingletonContext = !0;
                        renderLanes = $b0f42935ea826c41$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $b0f42935ea826c41$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $b0f42935ea826c41$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $b0f42935ea826c41$var$markRef(current, workInProgress), null === current ? (renderLanes = $b0f42935ea826c41$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $b0f42935ea826c41$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $b0f42935ea826c41$var$getOwnerDocumentFromRootContainer($b0f42935ea826c41$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress, props[$b0f42935ea826c41$var$internalPropsKey] = current, $b0f42935ea826c41$var$setInitialProperties(props, renderLanes, current), $b0f42935ea826c41$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $b0f42935ea826c41$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $b0f42935ea826c41$var$pushHostContext(workInProgress), null === current && $b0f42935ea826c41$var$isHydrating && (props = workInProgress.stateNode = $b0f42935ea826c41$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $b0f42935ea826c41$var$rootInstanceStackCursor.current), $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$rootOrSingletonContext = !0, $$typeof = $b0f42935ea826c41$var$nextHydratableInstance, $b0f42935ea826c41$var$isSingletonScope(workInProgress.type) ? ($b0f42935ea826c41$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(props.firstChild)) : $b0f42935ea826c41$var$nextHydratableInstance = $$typeof), $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $b0f42935ea826c41$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $b0f42935ea826c41$var$isHydrating) {
                if ($$typeof = props = $b0f42935ea826c41$var$nextHydratableInstance) props = $b0f42935ea826c41$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $b0f42935ea826c41$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$nextHydratableInstance = $b0f42935ea826c41$var$getNextHydratable(props.firstChild), $b0f42935ea826c41$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $b0f42935ea826c41$var$throwOnHydrationMismatch(workInProgress);
            }
            $b0f42935ea826c41$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $b0f42935ea826c41$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $b0f42935ea826c41$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $b0f42935ea826c41$var$renderWithHooks(current, workInProgress, $b0f42935ea826c41$var$TransitionAwareHostComponent, null, null, renderLanes), $b0f42935ea826c41$var$HostTransitionContext._currentValue = $$typeof);
            $b0f42935ea826c41$var$markRef(current, workInProgress);
            $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $b0f42935ea826c41$var$isHydrating) {
                if (current = renderLanes = $b0f42935ea826c41$var$nextHydratableInstance) renderLanes = $b0f42935ea826c41$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $b0f42935ea826c41$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $b0f42935ea826c41$var$hydrationParentFiber = workInProgress, $b0f42935ea826c41$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $b0f42935ea826c41$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $b0f42935ea826c41$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $b0f42935ea826c41$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $b0f42935ea826c41$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $b0f42935ea826c41$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $b0f42935ea826c41$var$pushProvider(workInProgress, workInProgress.type, props.value), $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $b0f42935ea826c41$var$prepareToReadContext(workInProgress), $$typeof = $b0f42935ea826c41$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $b0f42935ea826c41$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $b0f42935ea826c41$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $b0f42935ea826c41$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $b0f42935ea826c41$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $b0f42935ea826c41$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $b0f42935ea826c41$var$prepareToReadContext(workInProgress), props = $b0f42935ea826c41$var$readContext($b0f42935ea826c41$var$CacheContext), null === current ? ($$typeof = $b0f42935ea826c41$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $b0f42935ea826c41$var$workInProgressRoot, prevState = $b0f42935ea826c41$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $b0f42935ea826c41$var$initializeUpdateQueue(workInProgress), $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($b0f42935ea826c41$var$cloneUpdateQueue(current, workInProgress), $b0f42935ea826c41$var$processUpdateQueue(workInProgress, null, null, renderLanes), $b0f42935ea826c41$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, props)) : (props = prevState.cache, $b0f42935ea826c41$var$pushProvider(workInProgress, $b0f42935ea826c41$var$CacheContext, props), props !== $$typeof.cache && $b0f42935ea826c41$var$propagateContextChanges(workInProgress, [
                $b0f42935ea826c41$var$CacheContext
            ], renderLanes, !0))), $b0f42935ea826c41$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b0f42935ea826c41$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $b0f42935ea826c41$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($b0f42935ea826c41$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $b0f42935ea826c41$var$suspendedThenable = $b0f42935ea826c41$var$noopSuspenseyCommitThenable, $b0f42935ea826c41$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $b0f42935ea826c41$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$b0f42935ea826c41$var$preloadResource(resource)) {
        if ($b0f42935ea826c41$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $b0f42935ea826c41$var$suspendedThenable = $b0f42935ea826c41$var$noopSuspenseyCommitThenable, $b0f42935ea826c41$var$SuspenseyCommitException;
    }
}
function $b0f42935ea826c41$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $b0f42935ea826c41$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $b0f42935ea826c41$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$b0f42935ea826c41$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $b0f42935ea826c41$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $b0f42935ea826c41$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $b0f42935ea826c41$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
        case 1:
            return $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext);
            $b0f42935ea826c41$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $b0f42935ea826c41$var$popHydrationState(workInProgress) ? $b0f42935ea826c41$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $b0f42935ea826c41$var$upgradeHydrationErrorsToRecoverable());
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($b0f42935ea826c41$var$markUpdate(workInProgress), null !== nextResource ? ($b0f42935ea826c41$var$bubbleProperties(workInProgress), $b0f42935ea826c41$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b0f42935ea826c41$var$bubbleProperties(workInProgress), $b0f42935ea826c41$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($b0f42935ea826c41$var$markUpdate(workInProgress), $b0f42935ea826c41$var$bubbleProperties(workInProgress), $b0f42935ea826c41$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($b0f42935ea826c41$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $b0f42935ea826c41$var$markUpdate(workInProgress), $b0f42935ea826c41$var$bubbleProperties(workInProgress), $b0f42935ea826c41$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $b0f42935ea826c41$var$popHostContext(workInProgress);
            renderLanes = $b0f42935ea826c41$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b0f42935ea826c41$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(166));
                    $b0f42935ea826c41$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $b0f42935ea826c41$var$contextStackCursor.current;
                $b0f42935ea826c41$var$popHydrationState(workInProgress) ? $b0f42935ea826c41$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $b0f42935ea826c41$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $b0f42935ea826c41$var$markUpdate(workInProgress));
            }
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $b0f42935ea826c41$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b0f42935ea826c41$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(166));
                    $b0f42935ea826c41$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $b0f42935ea826c41$var$contextStackCursor.current;
                if ($b0f42935ea826c41$var$popHydrationState(workInProgress)) $b0f42935ea826c41$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $b0f42935ea826c41$var$getOwnerDocumentFromRootContainer($b0f42935ea826c41$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress;
                    nextResource[$b0f42935ea826c41$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($b0f42935ea826c41$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $b0f42935ea826c41$var$markUpdate(workInProgress);
                }
            }
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            $b0f42935ea826c41$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $b0f42935ea826c41$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(166));
                current = $b0f42935ea826c41$var$rootInstanceStackCursor.current;
                if ($b0f42935ea826c41$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $b0f42935ea826c41$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $b0f42935ea826c41$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $b0f42935ea826c41$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $b0f42935ea826c41$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $b0f42935ea826c41$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(557));
                        current[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress;
                    } else $b0f42935ea826c41$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b0f42935ea826c41$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $b0f42935ea826c41$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $b0f42935ea826c41$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(558));
            }
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $b0f42935ea826c41$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(317));
                        type[$b0f42935ea826c41$var$internalInstanceKey] = workInProgress;
                    } else $b0f42935ea826c41$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $b0f42935ea826c41$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $b0f42935ea826c41$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $b0f42935ea826c41$var$popSuspenseHandler(workInProgress), workInProgress;
                    $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $b0f42935ea826c41$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $b0f42935ea826c41$var$popHostContainer(), null === current && $b0f42935ea826c41$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
        case 10:
            return $b0f42935ea826c41$var$popProvider(workInProgress.type), $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
        case 19:
            $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $b0f42935ea826c41$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $b0f42935ea826c41$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $b0f42935ea826c41$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $b0f42935ea826c41$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $b0f42935ea826c41$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$b0f42935ea826c41$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, $b0f42935ea826c41$var$suspenseStackCursor.current & 1 | 2);
                            $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $b0f42935ea826c41$var$now() > $b0f42935ea826c41$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $b0f42935ea826c41$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $b0f42935ea826c41$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $b0f42935ea826c41$var$scheduleRetryEffect(workInProgress, current), $b0f42935ea826c41$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$b0f42935ea826c41$var$isHydrating) return $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
                    } else 2 * $b0f42935ea826c41$var$now() - newProps.renderingStartTime > $b0f42935ea826c41$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $b0f42935ea826c41$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $b0f42935ea826c41$var$now(), current.sibling = null, renderLanes = $b0f42935ea826c41$var$suspenseStackCursor.current, $b0f42935ea826c41$var$push($b0f42935ea826c41$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $b0f42935ea826c41$var$isHydrating && $b0f42935ea826c41$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $b0f42935ea826c41$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $b0f42935ea826c41$var$popSuspenseHandler(workInProgress), $b0f42935ea826c41$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($b0f42935ea826c41$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $b0f42935ea826c41$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $b0f42935ea826c41$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext), $b0f42935ea826c41$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $b0f42935ea826c41$var$unwindWork(current, workInProgress) {
    $b0f42935ea826c41$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext), $b0f42935ea826c41$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $b0f42935ea826c41$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(340));
                $b0f42935ea826c41$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $b0f42935ea826c41$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(340));
                $b0f42935ea826c41$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$suspenseStackCursor), null;
        case 4:
            return $b0f42935ea826c41$var$popHostContainer(), null;
        case 10:
            return $b0f42935ea826c41$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $b0f42935ea826c41$var$popSuspenseHandler(workInProgress), $b0f42935ea826c41$var$popHiddenContext(), null !== current && $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $b0f42935ea826c41$var$unwindInterruptedWork(current, interruptedWork) {
    $b0f42935ea826c41$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext);
            $b0f42935ea826c41$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $b0f42935ea826c41$var$popHostContext(interruptedWork);
            break;
        case 4:
            $b0f42935ea826c41$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $b0f42935ea826c41$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $b0f42935ea826c41$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$suspenseStackCursor);
            break;
        case 10:
            $b0f42935ea826c41$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $b0f42935ea826c41$var$popSuspenseHandler(interruptedWork);
            $b0f42935ea826c41$var$popHiddenContext();
            null !== current && $b0f42935ea826c41$var$pop($b0f42935ea826c41$var$resumedCache);
            break;
        case 24:
            $b0f42935ea826c41$var$popProvider($b0f42935ea826c41$var$CacheContext);
    }
}
function $b0f42935ea826c41$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b0f42935ea826c41$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $b0f42935ea826c41$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b0f42935ea826c41$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $b0f42935ea826c41$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b0f42935ea826c41$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $b0f42935ea826c41$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b0f42935ea826c41$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $b0f42935ea826c41$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $b0f42935ea826c41$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $b0f42935ea826c41$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $b0f42935ea826c41$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b0f42935ea826c41$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $b0f42935ea826c41$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$b0f42935ea826c41$var$internalPropsKey] = newProps;
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b0f42935ea826c41$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $b0f42935ea826c41$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $b0f42935ea826c41$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $b0f42935ea826c41$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $b0f42935ea826c41$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $b0f42935ea826c41$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $b0f42935ea826c41$var$noop$1));
    else if (4 !== tag && (27 === tag && $b0f42935ea826c41$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($b0f42935ea826c41$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$b0f42935ea826c41$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $b0f42935ea826c41$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $b0f42935ea826c41$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($b0f42935ea826c41$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$b0f42935ea826c41$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $b0f42935ea826c41$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $b0f42935ea826c41$var$setInitialProperties(singleton, type, props);
        singleton[$b0f42935ea826c41$var$internalInstanceKey] = finishedWork;
        singleton[$b0f42935ea826c41$var$internalPropsKey] = props;
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $b0f42935ea826c41$var$offscreenSubtreeIsHidden = !1, $b0f42935ea826c41$var$offscreenSubtreeWasHidden = !1, $b0f42935ea826c41$var$needsFormReset = !1, $b0f42935ea826c41$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $b0f42935ea826c41$var$nextEffect = null;
function $b0f42935ea826c41$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $b0f42935ea826c41$var$eventsEnabled = $b0f42935ea826c41$var$_enabled;
    root = $b0f42935ea826c41$var$getActiveElementDeep(root);
    if ($b0f42935ea826c41$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $b0f42935ea826c41$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $b0f42935ea826c41$var$_enabled = !1;
    for($b0f42935ea826c41$var$nextEffect = firstChild; null !== $b0f42935ea826c41$var$nextEffect;)if (firstChild = $b0f42935ea826c41$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $b0f42935ea826c41$var$nextEffect = root;
    else for(; null !== $b0f42935ea826c41$var$nextEffect;){
        firstChild = $b0f42935ea826c41$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $b0f42935ea826c41$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $b0f42935ea826c41$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $b0f42935ea826c41$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $b0f42935ea826c41$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $b0f42935ea826c41$var$nextEffect = root;
            break;
        }
        $b0f42935ea826c41$var$nextEffect = firstChild.return;
    }
}
function $b0f42935ea826c41$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b0f42935ea826c41$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $b0f42935ea826c41$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $b0f42935ea826c41$var$commitClassCallbacks(finishedWork);
            flags & 512 && $b0f42935ea826c41$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $b0f42935ea826c41$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $b0f42935ea826c41$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $b0f42935ea826c41$var$commitHostMount(finishedWork);
            flags & 512 && $b0f42935ea826c41$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b0f42935ea826c41$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $b0f42935ea826c41$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $b0f42935ea826c41$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $b0f42935ea826c41$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $b0f42935ea826c41$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $b0f42935ea826c41$var$offscreenSubtreeWasHidden;
                prevProps = $b0f42935ea826c41$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $b0f42935ea826c41$var$offscreenSubtreeWasHidden;
                $b0f42935ea826c41$var$offscreenSubtreeIsHidden = flags;
                ($b0f42935ea826c41$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $b0f42935ea826c41$var$offscreenSubtreeIsHidden = prevProps;
                $b0f42935ea826c41$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $b0f42935ea826c41$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $b0f42935ea826c41$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $b0f42935ea826c41$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $b0f42935ea826c41$var$hostParent = null, $b0f42935ea826c41$var$hostParentIsContainer = !1;
function $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$b0f42935ea826c41$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $b0f42935ea826c41$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($b0f42935ea826c41$var$injectedHook && "function" === typeof $b0f42935ea826c41$var$injectedHook.onCommitFiberUnmount) try {
        $b0f42935ea826c41$var$injectedHook.onCommitFiberUnmount($b0f42935ea826c41$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden || $b0f42935ea826c41$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden || $b0f42935ea826c41$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $b0f42935ea826c41$var$hostParent, prevHostParentIsContainer = $b0f42935ea826c41$var$hostParentIsContainer;
            $b0f42935ea826c41$var$isSingletonScope(deletedFiber.type) && ($b0f42935ea826c41$var$hostParent = deletedFiber.stateNode, $b0f42935ea826c41$var$hostParentIsContainer = !1);
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b0f42935ea826c41$var$releaseSingletonInstance(deletedFiber.stateNode);
            $b0f42935ea826c41$var$hostParent = prevHostParent;
            $b0f42935ea826c41$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden || $b0f42935ea826c41$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $b0f42935ea826c41$var$hostParent;
            prevHostParentIsContainer = $b0f42935ea826c41$var$hostParentIsContainer;
            $b0f42935ea826c41$var$hostParent = null;
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b0f42935ea826c41$var$hostParent = prevHostParent;
            $b0f42935ea826c41$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $b0f42935ea826c41$var$hostParent) {
                if ($b0f42935ea826c41$var$hostParentIsContainer) try {
                    (9 === $b0f42935ea826c41$var$hostParent.nodeType ? $b0f42935ea826c41$var$hostParent.body : "HTML" === $b0f42935ea826c41$var$hostParent.nodeName ? $b0f42935ea826c41$var$hostParent.ownerDocument.body : $b0f42935ea826c41$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $b0f42935ea826c41$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $b0f42935ea826c41$var$hostParent && ($b0f42935ea826c41$var$hostParentIsContainer ? (finishedRoot = $b0f42935ea826c41$var$hostParent, $b0f42935ea826c41$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $b0f42935ea826c41$var$retryIfBlockedOn(finishedRoot)) : $b0f42935ea826c41$var$clearHydrationBoundary($b0f42935ea826c41$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $b0f42935ea826c41$var$hostParent;
            prevHostParentIsContainer = $b0f42935ea826c41$var$hostParentIsContainer;
            $b0f42935ea826c41$var$hostParent = deletedFiber.stateNode.containerInfo;
            $b0f42935ea826c41$var$hostParentIsContainer = !0;
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b0f42935ea826c41$var$hostParent = prevHostParent;
            $b0f42935ea826c41$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $b0f42935ea826c41$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden || $b0f42935ea826c41$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden || ($b0f42935ea826c41$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $b0f42935ea826c41$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden = (prevHostParent = $b0f42935ea826c41$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $b0f42935ea826c41$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $b0f42935ea826c41$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $b0f42935ea826c41$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $b0f42935ea826c41$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $b0f42935ea826c41$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $b0f42935ea826c41$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $b0f42935ea826c41$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $b0f42935ea826c41$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $b0f42935ea826c41$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $b0f42935ea826c41$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $b0f42935ea826c41$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($b0f42935ea826c41$var$isSingletonScope(parent.type)) {
                        $b0f42935ea826c41$var$hostParent = parent.stateNode;
                        $b0f42935ea826c41$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $b0f42935ea826c41$var$hostParent = parent.stateNode;
                    $b0f42935ea826c41$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $b0f42935ea826c41$var$hostParent = parent.stateNode.containerInfo;
                    $b0f42935ea826c41$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $b0f42935ea826c41$var$hostParent) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(160));
        $b0f42935ea826c41$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $b0f42935ea826c41$var$hostParent = null;
        $b0f42935ea826c41$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$b0f42935ea826c41$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $b0f42935ea826c41$var$currentHoistableRoot = null;
function $b0f42935ea826c41$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($b0f42935ea826c41$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $b0f42935ea826c41$var$commitHookEffectListMount(3, finishedWork), $b0f42935ea826c41$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b0f42935ea826c41$var$offscreenSubtreeWasHidden || null === current || $b0f42935ea826c41$var$safelyDetachRef(current, current.return));
            flags & 64 && $b0f42935ea826c41$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $b0f42935ea826c41$var$currentHoistableRoot;
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b0f42935ea826c41$var$offscreenSubtreeWasHidden || null === current || $b0f42935ea826c41$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$b0f42935ea826c41$var$internalHoistableMarker] || currentResource[$b0f42935ea826c41$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $b0f42935ea826c41$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$b0f42935ea826c41$var$internalInstanceKey] = finishedWork;
                                        $b0f42935ea826c41$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $b0f42935ea826c41$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b0f42935ea826c41$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $b0f42935ea826c41$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $b0f42935ea826c41$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($b0f42935ea826c41$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$b0f42935ea826c41$var$internalInstanceKey] = finishedWork;
                                $b0f42935ea826c41$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $b0f42935ea826c41$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $b0f42935ea826c41$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $b0f42935ea826c41$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $b0f42935ea826c41$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $b0f42935ea826c41$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b0f42935ea826c41$var$offscreenSubtreeWasHidden || null === current || $b0f42935ea826c41$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $b0f42935ea826c41$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($b0f42935ea826c41$var$offscreenSubtreeWasHidden || null === current || $b0f42935ea826c41$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $b0f42935ea826c41$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $b0f42935ea826c41$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($b0f42935ea826c41$var$needsFormReset = !0);
            break;
        case 6:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $b0f42935ea826c41$var$tagCaches = null;
            hoistableRoot = $b0f42935ea826c41$var$currentHoistableRoot;
            $b0f42935ea826c41$var$currentHoistableRoot = $b0f42935ea826c41$var$getHoistableRoot(root.containerInfo);
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$currentHoistableRoot = hoistableRoot;
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $b0f42935ea826c41$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $b0f42935ea826c41$var$needsFormReset && ($b0f42935ea826c41$var$needsFormReset = !1, $b0f42935ea826c41$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $b0f42935ea826c41$var$currentHoistableRoot;
            $b0f42935ea826c41$var$currentHoistableRoot = $b0f42935ea826c41$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            $b0f42935ea826c41$var$currentHoistableRoot = flags;
            break;
        case 12:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b0f42935ea826c41$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($b0f42935ea826c41$var$globalMostRecentFallbackTime = $b0f42935ea826c41$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b0f42935ea826c41$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $b0f42935ea826c41$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $b0f42935ea826c41$var$offscreenSubtreeWasHidden;
            $b0f42935ea826c41$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $b0f42935ea826c41$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $b0f42935ea826c41$var$offscreenSubtreeIsHidden || $b0f42935ea826c41$var$offscreenSubtreeWasHidden || $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $b0f42935ea826c41$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $b0f42935ea826c41$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $b0f42935ea826c41$var$hideOrUnhideDehydratedBoundary(instance, !0) : $b0f42935ea826c41$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $b0f42935ea826c41$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $b0f42935ea826c41$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $b0f42935ea826c41$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $b0f42935ea826c41$var$recursivelyTraverseMutationEffects(root, finishedWork), $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork);
    }
}
function $b0f42935ea826c41$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($b0f42935ea826c41$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $b0f42935ea826c41$var$getHostSibling(finishedWork);
                    $b0f42935ea826c41$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($b0f42935ea826c41$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $b0f42935ea826c41$var$getHostSibling(finishedWork);
                    $b0f42935ea826c41$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $b0f42935ea826c41$var$getHostSibling(finishedWork);
                    $b0f42935ea826c41$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $b0f42935ea826c41$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $b0f42935ea826c41$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $b0f42935ea826c41$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$b0f42935ea826c41$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $b0f42935ea826c41$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $b0f42935ea826c41$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $b0f42935ea826c41$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $b0f42935ea826c41$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $b0f42935ea826c41$var$safelyDetachRef(finishedWork, finishedWork.return);
                $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $b0f42935ea826c41$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b0f42935ea826c41$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$b0f42935ea826c41$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $b0f42935ea826c41$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $b0f42935ea826c41$var$commitClassCallbacks(finishedWork);
                $b0f42935ea826c41$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $b0f42935ea826c41$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $b0f42935ea826c41$var$commitHostMount(finishedWork);
                $b0f42935ea826c41$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b0f42935ea826c41$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $b0f42935ea826c41$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $b0f42935ea826c41$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $b0f42935ea826c41$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b0f42935ea826c41$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $b0f42935ea826c41$var$releaseCache(previousCache));
}
function $b0f42935ea826c41$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $b0f42935ea826c41$var$releaseCache(current));
}
function $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b0f42935ea826c41$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $b0f42935ea826c41$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b0f42935ea826c41$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $b0f42935ea826c41$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $b0f42935ea826c41$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $b0f42935ea826c41$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $b0f42935ea826c41$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $b0f42935ea826c41$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $b0f42935ea826c41$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $b0f42935ea826c41$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $b0f42935ea826c41$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b0f42935ea826c41$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b0f42935ea826c41$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $b0f42935ea826c41$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $b0f42935ea826c41$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $b0f42935ea826c41$var$suspenseyCommitFlag = 8192;
function $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $b0f42935ea826c41$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$b0f42935ea826c41$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $b0f42935ea826c41$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $b0f42935ea826c41$var$suspenseyCommitFlag && null !== fiber.memoizedState && $b0f42935ea826c41$var$suspendResource(suspendedState, $b0f42935ea826c41$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $b0f42935ea826c41$var$currentHoistableRoot;
            $b0f42935ea826c41$var$currentHoistableRoot = $b0f42935ea826c41$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $b0f42935ea826c41$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $b0f42935ea826c41$var$suspenseyCommitFlag, $b0f42935ea826c41$var$suspenseyCommitFlag = 16777216, $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $b0f42935ea826c41$var$suspenseyCommitFlag = previousHoistableRoot) : $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $b0f42935ea826c41$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $b0f42935ea826c41$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b0f42935ea826c41$var$nextEffect = childToDelete;
            $b0f42935ea826c41$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b0f42935ea826c41$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$b0f42935ea826c41$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $b0f42935ea826c41$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $b0f42935ea826c41$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $b0f42935ea826c41$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $b0f42935ea826c41$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $b0f42935ea826c41$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $b0f42935ea826c41$var$nextEffect = childToDelete;
            $b0f42935ea826c41$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $b0f42935ea826c41$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $b0f42935ea826c41$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $b0f42935ea826c41$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $b0f42935ea826c41$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $b0f42935ea826c41$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $b0f42935ea826c41$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $b0f42935ea826c41$var$nextEffect;){
        var fiber = $b0f42935ea826c41$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $b0f42935ea826c41$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $b0f42935ea826c41$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $b0f42935ea826c41$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $b0f42935ea826c41$var$nextEffect;){
            cache = $b0f42935ea826c41$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $b0f42935ea826c41$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $b0f42935ea826c41$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $b0f42935ea826c41$var$nextEffect = sibling;
                break a;
            }
            $b0f42935ea826c41$var$nextEffect = returnFiber;
        }
    }
}
var $b0f42935ea826c41$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $b0f42935ea826c41$var$readContext($b0f42935ea826c41$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $b0f42935ea826c41$var$readContext($b0f42935ea826c41$var$CacheContext).controller.signal;
    }
}, $b0f42935ea826c41$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $b0f42935ea826c41$var$executionContext = 0, $b0f42935ea826c41$var$workInProgressRoot = null, $b0f42935ea826c41$var$workInProgress = null, $b0f42935ea826c41$var$workInProgressRootRenderLanes = 0, $b0f42935ea826c41$var$workInProgressSuspendedReason = 0, $b0f42935ea826c41$var$workInProgressThrownValue = null, $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings = !1, $b0f42935ea826c41$var$workInProgressRootIsPrerendering = !1, $b0f42935ea826c41$var$workInProgressRootDidAttachPingListener = !1, $b0f42935ea826c41$var$entangledRenderLanes = 0, $b0f42935ea826c41$var$workInProgressRootExitStatus = 0, $b0f42935ea826c41$var$workInProgressRootSkippedLanes = 0, $b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes = 0, $b0f42935ea826c41$var$workInProgressRootPingedLanes = 0, $b0f42935ea826c41$var$workInProgressDeferredLane = 0, $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes = 0, $b0f42935ea826c41$var$workInProgressRootConcurrentErrors = null, $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = null, $b0f42935ea826c41$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $b0f42935ea826c41$var$globalMostRecentFallbackTime = 0, $b0f42935ea826c41$var$globalMostRecentTransitionTime = 0, $b0f42935ea826c41$var$workInProgressRootRenderTargetTime = Infinity, $b0f42935ea826c41$var$workInProgressTransitions = null, $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed = null, $b0f42935ea826c41$var$pendingEffectsStatus = 0, $b0f42935ea826c41$var$pendingEffectsRoot = null, $b0f42935ea826c41$var$pendingFinishedWork = null, $b0f42935ea826c41$var$pendingEffectsLanes = 0, $b0f42935ea826c41$var$pendingEffectsRemainingLanes = 0, $b0f42935ea826c41$var$pendingPassiveTransitions = null, $b0f42935ea826c41$var$pendingRecoverableErrors = null, $b0f42935ea826c41$var$nestedUpdateCount = 0, $b0f42935ea826c41$var$rootWithNestedUpdates = null;
function $b0f42935ea826c41$var$requestUpdateLane() {
    return 0 !== ($b0f42935ea826c41$var$executionContext & 2) && 0 !== $b0f42935ea826c41$var$workInProgressRootRenderLanes ? $b0f42935ea826c41$var$workInProgressRootRenderLanes & -$b0f42935ea826c41$var$workInProgressRootRenderLanes : null !== $b0f42935ea826c41$var$ReactSharedInternals.T ? $b0f42935ea826c41$var$requestTransitionLane() : $b0f42935ea826c41$var$resolveUpdatePriority();
}
function $b0f42935ea826c41$var$requestDeferredLane() {
    if (0 === $b0f42935ea826c41$var$workInProgressDeferredLane) {
        if (0 === ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 536870912) || $b0f42935ea826c41$var$isHydrating) {
            var lane = $b0f42935ea826c41$var$nextTransitionDeferredLane;
            $b0f42935ea826c41$var$nextTransitionDeferredLane <<= 1;
            0 === ($b0f42935ea826c41$var$nextTransitionDeferredLane & 3932160) && ($b0f42935ea826c41$var$nextTransitionDeferredLane = 262144);
            $b0f42935ea826c41$var$workInProgressDeferredLane = lane;
        } else $b0f42935ea826c41$var$workInProgressDeferredLane = 536870912;
    }
    lane = $b0f42935ea826c41$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $b0f42935ea826c41$var$workInProgressDeferredLane;
}
function $b0f42935ea826c41$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $b0f42935ea826c41$var$workInProgressRoot && (2 === $b0f42935ea826c41$var$workInProgressSuspendedReason || 9 === $b0f42935ea826c41$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $b0f42935ea826c41$var$prepareFreshStack(root, 0), $b0f42935ea826c41$var$markRootSuspended(root, $b0f42935ea826c41$var$workInProgressRootRenderLanes, $b0f42935ea826c41$var$workInProgressDeferredLane, !1);
    $b0f42935ea826c41$var$markRootUpdated$1(root, lane);
    if (0 === ($b0f42935ea826c41$var$executionContext & 2) || root !== $b0f42935ea826c41$var$workInProgressRoot) root === $b0f42935ea826c41$var$workInProgressRoot && (0 === ($b0f42935ea826c41$var$executionContext & 2) && ($b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $b0f42935ea826c41$var$workInProgressRootExitStatus && $b0f42935ea826c41$var$markRootSuspended(root, $b0f42935ea826c41$var$workInProgressRootRenderLanes, $b0f42935ea826c41$var$workInProgressDeferredLane, !1)), $b0f42935ea826c41$var$ensureRootIsScheduled(root);
}
function $b0f42935ea826c41$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($b0f42935ea826c41$var$executionContext & 6)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $b0f42935ea826c41$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $b0f42935ea826c41$var$renderRootConcurrent(root$jscomp$0, lanes) : $b0f42935ea826c41$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $b0f42935ea826c41$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $b0f42935ea826c41$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$b0f42935ea826c41$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $b0f42935ea826c41$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $b0f42935ea826c41$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($b0f42935ea826c41$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $b0f42935ea826c41$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($b0f42935ea826c41$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $b0f42935ea826c41$var$workInProgressRootRecoverableErrors;
                            $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $b0f42935ea826c41$var$workInProgressRootRecoverableErrors ? $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $b0f42935ea826c41$var$workInProgressRootRecoverableErrors.push.apply($b0f42935ea826c41$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $b0f42935ea826c41$var$prepareFreshStack(root$jscomp$0, 0);
                $b0f42935ea826c41$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($b0f42935ea826c41$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $b0f42935ea826c41$var$markRootSuspended(shouldTimeSlice, lanes, $b0f42935ea826c41$var$workInProgressDeferredLane, !$b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($b0f42935ea826c41$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $b0f42935ea826c41$var$globalMostRecentFallbackTime + 300 - $b0f42935ea826c41$var$now(), 10 < exitStatus)) {
                    $b0f42935ea826c41$var$markRootSuspended(shouldTimeSlice, lanes, $b0f42935ea826c41$var$workInProgressDeferredLane, !$b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $b0f42935ea826c41$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $b0f42935ea826c41$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $b0f42935ea826c41$var$scheduleTimeout($b0f42935ea826c41$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $b0f42935ea826c41$var$workInProgressRootRecoverableErrors, $b0f42935ea826c41$var$workInProgressTransitions, $b0f42935ea826c41$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b0f42935ea826c41$var$workInProgressDeferredLane, $b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes, $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes, $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $b0f42935ea826c41$var$commitRootWhenReady(shouldTimeSlice, forceSync, $b0f42935ea826c41$var$workInProgressRootRecoverableErrors, $b0f42935ea826c41$var$workInProgressTransitions, $b0f42935ea826c41$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $b0f42935ea826c41$var$workInProgressDeferredLane, $b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes, $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes, $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $b0f42935ea826c41$var$ensureRootIsScheduled(root$jscomp$0);
}
function $b0f42935ea826c41$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $b0f42935ea826c41$var$noop$1
        };
        $b0f42935ea826c41$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $b0f42935ea826c41$var$globalMostRecentFallbackTime - $b0f42935ea826c41$var$now() : (lanes & 4194048) === lanes ? $b0f42935ea826c41$var$globalMostRecentTransitionTime - $b0f42935ea826c41$var$now() : 0;
        timeoutOffset = $b0f42935ea826c41$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $b0f42935ea826c41$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($b0f42935ea826c41$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $b0f42935ea826c41$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $b0f42935ea826c41$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $b0f42935ea826c41$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$b0f42935ea826c41$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $b0f42935ea826c41$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$b0f42935ea826c41$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $b0f42935ea826c41$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $b0f42935ea826c41$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $b0f42935ea826c41$var$flushSyncWork$1() {
    return 0 === ($b0f42935ea826c41$var$executionContext & 6) ? ($b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $b0f42935ea826c41$var$resetWorkInProgressStack() {
    if (null !== $b0f42935ea826c41$var$workInProgress) {
        if (0 === $b0f42935ea826c41$var$workInProgressSuspendedReason) var interruptedWork = $b0f42935ea826c41$var$workInProgress.return;
        else interruptedWork = $b0f42935ea826c41$var$workInProgress, $b0f42935ea826c41$var$lastContextDependency = $b0f42935ea826c41$var$currentlyRenderingFiber$1 = null, $b0f42935ea826c41$var$resetHooksOnUnwind(interruptedWork), $b0f42935ea826c41$var$thenableState$1 = null, $b0f42935ea826c41$var$thenableIndexCounter$1 = 0, interruptedWork = $b0f42935ea826c41$var$workInProgress;
        for(; null !== interruptedWork;)$b0f42935ea826c41$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $b0f42935ea826c41$var$workInProgress = null;
    }
}
function $b0f42935ea826c41$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $b0f42935ea826c41$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $b0f42935ea826c41$var$pendingEffectsLanes = 0;
    $b0f42935ea826c41$var$resetWorkInProgressStack();
    $b0f42935ea826c41$var$workInProgressRoot = root;
    $b0f42935ea826c41$var$workInProgress = timeoutHandle = $b0f42935ea826c41$var$createWorkInProgress(root.current, null);
    $b0f42935ea826c41$var$workInProgressRootRenderLanes = lanes;
    $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
    $b0f42935ea826c41$var$workInProgressThrownValue = null;
    $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $b0f42935ea826c41$var$workInProgressRootIsPrerendering = $b0f42935ea826c41$var$checkIfRootIsPrerendering(root, lanes);
    $b0f42935ea826c41$var$workInProgressRootDidAttachPingListener = !1;
    $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes = $b0f42935ea826c41$var$workInProgressDeferredLane = $b0f42935ea826c41$var$workInProgressRootPingedLanes = $b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes = $b0f42935ea826c41$var$workInProgressRootSkippedLanes = $b0f42935ea826c41$var$workInProgressRootExitStatus = 0;
    $b0f42935ea826c41$var$workInProgressRootRecoverableErrors = $b0f42935ea826c41$var$workInProgressRootConcurrentErrors = null;
    $b0f42935ea826c41$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $b0f42935ea826c41$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $b0f42935ea826c41$var$entangledRenderLanes = lanes;
    $b0f42935ea826c41$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $b0f42935ea826c41$var$handleThrow(root, thrownValue) {
    $b0f42935ea826c41$var$currentlyRenderingFiber = null;
    $b0f42935ea826c41$var$ReactSharedInternals.H = $b0f42935ea826c41$var$ContextOnlyDispatcher;
    thrownValue === $b0f42935ea826c41$var$SuspenseException || thrownValue === $b0f42935ea826c41$var$SuspenseActionException ? (thrownValue = $b0f42935ea826c41$var$getSuspendedThenable(), $b0f42935ea826c41$var$workInProgressSuspendedReason = 3) : thrownValue === $b0f42935ea826c41$var$SuspenseyCommitException ? (thrownValue = $b0f42935ea826c41$var$getSuspendedThenable(), $b0f42935ea826c41$var$workInProgressSuspendedReason = 4) : $b0f42935ea826c41$var$workInProgressSuspendedReason = thrownValue === $b0f42935ea826c41$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $b0f42935ea826c41$var$workInProgressThrownValue = thrownValue;
    null === $b0f42935ea826c41$var$workInProgress && ($b0f42935ea826c41$var$workInProgressRootExitStatus = 1, $b0f42935ea826c41$var$logUncaughtError(root, $b0f42935ea826c41$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $b0f42935ea826c41$var$shouldRemainOnPreviousScreen() {
    var handler = $b0f42935ea826c41$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 4194048) === $b0f42935ea826c41$var$workInProgressRootRenderLanes ? null === $b0f42935ea826c41$var$shellBoundary ? !0 : !1 : ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 62914560) === $b0f42935ea826c41$var$workInProgressRootRenderLanes || 0 !== ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 536870912) ? handler === $b0f42935ea826c41$var$shellBoundary : !1;
}
function $b0f42935ea826c41$var$pushDispatcher() {
    var prevDispatcher = $b0f42935ea826c41$var$ReactSharedInternals.H;
    $b0f42935ea826c41$var$ReactSharedInternals.H = $b0f42935ea826c41$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $b0f42935ea826c41$var$ContextOnlyDispatcher : prevDispatcher;
}
function $b0f42935ea826c41$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $b0f42935ea826c41$var$ReactSharedInternals.A;
    $b0f42935ea826c41$var$ReactSharedInternals.A = $b0f42935ea826c41$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $b0f42935ea826c41$var$renderDidSuspendDelayIfPossible() {
    $b0f42935ea826c41$var$workInProgressRootExitStatus = 4;
    $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings || ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 4194048) !== $b0f42935ea826c41$var$workInProgressRootRenderLanes && null !== $b0f42935ea826c41$var$suspenseHandlerStackCursor.current || ($b0f42935ea826c41$var$workInProgressRootIsPrerendering = !0);
    0 === ($b0f42935ea826c41$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($b0f42935ea826c41$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $b0f42935ea826c41$var$workInProgressRoot || $b0f42935ea826c41$var$markRootSuspended($b0f42935ea826c41$var$workInProgressRoot, $b0f42935ea826c41$var$workInProgressRootRenderLanes, $b0f42935ea826c41$var$workInProgressDeferredLane, !1);
}
function $b0f42935ea826c41$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $b0f42935ea826c41$var$executionContext;
    $b0f42935ea826c41$var$executionContext |= 2;
    var prevDispatcher = $b0f42935ea826c41$var$pushDispatcher(), prevAsyncDispatcher = $b0f42935ea826c41$var$pushAsyncDispatcher();
    if ($b0f42935ea826c41$var$workInProgressRoot !== root || $b0f42935ea826c41$var$workInProgressRootRenderLanes !== lanes) $b0f42935ea826c41$var$workInProgressTransitions = null, $b0f42935ea826c41$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $b0f42935ea826c41$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $b0f42935ea826c41$var$workInProgressSuspendedReason && null !== $b0f42935ea826c41$var$workInProgress) {
            var unitOfWork = $b0f42935ea826c41$var$workInProgress, thrownValue = $b0f42935ea826c41$var$workInProgressThrownValue;
            switch($b0f42935ea826c41$var$workInProgressSuspendedReason){
                case 8:
                    $b0f42935ea826c41$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $b0f42935ea826c41$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $b0f42935ea826c41$var$workInProgressSuspendedReason;
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                    $b0f42935ea826c41$var$workInProgressThrownValue = null;
                    $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $b0f42935ea826c41$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $b0f42935ea826c41$var$workInProgressSuspendedReason, $b0f42935ea826c41$var$workInProgressSuspendedReason = 0, $b0f42935ea826c41$var$workInProgressThrownValue = null, $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $b0f42935ea826c41$var$workLoopSync();
        exitStatus = $b0f42935ea826c41$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $b0f42935ea826c41$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $b0f42935ea826c41$var$lastContextDependency = $b0f42935ea826c41$var$currentlyRenderingFiber$1 = null;
    $b0f42935ea826c41$var$executionContext = prevExecutionContext;
    $b0f42935ea826c41$var$ReactSharedInternals.H = prevDispatcher;
    $b0f42935ea826c41$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $b0f42935ea826c41$var$workInProgress && ($b0f42935ea826c41$var$workInProgressRoot = null, $b0f42935ea826c41$var$workInProgressRootRenderLanes = 0, $b0f42935ea826c41$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $b0f42935ea826c41$var$workLoopSync() {
    for(; null !== $b0f42935ea826c41$var$workInProgress;)$b0f42935ea826c41$var$performUnitOfWork($b0f42935ea826c41$var$workInProgress);
}
function $b0f42935ea826c41$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $b0f42935ea826c41$var$executionContext;
    $b0f42935ea826c41$var$executionContext |= 2;
    var prevDispatcher = $b0f42935ea826c41$var$pushDispatcher(), prevAsyncDispatcher = $b0f42935ea826c41$var$pushAsyncDispatcher();
    $b0f42935ea826c41$var$workInProgressRoot !== root || $b0f42935ea826c41$var$workInProgressRootRenderLanes !== lanes ? ($b0f42935ea826c41$var$workInProgressTransitions = null, $b0f42935ea826c41$var$workInProgressRootRenderTargetTime = $b0f42935ea826c41$var$now() + 500, $b0f42935ea826c41$var$prepareFreshStack(root, lanes)) : $b0f42935ea826c41$var$workInProgressRootIsPrerendering = $b0f42935ea826c41$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $b0f42935ea826c41$var$workInProgressSuspendedReason && null !== $b0f42935ea826c41$var$workInProgress) {
            lanes = $b0f42935ea826c41$var$workInProgress;
            var thrownValue = $b0f42935ea826c41$var$workInProgressThrownValue;
            b: switch($b0f42935ea826c41$var$workInProgressSuspendedReason){
                case 1:
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                    $b0f42935ea826c41$var$workInProgressThrownValue = null;
                    $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($b0f42935ea826c41$var$isThenableResolved(thrownValue)) {
                        $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                        $b0f42935ea826c41$var$workInProgressThrownValue = null;
                        $b0f42935ea826c41$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $b0f42935ea826c41$var$workInProgressSuspendedReason && 9 !== $b0f42935ea826c41$var$workInProgressSuspendedReason || $b0f42935ea826c41$var$workInProgressRoot !== root || ($b0f42935ea826c41$var$workInProgressSuspendedReason = 7);
                        $b0f42935ea826c41$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $b0f42935ea826c41$var$isThenableResolved(thrownValue) ? ($b0f42935ea826c41$var$workInProgressSuspendedReason = 0, $b0f42935ea826c41$var$workInProgressThrownValue = null, $b0f42935ea826c41$var$replaySuspendedUnitOfWork(lanes)) : ($b0f42935ea826c41$var$workInProgressSuspendedReason = 0, $b0f42935ea826c41$var$workInProgressThrownValue = null, $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($b0f42935ea826c41$var$workInProgress.tag){
                        case 26:
                            resource = $b0f42935ea826c41$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $b0f42935ea826c41$var$workInProgress;
                            if (resource ? $b0f42935ea826c41$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                                $b0f42935ea826c41$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $b0f42935ea826c41$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($b0f42935ea826c41$var$workInProgress = returnFiber, $b0f42935ea826c41$var$completeUnitOfWork(returnFiber)) : $b0f42935ea826c41$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                    $b0f42935ea826c41$var$workInProgressThrownValue = null;
                    $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $b0f42935ea826c41$var$workInProgressSuspendedReason = 0;
                    $b0f42935ea826c41$var$workInProgressThrownValue = null;
                    $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $b0f42935ea826c41$var$resetWorkInProgressStack();
                    $b0f42935ea826c41$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(462));
            }
        }
        $b0f42935ea826c41$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $b0f42935ea826c41$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $b0f42935ea826c41$var$lastContextDependency = $b0f42935ea826c41$var$currentlyRenderingFiber$1 = null;
    $b0f42935ea826c41$var$ReactSharedInternals.H = prevDispatcher;
    $b0f42935ea826c41$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $b0f42935ea826c41$var$executionContext = prevExecutionContext;
    if (null !== $b0f42935ea826c41$var$workInProgress) return 0;
    $b0f42935ea826c41$var$workInProgressRoot = null;
    $b0f42935ea826c41$var$workInProgressRootRenderLanes = 0;
    $b0f42935ea826c41$var$finishQueueingConcurrentUpdates();
    return $b0f42935ea826c41$var$workInProgressRootExitStatus;
}
function $b0f42935ea826c41$var$workLoopConcurrentByScheduler() {
    for(; null !== $b0f42935ea826c41$var$workInProgress && !$b0f42935ea826c41$var$shouldYield();)$b0f42935ea826c41$var$performUnitOfWork($b0f42935ea826c41$var$workInProgress);
}
function $b0f42935ea826c41$var$performUnitOfWork(unitOfWork) {
    var next = $b0f42935ea826c41$var$beginWork(unitOfWork.alternate, unitOfWork, $b0f42935ea826c41$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b0f42935ea826c41$var$completeUnitOfWork(unitOfWork) : $b0f42935ea826c41$var$workInProgress = next;
}
function $b0f42935ea826c41$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $b0f42935ea826c41$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $b0f42935ea826c41$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $b0f42935ea826c41$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $b0f42935ea826c41$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $b0f42935ea826c41$var$resetHooksOnUnwind(next);
        default:
            $b0f42935ea826c41$var$unwindInterruptedWork(current, next), next = $b0f42935ea826c41$var$workInProgress = $b0f42935ea826c41$var$resetWorkInProgress(next, $b0f42935ea826c41$var$entangledRenderLanes), next = $b0f42935ea826c41$var$beginWork(current, next, $b0f42935ea826c41$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $b0f42935ea826c41$var$completeUnitOfWork(unitOfWork) : $b0f42935ea826c41$var$workInProgress = next;
}
function $b0f42935ea826c41$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $b0f42935ea826c41$var$lastContextDependency = $b0f42935ea826c41$var$currentlyRenderingFiber$1 = null;
    $b0f42935ea826c41$var$resetHooksOnUnwind(unitOfWork);
    $b0f42935ea826c41$var$thenableState$1 = null;
    $b0f42935ea826c41$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($b0f42935ea826c41$var$throwException(root, returnFiber, unitOfWork, thrownValue, $b0f42935ea826c41$var$workInProgressRootRenderLanes)) {
            $b0f42935ea826c41$var$workInProgressRootExitStatus = 1;
            $b0f42935ea826c41$var$logUncaughtError(root, $b0f42935ea826c41$var$createCapturedValueAtFiber(thrownValue, root.current));
            $b0f42935ea826c41$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $b0f42935ea826c41$var$workInProgress = returnFiber, error;
        $b0f42935ea826c41$var$workInProgressRootExitStatus = 1;
        $b0f42935ea826c41$var$logUncaughtError(root, $b0f42935ea826c41$var$createCapturedValueAtFiber(thrownValue, root.current));
        $b0f42935ea826c41$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($b0f42935ea826c41$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($b0f42935ea826c41$var$workInProgressRootIsPrerendering || 0 !== ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $b0f42935ea826c41$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $b0f42935ea826c41$var$unwindUnitOfWork(unitOfWork, root);
    } else $b0f42935ea826c41$var$completeUnitOfWork(unitOfWork);
}
function $b0f42935ea826c41$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $b0f42935ea826c41$var$unwindUnitOfWork(completedWork, $b0f42935ea826c41$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $b0f42935ea826c41$var$completeWork(completedWork.alternate, completedWork, $b0f42935ea826c41$var$entangledRenderLanes);
        if (null !== next) {
            $b0f42935ea826c41$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $b0f42935ea826c41$var$workInProgress = completedWork;
            return;
        }
        $b0f42935ea826c41$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $b0f42935ea826c41$var$workInProgressRootExitStatus && ($b0f42935ea826c41$var$workInProgressRootExitStatus = 5);
}
function $b0f42935ea826c41$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $b0f42935ea826c41$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $b0f42935ea826c41$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $b0f42935ea826c41$var$workInProgress = unitOfWork;
            return;
        }
        $b0f42935ea826c41$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $b0f42935ea826c41$var$workInProgressRootExitStatus = 6;
    $b0f42935ea826c41$var$workInProgress = null;
}
function $b0f42935ea826c41$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $b0f42935ea826c41$var$flushPendingEffects();
    while (0 !== $b0f42935ea826c41$var$pendingEffectsStatus);
    if (0 !== ($b0f42935ea826c41$var$executionContext & 6)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $b0f42935ea826c41$var$concurrentlyUpdatedLanes;
        $b0f42935ea826c41$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $b0f42935ea826c41$var$workInProgressRoot && ($b0f42935ea826c41$var$workInProgress = $b0f42935ea826c41$var$workInProgressRoot = null, $b0f42935ea826c41$var$workInProgressRootRenderLanes = 0);
        $b0f42935ea826c41$var$pendingFinishedWork = finishedWork;
        $b0f42935ea826c41$var$pendingEffectsRoot = root;
        $b0f42935ea826c41$var$pendingEffectsLanes = lanes;
        $b0f42935ea826c41$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $b0f42935ea826c41$var$pendingPassiveTransitions = transitions;
        $b0f42935ea826c41$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $b0f42935ea826c41$var$scheduleCallback$1($b0f42935ea826c41$var$NormalPriority$1, function() {
            $b0f42935ea826c41$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $b0f42935ea826c41$var$ReactSharedInternals.T;
            $b0f42935ea826c41$var$ReactSharedInternals.T = null;
            transitions = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
            $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $b0f42935ea826c41$var$executionContext;
            $b0f42935ea826c41$var$executionContext |= 4;
            try {
                $b0f42935ea826c41$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $b0f42935ea826c41$var$executionContext = spawnedLane, $b0f42935ea826c41$var$ReactDOMSharedInternals.p = transitions, $b0f42935ea826c41$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $b0f42935ea826c41$var$pendingEffectsStatus = 1;
        $b0f42935ea826c41$var$flushMutationEffects();
        $b0f42935ea826c41$var$flushLayoutEffects();
        $b0f42935ea826c41$var$flushSpawnedWork();
    }
}
function $b0f42935ea826c41$var$flushMutationEffects() {
    if (1 === $b0f42935ea826c41$var$pendingEffectsStatus) {
        $b0f42935ea826c41$var$pendingEffectsStatus = 0;
        var root = $b0f42935ea826c41$var$pendingEffectsRoot, finishedWork = $b0f42935ea826c41$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $b0f42935ea826c41$var$ReactSharedInternals.T;
            $b0f42935ea826c41$var$ReactSharedInternals.T = null;
            var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
            $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b0f42935ea826c41$var$executionContext;
            $b0f42935ea826c41$var$executionContext |= 4;
            try {
                $b0f42935ea826c41$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $b0f42935ea826c41$var$selectionInformation, curFocusedElem = $b0f42935ea826c41$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $b0f42935ea826c41$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $b0f42935ea826c41$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $b0f42935ea826c41$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $b0f42935ea826c41$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $b0f42935ea826c41$var$_enabled = !!$b0f42935ea826c41$var$eventsEnabled;
                $b0f42935ea826c41$var$selectionInformation = $b0f42935ea826c41$var$eventsEnabled = null;
            } finally{
                $b0f42935ea826c41$var$executionContext = prevExecutionContext, $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, $b0f42935ea826c41$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $b0f42935ea826c41$var$pendingEffectsStatus = 2;
    }
}
function $b0f42935ea826c41$var$flushLayoutEffects() {
    if (2 === $b0f42935ea826c41$var$pendingEffectsStatus) {
        $b0f42935ea826c41$var$pendingEffectsStatus = 0;
        var root = $b0f42935ea826c41$var$pendingEffectsRoot, finishedWork = $b0f42935ea826c41$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $b0f42935ea826c41$var$ReactSharedInternals.T;
            $b0f42935ea826c41$var$ReactSharedInternals.T = null;
            var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
            $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $b0f42935ea826c41$var$executionContext;
            $b0f42935ea826c41$var$executionContext |= 4;
            try {
                $b0f42935ea826c41$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $b0f42935ea826c41$var$executionContext = prevExecutionContext, $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, $b0f42935ea826c41$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $b0f42935ea826c41$var$pendingEffectsStatus = 3;
    }
}
function $b0f42935ea826c41$var$flushSpawnedWork() {
    if (4 === $b0f42935ea826c41$var$pendingEffectsStatus || 3 === $b0f42935ea826c41$var$pendingEffectsStatus) {
        $b0f42935ea826c41$var$pendingEffectsStatus = 0;
        $b0f42935ea826c41$var$requestPaint();
        var root = $b0f42935ea826c41$var$pendingEffectsRoot, finishedWork = $b0f42935ea826c41$var$pendingFinishedWork, lanes = $b0f42935ea826c41$var$pendingEffectsLanes, recoverableErrors = $b0f42935ea826c41$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $b0f42935ea826c41$var$pendingEffectsStatus = 5 : ($b0f42935ea826c41$var$pendingEffectsStatus = 0, $b0f42935ea826c41$var$pendingFinishedWork = $b0f42935ea826c41$var$pendingEffectsRoot = null, $b0f42935ea826c41$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $b0f42935ea826c41$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($b0f42935ea826c41$var$injectedHook && "function" === typeof $b0f42935ea826c41$var$injectedHook.onCommitFiberRoot) try {
            $b0f42935ea826c41$var$injectedHook.onCommitFiberRoot($b0f42935ea826c41$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $b0f42935ea826c41$var$ReactSharedInternals.T;
            remainingLanes = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
            $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 2;
            $b0f42935ea826c41$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $b0f42935ea826c41$var$ReactSharedInternals.T = finishedWork, $b0f42935ea826c41$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($b0f42935ea826c41$var$pendingEffectsLanes & 3) && $b0f42935ea826c41$var$flushPendingEffects();
        $b0f42935ea826c41$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $b0f42935ea826c41$var$rootWithNestedUpdates ? $b0f42935ea826c41$var$nestedUpdateCount++ : ($b0f42935ea826c41$var$nestedUpdateCount = 0, $b0f42935ea826c41$var$rootWithNestedUpdates = root) : $b0f42935ea826c41$var$nestedUpdateCount = 0;
        $b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $b0f42935ea826c41$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $b0f42935ea826c41$var$releaseCache(remainingLanes)));
}
function $b0f42935ea826c41$var$flushPendingEffects() {
    $b0f42935ea826c41$var$flushMutationEffects();
    $b0f42935ea826c41$var$flushLayoutEffects();
    $b0f42935ea826c41$var$flushSpawnedWork();
    return $b0f42935ea826c41$var$flushPassiveEffects();
}
function $b0f42935ea826c41$var$flushPassiveEffects() {
    if (5 !== $b0f42935ea826c41$var$pendingEffectsStatus) return !1;
    var root = $b0f42935ea826c41$var$pendingEffectsRoot, remainingLanes = $b0f42935ea826c41$var$pendingEffectsRemainingLanes;
    $b0f42935ea826c41$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $b0f42935ea826c41$var$lanesToEventPriority($b0f42935ea826c41$var$pendingEffectsLanes), prevTransition = $b0f42935ea826c41$var$ReactSharedInternals.T, previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    try {
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $b0f42935ea826c41$var$ReactSharedInternals.T = null;
        renderPriority = $b0f42935ea826c41$var$pendingPassiveTransitions;
        $b0f42935ea826c41$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $b0f42935ea826c41$var$pendingEffectsRoot, lanes = $b0f42935ea826c41$var$pendingEffectsLanes;
        $b0f42935ea826c41$var$pendingEffectsStatus = 0;
        $b0f42935ea826c41$var$pendingFinishedWork = $b0f42935ea826c41$var$pendingEffectsRoot = null;
        $b0f42935ea826c41$var$pendingEffectsLanes = 0;
        if (0 !== ($b0f42935ea826c41$var$executionContext & 6)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(331));
        var prevExecutionContext = $b0f42935ea826c41$var$executionContext;
        $b0f42935ea826c41$var$executionContext |= 4;
        $b0f42935ea826c41$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $b0f42935ea826c41$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $b0f42935ea826c41$var$executionContext = prevExecutionContext;
        $b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($b0f42935ea826c41$var$injectedHook && "function" === typeof $b0f42935ea826c41$var$injectedHook.onPostCommitFiberRoot) try {
            $b0f42935ea826c41$var$injectedHook.onPostCommitFiberRoot($b0f42935ea826c41$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, $b0f42935ea826c41$var$ReactSharedInternals.T = prevTransition, $b0f42935ea826c41$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $b0f42935ea826c41$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $b0f42935ea826c41$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $b0f42935ea826c41$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $b0f42935ea826c41$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($b0f42935ea826c41$var$markRootUpdated$1(rootFiber, 2), $b0f42935ea826c41$var$ensureRootIsScheduled(rootFiber));
}
function $b0f42935ea826c41$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $b0f42935ea826c41$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $b0f42935ea826c41$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed || !$b0f42935ea826c41$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $b0f42935ea826c41$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $b0f42935ea826c41$var$createClassErrorUpdate(2);
                instance = $b0f42935ea826c41$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($b0f42935ea826c41$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $b0f42935ea826c41$var$markRootUpdated$1(instance, 2), $b0f42935ea826c41$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $b0f42935ea826c41$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $b0f42935ea826c41$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($b0f42935ea826c41$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $b0f42935ea826c41$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $b0f42935ea826c41$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $b0f42935ea826c41$var$workInProgressRoot === root && ($b0f42935ea826c41$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $b0f42935ea826c41$var$workInProgressRootExitStatus || 3 === $b0f42935ea826c41$var$workInProgressRootExitStatus && ($b0f42935ea826c41$var$workInProgressRootRenderLanes & 62914560) === $b0f42935ea826c41$var$workInProgressRootRenderLanes && 300 > $b0f42935ea826c41$var$now() - $b0f42935ea826c41$var$globalMostRecentFallbackTime ? 0 === ($b0f42935ea826c41$var$executionContext & 2) && $b0f42935ea826c41$var$prepareFreshStack(root, 0) : $b0f42935ea826c41$var$workInProgressRootPingedLanes |= pingedLanes, $b0f42935ea826c41$var$workInProgressSuspendedRetryLanes === $b0f42935ea826c41$var$workInProgressRootRenderLanes && ($b0f42935ea826c41$var$workInProgressSuspendedRetryLanes = 0));
    $b0f42935ea826c41$var$ensureRootIsScheduled(root);
}
function $b0f42935ea826c41$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $b0f42935ea826c41$var$claimNextRetryLane());
    boundaryFiber = $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($b0f42935ea826c41$var$markRootUpdated$1(boundaryFiber, retryLane), $b0f42935ea826c41$var$ensureRootIsScheduled(boundaryFiber));
}
function $b0f42935ea826c41$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $b0f42935ea826c41$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b0f42935ea826c41$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $b0f42935ea826c41$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $b0f42935ea826c41$var$scheduleCallback$1(priorityLevel, callback) {
    return $b0f42935ea826c41$var$scheduleCallback$3(priorityLevel, callback);
}
var $b0f42935ea826c41$var$firstScheduledRoot = null, $b0f42935ea826c41$var$lastScheduledRoot = null, $b0f42935ea826c41$var$didScheduleMicrotask = !1, $b0f42935ea826c41$var$mightHavePendingSyncWork = !1, $b0f42935ea826c41$var$isFlushingWork = !1, $b0f42935ea826c41$var$currentEventTransitionLane = 0;
function $b0f42935ea826c41$var$ensureRootIsScheduled(root) {
    root !== $b0f42935ea826c41$var$lastScheduledRoot && null === root.next && (null === $b0f42935ea826c41$var$lastScheduledRoot ? $b0f42935ea826c41$var$firstScheduledRoot = $b0f42935ea826c41$var$lastScheduledRoot = root : $b0f42935ea826c41$var$lastScheduledRoot = $b0f42935ea826c41$var$lastScheduledRoot.next = root);
    $b0f42935ea826c41$var$mightHavePendingSyncWork = !0;
    $b0f42935ea826c41$var$didScheduleMicrotask || ($b0f42935ea826c41$var$didScheduleMicrotask = !0, $b0f42935ea826c41$var$scheduleImmediateRootScheduleTask());
}
function $b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$b0f42935ea826c41$var$isFlushingWork && $b0f42935ea826c41$var$mightHavePendingSyncWork) {
        $b0f42935ea826c41$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $b0f42935ea826c41$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $b0f42935ea826c41$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $b0f42935ea826c41$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $b0f42935ea826c41$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $b0f42935ea826c41$var$getNextLanes(root$170, root$170 === $b0f42935ea826c41$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $b0f42935ea826c41$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $b0f42935ea826c41$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $b0f42935ea826c41$var$isFlushingWork = !1;
    }
}
function $b0f42935ea826c41$var$processRootScheduleInImmediateTask() {
    $b0f42935ea826c41$var$processRootScheduleInMicrotask();
}
function $b0f42935ea826c41$var$processRootScheduleInMicrotask() {
    $b0f42935ea826c41$var$mightHavePendingSyncWork = $b0f42935ea826c41$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $b0f42935ea826c41$var$currentEventTransitionLane && $b0f42935ea826c41$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $b0f42935ea826c41$var$currentEventTransitionLane);
    for(var currentTime = $b0f42935ea826c41$var$now(), prev = null, root = $b0f42935ea826c41$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $b0f42935ea826c41$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $b0f42935ea826c41$var$firstScheduledRoot = next : prev.next = next, null === next && ($b0f42935ea826c41$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $b0f42935ea826c41$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $b0f42935ea826c41$var$pendingEffectsStatus && 5 !== $b0f42935ea826c41$var$pendingEffectsStatus || $b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $b0f42935ea826c41$var$currentEventTransitionLane && ($b0f42935ea826c41$var$currentEventTransitionLane = 0);
}
function $b0f42935ea826c41$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $b0f42935ea826c41$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $b0f42935ea826c41$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $b0f42935ea826c41$var$workInProgressRoot;
    suspendedLanes = $b0f42935ea826c41$var$workInProgressRootRenderLanes;
    suspendedLanes = $b0f42935ea826c41$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $b0f42935ea826c41$var$workInProgressSuspendedReason || 9 === $b0f42935ea826c41$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $b0f42935ea826c41$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $b0f42935ea826c41$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $b0f42935ea826c41$var$cancelCallback$1(pingedLanes);
        switch($b0f42935ea826c41$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $b0f42935ea826c41$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $b0f42935ea826c41$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $b0f42935ea826c41$var$IdlePriority;
                break;
            default:
                suspendedLanes = $b0f42935ea826c41$var$NormalPriority$1;
        }
        pingedLanes = $b0f42935ea826c41$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $b0f42935ea826c41$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $b0f42935ea826c41$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $b0f42935ea826c41$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $b0f42935ea826c41$var$pendingEffectsStatus && 5 !== $b0f42935ea826c41$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($b0f42935ea826c41$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $b0f42935ea826c41$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $b0f42935ea826c41$var$getNextLanes(root, root === $b0f42935ea826c41$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $b0f42935ea826c41$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $b0f42935ea826c41$var$scheduleTaskForRootDuringMicrotask(root, $b0f42935ea826c41$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $b0f42935ea826c41$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $b0f42935ea826c41$var$performSyncWorkOnRoot(root, lanes) {
    if ($b0f42935ea826c41$var$flushPendingEffects()) return null;
    $b0f42935ea826c41$var$performWorkOnRoot(root, lanes, !0);
}
function $b0f42935ea826c41$var$scheduleImmediateRootScheduleTask() {
    $b0f42935ea826c41$var$scheduleMicrotask(function() {
        0 !== ($b0f42935ea826c41$var$executionContext & 6) ? $b0f42935ea826c41$var$scheduleCallback$3($b0f42935ea826c41$var$ImmediatePriority, $b0f42935ea826c41$var$processRootScheduleInImmediateTask) : $b0f42935ea826c41$var$processRootScheduleInMicrotask();
    });
}
function $b0f42935ea826c41$var$requestTransitionLane() {
    if (0 === $b0f42935ea826c41$var$currentEventTransitionLane) {
        var actionScopeLane = $b0f42935ea826c41$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $b0f42935ea826c41$var$nextTransitionUpdateLane, $b0f42935ea826c41$var$nextTransitionUpdateLane <<= 1, 0 === ($b0f42935ea826c41$var$nextTransitionUpdateLane & 261888) && ($b0f42935ea826c41$var$nextTransitionUpdateLane = 256));
        $b0f42935ea826c41$var$currentEventTransitionLane = actionScopeLane;
    }
    return $b0f42935ea826c41$var$currentEventTransitionLane;
}
function $b0f42935ea826c41$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $b0f42935ea826c41$var$sanitizeURL("" + actionProp);
}
function $b0f42935ea826c41$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $b0f42935ea826c41$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $b0f42935ea826c41$var$coerceFormActionProp((nativeEventTarget[$b0f42935ea826c41$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$b0f42935ea826c41$var$internalPropsKey] || null) ? $b0f42935ea826c41$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $b0f42935ea826c41$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $b0f42935ea826c41$var$currentEventTransitionLane) {
                                var formData = submitter ? $b0f42935ea826c41$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $b0f42935ea826c41$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $b0f42935ea826c41$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $b0f42935ea826c41$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $b0f42935ea826c41$var$i$jscomp$inline_1577 = 0; $b0f42935ea826c41$var$i$jscomp$inline_1577 < $b0f42935ea826c41$var$simpleEventPluginEvents.length; $b0f42935ea826c41$var$i$jscomp$inline_1577++){
    var $b0f42935ea826c41$var$eventName$jscomp$inline_1578 = $b0f42935ea826c41$var$simpleEventPluginEvents[$b0f42935ea826c41$var$i$jscomp$inline_1577], $b0f42935ea826c41$var$domEventName$jscomp$inline_1579 = $b0f42935ea826c41$var$eventName$jscomp$inline_1578.toLowerCase(), $b0f42935ea826c41$var$capitalizedEvent$jscomp$inline_1580 = $b0f42935ea826c41$var$eventName$jscomp$inline_1578[0].toUpperCase() + $b0f42935ea826c41$var$eventName$jscomp$inline_1578.slice(1);
    $b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$domEventName$jscomp$inline_1579, "on" + $b0f42935ea826c41$var$capitalizedEvent$jscomp$inline_1580);
}
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$ANIMATION_END, "onAnimationEnd");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$ANIMATION_ITERATION, "onAnimationIteration");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$ANIMATION_START, "onAnimationStart");
$b0f42935ea826c41$var$registerSimpleEvent("dblclick", "onDoubleClick");
$b0f42935ea826c41$var$registerSimpleEvent("focusin", "onFocus");
$b0f42935ea826c41$var$registerSimpleEvent("focusout", "onBlur");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$TRANSITION_RUN, "onTransitionRun");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$TRANSITION_START, "onTransitionStart");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$TRANSITION_CANCEL, "onTransitionCancel");
$b0f42935ea826c41$var$registerSimpleEvent($b0f42935ea826c41$var$TRANSITION_END, "onTransitionEnd");
$b0f42935ea826c41$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b0f42935ea826c41$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b0f42935ea826c41$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b0f42935ea826c41$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b0f42935ea826c41$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b0f42935ea826c41$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b0f42935ea826c41$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b0f42935ea826c41$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b0f42935ea826c41$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b0f42935ea826c41$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b0f42935ea826c41$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b0f42935ea826c41$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($b0f42935ea826c41$var$mediaEventTypes));
function $b0f42935ea826c41$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b0f42935ea826c41$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $b0f42935ea826c41$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $b0f42935ea826c41$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$b0f42935ea826c41$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$b0f42935ea826c41$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($b0f42935ea826c41$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $b0f42935ea826c41$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $b0f42935ea826c41$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $b0f42935ea826c41$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $b0f42935ea826c41$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$b0f42935ea826c41$var$listeningMarker]) {
        rootContainerElement[$b0f42935ea826c41$var$listeningMarker] = !0;
        $b0f42935ea826c41$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($b0f42935ea826c41$var$nonDelegatedEvents.has(domEventName) || $b0f42935ea826c41$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $b0f42935ea826c41$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$b0f42935ea826c41$var$listeningMarker] || (ownerDocument[$b0f42935ea826c41$var$listeningMarker] = !0, $b0f42935ea826c41$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $b0f42935ea826c41$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($b0f42935ea826c41$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $b0f42935ea826c41$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $b0f42935ea826c41$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $b0f42935ea826c41$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$b0f42935ea826c41$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $b0f42935ea826c41$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $b0f42935ea826c41$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $b0f42935ea826c41$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $b0f42935ea826c41$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $b0f42935ea826c41$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $b0f42935ea826c41$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticTouchEvent;
                        break;
                    case $b0f42935ea826c41$var$ANIMATION_END:
                    case $b0f42935ea826c41$var$ANIMATION_ITERATION:
                    case $b0f42935ea826c41$var$ANIMATION_START:
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticAnimationEvent;
                        break;
                    case $b0f42935ea826c41$var$TRANSITION_END:
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $b0f42935ea826c41$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $b0f42935ea826c41$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($b0f42935ea826c41$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $b0f42935ea826c41$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($b0f42935ea826c41$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$b0f42935ea826c41$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $b0f42935ea826c41$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $b0f42935ea826c41$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $b0f42935ea826c41$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $b0f42935ea826c41$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $b0f42935ea826c41$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $b0f42935ea826c41$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $b0f42935ea826c41$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $b0f42935ea826c41$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $b0f42935ea826c41$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $b0f42935ea826c41$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $b0f42935ea826c41$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $b0f42935ea826c41$var$getTargetInstForChangeEvent;
                else if ($b0f42935ea826c41$var$isTextInputElement(reactName)) {
                    if ($b0f42935ea826c41$var$isInputEventSupported) getTargetInstFunc = $b0f42935ea826c41$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $b0f42935ea826c41$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $b0f42935ea826c41$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $b0f42935ea826c41$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $b0f42935ea826c41$var$getTargetInstForChangeEvent) : getTargetInstFunc = $b0f42935ea826c41$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $b0f42935ea826c41$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $b0f42935ea826c41$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $b0f42935ea826c41$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($b0f42935ea826c41$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $b0f42935ea826c41$var$activeElement = handleEventFunc, $b0f42935ea826c41$var$activeElementInst = targetInst, $b0f42935ea826c41$var$lastSelection = null;
                    break;
                case "focusout":
                    $b0f42935ea826c41$var$lastSelection = $b0f42935ea826c41$var$activeElementInst = $b0f42935ea826c41$var$activeElement = null;
                    break;
                case "mousedown":
                    $b0f42935ea826c41$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b0f42935ea826c41$var$mouseDown = !1;
                    $b0f42935ea826c41$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($b0f42935ea826c41$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $b0f42935ea826c41$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($b0f42935ea826c41$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $b0f42935ea826c41$var$isComposing ? $b0f42935ea826c41$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($b0f42935ea826c41$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($b0f42935ea826c41$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $b0f42935ea826c41$var$isComposing && (fallbackData = $b0f42935ea826c41$var$getData()) : ($b0f42935ea826c41$var$root = nativeEventTarget, $b0f42935ea826c41$var$startText = "value" in $b0f42935ea826c41$var$root ? $b0f42935ea826c41$var$root.value : $b0f42935ea826c41$var$root.textContent, $b0f42935ea826c41$var$isComposing = !0)), handleEventFunc = $b0f42935ea826c41$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $b0f42935ea826c41$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $b0f42935ea826c41$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $b0f42935ea826c41$var$canUseTextInputEvent ? $b0f42935ea826c41$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $b0f42935ea826c41$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $b0f42935ea826c41$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $b0f42935ea826c41$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $b0f42935ea826c41$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $b0f42935ea826c41$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $b0f42935ea826c41$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $b0f42935ea826c41$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $b0f42935ea826c41$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($b0f42935ea826c41$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $b0f42935ea826c41$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($b0f42935ea826c41$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $b0f42935ea826c41$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $b0f42935ea826c41$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $b0f42935ea826c41$var$getListener(target, registrationName), null != stateNode && listeners.unshift($b0f42935ea826c41$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $b0f42935ea826c41$var$getListener(target, registrationName), null != stateNode && listeners.push($b0f42935ea826c41$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $b0f42935ea826c41$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $b0f42935ea826c41$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $b0f42935ea826c41$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($b0f42935ea826c41$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($b0f42935ea826c41$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $b0f42935ea826c41$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $b0f42935ea826c41$var$normalizeMarkupForTextOrAttribute(clientText);
    return $b0f42935ea826c41$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $b0f42935ea826c41$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $b0f42935ea826c41$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $b0f42935ea826c41$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $b0f42935ea826c41$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $b0f42935ea826c41$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $b0f42935ea826c41$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $b0f42935ea826c41$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $b0f42935ea826c41$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b0f42935ea826c41$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $b0f42935ea826c41$var$setProp(domElement, tag, "name", props.name, props, null), $b0f42935ea826c41$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $b0f42935ea826c41$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $b0f42935ea826c41$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($b0f42935ea826c41$var$setProp(domElement, tag, "encType", props.encType, props, null), $b0f42935ea826c41$var$setProp(domElement, tag, "method", props.method, props, null), $b0f42935ea826c41$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $b0f42935ea826c41$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b0f42935ea826c41$var$noop$1);
            break;
        case "onScroll":
            null != value && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $b0f42935ea826c41$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("toggle", domElement);
            $b0f42935ea826c41$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $b0f42935ea826c41$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $b0f42935ea826c41$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $b0f42935ea826c41$var$aliases.get(key) || key, $b0f42935ea826c41$var$setValueForAttribute(domElement, key, value);
    }
}
function $b0f42935ea826c41$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $b0f42935ea826c41$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $b0f42935ea826c41$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $b0f42935ea826c41$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $b0f42935ea826c41$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $b0f42935ea826c41$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$b0f42935ea826c41$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$b0f42935ea826c41$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $b0f42935ea826c41$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $b0f42935ea826c41$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("error", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($b0f42935ea826c41$var$formatProdErrorMessage(137, tag));
                    default:
                        $b0f42935ea826c41$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $b0f42935ea826c41$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $b0f42935ea826c41$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $b0f42935ea826c41$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $b0f42935ea826c41$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $b0f42935ea826c41$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $b0f42935ea826c41$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(91));
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $b0f42935ea826c41$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("toggle", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("cancel", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $b0f42935ea826c41$var$mediaEventTypes.length; hasSrc++)$b0f42935ea826c41$var$listenToNonDelegatedEvent($b0f42935ea826c41$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("error", domElement);
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $b0f42935ea826c41$var$listenToNonDelegatedEvent("error", domElement), $b0f42935ea826c41$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($b0f42935ea826c41$var$formatProdErrorMessage(137, tag));
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($b0f42935ea826c41$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $b0f42935ea826c41$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $b0f42935ea826c41$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $b0f42935ea826c41$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $b0f42935ea826c41$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $b0f42935ea826c41$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $b0f42935ea826c41$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $b0f42935ea826c41$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $b0f42935ea826c41$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $b0f42935ea826c41$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $b0f42935ea826c41$var$updateOptions(domElement, !!lastProps, tag, !0) : $b0f42935ea826c41$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $b0f42935ea826c41$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $b0f42935ea826c41$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $b0f42935ea826c41$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $b0f42935ea826c41$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($b0f42935ea826c41$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $b0f42935ea826c41$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $b0f42935ea826c41$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $b0f42935ea826c41$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $b0f42935ea826c41$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $b0f42935ea826c41$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $b0f42935ea826c41$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $b0f42935ea826c41$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $b0f42935ea826c41$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $b0f42935ea826c41$var$eventsEnabled = null, $b0f42935ea826c41$var$selectionInformation = null;
function $b0f42935ea826c41$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $b0f42935ea826c41$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $b0f42935ea826c41$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $b0f42935ea826c41$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $b0f42935ea826c41$var$currentPopstateTransitionEvent = null;
function $b0f42935ea826c41$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $b0f42935ea826c41$var$currentPopstateTransitionEvent) return !1;
        $b0f42935ea826c41$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $b0f42935ea826c41$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $b0f42935ea826c41$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $b0f42935ea826c41$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $b0f42935ea826c41$var$localPromise = "function" === typeof Promise ? Promise : void 0, $b0f42935ea826c41$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b0f42935ea826c41$var$localPromise ? function(callback) {
    return $b0f42935ea826c41$var$localPromise.resolve(null).then(callback).catch($b0f42935ea826c41$var$handleErrorInNextTick);
} : $b0f42935ea826c41$var$scheduleTimeout;
function $b0f42935ea826c41$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $b0f42935ea826c41$var$isSingletonScope(type) {
    return "head" === type;
}
function $b0f42935ea826c41$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $b0f42935ea826c41$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $b0f42935ea826c41$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $b0f42935ea826c41$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$b0f42935ea826c41$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $b0f42935ea826c41$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $b0f42935ea826c41$var$retryIfBlockedOn(hydrationInstance);
}
function $b0f42935ea826c41$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $b0f42935ea826c41$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $b0f42935ea826c41$var$clearContainerSparingly(node);
                $b0f42935ea826c41$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $b0f42935ea826c41$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$b0f42935ea826c41$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $b0f42935ea826c41$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $b0f42935ea826c41$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b0f42935ea826c41$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b0f42935ea826c41$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $b0f42935ea826c41$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $b0f42935ea826c41$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $b0f42935ea826c41$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $b0f42935ea826c41$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $b0f42935ea826c41$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $b0f42935ea826c41$var$previousHydratableOnEnteringScopedSingleton = null;
function $b0f42935ea826c41$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $b0f42935ea826c41$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $b0f42935ea826c41$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $b0f42935ea826c41$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $b0f42935ea826c41$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(451));
    }
}
function $b0f42935ea826c41$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $b0f42935ea826c41$var$detachDeletedInstance(instance);
}
var $b0f42935ea826c41$var$preloadPropsMap = new Map(), $b0f42935ea826c41$var$preconnectsSet = new Set();
function $b0f42935ea826c41$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $b0f42935ea826c41$var$previousDispatcher = $b0f42935ea826c41$var$ReactDOMSharedInternals.d;
$b0f42935ea826c41$var$ReactDOMSharedInternals.d = {
    f: $b0f42935ea826c41$var$flushSyncWork,
    r: $b0f42935ea826c41$var$requestFormReset,
    D: $b0f42935ea826c41$var$prefetchDNS,
    C: $b0f42935ea826c41$var$preconnect,
    L: $b0f42935ea826c41$var$preload,
    m: $b0f42935ea826c41$var$preloadModule,
    X: $b0f42935ea826c41$var$preinitScript,
    S: $b0f42935ea826c41$var$preinitStyle,
    M: $b0f42935ea826c41$var$preinitModuleScript
};
function $b0f42935ea826c41$var$flushSyncWork() {
    var previousWasRendering = $b0f42935ea826c41$var$previousDispatcher.f(), wasRendering = $b0f42935ea826c41$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $b0f42935ea826c41$var$requestFormReset(form) {
    var formInst = $b0f42935ea826c41$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $b0f42935ea826c41$var$requestFormReset$1(formInst) : $b0f42935ea826c41$var$previousDispatcher.r(form);
}
var $b0f42935ea826c41$var$globalDocument = "undefined" === typeof document ? null : document;
function $b0f42935ea826c41$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $b0f42935ea826c41$var$preconnectsSet.has(limitedEscapedHref) || ($b0f42935ea826c41$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $b0f42935ea826c41$var$setInitialProperties(href, "link", rel), $b0f42935ea826c41$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $b0f42935ea826c41$var$prefetchDNS(href) {
    $b0f42935ea826c41$var$previousDispatcher.D(href);
    $b0f42935ea826c41$var$preconnectAs("dns-prefetch", href, null);
}
function $b0f42935ea826c41$var$preconnect(href, crossOrigin) {
    $b0f42935ea826c41$var$previousDispatcher.C(href, crossOrigin);
    $b0f42935ea826c41$var$preconnectAs("preconnect", href, crossOrigin);
}
function $b0f42935ea826c41$var$preload(href, as, options) {
    $b0f42935ea826c41$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $b0f42935ea826c41$var$getStyleKey(href);
                break;
            case "script":
                key = $b0f42935ea826c41$var$getScriptKey(href);
        }
        $b0f42935ea826c41$var$preloadPropsMap.has(key) || (href = $b0f42935ea826c41$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $b0f42935ea826c41$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($b0f42935ea826c41$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($b0f42935ea826c41$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $b0f42935ea826c41$var$setInitialProperties(as, "link", href), $b0f42935ea826c41$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $b0f42935ea826c41$var$preloadModule(href, options) {
    $b0f42935ea826c41$var$previousDispatcher.m(href, options);
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $b0f42935ea826c41$var$getScriptKey(href);
        }
        if (!$b0f42935ea826c41$var$preloadPropsMap.has(key) && (href = $b0f42935ea826c41$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $b0f42935ea826c41$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($b0f42935ea826c41$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $b0f42935ea826c41$var$setInitialProperties(as, "link", href);
            $b0f42935ea826c41$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $b0f42935ea826c41$var$preinitStyle(href, precedence, options) {
    $b0f42935ea826c41$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $b0f42935ea826c41$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $b0f42935ea826c41$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($b0f42935ea826c41$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $b0f42935ea826c41$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $b0f42935ea826c41$var$preloadPropsMap.get(key)) && $b0f42935ea826c41$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $b0f42935ea826c41$var$markNodeAsHoistable(link);
                $b0f42935ea826c41$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $b0f42935ea826c41$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $b0f42935ea826c41$var$preinitScript(src, options) {
    $b0f42935ea826c41$var$previousDispatcher.X(src, options);
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b0f42935ea826c41$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b0f42935ea826c41$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b0f42935ea826c41$var$getScriptSelectorFromKey(key)), resource || (src = $b0f42935ea826c41$var$assign({
            src: src,
            async: !0
        }, options), (options = $b0f42935ea826c41$var$preloadPropsMap.get(key)) && $b0f42935ea826c41$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b0f42935ea826c41$var$markNodeAsHoistable(resource), $b0f42935ea826c41$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b0f42935ea826c41$var$preinitModuleScript(src, options) {
    $b0f42935ea826c41$var$previousDispatcher.M(src, options);
    var ownerDocument = $b0f42935ea826c41$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $b0f42935ea826c41$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $b0f42935ea826c41$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($b0f42935ea826c41$var$getScriptSelectorFromKey(key)), resource || (src = $b0f42935ea826c41$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $b0f42935ea826c41$var$preloadPropsMap.get(key)) && $b0f42935ea826c41$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $b0f42935ea826c41$var$markNodeAsHoistable(resource), $b0f42935ea826c41$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $b0f42935ea826c41$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $b0f42935ea826c41$var$rootInstanceStackCursor.current) ? $b0f42935ea826c41$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $b0f42935ea826c41$var$getStyleKey(pendingProps.href), pendingProps = $b0f42935ea826c41$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $b0f42935ea826c41$var$getStyleKey(pendingProps.href);
                var styles$243 = $b0f42935ea826c41$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($b0f42935ea826c41$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $b0f42935ea826c41$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $b0f42935ea826c41$var$preloadPropsMap.set(type, pendingProps), styles$243 || $b0f42935ea826c41$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $b0f42935ea826c41$var$getScriptKey(pendingProps), pendingProps = $b0f42935ea826c41$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(444, type));
    }
}
function $b0f42935ea826c41$var$getStyleKey(href) {
    return 'href="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $b0f42935ea826c41$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $b0f42935ea826c41$var$stylesheetPropsFromRawProps(rawProps) {
    return $b0f42935ea826c41$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $b0f42935ea826c41$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $b0f42935ea826c41$var$setInitialProperties(key, "link", preloadProps), $b0f42935ea826c41$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $b0f42935ea826c41$var$getScriptKey(src) {
    return '[src="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $b0f42935ea826c41$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $b0f42935ea826c41$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $b0f42935ea826c41$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $b0f42935ea826c41$var$markNodeAsHoistable(instance), instance;
            var styleProps = $b0f42935ea826c41$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $b0f42935ea826c41$var$markNodeAsHoistable(instance);
            $b0f42935ea826c41$var$setInitialProperties(instance, "style", styleProps);
            $b0f42935ea826c41$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $b0f42935ea826c41$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($b0f42935ea826c41$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $b0f42935ea826c41$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $b0f42935ea826c41$var$stylesheetPropsFromRawProps(props);
            (styleProps = $b0f42935ea826c41$var$preloadPropsMap.get(styleProps)) && $b0f42935ea826c41$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $b0f42935ea826c41$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b0f42935ea826c41$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $b0f42935ea826c41$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $b0f42935ea826c41$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($b0f42935ea826c41$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $b0f42935ea826c41$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $b0f42935ea826c41$var$preloadPropsMap.get(instance$249)) instance = $b0f42935ea826c41$var$assign({}, props), $b0f42935ea826c41$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $b0f42935ea826c41$var$markNodeAsHoistable(styleProps);
            $b0f42935ea826c41$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($b0f42935ea826c41$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $b0f42935ea826c41$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $b0f42935ea826c41$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $b0f42935ea826c41$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $b0f42935ea826c41$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $b0f42935ea826c41$var$tagCaches = null;
function $b0f42935ea826c41$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $b0f42935ea826c41$var$tagCaches) {
        var cache = new Map();
        var caches = $b0f42935ea826c41$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $b0f42935ea826c41$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$b0f42935ea826c41$var$internalHoistableMarker] || node[$b0f42935ea826c41$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $b0f42935ea826c41$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $b0f42935ea826c41$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $b0f42935ea826c41$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $b0f42935ea826c41$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $b0f42935ea826c41$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($b0f42935ea826c41$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $b0f42935ea826c41$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $b0f42935ea826c41$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $b0f42935ea826c41$var$stylesheetPropsFromRawProps(props);
            (key = $b0f42935ea826c41$var$preloadPropsMap.get(key)) && $b0f42935ea826c41$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $b0f42935ea826c41$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $b0f42935ea826c41$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $b0f42935ea826c41$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $b0f42935ea826c41$var$estimatedBytesWithinLimit = 0;
function $b0f42935ea826c41$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $b0f42935ea826c41$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $b0f42935ea826c41$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $b0f42935ea826c41$var$estimatedBytesWithinLimit && ($b0f42935ea826c41$var$estimatedBytesWithinLimit = 62500 * $b0f42935ea826c41$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $b0f42935ea826c41$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $b0f42935ea826c41$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $b0f42935ea826c41$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $b0f42935ea826c41$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $b0f42935ea826c41$var$precedencesByRoot = null;
function $b0f42935ea826c41$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $b0f42935ea826c41$var$precedencesByRoot = new Map(), resources.forEach($b0f42935ea826c41$var$insertStylesheetIntoRoot, state), $b0f42935ea826c41$var$precedencesByRoot = null, $b0f42935ea826c41$var$onUnsuspend.call(state));
}
function $b0f42935ea826c41$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $b0f42935ea826c41$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $b0f42935ea826c41$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $b0f42935ea826c41$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $b0f42935ea826c41$var$HostTransitionContext = {
    $$typeof: $b0f42935ea826c41$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $b0f42935ea826c41$var$sharedNotPendingObject,
    _currentValue2: $b0f42935ea826c41$var$sharedNotPendingObject,
    _threadCount: 0
};
function $b0f42935ea826c41$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $b0f42935ea826c41$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b0f42935ea826c41$var$createLaneMap(0);
    this.hiddenUpdates = $b0f42935ea826c41$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $b0f42935ea826c41$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $b0f42935ea826c41$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $b0f42935ea826c41$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $b0f42935ea826c41$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $b0f42935ea826c41$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $b0f42935ea826c41$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $b0f42935ea826c41$var$emptyContextObject;
    parentComponent = $b0f42935ea826c41$var$emptyContextObject;
    return parentComponent;
}
function $b0f42935ea826c41$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $b0f42935ea826c41$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $b0f42935ea826c41$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $b0f42935ea826c41$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($b0f42935ea826c41$var$scheduleUpdateOnFiber(element, rootFiber, lane), $b0f42935ea826c41$var$entangleTransitions(element, rootFiber, lane));
}
function $b0f42935ea826c41$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $b0f42935ea826c41$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $b0f42935ea826c41$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $b0f42935ea826c41$var$markRetryLaneImpl(fiber, retryLane);
}
function $b0f42935ea826c41$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $b0f42935ea826c41$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $b0f42935ea826c41$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $b0f42935ea826c41$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $b0f42935ea826c41$var$requestUpdateLane();
        lane = $b0f42935ea826c41$var$getBumpedLaneForHydrationByLane(lane);
        var root = $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $b0f42935ea826c41$var$scheduleUpdateOnFiber(root, fiber, lane);
        $b0f42935ea826c41$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $b0f42935ea826c41$var$_enabled = !0;
function $b0f42935ea826c41$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b0f42935ea826c41$var$ReactSharedInternals.T;
    $b0f42935ea826c41$var$ReactSharedInternals.T = null;
    var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    try {
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 2, $b0f42935ea826c41$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, $b0f42935ea826c41$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b0f42935ea826c41$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $b0f42935ea826c41$var$ReactSharedInternals.T;
    $b0f42935ea826c41$var$ReactSharedInternals.T = null;
    var previousPriority = $b0f42935ea826c41$var$ReactDOMSharedInternals.p;
    try {
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = 8, $b0f42935ea826c41$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $b0f42935ea826c41$var$ReactDOMSharedInternals.p = previousPriority, $b0f42935ea826c41$var$ReactSharedInternals.T = prevTransition;
    }
}
function $b0f42935ea826c41$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($b0f42935ea826c41$var$_enabled) {
        var blockedOn = $b0f42935ea826c41$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $b0f42935ea826c41$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b0f42935ea826c41$var$return_targetInst, targetContainer), $b0f42935ea826c41$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($b0f42935ea826c41$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($b0f42935ea826c41$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $b0f42935ea826c41$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $b0f42935ea826c41$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $b0f42935ea826c41$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $b0f42935ea826c41$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $b0f42935ea826c41$var$ensureRootIsScheduled(fiber);
                                0 === ($b0f42935ea826c41$var$executionContext & 6) && ($b0f42935ea826c41$var$workInProgressRootRenderTargetTime = $b0f42935ea826c41$var$now() + 500, $b0f42935ea826c41$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $b0f42935ea826c41$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $b0f42935ea826c41$var$scheduleUpdateOnFiber(root, fiber, 2), $b0f42935ea826c41$var$flushSyncWork$1(), $b0f42935ea826c41$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $b0f42935ea826c41$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $b0f42935ea826c41$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $b0f42935ea826c41$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $b0f42935ea826c41$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $b0f42935ea826c41$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $b0f42935ea826c41$var$getEventTarget(nativeEvent);
    return $b0f42935ea826c41$var$findInstanceBlockingTarget(nativeEvent);
}
var $b0f42935ea826c41$var$return_targetInst = null;
function $b0f42935ea826c41$var$findInstanceBlockingTarget(targetNode) {
    $b0f42935ea826c41$var$return_targetInst = null;
    targetNode = $b0f42935ea826c41$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $b0f42935ea826c41$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $b0f42935ea826c41$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $b0f42935ea826c41$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $b0f42935ea826c41$var$return_targetInst = targetNode;
    return null;
}
function $b0f42935ea826c41$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($b0f42935ea826c41$var$getCurrentPriorityLevel()){
                case $b0f42935ea826c41$var$ImmediatePriority:
                    return 2;
                case $b0f42935ea826c41$var$UserBlockingPriority:
                    return 8;
                case $b0f42935ea826c41$var$NormalPriority$1:
                case $b0f42935ea826c41$var$LowPriority:
                    return 32;
                case $b0f42935ea826c41$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $b0f42935ea826c41$var$hasScheduledReplayAttempt = !1, $b0f42935ea826c41$var$queuedFocus = null, $b0f42935ea826c41$var$queuedDrag = null, $b0f42935ea826c41$var$queuedMouse = null, $b0f42935ea826c41$var$queuedPointers = new Map(), $b0f42935ea826c41$var$queuedPointerCaptures = new Map(), $b0f42935ea826c41$var$queuedExplicitHydrationTargets = [], $b0f42935ea826c41$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $b0f42935ea826c41$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $b0f42935ea826c41$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $b0f42935ea826c41$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $b0f42935ea826c41$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $b0f42935ea826c41$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b0f42935ea826c41$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $b0f42935ea826c41$var$getInstanceFromNode(blockedOn), null !== blockedOn && $b0f42935ea826c41$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $b0f42935ea826c41$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $b0f42935ea826c41$var$queuedFocus = $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent($b0f42935ea826c41$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $b0f42935ea826c41$var$queuedDrag = $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent($b0f42935ea826c41$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $b0f42935ea826c41$var$queuedMouse = $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent($b0f42935ea826c41$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $b0f42935ea826c41$var$queuedPointers.set(pointerId, $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent($b0f42935ea826c41$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $b0f42935ea826c41$var$queuedPointerCaptures.set(pointerId, $b0f42935ea826c41$var$accumulateOrCreateContinuousQueuedReplayableEvent($b0f42935ea826c41$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $b0f42935ea826c41$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $b0f42935ea826c41$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $b0f42935ea826c41$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $b0f42935ea826c41$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b0f42935ea826c41$var$runWithPriority(queuedTarget.priority, function() {
                        $b0f42935ea826c41$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $b0f42935ea826c41$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $b0f42935ea826c41$var$runWithPriority(queuedTarget.priority, function() {
                        $b0f42935ea826c41$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $b0f42935ea826c41$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $b0f42935ea826c41$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $b0f42935ea826c41$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $b0f42935ea826c41$var$currentReplayingEvent = null;
        } else return targetContainers = $b0f42935ea826c41$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $b0f42935ea826c41$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $b0f42935ea826c41$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $b0f42935ea826c41$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $b0f42935ea826c41$var$replayUnblockedEvents() {
    $b0f42935ea826c41$var$hasScheduledReplayAttempt = !1;
    null !== $b0f42935ea826c41$var$queuedFocus && $b0f42935ea826c41$var$attemptReplayContinuousQueuedEvent($b0f42935ea826c41$var$queuedFocus) && ($b0f42935ea826c41$var$queuedFocus = null);
    null !== $b0f42935ea826c41$var$queuedDrag && $b0f42935ea826c41$var$attemptReplayContinuousQueuedEvent($b0f42935ea826c41$var$queuedDrag) && ($b0f42935ea826c41$var$queuedDrag = null);
    null !== $b0f42935ea826c41$var$queuedMouse && $b0f42935ea826c41$var$attemptReplayContinuousQueuedEvent($b0f42935ea826c41$var$queuedMouse) && ($b0f42935ea826c41$var$queuedMouse = null);
    $b0f42935ea826c41$var$queuedPointers.forEach($b0f42935ea826c41$var$attemptReplayContinuousQueuedEventInMap);
    $b0f42935ea826c41$var$queuedPointerCaptures.forEach($b0f42935ea826c41$var$attemptReplayContinuousQueuedEventInMap);
}
function $b0f42935ea826c41$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $b0f42935ea826c41$var$hasScheduledReplayAttempt || ($b0f42935ea826c41$var$hasScheduledReplayAttempt = !0, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, $b0f42935ea826c41$var$replayUnblockedEvents)));
}
var $b0f42935ea826c41$var$lastScheduledReplayQueue = null;
function $b0f42935ea826c41$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $b0f42935ea826c41$var$lastScheduledReplayQueue !== formReplayingQueue && ($b0f42935ea826c41$var$lastScheduledReplayQueue = formReplayingQueue, $bIbqH.unstable_scheduleCallback($bIbqH.unstable_NormalPriority, function() {
        $b0f42935ea826c41$var$lastScheduledReplayQueue === formReplayingQueue && ($b0f42935ea826c41$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $b0f42935ea826c41$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $b0f42935ea826c41$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $b0f42935ea826c41$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $b0f42935ea826c41$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $b0f42935ea826c41$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $b0f42935ea826c41$var$queuedFocus && $b0f42935ea826c41$var$scheduleCallbackIfUnblocked($b0f42935ea826c41$var$queuedFocus, unblocked);
    null !== $b0f42935ea826c41$var$queuedDrag && $b0f42935ea826c41$var$scheduleCallbackIfUnblocked($b0f42935ea826c41$var$queuedDrag, unblocked);
    null !== $b0f42935ea826c41$var$queuedMouse && $b0f42935ea826c41$var$scheduleCallbackIfUnblocked($b0f42935ea826c41$var$queuedMouse, unblocked);
    $b0f42935ea826c41$var$queuedPointers.forEach(unblock);
    $b0f42935ea826c41$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $b0f42935ea826c41$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $b0f42935ea826c41$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $b0f42935ea826c41$var$queuedExplicitHydrationTargets.length && (i = $b0f42935ea826c41$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$b0f42935ea826c41$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $b0f42935ea826c41$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$b0f42935ea826c41$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $b0f42935ea826c41$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$b0f42935ea826c41$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $b0f42935ea826c41$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $b0f42935ea826c41$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $b0f42935ea826c41$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $b0f42935ea826c41$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b0f42935ea826c41$var$ReactDOMHydrationRoot.prototype.render = $b0f42935ea826c41$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(409));
    var current = root.current, lane = $b0f42935ea826c41$var$requestUpdateLane();
    $b0f42935ea826c41$var$updateContainerImpl(current, lane, children, root, null, null);
};
$b0f42935ea826c41$var$ReactDOMHydrationRoot.prototype.unmount = $b0f42935ea826c41$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $b0f42935ea826c41$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $b0f42935ea826c41$var$flushSyncWork$1();
        container[$b0f42935ea826c41$var$internalContainerInstanceKey] = null;
    }
};
function $b0f42935ea826c41$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$b0f42935ea826c41$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $b0f42935ea826c41$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $b0f42935ea826c41$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $b0f42935ea826c41$var$queuedExplicitHydrationTargets[i].priority; i++);
        $b0f42935ea826c41$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $b0f42935ea826c41$var$attemptExplicitHydrationTarget(target);
    }
};
var $b0f42935ea826c41$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $jXEQt.version;
if ("19.2.3" !== $b0f42935ea826c41$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(527, $b0f42935ea826c41$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.3"));
$b0f42935ea826c41$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($b0f42935ea826c41$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $b0f42935ea826c41$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $b0f42935ea826c41$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $b0f42935ea826c41$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.3",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $b0f42935ea826c41$var$ReactSharedInternals,
    reconcilerVersion: "19.2.3"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b0f42935ea826c41$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b0f42935ea826c41$var$hook$jscomp$inline_2348.isDisabled && $b0f42935ea826c41$var$hook$jscomp$inline_2348.supportsFiber) try {
        $b0f42935ea826c41$var$rendererID = $b0f42935ea826c41$var$hook$jscomp$inline_2348.inject($b0f42935ea826c41$var$internals$jscomp$inline_2347), $b0f42935ea826c41$var$injectedHook = $b0f42935ea826c41$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$b0f42935ea826c41$export$882461b6382ed46c = function(container, options) {
    if (!$b0f42935ea826c41$var$isValidContainer(container)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b0f42935ea826c41$var$defaultOnUncaughtError, onCaughtError = $b0f42935ea826c41$var$defaultOnCaughtError, onRecoverableError = $b0f42935ea826c41$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $b0f42935ea826c41$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $b0f42935ea826c41$var$defaultOnDefaultTransitionIndicator);
    container[$b0f42935ea826c41$var$internalContainerInstanceKey] = options.current;
    $b0f42935ea826c41$var$listenToAllSupportedEvents(container);
    return new $b0f42935ea826c41$var$ReactDOMRoot(options);
};
$b0f42935ea826c41$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$b0f42935ea826c41$var$isValidContainer(container)) throw Error($b0f42935ea826c41$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $b0f42935ea826c41$var$defaultOnUncaughtError, onCaughtError = $b0f42935ea826c41$var$defaultOnCaughtError, onRecoverableError = $b0f42935ea826c41$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $b0f42935ea826c41$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $b0f42935ea826c41$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $b0f42935ea826c41$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $b0f42935ea826c41$var$requestUpdateLane();
    isStrictMode = $b0f42935ea826c41$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $b0f42935ea826c41$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $b0f42935ea826c41$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $b0f42935ea826c41$var$markRootUpdated$1(initialChildren, options);
    $b0f42935ea826c41$var$ensureRootIsScheduled(initialChildren);
    container[$b0f42935ea826c41$var$internalContainerInstanceKey] = initialChildren.current;
    $b0f42935ea826c41$var$listenToAllSupportedEvents(container);
    return new $b0f42935ea826c41$var$ReactDOMHydrationRoot(initialChildren);
};
$b0f42935ea826c41$export$83d89fbfd8236492 = "19.2.3";

});
parcelRegister("bIbqH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hvKuw"));

});
parcelRegister("hvKuw", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $cbf9651fe4890f47$export$c4744153514ff05d, (v) => $cbf9651fe4890f47$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7, (v) => $cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $cbf9651fe4890f47$export$e26fe2ed2fa76875, (v) => $cbf9651fe4890f47$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $cbf9651fe4890f47$export$502329bbf4b505b1, (v) => $cbf9651fe4890f47$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $cbf9651fe4890f47$export$6e3807111c4874c4, (v) => $cbf9651fe4890f47$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $cbf9651fe4890f47$export$c27134553091fb3a, (v) => $cbf9651fe4890f47$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $cbf9651fe4890f47$export$33ee1acdc04fd2a2, (v) => $cbf9651fe4890f47$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $cbf9651fe4890f47$export$b00a404bbd5edef2, (v) => $cbf9651fe4890f47$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $cbf9651fe4890f47$export$d66a1c1c77bd778b, (v) => $cbf9651fe4890f47$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $cbf9651fe4890f47$export$d3dfb8e4810cb555, (v) => $cbf9651fe4890f47$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $cbf9651fe4890f47$export$72fdf0e06517287b, (v) => $cbf9651fe4890f47$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $cbf9651fe4890f47$export$816d2913ae6b83b1, (v) => $cbf9651fe4890f47$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $cbf9651fe4890f47$export$61bcfe829111a1d0, (v) => $cbf9651fe4890f47$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $cbf9651fe4890f47$export$7ee8c9beb337bc3f, (v) => $cbf9651fe4890f47$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $cbf9651fe4890f47$export$b5836b71941fa3ed, (v) => $cbf9651fe4890f47$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $cbf9651fe4890f47$export$cf845f2c119da08a, (v) => $cbf9651fe4890f47$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $cbf9651fe4890f47$export$c4744153514ff05d;
var $cbf9651fe4890f47$export$3e506c1ccc9cc1a7;
var $cbf9651fe4890f47$export$e26fe2ed2fa76875;
var $cbf9651fe4890f47$export$502329bbf4b505b1;
var $cbf9651fe4890f47$export$6e3807111c4874c4;
var $cbf9651fe4890f47$export$c27134553091fb3a;
var $cbf9651fe4890f47$export$33ee1acdc04fd2a2;
var $cbf9651fe4890f47$export$b00a404bbd5edef2;
var $cbf9651fe4890f47$export$d66a1c1c77bd778b;
var $cbf9651fe4890f47$export$d3dfb8e4810cb555;
var $cbf9651fe4890f47$export$72fdf0e06517287b;
var $cbf9651fe4890f47$export$816d2913ae6b83b1;
var $cbf9651fe4890f47$export$61bcfe829111a1d0;
var $cbf9651fe4890f47$export$7ee8c9beb337bc3f;
var $cbf9651fe4890f47$export$b5836b71941fa3ed;
var $cbf9651fe4890f47$export$cf845f2c119da08a;
"use strict";
function $cbf9651fe4890f47$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $cbf9651fe4890f47$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $cbf9651fe4890f47$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $cbf9651fe4890f47$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $cbf9651fe4890f47$var$compare(left, last)) rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $cbf9651fe4890f47$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $cbf9651fe4890f47$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$cbf9651fe4890f47$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $cbf9651fe4890f47$var$localPerformance = performance;
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localPerformance.now();
    };
} else {
    var $cbf9651fe4890f47$var$localDate = Date, $cbf9651fe4890f47$var$initialTime = $cbf9651fe4890f47$var$localDate.now();
    $cbf9651fe4890f47$export$c4744153514ff05d = function() {
        return $cbf9651fe4890f47$var$localDate.now() - $cbf9651fe4890f47$var$initialTime;
    };
}
var $cbf9651fe4890f47$var$taskQueue = [], $cbf9651fe4890f47$var$timerQueue = [], $cbf9651fe4890f47$var$taskIdCounter = 1, $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = 3, $cbf9651fe4890f47$var$isPerformingWork = !1, $cbf9651fe4890f47$var$isHostCallbackScheduled = !1, $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$needsPaint = !1, $cbf9651fe4890f47$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $cbf9651fe4890f47$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $cbf9651fe4890f47$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $cbf9651fe4890f47$var$advanceTimers(currentTime) {
    for(var timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue); null !== timer;){
        if (null === timer.callback) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue);
        else if (timer.startTime <= currentTime) $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$timerQueue), timer.sortIndex = timer.expirationTime, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, timer);
        else break;
        timer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
    }
}
function $cbf9651fe4890f47$var$handleTimeout(currentTime) {
    $cbf9651fe4890f47$var$isHostTimeoutScheduled = !1;
    $cbf9651fe4890f47$var$advanceTimers(currentTime);
    if (!$cbf9651fe4890f47$var$isHostCallbackScheduled) {
        if (null !== $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue)) $cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $cbf9651fe4890f47$var$isMessageLoopRunning = !1, $cbf9651fe4890f47$var$taskTimeoutID = -1, $cbf9651fe4890f47$var$frameInterval = 5, $cbf9651fe4890f47$var$startTime = -1;
function $cbf9651fe4890f47$var$shouldYieldToHost() {
    return $cbf9651fe4890f47$var$needsPaint ? !0 : $cbf9651fe4890f47$export$c4744153514ff05d() - $cbf9651fe4890f47$var$startTime < $cbf9651fe4890f47$var$frameInterval ? !1 : !0;
}
function $cbf9651fe4890f47$var$performWorkUntilDeadline() {
    $cbf9651fe4890f47$var$needsPaint = !1;
    if ($cbf9651fe4890f47$var$isMessageLoopRunning) {
        var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
        $cbf9651fe4890f47$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $cbf9651fe4890f47$var$isHostCallbackScheduled = !1;
                $cbf9651fe4890f47$var$isHostTimeoutScheduled && ($cbf9651fe4890f47$var$isHostTimeoutScheduled = !1, $cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1);
                $cbf9651fe4890f47$var$isPerformingWork = !0;
                var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
                try {
                    b: {
                        $cbf9651fe4890f47$var$advanceTimers(currentTime);
                        for($cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue); null !== $cbf9651fe4890f47$var$currentTask && !($cbf9651fe4890f47$var$currentTask.expirationTime > currentTime && $cbf9651fe4890f47$var$shouldYieldToHost());){
                            var callback = $cbf9651fe4890f47$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $cbf9651fe4890f47$var$currentTask.callback = null;
                                $cbf9651fe4890f47$var$currentPriorityLevel = $cbf9651fe4890f47$var$currentTask.priorityLevel;
                                var continuationCallback = callback($cbf9651fe4890f47$var$currentTask.expirationTime <= currentTime);
                                currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $cbf9651fe4890f47$var$currentTask.callback = continuationCallback;
                                    $cbf9651fe4890f47$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $cbf9651fe4890f47$var$currentTask === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                                $cbf9651fe4890f47$var$advanceTimers(currentTime);
                            } else $cbf9651fe4890f47$var$pop($cbf9651fe4890f47$var$taskQueue);
                            $cbf9651fe4890f47$var$currentTask = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue);
                        }
                        if (null !== $cbf9651fe4890f47$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue);
                            null !== firstTimer && $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $cbf9651fe4890f47$var$currentTask = null, $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel, $cbf9651fe4890f47$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline() : $cbf9651fe4890f47$var$isMessageLoopRunning = !1;
        }
    }
}
var $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $cbf9651fe4890f47$var$localSetImmediate) $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetImmediate($cbf9651fe4890f47$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $cbf9651fe4890f47$var$channel = new MessageChannel(), $cbf9651fe4890f47$var$port = $cbf9651fe4890f47$var$channel.port2;
    $cbf9651fe4890f47$var$channel.port1.onmessage = $cbf9651fe4890f47$var$performWorkUntilDeadline;
    $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
        $cbf9651fe4890f47$var$port.postMessage(null);
    };
} else $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline = function() {
    $cbf9651fe4890f47$var$localSetTimeout($cbf9651fe4890f47$var$performWorkUntilDeadline, 0);
};
function $cbf9651fe4890f47$var$requestHostTimeout(callback, ms) {
    $cbf9651fe4890f47$var$taskTimeoutID = $cbf9651fe4890f47$var$localSetTimeout(function() {
        callback($cbf9651fe4890f47$export$c4744153514ff05d());
    }, ms);
}
$cbf9651fe4890f47$export$3e506c1ccc9cc1a7 = 5;
$cbf9651fe4890f47$export$e26fe2ed2fa76875 = 1;
$cbf9651fe4890f47$export$502329bbf4b505b1 = 4;
$cbf9651fe4890f47$export$6e3807111c4874c4 = 3;
$cbf9651fe4890f47$export$c27134553091fb3a = null;
$cbf9651fe4890f47$export$33ee1acdc04fd2a2 = 2;
$cbf9651fe4890f47$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$cbf9651fe4890f47$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $cbf9651fe4890f47$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$cbf9651fe4890f47$export$d3dfb8e4810cb555 = function() {
    return $cbf9651fe4890f47$var$currentPriorityLevel;
};
$cbf9651fe4890f47$export$72fdf0e06517287b = function(eventHandler) {
    switch($cbf9651fe4890f47$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$816d2913ae6b83b1 = function() {
    $cbf9651fe4890f47$var$needsPaint = !0;
};
$cbf9651fe4890f47$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    $cbf9651fe4890f47$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$cbf9651fe4890f47$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $cbf9651fe4890f47$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $cbf9651fe4890f47$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$timerQueue, priorityLevel), null === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$taskQueue) && priorityLevel === $cbf9651fe4890f47$var$peek($cbf9651fe4890f47$var$timerQueue) && ($cbf9651fe4890f47$var$isHostTimeoutScheduled ? ($cbf9651fe4890f47$var$localClearTimeout($cbf9651fe4890f47$var$taskTimeoutID), $cbf9651fe4890f47$var$taskTimeoutID = -1) : $cbf9651fe4890f47$var$isHostTimeoutScheduled = !0, $cbf9651fe4890f47$var$requestHostTimeout($cbf9651fe4890f47$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $cbf9651fe4890f47$var$push($cbf9651fe4890f47$var$taskQueue, priorityLevel), $cbf9651fe4890f47$var$isHostCallbackScheduled || $cbf9651fe4890f47$var$isPerformingWork || ($cbf9651fe4890f47$var$isHostCallbackScheduled = !0, $cbf9651fe4890f47$var$isMessageLoopRunning || ($cbf9651fe4890f47$var$isMessageLoopRunning = !0, $cbf9651fe4890f47$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$cbf9651fe4890f47$export$b5836b71941fa3ed = $cbf9651fe4890f47$var$shouldYieldToHost;
$cbf9651fe4890f47$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $cbf9651fe4890f47$var$currentPriorityLevel;
        $cbf9651fe4890f47$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $cbf9651fe4890f47$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("8vWo2", function(module, exports) {
'use strict';
function $632e82600c6e6253$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($632e82600c6e6253$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$632e82600c6e6253$var$checkDCE();

module.exports = (parcelRequire("8mkm8"));

});
parcelRegister("8mkm8", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $61602b11b686f3ac$export$69ce8ef3fe5cead0, (v) => $61602b11b686f3ac$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $61602b11b686f3ac$export$d39a5bbd09211389, (v) => $61602b11b686f3ac$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $61602b11b686f3ac$export$cd75ccfd720a3cd4, (v) => $61602b11b686f3ac$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $61602b11b686f3ac$export$a0816fa17a9e79be, (v) => $61602b11b686f3ac$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $61602b11b686f3ac$export$7292efcadded39f3, (v) => $61602b11b686f3ac$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $61602b11b686f3ac$export$da407abadb9b8f86, (v) => $61602b11b686f3ac$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $61602b11b686f3ac$export$314cfea32580671c, (v) => $61602b11b686f3ac$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $61602b11b686f3ac$export$513ccb98c53b8039, (v) => $61602b11b686f3ac$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $61602b11b686f3ac$export$dbca993bc2d264a, (v) => $61602b11b686f3ac$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $61602b11b686f3ac$export$4797a8006f0655d0, (v) => $61602b11b686f3ac$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $61602b11b686f3ac$export$c78a37762a8d58e1, (v) => $61602b11b686f3ac$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $61602b11b686f3ac$export$606f11b2eb45ecc6, (v) => $61602b11b686f3ac$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $61602b11b686f3ac$export$f7e8a0bf92324b1e, (v) => $61602b11b686f3ac$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $61602b11b686f3ac$export$83d89fbfd8236492, (v) => $61602b11b686f3ac$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $61602b11b686f3ac$export$69ce8ef3fe5cead0;
var $61602b11b686f3ac$export$d39a5bbd09211389;
var $61602b11b686f3ac$export$cd75ccfd720a3cd4;
var $61602b11b686f3ac$export$a0816fa17a9e79be;
var $61602b11b686f3ac$export$7292efcadded39f3;
var $61602b11b686f3ac$export$da407abadb9b8f86;
var $61602b11b686f3ac$export$314cfea32580671c;
var $61602b11b686f3ac$export$513ccb98c53b8039;
var $61602b11b686f3ac$export$dbca993bc2d264a;
var $61602b11b686f3ac$export$4797a8006f0655d0;
var $61602b11b686f3ac$export$c78a37762a8d58e1;
var $61602b11b686f3ac$export$606f11b2eb45ecc6;
var $61602b11b686f3ac$export$f7e8a0bf92324b1e;
var $61602b11b686f3ac$export$83d89fbfd8236492;
"use strict";

var $jXEQt = parcelRequire("jXEQt");
function $61602b11b686f3ac$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $61602b11b686f3ac$var$noop() {}
var $61602b11b686f3ac$var$Internals = {
    d: {
        f: $61602b11b686f3ac$var$noop,
        r: function() {
            throw Error($61602b11b686f3ac$var$formatProdErrorMessage(522));
        },
        D: $61602b11b686f3ac$var$noop,
        C: $61602b11b686f3ac$var$noop,
        L: $61602b11b686f3ac$var$noop,
        m: $61602b11b686f3ac$var$noop,
        X: $61602b11b686f3ac$var$noop,
        S: $61602b11b686f3ac$var$noop,
        M: $61602b11b686f3ac$var$noop
    },
    p: 0,
    findDOMNode: null
}, $61602b11b686f3ac$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $61602b11b686f3ac$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $61602b11b686f3ac$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $61602b11b686f3ac$var$ReactSharedInternals = $jXEQt.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $61602b11b686f3ac$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$61602b11b686f3ac$export$69ce8ef3fe5cead0 = $61602b11b686f3ac$var$Internals;
$61602b11b686f3ac$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($61602b11b686f3ac$var$formatProdErrorMessage(299));
    return $61602b11b686f3ac$var$createPortal$1(children, container, null, key);
};
$61602b11b686f3ac$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $61602b11b686f3ac$var$ReactSharedInternals.T, previousUpdatePriority = $61602b11b686f3ac$var$Internals.p;
    try {
        if ($61602b11b686f3ac$var$ReactSharedInternals.T = null, $61602b11b686f3ac$var$Internals.p = 2, fn) return fn();
    } finally{
        $61602b11b686f3ac$var$ReactSharedInternals.T = previousTransition, $61602b11b686f3ac$var$Internals.p = previousUpdatePriority, $61602b11b686f3ac$var$Internals.d.f();
    }
};
$61602b11b686f3ac$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $61602b11b686f3ac$var$Internals.d.C(href, options));
};
$61602b11b686f3ac$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $61602b11b686f3ac$var$Internals.d.D(href);
};
$61602b11b686f3ac$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $61602b11b686f3ac$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $61602b11b686f3ac$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $61602b11b686f3ac$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$61602b11b686f3ac$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $61602b11b686f3ac$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $61602b11b686f3ac$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $61602b11b686f3ac$var$Internals.d.M(href);
    }
};
$61602b11b686f3ac$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $61602b11b686f3ac$var$getCrossOriginStringAs(as, options.crossOrigin);
        $61602b11b686f3ac$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$61602b11b686f3ac$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $61602b11b686f3ac$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $61602b11b686f3ac$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $61602b11b686f3ac$var$Internals.d.m(href);
    }
};
$61602b11b686f3ac$export$4797a8006f0655d0 = function(form) {
    $61602b11b686f3ac$var$Internals.d.r(form);
};
$61602b11b686f3ac$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$61602b11b686f3ac$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $61602b11b686f3ac$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$61602b11b686f3ac$export$f7e8a0bf92324b1e = function() {
    return $61602b11b686f3ac$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$61602b11b686f3ac$export$83d89fbfd8236492 = "19.2.3";

});



parcelRegister("bw3ua", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $4cd1904575291251$export$2881499e37b75b9a);
$parcel$export(module.exports, "useDispatch", () => $4cd1904575291251$export$8ad76b76a4c905f8);
$parcel$export(module.exports, "useSelector", () => $4cd1904575291251$export$2105062e25df4afe);
// src/utils/react.ts

var $jXEQt = parcelRequire("jXEQt");

var $eiiLW = parcelRequire("eiiLW");
// src/utils/react-is.ts
var $4cd1904575291251$var$IS_REACT_19 = /* @__PURE__ */ $jXEQt.version.startsWith("19");
var $4cd1904575291251$var$REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for($4cd1904575291251$var$IS_REACT_19 ? "react.transitional.element" : "react.element");
var $4cd1904575291251$var$REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var $4cd1904575291251$var$REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var $4cd1904575291251$var$REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var $4cd1904575291251$var$REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var $4cd1904575291251$var$REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var $4cd1904575291251$var$REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var $4cd1904575291251$var$REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var $4cd1904575291251$var$REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var $4cd1904575291251$var$REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var $4cd1904575291251$var$REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var $4cd1904575291251$var$REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var $4cd1904575291251$var$REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var $4cd1904575291251$var$REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var $4cd1904575291251$var$ForwardRef = $4cd1904575291251$var$REACT_FORWARD_REF_TYPE;
var $4cd1904575291251$var$Memo = $4cd1904575291251$var$REACT_MEMO_TYPE;
function $4cd1904575291251$var$isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === $4cd1904575291251$var$REACT_FRAGMENT_TYPE || type === $4cd1904575291251$var$REACT_PROFILER_TYPE || type === $4cd1904575291251$var$REACT_STRICT_MODE_TYPE || type === $4cd1904575291251$var$REACT_SUSPENSE_TYPE || type === $4cd1904575291251$var$REACT_SUSPENSE_LIST_TYPE || type === $4cd1904575291251$var$REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === $4cd1904575291251$var$REACT_LAZY_TYPE || type.$$typeof === $4cd1904575291251$var$REACT_MEMO_TYPE || type.$$typeof === $4cd1904575291251$var$REACT_CONTEXT_TYPE || type.$$typeof === $4cd1904575291251$var$REACT_CONSUMER_TYPE || type.$$typeof === $4cd1904575291251$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $4cd1904575291251$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function $4cd1904575291251$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof: $$typeof } = object;
        switch($$typeof){
            case $4cd1904575291251$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $4cd1904575291251$var$REACT_FRAGMENT_TYPE:
                    case $4cd1904575291251$var$REACT_PROFILER_TYPE:
                    case $4cd1904575291251$var$REACT_STRICT_MODE_TYPE:
                    case $4cd1904575291251$var$REACT_SUSPENSE_TYPE:
                    case $4cd1904575291251$var$REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $4cd1904575291251$var$REACT_CONTEXT_TYPE:
                            case $4cd1904575291251$var$REACT_FORWARD_REF_TYPE:
                            case $4cd1904575291251$var$REACT_LAZY_TYPE:
                            case $4cd1904575291251$var$REACT_MEMO_TYPE:
                                return object;
                            case $4cd1904575291251$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $4cd1904575291251$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function $4cd1904575291251$var$isContextConsumer(object) {
    return $4cd1904575291251$var$IS_REACT_19 ? $4cd1904575291251$var$typeOf(object) === $4cd1904575291251$var$REACT_CONSUMER_TYPE : $4cd1904575291251$var$typeOf(object) === $4cd1904575291251$var$REACT_CONTEXT_TYPE;
}
function $4cd1904575291251$var$isMemo(object) {
    return $4cd1904575291251$var$typeOf(object) === $4cd1904575291251$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $4cd1904575291251$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $4cd1904575291251$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $4cd1904575291251$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $4cd1904575291251$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $4cd1904575291251$var$verify(mapStateToProps, "mapStateToProps");
    $4cd1904575291251$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $4cd1904575291251$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $4cd1904575291251$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $4cd1904575291251$var$finalPropsSelectorFactory(dispatch, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps, ...options }) {
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $4cd1904575291251$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $4cd1904575291251$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $4cd1904575291251$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $4cd1904575291251$var$verifyPlainObject(value, displayName, methodName) {
    if (!$4cd1904575291251$var$isPlainObject(value)) $4cd1904575291251$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $4cd1904575291251$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $4cd1904575291251$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $4cd1904575291251$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $4cd1904575291251$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $4cd1904575291251$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $4cd1904575291251$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $4cd1904575291251$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $4cd1904575291251$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $4cd1904575291251$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $4cd1904575291251$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $4cd1904575291251$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $4cd1904575291251$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $4cd1904575291251$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $4cd1904575291251$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $4cd1904575291251$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $4cd1904575291251$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $4cd1904575291251$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps
    };
}
function $4cd1904575291251$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $4cd1904575291251$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$4cd1904575291251$var$defaultMergeProps : typeof mergeProps === "function" ? $4cd1904575291251$var$wrapMergePropsFunc(mergeProps) : $4cd1904575291251$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $4cd1904575291251$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $4cd1904575291251$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $4cd1904575291251$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $4cd1904575291251$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $4cd1904575291251$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $4cd1904575291251$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $4cd1904575291251$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $4cd1904575291251$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $4cd1904575291251$var$canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $4cd1904575291251$var$isDOM = /* @__PURE__ */ $4cd1904575291251$var$canUseDOM();
var $4cd1904575291251$var$isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var $4cd1904575291251$var$isReactNative = /* @__PURE__ */ $4cd1904575291251$var$isRunningInReactNative();
var $4cd1904575291251$var$getUseIsomorphicLayoutEffect = ()=>$4cd1904575291251$var$isDOM || $4cd1904575291251$var$isReactNative ? $jXEQt.useLayoutEffect : $jXEQt.useEffect;
var $4cd1904575291251$var$useIsomorphicLayoutEffect = /* @__PURE__ */ $4cd1904575291251$var$getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function $4cd1904575291251$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $4cd1904575291251$export$d36bdfa510afb180(objA, objB) {
    if ($4cd1904575291251$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$4cd1904575291251$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $4cd1904575291251$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4cd1904575291251$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4cd1904575291251$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $4cd1904575291251$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $4cd1904575291251$var$TYPE_STATICS = {
    [$4cd1904575291251$var$ForwardRef]: $4cd1904575291251$var$FORWARD_REF_STATICS,
    [$4cd1904575291251$var$Memo]: $4cd1904575291251$var$MEMO_STATICS
};
function $4cd1904575291251$var$getStatics(component) {
    if ($4cd1904575291251$var$isMemo(component)) return $4cd1904575291251$var$MEMO_STATICS;
    return $4cd1904575291251$var$TYPE_STATICS[component["$$typeof"]] || $4cd1904575291251$var$REACT_STATICS;
}
var $4cd1904575291251$var$defineProperty = Object.defineProperty;
var $4cd1904575291251$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4cd1904575291251$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4cd1904575291251$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4cd1904575291251$var$getPrototypeOf = Object.getPrototypeOf;
var $4cd1904575291251$var$objectPrototype = Object.prototype;
function $4cd1904575291251$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($4cd1904575291251$var$objectPrototype) {
            const inheritedComponent = $4cd1904575291251$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4cd1904575291251$var$objectPrototype) $4cd1904575291251$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $4cd1904575291251$var$getOwnPropertyNames(sourceComponent);
        if ($4cd1904575291251$var$getOwnPropertySymbols) keys = keys.concat($4cd1904575291251$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $4cd1904575291251$var$getStatics(targetComponent);
        const sourceStatics = $4cd1904575291251$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$4cd1904575291251$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $4cd1904575291251$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $4cd1904575291251$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var $4cd1904575291251$var$ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var $4cd1904575291251$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $4cd1904575291251$var$getContext() {
    if (!$jXEQt.createContext) return {};
    const contextMap = $4cd1904575291251$var$gT[$4cd1904575291251$var$ContextKey] ??= /* @__PURE__ */ new Map();
    let realContext = contextMap.get($jXEQt.createContext);
    if (!realContext) {
        realContext = $jXEQt.createContext(null);
        contextMap.set($jXEQt.createContext, realContext);
    }
    return realContext;
}
var $4cd1904575291251$export$cc80c08dc91f1c00 = /* @__PURE__ */ $4cd1904575291251$var$getContext();
// src/components/connect.tsx
var $4cd1904575291251$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $4cd1904575291251$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $4cd1904575291251$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $4cd1904575291251$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $4cd1904575291251$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $4cd1904575291251$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $4cd1904575291251$var$strictEqual(a, b) {
    return a === b;
}
var $4cd1904575291251$var$hasWarnedAboutDeprecatedPureOption = false;
function $4cd1904575291251$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $4cd1904575291251$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $4cd1904575291251$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $4cd1904575291251$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $4cd1904575291251$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $4cd1904575291251$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $4cd1904575291251$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $4cd1904575291251$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $4cd1904575291251$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $jXEQt.useMemo(()=>{
                const { reactReduxForwardedRef: reactReduxForwardedRef2, ...wrapperProps2 } = props;
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $jXEQt.useMemo(()=>{
                let ResultContext = Context;
                propsContext?.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $jXEQt.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $jXEQt.useMemo(()=>{
                return $4cd1904575291251$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $jXEQt.useMemo(()=>{
                if (!shouldHandleStateChanges) return $4cd1904575291251$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $4cd1904575291251$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $jXEQt.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return {
                    ...contextValue,
                    subscription: subscription
                };
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $jXEQt.useRef(void 0);
            const lastWrapperProps = $jXEQt.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $jXEQt.useRef(void 0);
            const renderIsScheduled = $jXEQt.useRef(false);
            const isMounted = $jXEQt.useRef(false);
            const latestSubscriptionCallbackError = $jXEQt.useRef(void 0);
            $4cd1904575291251$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $jXEQt.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $jXEQt.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $4cd1904575291251$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $4cd1904575291251$var$useIsomorphicLayoutEffectWithArgs($4cd1904575291251$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $jXEQt.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $4cd1904575291251$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $jXEQt.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $jXEQt.createElement(WrappedComponent, {
                    ...actualChildProps,
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $jXEQt.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $jXEQt.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $jXEQt.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $jXEQt.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $jXEQt.createElement(Connect, {
                    ...props,
                    reactReduxForwardedRef: ref
                });
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $4cd1904575291251$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $4cd1904575291251$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $4cd1904575291251$export$64605811ab45167f = $4cd1904575291251$var$connect;
// src/components/Provider.tsx
function $4cd1904575291251$var$Provider(providerProps) {
    const { children: children, context: context, serverState: serverState, store: store } = providerProps;
    const contextValue = $jXEQt.useMemo(()=>{
        const subscription = $4cd1904575291251$var$createSubscription(store);
        const baseContextValue = {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = $jXEQt.useMemo(()=>store.getState(), [
        store
    ]);
    $4cd1904575291251$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $4cd1904575291251$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $jXEQt.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $4cd1904575291251$export$2881499e37b75b9a = $4cd1904575291251$var$Provider;
// src/hooks/useReduxContext.ts
function $4cd1904575291251$var$createReduxContextHook(context = $4cd1904575291251$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $jXEQt.useContext(context);
        return contextValue;
    };
}
var $4cd1904575291251$var$useReduxContext = /* @__PURE__ */ $4cd1904575291251$var$createReduxContextHook();
// src/hooks/useStore.ts
function $4cd1904575291251$export$671dba69185d0304(context = $4cd1904575291251$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $4cd1904575291251$export$cc80c08dc91f1c00 ? $4cd1904575291251$var$useReduxContext : // @ts-ignore
    $4cd1904575291251$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $4cd1904575291251$export$6ccbb43953eebf8 = /* @__PURE__ */ $4cd1904575291251$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $4cd1904575291251$export$bc9b55530897c558(context = $4cd1904575291251$export$cc80c08dc91f1c00) {
    const useStore2 = context === $4cd1904575291251$export$cc80c08dc91f1c00 ? $4cd1904575291251$export$6ccbb43953eebf8 : $4cd1904575291251$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $4cd1904575291251$export$8ad76b76a4c905f8 = /* @__PURE__ */ $4cd1904575291251$export$bc9b55530897c558();
var $4cd1904575291251$var$refEquality = (a, b)=>a === b;
function $4cd1904575291251$export$2b53f90d2bd1cbfb(context = $4cd1904575291251$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $4cd1904575291251$export$cc80c08dc91f1c00 ? $4cd1904575291251$var$useReduxContext : $4cd1904575291251$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $4cd1904575291251$var$refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store: store, subscription: subscription, getServerState: getServerState } = reduxContext;
        const firstRun = $jXEQt.useRef(true);
        const wrappedSelector = $jXEQt.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, $eiiLW.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $jXEQt.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $4cd1904575291251$export$2105062e25df4afe = /* @__PURE__ */ $4cd1904575291251$export$2b53f90d2bd1cbfb();
// src/exports.ts
var $4cd1904575291251$export$712ea50be43a7858 = $4cd1904575291251$var$defaultNoopBatch;

});
parcelRegister("eiiLW", function(module, exports) {
'use strict';

module.exports = (parcelRequire("7ooKD"));

});
parcelRegister("7ooKD", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $561df9594bba7914$export$bf730a2d8bf68b42, (v) => $561df9594bba7914$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $561df9594bba7914$export$bf730a2d8bf68b42;
"use strict";

var $jXEQt = parcelRequire("jXEQt");
function $561df9594bba7914$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $561df9594bba7914$var$objectIs = "function" === typeof Object.is ? Object.is : $561df9594bba7914$var$is, $561df9594bba7914$var$useSyncExternalStore = $jXEQt.useSyncExternalStore, $561df9594bba7914$var$useRef = $jXEQt.useRef, $561df9594bba7914$var$useEffect = $jXEQt.useEffect, $561df9594bba7914$var$useMemo = $jXEQt.useMemo, $561df9594bba7914$var$useDebugValue = $jXEQt.useDebugValue;
$561df9594bba7914$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $561df9594bba7914$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $561df9594bba7914$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($561df9594bba7914$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $561df9594bba7914$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $561df9594bba7914$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $561df9594bba7914$var$useDebugValue(value);
    return value;
};

});



parcelRegister("4Tpzr", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $5d24b541956da6cf$export$45d76561a5302f2b);
$parcel$export(module.exports, "useNavigate", () => $5d24b541956da6cf$export$9770f232ac06a008);
$parcel$export(module.exports, "useParams", () => $5d24b541956da6cf$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "Route", () => $5d24b541956da6cf$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "Routes", () => $5d24b541956da6cf$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "BrowserRouter", () => $5d24b541956da6cf$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $5d24b541956da6cf$export$a6c7ac8248d6e38a);
/**
 * react-router v7.13.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $jXEQt = parcelRequire("jXEQt");
var $5d24b541956da6cf$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/.pnpm/react-router@7.13.1_react-dom@19.2.3_react@19.2.3__react@19.2.3/node_modules/react-router/dist/development/chunk-LFPYN7LY.mjs"
});
var $5d24b541956da6cf$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $5d24b541956da6cf$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $5d24b541956da6cf$var$__typeError("Cannot " + msg);
var $5d24b541956da6cf$var$__privateGet = (obj, member, getter)=>($5d24b541956da6cf$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $5d24b541956da6cf$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $5d24b541956da6cf$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $5d24b541956da6cf$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($5d24b541956da6cf$export$e19cd5f9376f8cee || {});
var $5d24b541956da6cf$var$PopStateEventType = "popstate";
function $5d24b541956da6cf$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
function $5d24b541956da6cf$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.unstable_mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, unstable_mask) {
        let location = $5d24b541956da6cf$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key, unstable_mask);
        $5d24b541956da6cf$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $5d24b541956da6cf$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $5d24b541956da6cf$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = $5d24b541956da6cf$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = $5d24b541956da6cf$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $5d24b541956da6cf$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window2.location;
        return $5d24b541956da6cf$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window2.location.pathname,
            search: window2.location.search,
            hash: window2.location.hash
        } : void 0);
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $5d24b541956da6cf$export$fe53371bee54353d(to);
    }
    return $5d24b541956da6cf$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $5d24b541956da6cf$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $5d24b541956da6cf$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $5d24b541956da6cf$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $5d24b541956da6cf$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $5d24b541956da6cf$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $5d24b541956da6cf$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $5d24b541956da6cf$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $5d24b541956da6cf$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $5d24b541956da6cf$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $5d24b541956da6cf$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.unstable_mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
function $5d24b541956da6cf$var$createLocation(current, to, state = null, key, unstable_mask) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $5d24b541956da6cf$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $5d24b541956da6cf$var$createKey(),
        unstable_mask: unstable_mask
    };
    return location;
}
function $5d24b541956da6cf$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $5d24b541956da6cf$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $5d24b541956da6cf$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $5d24b541956da6cf$var$isLocation(to) ? to : $5d24b541956da6cf$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $5d24b541956da6cf$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $5d24b541956da6cf$var$isLocation(to) ? to : $5d24b541956da6cf$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $5d24b541956da6cf$var$getHistoryState(location, index);
        let url = history.createHref(location.unstable_mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $5d24b541956da6cf$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($5d24b541956da6cf$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($5d24b541956da6cf$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $5d24b541956da6cf$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $5d24b541956da6cf$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $5d24b541956da6cf$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $5d24b541956da6cf$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $5d24b541956da6cf$var$_map;
var $5d24b541956da6cf$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $5d24b541956da6cf$var$__privateAdd(this, $5d24b541956da6cf$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($5d24b541956da6cf$var$__privateGet(this, $5d24b541956da6cf$var$_map).has(context)) return $5d24b541956da6cf$var$__privateGet(this, $5d24b541956da6cf$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $5d24b541956da6cf$var$__privateGet(this, $5d24b541956da6cf$var$_map).set(context, value);
    }
};
$5d24b541956da6cf$var$_map = new WeakMap();
var $5d24b541956da6cf$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $5d24b541956da6cf$var$isUnsupportedLazyRouteObjectKey(key) {
    return $5d24b541956da6cf$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $5d24b541956da6cf$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $5d24b541956da6cf$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $5d24b541956da6cf$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $5d24b541956da6cf$var$isIndexRoute(route) {
    return route.index === true;
}
function $5d24b541956da6cf$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $5d24b541956da6cf$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $5d24b541956da6cf$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($5d24b541956da6cf$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $5d24b541956da6cf$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $5d24b541956da6cf$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $5d24b541956da6cf$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $5d24b541956da6cf$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $5d24b541956da6cf$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $5d24b541956da6cf$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $5d24b541956da6cf$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $5d24b541956da6cf$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $5d24b541956da6cf$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $5d24b541956da6cf$var$flattenRoutes(routes);
    $5d24b541956da6cf$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $5d24b541956da6cf$var$decodePath(pathname);
        matches = $5d24b541956da6cf$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $5d24b541956da6cf$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $5d24b541956da6cf$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $5d24b541956da6cf$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $5d24b541956da6cf$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $5d24b541956da6cf$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $5d24b541956da6cf$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $5d24b541956da6cf$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $5d24b541956da6cf$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $5d24b541956da6cf$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $5d24b541956da6cf$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $5d24b541956da6cf$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $5d24b541956da6cf$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $5d24b541956da6cf$var$paramRe = /^:[\w-]+$/;
var $5d24b541956da6cf$var$dynamicSegmentValue = 3;
var $5d24b541956da6cf$var$indexRouteValue = 2;
var $5d24b541956da6cf$var$emptySegmentValue = 1;
var $5d24b541956da6cf$var$staticSegmentValue = 10;
var $5d24b541956da6cf$var$splatPenalty = -2;
var $5d24b541956da6cf$var$isSplat = (s)=>s === "*";
function $5d24b541956da6cf$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($5d24b541956da6cf$var$isSplat)) initialScore += $5d24b541956da6cf$var$splatPenalty;
    if (index) initialScore += $5d24b541956da6cf$var$indexRouteValue;
    return segments.filter((s)=>!$5d24b541956da6cf$var$isSplat(s)).reduce((score, segment)=>score + ($5d24b541956da6cf$var$paramRe.test(segment) ? $5d24b541956da6cf$var$dynamicSegmentValue : segment === "" ? $5d24b541956da6cf$var$emptySegmentValue : $5d24b541956da6cf$var$staticSegmentValue), initialScore);
}
function $5d24b541956da6cf$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $5d24b541956da6cf$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $5d24b541956da6cf$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $5d24b541956da6cf$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $5d24b541956da6cf$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $5d24b541956da6cf$var$normalizePathname($5d24b541956da6cf$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $5d24b541956da6cf$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $5d24b541956da6cf$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $5d24b541956da6cf$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $5d24b541956da6cf$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $5d24b541956da6cf$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $5d24b541956da6cf$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $5d24b541956da6cf$var$compilePath(path, caseSensitive = false, end = true) {
    $5d24b541956da6cf$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $5d24b541956da6cf$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $5d24b541956da6cf$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $5d24b541956da6cf$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $5d24b541956da6cf$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $5d24b541956da6cf$var$joinPaths([
        basename,
        pathname
    ]);
}
var $5d24b541956da6cf$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $5d24b541956da6cf$var$isAbsoluteUrl = (url)=>$5d24b541956da6cf$var$ABSOLUTE_URL_REGEX.test(url);
function $5d24b541956da6cf$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $5d24b541956da6cf$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = toPathname.replace(/\/\/+/g, "/");
        if (toPathname.startsWith("/")) pathname = $5d24b541956da6cf$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $5d24b541956da6cf$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $5d24b541956da6cf$var$normalizeSearch(search),
        hash: $5d24b541956da6cf$var$normalizeHash(hash)
    };
}
function $5d24b541956da6cf$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $5d24b541956da6cf$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $5d24b541956da6cf$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $5d24b541956da6cf$var$getResolveToMatches(matches) {
    let pathMatches = $5d24b541956da6cf$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $5d24b541956da6cf$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $5d24b541956da6cf$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $5d24b541956da6cf$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $5d24b541956da6cf$var$getInvalidPathError("?", "pathname", "search", to));
        $5d24b541956da6cf$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $5d24b541956da6cf$var$getInvalidPathError("#", "pathname", "hash", to));
        $5d24b541956da6cf$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $5d24b541956da6cf$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $5d24b541956da6cf$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $5d24b541956da6cf$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $5d24b541956da6cf$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $5d24b541956da6cf$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $5d24b541956da6cf$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $5d24b541956da6cf$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $5d24b541956da6cf$export$4051a07651545597(data2, init) {
    return new $5d24b541956da6cf$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $5d24b541956da6cf$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $5d24b541956da6cf$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $5d24b541956da6cf$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $5d24b541956da6cf$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $5d24b541956da6cf$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $5d24b541956da6cf$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $5d24b541956da6cf$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $5d24b541956da6cf$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
var $5d24b541956da6cf$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $5d24b541956da6cf$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$5d24b541956da6cf$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($5d24b541956da6cf$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $5d24b541956da6cf$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $5d24b541956da6cf$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $5d24b541956da6cf$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $5d24b541956da6cf$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $5d24b541956da6cf$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $5d24b541956da6cf$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$5d24b541956da6cf$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $5d24b541956da6cf$var$wrapImpl(aggregated[key], original, (...args)=>$5d24b541956da6cf$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$5d24b541956da6cf$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$5d24b541956da6cf$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $5d24b541956da6cf$var$wrapImpl(aggregated.middleware, original, (...args)=>$5d24b541956da6cf$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$5d24b541956da6cf$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $5d24b541956da6cf$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$5d24b541956da6cf$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $5d24b541956da6cf$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $5d24b541956da6cf$export$fe53371bee54353d(to) : ".",
                ...$5d24b541956da6cf$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$5d24b541956da6cf$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$5d24b541956da6cf$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $5d24b541956da6cf$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$5d24b541956da6cf$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$5d24b541956da6cf$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $5d24b541956da6cf$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $5d24b541956da6cf$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $5d24b541956da6cf$var$getReadonlyRequest(request),
            context: context != null ? $5d24b541956da6cf$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $5d24b541956da6cf$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $5d24b541956da6cf$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $5d24b541956da6cf$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $5d24b541956da6cf$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $5d24b541956da6cf$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $5d24b541956da6cf$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $5d24b541956da6cf$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $5d24b541956da6cf$var$getReadonlyContext(context)
    };
}
function $5d24b541956da6cf$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $5d24b541956da6cf$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $5d24b541956da6cf$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $5d24b541956da6cf$var$getReadonlyContext(context) {
    if ($5d24b541956da6cf$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $5d24b541956da6cf$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $5d24b541956da6cf$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $5d24b541956da6cf$var$objectProtoNames;
}
// lib/router/router.ts
var $5d24b541956da6cf$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $5d24b541956da6cf$var$validMutationMethods = new Set($5d24b541956da6cf$var$validMutationMethodsArr);
var $5d24b541956da6cf$var$validRequestMethodsArr = [
    "GET",
    ...$5d24b541956da6cf$var$validMutationMethodsArr
];
var $5d24b541956da6cf$var$validRequestMethods = new Set($5d24b541956da6cf$var$validRequestMethodsArr);
var $5d24b541956da6cf$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $5d24b541956da6cf$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $5d24b541956da6cf$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $5d24b541956da6cf$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $5d24b541956da6cf$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $5d24b541956da6cf$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $5d24b541956da6cf$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $5d24b541956da6cf$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $5d24b541956da6cf$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $5d24b541956da6cf$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $5d24b541956da6cf$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$5d24b541956da6cf$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $5d24b541956da6cf$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $5d24b541956da6cf$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $5d24b541956da6cf$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $5d24b541956da6cf$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $5d24b541956da6cf$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$5d24b541956da6cf$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = relevantMatches.every((m)=>{
                let status = $5d24b541956da6cf$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                return !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $5d24b541956da6cf$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $5d24b541956da6cf$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $5d24b541956da6cf$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $5d24b541956da6cf$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$5d24b541956da6cf$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $5d24b541956da6cf$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $5d24b541956da6cf$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $5d24b541956da6cf$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $5d24b541956da6cf$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $5d24b541956da6cf$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $5d24b541956da6cf$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $5d24b541956da6cf$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $5d24b541956da6cf$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let maskPath;
        if (opts?.unstable_mask) {
            let partialPath = typeof opts.unstable_mask === "string" ? $5d24b541956da6cf$export$8ccf933b0513f8d0(opts.unstable_mask) : {
                ...state.location.unstable_mask,
                ...opts.unstable_mask
            };
            maskPath = {
                pathname: "",
                search: "",
                hash: "",
                ...partialPath
            };
        }
        let currentLocation = state.location;
        let nextLocation = $5d24b541956da6cf$var$createLocation(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $5d24b541956da6cf$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $5d24b541956da6cf$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.unstable_defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $5d24b541956da6cf$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $5d24b541956da6cf$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $5d24b541956da6cf$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $5d24b541956da6cf$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $5d24b541956da6cf$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $5d24b541956da6cf$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $5d24b541956da6cf$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $5d24b541956da6cf$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($5d24b541956da6cf$var$isErrorResult(result) && $5d24b541956da6cf$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $5d24b541956da6cf$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $5d24b541956da6cf$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$5d24b541956da6cf$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $5d24b541956da6cf$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $5d24b541956da6cf$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $5d24b541956da6cf$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $5d24b541956da6cf$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $5d24b541956da6cf$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $5d24b541956da6cf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($5d24b541956da6cf$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $5d24b541956da6cf$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($5d24b541956da6cf$var$isErrorResult(result)) {
            let boundaryMatch = $5d24b541956da6cf$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $5d24b541956da6cf$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $5d24b541956da6cf$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $5d24b541956da6cf$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $5d24b541956da6cf$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $5d24b541956da6cf$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $5d24b541956da6cf$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$5d24b541956da6cf$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $5d24b541956da6cf$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $5d24b541956da6cf$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $5d24b541956da6cf$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$5d24b541956da6cf$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $5d24b541956da6cf$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $5d24b541956da6cf$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $5d24b541956da6cf$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $5d24b541956da6cf$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $5d24b541956da6cf$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $5d24b541956da6cf$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $5d24b541956da6cf$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.unstable_defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5d24b541956da6cf$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5d24b541956da6cf$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5d24b541956da6cf$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $5d24b541956da6cf$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $5d24b541956da6cf$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $5d24b541956da6cf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($5d24b541956da6cf$var$isRedirectResult(actionResult) || $5d24b541956da6cf$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $5d24b541956da6cf$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($5d24b541956da6cf$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $5d24b541956da6cf$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $5d24b541956da6cf$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($5d24b541956da6cf$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $5d24b541956da6cf$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $5d24b541956da6cf$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $5d24b541956da6cf$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $5d24b541956da6cf$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $5d24b541956da6cf$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $5d24b541956da6cf$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $5d24b541956da6cf$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $5d24b541956da6cf$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $5d24b541956da6cf$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $5d24b541956da6cf$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $5d24b541956da6cf$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $5d24b541956da6cf$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $5d24b541956da6cf$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $5d24b541956da6cf$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $5d24b541956da6cf$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $5d24b541956da6cf$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $5d24b541956da6cf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $5d24b541956da6cf$var$getDoneFetcher(void 0));
            return;
        }
        if ($5d24b541956da6cf$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $5d24b541956da6cf$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($5d24b541956da6cf$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $5d24b541956da6cf$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $5d24b541956da6cf$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $5d24b541956da6cf$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $5d24b541956da6cf$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($5d24b541956da6cf$var$isAbsoluteUrl(location)) {
                const url = $5d24b541956da6cf$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $5d24b541956da6cf$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $5d24b541956da6cf$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($5d24b541956da6cf$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $5d24b541956da6cf$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $5d24b541956da6cf$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $5d24b541956da6cf$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$5d24b541956da6cf$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($5d24b541956da6cf$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $5d24b541956da6cf$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $5d24b541956da6cf$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $5d24b541956da6cf$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $5d24b541956da6cf$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $5d24b541956da6cf$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $5d24b541956da6cf$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $5d24b541956da6cf$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $5d24b541956da6cf$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $5d24b541956da6cf$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $5d24b541956da6cf$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $5d24b541956da6cf$export$386d57f03f0b2883;
        $5d24b541956da6cf$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $5d24b541956da6cf$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $5d24b541956da6cf$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $5d24b541956da6cf$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $5d24b541956da6cf$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$5d24b541956da6cf$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $5d24b541956da6cf$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $5d24b541956da6cf$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $5d24b541956da6cf$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $5d24b541956da6cf$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $5d24b541956da6cf$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $5d24b541956da6cf$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $5d24b541956da6cf$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $5d24b541956da6cf$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $5d24b541956da6cf$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $5d24b541956da6cf$export$3336b097a6fbc59a(routes, opts) {
    $5d24b541956da6cf$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $5d24b541956da6cf$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$5d24b541956da6cf$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $5d24b541956da6cf$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $5d24b541956da6cf$var$createLocation("", $5d24b541956da6cf$export$fe53371bee54353d(url), null, "default");
        let matches = $5d24b541956da6cf$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $5d24b541956da6cf$export$b8d3e69d4b3eff04();
        if (!$5d24b541956da6cf$var$isValidMethod(method) && method !== "HEAD") {
            let error = $5d24b541956da6cf$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $5d24b541956da6cf$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $5d24b541956da6cf$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $5d24b541956da6cf$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $5d24b541956da6cf$export$f5708dca728d7177(requestContext instanceof $5d24b541956da6cf$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $5d24b541956da6cf$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $5d24b541956da6cf$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $5d24b541956da6cf$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($5d24b541956da6cf$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($5d24b541956da6cf$export$6e80290866a84dd4(error)) return error;
                    if ($5d24b541956da6cf$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $5d24b541956da6cf$export$f2680fa305b734ca(error.status, error.statusText, await $5d24b541956da6cf$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($5d24b541956da6cf$export$e0163cfdf7bc9cfa(error)) error = $5d24b541956da6cf$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $5d24b541956da6cf$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $5d24b541956da6cf$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $5d24b541956da6cf$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $5d24b541956da6cf$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $5d24b541956da6cf$export$f5708dca728d7177($5d24b541956da6cf$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($5d24b541956da6cf$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($5d24b541956da6cf$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $5d24b541956da6cf$var$createLocation("", $5d24b541956da6cf$export$fe53371bee54353d(url), null, "default");
        let matches = $5d24b541956da6cf$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $5d24b541956da6cf$export$b8d3e69d4b3eff04();
        if (!$5d24b541956da6cf$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $5d24b541956da6cf$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $5d24b541956da6cf$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $5d24b541956da6cf$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $5d24b541956da6cf$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $5d24b541956da6cf$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $5d24b541956da6cf$export$f5708dca728d7177(requestContext instanceof $5d24b541956da6cf$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $5d24b541956da6cf$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $5d24b541956da6cf$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $5d24b541956da6cf$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $5d24b541956da6cf$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($5d24b541956da6cf$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($5d24b541956da6cf$var$dataWithResponseInitToResponse(error));
                if ($5d24b541956da6cf$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($5d24b541956da6cf$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $5d24b541956da6cf$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($5d24b541956da6cf$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $5d24b541956da6cf$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $5d24b541956da6cf$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($5d24b541956da6cf$var$isDataStrategyResult(e) && $5d24b541956da6cf$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($5d24b541956da6cf$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $5d24b541956da6cf$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $5d24b541956da6cf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $5d24b541956da6cf$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($5d24b541956da6cf$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($5d24b541956da6cf$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($5d24b541956da6cf$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $5d24b541956da6cf$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $5d24b541956da6cf$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($5d24b541956da6cf$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $5d24b541956da6cf$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $5d24b541956da6cf$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $5d24b541956da6cf$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $5d24b541956da6cf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $5d24b541956da6cf$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $5d24b541956da6cf$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $5d24b541956da6cf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $5d24b541956da6cf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $5d24b541956da6cf$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $5d24b541956da6cf$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $5d24b541956da6cf$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $5d24b541956da6cf$var$callDataStrategyImpl(dataStrategy || $5d24b541956da6cf$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($5d24b541956da6cf$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $5d24b541956da6cf$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($5d24b541956da6cf$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($5d24b541956da6cf$export$e0163cfdf7bc9cfa(result.result)) throw $5d24b541956da6cf$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $5d24b541956da6cf$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $5d24b541956da6cf$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $5d24b541956da6cf$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $5d24b541956da6cf$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $5d24b541956da6cf$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $5d24b541956da6cf$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $5d24b541956da6cf$var$resolveTo(to ? to : ".", $5d24b541956da6cf$var$getResolveToMatches(contextualMatches), $5d24b541956da6cf$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $5d24b541956da6cf$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $5d24b541956da6cf$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $5d24b541956da6cf$export$fe53371bee54353d(path);
}
function $5d24b541956da6cf$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$5d24b541956da6cf$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$5d24b541956da6cf$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $5d24b541956da6cf$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $5d24b541956da6cf$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $5d24b541956da6cf$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$5d24b541956da6cf$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$5d24b541956da6cf$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $5d24b541956da6cf$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $5d24b541956da6cf$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $5d24b541956da6cf$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $5d24b541956da6cf$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $5d24b541956da6cf$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($5d24b541956da6cf$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $5d24b541956da6cf$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $5d24b541956da6cf$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $5d24b541956da6cf$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $5d24b541956da6cf$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $5d24b541956da6cf$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $5d24b541956da6cf$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $5d24b541956da6cf$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$5d24b541956da6cf$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad2 } = $5d24b541956da6cf$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad2;
        } else if ($5d24b541956da6cf$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $5d24b541956da6cf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($5d24b541956da6cf$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $5d24b541956da6cf$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $5d24b541956da6cf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $5d24b541956da6cf$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $5d24b541956da6cf$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $5d24b541956da6cf$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $5d24b541956da6cf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $5d24b541956da6cf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($5d24b541956da6cf$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $5d24b541956da6cf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $5d24b541956da6cf$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $5d24b541956da6cf$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$5d24b541956da6cf$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $5d24b541956da6cf$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $5d24b541956da6cf$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $5d24b541956da6cf$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $5d24b541956da6cf$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $5d24b541956da6cf$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$5d24b541956da6cf$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $5d24b541956da6cf$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $5d24b541956da6cf$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $5d24b541956da6cf$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$5d24b541956da6cf$var$isSameRoute(aChild, bChild))) ?? false;
}
var $5d24b541956da6cf$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $5d24b541956da6cf$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $5d24b541956da6cf$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $5d24b541956da6cf$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $5d24b541956da6cf$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $5d24b541956da6cf$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $5d24b541956da6cf$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $5d24b541956da6cf$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $5d24b541956da6cf$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $5d24b541956da6cf$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $5d24b541956da6cf$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $5d24b541956da6cf$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $5d24b541956da6cf$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $5d24b541956da6cf$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $5d24b541956da6cf$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $5d24b541956da6cf$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $5d24b541956da6cf$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $5d24b541956da6cf$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $5d24b541956da6cf$var$isNonNullable(value) {
    return value !== void 0;
}
function $5d24b541956da6cf$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $5d24b541956da6cf$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($5d24b541956da6cf$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $5d24b541956da6cf$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $5d24b541956da6cf$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $5d24b541956da6cf$var$defaultDataStrategy(args);
    return $5d24b541956da6cf$var$runClientMiddlewarePipeline(args, ()=>$5d24b541956da6cf$var$defaultDataStrategy(args));
}
function $5d24b541956da6cf$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $5d24b541956da6cf$var$runMiddlewarePipeline(args, handler, processResult, $5d24b541956da6cf$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $5d24b541956da6cf$export$e0163cfdf7bc9cfa(result) ? $5d24b541956da6cf$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $5d24b541956da6cf$var$runClientMiddlewarePipeline(args, handler) {
    return $5d24b541956da6cf$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($5d24b541956da6cf$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $5d24b541956da6cf$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $5d24b541956da6cf$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $5d24b541956da6cf$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $5d24b541956da6cf$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $5d24b541956da6cf$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $5d24b541956da6cf$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $5d24b541956da6cf$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $5d24b541956da6cf$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $5d24b541956da6cf$var$loadLazyRoute(match.route, $5d24b541956da6cf$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $5d24b541956da6cf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $5d24b541956da6cf$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $5d24b541956da6cf$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $5d24b541956da6cf$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $5d24b541956da6cf$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$5d24b541956da6cf$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($5d24b541956da6cf$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $5d24b541956da6cf$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $5d24b541956da6cf$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $5d24b541956da6cf$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $5d24b541956da6cf$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $5d24b541956da6cf$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $5d24b541956da6cf$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $5d24b541956da6cf$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $5d24b541956da6cf$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $5d24b541956da6cf$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $5d24b541956da6cf$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $5d24b541956da6cf$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $5d24b541956da6cf$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $5d24b541956da6cf$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $5d24b541956da6cf$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($5d24b541956da6cf$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $5d24b541956da6cf$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $5d24b541956da6cf$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($5d24b541956da6cf$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $5d24b541956da6cf$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $5d24b541956da6cf$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $5d24b541956da6cf$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($5d24b541956da6cf$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $5d24b541956da6cf$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $5d24b541956da6cf$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$5d24b541956da6cf$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $5d24b541956da6cf$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $5d24b541956da6cf$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($5d24b541956da6cf$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $5d24b541956da6cf$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $5d24b541956da6cf$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($5d24b541956da6cf$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $5d24b541956da6cf$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $5d24b541956da6cf$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $5d24b541956da6cf$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $5d24b541956da6cf$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $5d24b541956da6cf$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $5d24b541956da6cf$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $5d24b541956da6cf$export$f5708dca728d7177(!$5d24b541956da6cf$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($5d24b541956da6cf$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $5d24b541956da6cf$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $5d24b541956da6cf$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $5d24b541956da6cf$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $5d24b541956da6cf$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $5d24b541956da6cf$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $5d24b541956da6cf$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($5d24b541956da6cf$var$isErrorResult(result)) {
            let boundaryMatch = $5d24b541956da6cf$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($5d24b541956da6cf$var$isRedirectResult(result)) $5d24b541956da6cf$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $5d24b541956da6cf$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $5d24b541956da6cf$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $5d24b541956da6cf$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $5d24b541956da6cf$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $5d24b541956da6cf$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $5d24b541956da6cf$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $5d24b541956da6cf$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $5d24b541956da6cf$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $5d24b541956da6cf$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $5d24b541956da6cf$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($5d24b541956da6cf$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $5d24b541956da6cf$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $5d24b541956da6cf$export$8ccf933b0513f8d0(path) : path;
    return $5d24b541956da6cf$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $5d24b541956da6cf$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $5d24b541956da6cf$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $5d24b541956da6cf$var$dataWithResponseInitToErrorResponse(data2) {
    return new $5d24b541956da6cf$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $5d24b541956da6cf$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $5d24b541956da6cf$var$isDataStrategyResult(value));
}
function $5d24b541956da6cf$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $5d24b541956da6cf$var$isRedirectDataStrategyResult(result) {
    return $5d24b541956da6cf$export$3f1eb41d9a6a6a27(result.result) && $5d24b541956da6cf$var$redirectStatusCodes.has(result.result.status);
}
function $5d24b541956da6cf$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $5d24b541956da6cf$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $5d24b541956da6cf$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $5d24b541956da6cf$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $5d24b541956da6cf$export$794b2760043cf8cd(statusCode) {
    return $5d24b541956da6cf$var$redirectStatusCodes.has(statusCode);
}
function $5d24b541956da6cf$export$6e80290866a84dd4(result) {
    return $5d24b541956da6cf$export$3f1eb41d9a6a6a27(result) && $5d24b541956da6cf$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $5d24b541956da6cf$var$isValidMethod(method) {
    return $5d24b541956da6cf$var$validRequestMethods.has(method.toUpperCase());
}
function $5d24b541956da6cf$export$cbae47800eb95bc3(method) {
    return $5d24b541956da6cf$var$validMutationMethods.has(method.toUpperCase());
}
function $5d24b541956da6cf$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $5d24b541956da6cf$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $5d24b541956da6cf$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $5d24b541956da6cf$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $5d24b541956da6cf$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $5d24b541956da6cf$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $5d24b541956da6cf$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $5d24b541956da6cf$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $5d24b541956da6cf$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $5d24b541956da6cf$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $5d24b541956da6cf$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $5d24b541956da6cf$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($5d24b541956da6cf$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $5d24b541956da6cf$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($5d24b541956da6cf$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $5d24b541956da6cf$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $5d24b541956da6cf$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $5d24b541956da6cf$export$2eeee58951ff3c1c = $jXEQt.createContext(null);
$5d24b541956da6cf$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $5d24b541956da6cf$export$315e3ffb01f217 = $jXEQt.createContext(null);
$5d24b541956da6cf$export$315e3ffb01f217.displayName = "DataRouterState";
var $5d24b541956da6cf$export$717f757c655223f1 = $jXEQt.createContext(false);
function $5d24b541956da6cf$var$useIsRSCRouterContext() {
    return $jXEQt.useContext($5d24b541956da6cf$export$717f757c655223f1);
}
var $5d24b541956da6cf$export$3681f408decb40d1 = $jXEQt.createContext({
    isTransitioning: false
});
$5d24b541956da6cf$export$3681f408decb40d1.displayName = "ViewTransition";
var $5d24b541956da6cf$export$cb3f1df1bef00a39 = $jXEQt.createContext(/* @__PURE__ */ new Map());
$5d24b541956da6cf$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $5d24b541956da6cf$var$AwaitContext = $jXEQt.createContext(null);
$5d24b541956da6cf$var$AwaitContext.displayName = "Await";
var $5d24b541956da6cf$export$2666c20e15407622 = (props)=>$jXEQt.createElement($5d24b541956da6cf$var$AwaitContext.Provider, props);
var $5d24b541956da6cf$export$3044ab7fdabeaee6 = $jXEQt.createContext(null);
$5d24b541956da6cf$export$3044ab7fdabeaee6.displayName = "Navigation";
var $5d24b541956da6cf$export$e6a44b110a0c44d3 = $jXEQt.createContext(null);
$5d24b541956da6cf$export$e6a44b110a0c44d3.displayName = "Location";
var $5d24b541956da6cf$export$aac280ed165a4397 = $jXEQt.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$5d24b541956da6cf$export$aac280ed165a4397.displayName = "Route";
var $5d24b541956da6cf$var$RouteErrorContext = $jXEQt.createContext(null);
$5d24b541956da6cf$var$RouteErrorContext.displayName = "RouteError";
var $5d24b541956da6cf$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $5d24b541956da6cf$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $5d24b541956da6cf$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $5d24b541956da6cf$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $5d24b541956da6cf$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$5d24b541956da6cf$var$ERROR_DIGEST_BASE}:${$5d24b541956da6cf$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $5d24b541956da6cf$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$5d24b541956da6cf$var$ERROR_DIGEST_BASE}:${$5d24b541956da6cf$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $5d24b541956da6cf$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $5d24b541956da6cf$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $5d24b541956da6cf$export$f5708dca728d7177($5d24b541956da6cf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $5d24b541956da6cf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $5d24b541956da6cf$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $5d24b541956da6cf$export$9c954a9d03d32f4a() {
    return $jXEQt.useContext($5d24b541956da6cf$export$e6a44b110a0c44d3) != null;
}
function $5d24b541956da6cf$export$45d76561a5302f2b() {
    $5d24b541956da6cf$export$f5708dca728d7177($5d24b541956da6cf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $jXEQt.useContext($5d24b541956da6cf$export$e6a44b110a0c44d3).location;
}
function $5d24b541956da6cf$export$1b3f31771c5d07c() {
    return $jXEQt.useContext($5d24b541956da6cf$export$e6a44b110a0c44d3).navigationType;
}
function $5d24b541956da6cf$export$6c330e8992e8a295(pattern) {
    $5d24b541956da6cf$export$f5708dca728d7177($5d24b541956da6cf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $5d24b541956da6cf$export$45d76561a5302f2b();
    return $jXEQt.useMemo(()=>$5d24b541956da6cf$export$81336c211d5ff295(pattern, $5d24b541956da6cf$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $5d24b541956da6cf$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $5d24b541956da6cf$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6).static;
    if (!isStatic) $jXEQt.useLayoutEffect(cb);
}
function $5d24b541956da6cf$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $jXEQt.useContext($5d24b541956da6cf$export$aac280ed165a4397);
    return isDataRoute ? $5d24b541956da6cf$var$useNavigateStable() : $5d24b541956da6cf$var$useNavigateUnstable();
}
function $5d24b541956da6cf$var$useNavigateUnstable() {
    $5d24b541956da6cf$export$f5708dca728d7177($5d24b541956da6cf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $jXEQt.useContext($5d24b541956da6cf$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    let { matches: matches } = $jXEQt.useContext($5d24b541956da6cf$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5d24b541956da6cf$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($5d24b541956da6cf$var$getResolveToMatches(matches));
    let activeRef = $jXEQt.useRef(false);
    $5d24b541956da6cf$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jXEQt.useCallback((to, options = {})=>{
        $5d24b541956da6cf$var$warning(activeRef.current, $5d24b541956da6cf$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $5d24b541956da6cf$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $5d24b541956da6cf$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $5d24b541956da6cf$var$OutletContext = $jXEQt.createContext(null);
function $5d24b541956da6cf$export$4138103a3ae699cc() {
    return $jXEQt.useContext($5d24b541956da6cf$var$OutletContext);
}
function $5d24b541956da6cf$export$a3be3530d8e40d0b(context) {
    let outlet = $jXEQt.useContext($5d24b541956da6cf$export$aac280ed165a4397).outlet;
    return $jXEQt.useMemo(()=>outlet && /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $5d24b541956da6cf$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $jXEQt.useContext($5d24b541956da6cf$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $5d24b541956da6cf$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $jXEQt.useContext($5d24b541956da6cf$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5d24b541956da6cf$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($5d24b541956da6cf$var$getResolveToMatches(matches));
    return $jXEQt.useMemo(()=>$5d24b541956da6cf$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $5d24b541956da6cf$export$5d3fca4a98652595(routes, locationArg) {
    return $5d24b541956da6cf$var$useRoutesImpl(routes, locationArg);
}
function $5d24b541956da6cf$var$useRoutesImpl(routes, locationArg, dataRouterOpts) {
    $5d24b541956da6cf$export$f5708dca728d7177($5d24b541956da6cf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $jXEQt.useContext($5d24b541956da6cf$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($5d24b541956da6cf$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $5d24b541956da6cf$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $5d24b541956da6cf$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $5d24b541956da6cf$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $5d24b541956da6cf$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $5d24b541956da6cf$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($5d24b541956da6cf$export$945fecf35a8ef089) {
        $5d24b541956da6cf$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $5d24b541956da6cf$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $5d24b541956da6cf$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $5d24b541956da6cf$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $5d24b541956da6cf$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                unstable_mask: void 0,
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $5d24b541956da6cf$var$DefaultErrorComponent() {
    let error = $5d24b541956da6cf$export$ed527bf60f6e05f2();
    let message = $5d24b541956da6cf$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($5d24b541956da6cf$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, /* @__PURE__ */ $jXEQt.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $jXEQt.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $jXEQt.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $jXEQt.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, /* @__PURE__ */ $jXEQt.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $jXEQt.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $jXEQt.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $5d24b541956da6cf$var$defaultErrorElement = /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$DefaultErrorComponent, null);
var $5d24b541956da6cf$var$RenderErrorBoundary = class extends $jXEQt.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $5d24b541956da6cf$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$5d24b541956da6cf$var$RenderErrorBoundary.contextType = $5d24b541956da6cf$export$717f757c655223f1;
var $5d24b541956da6cf$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $5d24b541956da6cf$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $5d24b541956da6cf$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $5d24b541956da6cf$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $5d24b541956da6cf$var$parseToInfo(redirect2.location, basename);
            if ($5d24b541956da6cf$var$isBrowser && !$5d24b541956da6cf$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $5d24b541956da6cf$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $jXEQt.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $5d24b541956da6cf$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $jXEQt.useContext($5d24b541956da6cf$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $5d24b541956da6cf$var$_renderMatches(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $5d24b541956da6cf$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors2 } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $5d24b541956da6cf$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $5d24b541956da6cf$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $5d24b541956da6cf$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $jXEQt.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $5d24b541956da6cf$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $5d24b541956da6cf$var$useDataRouterContext(hookName) {
    let ctx = $jXEQt.useContext($5d24b541956da6cf$export$2eeee58951ff3c1c);
    $5d24b541956da6cf$export$f5708dca728d7177(ctx, $5d24b541956da6cf$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $5d24b541956da6cf$var$useDataRouterState(hookName) {
    let state = $jXEQt.useContext($5d24b541956da6cf$export$315e3ffb01f217);
    $5d24b541956da6cf$export$f5708dca728d7177(state, $5d24b541956da6cf$var$getDataRouterConsoleError(hookName));
    return state;
}
function $5d24b541956da6cf$var$useRouteContext(hookName) {
    let route = $jXEQt.useContext($5d24b541956da6cf$export$aac280ed165a4397);
    $5d24b541956da6cf$export$f5708dca728d7177(route, $5d24b541956da6cf$var$getDataRouterConsoleError(hookName));
    return route;
}
function $5d24b541956da6cf$var$useCurrentRouteId(hookName) {
    let route = $5d24b541956da6cf$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $5d24b541956da6cf$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $5d24b541956da6cf$var$useRouteId() {
    return $5d24b541956da6cf$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $5d24b541956da6cf$export$d0fd4b7106de2769() {
    let state = $5d24b541956da6cf$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $5d24b541956da6cf$export$600dc272ed516c15() {
    let dataRouterContext = $5d24b541956da6cf$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $5d24b541956da6cf$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $jXEQt.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $jXEQt.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $5d24b541956da6cf$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $5d24b541956da6cf$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $jXEQt.useMemo(()=>matches.map((m)=>$5d24b541956da6cf$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $5d24b541956da6cf$export$1448a5050d252c4d() {
    let state = $5d24b541956da6cf$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $5d24b541956da6cf$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $5d24b541956da6cf$export$fd5d37484eab868d(routeId) {
    let state = $5d24b541956da6cf$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $5d24b541956da6cf$export$fdc00f3f26066d5e() {
    let state = $5d24b541956da6cf$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $5d24b541956da6cf$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $5d24b541956da6cf$export$ed527bf60f6e05f2() {
    let error = $jXEQt.useContext($5d24b541956da6cf$var$RouteErrorContext);
    let state = $5d24b541956da6cf$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $5d24b541956da6cf$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $5d24b541956da6cf$export$78a72ddb39bdd145() {
    let value = $jXEQt.useContext($5d24b541956da6cf$var$AwaitContext);
    return value?._data;
}
function $5d24b541956da6cf$export$17f53340677d5831() {
    let value = $jXEQt.useContext($5d24b541956da6cf$var$AwaitContext);
    return value?._error;
}
var $5d24b541956da6cf$var$blockerId = 0;
function $5d24b541956da6cf$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $5d24b541956da6cf$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $5d24b541956da6cf$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $jXEQt.useState("");
    let blockerFunction = $jXEQt.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $5d24b541956da6cf$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $5d24b541956da6cf$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $jXEQt.useEffect(()=>{
        let key = String(++$5d24b541956da6cf$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $jXEQt.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $5d24b541956da6cf$export$386d57f03f0b2883;
}
function $5d24b541956da6cf$var$useNavigateStable() {
    let { router: router } = $5d24b541956da6cf$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $5d24b541956da6cf$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $jXEQt.useRef(false);
    $5d24b541956da6cf$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $jXEQt.useCallback(async (to, options = {})=>{
        $5d24b541956da6cf$var$warning(activeRef.current, $5d24b541956da6cf$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $5d24b541956da6cf$var$alreadyWarned = {};
function $5d24b541956da6cf$var$warningOnce(key, cond, message) {
    if (!cond && !$5d24b541956da6cf$var$alreadyWarned[key]) {
        $5d24b541956da6cf$var$alreadyWarned[key] = true;
        $5d24b541956da6cf$var$warning(false, message);
    }
}
function $5d24b541956da6cf$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $5d24b541956da6cf$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $5d24b541956da6cf$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $5d24b541956da6cf$var$alreadyWarned2 = {};
function $5d24b541956da6cf$export$5b28268982f175ba(condition, message) {
    if (!condition && !$5d24b541956da6cf$var$alreadyWarned2[message]) {
        $5d24b541956da6cf$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $5d24b541956da6cf$var$USE_OPTIMISTIC = "useOptimistic";
var $5d24b541956da6cf$var$useOptimisticImpl = $jXEQt[$5d24b541956da6cf$var$USE_OPTIMISTIC];
var $5d24b541956da6cf$var$stableUseOptimisticSetter = ()=>void 0;
function $5d24b541956da6cf$var$useOptimisticSafe(val) {
    if ($5d24b541956da6cf$var$useOptimisticImpl) return $5d24b541956da6cf$var$useOptimisticImpl(val);
    else return [
        val,
        $5d24b541956da6cf$var$stableUseOptimisticSetter
    ];
}
function $5d24b541956da6cf$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($5d24b541956da6cf$export$945fecf35a8ef089) {
            if (route.element) $5d24b541956da6cf$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $jXEQt.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($5d24b541956da6cf$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $5d24b541956da6cf$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $jXEQt.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($5d24b541956da6cf$export$945fecf35a8ef089) {
            if (route.errorElement) $5d24b541956da6cf$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $jXEQt.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $5d24b541956da6cf$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $5d24b541956da6cf$export$f30f7e456d254e83(routes, opts) {
    return $5d24b541956da6cf$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5d24b541956da6cf$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $5d24b541956da6cf$export$e2fd2c03906469db,
        mapRouteProperties: $5d24b541956da6cf$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $5d24b541956da6cf$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $5d24b541956da6cf$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, unstable_useTransitions: unstable_useTransitions }) {
    let unstable_rsc = $5d24b541956da6cf$var$useIsRSCRouterContext();
    unstable_useTransitions = unstable_rsc || unstable_useTransitions;
    let [_state, setStateImpl] = $jXEQt.useState(router.state);
    let [state, setOptimisticState] = $5d24b541956da6cf$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $jXEQt.useState();
    let [vtContext, setVtContext] = $jXEQt.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $jXEQt.useState();
    let [transition, setTransition] = $jXEQt.useState();
    let [interruption, setInterruption] = $jXEQt.useState();
    let fetcherData = $jXEQt.useRef(/* @__PURE__ */ new Map());
    let setState = $jXEQt.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $5d24b541956da6cf$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $5d24b541956da6cf$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $5d24b541956da6cf$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $jXEQt.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$5d24b541956da6cf$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        onError
    ]);
    $jXEQt.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $jXEQt.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $5d24b541956da6cf$var$Deferred());
    }, [
        vtContext
    ]);
    $jXEQt.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $jXEQt.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$5d24b541956da6cf$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $jXEQt.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $jXEQt.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $jXEQt.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $jXEQt.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $5d24b541956da6cf$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $5d24b541956da6cf$var$MemoizedDataRoutes = $jXEQt.memo($5d24b541956da6cf$var$DataRoutes);
function $5d24b541956da6cf$var$DataRoutes({ routes: routes, future: future, state: state, isStatic: isStatic, onError: onError }) {
    return $5d24b541956da6cf$var$useRoutesImpl(routes, void 0, {
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
function $5d24b541956da6cf$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $jXEQt.useRef();
    if (historyRef.current == null) historyRef.current = $5d24b541956da6cf$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jXEQt.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jXEQt.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $jXEQt.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $jXEQt.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $5d24b541956da6cf$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $5d24b541956da6cf$export$f5708dca728d7177($5d24b541956da6cf$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    $5d24b541956da6cf$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $jXEQt.useContext($5d24b541956da6cf$export$aac280ed165a4397);
    let { pathname: locationPathname } = $5d24b541956da6cf$export$45d76561a5302f2b();
    let navigate = $5d24b541956da6cf$export$9770f232ac06a008();
    let path = $5d24b541956da6cf$var$resolveTo(to, $5d24b541956da6cf$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $jXEQt.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $5d24b541956da6cf$export$910ae8079b2c2852(props) {
    return $5d24b541956da6cf$export$a3be3530d8e40d0b(props.context);
}
function $5d24b541956da6cf$export$e7b0ac011bb776c6(props) {
    $5d24b541956da6cf$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $5d24b541956da6cf$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $5d24b541956da6cf$export$f5708dca728d7177(!$5d24b541956da6cf$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $jXEQt.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $5d24b541956da6cf$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", unstable_mask: unstable_mask } = locationProp;
    let locationContext = $jXEQt.useMemo(()=>{
        let trailingPathname = $5d24b541956da6cf$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                unstable_mask: unstable_mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        unstable_mask
    ]);
    $5d24b541956da6cf$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $5d24b541956da6cf$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $5d24b541956da6cf$export$5d3fca4a98652595($5d24b541956da6cf$export$16da398f5434bdec(children), location);
}
function $5d24b541956da6cf$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $jXEQt.useContext($5d24b541956da6cf$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $jXEQt.useContext($5d24b541956da6cf$export$315e3ffb01f217);
    let onError = $jXEQt.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $5d24b541956da6cf$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$ResolveAwait, null, children));
}
var $5d24b541956da6cf$var$AwaitErrorBoundary = class extends $jXEQt.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $5d24b541956da6cf$var$ResolveAwait({ children: children }) {
    let data2 = $5d24b541956da6cf$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, toRender);
}
function $5d24b541956da6cf$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $jXEQt.Children.forEach(children, (element, index)=>{
        if (!$jXEQt.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $jXEQt.Fragment) {
            routes.push.apply(routes, $5d24b541956da6cf$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $5d24b541956da6cf$export$f5708dca728d7177(element.type === $5d24b541956da6cf$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $5d24b541956da6cf$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $5d24b541956da6cf$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $5d24b541956da6cf$export$9b5b6d122dea0c88 = $5d24b541956da6cf$export$16da398f5434bdec;
function $5d24b541956da6cf$export$daf73786167a7f72(matches) {
    return $5d24b541956da6cf$var$_renderMatches(matches);
}
function $5d24b541956da6cf$var$useRouteComponentProps() {
    return {
        params: $5d24b541956da6cf$export$99eaa27ddbbb95ef(),
        loaderData: $5d24b541956da6cf$export$1448a5050d252c4d(),
        actionData: $5d24b541956da6cf$export$fdc00f3f26066d5e(),
        matches: $5d24b541956da6cf$export$2378eb7f5ff86053()
    };
}
function $5d24b541956da6cf$export$6c4f3826290c37af({ children: children }) {
    const props = $5d24b541956da6cf$var$useRouteComponentProps();
    return $jXEQt.cloneElement(children, props);
}
function $5d24b541956da6cf$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $5d24b541956da6cf$var$useRouteComponentProps();
        return $jXEQt.createElement(Component4, props);
    };
}
function $5d24b541956da6cf$var$useHydrateFallbackProps() {
    return {
        params: $5d24b541956da6cf$export$99eaa27ddbbb95ef(),
        loaderData: $5d24b541956da6cf$export$1448a5050d252c4d(),
        actionData: $5d24b541956da6cf$export$fdc00f3f26066d5e()
    };
}
function $5d24b541956da6cf$export$f8cff34f39c1932a({ children: children }) {
    const props = $5d24b541956da6cf$var$useHydrateFallbackProps();
    return $jXEQt.cloneElement(children, props);
}
function $5d24b541956da6cf$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $5d24b541956da6cf$var$useHydrateFallbackProps();
        return $jXEQt.createElement(HydrateFallback, props);
    };
}
function $5d24b541956da6cf$var$useErrorBoundaryProps() {
    return {
        params: $5d24b541956da6cf$export$99eaa27ddbbb95ef(),
        loaderData: $5d24b541956da6cf$export$1448a5050d252c4d(),
        actionData: $5d24b541956da6cf$export$fdc00f3f26066d5e(),
        error: $5d24b541956da6cf$export$ed527bf60f6e05f2()
    };
}
function $5d24b541956da6cf$export$e5afde5c4b6d747b({ children: children }) {
    const props = $5d24b541956da6cf$var$useErrorBoundaryProps();
    return $jXEQt.cloneElement(children, props);
}
function $5d24b541956da6cf$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $5d24b541956da6cf$var$useErrorBoundaryProps();
        return $jXEQt.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $5d24b541956da6cf$var$defaultMethod = "get";
var $5d24b541956da6cf$var$defaultEncType = "application/x-www-form-urlencoded";
function $5d24b541956da6cf$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $5d24b541956da6cf$var$isButtonElement(object) {
    return $5d24b541956da6cf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $5d24b541956da6cf$var$isFormElement(object) {
    return $5d24b541956da6cf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $5d24b541956da6cf$var$isInputElement(object) {
    return $5d24b541956da6cf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $5d24b541956da6cf$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $5d24b541956da6cf$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$5d24b541956da6cf$var$isModifiedEvent(event);
}
function $5d24b541956da6cf$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $5d24b541956da6cf$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $5d24b541956da6cf$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $5d24b541956da6cf$var$_formDataSupportsSubmitter = null;
function $5d24b541956da6cf$var$isFormDataSubmitterSupported() {
    if ($5d24b541956da6cf$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $5d24b541956da6cf$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $5d24b541956da6cf$var$_formDataSupportsSubmitter = true;
    }
    return $5d24b541956da6cf$var$_formDataSupportsSubmitter;
}
var $5d24b541956da6cf$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $5d24b541956da6cf$var$getFormEncType(encType) {
    if (encType != null && !$5d24b541956da6cf$var$supportedFormEncTypes.has(encType)) {
        $5d24b541956da6cf$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$5d24b541956da6cf$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $5d24b541956da6cf$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($5d24b541956da6cf$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $5d24b541956da6cf$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $5d24b541956da6cf$var$defaultMethod;
        encType = $5d24b541956da6cf$var$getFormEncType(target.getAttribute("enctype")) || $5d24b541956da6cf$var$defaultEncType;
        formData = new FormData(target);
    } else if ($5d24b541956da6cf$var$isButtonElement(target) || $5d24b541956da6cf$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $5d24b541956da6cf$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $5d24b541956da6cf$var$defaultMethod;
        encType = $5d24b541956da6cf$var$getFormEncType(target.getAttribute("formenctype")) || $5d24b541956da6cf$var$getFormEncType(form.getAttribute("enctype")) || $5d24b541956da6cf$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$5d24b541956da6cf$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($5d24b541956da6cf$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $5d24b541956da6cf$var$defaultMethod;
        action = null;
        encType = $5d24b541956da6cf$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $5d24b541956da6cf$var$HOLE = -1;
var $5d24b541956da6cf$var$NAN = -2;
var $5d24b541956da6cf$var$NEGATIVE_INFINITY = -3;
var $5d24b541956da6cf$var$NEGATIVE_ZERO = -4;
var $5d24b541956da6cf$var$NULL = -5;
var $5d24b541956da6cf$var$POSITIVE_INFINITY = -6;
var $5d24b541956da6cf$var$UNDEFINED = -7;
var $5d24b541956da6cf$var$TYPE_BIGINT = "B";
var $5d24b541956da6cf$var$TYPE_DATE = "D";
var $5d24b541956da6cf$var$TYPE_ERROR = "E";
var $5d24b541956da6cf$var$TYPE_MAP = "M";
var $5d24b541956da6cf$var$TYPE_NULL_OBJECT = "N";
var $5d24b541956da6cf$var$TYPE_PROMISE = "P";
var $5d24b541956da6cf$var$TYPE_REGEXP = "R";
var $5d24b541956da6cf$var$TYPE_SET = "S";
var $5d24b541956da6cf$var$TYPE_SYMBOL = "Y";
var $5d24b541956da6cf$var$TYPE_URL = "U";
var $5d24b541956da6cf$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $5d24b541956da6cf$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $5d24b541956da6cf$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $5d24b541956da6cf$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $5d24b541956da6cf$var$UNDEFINED;
    if (input === null) return $5d24b541956da6cf$var$NULL;
    if (Number.isNaN(input)) return $5d24b541956da6cf$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $5d24b541956da6cf$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $5d24b541956da6cf$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $5d24b541956da6cf$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $5d24b541956da6cf$var$stringify.call(this, input, index);
    return index;
}
function $5d24b541956da6cf$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$5d24b541956da6cf$var$flatten.call(this, k)}":${$5d24b541956da6cf$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$5d24b541956da6cf$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$5d24b541956da6cf$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$5d24b541956da6cf$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$5d24b541956da6cf$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $5d24b541956da6cf$var$flatten.call(this, input2[i]) : $5d24b541956da6cf$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$5d24b541956da6cf$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$5d24b541956da6cf$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$5d24b541956da6cf$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$5d24b541956da6cf$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$5d24b541956da6cf$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$5d24b541956da6cf$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$5d24b541956da6cf$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $5d24b541956da6cf$var$flatten.call(this, k),
                                    $5d24b541956da6cf$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$5d24b541956da6cf$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$5d24b541956da6cf$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$5d24b541956da6cf$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$5d24b541956da6cf$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($5d24b541956da6cf$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$5d24b541956da6cf$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$5d24b541956da6cf$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $5d24b541956da6cf$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $5d24b541956da6cf$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $5d24b541956da6cf$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $5d24b541956da6cf$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $5d24b541956da6cf$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $5d24b541956da6cf$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $5d24b541956da6cf$var$hydrate.call(this, startIndex);
}
function $5d24b541956da6cf$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $5d24b541956da6cf$var$UNDEFINED:
                set(void 0);
                continue;
            case $5d24b541956da6cf$var$NULL:
                set(null);
                continue;
            case $5d24b541956da6cf$var$NAN:
                set(NaN);
                continue;
            case $5d24b541956da6cf$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $5d24b541956da6cf$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $5d24b541956da6cf$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $5d24b541956da6cf$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $5d24b541956da6cf$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $5d24b541956da6cf$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $5d24b541956da6cf$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $5d24b541956da6cf$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $5d24b541956da6cf$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $5d24b541956da6cf$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $5d24b541956da6cf$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $5d24b541956da6cf$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $5d24b541956da6cf$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $5d24b541956da6cf$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $5d24b541956da6cf$var$globalObj && $5d24b541956da6cf$var$globalObj[errorType] ? new $5d24b541956da6cf$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $5d24b541956da6cf$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $5d24b541956da6cf$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $5d24b541956da6cf$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $5d24b541956da6cf$var$Deferred2();
    const reader = readable.pipeThrough($5d24b541956da6cf$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $5d24b541956da6cf$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $5d24b541956da6cf$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $5d24b541956da6cf$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $5d24b541956da6cf$var$unflatten.call(this, line)
    };
}
async function $5d24b541956da6cf$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $5d24b541956da6cf$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $5d24b541956da6cf$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $5d24b541956da6cf$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $5d24b541956da6cf$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $5d24b541956da6cf$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal, onComplete: onComplete } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $5d24b541956da6cf$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $5d24b541956da6cf$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$5d24b541956da6cf$var$TYPE_PROMISE}${deferredId}:[["${$5d24b541956da6cf$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$5d24b541956da6cf$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$5d24b541956da6cf$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $5d24b541956da6cf$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$5d24b541956da6cf$var$TYPE_ERROR}${deferredId}:[["${$5d24b541956da6cf$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$5d24b541956da6cf$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$5d24b541956da6cf$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            onComplete?.();
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $5d24b541956da6cf$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $5d24b541956da6cf$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $5d24b541956da6cf$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $5d24b541956da6cf$export$4cf11838cdc2a8a8(html) {
    return html.replace($5d24b541956da6cf$var$ESCAPE_REGEX, (match)=>$5d24b541956da6cf$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $5d24b541956da6cf$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $5d24b541956da6cf$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $5d24b541956da6cf$var$SingleFetchNoResultError = class extends Error {
};
var $5d24b541956da6cf$export$ae9272e641ead836 = 202;
var $5d24b541956da6cf$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $5d24b541956da6cf$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $jXEQt.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$5d24b541956da6cf$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, scriptTag, /* @__PURE__ */ $jXEQt.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, scriptTag, /* @__PURE__ */ $jXEQt.createElement($jXEQt.Suspense, null, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $5d24b541956da6cf$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $5d24b541956da6cf$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $5d24b541956da6cf$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $5d24b541956da6cf$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $5d24b541956da6cf$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $5d24b541956da6cf$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $5d24b541956da6cf$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $5d24b541956da6cf$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $5d24b541956da6cf$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $5d24b541956da6cf$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $5d24b541956da6cf$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $5d24b541956da6cf$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($5d24b541956da6cf$export$3f1eb41d9a6a6a27(result.result) || $5d24b541956da6cf$export$972111febbeef05b(result.result) || $5d24b541956da6cf$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $5d24b541956da6cf$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $5d24b541956da6cf$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $5d24b541956da6cf$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $5d24b541956da6cf$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$5d24b541956da6cf$var$createDeferred2());
    let singleFetchDfd = $5d24b541956da6cf$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $5d24b541956da6cf$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $5d24b541956da6cf$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $5d24b541956da6cf$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $5d24b541956da6cf$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $5d24b541956da6cf$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $5d24b541956da6cf$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $5d24b541956da6cf$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $5d24b541956da6cf$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $5d24b541956da6cf$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $5d24b541956da6cf$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $5d24b541956da6cf$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
        else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    }
    return url;
}
async function $5d24b541956da6cf$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $5d24b541956da6cf$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $5d24b541956da6cf$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $5d24b541956da6cf$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $5d24b541956da6cf$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $5d24b541956da6cf$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($5d24b541956da6cf$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $5d24b541956da6cf$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $5d24b541956da6cf$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($5d24b541956da6cf$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$5d24b541956da6cf$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $5d24b541956da6cf$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $5d24b541956da6cf$export$4023ad4ecd4126a2(body, global) {
    return $5d24b541956da6cf$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $5d24b541956da6cf$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$5d24b541956da6cf$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $5d24b541956da6cf$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $5d24b541956da6cf$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $5d24b541956da6cf$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $5d24b541956da6cf$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $5d24b541956da6cf$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $5d24b541956da6cf$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $5d24b541956da6cf$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $5d24b541956da6cf$var$getModuleLinkHrefs(matches, manifest);
    return $5d24b541956da6cf$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $5d24b541956da6cf$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $5d24b541956da6cf$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $5d24b541956da6cf$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($5d24b541956da6cf$var$prefetchStyleLink));
}
async function $5d24b541956da6cf$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$5d24b541956da6cf$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$5d24b541956da6cf$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$5d24b541956da6cf$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($5d24b541956da6cf$var$prefetchStyleLink));
}
async function $5d24b541956da6cf$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $5d24b541956da6cf$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $5d24b541956da6cf$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $5d24b541956da6cf$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $5d24b541956da6cf$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $5d24b541956da6cf$var$dedupeLinkDescriptors(links.flat(1).filter($5d24b541956da6cf$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $5d24b541956da6cf$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $5d24b541956da6cf$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $5d24b541956da6cf$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $5d24b541956da6cf$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $5d24b541956da6cf$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $5d24b541956da6cf$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$5d24b541956da6cf$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($5d24b541956da6cf$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $5d24b541956da6cf$var$_isPreloadSupported;
function $5d24b541956da6cf$var$isPreloadSupported() {
    if ($5d24b541956da6cf$var$_isPreloadSupported !== void 0) return $5d24b541956da6cf$var$_isPreloadSupported;
    let el = document.createElement("link");
    $5d24b541956da6cf$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $5d24b541956da6cf$var$_isPreloadSupported;
}
function $5d24b541956da6cf$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $5d24b541956da6cf$export$945fecf35a8ef089 ? /* @__PURE__ */ $jXEQt.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $5d24b541956da6cf$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $5d24b541956da6cf$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $5d24b541956da6cf$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $5d24b541956da6cf$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$RemixRootDefaultErrorBoundary, {
            error: $5d24b541956da6cf$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $jXEQt.createElement(routeModule.Layout, null, /* @__PURE__ */ $jXEQt.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $jXEQt.createElement(routeModule.Layout, null, /* @__PURE__ */ $jXEQt.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $jXEQt.createElement(routeModule.Layout, null, /* @__PURE__ */ $jXEQt.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $5d24b541956da6cf$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $5d24b541956da6cf$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $5d24b541956da6cf$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$5d24b541956da6cf$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $5d24b541956da6cf$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $5d24b541956da6cf$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $5d24b541956da6cf$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $5d24b541956da6cf$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $5d24b541956da6cf$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $5d24b541956da6cf$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $5d24b541956da6cf$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $5d24b541956da6cf$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $5d24b541956da6cf$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $5d24b541956da6cf$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $5d24b541956da6cf$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $5d24b541956da6cf$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $5d24b541956da6cf$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$5d24b541956da6cf$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $5d24b541956da6cf$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $5d24b541956da6cf$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $5d24b541956da6cf$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $5d24b541956da6cf$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $5d24b541956da6cf$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $5d24b541956da6cf$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $5d24b541956da6cf$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $5d24b541956da6cf$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $5d24b541956da6cf$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $5d24b541956da6cf$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $5d24b541956da6cf$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $5d24b541956da6cf$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $5d24b541956da6cf$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $5d24b541956da6cf$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $5d24b541956da6cf$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $5d24b541956da6cf$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $5d24b541956da6cf$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $5d24b541956da6cf$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $5d24b541956da6cf$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $5d24b541956da6cf$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $5d24b541956da6cf$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $5d24b541956da6cf$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $5d24b541956da6cf$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $5d24b541956da6cf$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $5d24b541956da6cf$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $5d24b541956da6cf$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $5d24b541956da6cf$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $5d24b541956da6cf$var$nextPaths = /* @__PURE__ */ new Set();
var $5d24b541956da6cf$var$discoveredPathsMaxSize = 1e3;
var $5d24b541956da6cf$var$discoveredPaths = /* @__PURE__ */ new Set();
var $5d24b541956da6cf$var$URL_LIMIT = 7680;
function $5d24b541956da6cf$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $5d24b541956da6cf$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $5d24b541956da6cf$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $5d24b541956da6cf$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$5d24b541956da6cf$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($5d24b541956da6cf$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $5d24b541956da6cf$var$fetchAndApplyManifestPatches([
            path
        ], // If we're patching for a fetcher call, reload the current location
        // Otherwise prefer any ongoing navigation location
        fetcherKey ? window.location.href : $5d24b541956da6cf$export$fe53371bee54353d(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $5d24b541956da6cf$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $jXEQt.useEffect(()=>{
        if (!$5d24b541956da6cf$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$5d24b541956da6cf$var$discoveredPaths.has(pathname)) $5d24b541956da6cf$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($5d24b541956da6cf$var$nextPaths.keys()).filter((path)=>{
                if ($5d24b541956da6cf$var$discoveredPaths.has(path)) {
                    $5d24b541956da6cf$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $5d24b541956da6cf$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $5d24b541956da6cf$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $5d24b541956da6cf$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $5d24b541956da6cf$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $5d24b541956da6cf$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($5d24b541956da6cf$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $5d24b541956da6cf$var$URL_LIMIT) {
        $5d24b541956da6cf$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($5d24b541956da6cf$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($5d24b541956da6cf$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($5d24b541956da6cf$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$5d24b541956da6cf$var$addToFifoQueue(p, $5d24b541956da6cf$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $5d24b541956da6cf$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $5d24b541956da6cf$var$addToFifoQueue(path, queue) {
    if (queue.size >= $5d24b541956da6cf$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $5d24b541956da6cf$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $5d24b541956da6cf$var$useDataRouterContext2() {
    let context = $jXEQt.useContext($5d24b541956da6cf$export$2eeee58951ff3c1c);
    $5d24b541956da6cf$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $5d24b541956da6cf$var$useDataRouterStateContext() {
    let context = $jXEQt.useContext($5d24b541956da6cf$export$315e3ffb01f217);
    $5d24b541956da6cf$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $5d24b541956da6cf$export$208d6a3bc3aa62bd = $jXEQt.createContext(void 0);
$5d24b541956da6cf$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $5d24b541956da6cf$var$useFrameworkContext() {
    let context = $jXEQt.useContext($5d24b541956da6cf$export$208d6a3bc3aa62bd);
    $5d24b541956da6cf$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $5d24b541956da6cf$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $jXEQt.useContext($5d24b541956da6cf$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $jXEQt.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $jXEQt.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $jXEQt.useRef(null);
    $jXEQt.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $jXEQt.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $5d24b541956da6cf$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $5d24b541956da6cf$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $5d24b541956da6cf$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $5d24b541956da6cf$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $5d24b541956da6cf$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $5d24b541956da6cf$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $5d24b541956da6cf$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$5d24b541956da6cf$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $5d24b541956da6cf$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $5d24b541956da6cf$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $5d24b541956da6cf$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $5d24b541956da6cf$var$useDataRouterStateContext();
    let matches = $5d24b541956da6cf$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $jXEQt.useMemo(()=>$5d24b541956da6cf$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $jXEQt.createElement("style", {
        [$5d24b541956da6cf$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $jXEQt.createElement("link", {
        [$5d24b541956da6cf$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$5d24b541956da6cf$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $jXEQt.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $5d24b541956da6cf$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $5d24b541956da6cf$var$useDataRouterContext2();
    let matches = $jXEQt.useMemo(()=>$5d24b541956da6cf$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $5d24b541956da6cf$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $5d24b541956da6cf$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $jXEQt.useState([]);
    $jXEQt.useEffect(()=>{
        let interrupted = false;
        $5d24b541956da6cf$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $5d24b541956da6cf$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $5d24b541956da6cf$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $5d24b541956da6cf$var$useFrameworkContext();
    let { basename: basename } = $5d24b541956da6cf$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $5d24b541956da6cf$var$useDataRouterStateContext();
    let newMatchesForData = $jXEQt.useMemo(()=>$5d24b541956da6cf$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $jXEQt.useMemo(()=>$5d24b541956da6cf$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $jXEQt.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $5d24b541956da6cf$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $jXEQt.useMemo(()=>$5d24b541956da6cf$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $5d24b541956da6cf$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $jXEQt.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $jXEQt.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $jXEQt.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $5d24b541956da6cf$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $5d24b541956da6cf$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $5d24b541956da6cf$var$useDataRouterStateContext();
    let location = $5d24b541956da6cf$export$45d76561a5302f2b();
    let _matches = $5d24b541956da6cf$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$5d24b541956da6cf$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $jXEQt.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $jXEQt.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $jXEQt.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $jXEQt.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $5d24b541956da6cf$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $jXEQt.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $5d24b541956da6cf$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $5d24b541956da6cf$var$isHydrated = false;
function $5d24b541956da6cf$export$3be068dde909e563() {
    $5d24b541956da6cf$var$isHydrated = true;
}
function $5d24b541956da6cf$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $5d24b541956da6cf$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $5d24b541956da6cf$var$useDataRouterContext2();
    let { matches: routerMatches } = $5d24b541956da6cf$var$useDataRouterStateContext();
    let isRSCRouterContext = $5d24b541956da6cf$var$useIsRSCRouterContext();
    let enableFogOfWar = $5d24b541956da6cf$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $5d24b541956da6cf$var$getActiveMatches(routerMatches, null, isSpaMode);
    $jXEQt.useEffect(()=>{
        $5d24b541956da6cf$export$3be068dde909e563();
    }, []);
    let initialScripts = $jXEQt.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $5d24b541956da6cf$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($5d24b541956da6cf$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, /* @__PURE__ */ $jXEQt.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $jXEQt.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $5d24b541956da6cf$var$isHydrated || isRSCRouterContext ? [] : $5d24b541956da6cf$var$dedupe(manifest.entry.imports.concat($5d24b541956da6cf$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $5d24b541956da6cf$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $5d24b541956da6cf$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $jXEQt.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $jXEQt.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $jXEQt.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $jXEQt.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $5d24b541956da6cf$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $5d24b541956da6cf$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $5d24b541956da6cf$export$32e57f52df4b6e34 = class extends $jXEQt.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $5d24b541956da6cf$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $jXEQt.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($5d24b541956da6cf$export$972111febbeef05b(error)) return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $jXEQt.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $5d24b541956da6cf$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $jXEQt.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $jXEQt.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $5d24b541956da6cf$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $5d24b541956da6cf$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $jXEQt.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $jXEQt.createElement("head", null, /* @__PURE__ */ $jXEQt.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $jXEQt.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $jXEQt.createElement("title", null, title)), /* @__PURE__ */ $jXEQt.createElement("body", null, /* @__PURE__ */ $jXEQt.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$ff0bf87698939488, null) : null)));
}
var $5d24b541956da6cf$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($5d24b541956da6cf$var$isBrowser2) window.__reactRouterVersion = "7.13.1";
} catch (e) {}
function $5d24b541956da6cf$export$1f3f55432a00e06d(routes, opts) {
    return $5d24b541956da6cf$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5d24b541956da6cf$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5d24b541956da6cf$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $5d24b541956da6cf$export$9269a41d8c4635e,
        hydrationRouteProperties: $5d24b541956da6cf$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $5d24b541956da6cf$export$1ba7ed8a3a7b3765(routes, opts) {
    return $5d24b541956da6cf$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $5d24b541956da6cf$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $5d24b541956da6cf$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $5d24b541956da6cf$export$9269a41d8c4635e,
        hydrationRouteProperties: $5d24b541956da6cf$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $5d24b541956da6cf$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $5d24b541956da6cf$var$deserializeErrors(state.errors)
    };
    return state;
}
function $5d24b541956da6cf$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $5d24b541956da6cf$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $5d24b541956da6cf$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $jXEQt.useRef();
    if (historyRef.current == null) historyRef.current = $5d24b541956da6cf$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jXEQt.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jXEQt.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $jXEQt.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $jXEQt.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $5d24b541956da6cf$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $jXEQt.useRef();
    if (historyRef.current == null) historyRef.current = $5d24b541956da6cf$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $jXEQt.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jXEQt.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $jXEQt.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $jXEQt.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $5d24b541956da6cf$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $jXEQt.useState({
        action: history.action,
        location: history.location
    });
    let setState = $jXEQt.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $jXEQt.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $jXEQt.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
$5d24b541956da6cf$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $5d24b541956da6cf$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $5d24b541956da6cf$export$a6c7ac8248d6e38a = $jXEQt.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, unstable_mask: unstable_mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, unstable_useTransitions: unstable_useTransitions } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $5d24b541956da6cf$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $5d24b541956da6cf$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $5d24b541956da6cf$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let location = $5d24b541956da6cf$export$45d76561a5302f2b();
    let maskedHref = null;
    if (unstable_mask) {
        let resolved = $5d24b541956da6cf$var$resolveTo(unstable_mask, [], location.unstable_mask ? location.unstable_mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : $5d24b541956da6cf$var$joinPaths([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $5d24b541956da6cf$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $5d24b541956da6cf$export$67621102c14d847(to, {
        replace: replace2,
        unstable_mask: unstable_mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $jXEQt.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: $5d24b541956da6cf$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, link, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$5d24b541956da6cf$export$a6c7ac8248d6e38a.displayName = "Link";
var $5d24b541956da6cf$export$b0d92dbee9b5b60d = $jXEQt.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $5d24b541956da6cf$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $5d24b541956da6cf$export$45d76561a5302f2b();
    let routerState = $jXEQt.useContext($5d24b541956da6cf$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $5d24b541956da6cf$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $5d24b541956da6cf$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$5d24b541956da6cf$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $5d24b541956da6cf$export$a7fed597f4b8afd8 = $jXEQt.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $5d24b541956da6cf$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    let submit = $5d24b541956da6cf$export$47c85c6e3a081d3();
    let formAction = $5d24b541956da6cf$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $5d24b541956da6cf$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
            });
        if (unstable_useTransitions && navigate !== false) $jXEQt.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $jXEQt.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$5d24b541956da6cf$export$a7fed597f4b8afd8.displayName = "Form";
function $5d24b541956da6cf$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $jXEQt.useContext($5d24b541956da6cf$export$208d6a3bc3aa62bd);
    let { basename: basename } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    let location = $5d24b541956da6cf$export$45d76561a5302f2b();
    let matches = $5d24b541956da6cf$export$2378eb7f5ff86053();
    $5d24b541956da6cf$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $jXEQt.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $5d24b541956da6cf$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $jXEQt.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$5d24b541956da6cf$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $5d24b541956da6cf$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$5d24b541956da6cf$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$5d24b541956da6cf$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $5d24b541956da6cf$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $5d24b541956da6cf$var$useDataRouterContext3(hookName) {
    let ctx = $jXEQt.useContext($5d24b541956da6cf$export$2eeee58951ff3c1c);
    $5d24b541956da6cf$export$f5708dca728d7177(ctx, $5d24b541956da6cf$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $5d24b541956da6cf$var$useDataRouterState2(hookName) {
    let state = $jXEQt.useContext($5d24b541956da6cf$export$315e3ffb01f217);
    $5d24b541956da6cf$export$f5708dca728d7177(state, $5d24b541956da6cf$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $5d24b541956da6cf$export$67621102c14d847(to, { target: target, replace: replaceProp, unstable_mask: unstable_mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $5d24b541956da6cf$export$9770f232ac06a008();
    let location = $5d24b541956da6cf$export$45d76561a5302f2b();
    let path = $5d24b541956da6cf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $jXEQt.useCallback((event)=>{
        if ($5d24b541956da6cf$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $5d24b541956da6cf$export$fe53371bee54353d(location) === $5d24b541956da6cf$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    unstable_mask: unstable_mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
                });
            if (unstable_useTransitions) $jXEQt.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        unstable_mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_defaultShouldRevalidate,
        unstable_useTransitions
    ]);
}
function $5d24b541956da6cf$export$f1a78c17382fe22a(defaultInit) {
    $5d24b541956da6cf$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $jXEQt.useRef($5d24b541956da6cf$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $jXEQt.useRef(false);
    let location = $5d24b541956da6cf$export$45d76561a5302f2b();
    let searchParams = $jXEQt.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $5d24b541956da6cf$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $5d24b541956da6cf$export$9770f232ac06a008();
    let setSearchParams = $jXEQt.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $5d24b541956da6cf$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $5d24b541956da6cf$var$fetcherId = 0;
var $5d24b541956da6cf$var$getUniqueFetcherId = ()=>`__${String(++$5d24b541956da6cf$var$fetcherId)}__`;
function $5d24b541956da6cf$export$47c85c6e3a081d3() {
    let { router: router } = $5d24b541956da6cf$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    let currentRouteId = $5d24b541956da6cf$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $jXEQt.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $5d24b541956da6cf$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $5d24b541956da6cf$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $5d24b541956da6cf$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    let routeContext = $jXEQt.useContext($5d24b541956da6cf$export$aac280ed165a4397);
    $5d24b541956da6cf$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$5d24b541956da6cf$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $5d24b541956da6cf$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $5d24b541956da6cf$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $5d24b541956da6cf$export$fe53371bee54353d(path);
}
function $5d24b541956da6cf$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $5d24b541956da6cf$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $5d24b541956da6cf$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $jXEQt.useContext($5d24b541956da6cf$export$cb3f1df1bef00a39);
    let route = $jXEQt.useContext($5d24b541956da6cf$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $5d24b541956da6cf$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $5d24b541956da6cf$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $5d24b541956da6cf$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $jXEQt.useId();
    let [fetcherKey, setFetcherKey] = $jXEQt.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $jXEQt.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $jXEQt.useCallback(async (href, opts)=>{
        $5d24b541956da6cf$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $5d24b541956da6cf$export$47c85c6e3a081d3();
    let submit = $jXEQt.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $jXEQt.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $jXEQt.useMemo(()=>{
        let FetcherForm2 = $jXEQt.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $5d24b541956da6cf$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $jXEQt.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $5d24b541956da6cf$export$fa996778a3a31087() {
    let state = $5d24b541956da6cf$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $5d24b541956da6cf$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $5d24b541956da6cf$var$savedScrollPositions = {};
function $5d24b541956da6cf$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $5d24b541956da6cf$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $5d24b541956da6cf$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $5d24b541956da6cf$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $5d24b541956da6cf$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $jXEQt.useContext($5d24b541956da6cf$export$3044ab7fdabeaee6);
    let location = $5d24b541956da6cf$export$45d76561a5302f2b();
    let matches = $5d24b541956da6cf$export$2378eb7f5ff86053();
    let navigation = $5d24b541956da6cf$export$d0fd4b7106de2769();
    $jXEQt.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $5d24b541956da6cf$var$usePageHide($jXEQt.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $5d24b541956da6cf$var$getScrollRestorationKey(location, matches, basename, getKey);
            $5d24b541956da6cf$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $5d24b541956da6cf$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($5d24b541956da6cf$var$savedScrollPositions));
        } catch (error) {
            $5d24b541956da6cf$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $jXEQt.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $5d24b541956da6cf$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $5d24b541956da6cf$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $jXEQt.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($5d24b541956da6cf$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$5d24b541956da6cf$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $jXEQt.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $5d24b541956da6cf$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $5d24b541956da6cf$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $jXEQt.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5d24b541956da6cf$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $jXEQt.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $5d24b541956da6cf$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $5d24b541956da6cf$export$b273b3273281a049(when);
    $jXEQt.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $jXEQt.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $5d24b541956da6cf$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $jXEQt.useContext($5d24b541956da6cf$export$3681f408decb40d1);
    $5d24b541956da6cf$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $5d24b541956da6cf$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $5d24b541956da6cf$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $5d24b541956da6cf$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $5d24b541956da6cf$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $5d24b541956da6cf$export$81336c211d5ff295(path.pathname, nextPath) != null || $5d24b541956da6cf$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $5d24b541956da6cf$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $5d24b541956da6cf$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default",
        unstable_mask: void 0
    };
    let staticNavigator = $5d24b541956da6cf$var$getStatelessNavigator();
    return /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $5d24b541956da6cf$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $5d24b541956da6cf$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $5d24b541956da6cf$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $5d24b541956da6cf$var$serializeErrors(context.errors)
        };
        let json = $5d24b541956da6cf$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $jXEQt.createElement($jXEQt.Fragment, null, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $jXEQt.createElement($5d24b541956da6cf$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        isStatic: true
    })))))), hydrateScript ? /* @__PURE__ */ $jXEQt.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $5d24b541956da6cf$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($5d24b541956da6cf$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $5d24b541956da6cf$var$getStatelessNavigator() {
    return {
        createHref: $5d24b541956da6cf$var$createHref,
        encodeLocation: $5d24b541956da6cf$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $5d24b541956da6cf$export$69163f0b72ec60d9(routes, opts) {
    return $5d24b541956da6cf$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $5d24b541956da6cf$export$9269a41d8c4635e
    });
}
function $5d24b541956da6cf$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $5d24b541956da6cf$export$87cb1a9238dc3fba(routes, $5d24b541956da6cf$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                renderFallback: false,
                navigation: $5d24b541956da6cf$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $5d24b541956da6cf$var$createHref,
        encodeLocation: $5d24b541956da6cf$var$encodeLocation,
        getFetcher () {
            return $5d24b541956da6cf$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $5d24b541956da6cf$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $5d24b541956da6cf$var$createHref(to) {
    return typeof to === "string" ? to : $5d24b541956da6cf$export$fe53371bee54353d(to);
}
function $5d24b541956da6cf$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $5d24b541956da6cf$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $5d24b541956da6cf$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $5d24b541956da6cf$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;

});

parcelRegister("1MCB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c836d91aef5e7f$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $2KJEQ = parcelRequire("2KJEQ");
var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $dvg8e = parcelRequire("dvg8e");

var $8oH7q = parcelRequire("8oH7q");

var $zjm80 = parcelRequire("zjm80");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $14c836d91aef5e7f$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $14c836d91aef5e7f$var$extendSxProp = (0, $2KJEQ.internal_createExtendSxProp)();
const $14c836d91aef5e7f$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $dvg8e.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $zjm80.getTypographyUtilityClass), classes);
};
const $14c836d91aef5e7f$export$140e2f5526d3cad8 = (0, $3EMXY.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $dvg8e.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $dvg8e.default)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $14c836d91aef5e7f$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $14c836d91aef5e7f$var$Typography = /*#__PURE__*/ $jXEQt.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$14c836d91aef5e7f$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $14c836d91aef5e7f$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $14c836d91aef5e7f$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $14c836d91aef5e7f$var$defaultVariantMapping[variant]) || 'span';
    const classes = $14c836d91aef5e7f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($14c836d91aef5e7f$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $fQojQ.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $14c836d91aef5e7f$export$2e2bcd8739ae039 = $14c836d91aef5e7f$var$Typography;

});
parcelRegister("fQojQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee9d4e7b280b4edb$export$2e2bcd8739ae039);
function $ee9d4e7b280b4edb$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ee9d4e7b280b4edb$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ee9d4e7b280b4edb$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ee9d4e7b280b4edb$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ee9d4e7b280b4edb$export$2e2bcd8739ae039 = $ee9d4e7b280b4edb$export$4f5d2d50c9deca37;

});

parcelRegister("3ptEP", function(module, exports) {

$parcel$export(module.exports, "default", () => $27bab64329802e78$export$2e2bcd8739ae039);
/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $27bab64329802e78$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}

});

parcelRegister("2KJEQ", function(module, exports) {

$parcel$export(module.exports, "globalCss", () => $20134b5564223953$export$db53682eef82cc11);
$parcel$export(module.exports, "internal_createExtendSxProp", () => $20134b5564223953$export$7e7f5719ff4debb1);

var $ilrFM = parcelRequire("ilrFM");

var $k3tJq = parcelRequire("k3tJq");

var $8a4xl = parcelRequire("8a4xl");

var $7rM61 = parcelRequire("7rM61");

var $IRdXs = parcelRequire("IRdXs");

var $3EMXY = parcelRequire("3EMXY");
function $20134b5564223953$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $7rM61.jsx)((0, $8a4xl.default), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $20134b5564223953$export$7e7f5719ff4debb1() {
    return 0, $ilrFM.default;
}

});
parcelRegister("ilrFM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5afa76667dbb2bd$export$2e2bcd8739ae039);

var $cqtAx = parcelRequire("cqtAx");

var $esenk = parcelRequire("esenk");
const $d5afa76667dbb2bd$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $esenk.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $d5afa76667dbb2bd$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $d5afa76667dbb2bd$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $cqtAx.isPlainObject)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}

});
parcelRegister("cqtAx", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $90bedd629d287b84$export$53b83ca8eaab0383);
$parcel$export(module.exports, "default", () => $90bedd629d287b84$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");

var $lsYCk = parcelRequire("lsYCk");
function $90bedd629d287b84$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $90bedd629d287b84$var$deepClone(source) {
    if (/*#__PURE__*/ $jXEQt.isValidElement(source) || (0, $lsYCk.isValidElementType)(source) || !$90bedd629d287b84$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $90bedd629d287b84$var$deepClone(source[key]);
    });
    return output;
}
function $90bedd629d287b84$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($90bedd629d287b84$export$53b83ca8eaab0383(target) && $90bedd629d287b84$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $jXEQt.isValidElement(source[key]) || (0, $lsYCk.isValidElementType)(source[key])) output[key] = source[key];
        else if ($90bedd629d287b84$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $90bedd629d287b84$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $90bedd629d287b84$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $90bedd629d287b84$export$53b83ca8eaab0383(source[key]) ? $90bedd629d287b84$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});
parcelRegister("lsYCk", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4ZDZL"));

});
parcelRegister("4ZDZL", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $3a2be22975b8c249$export$a7c73072b1a182ae, (v) => $3a2be22975b8c249$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $3a2be22975b8c249$export$9f27bc3417b4524d, (v) => $3a2be22975b8c249$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $3a2be22975b8c249$export$db77ccec0bb4ccac, (v) => $3a2be22975b8c249$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $3a2be22975b8c249$export$8392c0c9d3dcbd35, (v) => $3a2be22975b8c249$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $3a2be22975b8c249$export$ffb0004e005737fa, (v) => $3a2be22975b8c249$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $3a2be22975b8c249$export$b624eff549462981, (v) => $3a2be22975b8c249$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $3a2be22975b8c249$export$7897aa7841a5380c, (v) => $3a2be22975b8c249$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $3a2be22975b8c249$export$602eac185826482c, (v) => $3a2be22975b8c249$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $3a2be22975b8c249$export$e2c29f18771995cb, (v) => $3a2be22975b8c249$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $3a2be22975b8c249$export$5f8d39834fd61797, (v) => $3a2be22975b8c249$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $3a2be22975b8c249$export$74bf444e3cd11ea5, (v) => $3a2be22975b8c249$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $3a2be22975b8c249$export$998bcd577473dd93, (v) => $3a2be22975b8c249$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $3a2be22975b8c249$export$b706b080d889d2c9, (v) => $3a2be22975b8c249$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $3a2be22975b8c249$export$5be5a87408f70ddc, (v) => $3a2be22975b8c249$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $3a2be22975b8c249$export$45a5e7f76e0caa8d, (v) => $3a2be22975b8c249$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $3a2be22975b8c249$export$455c2e768291efa6, (v) => $3a2be22975b8c249$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $3a2be22975b8c249$export$9522e17588c12572, (v) => $3a2be22975b8c249$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $3a2be22975b8c249$export$2110ac352bb060b9, (v) => $3a2be22975b8c249$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $3a2be22975b8c249$export$56885ab8b9c456ab, (v) => $3a2be22975b8c249$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $3a2be22975b8c249$export$d927fcb6adf8f9de, (v) => $3a2be22975b8c249$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $3a2be22975b8c249$export$b82d16f27459e05a, (v) => $3a2be22975b8c249$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $3a2be22975b8c249$export$522c17b4f5e123e8, (v) => $3a2be22975b8c249$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $3a2be22975b8c249$export$1aabd8a0274ecfd6, (v) => $3a2be22975b8c249$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $3a2be22975b8c249$export$3d6c20d97e46b957, (v) => $3a2be22975b8c249$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $3a2be22975b8c249$export$9b621391a187a31a, (v) => $3a2be22975b8c249$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $3a2be22975b8c249$export$f5bbd400c2f4426f, (v) => $3a2be22975b8c249$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3a2be22975b8c249$export$a7c73072b1a182ae;
var $3a2be22975b8c249$export$9f27bc3417b4524d;
var $3a2be22975b8c249$export$db77ccec0bb4ccac;
var $3a2be22975b8c249$export$8392c0c9d3dcbd35;
var $3a2be22975b8c249$export$ffb0004e005737fa;
var $3a2be22975b8c249$export$b624eff549462981;
var $3a2be22975b8c249$export$7897aa7841a5380c;
var $3a2be22975b8c249$export$602eac185826482c;
var $3a2be22975b8c249$export$e2c29f18771995cb;
var $3a2be22975b8c249$export$5f8d39834fd61797;
var $3a2be22975b8c249$export$74bf444e3cd11ea5;
var $3a2be22975b8c249$export$998bcd577473dd93;
var $3a2be22975b8c249$export$b706b080d889d2c9;
var $3a2be22975b8c249$export$5be5a87408f70ddc;
var $3a2be22975b8c249$export$45a5e7f76e0caa8d;
var $3a2be22975b8c249$export$455c2e768291efa6;
var $3a2be22975b8c249$export$9522e17588c12572;
var $3a2be22975b8c249$export$2110ac352bb060b9;
var $3a2be22975b8c249$export$56885ab8b9c456ab;
var $3a2be22975b8c249$export$d927fcb6adf8f9de;
var $3a2be22975b8c249$export$b82d16f27459e05a;
var $3a2be22975b8c249$export$522c17b4f5e123e8;
var $3a2be22975b8c249$export$1aabd8a0274ecfd6;
var $3a2be22975b8c249$export$3d6c20d97e46b957;
var $3a2be22975b8c249$export$9b621391a187a31a;
var $3a2be22975b8c249$export$f5bbd400c2f4426f;
"use strict";
var $3a2be22975b8c249$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $3a2be22975b8c249$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $3a2be22975b8c249$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $3a2be22975b8c249$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $3a2be22975b8c249$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $3a2be22975b8c249$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $3a2be22975b8c249$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $3a2be22975b8c249$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $3a2be22975b8c249$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $3a2be22975b8c249$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $3a2be22975b8c249$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $3a2be22975b8c249$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $3a2be22975b8c249$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $3a2be22975b8c249$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $3a2be22975b8c249$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $3a2be22975b8c249$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $3a2be22975b8c249$var$REACT_FRAGMENT_TYPE:
                    case $3a2be22975b8c249$var$REACT_PROFILER_TYPE:
                    case $3a2be22975b8c249$var$REACT_STRICT_MODE_TYPE:
                    case $3a2be22975b8c249$var$REACT_SUSPENSE_TYPE:
                    case $3a2be22975b8c249$var$REACT_SUSPENSE_LIST_TYPE:
                    case $3a2be22975b8c249$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $3a2be22975b8c249$var$REACT_CONTEXT_TYPE:
                            case $3a2be22975b8c249$var$REACT_FORWARD_REF_TYPE:
                            case $3a2be22975b8c249$var$REACT_LAZY_TYPE:
                            case $3a2be22975b8c249$var$REACT_MEMO_TYPE:
                                return object;
                            case $3a2be22975b8c249$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $3a2be22975b8c249$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$3a2be22975b8c249$export$a7c73072b1a182ae = $3a2be22975b8c249$var$REACT_CONSUMER_TYPE;
$3a2be22975b8c249$export$9f27bc3417b4524d = $3a2be22975b8c249$var$REACT_CONTEXT_TYPE;
$3a2be22975b8c249$export$db77ccec0bb4ccac = $3a2be22975b8c249$var$REACT_ELEMENT_TYPE;
$3a2be22975b8c249$export$8392c0c9d3dcbd35 = $3a2be22975b8c249$var$REACT_FORWARD_REF_TYPE;
$3a2be22975b8c249$export$ffb0004e005737fa = $3a2be22975b8c249$var$REACT_FRAGMENT_TYPE;
$3a2be22975b8c249$export$b624eff549462981 = $3a2be22975b8c249$var$REACT_LAZY_TYPE;
$3a2be22975b8c249$export$7897aa7841a5380c = $3a2be22975b8c249$var$REACT_MEMO_TYPE;
$3a2be22975b8c249$export$602eac185826482c = $3a2be22975b8c249$var$REACT_PORTAL_TYPE;
$3a2be22975b8c249$export$e2c29f18771995cb = $3a2be22975b8c249$var$REACT_PROFILER_TYPE;
$3a2be22975b8c249$export$5f8d39834fd61797 = $3a2be22975b8c249$var$REACT_STRICT_MODE_TYPE;
$3a2be22975b8c249$export$74bf444e3cd11ea5 = $3a2be22975b8c249$var$REACT_SUSPENSE_TYPE;
$3a2be22975b8c249$export$998bcd577473dd93 = $3a2be22975b8c249$var$REACT_SUSPENSE_LIST_TYPE;
$3a2be22975b8c249$export$b706b080d889d2c9 = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_CONSUMER_TYPE;
};
$3a2be22975b8c249$export$5be5a87408f70ddc = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_CONTEXT_TYPE;
};
$3a2be22975b8c249$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $3a2be22975b8c249$var$REACT_ELEMENT_TYPE;
};
$3a2be22975b8c249$export$455c2e768291efa6 = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_FORWARD_REF_TYPE;
};
$3a2be22975b8c249$export$9522e17588c12572 = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_FRAGMENT_TYPE;
};
$3a2be22975b8c249$export$2110ac352bb060b9 = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_LAZY_TYPE;
};
$3a2be22975b8c249$export$56885ab8b9c456ab = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_MEMO_TYPE;
};
$3a2be22975b8c249$export$d927fcb6adf8f9de = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_PORTAL_TYPE;
};
$3a2be22975b8c249$export$b82d16f27459e05a = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_PROFILER_TYPE;
};
$3a2be22975b8c249$export$522c17b4f5e123e8 = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_STRICT_MODE_TYPE;
};
$3a2be22975b8c249$export$1aabd8a0274ecfd6 = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_SUSPENSE_TYPE;
};
$3a2be22975b8c249$export$3d6c20d97e46b957 = function(object) {
    return $3a2be22975b8c249$var$typeOf(object) === $3a2be22975b8c249$var$REACT_SUSPENSE_LIST_TYPE;
};
$3a2be22975b8c249$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $3a2be22975b8c249$var$REACT_FRAGMENT_TYPE || type === $3a2be22975b8c249$var$REACT_PROFILER_TYPE || type === $3a2be22975b8c249$var$REACT_STRICT_MODE_TYPE || type === $3a2be22975b8c249$var$REACT_SUSPENSE_TYPE || type === $3a2be22975b8c249$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $3a2be22975b8c249$var$REACT_LAZY_TYPE || type.$$typeof === $3a2be22975b8c249$var$REACT_MEMO_TYPE || type.$$typeof === $3a2be22975b8c249$var$REACT_CONTEXT_TYPE || type.$$typeof === $3a2be22975b8c249$var$REACT_CONSUMER_TYPE || type.$$typeof === $3a2be22975b8c249$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $3a2be22975b8c249$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$3a2be22975b8c249$export$f5bbd400c2f4426f = $3a2be22975b8c249$var$typeOf;

});



parcelRegister("esenk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a85ed4d6afb1671e$export$2e2bcd8739ae039);

var $l4VbN = parcelRequire("l4VbN");

var $hpgOB = parcelRequire("hpgOB");

var $kEOU3 = parcelRequire("kEOU3");

var $dm9MX = parcelRequire("dm9MX");

var $5btf1 = parcelRequire("5btf1");
const $a85ed4d6afb1671e$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $hpgOB.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $hpgOB.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $hpgOB.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $hpgOB.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $hpgOB.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $hpgOB.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $hpgOB.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $dm9MX.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $dm9MX.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $dm9MX.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $l4VbN.padding)
    },
    pt: {
        style: (0, $l4VbN.padding)
    },
    pr: {
        style: (0, $l4VbN.padding)
    },
    pb: {
        style: (0, $l4VbN.padding)
    },
    pl: {
        style: (0, $l4VbN.padding)
    },
    px: {
        style: (0, $l4VbN.padding)
    },
    py: {
        style: (0, $l4VbN.padding)
    },
    padding: {
        style: (0, $l4VbN.padding)
    },
    paddingTop: {
        style: (0, $l4VbN.padding)
    },
    paddingRight: {
        style: (0, $l4VbN.padding)
    },
    paddingBottom: {
        style: (0, $l4VbN.padding)
    },
    paddingLeft: {
        style: (0, $l4VbN.padding)
    },
    paddingX: {
        style: (0, $l4VbN.padding)
    },
    paddingY: {
        style: (0, $l4VbN.padding)
    },
    paddingInline: {
        style: (0, $l4VbN.padding)
    },
    paddingInlineStart: {
        style: (0, $l4VbN.padding)
    },
    paddingInlineEnd: {
        style: (0, $l4VbN.padding)
    },
    paddingBlock: {
        style: (0, $l4VbN.padding)
    },
    paddingBlockStart: {
        style: (0, $l4VbN.padding)
    },
    paddingBlockEnd: {
        style: (0, $l4VbN.padding)
    },
    m: {
        style: (0, $l4VbN.margin)
    },
    mt: {
        style: (0, $l4VbN.margin)
    },
    mr: {
        style: (0, $l4VbN.margin)
    },
    mb: {
        style: (0, $l4VbN.margin)
    },
    ml: {
        style: (0, $l4VbN.margin)
    },
    mx: {
        style: (0, $l4VbN.margin)
    },
    my: {
        style: (0, $l4VbN.margin)
    },
    margin: {
        style: (0, $l4VbN.margin)
    },
    marginTop: {
        style: (0, $l4VbN.margin)
    },
    marginRight: {
        style: (0, $l4VbN.margin)
    },
    marginBottom: {
        style: (0, $l4VbN.margin)
    },
    marginLeft: {
        style: (0, $l4VbN.margin)
    },
    marginX: {
        style: (0, $l4VbN.margin)
    },
    marginY: {
        style: (0, $l4VbN.margin)
    },
    marginInline: {
        style: (0, $l4VbN.margin)
    },
    marginInlineStart: {
        style: (0, $l4VbN.margin)
    },
    marginInlineEnd: {
        style: (0, $l4VbN.margin)
    },
    marginBlock: {
        style: (0, $l4VbN.margin)
    },
    marginBlockStart: {
        style: (0, $l4VbN.margin)
    },
    marginBlockEnd: {
        style: (0, $l4VbN.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $kEOU3.gap)
    },
    rowGap: {
        style: (0, $kEOU3.rowGap)
    },
    columnGap: {
        style: (0, $kEOU3.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $5btf1.sizingTransform)
    },
    maxWidth: {
        style: (0, $5btf1.maxWidth)
    },
    minWidth: {
        transform: (0, $5btf1.sizingTransform)
    },
    height: {
        transform: (0, $5btf1.sizingTransform)
    },
    maxHeight: {
        transform: (0, $5btf1.sizingTransform)
    },
    minHeight: {
        transform: (0, $5btf1.sizingTransform)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $a85ed4d6afb1671e$export$2e2bcd8739ae039 = $a85ed4d6afb1671e$var$defaultSxConfig;

});
parcelRegister("l4VbN", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", () => $f586554bf58d3b3d$export$cb5ee237cce814a2);
$parcel$export(module.exports, "createUnarySpacing", () => $f586554bf58d3b3d$export$1def6f833384e3d1);
$parcel$export(module.exports, "getValue", () => $f586554bf58d3b3d$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "margin", () => $f586554bf58d3b3d$export$7ede87f9b603dd3c);
$parcel$export(module.exports, "padding", () => $f586554bf58d3b3d$export$6f98e8eaf0be1996);


var $pU3Yi = parcelRequire("pU3Yi");

var $1t69u = parcelRequire("1t69u");

var $eTfHg = parcelRequire("eTfHg");

var $7C7zJ = parcelRequire("7C7zJ");
const $f586554bf58d3b3d$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $f586554bf58d3b3d$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $f586554bf58d3b3d$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $f586554bf58d3b3d$var$getCssProperties = (0, $7C7zJ.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($f586554bf58d3b3d$var$aliases[prop]) prop = $f586554bf58d3b3d$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $f586554bf58d3b3d$var$properties[a];
    const direction = $f586554bf58d3b3d$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $f586554bf58d3b3d$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $f586554bf58d3b3d$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $f586554bf58d3b3d$var$spacingKeys = [
    ...$f586554bf58d3b3d$export$aab52a0dde05ad8a,
    ...$f586554bf58d3b3d$export$f8397d44f03ab6ad
];
function $f586554bf58d3b3d$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $1t69u.getPath)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $f586554bf58d3b3d$export$1def6f833384e3d1(theme) {
    return $f586554bf58d3b3d$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $f586554bf58d3b3d$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $f586554bf58d3b3d$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $f586554bf58d3b3d$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $f586554bf58d3b3d$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $f586554bf58d3b3d$var$getCssProperties(prop);
    const styleFromPropValue = $f586554bf58d3b3d$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $pU3Yi.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $f586554bf58d3b3d$var$style(props, keys) {
    const transformer = $f586554bf58d3b3d$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$f586554bf58d3b3d$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $eTfHg.default), {});
}
function $f586554bf58d3b3d$export$7ede87f9b603dd3c(props) {
    return $f586554bf58d3b3d$var$style(props, $f586554bf58d3b3d$export$aab52a0dde05ad8a);
}
$f586554bf58d3b3d$export$7ede87f9b603dd3c.propTypes = {};
$f586554bf58d3b3d$export$7ede87f9b603dd3c.filterProps = $f586554bf58d3b3d$export$aab52a0dde05ad8a;
function $f586554bf58d3b3d$export$6f98e8eaf0be1996(props) {
    return $f586554bf58d3b3d$var$style(props, $f586554bf58d3b3d$export$f8397d44f03ab6ad);
}
$f586554bf58d3b3d$export$6f98e8eaf0be1996.propTypes = {};
$f586554bf58d3b3d$export$6f98e8eaf0be1996.filterProps = $f586554bf58d3b3d$export$f8397d44f03ab6ad;
function $f586554bf58d3b3d$var$spacing(props) {
    return $f586554bf58d3b3d$var$style(props, $f586554bf58d3b3d$var$spacingKeys);
}
$f586554bf58d3b3d$var$spacing.propTypes = {};
$f586554bf58d3b3d$var$spacing.filterProps = $f586554bf58d3b3d$var$spacingKeys;
var $f586554bf58d3b3d$export$2e2bcd8739ae039 = $f586554bf58d3b3d$var$spacing;

});
parcelRegister("pU3Yi", function(module, exports) {

$parcel$export(module.exports, "values", () => $04ddd2de7cf3fd68$export$68c286be0e7e55b7);
$parcel$export(module.exports, "handleBreakpoints", () => $04ddd2de7cf3fd68$export$88347efdb2e19abd);
$parcel$export(module.exports, "createEmptyBreakpointObject", () => $04ddd2de7cf3fd68$export$1f2600516e91381f);
$parcel$export(module.exports, "removeUnusedBreakpoints", () => $04ddd2de7cf3fd68$export$8922c90b6e020726);


var $cqtAx = parcelRequire("cqtAx");

var $eTfHg = parcelRequire("eTfHg");

var $1NX1j = parcelRequire("1NX1j");
const $04ddd2de7cf3fd68$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $04ddd2de7cf3fd68$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$04ddd2de7cf3fd68$export$68c286be0e7e55b7[key]}px)`
};
const $04ddd2de7cf3fd68$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $04ddd2de7cf3fd68$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $04ddd2de7cf3fd68$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $04ddd2de7cf3fd68$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $04ddd2de7cf3fd68$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $1NX1j.isCqShorthand)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $1NX1j.getContainerQuery)(theme.containerQueries ? theme : $04ddd2de7cf3fd68$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $04ddd2de7cf3fd68$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $04ddd2de7cf3fd68$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $04ddd2de7cf3fd68$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $eTfHg.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $04ddd2de7cf3fd68$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $04ddd2de7cf3fd68$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $04ddd2de7cf3fd68$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $04ddd2de7cf3fd68$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $cqtAx.default)(prev, next), {});
    return $04ddd2de7cf3fd68$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $04ddd2de7cf3fd68$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $04ddd2de7cf3fd68$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $04ddd2de7cf3fd68$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $04ddd2de7cf3fd68$export$2e2bcd8739ae039 = $04ddd2de7cf3fd68$var$breakpoints;

});
parcelRegister("eTfHg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad7260d0b7e095ac$export$2e2bcd8739ae039);

var $cqtAx = parcelRequire("cqtAx");
function $ad7260d0b7e095ac$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $cqtAx.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $ad7260d0b7e095ac$export$2e2bcd8739ae039 = $ad7260d0b7e095ac$var$merge;

});

parcelRegister("1NX1j", function(module, exports) {

$parcel$export(module.exports, "sortContainerQueries", () => $1508263c52b415e7$export$456f6c1142f990db);
$parcel$export(module.exports, "isCqShorthand", () => $1508263c52b415e7$export$77c7c3e357f440e7);
$parcel$export(module.exports, "getContainerQuery", () => $1508263c52b415e7$export$10a9745dfa00d15);
$parcel$export(module.exports, "default", () => $1508263c52b415e7$export$2e2bcd8739ae039);
/**
 * For using in `sx` prop to sort the breakpoint from low to high.
 * Note: this function does not work and will not support multiple units.
 *       e.g. input: { '@container (min-width:300px)': '1rem', '@container (min-width:40rem)': '2rem' }
 *            output: { '@container (min-width:40rem)': '2rem', '@container (min-width:300px)': '1rem' } // since 40 < 300 even though 40rem > 300px
 */ function $1508263c52b415e7$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $1508263c52b415e7$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $1508263c52b415e7$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $1508263c52b415e7$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}

});


parcelRegister("1t69u", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $111d45862a1b429a$export$2aa3fd96c49a84a8);
$parcel$export(module.exports, "getStyleValue", () => $111d45862a1b429a$export$741ad47189a64aa0);
$parcel$export(module.exports, "default", () => $111d45862a1b429a$export$2e2bcd8739ae039);

var $l7dVi = parcelRequire("l7dVi");


var $pU3Yi = parcelRequire("pU3Yi");
function $111d45862a1b429a$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $111d45862a1b429a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $111d45862a1b429a$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $111d45862a1b429a$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $111d45862a1b429a$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $111d45862a1b429a$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $111d45862a1b429a$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $l7dVi.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $pU3Yi.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $111d45862a1b429a$export$2e2bcd8739ae039 = $111d45862a1b429a$var$style;

});
parcelRegister("l7dVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5f50d3fe796b314$export$2e2bcd8739ae039);

var $fskif = parcelRequire("fskif");
function $f5f50d3fe796b314$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $fskif.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});
parcelRegister("fskif", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4093662a0755f10$export$2e2bcd8739ae039);
/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $b4093662a0755f10$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}

});



parcelRegister("7C7zJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $58b1f54f03687fd8$export$2e2bcd8739ae039);
function $58b1f54f03687fd8$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("hpgOB", function(module, exports) {

$parcel$export(module.exports, "borderTransform", () => $cac1d0a041de5215$export$34e2febe53ae29cc);
$parcel$export(module.exports, "borderRadius", () => $cac1d0a041de5215$export$7a57f79000377ca2);


var $1t69u = parcelRequire("1t69u");

var $8nfK2 = parcelRequire("8nfK2");

var $l4VbN = parcelRequire("l4VbN");

var $pU3Yi = parcelRequire("pU3Yi");
function $cac1d0a041de5215$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $cac1d0a041de5215$var$createBorderStyle(prop, transform) {
    return (0, $1t69u.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $cac1d0a041de5215$export$1edee58a52776cd9 = $cac1d0a041de5215$var$createBorderStyle('border', $cac1d0a041de5215$export$34e2febe53ae29cc);
const $cac1d0a041de5215$export$f9a7b6bd24892946 = $cac1d0a041de5215$var$createBorderStyle('borderTop', $cac1d0a041de5215$export$34e2febe53ae29cc);
const $cac1d0a041de5215$export$5abca33e6be905d2 = $cac1d0a041de5215$var$createBorderStyle('borderRight', $cac1d0a041de5215$export$34e2febe53ae29cc);
const $cac1d0a041de5215$export$e2ce9f12a980a822 = $cac1d0a041de5215$var$createBorderStyle('borderBottom', $cac1d0a041de5215$export$34e2febe53ae29cc);
const $cac1d0a041de5215$export$47658cca1a909427 = $cac1d0a041de5215$var$createBorderStyle('borderLeft', $cac1d0a041de5215$export$34e2febe53ae29cc);
const $cac1d0a041de5215$export$e7fb0694ba2404fc = $cac1d0a041de5215$var$createBorderStyle('borderColor');
const $cac1d0a041de5215$export$126a92c968acdb85 = $cac1d0a041de5215$var$createBorderStyle('borderTopColor');
const $cac1d0a041de5215$export$85cc51cb8fbb8c0e = $cac1d0a041de5215$var$createBorderStyle('borderRightColor');
const $cac1d0a041de5215$export$340b0327727f6d1a = $cac1d0a041de5215$var$createBorderStyle('borderBottomColor');
const $cac1d0a041de5215$export$60beef91a985b4bf = $cac1d0a041de5215$var$createBorderStyle('borderLeftColor');
const $cac1d0a041de5215$export$f9258c55612cbed7 = $cac1d0a041de5215$var$createBorderStyle('outline', $cac1d0a041de5215$export$34e2febe53ae29cc);
const $cac1d0a041de5215$export$621fe586efeb64b9 = $cac1d0a041de5215$var$createBorderStyle('outlineColor');
const $cac1d0a041de5215$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $l4VbN.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $l4VbN.getValue)(transformer, propValue)
            });
        return (0, $pU3Yi.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$cac1d0a041de5215$export$7a57f79000377ca2.propTypes = {};
$cac1d0a041de5215$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $cac1d0a041de5215$var$borders = (0, $8nfK2.default)($cac1d0a041de5215$export$1edee58a52776cd9, $cac1d0a041de5215$export$f9a7b6bd24892946, $cac1d0a041de5215$export$5abca33e6be905d2, $cac1d0a041de5215$export$e2ce9f12a980a822, $cac1d0a041de5215$export$47658cca1a909427, $cac1d0a041de5215$export$e7fb0694ba2404fc, $cac1d0a041de5215$export$126a92c968acdb85, $cac1d0a041de5215$export$85cc51cb8fbb8c0e, $cac1d0a041de5215$export$340b0327727f6d1a, $cac1d0a041de5215$export$60beef91a985b4bf, $cac1d0a041de5215$export$7a57f79000377ca2, $cac1d0a041de5215$export$f9258c55612cbed7, $cac1d0a041de5215$export$621fe586efeb64b9);
var $cac1d0a041de5215$export$2e2bcd8739ae039 = $cac1d0a041de5215$var$borders;

});
parcelRegister("8nfK2", function(module, exports) {

$parcel$export(module.exports, "default", () => $618caea34176e3ea$export$2e2bcd8739ae039);

var $eTfHg = parcelRequire("eTfHg");
function $618caea34176e3ea$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $eTfHg.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $618caea34176e3ea$export$2e2bcd8739ae039 = $618caea34176e3ea$var$compose;

});


parcelRegister("kEOU3", function(module, exports) {

$parcel$export(module.exports, "gap", () => $f09f0760f0473057$export$5df9adcb0db95e1e);
$parcel$export(module.exports, "columnGap", () => $f09f0760f0473057$export$ec60d70ff941a580);
$parcel$export(module.exports, "rowGap", () => $f09f0760f0473057$export$8a833ffa5f5dbeda);

var $1t69u = parcelRequire("1t69u");

var $8nfK2 = parcelRequire("8nfK2");

var $l4VbN = parcelRequire("l4VbN");

var $pU3Yi = parcelRequire("pU3Yi");

const $f09f0760f0473057$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $l4VbN.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $l4VbN.getValue)(transformer, propValue)
            });
        return (0, $pU3Yi.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$f09f0760f0473057$export$5df9adcb0db95e1e.propTypes = {};
$f09f0760f0473057$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $f09f0760f0473057$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $l4VbN.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $l4VbN.getValue)(transformer, propValue)
            });
        return (0, $pU3Yi.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$f09f0760f0473057$export$ec60d70ff941a580.propTypes = {};
$f09f0760f0473057$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $f09f0760f0473057$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $l4VbN.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $l4VbN.getValue)(transformer, propValue)
            });
        return (0, $pU3Yi.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$f09f0760f0473057$export$8a833ffa5f5dbeda.propTypes = {};
$f09f0760f0473057$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $f09f0760f0473057$export$baf44164ca3a34e8 = (0, $1t69u.default)({
    prop: 'gridColumn'
});
const $f09f0760f0473057$export$8f7213a1cd01e832 = (0, $1t69u.default)({
    prop: 'gridRow'
});
const $f09f0760f0473057$export$b0e0abbc49ba668 = (0, $1t69u.default)({
    prop: 'gridAutoFlow'
});
const $f09f0760f0473057$export$bcd8b929d4b4142 = (0, $1t69u.default)({
    prop: 'gridAutoColumns'
});
const $f09f0760f0473057$export$e5039a674e14c828 = (0, $1t69u.default)({
    prop: 'gridAutoRows'
});
const $f09f0760f0473057$export$42bd9088661ffb03 = (0, $1t69u.default)({
    prop: 'gridTemplateColumns'
});
const $f09f0760f0473057$export$920682ae05b999bc = (0, $1t69u.default)({
    prop: 'gridTemplateRows'
});
const $f09f0760f0473057$export$1b88fbdd482fd33a = (0, $1t69u.default)({
    prop: 'gridTemplateAreas'
});
const $f09f0760f0473057$export$bdb486e40d52d26f = (0, $1t69u.default)({
    prop: 'gridArea'
});
const $f09f0760f0473057$var$grid = (0, $8nfK2.default)($f09f0760f0473057$export$5df9adcb0db95e1e, $f09f0760f0473057$export$ec60d70ff941a580, $f09f0760f0473057$export$8a833ffa5f5dbeda, $f09f0760f0473057$export$baf44164ca3a34e8, $f09f0760f0473057$export$8f7213a1cd01e832, $f09f0760f0473057$export$b0e0abbc49ba668, $f09f0760f0473057$export$bcd8b929d4b4142, $f09f0760f0473057$export$e5039a674e14c828, $f09f0760f0473057$export$42bd9088661ffb03, $f09f0760f0473057$export$920682ae05b999bc, $f09f0760f0473057$export$1b88fbdd482fd33a, $f09f0760f0473057$export$bdb486e40d52d26f);
var $f09f0760f0473057$export$2e2bcd8739ae039 = $f09f0760f0473057$var$grid;

});

parcelRegister("dm9MX", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", () => $9b94ec4039f553e7$export$dbaffd4420ea0ac6);

var $1t69u = parcelRequire("1t69u");

var $8nfK2 = parcelRequire("8nfK2");
function $9b94ec4039f553e7$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $9b94ec4039f553e7$export$35e9368ef982300f = (0, $1t69u.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $9b94ec4039f553e7$export$dbaffd4420ea0ac6
});
const $9b94ec4039f553e7$export$2506f56c10355b33 = (0, $1t69u.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $9b94ec4039f553e7$export$dbaffd4420ea0ac6
});
const $9b94ec4039f553e7$export$8c5a050822fd698c = (0, $1t69u.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $9b94ec4039f553e7$export$dbaffd4420ea0ac6
});
const $9b94ec4039f553e7$var$palette = (0, $8nfK2.default)($9b94ec4039f553e7$export$35e9368ef982300f, $9b94ec4039f553e7$export$2506f56c10355b33, $9b94ec4039f553e7$export$8c5a050822fd698c);
var $9b94ec4039f553e7$export$2e2bcd8739ae039 = $9b94ec4039f553e7$var$palette;

});

parcelRegister("5btf1", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", () => $3c64a99088113bb0$export$8afece71750ec241);
$parcel$export(module.exports, "maxWidth", () => $3c64a99088113bb0$export$488fda99655ff65a);

var $1t69u = parcelRequire("1t69u");

var $8nfK2 = parcelRequire("8nfK2");

var $pU3Yi = parcelRequire("pU3Yi");
function $3c64a99088113bb0$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $3c64a99088113bb0$export$7e3df82ee760448c = (0, $1t69u.default)({
    prop: 'width',
    transform: $3c64a99088113bb0$export$8afece71750ec241
});
const $3c64a99088113bb0$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $pU3Yi.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $3c64a99088113bb0$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $pU3Yi.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$3c64a99088113bb0$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $3c64a99088113bb0$export$ee148fbbe8357dd2 = (0, $1t69u.default)({
    prop: 'minWidth',
    transform: $3c64a99088113bb0$export$8afece71750ec241
});
const $3c64a99088113bb0$export$ac607276a8fe9f0a = (0, $1t69u.default)({
    prop: 'height',
    transform: $3c64a99088113bb0$export$8afece71750ec241
});
const $3c64a99088113bb0$export$dc0d8bd0b94f8570 = (0, $1t69u.default)({
    prop: 'maxHeight',
    transform: $3c64a99088113bb0$export$8afece71750ec241
});
const $3c64a99088113bb0$export$a43cf604e12f3b17 = (0, $1t69u.default)({
    prop: 'minHeight',
    transform: $3c64a99088113bb0$export$8afece71750ec241
});
const $3c64a99088113bb0$export$ffed9f14fb65e276 = (0, $1t69u.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $3c64a99088113bb0$export$8afece71750ec241
});
const $3c64a99088113bb0$export$905076ed6620e671 = (0, $1t69u.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $3c64a99088113bb0$export$8afece71750ec241
});
const $3c64a99088113bb0$export$6ccc93f785106a58 = (0, $1t69u.default)({
    prop: 'boxSizing'
});
const $3c64a99088113bb0$var$sizing = (0, $8nfK2.default)($3c64a99088113bb0$export$7e3df82ee760448c, $3c64a99088113bb0$export$488fda99655ff65a, $3c64a99088113bb0$export$ee148fbbe8357dd2, $3c64a99088113bb0$export$ac607276a8fe9f0a, $3c64a99088113bb0$export$dc0d8bd0b94f8570, $3c64a99088113bb0$export$a43cf604e12f3b17, $3c64a99088113bb0$export$6ccc93f785106a58);
var $3c64a99088113bb0$export$2e2bcd8739ae039 = $3c64a99088113bb0$var$sizing;

});



parcelRegister("k3tJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e99b268d7ca25412$export$2e2bcd8739ae039);
parcelRequire("jXEQt");

var $gvt33 = parcelRequire("gvt33");

var $5Gz5b = parcelRequire("5Gz5b");

var $lyEQv = parcelRequire("lyEQv");
'use client';
function $e99b268d7ca25412$export$2e2bcd8739ae039() {
    const theme = (0, $gvt33.default)((0, $5Gz5b.default));
    return theme[0, $lyEQv.default] || theme;
}

});
parcelRegister("gvt33", function(module, exports) {

$parcel$export(module.exports, "default", () => $c04612fc6cdc72a8$export$2e2bcd8739ae039);

var $jECx5 = parcelRequire("jECx5");

var $dDbWc = parcelRequire("dDbWc");
'use client';
const $c04612fc6cdc72a8$export$35e57303dbd8a66 = (0, $jECx5.default)();
function $c04612fc6cdc72a8$var$useTheme(defaultTheme = $c04612fc6cdc72a8$export$35e57303dbd8a66) {
    return (0, $dDbWc.default)(defaultTheme);
}
var $c04612fc6cdc72a8$export$2e2bcd8739ae039 = $c04612fc6cdc72a8$var$useTheme;

});
parcelRegister("jECx5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4efa48e07c41b95$export$2e2bcd8739ae039);

var $cqtAx = parcelRequire("cqtAx");

var $K7LR3 = parcelRequire("K7LR3");

var $1NX1j = parcelRequire("1NX1j");

var $br28h = parcelRequire("br28h");

var $9nluD = parcelRequire("9nluD");

var $iBnPH = parcelRequire("iBnPH");

var $esenk = parcelRequire("esenk");

var $cCHOL = parcelRequire("cCHOL");
function $e4efa48e07c41b95$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $K7LR3.default)(breakpointsInput);
    const spacing = (0, $9nluD.default)(spacingInput);
    let muiTheme = (0, $cqtAx.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $br28h.default),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $1NX1j.default)(muiTheme);
    muiTheme.applyStyles = (0, $cCHOL.default);
    muiTheme = args.reduce((acc, argument)=>(0, $cqtAx.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $esenk.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $iBnPH.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $e4efa48e07c41b95$export$2e2bcd8739ae039 = $e4efa48e07c41b95$var$createTheme;

});
parcelRegister("K7LR3", function(module, exports) {

$parcel$export(module.exports, "default", () => $08aa531f1e73a492$export$2e2bcd8739ae039);
// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $08aa531f1e73a492$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $08aa531f1e73a492$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $08aa531f1e73a492$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $08aa531f1e73a492$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}

});

parcelRegister("br28h", function(module, exports) {

$parcel$export(module.exports, "default", () => $8533dec8ee03e166$export$2e2bcd8739ae039);
const $8533dec8ee03e166$var$shape = {
    borderRadius: 4
};
var $8533dec8ee03e166$export$2e2bcd8739ae039 = $8533dec8ee03e166$var$shape;

});

parcelRegister("9nluD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d36ef1f324129a8$export$2e2bcd8739ae039);

var $l4VbN = parcelRequire("l4VbN");
function $6d36ef1f324129a8$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $l4VbN.createUnarySpacing)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});

parcelRegister("iBnPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8ae2b685e36e58a$export$2e2bcd8739ae039);

var $l7dVi = parcelRequire("l7dVi");

var $eTfHg = parcelRequire("eTfHg");

var $1t69u = parcelRequire("1t69u");

var $pU3Yi = parcelRequire("pU3Yi");

var $1NX1j = parcelRequire("1NX1j");

var $esenk = parcelRequire("esenk");
function $d8ae2b685e36e58a$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $d8ae2b685e36e58a$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $d8ae2b685e36e58a$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $1t69u.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $1t69u.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $1t69u.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $l7dVi.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $pU3Yi.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $esenk.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $pU3Yi.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $d8ae2b685e36e58a$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $eTfHg.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $pU3Yi.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($d8ae2b685e36e58a$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $eTfHg.default)(css, breakpointsValues);
                        }
                    } else css = (0, $eTfHg.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $1NX1j.sortContainerQueries)(theme, (0, $pU3Yi.removeUnusedBreakpoints)(breakpointsKeys, css))
            };
            return (0, $1NX1j.sortContainerQueries)(theme, (0, $pU3Yi.removeUnusedBreakpoints)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $d8ae2b685e36e58a$var$styleFunctionSx = $d8ae2b685e36e58a$export$7d53d8bf2911e013();
$d8ae2b685e36e58a$var$styleFunctionSx.filterProps = [
    'sx'
];
var $d8ae2b685e36e58a$export$2e2bcd8739ae039 = $d8ae2b685e36e58a$var$styleFunctionSx;

});

parcelRegister("cCHOL", function(module, exports) {

$parcel$export(module.exports, "default", () => $930b05f3aff7989f$export$2e2bcd8739ae039);
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $930b05f3aff7989f$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});


parcelRegister("dDbWc", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ec82d7651e12e35$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
parcelRequire("IRdXs");
var $h1PbY = parcelRequire("h1PbY");
'use client';
function $9ec82d7651e12e35$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $9ec82d7651e12e35$var$useTheme(defaultTheme = null) {
    const contextTheme = $jXEQt.useContext((0, $h1PbY.T));
    return !contextTheme || $9ec82d7651e12e35$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $9ec82d7651e12e35$export$2e2bcd8739ae039 = $9ec82d7651e12e35$var$useTheme;

});
parcelRegister("IRdXs", function(module, exports) {

$parcel$export(module.exports, "Global", () => $086d6560f3b10fc5$export$98f03c5d19621d70);
$parcel$export(module.exports, "css", () => $086d6560f3b10fc5$export$dbf350e5966cf602);
$parcel$export(module.exports, "keyframes", () => $086d6560f3b10fc5$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("h1PbY")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("h1PbY")).w);

var $h1PbY = parcelRequire("h1PbY");

var $jXEQt = parcelRequire("jXEQt");

var $7i4hv = parcelRequire("7i4hv");

var $a7NNJ = parcelRequire("a7NNJ");

var $eC8G3 = parcelRequire("eC8G3");
parcelRequire("7g1UW");
parcelRequire("eR4tV");
parcelRequire("83kLZ");

parcelRequire("4Djfw");
var $086d6560f3b10fc5$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $h1PbY.h).call(props, 'css')) return $jXEQt.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $h1PbY.E);
    createElementArgArray[1] = (0, $h1PbY.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $jXEQt.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($086d6560f3b10fc5$export$c8a8987d4410bf2d || ($086d6560f3b10fc5$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $086d6560f3b10fc5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $h1PbY.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $eC8G3.serializeStyles)([
        styles
    ], undefined, $jXEQt.useContext((0, $h1PbY.T)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $jXEQt.useRef();
    (0, $a7NNJ.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $a7NNJ.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $7i4hv.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $086d6560f3b10fc5$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $eC8G3.serializeStyles)(args);
}
function $086d6560f3b10fc5$export$d25ddfdf17c3ad3e() {
    var insertable = $086d6560f3b10fc5$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $086d6560f3b10fc5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $086d6560f3b10fc5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $7i4hv.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $086d6560f3b10fc5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $a7NNJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $7i4hv.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $086d6560f3b10fc5$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $h1PbY.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $h1PbY.i)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $eC8G3.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $7i4hv.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $h1PbY.i)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $086d6560f3b10fc5$var$merge(cache.registered, css, $086d6560f3b10fc5$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $jXEQt.useContext((0, $h1PbY.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $jXEQt.createElement($jXEQt.Fragment, null, /*#__PURE__*/ $jXEQt.createElement($086d6560f3b10fc5$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("h1PbY", function(module, exports) {

$parcel$export(module.exports, "i", () => $c65a3d54cddd6d39$export$23f2a1d2818174ef);
$parcel$export(module.exports, "C", () => $c65a3d54cddd6d39$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $c65a3d54cddd6d39$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "T", () => $c65a3d54cddd6d39$export$971d5caa766a69d7);
$parcel$export(module.exports, "h", () => $c65a3d54cddd6d39$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "c", () => $c65a3d54cddd6d39$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $c65a3d54cddd6d39$export$a9c23c6ac3fc3eca);

var $jXEQt = parcelRequire("jXEQt");

var $7g1UW = parcelRequire("7g1UW");

var $eR4tV = parcelRequire("eR4tV");

var $83kLZ = parcelRequire("83kLZ");

var $ipyNH = parcelRequire("ipyNH");

var $7i4hv = parcelRequire("7i4hv");

var $eC8G3 = parcelRequire("eC8G3");

var $a7NNJ = parcelRequire("a7NNJ");
var $c65a3d54cddd6d39$export$23f2a1d2818174ef = false;
var $c65a3d54cddd6d39$var$EmotionCacheContext = /* #__PURE__ */ $jXEQt.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $7g1UW.default)({
    key: 'css'
}) : null);
var $c65a3d54cddd6d39$export$e7094788287c5e9b = $c65a3d54cddd6d39$var$EmotionCacheContext.Provider;
var $c65a3d54cddd6d39$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $jXEQt.useContext)($c65a3d54cddd6d39$var$EmotionCacheContext);
};
var $c65a3d54cddd6d39$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $jXEQt.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $jXEQt.useContext)($c65a3d54cddd6d39$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $c65a3d54cddd6d39$export$971d5caa766a69d7 = /* #__PURE__ */ $jXEQt.createContext({});
var $c65a3d54cddd6d39$export$3b14a55fb2447963 = function useTheme() {
    return $jXEQt.useContext($c65a3d54cddd6d39$export$971d5caa766a69d7);
};
var $c65a3d54cddd6d39$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $eR4tV.default)({}, outerTheme, theme);
};
var $c65a3d54cddd6d39$var$createCacheWithTheme = /* #__PURE__ */ (0, $83kLZ.default)(function(outerTheme) {
    return (0, $83kLZ.default)(function(theme) {
        return $c65a3d54cddd6d39$var$getTheme(outerTheme, theme);
    });
});
var $c65a3d54cddd6d39$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $jXEQt.useContext($c65a3d54cddd6d39$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $c65a3d54cddd6d39$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $jXEQt.createElement($c65a3d54cddd6d39$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $c65a3d54cddd6d39$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $jXEQt.forwardRef(function render(props, ref) {
        var theme = $jXEQt.useContext($c65a3d54cddd6d39$export$971d5caa766a69d7);
        return /*#__PURE__*/ $jXEQt.createElement(Component, (0, $eR4tV.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $ipyNH.default)(WithTheme, Component);
}
var $c65a3d54cddd6d39$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $c65a3d54cddd6d39$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $c65a3d54cddd6d39$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($c65a3d54cddd6d39$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$c65a3d54cddd6d39$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $c65a3d54cddd6d39$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7i4hv.registerStyles)(cache, serialized, isStringTag);
    (0, $a7NNJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7i4hv.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $c65a3d54cddd6d39$var$Emotion = /* #__PURE__ */ $c65a3d54cddd6d39$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$c65a3d54cddd6d39$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $7i4hv.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $eC8G3.serializeStyles)(registeredStyles, undefined, $jXEQt.useContext($c65a3d54cddd6d39$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($c65a3d54cddd6d39$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $c65a3d54cddd6d39$var$typePropName && !$c65a3d54cddd6d39$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $jXEQt.createElement($jXEQt.Fragment, null, /*#__PURE__*/ $jXEQt.createElement($c65a3d54cddd6d39$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $jXEQt.createElement(WrappedComponent, newProps));
});
var $c65a3d54cddd6d39$export$a9c23c6ac3fc3eca = $c65a3d54cddd6d39$var$Emotion;

});
parcelRegister("7g1UW", function(module, exports) {

$parcel$export(module.exports, "default", () => $548b83c87c9e2cbd$export$2e2bcd8739ae039);

var $bIyd5 = parcelRequire("bIyd5");

var $is4Ai = parcelRequire("is4Ai");
var $lq8nA = parcelRequire("lq8nA");
var $cErpd = parcelRequire("cErpd");
var $hbI1W = parcelRequire("hbI1W");
var $2hxzb = parcelRequire("2hxzb");
var $dc1rY = parcelRequire("dc1rY");
parcelRequire("83kLZ");
parcelRequire("jeNL3");
var $548b83c87c9e2cbd$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $is4Ai.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $is4Ai.token)(character)) break;
        (0, $is4Ai.next)();
    }
    return (0, $is4Ai.slice)(begin, (0, $is4Ai.position));
};
var $548b83c87c9e2cbd$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $is4Ai.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $is4Ai.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $548b83c87c9e2cbd$var$identifierWithPointTracking((0, $is4Ai.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $is4Ai.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $is4Ai.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $lq8nA.from)(character);
    }
    while (character = (0, $is4Ai.next)());
    return parsed;
};
var $548b83c87c9e2cbd$var$getRules = function getRules(value, points) {
    return (0, $is4Ai.dealloc)($548b83c87c9e2cbd$var$toRules((0, $is4Ai.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $548b83c87c9e2cbd$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $548b83c87c9e2cbd$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$548b83c87c9e2cbd$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $548b83c87c9e2cbd$var$fixedElements.set(element, true);
    var points = [];
    var rules = $548b83c87c9e2cbd$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $548b83c87c9e2cbd$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $548b83c87c9e2cbd$var$prefix(value, length) {
    switch((0, $lq8nA.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $hbI1W.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $hbI1W.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MOZ) + value + (0, $hbI1W.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + value + value;
        // order
        case 6165:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $hbI1W.WEBKIT) + value + (0, $lq8nA.replace)(value, /(\w+).+(:[^]+)/, (0, $hbI1W.WEBKIT) + 'box-$1$2' + (0, $hbI1W.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + 'flex-item-' + (0, $lq8nA.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + 'flex-line-pack' + (0, $lq8nA.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $hbI1W.WEBKIT) + 'box-' + (0, $lq8nA.replace)(value, '-grow', '') + (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $hbI1W.WEBKIT) + (0, $lq8nA.replace)(value, /([^-])(transform)/g, '$1' + (0, $hbI1W.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $lq8nA.replace)((0, $lq8nA.replace)((0, $lq8nA.replace)(value, /(zoom-|grab)/, (0, $hbI1W.WEBKIT) + '$1'), /(image-set)/, (0, $hbI1W.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $lq8nA.replace)(value, /(image-set\([^]*)/, (0, $hbI1W.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $lq8nA.replace)((0, $lq8nA.replace)(value, /(.+:)(flex-)?(.*)/, (0, $hbI1W.WEBKIT) + 'box-pack:$3' + (0, $hbI1W.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $hbI1W.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $lq8nA.replace)(value, /(.+)-inline(.+)/, (0, $hbI1W.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $lq8nA.strlen)(value) - 1 - length > 6) switch((0, $lq8nA.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $lq8nA.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $lq8nA.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $hbI1W.WEBKIT) + '$2-$3' + '$1' + (0, $hbI1W.MOZ) + ((0, $lq8nA.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $lq8nA.indexof)(value, 'stretch') ? $548b83c87c9e2cbd$var$prefix((0, $lq8nA.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $lq8nA.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $lq8nA.charat)(value, (0, $lq8nA.strlen)(value) - 3 - (~(0, $lq8nA.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $lq8nA.replace)(value, ':', ':' + (0, $hbI1W.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $lq8nA.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $hbI1W.WEBKIT) + ((0, $lq8nA.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $hbI1W.WEBKIT) + '$2$3' + '$1' + (0, $hbI1W.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $lq8nA.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + value + value;
    }
    return value;
}
var $548b83c87c9e2cbd$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $hbI1W.DECLARATION:
                element["return"] = $548b83c87c9e2cbd$var$prefix(element.value, element.length);
                break;
            case 0, $hbI1W.KEYFRAMES:
                return (0, $dc1rY.serialize)([
                    (0, $is4Ai.copy)(element, {
                        value: (0, $lq8nA.replace)(element.value, '@', '@' + (0, $hbI1W.WEBKIT))
                    })
                ], callback);
            case 0, $hbI1W.RULESET:
                if (element.length) return (0, $lq8nA.combine)(element.props, function(value) {
                    switch((0, $lq8nA.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $dc1rY.serialize)([
                                (0, $is4Ai.copy)(element, {
                                    props: [
                                        (0, $lq8nA.replace)(value, /:(read-\w+)/, ':' + (0, $hbI1W.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $dc1rY.serialize)([
                                (0, $is4Ai.copy)(element, {
                                    props: [
                                        (0, $lq8nA.replace)(value, /:(plac\w+)/, ':' + (0, $hbI1W.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $is4Ai.copy)(element, {
                                    props: [
                                        (0, $lq8nA.replace)(value, /:(plac\w+)/, ':' + (0, $hbI1W.MOZ) + '$1')
                                    ]
                                }),
                                (0, $is4Ai.copy)(element, {
                                    props: [
                                        (0, $lq8nA.replace)(value, /:(plac\w+)/, (0, $hbI1W.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $548b83c87c9e2cbd$var$defaultStylisPlugins = [
    $548b83c87c9e2cbd$var$prefixer
];
var $548b83c87c9e2cbd$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $548b83c87c9e2cbd$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $548b83c87c9e2cbd$var$compat,
        $548b83c87c9e2cbd$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $dc1rY.stringify),
        (0, $2hxzb.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $2hxzb.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $dc1rY.serialize)((0, $cErpd.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $bIyd5.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("bIyd5", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $887e572a59b27363$export$9d753cd7ae895cce);
var $887e572a59b27363$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $887e572a59b27363$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $887e572a59b27363$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $887e572a59b27363$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$887e572a59b27363$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($887e572a59b27363$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $887e572a59b27363$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("is4Ai", function(module, exports) {

$parcel$export(module.exports, "position", () => $d6ee65e080771c76$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $d6ee65e080771c76$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $d6ee65e080771c76$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $d6ee65e080771c76$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $d6ee65e080771c76$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $d6ee65e080771c76$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $d6ee65e080771c76$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $d6ee65e080771c76$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $d6ee65e080771c76$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $d6ee65e080771c76$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $d6ee65e080771c76$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $d6ee65e080771c76$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $d6ee65e080771c76$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $d6ee65e080771c76$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $d6ee65e080771c76$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $d6ee65e080771c76$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $d6ee65e080771c76$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $d6ee65e080771c76$export$4254d4e2b3745c4c);

var $lq8nA = parcelRequire("lq8nA");
var $d6ee65e080771c76$export$53f1d5ea8de3d7c = 1;
var $d6ee65e080771c76$export$4e0c71f277ca26b3 = 1;
var $d6ee65e080771c76$export$f24224f1c91d8156 = 0;
var $d6ee65e080771c76$export$5880b8b5730aff45 = 0;
var $d6ee65e080771c76$export$c0306caf338ac095 = 0;
var $d6ee65e080771c76$export$30a86d91af8ff6e6 = '';
function $d6ee65e080771c76$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $d6ee65e080771c76$export$53f1d5ea8de3d7c,
        column: $d6ee65e080771c76$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $d6ee65e080771c76$export$784d13d8ee351f07(root, props) {
    return (0, $lq8nA.assign)($d6ee65e080771c76$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $d6ee65e080771c76$export$eba6f6f03b0a92e7() {
    return $d6ee65e080771c76$export$c0306caf338ac095;
}
function $d6ee65e080771c76$export$232faf9add678146() {
    $d6ee65e080771c76$export$c0306caf338ac095 = $d6ee65e080771c76$export$5880b8b5730aff45 > 0 ? (0, $lq8nA.charat)($d6ee65e080771c76$export$30a86d91af8ff6e6, --$d6ee65e080771c76$export$5880b8b5730aff45) : 0;
    if ($d6ee65e080771c76$export$4e0c71f277ca26b3--, $d6ee65e080771c76$export$c0306caf338ac095 === 10) $d6ee65e080771c76$export$4e0c71f277ca26b3 = 1, $d6ee65e080771c76$export$53f1d5ea8de3d7c--;
    return $d6ee65e080771c76$export$c0306caf338ac095;
}
function $d6ee65e080771c76$export$48cfd1e771a65c4f() {
    $d6ee65e080771c76$export$c0306caf338ac095 = $d6ee65e080771c76$export$5880b8b5730aff45 < $d6ee65e080771c76$export$f24224f1c91d8156 ? (0, $lq8nA.charat)($d6ee65e080771c76$export$30a86d91af8ff6e6, $d6ee65e080771c76$export$5880b8b5730aff45++) : 0;
    if ($d6ee65e080771c76$export$4e0c71f277ca26b3++, $d6ee65e080771c76$export$c0306caf338ac095 === 10) $d6ee65e080771c76$export$4e0c71f277ca26b3 = 1, $d6ee65e080771c76$export$53f1d5ea8de3d7c++;
    return $d6ee65e080771c76$export$c0306caf338ac095;
}
function $d6ee65e080771c76$export$4d3fb11e950abb9e() {
    return (0, $lq8nA.charat)($d6ee65e080771c76$export$30a86d91af8ff6e6, $d6ee65e080771c76$export$5880b8b5730aff45);
}
function $d6ee65e080771c76$export$e88cb2efb12ae807() {
    return $d6ee65e080771c76$export$5880b8b5730aff45;
}
function $d6ee65e080771c76$export$58adb3bec8346d0f(begin, end) {
    return (0, $lq8nA.substr)($d6ee65e080771c76$export$30a86d91af8ff6e6, begin, end);
}
function $d6ee65e080771c76$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $d6ee65e080771c76$export$2de70f21292aac9e(value) {
    return $d6ee65e080771c76$export$53f1d5ea8de3d7c = $d6ee65e080771c76$export$4e0c71f277ca26b3 = 1, $d6ee65e080771c76$export$f24224f1c91d8156 = (0, $lq8nA.strlen)($d6ee65e080771c76$export$30a86d91af8ff6e6 = value), $d6ee65e080771c76$export$5880b8b5730aff45 = 0, [];
}
function $d6ee65e080771c76$export$45918ac1574455b1(value) {
    return $d6ee65e080771c76$export$30a86d91af8ff6e6 = '', value;
}
function $d6ee65e080771c76$export$410ac95b9ec204b8(type) {
    return (0, $lq8nA.trim)($d6ee65e080771c76$export$58adb3bec8346d0f($d6ee65e080771c76$export$5880b8b5730aff45 - 1, $d6ee65e080771c76$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $d6ee65e080771c76$export$660b2ee2d4fb4eff(value) {
    return $d6ee65e080771c76$export$45918ac1574455b1($d6ee65e080771c76$export$5f8c09e3ae6f64e1($d6ee65e080771c76$export$2de70f21292aac9e(value)));
}
function $d6ee65e080771c76$export$7af1228ff777d175(type) {
    while($d6ee65e080771c76$export$c0306caf338ac095 = $d6ee65e080771c76$export$4d3fb11e950abb9e())if ($d6ee65e080771c76$export$c0306caf338ac095 < 33) $d6ee65e080771c76$export$48cfd1e771a65c4f();
    else break;
    return $d6ee65e080771c76$export$9e1725a4cfeada27(type) > 2 || $d6ee65e080771c76$export$9e1725a4cfeada27($d6ee65e080771c76$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $d6ee65e080771c76$export$5f8c09e3ae6f64e1(children) {
    while($d6ee65e080771c76$export$48cfd1e771a65c4f())switch($d6ee65e080771c76$export$9e1725a4cfeada27($d6ee65e080771c76$export$c0306caf338ac095)){
        case 0:
            (0, $lq8nA.append)($d6ee65e080771c76$export$c2ab62c7bf24634($d6ee65e080771c76$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $lq8nA.append)($d6ee65e080771c76$export$410ac95b9ec204b8($d6ee65e080771c76$export$c0306caf338ac095), children);
            break;
        default:
            (0, $lq8nA.append)((0, $lq8nA.from)($d6ee65e080771c76$export$c0306caf338ac095), children);
    }
    return children;
}
function $d6ee65e080771c76$export$955ba06d119e085e(index, count) {
    while(--count && $d6ee65e080771c76$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($d6ee65e080771c76$export$c0306caf338ac095 < 48 || $d6ee65e080771c76$export$c0306caf338ac095 > 102 || $d6ee65e080771c76$export$c0306caf338ac095 > 57 && $d6ee65e080771c76$export$c0306caf338ac095 < 65 || $d6ee65e080771c76$export$c0306caf338ac095 > 70 && $d6ee65e080771c76$export$c0306caf338ac095 < 97) break;
    return $d6ee65e080771c76$export$58adb3bec8346d0f(index, $d6ee65e080771c76$export$e88cb2efb12ae807() + (count < 6 && $d6ee65e080771c76$export$4d3fb11e950abb9e() == 32 && $d6ee65e080771c76$export$48cfd1e771a65c4f() == 32));
}
function $d6ee65e080771c76$export$c889f2fcc19dbf12(type) {
    while($d6ee65e080771c76$export$48cfd1e771a65c4f())switch($d6ee65e080771c76$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $d6ee65e080771c76$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $d6ee65e080771c76$export$c889f2fcc19dbf12($d6ee65e080771c76$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $d6ee65e080771c76$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $d6ee65e080771c76$export$48cfd1e771a65c4f();
            break;
    }
    return $d6ee65e080771c76$export$5880b8b5730aff45;
}
function $d6ee65e080771c76$export$4254d4e2b3745c4c(type, index) {
    while($d6ee65e080771c76$export$48cfd1e771a65c4f())// //
    if (type + $d6ee65e080771c76$export$c0306caf338ac095 === 57) break;
    else if (type + $d6ee65e080771c76$export$c0306caf338ac095 === 84 && $d6ee65e080771c76$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $d6ee65e080771c76$export$58adb3bec8346d0f(index, $d6ee65e080771c76$export$5880b8b5730aff45 - 1) + '*' + (0, $lq8nA.from)(type === 47 ? type : $d6ee65e080771c76$export$48cfd1e771a65c4f());
}
function $d6ee65e080771c76$export$c2ab62c7bf24634(index) {
    while(!$d6ee65e080771c76$export$9e1725a4cfeada27($d6ee65e080771c76$export$4d3fb11e950abb9e()))$d6ee65e080771c76$export$48cfd1e771a65c4f();
    return $d6ee65e080771c76$export$58adb3bec8346d0f(index, $d6ee65e080771c76$export$5880b8b5730aff45);
}

});
parcelRegister("lq8nA", function(module, exports) {

$parcel$export(module.exports, "abs", () => $f98286a93dae12c3$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $f98286a93dae12c3$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $f98286a93dae12c3$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $f98286a93dae12c3$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $f98286a93dae12c3$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $f98286a93dae12c3$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $f98286a93dae12c3$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $f98286a93dae12c3$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $f98286a93dae12c3$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $f98286a93dae12c3$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $f98286a93dae12c3$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $f98286a93dae12c3$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $f98286a93dae12c3$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $f98286a93dae12c3$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $f98286a93dae12c3$export$2335f513bbd82c6d = Math.abs;
var $f98286a93dae12c3$export$6788812c4e6611e6 = String.fromCharCode;
var $f98286a93dae12c3$export$e6e34fd1f2686227 = Object.assign;
function $f98286a93dae12c3$export$d6af199866bfb566(value, length) {
    return $f98286a93dae12c3$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $f98286a93dae12c3$export$a9db5e087081082d(value, 0)) << 2 ^ $f98286a93dae12c3$export$a9db5e087081082d(value, 1)) << 2 ^ $f98286a93dae12c3$export$a9db5e087081082d(value, 2)) << 2 ^ $f98286a93dae12c3$export$a9db5e087081082d(value, 3) : 0;
}
function $f98286a93dae12c3$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $f98286a93dae12c3$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $f98286a93dae12c3$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $f98286a93dae12c3$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $f98286a93dae12c3$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $f98286a93dae12c3$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $f98286a93dae12c3$export$36776f635604f274(value) {
    return value.length;
}
function $f98286a93dae12c3$export$f9084667e487ed46(value) {
    return value.length;
}
function $f98286a93dae12c3$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $f98286a93dae12c3$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("cErpd", function(module, exports) {

$parcel$export(module.exports, "compile", () => $935e7aaccb868393$export$ef7acd7185315e22);

var $hbI1W = parcelRequire("hbI1W");

var $lq8nA = parcelRequire("lq8nA");

var $is4Ai = parcelRequire("is4Ai");
function $935e7aaccb868393$export$ef7acd7185315e22(value) {
    return (0, $is4Ai.dealloc)($935e7aaccb868393$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $is4Ai.alloc)(value), 0, [
        0
    ], value));
}
function $935e7aaccb868393$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $is4Ai.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $lq8nA.charat)(characters, length - 1) == 58) {
                if ((0, $lq8nA.indexof)(characters += (0, $lq8nA.replace)((0, $is4Ai.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $is4Ai.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $is4Ai.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $is4Ai.escaping)((0, $is4Ai.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $is4Ai.peek)()){
                case 42:
                case 47:
                    (0, $lq8nA.append)($935e7aaccb868393$export$4a34f930e789283c((0, $is4Ai.commenter)((0, $is4Ai.next)(), (0, $is4Ai.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $lq8nA.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $lq8nA.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $lq8nA.strlen)(characters) - length) (0, $lq8nA.append)(property > 32 ? $935e7aaccb868393$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $935e7aaccb868393$export$f8483753829ec8f3((0, $lq8nA.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $lq8nA.append)(reference = $935e7aaccb868393$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $935e7aaccb868393$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $lq8nA.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $935e7aaccb868393$export$98e6a39c04603d36(value, reference, reference, rule && (0, $lq8nA.append)($935e7aaccb868393$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $935e7aaccb868393$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $lq8nA.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $is4Ai.prev)() == 125) continue;
            }
            switch(characters += (0, $lq8nA.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $lq8nA.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $is4Ai.peek)() === 45) characters += (0, $is4Ai.delimit)((0, $is4Ai.next)());
                    atrule = (0, $is4Ai.peek)(), offset = length = (0, $lq8nA.strlen)(type = characters += (0, $is4Ai.identifier)((0, $is4Ai.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $lq8nA.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $935e7aaccb868393$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $lq8nA.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $lq8nA.substr)(value, post + 1, post = (0, $lq8nA.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $lq8nA.trim)(j > 0 ? rule[x] + ' ' + y : (0, $lq8nA.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $is4Ai.node)(value, root, parent, offset === 0 ? (0, $hbI1W.RULESET) : type, props, children, length);
}
function $935e7aaccb868393$export$4a34f930e789283c(value, root, parent) {
    return (0, $is4Ai.node)(value, root, parent, (0, $hbI1W.COMMENT), (0, $lq8nA.from)((0, $is4Ai.char)()), (0, $lq8nA.substr)(value, 2, -2), 0);
}
function $935e7aaccb868393$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $is4Ai.node)(value, root, parent, (0, $hbI1W.DECLARATION), (0, $lq8nA.substr)(value, 0, length), (0, $lq8nA.substr)(value, length + 1, -1), length);
}

});
parcelRegister("hbI1W", function(module, exports) {

$parcel$export(module.exports, "MS", () => $c8359e40837a4f4e$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $c8359e40837a4f4e$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $c8359e40837a4f4e$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $c8359e40837a4f4e$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $c8359e40837a4f4e$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $c8359e40837a4f4e$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $c8359e40837a4f4e$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $c8359e40837a4f4e$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $c8359e40837a4f4e$export$d773506282b3cfe6);
var $c8359e40837a4f4e$export$71ad59f2e432cfe8 = '-ms-';
var $c8359e40837a4f4e$export$2c0f367103c8d01c = '-moz-';
var $c8359e40837a4f4e$export$39dfd62a25e0fe93 = '-webkit-';
var $c8359e40837a4f4e$export$a29989082612d0d9 = 'comm';
var $c8359e40837a4f4e$export$aa3a2e812ca8570d = 'rule';
var $c8359e40837a4f4e$export$527d108ccf083c2b = 'decl';
var $c8359e40837a4f4e$export$d3d35020fa5b54f0 = '@page';
var $c8359e40837a4f4e$export$500415a86c544f73 = '@media';
var $c8359e40837a4f4e$export$a763edbf796b780a = '@import';
var $c8359e40837a4f4e$export$2790aeb8b4e5c826 = '@charset';
var $c8359e40837a4f4e$export$1cc683e23b84b133 = '@viewport';
var $c8359e40837a4f4e$export$9447a5efea57e862 = '@supports';
var $c8359e40837a4f4e$export$ef011b4e114b1fba = '@document';
var $c8359e40837a4f4e$export$6aad947bda0f3f46 = '@namespace';
var $c8359e40837a4f4e$export$b44a8529a35fcb60 = '@keyframes';
var $c8359e40837a4f4e$export$2c16de31893252e6 = '@font-face';
var $c8359e40837a4f4e$export$3d846dd52e150c6f = '@counter-style';
var $c8359e40837a4f4e$export$22314bfbb57653fe = '@font-feature-values';
var $c8359e40837a4f4e$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("2hxzb", function(module, exports) {

$parcel$export(module.exports, "middleware", () => $1a9734e344854e37$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $1a9734e344854e37$export$38bcb760f1d4871c);

var $hbI1W = parcelRequire("hbI1W");

var $lq8nA = parcelRequire("lq8nA");

var $is4Ai = parcelRequire("is4Ai");

var $dc1rY = parcelRequire("dc1rY");

var $8pwsA = parcelRequire("8pwsA");
function $1a9734e344854e37$export$5a7767152ae0305f(collection) {
    var length = (0, $lq8nA.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $1a9734e344854e37$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $1a9734e344854e37$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $hbI1W.DECLARATION:
                element.return = (0, $8pwsA.prefix)(element.value, element.length, children);
                return;
            case 0, $hbI1W.KEYFRAMES:
                return (0, $dc1rY.serialize)([
                    (0, $is4Ai.copy)(element, {
                        value: (0, $lq8nA.replace)(element.value, '@', '@' + (0, $hbI1W.WEBKIT))
                    })
                ], callback);
            case 0, $hbI1W.RULESET:
                if (element.length) return (0, $lq8nA.combine)(element.props, function(value) {
                    switch((0, $lq8nA.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $dc1rY.serialize)([
                                (0, $is4Ai.copy)(element, {
                                    props: [
                                        (0, $lq8nA.replace)(value, /:(read-\w+)/, ':' + (0, $hbI1W.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $dc1rY.serialize)([
                                (0, $is4Ai.copy)(element, {
                                    props: [
                                        (0, $lq8nA.replace)(value, /:(plac\w+)/, ':' + (0, $hbI1W.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $is4Ai.copy)(element, {
                                    props: [
                                        (0, $lq8nA.replace)(value, /:(plac\w+)/, ':' + (0, $hbI1W.MOZ) + '$1')
                                    ]
                                }),
                                (0, $is4Ai.copy)(element, {
                                    props: [
                                        (0, $lq8nA.replace)(value, /:(plac\w+)/, (0, $hbI1W.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $1a9734e344854e37$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $hbI1W.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $lq8nA.combine)((0, $is4Ai.tokenize)(value), function(value, index, children) {
                    switch((0, $lq8nA.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $lq8nA.substr)(value, 1, (0, $lq8nA.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $lq8nA.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $lq8nA.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $lq8nA.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("dc1rY", function(module, exports) {

$parcel$export(module.exports, "serialize", () => $99ad855990dcb797$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $99ad855990dcb797$export$fac44ee5b035f737);

var $hbI1W = parcelRequire("hbI1W");

var $lq8nA = parcelRequire("lq8nA");
function $99ad855990dcb797$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $lq8nA.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $99ad855990dcb797$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $hbI1W.LAYER:
            if (element.children.length) break;
        case 0, $hbI1W.IMPORT:
        case 0, $hbI1W.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $hbI1W.COMMENT:
            return '';
        case 0, $hbI1W.KEYFRAMES:
            return element.return = element.value + '{' + $99ad855990dcb797$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $hbI1W.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $lq8nA.strlen)(children = $99ad855990dcb797$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("8pwsA", function(module, exports) {

$parcel$export(module.exports, "prefix", () => $61f9d6722e5b993f$export$82e9f45cca5ba907);

var $hbI1W = parcelRequire("hbI1W");

var $lq8nA = parcelRequire("lq8nA");
function $61f9d6722e5b993f$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $lq8nA.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $hbI1W.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $hbI1W.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $hbI1W.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MOZ) + value + (0, $hbI1W.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $lq8nA.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + value + value;
        // order
        case 6165:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $hbI1W.WEBKIT) + value + (0, $lq8nA.replace)(value, /(\w+).+(:[^]+)/, (0, $hbI1W.WEBKIT) + 'box-$1$2' + (0, $hbI1W.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + 'flex-item-' + (0, $lq8nA.replace)(value, /flex-|-self/g, '') + (!(0, $lq8nA.match)(value, /flex-|baseline/) ? (0, $hbI1W.MS) + 'grid-row-' + (0, $lq8nA.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + 'flex-line-pack' + (0, $lq8nA.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $hbI1W.WEBKIT) + 'box-' + (0, $lq8nA.replace)(value, '-grow', '') + (0, $hbI1W.WEBKIT) + value + (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $hbI1W.WEBKIT) + (0, $lq8nA.replace)(value, /([^-])(transform)/g, '$1' + (0, $hbI1W.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $lq8nA.replace)((0, $lq8nA.replace)((0, $lq8nA.replace)(value, /(zoom-|grab)/, (0, $hbI1W.WEBKIT) + '$1'), /(image-set)/, (0, $hbI1W.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $lq8nA.replace)(value, /(image-set\([^]*)/, (0, $hbI1W.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $lq8nA.replace)((0, $lq8nA.replace)(value, /(.+:)(flex-)?(.*)/, (0, $hbI1W.WEBKIT) + 'box-pack:$3' + (0, $hbI1W.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $hbI1W.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $lq8nA.match)(value, /flex-|baseline/)) return (0, $hbI1W.MS) + 'grid-column-align' + (0, $lq8nA.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $lq8nA.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $lq8nA.indexof)(value + (children = children[length].value), 'span') ? value : (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, '-start', '') + value + (0, $hbI1W.MS) + 'grid-row-span:' + (~(0, $lq8nA.indexof)(children, 'span') ? (0, $lq8nA.match)(children, /\d+/) : +(0, $lq8nA.match)(children, /\d+/) - +(0, $lq8nA.match)(value, /\d+/)) + ';';
            return (0, $hbI1W.MS) + (0, $lq8nA.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $lq8nA.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $hbI1W.MS) + (0, $lq8nA.replace)((0, $lq8nA.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $lq8nA.replace)(value, /(.+)-inline(.+)/, (0, $hbI1W.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $lq8nA.strlen)(value) - 1 - length > 6) switch((0, $lq8nA.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $lq8nA.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $lq8nA.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $hbI1W.WEBKIT) + '$2-$3' + '$1' + (0, $hbI1W.MOZ) + ((0, $lq8nA.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $lq8nA.indexof)(value, 'stretch') ? $61f9d6722e5b993f$export$82e9f45cca5ba907((0, $lq8nA.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $lq8nA.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $hbI1W.MS) + a + ':' + b + f + (c ? (0, $hbI1W.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $lq8nA.charat)(value, length + 6) === 121) return (0, $lq8nA.replace)(value, ':', ':' + (0, $hbI1W.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $lq8nA.charat)(value, (0, $lq8nA.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $lq8nA.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $hbI1W.WEBKIT) + ((0, $lq8nA.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $hbI1W.WEBKIT) + '$2$3' + '$1' + (0, $hbI1W.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $lq8nA.replace)(value, ':', ':' + (0, $hbI1W.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $lq8nA.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("83kLZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5dceb7a01231679c$export$2e2bcd8739ae039);
var $5dceb7a01231679c$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("jeNL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e015ec02b8c36601$export$2e2bcd8739ae039);
function $e015ec02b8c36601$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("eR4tV", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad097dddec7c7edd$export$2e2bcd8739ae039);
function $ad097dddec7c7edd$export$2e2bcd8739ae039() {
    return $ad097dddec7c7edd$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ad097dddec7c7edd$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("ipyNH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6758e750e108ae9$export$2e2bcd8739ae039);

var $4Djfw = parcelRequire("4Djfw");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $d6758e750e108ae9$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4Djfw)))(targetComponent, sourceComponent);
};

});
parcelRegister("4Djfw", function(module, exports) {
'use strict';

var $9rjTY = parcelRequire("9rjTY");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $35f9bc7c0d546ba3$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $35f9bc7c0d546ba3$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $35f9bc7c0d546ba3$var$TYPE_STATICS = {};
$35f9bc7c0d546ba3$var$TYPE_STATICS[$9rjTY.ForwardRef] = $35f9bc7c0d546ba3$var$FORWARD_REF_STATICS;
$35f9bc7c0d546ba3$var$TYPE_STATICS[$9rjTY.Memo] = $35f9bc7c0d546ba3$var$MEMO_STATICS;
function $35f9bc7c0d546ba3$var$getStatics(component) {
    // React v16.11 and below
    if ($9rjTY.isMemo(component)) return $35f9bc7c0d546ba3$var$MEMO_STATICS;
     // React v16.12 and above
    return $35f9bc7c0d546ba3$var$TYPE_STATICS[component['$$typeof']] || $35f9bc7c0d546ba3$var$REACT_STATICS;
}
var $35f9bc7c0d546ba3$var$defineProperty = Object.defineProperty;
var $35f9bc7c0d546ba3$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $35f9bc7c0d546ba3$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $35f9bc7c0d546ba3$var$getPrototypeOf = Object.getPrototypeOf;
var $35f9bc7c0d546ba3$var$objectPrototype = Object.prototype;
function $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($35f9bc7c0d546ba3$var$objectPrototype) {
            var inheritedComponent = $35f9bc7c0d546ba3$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $35f9bc7c0d546ba3$var$objectPrototype) $35f9bc7c0d546ba3$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $35f9bc7c0d546ba3$var$getOwnPropertyNames(sourceComponent);
        if ($35f9bc7c0d546ba3$var$getOwnPropertySymbols) keys = keys.concat($35f9bc7c0d546ba3$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $35f9bc7c0d546ba3$var$getStatics(targetComponent);
        var sourceStatics = $35f9bc7c0d546ba3$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$35f9bc7c0d546ba3$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $35f9bc7c0d546ba3$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $35f9bc7c0d546ba3$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $35f9bc7c0d546ba3$var$hoistNonReactStatics;

});
parcelRegister("9rjTY", function(module, exports) {
'use strict';

module.exports = (parcelRequire("dhnve"));

});
parcelRegister("dhnve", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $9aaf1809a83fe6d0$export$2b8d127b894957b9, (v) => $9aaf1809a83fe6d0$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9aaf1809a83fe6d0$export$cea3a54a6425200c, (v) => $9aaf1809a83fe6d0$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9aaf1809a83fe6d0$export$a7c73072b1a182ae, (v) => $9aaf1809a83fe6d0$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9aaf1809a83fe6d0$export$9f27bc3417b4524d, (v) => $9aaf1809a83fe6d0$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac, (v) => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35, (v) => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9aaf1809a83fe6d0$export$ffb0004e005737fa, (v) => $9aaf1809a83fe6d0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9aaf1809a83fe6d0$export$b624eff549462981, (v) => $9aaf1809a83fe6d0$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9aaf1809a83fe6d0$export$7897aa7841a5380c, (v) => $9aaf1809a83fe6d0$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9aaf1809a83fe6d0$export$602eac185826482c, (v) => $9aaf1809a83fe6d0$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9aaf1809a83fe6d0$export$e2c29f18771995cb, (v) => $9aaf1809a83fe6d0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9aaf1809a83fe6d0$export$5f8d39834fd61797, (v) => $9aaf1809a83fe6d0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5, (v) => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9aaf1809a83fe6d0$export$92387174baf9b227, (v) => $9aaf1809a83fe6d0$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9aaf1809a83fe6d0$export$ec112efeb987d9c6, (v) => $9aaf1809a83fe6d0$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9aaf1809a83fe6d0$export$b706b080d889d2c9, (v) => $9aaf1809a83fe6d0$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9aaf1809a83fe6d0$export$5be5a87408f70ddc, (v) => $9aaf1809a83fe6d0$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d, (v) => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9aaf1809a83fe6d0$export$455c2e768291efa6, (v) => $9aaf1809a83fe6d0$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9aaf1809a83fe6d0$export$9522e17588c12572, (v) => $9aaf1809a83fe6d0$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9aaf1809a83fe6d0$export$2110ac352bb060b9, (v) => $9aaf1809a83fe6d0$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9aaf1809a83fe6d0$export$56885ab8b9c456ab, (v) => $9aaf1809a83fe6d0$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de, (v) => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9aaf1809a83fe6d0$export$b82d16f27459e05a, (v) => $9aaf1809a83fe6d0$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9aaf1809a83fe6d0$export$522c17b4f5e123e8, (v) => $9aaf1809a83fe6d0$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6, (v) => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9aaf1809a83fe6d0$export$9b621391a187a31a, (v) => $9aaf1809a83fe6d0$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f, (v) => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aaf1809a83fe6d0$export$2b8d127b894957b9;
var $9aaf1809a83fe6d0$export$cea3a54a6425200c;
var $9aaf1809a83fe6d0$export$a7c73072b1a182ae;
var $9aaf1809a83fe6d0$export$9f27bc3417b4524d;
var $9aaf1809a83fe6d0$export$db77ccec0bb4ccac;
var $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35;
var $9aaf1809a83fe6d0$export$ffb0004e005737fa;
var $9aaf1809a83fe6d0$export$b624eff549462981;
var $9aaf1809a83fe6d0$export$7897aa7841a5380c;
var $9aaf1809a83fe6d0$export$602eac185826482c;
var $9aaf1809a83fe6d0$export$e2c29f18771995cb;
var $9aaf1809a83fe6d0$export$5f8d39834fd61797;
var $9aaf1809a83fe6d0$export$74bf444e3cd11ea5;
var $9aaf1809a83fe6d0$export$92387174baf9b227;
var $9aaf1809a83fe6d0$export$ec112efeb987d9c6;
var $9aaf1809a83fe6d0$export$b706b080d889d2c9;
var $9aaf1809a83fe6d0$export$5be5a87408f70ddc;
var $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d;
var $9aaf1809a83fe6d0$export$455c2e768291efa6;
var $9aaf1809a83fe6d0$export$9522e17588c12572;
var $9aaf1809a83fe6d0$export$2110ac352bb060b9;
var $9aaf1809a83fe6d0$export$56885ab8b9c456ab;
var $9aaf1809a83fe6d0$export$d927fcb6adf8f9de;
var $9aaf1809a83fe6d0$export$b82d16f27459e05a;
var $9aaf1809a83fe6d0$export$522c17b4f5e123e8;
var $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6;
var $9aaf1809a83fe6d0$export$9b621391a187a31a;
var $9aaf1809a83fe6d0$export$f5bbd400c2f4426f;
'use strict';
var $9aaf1809a83fe6d0$var$b = "function" === typeof Symbol && Symbol.for, $9aaf1809a83fe6d0$var$c = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.element") : 60103, $9aaf1809a83fe6d0$var$d = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.portal") : 60106, $9aaf1809a83fe6d0$var$e = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fragment") : 60107, $9aaf1809a83fe6d0$var$f = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.strict_mode") : 60108, $9aaf1809a83fe6d0$var$g = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.profiler") : 60114, $9aaf1809a83fe6d0$var$h = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.provider") : 60109, $9aaf1809a83fe6d0$var$k = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.context") : 60110, $9aaf1809a83fe6d0$var$l = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.async_mode") : 60111, $9aaf1809a83fe6d0$var$m = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9aaf1809a83fe6d0$var$n = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.forward_ref") : 60112, $9aaf1809a83fe6d0$var$p = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense") : 60113, $9aaf1809a83fe6d0$var$q = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense_list") : 60120, $9aaf1809a83fe6d0$var$r = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.memo") : 60115, $9aaf1809a83fe6d0$var$t = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.lazy") : 60116, $9aaf1809a83fe6d0$var$v = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.block") : 60121, $9aaf1809a83fe6d0$var$w = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fundamental") : 60117, $9aaf1809a83fe6d0$var$x = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.responder") : 60118, $9aaf1809a83fe6d0$var$y = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.scope") : 60119;
function $9aaf1809a83fe6d0$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9aaf1809a83fe6d0$var$c:
                switch(a = a.type, a){
                    case $9aaf1809a83fe6d0$var$l:
                    case $9aaf1809a83fe6d0$var$m:
                    case $9aaf1809a83fe6d0$var$e:
                    case $9aaf1809a83fe6d0$var$g:
                    case $9aaf1809a83fe6d0$var$f:
                    case $9aaf1809a83fe6d0$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9aaf1809a83fe6d0$var$k:
                            case $9aaf1809a83fe6d0$var$n:
                            case $9aaf1809a83fe6d0$var$t:
                            case $9aaf1809a83fe6d0$var$r:
                            case $9aaf1809a83fe6d0$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9aaf1809a83fe6d0$var$d:
                return u;
        }
    }
}
function $9aaf1809a83fe6d0$var$A(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$m;
}
$9aaf1809a83fe6d0$export$2b8d127b894957b9 = $9aaf1809a83fe6d0$var$l;
$9aaf1809a83fe6d0$export$cea3a54a6425200c = $9aaf1809a83fe6d0$var$m;
$9aaf1809a83fe6d0$export$a7c73072b1a182ae = $9aaf1809a83fe6d0$var$k;
$9aaf1809a83fe6d0$export$9f27bc3417b4524d = $9aaf1809a83fe6d0$var$h;
$9aaf1809a83fe6d0$export$db77ccec0bb4ccac = $9aaf1809a83fe6d0$var$c;
$9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = $9aaf1809a83fe6d0$var$n;
$9aaf1809a83fe6d0$export$ffb0004e005737fa = $9aaf1809a83fe6d0$var$e;
$9aaf1809a83fe6d0$export$b624eff549462981 = $9aaf1809a83fe6d0$var$t;
$9aaf1809a83fe6d0$export$7897aa7841a5380c = $9aaf1809a83fe6d0$var$r;
$9aaf1809a83fe6d0$export$602eac185826482c = $9aaf1809a83fe6d0$var$d;
$9aaf1809a83fe6d0$export$e2c29f18771995cb = $9aaf1809a83fe6d0$var$g;
$9aaf1809a83fe6d0$export$5f8d39834fd61797 = $9aaf1809a83fe6d0$var$f;
$9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = $9aaf1809a83fe6d0$var$p;
$9aaf1809a83fe6d0$export$92387174baf9b227 = function(a) {
    return $9aaf1809a83fe6d0$var$A(a) || $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$l;
};
$9aaf1809a83fe6d0$export$ec112efeb987d9c6 = $9aaf1809a83fe6d0$var$A;
$9aaf1809a83fe6d0$export$b706b080d889d2c9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$k;
};
$9aaf1809a83fe6d0$export$5be5a87408f70ddc = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$h;
};
$9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9aaf1809a83fe6d0$var$c;
};
$9aaf1809a83fe6d0$export$455c2e768291efa6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$n;
};
$9aaf1809a83fe6d0$export$9522e17588c12572 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$e;
};
$9aaf1809a83fe6d0$export$2110ac352bb060b9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$t;
};
$9aaf1809a83fe6d0$export$56885ab8b9c456ab = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$r;
};
$9aaf1809a83fe6d0$export$d927fcb6adf8f9de = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$d;
};
$9aaf1809a83fe6d0$export$b82d16f27459e05a = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$g;
};
$9aaf1809a83fe6d0$export$522c17b4f5e123e8 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$f;
};
$9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$p;
};
$9aaf1809a83fe6d0$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9aaf1809a83fe6d0$var$e || a === $9aaf1809a83fe6d0$var$m || a === $9aaf1809a83fe6d0$var$g || a === $9aaf1809a83fe6d0$var$f || a === $9aaf1809a83fe6d0$var$p || a === $9aaf1809a83fe6d0$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9aaf1809a83fe6d0$var$t || a.$$typeof === $9aaf1809a83fe6d0$var$r || a.$$typeof === $9aaf1809a83fe6d0$var$h || a.$$typeof === $9aaf1809a83fe6d0$var$k || a.$$typeof === $9aaf1809a83fe6d0$var$n || a.$$typeof === $9aaf1809a83fe6d0$var$w || a.$$typeof === $9aaf1809a83fe6d0$var$x || a.$$typeof === $9aaf1809a83fe6d0$var$y || a.$$typeof === $9aaf1809a83fe6d0$var$v);
};
$9aaf1809a83fe6d0$export$f5bbd400c2f4426f = $9aaf1809a83fe6d0$var$z;

});




parcelRegister("7i4hv", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $54ed890c25e656bc$export$95d99596f328fd52);
$parcel$export(module.exports, "registerStyles", () => $54ed890c25e656bc$export$580009a5da2a8b4b);
$parcel$export(module.exports, "insertStyles", () => $54ed890c25e656bc$export$6f077d94b33a01aa);
var $54ed890c25e656bc$var$isBrowser = true;
function $54ed890c25e656bc$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $54ed890c25e656bc$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $54ed890c25e656bc$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $54ed890c25e656bc$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $54ed890c25e656bc$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("eC8G3", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $aa3b5868d1a715ff$export$6321afa313b251b5);

var $ayDaZ = parcelRequire("ayDaZ");

var $2TSYT = parcelRequire("2TSYT");

var $jeNL3 = parcelRequire("jeNL3");
var $aa3b5868d1a715ff$var$isDevelopment = false;
var $aa3b5868d1a715ff$var$hyphenateRegex = /[A-Z]|^ms/g;
var $aa3b5868d1a715ff$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $aa3b5868d1a715ff$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $aa3b5868d1a715ff$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $aa3b5868d1a715ff$var$processStyleName = /* #__PURE__ */ (0, $jeNL3.default)(function(styleName) {
    return $aa3b5868d1a715ff$var$isCustomProperty(styleName) ? styleName : styleName.replace($aa3b5868d1a715ff$var$hyphenateRegex, '-$&').toLowerCase();
});
var $aa3b5868d1a715ff$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($aa3b5868d1a715ff$var$animationRegex, function(match, p1, p2) {
                $aa3b5868d1a715ff$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $aa3b5868d1a715ff$var$cursor
                };
                return p1;
            });
    }
    if ((0, $2TSYT.default)[key] !== 1 && !$aa3b5868d1a715ff$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $aa3b5868d1a715ff$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $aa3b5868d1a715ff$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $aa3b5868d1a715ff$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $aa3b5868d1a715ff$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $aa3b5868d1a715ff$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $aa3b5868d1a715ff$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $aa3b5868d1a715ff$var$cursor;
                var result = interpolation(mergedProps);
                $aa3b5868d1a715ff$var$cursor = previousCursor;
                return $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $aa3b5868d1a715ff$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($aa3b5868d1a715ff$var$isProcessableValue(asString)) string += $aa3b5868d1a715ff$var$processStyleName(key) + ":" + $aa3b5868d1a715ff$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $aa3b5868d1a715ff$var$isDevelopment) throw new Error($aa3b5868d1a715ff$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($aa3b5868d1a715ff$var$isProcessableValue(value[_i])) string += $aa3b5868d1a715ff$var$processStyleName(key) + ":" + $aa3b5868d1a715ff$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $aa3b5868d1a715ff$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $aa3b5868d1a715ff$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $aa3b5868d1a715ff$var$cursor;
function $aa3b5868d1a715ff$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $aa3b5868d1a715ff$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $aa3b5868d1a715ff$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $aa3b5868d1a715ff$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $aa3b5868d1a715ff$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $ayDaZ.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $aa3b5868d1a715ff$var$cursor
    };
}

});
parcelRegister("ayDaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7afb77f31dbef2ab$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7afb77f31dbef2ab$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("2TSYT", function(module, exports) {

$parcel$export(module.exports, "default", () => $21cb5de91d0b0040$export$2e2bcd8739ae039);
var $21cb5de91d0b0040$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("a7NNJ", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $75f1304bf12ff9b8$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $75f1304bf12ff9b8$export$811a713a7276cb9d);

var $jXEQt = parcelRequire("jXEQt");
var $75f1304bf12ff9b8$var$syncFallback = function syncFallback(create) {
    return create();
};
var $75f1304bf12ff9b8$var$useInsertionEffect = $jXEQt.useInsertionEffect ? $jXEQt.useInsertionEffect : false;
var $75f1304bf12ff9b8$export$db21c7ffa21794e7 = $75f1304bf12ff9b8$var$useInsertionEffect || $75f1304bf12ff9b8$var$syncFallback;
var $75f1304bf12ff9b8$export$811a713a7276cb9d = $75f1304bf12ff9b8$var$useInsertionEffect || $jXEQt.useLayoutEffect;

});





parcelRegister("5Gz5b", function(module, exports) {

$parcel$export(module.exports, "default", () => $423c16aec243af8b$export$2e2bcd8739ae039);

var $8sdmv = parcelRequire("8sdmv");
'use client';
const $423c16aec243af8b$var$defaultTheme = (0, $8sdmv.default)();
var $423c16aec243af8b$export$2e2bcd8739ae039 = $423c16aec243af8b$var$defaultTheme;

});
parcelRegister("8sdmv", function(module, exports) {

$parcel$export(module.exports, "default", () => $627b4dad19c9c07d$export$2e2bcd8739ae039);

var $3pOT6 = parcelRequire("3pOT6");

var $9Ohob = parcelRequire("9Ohob");

var $4i2qV = parcelRequire("4i2qV");
// eslint-disable-next-line consistent-return
function $627b4dad19c9c07d$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $3pOT6.default)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $627b4dad19c9c07d$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $4i2qV.default)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $4i2qV.default)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $627b4dad19c9c07d$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $627b4dad19c9c07d$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $9Ohob.default)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}

});
parcelRegister("3pOT6", function(module, exports) {

$parcel$export(module.exports, "light", () => $27cb2e29f3cf749b$export$a43af521ac8c3202);
$parcel$export(module.exports, "dark", () => $27cb2e29f3cf749b$export$55ce6f3a06c59543);
$parcel$export(module.exports, "default", () => $27cb2e29f3cf749b$export$2e2bcd8739ae039);

var $fskif = parcelRequire("fskif");

var $cqtAx = parcelRequire("cqtAx");

var $h5VeH = parcelRequire("h5VeH");

var $8Djk6 = parcelRequire("8Djk6");

var $2aRlY = parcelRequire("2aRlY");

var $aPJII = parcelRequire("aPJII");

var $7pyVc = parcelRequire("7pyVc");

var $kI0UY = parcelRequire("kI0UY");

var $fUkwd = parcelRequire("fUkwd");

var $hXBzO = parcelRequire("hXBzO");

var $92pt9 = parcelRequire("92pt9");
function $27cb2e29f3cf749b$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $8Djk6.default).white,
            default: (0, $8Djk6.default).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $27cb2e29f3cf749b$export$a43af521ac8c3202 = $27cb2e29f3cf749b$var$getLight();
function $27cb2e29f3cf749b$var$getDark() {
    return {
        text: {
            primary: (0, $8Djk6.default).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $8Djk6.default).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $27cb2e29f3cf749b$export$55ce6f3a06c59543 = $27cb2e29f3cf749b$var$getDark();
function $27cb2e29f3cf749b$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $h5VeH.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $h5VeH.darken)(intent.main, tonalOffsetDark);
    }
}
function $27cb2e29f3cf749b$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $27cb2e29f3cf749b$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $fUkwd.default)[200],
        light: (0, $fUkwd.default)[50],
        dark: (0, $fUkwd.default)[400]
    };
    return {
        main: (0, $fUkwd.default)[700],
        light: (0, $fUkwd.default)[400],
        dark: (0, $fUkwd.default)[800]
    };
}
function $27cb2e29f3cf749b$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $aPJII.default)[200],
        light: (0, $aPJII.default)[50],
        dark: (0, $aPJII.default)[400]
    };
    return {
        main: (0, $aPJII.default)[500],
        light: (0, $aPJII.default)[300],
        dark: (0, $aPJII.default)[700]
    };
}
function $27cb2e29f3cf749b$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $7pyVc.default)[500],
        light: (0, $7pyVc.default)[300],
        dark: (0, $7pyVc.default)[700]
    };
    return {
        main: (0, $7pyVc.default)[700],
        light: (0, $7pyVc.default)[400],
        dark: (0, $7pyVc.default)[800]
    };
}
function $27cb2e29f3cf749b$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $hXBzO.default)[400],
        light: (0, $hXBzO.default)[300],
        dark: (0, $hXBzO.default)[700]
    };
    return {
        main: (0, $hXBzO.default)[700],
        light: (0, $hXBzO.default)[500],
        dark: (0, $hXBzO.default)[900]
    };
}
function $27cb2e29f3cf749b$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $92pt9.default)[400],
        light: (0, $92pt9.default)[300],
        dark: (0, $92pt9.default)[700]
    };
    return {
        main: (0, $92pt9.default)[800],
        light: (0, $92pt9.default)[500],
        dark: (0, $92pt9.default)[900]
    };
}
function $27cb2e29f3cf749b$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $kI0UY.default)[400],
        light: (0, $kI0UY.default)[300],
        dark: (0, $kI0UY.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $kI0UY.default)[500],
        dark: (0, $kI0UY.default)[900]
    };
}
function $27cb2e29f3cf749b$export$b6e2ca4581a735cb(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $27cb2e29f3cf749b$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $27cb2e29f3cf749b$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $27cb2e29f3cf749b$var$getDefaultSecondary(mode);
    const error = palette.error || $27cb2e29f3cf749b$var$getDefaultError(mode);
    const info = palette.info || $27cb2e29f3cf749b$var$getDefaultInfo(mode);
    const success = palette.success || $27cb2e29f3cf749b$var$getDefaultSuccess(mode);
    const warning = palette.warning || $27cb2e29f3cf749b$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $27cb2e29f3cf749b$export$b6e2ca4581a735cb(background);
        const contrastText = (0, $h5VeH.getContrastRatio)(background, $27cb2e29f3cf749b$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $27cb2e29f3cf749b$export$55ce6f3a06c59543.text.primary : $27cb2e29f3cf749b$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $fskif.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $fskif.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $27cb2e29f3cf749b$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $27cb2e29f3cf749b$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $27cb2e29f3cf749b$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $27cb2e29f3cf749b$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $27cb2e29f3cf749b$var$getLight();
    else if (mode === 'dark') modeHydrated = $27cb2e29f3cf749b$var$getDark();
    const paletteOutput = (0, $cqtAx.default)({
        // A collection of common colors.
        common: {
            ...(0, $8Djk6.default)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $2aRlY.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}

});
parcelRegister("h5VeH", function(module, exports) {

$parcel$export(module.exports, "private_safeColorChannel", () => $c71f4d2cbc182383$export$427365fc3db6fc5e);
$parcel$export(module.exports, "hslToRgb", () => $c71f4d2cbc182383$export$29fb7152bd3f781a);
$parcel$export(module.exports, "getContrastRatio", () => $c71f4d2cbc182383$export$d061e26956a60b0a);
$parcel$export(module.exports, "alpha", () => $c71f4d2cbc182383$export$58f0f39f63f3cf42);
$parcel$export(module.exports, "private_safeAlpha", () => $c71f4d2cbc182383$export$34109543fc7f43f8);
$parcel$export(module.exports, "darken", () => $c71f4d2cbc182383$export$4b073707ff63303);
$parcel$export(module.exports, "private_safeDarken", () => $c71f4d2cbc182383$export$eaaef2dca3e9e512);
$parcel$export(module.exports, "lighten", () => $c71f4d2cbc182383$export$c0816ed86df316af);
$parcel$export(module.exports, "private_safeLighten", () => $c71f4d2cbc182383$export$aeeda94ef1d01275);
$parcel$export(module.exports, "private_safeEmphasize", () => $c71f4d2cbc182383$export$11bb74ba10c85505);

var $fskif = parcelRequire("fskif");

var $4JXXc = parcelRequire("4JXXc");
/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $c71f4d2cbc182383$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $4JXXc.default)(value, min, max);
}
function $c71f4d2cbc182383$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $c71f4d2cbc182383$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $c71f4d2cbc182383$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $c71f4d2cbc182383$export$677b39864803984e($c71f4d2cbc182383$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $fskif.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $fskif.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $c71f4d2cbc182383$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $c71f4d2cbc182383$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $c71f4d2cbc182383$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $c71f4d2cbc182383$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $c71f4d2cbc182383$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $c71f4d2cbc182383$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $c71f4d2cbc182383$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$c71f4d2cbc182383$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $c71f4d2cbc182383$export$29fb7152bd3f781a(color) {
    color = $c71f4d2cbc182383$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $c71f4d2cbc182383$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $c71f4d2cbc182383$export$c852d90bf7403b62(color) {
    color = $c71f4d2cbc182383$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $c71f4d2cbc182383$export$677b39864803984e($c71f4d2cbc182383$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $c71f4d2cbc182383$export$d061e26956a60b0a(foreground, background) {
    const lumA = $c71f4d2cbc182383$export$c852d90bf7403b62(foreground);
    const lumB = $c71f4d2cbc182383$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $c71f4d2cbc182383$export$58f0f39f63f3cf42(color, value) {
    color = $c71f4d2cbc182383$export$677b39864803984e(color);
    value = $c71f4d2cbc182383$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $c71f4d2cbc182383$export$211a73f2b8c10ce4(color);
}
function $c71f4d2cbc182383$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $c71f4d2cbc182383$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $c71f4d2cbc182383$export$4b073707ff63303(color, coefficient) {
    color = $c71f4d2cbc182383$export$677b39864803984e(color);
    coefficient = $c71f4d2cbc182383$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $c71f4d2cbc182383$export$211a73f2b8c10ce4(color);
}
function $c71f4d2cbc182383$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $c71f4d2cbc182383$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $c71f4d2cbc182383$export$c0816ed86df316af(color, coefficient) {
    color = $c71f4d2cbc182383$export$677b39864803984e(color);
    coefficient = $c71f4d2cbc182383$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $c71f4d2cbc182383$export$211a73f2b8c10ce4(color);
}
function $c71f4d2cbc182383$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $c71f4d2cbc182383$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $c71f4d2cbc182383$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $c71f4d2cbc182383$export$c852d90bf7403b62(color) > 0.5 ? $c71f4d2cbc182383$export$4b073707ff63303(color, coefficient) : $c71f4d2cbc182383$export$c0816ed86df316af(color, coefficient);
}
function $c71f4d2cbc182383$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $c71f4d2cbc182383$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $c71f4d2cbc182383$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $c71f4d2cbc182383$export$677b39864803984e(background);
    const overlayColor = $c71f4d2cbc182383$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $c71f4d2cbc182383$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}

});
parcelRegister("4JXXc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3739df00101327f5$export$2e2bcd8739ae039);
function $3739df00101327f5$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $3739df00101327f5$export$2e2bcd8739ae039 = $3739df00101327f5$var$clamp;

});


parcelRegister("8Djk6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6490f47355e4f6b4$export$2e2bcd8739ae039);
const $6490f47355e4f6b4$var$common = {
    black: '#000',
    white: '#fff'
};
var $6490f47355e4f6b4$export$2e2bcd8739ae039 = $6490f47355e4f6b4$var$common;

});

parcelRegister("2aRlY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1955e6cd65cf84ad$export$2e2bcd8739ae039);
const $1955e6cd65cf84ad$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $1955e6cd65cf84ad$export$2e2bcd8739ae039 = $1955e6cd65cf84ad$var$grey;

});

parcelRegister("aPJII", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e3221e29788cb69$export$2e2bcd8739ae039);
const $7e3221e29788cb69$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $7e3221e29788cb69$export$2e2bcd8739ae039 = $7e3221e29788cb69$var$purple;

});

parcelRegister("7pyVc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5655f4e2b3104c46$export$2e2bcd8739ae039);
const $5655f4e2b3104c46$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $5655f4e2b3104c46$export$2e2bcd8739ae039 = $5655f4e2b3104c46$var$red;

});

parcelRegister("kI0UY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f138a0fa8c023cbf$export$2e2bcd8739ae039);
const $f138a0fa8c023cbf$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $f138a0fa8c023cbf$export$2e2bcd8739ae039 = $f138a0fa8c023cbf$var$orange;

});

parcelRegister("fUkwd", function(module, exports) {

$parcel$export(module.exports, "default", () => $b94c008d11963a92$export$2e2bcd8739ae039);
const $b94c008d11963a92$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $b94c008d11963a92$export$2e2bcd8739ae039 = $b94c008d11963a92$var$blue;

});

parcelRegister("hXBzO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d13518497f20993c$export$2e2bcd8739ae039);
const $d13518497f20993c$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $d13518497f20993c$export$2e2bcd8739ae039 = $d13518497f20993c$var$lightBlue;

});

parcelRegister("92pt9", function(module, exports) {

$parcel$export(module.exports, "default", () => $69480e96ff0c340f$export$2e2bcd8739ae039);
const $69480e96ff0c340f$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $69480e96ff0c340f$export$2e2bcd8739ae039 = $69480e96ff0c340f$var$green;

});


parcelRegister("9Ohob", function(module, exports) {

$parcel$export(module.exports, "default", () => $724645ae2fd6ce65$export$2e2bcd8739ae039);

var $fskif = parcelRequire("fskif");

var $cqtAx = parcelRequire("cqtAx");

var $9nluD = parcelRequire("9nluD");
var $24XaJ = parcelRequire("24XaJ");

var $l4VbN = parcelRequire("l4VbN");

var $3F1LP = parcelRequire("3F1LP");
var $ceM40 = parcelRequire("ceM40");
var $1v2Kv = parcelRequire("1v2Kv");

var $iBnPH = parcelRequire("iBnPH");
var $esenk = parcelRequire("esenk");

var $h5VeH = parcelRequire("h5VeH");

var $4i2qV = parcelRequire("4i2qV");

var $juJpa = parcelRequire("juJpa");

var $bizlR = parcelRequire("bizlR");

var $9NfW4 = parcelRequire("9NfW4");

var $bsaPk = parcelRequire("bsaPk");

var $3pOT6 = parcelRequire("3pOT6");
function $724645ae2fd6ce65$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $724645ae2fd6ce65$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $724645ae2fd6ce65$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $h5VeH.hslToRgb)(color);
}
function $724645ae2fd6ce65$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $h5VeH.private_safeColorChannel)($724645ae2fd6ce65$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $724645ae2fd6ce65$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $724645ae2fd6ce65$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $724645ae2fd6ce65$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $24XaJ.default)(cssVarPrefix);
function $724645ae2fd6ce65$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $juJpa.default)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $4i2qV.default)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $juJpa.getOpacity)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $juJpa.getOverlays)(mode)
    };
    return muiTheme;
}
function $724645ae2fd6ce65$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $bizlR.default), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $724645ae2fd6ce65$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $fskif.default)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $724645ae2fd6ce65$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $724645ae2fd6ce65$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $724645ae2fd6ce65$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $1v2Kv.default)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $724645ae2fd6ce65$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $724645ae2fd6ce65$var$setColor(palette.common, 'background', '#fff');
            $724645ae2fd6ce65$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $724645ae2fd6ce65$var$setColor(palette.common, 'background', '#000');
            $724645ae2fd6ce65$var$setColor(palette.common, 'onBackground', '#fff');
        }
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === (0, $h5VeH.private_safeAlpha)) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === (0, $h5VeH.private_safeDarken)) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === (0, $h5VeH.private_safeLighten)) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $724645ae2fd6ce65$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'errorColor', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'infoColor', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'successColor', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'warningColor', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'errorFilledColor', $724645ae2fd6ce65$var$silent(()=>palette.getContrastText(palette.error.main)));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'infoFilledColor', $724645ae2fd6ce65$var$silent(()=>palette.getContrastText(palette.info.main)));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'successFilledColor', $724645ae2fd6ce65$var$silent(()=>palette.getContrastText(palette.success.main)));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'warningFilledColor', $724645ae2fd6ce65$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $724645ae2fd6ce65$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $724645ae2fd6ce65$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $724645ae2fd6ce65$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $724645ae2fd6ce65$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $724645ae2fd6ce65$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $724645ae2fd6ce65$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $724645ae2fd6ce65$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $724645ae2fd6ce65$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $724645ae2fd6ce65$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $724645ae2fd6ce65$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $h5VeH.private_safeAlpha), nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'successTrack', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $h5VeH.private_safeEmphasize)(palette.background.default, 0.8);
            $724645ae2fd6ce65$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $724645ae2fd6ce65$var$setColor(palette.SnackbarContent, 'color', $724645ae2fd6ce65$var$silent(()=>colorSpace ? (0, $3pOT6.dark).text.primary : palette.getContrastText(snackbarContentBackground)));
            $724645ae2fd6ce65$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h5VeH.private_safeEmphasize)(palette.background.paper, 0.15));
            $724645ae2fd6ce65$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $724645ae2fd6ce65$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.62));
            $724645ae2fd6ce65$var$setColor(palette.TableCell, 'border', colorMix((0, $h5VeH.private_safeLighten), (0, $h5VeH.private_safeAlpha)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.88));
            $724645ae2fd6ce65$var$setColor(palette.Tooltip, 'bg', colorMix((0, $h5VeH.private_safeAlpha), nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'errorColor', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.6));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'infoColor', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.6));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'successColor', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.6));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'warningColor', colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.6));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'errorFilledColor', $724645ae2fd6ce65$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'infoFilledColor', $724645ae2fd6ce65$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'successFilledColor', $724645ae2fd6ce65$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'warningFilledColor', $724645ae2fd6ce65$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-error-light') : palette.error.light, 0.9));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-info-light') : palette.info.light, 0.9));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-success-light') : palette.success.light, 0.9));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-warning-light') : palette.warning.light, 0.9));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $724645ae2fd6ce65$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $724645ae2fd6ce65$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $724645ae2fd6ce65$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $724645ae2fd6ce65$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $724645ae2fd6ce65$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $724645ae2fd6ce65$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $724645ae2fd6ce65$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $724645ae2fd6ce65$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $724645ae2fd6ce65$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $724645ae2fd6ce65$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $724645ae2fd6ce65$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $724645ae2fd6ce65$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $724645ae2fd6ce65$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-warning-main') : palette.warning.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $h5VeH.private_safeAlpha), nativeColor ? getCssVar('palette-text-primary') : palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'successTrack', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.5));
            $724645ae2fd6ce65$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix((0, $h5VeH.private_safeLighten), nativeColor ? getCssVar('palette-background-default') : palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $h5VeH.private_safeEmphasize)(palette.background.default, 0.98);
            $724645ae2fd6ce65$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $724645ae2fd6ce65$var$setColor(palette.SnackbarContent, 'color', $724645ae2fd6ce65$var$silent(()=>colorSpace ? (0, $3pOT6.light).text.primary : palette.getContrastText(snackbarContentBackground)));
            $724645ae2fd6ce65$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $h5VeH.private_safeEmphasize)(palette.background.paper, 0.15));
            $724645ae2fd6ce65$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $724645ae2fd6ce65$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-primary-main') : palette.primary.main, 0.55));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-secondary-main') : palette.secondary.main, 0.55));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-error-main') : palette.error.main, 0.55));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-info-main') : palette.info.main, 0.55));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-success-main') : palette.success.main, 0.55));
            $724645ae2fd6ce65$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $h5VeH.private_safeDarken), nativeColor ? getCssVar('palette-warning-light') : palette.warning.main, 0.55));
            $724645ae2fd6ce65$var$setColor(palette.TableCell, 'border', colorMix((0, $h5VeH.private_safeDarken), (0, $h5VeH.private_safeAlpha)(nativeColor ? getCssVar('palette-divider') : palette.divider, 1), 0.68));
            $724645ae2fd6ce65$var$setColor(palette.Tooltip, 'bg', colorMix((0, $h5VeH.private_safeAlpha), nativeColor ? getCssVar('palette-grey-700') : palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $724645ae2fd6ce65$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $724645ae2fd6ce65$var$setColorChannel(palette.background, 'paper');
        $724645ae2fd6ce65$var$setColorChannel(palette.common, 'background');
        $724645ae2fd6ce65$var$setColorChannel(palette.common, 'onBackground');
        $724645ae2fd6ce65$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $724645ae2fd6ce65$var$setColor(palette[color], 'mainChannel', (0, $h5VeH.private_safeColorChannel)($724645ae2fd6ce65$var$toRgb(colors.main)));
                if (colors.light) $724645ae2fd6ce65$var$setColor(palette[color], 'lightChannel', (0, $h5VeH.private_safeColorChannel)($724645ae2fd6ce65$var$toRgb(colors.light)));
                if (colors.dark) $724645ae2fd6ce65$var$setColor(palette[color], 'darkChannel', (0, $h5VeH.private_safeColorChannel)($724645ae2fd6ce65$var$toRgb(colors.dark)));
                if (colors.contrastText) $724645ae2fd6ce65$var$setColor(palette[color], 'contrastTextChannel', (0, $h5VeH.private_safeColorChannel)($724645ae2fd6ce65$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $724645ae2fd6ce65$var$setColorChannel(palette[color], 'primary');
                    $724645ae2fd6ce65$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $724645ae2fd6ce65$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $724645ae2fd6ce65$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $cqtAx.default)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $9NfW4.default)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $ceM40.default)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $9nluD.default)(input.spacing, (0, $l4VbN.createUnarySpacing)(this));
    };
    theme.getColorSchemeSelector = (0, $3F1LP.createGetColorSchemeSelector)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $esenk.default),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $iBnPH.default)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $bsaPk.stringifyTheme); // for Pigment CSS integration
    return theme;
}

});
parcelRegister("24XaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1839dad120eb03d8$export$2e2bcd8739ae039);
/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $1839dad120eb03d8$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}

});

parcelRegister("3F1LP", function(module, exports) {

$parcel$export(module.exports, "createGetColorSchemeSelector", () => $2aa693040d0d8413$export$858538ff6c0d421d);
/* eslint-disable import/prefer-default-export */ function $2aa693040d0d8413$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}

});

parcelRegister("ceM40", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8c13489650d83a$export$2e2bcd8739ae039);

var $cqtAx = parcelRequire("cqtAx");

var $6ZSQ2 = parcelRequire("6ZSQ2");
function $8e8c13489650d83a$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $6ZSQ2.default)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $6ZSQ2.default)(scheme, parserConfig);
        themeVars = (0, $cqtAx.default)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $6ZSQ2.default)(defaultScheme, parserConfig);
        themeVars = (0, $cqtAx.default)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $cqtAx.default)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $8e8c13489650d83a$export$2e2bcd8739ae039 = $8e8c13489650d83a$var$prepareCssVars;

});
parcelRegister("6ZSQ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $5182fa540d92d503$export$2e2bcd8739ae039);
/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $5182fa540d92d503$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $5182fa540d92d503$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $5182fa540d92d503$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $5182fa540d92d503$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $5182fa540d92d503$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $5182fa540d92d503$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $5182fa540d92d503$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $5182fa540d92d503$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}

});


parcelRegister("1v2Kv", function(module, exports) {

$parcel$export(module.exports, "default", () => $117ad1a206e6e085$export$2e2bcd8739ae039);
function $117ad1a206e6e085$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}

});

parcelRegister("4i2qV", function(module, exports) {

$parcel$export(module.exports, "default", () => $31fabb15253947f5$export$2e2bcd8739ae039);

var $fskif = parcelRequire("fskif");

var $cqtAx = parcelRequire("cqtAx");

var $iBnPH = parcelRequire("iBnPH");
var $esenk = parcelRequire("esenk");

var $jECx5 = parcelRequire("jECx5");

var $h5VeH = parcelRequire("h5VeH");


var $6b7FX = parcelRequire("6b7FX");

var $3pOT6 = parcelRequire("3pOT6");

var $bzMhy = parcelRequire("bzMhy");

var $5LPiZ = parcelRequire("5LPiZ");

var $iC6NG = parcelRequire("iC6NG");

var $2a1hu = parcelRequire("2a1hu");

var $bsaPk = parcelRequire("bsaPk");
function $31fabb15253947f5$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $31fabb15253947f5$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
function $31fabb15253947f5$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) // To preserve the behavior of the CSS theme variables
            // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
            return `rgba(${color.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, 'var(--$1Channel)')} / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            return (0, $h5VeH.alpha)(color, $31fabb15253947f5$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$31fabb15253947f5$var$coefficientToPercentage(coefficient)})`;
            return (0, $h5VeH.lighten)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$31fabb15253947f5$var$coefficientToPercentage(coefficient)})`;
            return (0, $h5VeH.darken)(color, coefficient);
        }
    });
}
function $31fabb15253947f5$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $fskif.default)(20));
    const palette = (0, $3pOT6.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $jECx5.default)(options);
    let muiTheme = (0, $cqtAx.default)(systemTheme, {
        mixins: (0, $6b7FX.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $5LPiZ.default).slice(),
        typography: (0, $bzMhy.default)(palette, typographyInput),
        transitions: (0, $iC6NG.default)(transitionsInput),
        zIndex: {
            ...(0, $2a1hu.default)
        }
    });
    muiTheme = (0, $cqtAx.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $cqtAx.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $esenk.default),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $iBnPH.default)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $bsaPk.stringifyTheme); // for Pigment CSS integration
    $31fabb15253947f5$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $31fabb15253947f5$export$2e2bcd8739ae039 = $31fabb15253947f5$var$createThemeNoVars;

});
parcelRegister("6b7FX", function(module, exports) {

$parcel$export(module.exports, "default", () => $47f9b966c258e2f6$export$2e2bcd8739ae039);
function $47f9b966c258e2f6$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}

});

parcelRegister("bzMhy", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d86a67c0f66fd3$export$2e2bcd8739ae039);

var $cqtAx = parcelRequire("cqtAx");
function $86d86a67c0f66fd3$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $86d86a67c0f66fd3$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $86d86a67c0f66fd3$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $86d86a67c0f66fd3$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $86d86a67c0f66fd3$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $86d86a67c0f66fd3$var$defaultFontFamily ? {
                letterSpacing: `${$86d86a67c0f66fd3$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $86d86a67c0f66fd3$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $86d86a67c0f66fd3$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $cqtAx.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("5LPiZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $433923b64f2c2e4e$export$2e2bcd8739ae039);
const $433923b64f2c2e4e$var$shadowKeyUmbraOpacity = 0.2;
const $433923b64f2c2e4e$var$shadowKeyPenumbraOpacity = 0.14;
const $433923b64f2c2e4e$var$shadowAmbientShadowOpacity = 0.12;
function $433923b64f2c2e4e$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$433923b64f2c2e4e$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$433923b64f2c2e4e$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$433923b64f2c2e4e$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $433923b64f2c2e4e$var$shadows = [
    'none',
    $433923b64f2c2e4e$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $433923b64f2c2e4e$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $433923b64f2c2e4e$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $433923b64f2c2e4e$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $433923b64f2c2e4e$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $433923b64f2c2e4e$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $433923b64f2c2e4e$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $433923b64f2c2e4e$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $433923b64f2c2e4e$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $433923b64f2c2e4e$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $433923b64f2c2e4e$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $433923b64f2c2e4e$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $433923b64f2c2e4e$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $433923b64f2c2e4e$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $433923b64f2c2e4e$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $433923b64f2c2e4e$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $433923b64f2c2e4e$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $433923b64f2c2e4e$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $433923b64f2c2e4e$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $433923b64f2c2e4e$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $433923b64f2c2e4e$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $433923b64f2c2e4e$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $433923b64f2c2e4e$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $433923b64f2c2e4e$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $433923b64f2c2e4e$export$2e2bcd8739ae039 = $433923b64f2c2e4e$var$shadows;

});

parcelRegister("iC6NG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8d10cfe71d3a375$export$2e2bcd8739ae039);
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $d8d10cfe71d3a375$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $d8d10cfe71d3a375$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $d8d10cfe71d3a375$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $d8d10cfe71d3a375$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $d8d10cfe71d3a375$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$d8d10cfe71d3a375$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$d8d10cfe71d3a375$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $d8d10cfe71d3a375$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $d8d10cfe71d3a375$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $d8d10cfe71d3a375$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}

});

parcelRegister("2a1hu", function(module, exports) {

$parcel$export(module.exports, "default", () => $192d8254a7577de5$export$2e2bcd8739ae039);
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $192d8254a7577de5$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $192d8254a7577de5$export$2e2bcd8739ae039 = $192d8254a7577de5$var$zIndex;

});

parcelRegister("bsaPk", function(module, exports) {

$parcel$export(module.exports, "stringifyTheme", () => $856ab5344bd87eb5$export$32c2afa5f91892aa);
/* eslint-disable import/prefer-default-export */ 
var $cqtAx = parcelRequire("cqtAx");
function $856ab5344bd87eb5$var$isSerializable(val) {
    return (0, $cqtAx.isPlainObject)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $856ab5344bd87eb5$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$856ab5344bd87eb5$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $cqtAx.isPlainObject)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}

});


parcelRegister("juJpa", function(module, exports) {

$parcel$export(module.exports, "getOpacity", () => $e3140a272686349b$export$c85e0347fceb69ba);
$parcel$export(module.exports, "getOverlays", () => $e3140a272686349b$export$dd191566510330d3);
$parcel$export(module.exports, "default", () => $e3140a272686349b$export$2e2bcd8739ae039);

var $3pOT6 = parcelRequire("3pOT6");

var $bdgU1 = parcelRequire("bdgU1");
const $e3140a272686349b$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $bdgU1.default)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $e3140a272686349b$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $e3140a272686349b$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $e3140a272686349b$var$defaultDarkOverlays : [];
}
function $e3140a272686349b$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $3pOT6.default)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$e3140a272686349b$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $e3140a272686349b$export$dd191566510330d3(palette.mode),
        ...other
    };
}

});
parcelRegister("bdgU1", function(module, exports) {

$parcel$export(module.exports, "default", () => $829e0521d2e34386$export$2e2bcd8739ae039);
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $829e0521d2e34386$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}

});


parcelRegister("bizlR", function(module, exports) {

$parcel$export(module.exports, "default", () => $839ccc3d7df01e63$export$2e2bcd8739ae039);
function $839ccc3d7df01e63$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}

});

parcelRegister("9NfW4", function(module, exports) {

$parcel$export(module.exports, "default", () => $72150d29f14fc7c2$export$2e2bcd8739ae039);

var $7f2Uu = parcelRequire("7f2Uu");
var $72150d29f14fc7c2$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $7f2Uu.default)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };

});
parcelRegister("7f2Uu", function(module, exports) {

$parcel$export(module.exports, "default", () => $545c30fc9e85d7a9$export$2e2bcd8739ae039);
/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $545c30fc9e85d7a9$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $545c30fc9e85d7a9$export$2e2bcd8739ae039 = $545c30fc9e85d7a9$var$excludeVariablesFromRoot;

});





parcelRegister("lyEQv", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1c7513a82d67d3$export$2e2bcd8739ae039);
var $fb1c7513a82d67d3$export$2e2bcd8739ae039 = '$$material';

});


parcelRegister("8a4xl", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f12c6d1068e62fe$export$2e2bcd8739ae039);


var $e7ggv = parcelRequire("e7ggv");

var $5Gz5b = parcelRequire("5Gz5b");

var $lyEQv = parcelRequire("lyEQv");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $5f12c6d1068e62fe$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $e7ggv.default), {
        ...props,
        defaultTheme: (0, $5Gz5b.default),
        themeId: (0, $lyEQv.default)
    });
}
var $5f12c6d1068e62fe$export$2e2bcd8739ae039 = $5f12c6d1068e62fe$var$GlobalStyles;

});
parcelRegister("e7ggv", function(module, exports) {

$parcel$export(module.exports, "default", () => $a46e5611cfce65b3$export$2e2bcd8739ae039);


var $8QDCO = parcelRequire("8QDCO");
var $jaCzf = parcelRequire("jaCzf");

var $gvt33 = parcelRequire("gvt33");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $a46e5611cfce65b3$var$wrapGlobalLayer(styles) {
    const serialized = (0, $jaCzf.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $a46e5611cfce65b3$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $gvt33.default)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $a46e5611cfce65b3$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $a46e5611cfce65b3$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $a46e5611cfce65b3$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $8QDCO.default), {
        styles: globalStyles
    });
}
var $a46e5611cfce65b3$export$2e2bcd8739ae039 = $a46e5611cfce65b3$var$GlobalStyles;

});
parcelRegister("8QDCO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6711eabf83822d21$export$2e2bcd8739ae039);


var $IRdXs = parcelRequire("IRdXs");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $6711eabf83822d21$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $6711eabf83822d21$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($6711eabf83822d21$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $IRdXs.Global), {
        styles: globalStyles
    });
}

});

parcelRegister("jaCzf", function(module, exports) {

$parcel$export(module.exports, "default", () => $df4cde34fd8ee641$export$2e2bcd8739ae039);
$parcel$export(module.exports, "internal_mutateStyles", () => $df4cde34fd8ee641$export$592c7226e4cb0171);
$parcel$export(module.exports, "internal_serializeStyles", () => $df4cde34fd8ee641$export$13a2d3ef13012b32);
/**
 * @mui/styled-engine v7.3.9
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $7EKRh = parcelRequire("7EKRh");

var $eC8G3 = parcelRequire("eC8G3");

var $IRdXs = parcelRequire("IRdXs");
var $h1PbY = parcelRequire("h1PbY");

var $dAPbx = parcelRequire("dAPbx");

var $8QDCO = parcelRequire("8QDCO");
'use client';
function $df4cde34fd8ee641$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $7EKRh.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $df4cde34fd8ee641$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $df4cde34fd8ee641$var$wrapper = [];
function $df4cde34fd8ee641$export$13a2d3ef13012b32(styles) {
    $df4cde34fd8ee641$var$wrapper[0] = styles;
    return (0, $eC8G3.serializeStyles)($df4cde34fd8ee641$var$wrapper);
}

});
parcelRegister("7EKRh", function(module, exports) {

$parcel$export(module.exports, "default", () => $59309de5fb48f10d$export$2e2bcd8739ae039);

var $39Exn = parcelRequire("39Exn");
parcelRequire("eR4tV");

parcelRequire("eC8G3");
parcelRequire("a7NNJ");
parcelRequire("7i4hv");
parcelRequire("jXEQt");
parcelRequire("jHGAH");
var $59309de5fb48f10d$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $59309de5fb48f10d$export$2e2bcd8739ae039 = (0, $39Exn.default).bind(null);
$59309de5fb48f10d$var$tags.forEach(function(tagName) {
    $59309de5fb48f10d$export$2e2bcd8739ae039[tagName] = $59309de5fb48f10d$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("39Exn", function(module, exports) {

$parcel$export(module.exports, "default", () => $24c1a83bd61e8072$export$2e2bcd8739ae039);

var $eR4tV = parcelRequire("eR4tV");
parcelRequire("IRdXs");
var $h1PbY = parcelRequire("h1PbY");

var $eC8G3 = parcelRequire("eC8G3");

var $a7NNJ = parcelRequire("a7NNJ");

var $7i4hv = parcelRequire("7i4hv");

var $jXEQt = parcelRequire("jXEQt");

var $jHGAH = parcelRequire("jHGAH");
var $24c1a83bd61e8072$var$isDevelopment = false;
var $24c1a83bd61e8072$var$testOmitPropsOnStringTag = (0, $jHGAH.default);
var $24c1a83bd61e8072$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $24c1a83bd61e8072$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $24c1a83bd61e8072$var$testOmitPropsOnStringTag : $24c1a83bd61e8072$var$testOmitPropsOnComponent;
};
var $24c1a83bd61e8072$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $24c1a83bd61e8072$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7i4hv.registerStyles)(cache, serialized, isStringTag);
    (0, $a7NNJ.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7i4hv.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $24c1a83bd61e8072$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $24c1a83bd61e8072$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $24c1a83bd61e8072$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $h1PbY.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $jXEQt.useContext((0, $h1PbY.T));
            }
            if (typeof props.className === 'string') className = (0, $7i4hv.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $eC8G3.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $24c1a83bd61e8072$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $jXEQt.createElement($jXEQt.Fragment, null, /*#__PURE__*/ $jXEQt.createElement($24c1a83bd61e8072$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $jXEQt.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $24c1a83bd61e8072$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $eR4tV.default)({}, options, nextOptions, {
                shouldForwardProp: $24c1a83bd61e8072$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("jHGAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e58312245c719150$export$2e2bcd8739ae039);

var $jeNL3 = parcelRequire("jeNL3");
// eslint-disable-next-line no-undef
var $e58312245c719150$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $e58312245c719150$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $jeNL3.default)(function(prop) {
    return $e58312245c719150$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("dAPbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e565778652cf4ed$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $h1PbY = parcelRequire("h1PbY");

var $7g1UW = parcelRequire("7g1UW");

var $bIyd5 = parcelRequire("bIyd5");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $9e565778652cf4ed$var$cacheMap = new Map();
const $9e565778652cf4ed$export$5a3f4e255fc47e86 = {
    /**
   * to intercept the generated CSS before inserting to the style tag, so that we can check the generated CSS.
   *
   * let rule;
   * TEST_INTERNALS_DO_NOT_USE.insert = (...args) => {
   *    rule = args[0];
   * };
   *
   * expect(rule).to.equal(...);
   */ insert: undefined
};
// We might be able to remove this when this issue is fixed:
// https://github.com/emotion-js/emotion/issues/2790
const $9e565778652cf4ed$var$createEmotionCache = (options, CustomSheet)=>{
    const cache = (0, $7g1UW.default)(options);
    // Do the same as https://github.com/emotion-js/emotion/blob/main/packages/cache/src/index.js#L238-L245
    cache.sheet = new CustomSheet({
        key: cache.key,
        nonce: cache.sheet.nonce,
        container: cache.sheet.container,
        speedy: cache.sheet.isSpeedy,
        prepend: cache.sheet.prepend,
        insertionPoint: cache.sheet.insertionPoint
    });
    return cache;
};
let $9e565778652cf4ed$var$insertionPoint;
if (typeof document === 'object') {
    // Use `insertionPoint` over `prepend`(deprecated) because it can be controlled for GlobalStyles injection order
    // For more information, see https://github.com/mui/material-ui/issues/44597
    $9e565778652cf4ed$var$insertionPoint = document.querySelector('[name="emotion-insertion-point"]');
    if (!$9e565778652cf4ed$var$insertionPoint) {
        $9e565778652cf4ed$var$insertionPoint = document.createElement('meta');
        $9e565778652cf4ed$var$insertionPoint.setAttribute('name', 'emotion-insertion-point');
        $9e565778652cf4ed$var$insertionPoint.setAttribute('content', '');
        const head = document.querySelector('head');
        if (head) head.prepend($9e565778652cf4ed$var$insertionPoint);
    }
}
function $9e565778652cf4ed$var$getCache(injectFirst, enableCssLayer) {
    if (injectFirst || enableCssLayer) {
        /**
     * This is for client-side apps only.
     * A custom sheet is required to make the GlobalStyles API injected above the insertion point.
     * This is because the [sheet](https://github.com/emotion-js/emotion/blob/main/packages/react/src/global.js#L94-L99) does not consume the options.
     */ class MyStyleSheet extends (0, $bIyd5.StyleSheet) {
            insert(rule, options) {
                if ($9e565778652cf4ed$export$5a3f4e255fc47e86.insert) return $9e565778652cf4ed$export$5a3f4e255fc47e86.insert(rule, options);
                if (this.key && this.key.endsWith('global')) this.before = $9e565778652cf4ed$var$insertionPoint;
                return super.insert(rule, options);
            }
        }
        const emotionCache = $9e565778652cf4ed$var$createEmotionCache({
            key: 'css',
            insertionPoint: injectFirst ? $9e565778652cf4ed$var$insertionPoint : undefined
        }, MyStyleSheet);
        if (enableCssLayer) {
            const prevInsert = emotionCache.insert;
            emotionCache.insert = (...args)=>{
                if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
                args[1].styles = `@layer mui {${args[1].styles}}`;
                return prevInsert(...args);
            };
        }
        return emotionCache;
    }
    return undefined;
}
function $9e565778652cf4ed$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $jXEQt.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $9e565778652cf4ed$var$cacheMap.has(cacheKey)) return $9e565778652cf4ed$var$cacheMap.get(cacheKey);
        const fresh = $9e565778652cf4ed$var$getCache(injectFirst, enableCssLayer);
        $9e565778652cf4ed$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    return cache ? /*#__PURE__*/ (0, $7rM61.jsx)((0, $h1PbY.C), {
        value: cache,
        children: children
    }) : children;
}

});




parcelRegister("3EMXY", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a9b17315d166e2c$export$2e2bcd8739ae039);

var $283M5 = parcelRequire("283M5");

var $5Gz5b = parcelRequire("5Gz5b");

var $lyEQv = parcelRequire("lyEQv");

var $i29Fs = parcelRequire("i29Fs");

'use client';
const $2a9b17315d166e2c$var$styled = (0, $283M5.default)({
    themeId: (0, $lyEQv.default),
    defaultTheme: $5Gz5b.default,
    rootShouldForwardProp: $i29Fs.default
});
var $2a9b17315d166e2c$export$2e2bcd8739ae039 = $2a9b17315d166e2c$var$styled;

});
parcelRegister("283M5", function(module, exports) {

$parcel$export(module.exports, "default", () => $18cf41b3dab696a5$export$2e2bcd8739ae039);

var $jaCzf = parcelRequire("jaCzf");

var $cqtAx = parcelRequire("cqtAx");

var $l7dVi = parcelRequire("l7dVi");

var $dpO0X = parcelRequire("dpO0X");

var $jECx5 = parcelRequire("jECx5");

var $iBnPH = parcelRequire("iBnPH");

var $a1yPc = parcelRequire("a1yPc");
const $18cf41b3dab696a5$export$35e57303dbd8a66 = (0, $jECx5.default)();
function $18cf41b3dab696a5$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $18cf41b3dab696a5$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $18cf41b3dab696a5$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $18cf41b3dab696a5$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $18cf41b3dab696a5$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $18cf41b3dab696a5$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$18cf41b3dab696a5$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $18cf41b3dab696a5$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $18cf41b3dab696a5$var$shallowLayer((0, $jaCzf.internal_serializeStyles)(otherStyles), layerName) : otherStyles;
        }
        return $18cf41b3dab696a5$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $18cf41b3dab696a5$var$shallowLayer((0, $jaCzf.internal_serializeStyles)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $18cf41b3dab696a5$var$shallowLayer((0, $jaCzf.internal_serializeStyles)(resolvedStyle), layerName) : resolvedStyle;
}
function $18cf41b3dab696a5$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $18cf41b3dab696a5$var$shallowLayer((0, $jaCzf.internal_serializeStyles)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $18cf41b3dab696a5$var$shallowLayer((0, $jaCzf.internal_serializeStyles)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $18cf41b3dab696a5$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $18cf41b3dab696a5$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $18cf41b3dab696a5$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $18cf41b3dab696a5$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $18cf41b3dab696a5$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $jaCzf.internal_mutateStyles)(tag, (styles)=>styles.filter((style)=>style !== (0, $iBnPH.default)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $18cf41b3dab696a5$var$defaultOverridesResolver($18cf41b3dab696a5$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $18cf41b3dab696a5$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($18cf41b3dab696a5$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $jaCzf.default)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $18cf41b3dab696a5$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $18cf41b3dab696a5$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $cqtAx.isPlainObject)(style)) {
                const serialized = (0, $a1yPc.default)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $18cf41b3dab696a5$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $18cf41b3dab696a5$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $18cf41b3dab696a5$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $18cf41b3dab696a5$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $iBnPH.default));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $18cf41b3dab696a5$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $l7dVi.default)(componentSlot || '')}`;
    return `Styled(${(0, $dpO0X.default)(tag)})`;
}
function $18cf41b3dab696a5$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $18cf41b3dab696a5$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $18cf41b3dab696a5$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $18cf41b3dab696a5$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}

});
parcelRegister("dpO0X", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c446802d5ef14eb$export$2e2bcd8739ae039);

var $lsYCk = parcelRequire("lsYCk");
function $9c446802d5ef14eb$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $9c446802d5ef14eb$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $9c446802d5ef14eb$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $9c446802d5ef14eb$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $9c446802d5ef14eb$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $lsYCk.ForwardRef:
            return $9c446802d5ef14eb$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $lsYCk.Memo:
            return $9c446802d5ef14eb$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});

parcelRegister("a1yPc", function(module, exports) {

$parcel$export(module.exports, "default", () => $74c502e13463c2a9$export$2e2bcd8739ae039);

var $jaCzf = parcelRequire("jaCzf");
function $74c502e13463c2a9$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $jaCzf.internal_serializeStyles)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $jaCzf.internal_serializeStyles)(variant.style);
    });
    return result;
}

});


parcelRegister("i29Fs", function(module, exports) {

$parcel$export(module.exports, "default", () => $d20fe9b60dd2abd5$export$2e2bcd8739ae039);

var $7jAyz = parcelRequire("7jAyz");
const $d20fe9b60dd2abd5$var$rootShouldForwardProp = (prop)=>(0, $7jAyz.default)(prop) && prop !== 'classes';
var $d20fe9b60dd2abd5$export$2e2bcd8739ae039 = $d20fe9b60dd2abd5$var$rootShouldForwardProp;

});
parcelRegister("7jAyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $5536aa1be9d073d9$export$2e2bcd8739ae039);
// copied from @mui/system/createStyled
function $5536aa1be9d073d9$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $5536aa1be9d073d9$export$2e2bcd8739ae039 = $5536aa1be9d073d9$var$slotShouldForwardProp;

});




parcelRegister("31RRc", function(module, exports) {

$parcel$export(module.exports, "default", () => $234b3df93586e6a0$export$2e2bcd8739ae039);

var $2M189 = parcelRequire("2M189");
const $234b3df93586e6a0$var$memoTheme = (0, $2M189.default);
var $234b3df93586e6a0$export$2e2bcd8739ae039 = $234b3df93586e6a0$var$memoTheme;

});
parcelRegister("2M189", function(module, exports) {

$parcel$export(module.exports, "default", () => $2050f0f13771a8ac$export$2e2bcd8739ae039);

var $a1yPc = parcelRequire("a1yPc");
/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $2050f0f13771a8ac$var$arg = {
    theme: undefined
};
function $2050f0f13771a8ac$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $2050f0f13771a8ac$var$arg.theme = props.theme;
            value = (0, $a1yPc.default)(styleFn($2050f0f13771a8ac$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}

});


parcelRegister("5MTiZ", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $436c55ee41e50e87$export$2440da353cedad43);
parcelRequire("jXEQt");


var $k6Apu = parcelRequire("k6Apu");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $436c55ee41e50e87$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $k6Apu.default), {
        ...props
    });
}
var $436c55ee41e50e87$export$2e2bcd8739ae039 = $436c55ee41e50e87$var$DefaultPropsProvider;
function $436c55ee41e50e87$export$2440da353cedad43(params) {
    return (0, $k6Apu.useDefaultProps)(params);
}

});
parcelRegister("k6Apu", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", () => $ea309c7c90ed6a63$export$2440da353cedad43);
$parcel$export(module.exports, "default", () => $ea309c7c90ed6a63$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $5ZtsM = parcelRequire("5ZtsM");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $ea309c7c90ed6a63$var$PropsContext = /*#__PURE__*/ $jXEQt.createContext(undefined);
function $ea309c7c90ed6a63$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $7rM61.jsx)($ea309c7c90ed6a63$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $ea309c7c90ed6a63$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $5ZtsM.default)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $5ZtsM.default)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $ea309c7c90ed6a63$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $jXEQt.useContext($ea309c7c90ed6a63$var$PropsContext);
    return $ea309c7c90ed6a63$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $ea309c7c90ed6a63$export$2e2bcd8739ae039 = $ea309c7c90ed6a63$var$DefaultPropsProvider;

});
parcelRegister("5ZtsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $45c9810d3670cb18$export$2e2bcd8739ae039);

var $fQojQ = parcelRequire("fQojQ");
function $45c9810d3670cb18$export$2e2bcd8739ae039(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $45c9810d3670cb18$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className) output.className = (0, $fQojQ.default)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}

});



parcelRegister("dvg8e", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d4aaf0e0fd48e17$export$2e2bcd8739ae039);

var $l7dVi = parcelRequire("l7dVi");
var $9d4aaf0e0fd48e17$export$2e2bcd8739ae039 = (0, $l7dVi.default);

});

parcelRegister("8oH7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $61d2031a9648d291$export$2e2bcd8739ae039);
/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $61d2031a9648d291$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $61d2031a9648d291$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$61d2031a9648d291$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $61d2031a9648d291$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $61d2031a9648d291$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}

});

parcelRegister("zjm80", function(module, exports) {

$parcel$export(module.exports, "getTypographyUtilityClass", () => $06a248adc2afcc83$export$24c1f8f60cbac79e);
$parcel$export(module.exports, "default", () => $06a248adc2afcc83$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $06a248adc2afcc83$export$24c1f8f60cbac79e(slot) {
    return (0, $5KipK.default)('MuiTypography', slot);
}
const $06a248adc2afcc83$var$typographyClasses = (0, $1XfUG.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $06a248adc2afcc83$export$2e2bcd8739ae039 = $06a248adc2afcc83$var$typographyClasses;

});
parcelRegister("1XfUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c7a52a27a1887f$export$2e2bcd8739ae039);

var $5KipK = parcelRequire("5KipK");
function $16c7a52a27a1887f$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $5KipK.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("5KipK", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ef8853a1d24884$export$2e2bcd8739ae039);

var $jZ8iZ = parcelRequire("jZ8iZ");
const $42ef8853a1d24884$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $42ef8853a1d24884$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $42ef8853a1d24884$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $jZ8iZ.default).generate(componentName)}-${slot}`;
}
function $42ef8853a1d24884$export$34c0130b1f3e8ae3(slot) {
    return $42ef8853a1d24884$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("jZ8iZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8ca280ec56a82b8$export$2e2bcd8739ae039);
const $e8ca280ec56a82b8$var$defaultGenerator = (componentName)=>componentName;
const $e8ca280ec56a82b8$var$createClassNameGenerator = ()=>{
    let generate = $e8ca280ec56a82b8$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $e8ca280ec56a82b8$var$defaultGenerator;
        }
    };
};
const $e8ca280ec56a82b8$var$ClassNameGenerator = $e8ca280ec56a82b8$var$createClassNameGenerator();
var $e8ca280ec56a82b8$export$2e2bcd8739ae039 = $e8ca280ec56a82b8$var$ClassNameGenerator;

});





parcelRegister("1jMLP", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b36b0e66a5e3a25$export$2e2bcd8739ae039);
$parcel$export(module.exports, "migrateFromGuest", () => $6b36b0e66a5e3a25$export$a9bcf3819aac9b24);

var $04X5o = parcelRequire("04X5o");

var $iw6Kb = parcelRequire("iw6Kb");

var $lVt6m = parcelRequire("lVt6m");

var $5xV4Q = parcelRequire("5xV4Q");

var $gi5DA = parcelRequire("gi5DA");

var $4EGLj = parcelRequire("4EGLj");

var $cBzxi = parcelRequire("cBzxi");
(0, $iw6Kb.default).plugin((0, $04X5o.default));
(0, $iw6Kb.default).plugin((0, $lVt6m.default));
/**
 * Cleanup function to delete old IndexedDB databases from before the 2.0 migration.
 * Old databases were named `sanremo-${username}` (with PouchDB prefix `_pouch_`).
 * New databases are named `sanremo-2.0-${username}`.
 */ //  FIXME: use a metadata document (same as migrating documents to version two)
async function $6b36b0e66a5e3a25$var$cleanupOldDatabases() {
    if (!indexedDB.databases) return;
    try {
        const databases = await indexedDB.databases();
        const oldDatabases = databases.filter((db)=>db.name?.startsWith('_pouch_sanremo-') && !db.name?.startsWith('_pouch_sanremo-2.0-'));
        for (const db of oldDatabases)if (db.name) {
            console.log(`[db] Deleting old database: ${db.name}`);
            await new Promise((resolve, reject)=>{
                const request = indexedDB.deleteDatabase(db.name);
                request.onsuccess = ()=>resolve();
                request.onerror = ()=>reject(request.error);
                request.onblocked = ()=>{
                    console.warn(`[db] Database deletion blocked: ${db.name}`);
                    resolve();
                };
            });
        }
        if (oldDatabases.length > 0) console.log(`[db] Cleaned up ${oldDatabases.length} old database(s)`);
    } catch (error) {
        // Non-critical cleanup, log but don't throw
        console.warn('[db] Failed to cleanup old databases:', error);
    }
}
// TODO: we don't need to append the database name with the username
// We delete the database when they user logs out, so there shouldn't be a conflict
// NB: when logging in versus creating an account we would have to consider taking guest data
function $6b36b0e66a5e3a25$var$handle(loggedInUser) {
    const db = new (0, $iw6Kb.default)(`sanremo-2.0-${loggedInUser.name}`, {
        adapter: 'indexeddb',
        auto_compaction: true
    });
    // Cleanup old databases in the background (fire and forget)
    $6b36b0e66a5e3a25$var$cleanupOldDatabases();
    db.userPut = async (doc)=>{
        const { rev: rev } = await db.put(doc);
        doc._rev = rev;
        (0, $4EGLj.default).dispatch((0, $5xV4Q.markStale)(doc));
        return doc;
    };
    return db;
}
// we store the handle here because redux doesn't like non-serializable state, and Context is more trouble than it's worth
// this way we just keep the user in the store and get the DB from here each time
//
// nb: the only time you'll have more than one of these is if you start as a guest and change to a logged in user,
// switch users without reloading etc.
let $6b36b0e66a5e3a25$var$lastUserId;
let $6b36b0e66a5e3a25$var$lastHandle;
function $6b36b0e66a5e3a25$export$2e2bcd8739ae039(user) {
    if ($6b36b0e66a5e3a25$var$lastUserId !== user.id) {
        $6b36b0e66a5e3a25$var$lastUserId = user.id;
        $6b36b0e66a5e3a25$var$lastHandle = $6b36b0e66a5e3a25$var$handle(user);
        (0, $cBzxi.default)($6b36b0e66a5e3a25$var$lastHandle);
    }
    return $6b36b0e66a5e3a25$var$lastHandle;
}

async function $6b36b0e66a5e3a25$export$a9bcf3819aac9b24(user) {
    // Dynamically load replication plugin only when needed
    const Replication = (await (parcelRequire("gVYQt"))).default;
    (0, $iw6Kb.default).plugin(Replication);
    const userDb = $6b36b0e66a5e3a25$var$handle(user);
    const guestDb = $6b36b0e66a5e3a25$var$handle((0, $gi5DA.GuestUser));
    await guestDb.replicate.to(userDb);
    await guestDb.destroy();
}

});
parcelRegister("04X5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $00ee3510475588eb$export$2e2bcd8739ae039);

var $4GdZ0 = parcelRequire("4GdZ0");

var $2QQ9m = parcelRequire("2QQ9m");
var $eMG3m = parcelRequire("eMG3m");

var $9Pw4Q = parcelRequire("9Pw4Q");

var $47bZj = parcelRequire("47bZj");

var $cqZVJ = parcelRequire("cqZVJ");

var $eMG3m = parcelRequire("eMG3m");
const $00ee3510475588eb$var$IDB_NULL = Number.MIN_SAFE_INTEGER;
const $00ee3510475588eb$var$IDB_FALSE = Number.MIN_SAFE_INTEGER + 1;
const $00ee3510475588eb$var$IDB_TRUE = Number.MIN_SAFE_INTEGER + 2;
// These are the same as below but without the global flag
// we want to use RegExp.test because it's really fast, but the global flag
// makes the regex const stateful (seriously) as it walked through all instances
const $00ee3510475588eb$var$TEST_KEY_INVALID = /^[^a-zA-Z$]|[^a-zA-Z0-9$]+/;
const $00ee3510475588eb$var$TEST_PATH_INVALID = /\\.|(^|\.)[^a-zA-Z$]|[^a-zA-Z0-9$.]+/;
function $00ee3510475588eb$var$needsSanitise(name, isPath) {
    if (isPath) return $00ee3510475588eb$var$TEST_PATH_INVALID.test(name);
    else return $00ee3510475588eb$var$TEST_KEY_INVALID.test(name);
}
//
// IndexedDB only allows valid JS names in its index paths, whereas JSON allows
// for any string at all. This converts invalid JS names to valid ones, to allow
// for them to be indexed.
//
// For example, "foo-bar" is a valid JSON key, but cannot be a valid JS name
// (because that would be read as foo minus bar).
//
// Very high level rules for valid JS names are:
//  - First character cannot start with a number
//  - Otherwise all characters must be be a-z, A-Z, 0-9, or $.
//  - Underscores (_) are encoded even though legal, to avoid collisions with
//    encoded illegal characters
//  - We allow . unless the name represents a single field, as that represents
//    a deep index path.
// See: https://www.w3.org/TR/IndexedDB/#key-path-construct
//
// This is more aggressive than it needs to be, but also simpler.
//
const $00ee3510475588eb$var$KEY_INVALID = new RegExp($00ee3510475588eb$var$TEST_KEY_INVALID.source, 'g');
const $00ee3510475588eb$var$PATH_INVALID = new RegExp($00ee3510475588eb$var$TEST_PATH_INVALID.source, 'g');
const $00ee3510475588eb$var$SLASH = '\\'.charCodeAt(0);
const $00ee3510475588eb$var$IS_DOT = '.'.charCodeAt(0);
function $00ee3510475588eb$var$sanitise(name, isPath) {
    const correctCharacters = function(match) {
        let good = '';
        for(let i = 0; i < match.length; i++){
            const code = match.charCodeAt(i);
            // If you're sanitising a path, a slash character is there to be interpreted
            // by whatever parses the path later as "escape the next thing".
            //
            // e.g., if you want to index THIS string:
            //   {"foo": {"bar.baz": "THIS"}}
            // Your index path would be "foo.bar\.baz".
            if (code === $00ee3510475588eb$var$IS_DOT && isPath && i === 0) good += '.';
            else if (code === $00ee3510475588eb$var$SLASH && isPath) continue;
            else good += '_c' + code + '_';
        }
        return good;
    };
    if (isPath) return name.replace($00ee3510475588eb$var$PATH_INVALID, correctCharacters);
    else return name.replace($00ee3510475588eb$var$KEY_INVALID, correctCharacters);
}
function $00ee3510475588eb$var$needsRewrite(data) {
    for (const key of Object.keys(data)){
        if ($00ee3510475588eb$var$needsSanitise(key)) return true;
        else if (data[key] === null || typeof data[key] === 'boolean') return true;
        else if (typeof data[key] === 'object') return $00ee3510475588eb$var$needsRewrite(data[key]);
    }
}
function $00ee3510475588eb$var$rewrite(data) {
    if (!$00ee3510475588eb$var$needsRewrite(data)) return false;
    const isArray = Array.isArray(data);
    const clone = isArray ? [] : {};
    Object.keys(data).forEach(function(key) {
        const safeKey = isArray ? key : $00ee3510475588eb$var$sanitise(key);
        if (data[key] === null) clone[safeKey] = $00ee3510475588eb$var$IDB_NULL;
        else if (typeof data[key] === 'boolean') clone[safeKey] = data[key] ? $00ee3510475588eb$var$IDB_TRUE : $00ee3510475588eb$var$IDB_FALSE;
        else if (typeof data[key] === 'object') clone[safeKey] = $00ee3510475588eb$var$rewrite(data[key]);
        else clone[safeKey] = data[key];
    });
    return clone;
}
const $00ee3510475588eb$var$DOC_STORE = 'docs';
const $00ee3510475588eb$var$META_LOCAL_STORE = 'meta';
function $00ee3510475588eb$var$idbError(callback) {
    return function(evt) {
        let message = 'unknown_error';
        if (evt.target && evt.target.error) message = evt.target.error.name || evt.target.error.message;
        callback((0, $cqZVJ.createError)((0, $cqZVJ.IDB_ERROR), message, evt.type));
    };
}
function $00ee3510475588eb$var$processAttachment(name, src, doc, isBinary, attachmentFormat) {
    delete doc._attachments[name].stub;
    if (attachmentFormat === 'base64') {
        if (isBinary) {
            const att = src.attachments[doc._attachments[name].digest];
            doc._attachments[name].data = (0, $4GdZ0.base64StringToBlobOrBuffer)(att.data, att.content_type);
        } else doc._attachments[name].data = src.attachments[doc._attachments[name].digest].data;
        delete doc._attachments[name].length;
        return Promise.resolve();
    }
    if (isBinary) {
        doc._attachments[name].data = src.attachments[doc._attachments[name].digest].data;
        return Promise.resolve();
    }
    return new Promise(function(resolve) {
        const data = src.attachments[doc._attachments[name].digest].data;
        (0, $4GdZ0.readAsBinaryString)(data, function(binString) {
            doc._attachments[name].data = (0, $4GdZ0.btoa)(binString);
            delete doc._attachments[name].length;
            resolve();
        });
    });
}
function $00ee3510475588eb$var$rawIndexFields(ddoc, viewName) {
    // fields are an array of either the string name of the field, or a key value
    const fields = ddoc.views[viewName].options && ddoc.views[viewName].options.def && ddoc.views[viewName].options.def.fields || [];
    // Either ['foo'] or [{'foo': 'desc'}]
    return fields.map(function(field) {
        if (typeof field === 'string') return field;
        else return Object.keys(field)[0];
    });
}
/**
 * true if the view is has a "partial_filter_selector".
 */ function $00ee3510475588eb$var$isPartialFilterView(ddoc, viewName) {
    return viewName in ddoc.views && ddoc.views[viewName].options && ddoc.views[viewName].options.def && ddoc.views[viewName].options.def.partial_filter_selector;
}
function $00ee3510475588eb$var$naturalIndexName(fields) {
    return '_find_idx/' + fields.join('/');
}
/**
 * Convert the fields the user gave us in the view and convert them to work for
 * indexeddb.
 *
 * fields is an array of field strings. A field string could be one field:
 *   'foo'
 * Or it could be a json path:
 *   'foo.bar'
 */ function $00ee3510475588eb$var$correctIndexFields(fields) {
    // Every index has to have deleted at the front, because when we do a query
    // we need to filter out deleted documents.
    return [
        'deleted'
    ].concat(fields.map(function(field) {
        if ([
            '_id',
            '_rev',
            '_deleted',
            '_attachments'
        ].includes(field)) // These properties are stored at the top level without the underscore
        return field.substr(1);
        else // The custom document fields are inside the `data` property
        return 'data.' + $00ee3510475588eb$var$sanitise(field, true);
    }));
}
//
// Core PouchDB schema version. Increment this if we, as a library, want to make
// schema changes in indexeddb. See upgradePouchDbSchema()
//
const $00ee3510475588eb$var$POUCHDB_IDB_VERSION = 2;
//
// Functions that manage a combinate indexeddb version, by combining the current
// time in millis that represents user migrations with a large multiplier that
// represents PouchDB system migrations.
//
// This lets us use the idb version number to both represent
// PouchDB-library-level migrations as well as "user migrations" required for
// when design documents trigger the addition or removal of native indexes.
//
// Given that Number.MAX_SAFE_INTEGER = 9007199254740991
//
// We can easily use the largest 2-3 digits and either allow:
//  - 900 system migrations up to 2198/02/18
//  - or 89 system migrations up to 5050/02/14
//
// This impl does the former. If this code still exists after 2198 someone send my
// descendants a Spacebook message congratulating them on their impressive genes.
//
// 9007199254740991 <- MAX_SAFE_INTEGER
//   10000000000000 <- 10^13
//    7199254740991 <- 2198-02-18T16:59:00.991Z
//
const $00ee3510475588eb$var$versionMultiplier = Math.pow(10, 13);
function $00ee3510475588eb$var$createIdbVersion() {
    return $00ee3510475588eb$var$versionMultiplier * $00ee3510475588eb$var$POUCHDB_IDB_VERSION + new Date().getTime();
}
function $00ee3510475588eb$var$getPouchDbVersion(version) {
    return Math.floor(version / $00ee3510475588eb$var$versionMultiplier);
}
function $00ee3510475588eb$var$maintainNativeIndexes(openReq, reject) {
    const docStore = openReq.transaction.objectStore($00ee3510475588eb$var$DOC_STORE);
    const ddocsReq = docStore.getAll(IDBKeyRange.bound('_design/', '_design/\uffff'));
    ddocsReq.onsuccess = function(e) {
        const results = e.target.result;
        const existingIndexNames = Array.from(docStore.indexNames);
        // NB: the only thing we're supporting here is the declared indexing
        // fields nothing more.
        const expectedIndexes = results.filter(function(row) {
            return row.deleted === 0 && row.revs[row.rev].data.views;
        }).map(function(row) {
            return row.revs[row.rev].data;
        }).reduce(function(indexes, ddoc) {
            return Object.keys(ddoc.views).reduce(function(acc, viewName) {
                const fields = $00ee3510475588eb$var$rawIndexFields(ddoc, viewName);
                if (fields && fields.length > 0) acc[$00ee3510475588eb$var$naturalIndexName(fields)] = $00ee3510475588eb$var$correctIndexFields(fields);
                return acc;
            }, indexes);
        }, {});
        const expectedIndexNames = Object.keys(expectedIndexes);
        // Delete any indexes that aren't system indexes or expected
        const systemIndexNames = [
            'seq',
            'deleted,id'
        ];
        existingIndexNames.forEach(function(index) {
            if (systemIndexNames.indexOf(index) === -1 && expectedIndexNames.indexOf(index) === -1) docStore.deleteIndex(index);
        });
        // Work out which indexes are missing and create them
        const newIndexNames = expectedIndexNames.filter(function(ei) {
            return existingIndexNames.indexOf(ei) === -1;
        });
        try {
            newIndexNames.forEach(function(indexName) {
                docStore.createIndex(indexName, expectedIndexes[indexName]);
            });
        } catch (err) {
            reject(err);
        }
    };
}
function $00ee3510475588eb$var$upgradePouchDbSchema(dbName, db, tx, pouchdbVersion) {
    if (pouchdbVersion < 1) {
        const docStore = db.createObjectStore($00ee3510475588eb$var$DOC_STORE, {
            keyPath: 'id'
        });
        docStore.createIndex('seq', 'seq', {
            unique: true
        });
        db.createObjectStore($00ee3510475588eb$var$META_LOCAL_STORE, {
            keyPath: 'id'
        });
    }
    if (pouchdbVersion < 2) {
        const docStore = tx.objectStore($00ee3510475588eb$var$DOC_STORE);
        docStore.createIndex('deleted,id', [
            'deleted',
            'id'
        ], {
            unique: true
        });
        if (dbName.includes('-mrview-')) docStore.deleteIndex('seq');
    }
// Declare more PouchDB schema changes here
// if (pouchdbVersion < 3) { .. }
}
function $00ee3510475588eb$var$openDatabase(openDatabases, api, opts, resolve, reject) {
    const openReq = opts.versionChangedWhileOpen ? indexedDB.open(opts.name) : indexedDB.open(opts.name, $00ee3510475588eb$var$createIdbVersion());
    openReq.onupgradeneeded = function(e) {
        if (e.oldVersion > 0 && e.oldVersion < $00ee3510475588eb$var$versionMultiplier) // This DB was created with the "idb" adapter, **not** this one.
        // For now we're going to just error out here: users must manually
        // migrate between the two. In the future, dependent on performance tests,
        // we might silently migrate
        throw new Error('Incorrect adapter: you should specify the "idb" adapter to open this DB');
        else if (e.oldVersion === 0 && e.newVersion < $00ee3510475588eb$var$versionMultiplier) {
            // Firefox still creates the database with version=1 even if we throw,
            // so we need to be sure to destroy the empty database before throwing
            indexedDB.deleteDatabase(opts.name);
            throw new Error('Database was deleted while open');
        }
        const tx = e.target.transaction;
        const db = e.target.result;
        const pouchdbVersion = $00ee3510475588eb$var$getPouchDbVersion(e.oldVersion);
        $00ee3510475588eb$var$upgradePouchDbSchema(opts.name, db, tx, pouchdbVersion);
        $00ee3510475588eb$var$maintainNativeIndexes(openReq, reject);
        if (pouchdbVersion < 2) {
            const docStore = openReq.transaction.objectStore($00ee3510475588eb$var$DOC_STORE);
            const metaStore = openReq.transaction.objectStore($00ee3510475588eb$var$META_LOCAL_STORE);
            const allDocsReq = docStore.openCursor();
            allDocsReq.onsuccess = (event)=>{
                const cursor = event.target.result;
                if (!cursor) return;
                const doc = cursor.value;
                if (!(0, $eMG3m.isLocalId)(doc.id)) return cursor.continue();
                // Move _local/ docs to the META_LOCAL_STORE
                metaStore.put(doc).onsuccess = ()=>{
                    cursor.delete(doc).onsuccess = ()=>{
                        cursor.continue();
                    };
                };
            };
        }
    };
    openReq.onblocked = function(e) {
        // AFAICT this only occurs if, after sending `onversionchange` events to
        // all other open DBs (ie in different tabs), there are still open
        // connections to the DB. In this code we should never see this because we
        // close our DBs on these events, and all DB interactions are wrapped in
        // safely re-opening the DB.
        console.error('onblocked, this should never happen', e);
    };
    openReq.onsuccess = function(e) {
        const idb = e.target.result;
        idb.onabort = function(e) {
            console.error('Database has a global failure', e.target.error);
            delete openDatabases[opts.name];
            idb.close();
        };
        // In IndexedDB you can only change the version, and thus the schema, when you are opening the database.
        // versionChangedWhileOpen means that something else outside of our control has likely updated the version.
        // One way this could happen is if you open multiple tabs, as the version number changes each time the database is opened.
        // If we suspect this we close the db and tag it, so that next time it's accessed it reopens the DB with the current version
        // as opposed to upping the version again
        // This avoids infinite loops of version updates if you have multiple tabs open
        idb.onversionchange = function() {
            console.log('Database was made stale, closing handle');
            openDatabases[opts.name].versionChangedWhileOpen = true;
            idb.close();
        };
        idb.onclose = function() {
            console.log('Database was made stale, closing handle');
            if (opts.name in openDatabases) openDatabases[opts.name].versionChangedWhileOpen = true;
        };
        let metadata = {
            id: $00ee3510475588eb$var$META_LOCAL_STORE
        };
        const txn = idb.transaction([
            $00ee3510475588eb$var$META_LOCAL_STORE
        ], 'readwrite');
        txn.oncomplete = function() {
            resolve({
                idb: idb,
                metadata: metadata
            });
        };
        const metaStore = txn.objectStore($00ee3510475588eb$var$META_LOCAL_STORE);
        metaStore.get($00ee3510475588eb$var$META_LOCAL_STORE).onsuccess = function(e) {
            metadata = e.target.result || metadata;
            let changed = false;
            if (!('doc_count' in metadata)) {
                changed = true;
                metadata.doc_count = 0;
            }
            if (!('seq' in metadata)) {
                changed = true;
                metadata.seq = 0;
            }
            if (!('db_uuid' in metadata)) {
                changed = true;
                metadata.db_uuid = (0, $47bZj.uuid)();
            }
            if (!('idb_attachment_format' in metadata)) {
                // There will be trouble if any browser _stops_ supporting blobs.
                const createBlobDoc = (blob)=>({
                        id: 'blob-support',
                        blob: blob
                    });
                (0, $2QQ9m.checkBlobSupport)(txn, $00ee3510475588eb$var$META_LOCAL_STORE, createBlobDoc).then((blobSupport)=>{
                    // Unfortunate that we have to track this in both the metadata and on
                    // api, but sometimes we have access to one, sometimes the other (and
                    // sometimes both).  We could change function signatures in index.js
                    // to make this consistent.
                    api.blobSupport = metadata.idb_attachment_format = blobSupport ? 'binary' : 'base64';
                    metaStore.put(metadata);
                });
            } else if (changed) {
                api.blobSupport = metadata.idb_attachment_format;
                metaStore.put(metadata);
            }
        };
    };
    openReq.onerror = function(e) {
        reject(e.target.error);
    };
}
function $00ee3510475588eb$var$setup(openDatabases, api, opts) {
    if (!openDatabases[opts.name] || openDatabases[opts.name].versionChangedWhileOpen) {
        opts.versionChangedWhileOpen = openDatabases[opts.name] && openDatabases[opts.name].versionChangedWhileOpen;
        openDatabases[opts.name] = new Promise(function(resolve, reject) {
            $00ee3510475588eb$var$openDatabase(openDatabases, api, opts, resolve, reject);
        });
    }
    return openDatabases[opts.name];
}
function $00ee3510475588eb$var$info(metadata, callback) {
    callback(null, {
        doc_count: metadata.doc_count,
        update_seq: metadata.seq
    });
}
function $00ee3510475588eb$var$get(txn, id, opts, callback) {
    if (txn.error) return callback(txn.error);
    txn.txn.objectStore($00ee3510475588eb$var$DOC_STORE).get(id).onsuccess = function(e) {
        const doc = e.target.result;
        let rev;
        if (!opts.rev) rev = doc && doc.rev;
        else rev = opts.latest ? (0, $eMG3m.latest)(opts.rev, doc) : opts.rev;
        if (!doc || doc.deleted && !opts.rev || !(rev in doc.revs)) {
            callback((0, $cqZVJ.createError)((0, $cqZVJ.MISSING_DOC), 'missing'));
            return;
        }
        const result = doc.revs[rev].data;
        result._id = doc.id;
        result._rev = rev;
        // WARNING: expecting possible old format
        // TODO: why are we passing the transaction in the context?
        //       It's not clear we ever thread these txns usefully
        callback(null, {
            doc: result,
            metadata: doc,
            ctx: txn
        });
    };
}
// _getLocal() doesn't know if opts.binary is set or not, so assume it's not.
const $00ee3510475588eb$var$BINARY_ATTACHMENTS = false;
function $00ee3510475588eb$var$getLocal(txn, id, api, callback) {
    if (txn.error) return callback(txn.error);
    txn.txn.objectStore($00ee3510475588eb$var$META_LOCAL_STORE).get(id).onsuccess = function(e) {
        const doc = e.target.result;
        if (!doc) {
            callback((0, $cqZVJ.createError)((0, $cqZVJ.MISSING_DOC), 'missing'));
            return;
        }
        const result = doc.revs[doc.rev].data;
        result._id = doc.id;
        result._rev = doc.rev;
        if (result._attachments) {
            const processing = [];
            for(const name in result._attachments)processing.push($00ee3510475588eb$var$processAttachment(name, doc, result, $00ee3510475588eb$var$BINARY_ATTACHMENTS, api.blobSupport));
            Promise.all(processing).then(()=>callback(null, result)).catch(callback);
        } else callback(null, result);
    };
}
function $00ee3510475588eb$var$getAttachment(docId, attachId, attachment, opts, cb) {
    if ((0, $eMG3m.isLocalId)(docId)) {
        cb((0, $cqZVJ.createError)((0, $cqZVJ.MISSING_DOC), 'missing'));
        return;
    }
    const doc = opts.metadata;
    const data = doc.attachments[attachment.digest].data;
    if (typeof data === 'string') {
        if (opts.binary) cb(null, (0, $4GdZ0.base64StringToBlobOrBuffer)(data, attachment.content_type));
        else cb(null, data);
        return;
    }
    if (opts.binary) return cb(null, data);
    else (0, $4GdZ0.readAsBinaryString)(data, function(binString) {
        cb(null, (0, $4GdZ0.btoa)(binString));
    });
}
function $00ee3510475588eb$var$bulkDocs(api, req, opts, metadata, dbOpts, idbChanges, callback) {
    let txn;
    // TODO: I would prefer to get rid of these globals
    let error;
    const results = [];
    const docs = [];
    let lastWriteIndex;
    const revsLimit = dbOpts.revs_limit || 1000;
    const rewriteEnabled = dbOpts.name.indexOf("-mrview-") === -1;
    const autoCompaction = dbOpts.auto_compaction;
    // We only need to track 1 revision for local documents
    function docsRevsLimit(doc) {
        return (0, $eMG3m.isLocalId)(doc.id) ? 1 : revsLimit;
    }
    function rootIsMissing(doc) {
        return doc.rev_tree[0].ids[1].status === 'missing';
    }
    // Reads the original doc from the store if available
    // As in allDocs with keys option using multiple get calls is the fastest way
    function fetchExistingDocs(txn, docs) {
        let fetched = 0;
        const oldDocs = {};
        function readDone(e) {
            if (e.target.result) oldDocs[e.target.result.id] = e.target.result;
            if (++fetched === docs.length) processDocs(txn, docs, oldDocs);
        }
        docs.forEach(function(doc) {
            const docStore = (0, $eMG3m.isLocalId)(doc.id) ? $00ee3510475588eb$var$META_LOCAL_STORE : $00ee3510475588eb$var$DOC_STORE;
            txn.objectStore(docStore).get(doc.id).onsuccess = readDone;
        });
    }
    function revHasAttachment(doc, rev, digest) {
        return doc.revs[rev] && doc.revs[rev].data._attachments && Object.values(doc.revs[rev].data._attachments).find(function(att) {
            return att.digest === digest;
        });
    }
    function processDocs(txn, docs, oldDocs) {
        docs.forEach(function(doc, i) {
            let newDoc;
            // The first document write cannot be a deletion
            if ('was_delete' in opts && !Object.prototype.hasOwnProperty.call(oldDocs, doc.id)) newDoc = (0, $cqZVJ.createError)((0, $cqZVJ.MISSING_DOC), 'deleted');
            else if (opts.new_edits && !Object.prototype.hasOwnProperty.call(oldDocs, doc.id) && rootIsMissing(doc)) newDoc = (0, $cqZVJ.createError)((0, $cqZVJ.REV_CONFLICT));
            else if (Object.prototype.hasOwnProperty.call(oldDocs, doc.id)) {
                newDoc = update(txn, doc, oldDocs[doc.id]);
                // The update can be rejected if it is an update to an existing
                // revision, if so skip it
                if (newDoc == false) return;
            // New document
            } else {
                // Ensure new documents are also stemmed
                const merged = (0, $eMG3m.merge)([], doc.rev_tree[0], docsRevsLimit(doc));
                doc.rev_tree = merged.tree;
                doc.stemmedRevs = merged.stemmedRevs;
                newDoc = doc;
                newDoc.isNewDoc = true;
                newDoc.wasDeleted = doc.revs[doc.rev].deleted ? 1 : 0;
            }
            if (newDoc.error) results[i] = newDoc;
            else {
                oldDocs[newDoc.id] = newDoc;
                lastWriteIndex = i;
                write(txn, newDoc, i);
            }
        });
    }
    // Converts from the format returned by parseDoc into the new format
    // we use to store
    function convertDocFormat(doc) {
        const newDoc = {
            id: doc.metadata.id,
            rev: doc.metadata.rev,
            rev_tree: doc.metadata.rev_tree,
            revs: doc.metadata.revs || {}
        };
        newDoc.revs[newDoc.rev] = {
            data: doc.data,
            deleted: doc.metadata.deleted
        };
        return newDoc;
    }
    function update(txn, doc, oldDoc) {
        // Ignore updates to existing revisions
        if (doc.rev in oldDoc.revs && !opts.new_edits) return false;
        const isRoot = /^1-/.test(doc.rev);
        // Reattach first writes after a deletion to last deleted tree
        if (oldDoc.deleted && !doc.deleted && opts.new_edits && isRoot) {
            const tmp = doc.revs[doc.rev].data;
            tmp._rev = oldDoc.rev;
            tmp._id = oldDoc.id;
            doc = convertDocFormat((0, $2QQ9m.parseDoc)(tmp, opts.new_edits, dbOpts));
        }
        const merged = (0, $eMG3m.merge)(oldDoc.rev_tree, doc.rev_tree[0], docsRevsLimit(doc));
        doc.stemmedRevs = merged.stemmedRevs;
        doc.rev_tree = merged.tree;
        // Merge the old and new rev data
        const revs = oldDoc.revs;
        revs[doc.rev] = doc.revs[doc.rev];
        doc.revs = revs;
        doc.attachments = oldDoc.attachments;
        const inConflict = opts.new_edits && (oldDoc.deleted && doc.deleted || !oldDoc.deleted && merged.conflicts !== 'new_leaf' || oldDoc.deleted && !doc.deleted && merged.conflicts === 'new_branch' || oldDoc.rev === doc.rev);
        if (inConflict) return (0, $cqZVJ.createError)((0, $cqZVJ.REV_CONFLICT));
        doc.wasDeleted = oldDoc.deleted;
        return doc;
    }
    function write(txn, doc, i) {
        // We copy the data from the winning revision into the root
        // of the document so that it can be indexed
        const winningRev$$1 = (0, $eMG3m.winningRev)(doc);
        // rev of new doc for attachments and to return it
        const writtenRev = doc.rev;
        const isLocal = (0, $eMG3m.isLocalId)(doc.id);
        const theDoc = doc.revs[winningRev$$1].data;
        const isNewDoc = doc.isNewDoc;
        if (rewriteEnabled) {
            // doc.data is what we index, so we need to clone and rewrite it, and clean
            // it up for indexability
            const result = $00ee3510475588eb$var$rewrite(theDoc);
            if (result) {
                doc.data = result;
                delete doc.data._attachments;
            } else doc.data = theDoc;
        } else doc.data = theDoc;
        doc.rev = winningRev$$1;
        // .deleted needs to be an int for indexing
        doc.deleted = doc.revs[winningRev$$1].deleted ? 1 : 0;
        // Bump the seq for every new (non local) revision written
        if (!isLocal) {
            doc.seq = ++metadata.seq;
            let delta = 0;
            // If its a new document, we wont decrement if deleted
            if (doc.isNewDoc) delta = doc.deleted ? 0 : 1;
            else if (doc.wasDeleted !== doc.deleted) delta = doc.deleted ? -1 : 1;
            metadata.doc_count += delta;
        }
        delete doc.isNewDoc;
        delete doc.wasDeleted;
        // If there have been revisions stemmed when merging trees,
        // delete their data
        let revsToDelete = doc.stemmedRevs || [];
        if (autoCompaction && !isNewDoc) {
            const result = (0, $eMG3m.compactTree)(doc);
            if (result.length) revsToDelete = revsToDelete.concat(result);
        }
        if (revsToDelete.length) revsToDelete.forEach(function(rev) {
            delete doc.revs[rev];
        });
        delete doc.stemmedRevs;
        if (!('attachments' in doc)) doc.attachments = {};
        if (theDoc._attachments) for(const k in theDoc._attachments){
            const attachment = theDoc._attachments[k];
            if (attachment.stub) {
                if (!(attachment.digest in doc.attachments)) {
                    error = (0, $cqZVJ.createError)((0, $cqZVJ.MISSING_STUB));
                    // TODO: Not sure how safe this manual abort is, seeing
                    // console issues
                    txn.abort();
                    return;
                }
                if (revHasAttachment(doc, writtenRev, attachment.digest)) doc.attachments[attachment.digest].revs[writtenRev] = true;
            } else {
                doc.attachments[attachment.digest] = attachment;
                doc.attachments[attachment.digest].revs = {};
                doc.attachments[attachment.digest].revs[writtenRev] = true;
                theDoc._attachments[k] = {
                    stub: true,
                    digest: attachment.digest,
                    content_type: attachment.content_type,
                    length: attachment.length,
                    revpos: parseInt(writtenRev, 10)
                };
            }
        }
        // Local documents have different revision handling
        if (isLocal && doc.deleted) {
            txn.objectStore($00ee3510475588eb$var$META_LOCAL_STORE).delete(doc.id).onsuccess = function() {
                results[i] = {
                    ok: true,
                    id: doc.id,
                    rev: '0-0'
                };
            };
            updateSeq(i);
            return;
        }
        const docStore = isLocal ? $00ee3510475588eb$var$META_LOCAL_STORE : $00ee3510475588eb$var$DOC_STORE;
        txn.objectStore(docStore).put(doc).onsuccess = function() {
            results[i] = {
                ok: true,
                id: doc.id,
                rev: writtenRev
            };
            updateSeq(i);
        };
    }
    function updateSeq(i) {
        if (i === lastWriteIndex) txn.objectStore($00ee3510475588eb$var$META_LOCAL_STORE).put(metadata);
    }
    function preProcessAttachment(attachment) {
        if (attachment.stub) return Promise.resolve(attachment);
        let binData;
        if (typeof attachment.data === 'string') {
            try {
                binData = (0, $4GdZ0.atob)(attachment.data);
            } catch (e) {
                return Promise.reject((0, $cqZVJ.createError)((0, $cqZVJ.BAD_ARG), 'Attachment is not a valid base64 string'));
            }
            if (metadata.idb_attachment_format === 'binary') attachment.data = (0, $4GdZ0.binaryStringToBlobOrBuffer)(binData, attachment.content_type);
        } else {
            binData = attachment.data;
            if (metadata.idb_attachment_format === 'base64') // TODO could run these in parallel, if we cared
            return new Promise((resolve)=>{
                (0, $4GdZ0.blobOrBufferToBase64)(attachment.data, function(b64) {
                    attachment.data = b64;
                    (0, $9Pw4Q.binaryMd5)(binData, function(result) {
                        attachment.digest = 'md5-' + result;
                        attachment.length = binData.size || binData.length || 0;
                        resolve(attachment);
                    });
                });
            });
        }
        return new Promise(function(resolve) {
            (0, $9Pw4Q.binaryMd5)(binData, function(result) {
                attachment.digest = 'md5-' + result;
                attachment.length = binData.size || binData.length || 0;
                resolve(attachment);
            });
        });
    }
    function preProcessAttachments() {
        const promises = docs.map(function(doc) {
            const data = doc.revs[doc.rev].data;
            if (!data._attachments) return Promise.resolve(data);
            const attachments = Object.keys(data._attachments).map(function(k) {
                data._attachments[k].name = k;
                return preProcessAttachment(data._attachments[k]);
            });
            return Promise.all(attachments).then(function(newAttachments) {
                const processed = {};
                newAttachments.forEach(function(attachment) {
                    processed[attachment.name] = attachment;
                    delete attachment.name;
                });
                data._attachments = processed;
                return data;
            });
        });
        return Promise.all(promises);
    }
    for(let i = 0, len = req.docs.length; i < len; i++){
        let result;
        // TODO: We should get rid of throwing for invalid docs, also not sure
        // why this is needed in idb-next and not idb
        try {
            result = (0, $2QQ9m.parseDoc)(req.docs[i], opts.new_edits, dbOpts);
        } catch (err) {
            result = err;
        }
        if (result.error) return callback(result);
        // Ideally parseDoc would return data in this format, but it is currently
        // shared so we need to convert
        docs.push(convertDocFormat(result));
    }
    preProcessAttachments().then(function() {
        // We _could_ check doc ids here, and skip opening DOC_STORE if all docs are local.
        // This may marginally slow things down for local docs.  It seems pragmatic to keep
        // the code simple and optimise for calls to bulkDocs() which include non-local docs.
        api._openTransactionSafely([
            $00ee3510475588eb$var$DOC_STORE,
            $00ee3510475588eb$var$META_LOCAL_STORE
        ], 'readwrite', function(err, _txn) {
            if (err) return callback(err);
            txn = _txn;
            txn.onabort = function() {
                callback(error || (0, $cqZVJ.createError)((0, $cqZVJ.UNKNOWN_ERROR), 'transaction was aborted'));
            };
            txn.ontimeout = $00ee3510475588eb$var$idbError(callback);
            txn.oncomplete = function() {
                idbChanges.notify(dbOpts.name);
                callback(null, results);
            };
            // We would like to use promises here, but idb sucks
            fetchExistingDocs(txn, docs);
        });
    }).catch(function(err) {
        callback(err);
    });
}
function $00ee3510475588eb$var$allDocsKeys(keys, docStore, allDocsInner) {
    // It's not guaranteed to be returned in right order
    const valuesBatch = new Array(keys.length);
    let count = 0;
    keys.forEach(function(key, index) {
        docStore.get(key).onsuccess = function(event) {
            if (event.target.result) valuesBatch[index] = event.target.result;
            else valuesBatch[index] = {
                key: key,
                error: 'not_found'
            };
            count++;
            if (count === keys.length) valuesBatch.forEach(function(doc) {
                allDocsInner(doc);
            });
        };
    });
}
function $00ee3510475588eb$var$createKeyRange(start, end, inclusiveStart, inclusiveEnd, key, descending) {
    try {
        if (key) return IDBKeyRange.only([
            0,
            key
        ]);
        else if (descending) return IDBKeyRange.bound(end, start, !inclusiveEnd, !inclusiveStart);
        else return IDBKeyRange.bound(start, end, !inclusiveStart, !inclusiveEnd);
    } catch (e) {
        return {
            error: e
        };
    }
}
function $00ee3510475588eb$var$handleKeyRangeError(opts, metadata, err, callback) {
    if (err.name === "DataError" && err.code === 0) {
        // data error, start is less than end
        const returnVal = {
            total_rows: metadata.doc_count,
            offset: opts.skip,
            rows: []
        };
        /* istanbul ignore if */ if (opts.update_seq) returnVal.update_seq = metadata.seq;
        return callback(null, returnVal);
    }
    callback((0, $cqZVJ.createError)((0, $cqZVJ.IDB_ERROR), err.name, err.message));
}
function $00ee3510475588eb$var$allDocs(txn, metadata, opts, callback) {
    if (txn.error) return callback(txn.error);
    // TODO: Weird hack, I don't like it
    if (opts.limit === 0) {
        const returnVal = {
            total_rows: metadata.doc_count,
            offset: opts.skip,
            rows: []
        };
        /* istanbul ignore if */ if (opts.update_seq) returnVal.update_seq = metadata.seq;
        return callback(null, returnVal);
    }
    const results = [];
    const processing = [];
    const key = 'key' in opts ? opts.key : false;
    const keys = 'keys' in opts ? opts.keys : false;
    let skip = opts.skip || 0;
    let limit = typeof opts.limit === 'number' ? opts.limit : undefined;
    const inclusiveEnd = opts.inclusive_end !== false;
    const descending = 'descending' in opts && opts.descending ? 'prev' : null;
    const start = 'startkey' in opts ? opts.startkey : descending ? '\uffff' : '';
    const end = 'endkey' in opts ? opts.endkey : descending ? '' : '\uffff';
    const docStore = txn.txn.objectStore($00ee3510475588eb$var$DOC_STORE);
    if (keys) {
        txn.txn.oncomplete = onTxnComplete;
        const allDocsInner = (doc)=>{
            if (doc.error) return results.push(doc);
            const row = {
                id: doc.id,
                key: doc.id,
                value: {
                    rev: doc.rev
                }
            };
            if (doc.deleted) {
                row.value.deleted = true;
                row.doc = null;
            } else if (opts.include_docs) include_doc(row, doc);
            results.push(row);
        };
        return $00ee3510475588eb$var$allDocsKeys(keys, docStore, allDocsInner);
    }
    let keyRange = $00ee3510475588eb$var$createKeyRange([
        0,
        start
    ], [
        0,
        end
    ], true, inclusiveEnd, key, descending);
    if (keyRange.error) return $00ee3510475588eb$var$handleKeyRangeError(opts, metadata, keyRange.error, callback);
    // txn.oncomplete must be set AFTER key-range-error is generated
    txn.txn.oncomplete = onTxnComplete;
    function include_doc(row, doc) {
        const docData = doc.revs[doc.rev].data;
        row.doc = docData;
        row.doc._id = doc.id;
        row.doc._rev = doc.rev;
        if (opts.conflicts) {
            const conflicts = (0, $eMG3m.collectConflicts)(doc);
            if (conflicts.length) row.doc._conflicts = conflicts;
        }
        if (opts.attachments && docData._attachments) for(const name in docData._attachments)processing.push($00ee3510475588eb$var$processAttachment(name, doc, row.doc, opts.binary, metadata.idb_attachment_format));
    }
    function onTxnComplete() {
        const returnVal = {
            total_rows: metadata.doc_count,
            offset: 0,
            rows: results
        };
        /* istanbul ignore if */ if (opts.update_seq) returnVal.update_seq = metadata.seq;
        if (processing.length) Promise.all(processing).then(function() {
            callback(null, returnVal);
        });
        else callback(null, returnVal);
    }
    const dbIndex = docStore.index('deleted,id');
    if (!skip && !limit) fetchResults();
    else {
        let firstKey;
        let limitKey = limit > 0;
        dbIndex.openKeyCursor(keyRange, descending || 'next').onsuccess = (e)=>{
            const cursor = e.target.result;
            if (skip) {
                if (!cursor) return txn.txn.commit();
                cursor.advance(skip);
                skip = 0;
                return;
            }
            if (firstKey === undefined) {
                firstKey = cursor && cursor.key;
                if (!firstKey) return txn.txn.commit();
            }
            if (limit) {
                if (limit > 1 && cursor) {
                    cursor.advance(limit - 1);
                    limit = undefined;
                    return;
                }
                limit = undefined;
            }
            if (limitKey) limitKey = cursor && cursor.key;
            if (!limitKey) limitKey = descending ? keyRange.lower : keyRange.upper;
            keyRange = $00ee3510475588eb$var$createKeyRange(firstKey, limitKey, true, inclusiveEnd, key, descending);
            if (keyRange.error) {
                txn.txn.abort();
                return $00ee3510475588eb$var$handleKeyRangeError(opts, metadata, keyRange.error, callback);
            }
            fetchResults();
        };
    }
    async function fetchResults() {
        // There is a risk here with getting all results into memory - if they have multiple
        // revs, then we risk loading loads of extra data which is then discarded.  This is
        // reduced by batching.  This also loads unused data when include_docs is false.
        //
        // Current batch size is quite arbitrary, but seems like (1) more than a typical
        // result size, and (2) not so big it's likely to cause issues.
        const batchSize = 100;
        let kr = keyRange;
        do kr = await fetchNextBatch(kr);
        while (kr);
        if (descending) results.reverse();
        return txn.txn.commit();
        function fetchNextBatch(kr) {
            return new Promise((resolve)=>{
                dbIndex.getAll(kr, batchSize).onsuccess = (e)=>{
                    const batch = e.target.result;
                    for(let i = 0; i < batch.length; ++i){
                        const doc = batch[i];
                        const row = {
                            id: doc.id,
                            key: doc.id,
                            value: {
                                rev: doc.rev
                            }
                        };
                        if (opts.include_docs) include_doc(row, doc);
                        results.push(row);
                    }
                    if (batch.length >= batchSize) {
                        const lastSeenKey = [
                            0,
                            batch[batch.length - 1].id
                        ];
                        const startKey = descending ? kr.upper : lastSeenKey;
                        const endKey = descending ? lastSeenKey : kr.upper;
                        if (startKey[1] !== endKey[1]) {
                            const incEnd = descending ? false : inclusiveEnd;
                            const incStart = descending ? true : false;
                            return resolve($00ee3510475588eb$var$createKeyRange(startKey, endKey, incStart, incEnd, key, descending));
                        }
                    }
                    return resolve();
                };
            });
        }
    }
}
function $00ee3510475588eb$var$changes(txn, idbChanges, api, dbOpts, opts) {
    if (txn.error) return opts.complete(txn.error);
    if (opts.continuous) {
        const id = dbOpts.name + ':' + (0, $47bZj.uuid)();
        idbChanges.addListener(dbOpts.name, id, api, opts);
        idbChanges.notify(dbOpts.name);
        return {
            cancel: function() {
                idbChanges.removeListener(dbOpts.name, id);
            }
        };
    }
    let limit = 'limit' in opts ? opts.limit : -1;
    if (limit === 0) limit = 1;
    const store = txn.txn.objectStore($00ee3510475588eb$var$DOC_STORE).index('seq');
    const filter = (0, $47bZj.filterChange)(opts);
    let received = 0;
    let lastSeq = opts.since || 0;
    const results = [];
    const processing = [];
    function onReqSuccess(e) {
        if (!e.target.result) return;
        const cursor = e.target.result;
        const doc = cursor.value;
        // Overwrite doc.data, which may have been rewritten (see rewrite.js) with
        // the clean version for that rev
        doc.data = doc.revs[doc.rev].data;
        doc.data._id = doc.id;
        doc.data._rev = doc.rev;
        if (doc.deleted) doc.data._deleted = true;
        if (opts.doc_ids && opts.doc_ids.indexOf(doc.id) === -1) return cursor.continue();
        // WARNING: expecting possible old format
        const change = opts.processChange(doc.data, doc, opts);
        change.seq = doc.seq;
        lastSeq = doc.seq;
        const filtered = filter(change);
        // If its an error
        if (typeof filtered === 'object') return opts.complete(filtered);
        if (filtered) {
            received++;
            if (opts.return_docs) results.push(change);
            if (opts.include_docs && opts.attachments && doc.data._attachments) {
                const promises = [];
                for(const name in doc.data._attachments){
                    const p = $00ee3510475588eb$var$processAttachment(name, doc, change.doc, opts.binary, api.blobSupport);
                    // We add the processing promise to 2 arrays, one tracks all
                    // the promises needed before we fire onChange, the other
                    // ensure we process all attachments before onComplete
                    promises.push(p);
                    processing.push(p);
                }
                Promise.all(promises).then(function() {
                    opts.onChange(change);
                });
            } else opts.onChange(change);
        }
        if (received !== limit) cursor.continue();
    }
    function onTxnComplete() {
        Promise.all(processing).then(function() {
            opts.complete(null, {
                results: results,
                last_seq: lastSeq
            });
        });
    }
    let req;
    if (opts.descending) req = store.openCursor(null, 'prev');
    else req = store.openCursor(IDBKeyRange.lowerBound(opts.since, true));
    txn.txn.oncomplete = onTxnComplete;
    req.onsuccess = onReqSuccess;
}
function $00ee3510475588eb$var$getRevisionTree(txn, id, callback) {
    if (txn.error) return callback(txn.error);
    const req = txn.txn.objectStore($00ee3510475588eb$var$DOC_STORE).get(id);
    req.onsuccess = function(e) {
        if (!e.target.result) callback((0, $cqZVJ.createError)((0, $cqZVJ.MISSING_DOC)));
        else callback(null, e.target.result.rev_tree);
    };
}
function $00ee3510475588eb$var$doCompaction(txn, id, revs, callback) {
    if (txn.error) return callback(txn.error);
    const docStore = txn.txn.objectStore($00ee3510475588eb$var$DOC_STORE);
    docStore.get(id).onsuccess = function(e) {
        const doc = e.target.result;
        (0, $eMG3m.traverseRevTree)(doc.rev_tree, function(isLeaf, pos, revHash, ctx, opts) {
            const rev = pos + '-' + revHash;
            if (revs.indexOf(rev) !== -1) opts.status = 'missing';
        });
        const attachments = [];
        revs.forEach(function(rev) {
            if (rev in doc.revs) {
                // Make a list of attachments that are used by the revisions being
                // deleted
                if (doc.revs[rev].data._attachments) for(const k in doc.revs[rev].data._attachments)attachments.push(doc.revs[rev].data._attachments[k].digest);
                delete doc.revs[rev];
            }
        });
        // Attachments have a list of revisions that are using them, when
        // that list becomes empty we can delete the attachment.
        attachments.forEach(function(digest) {
            revs.forEach(function(rev) {
                delete doc.attachments[digest].revs[rev];
            });
            if (!Object.keys(doc.attachments[digest].revs).length) delete doc.attachments[digest];
        });
        docStore.put(doc);
    };
    txn.txn.oncomplete = function() {
        callback();
    };
}
function $00ee3510475588eb$var$destroy(dbOpts, openDatabases, idbChanges, callback) {
    idbChanges.removeAllListeners(dbOpts.name);
    function doDestroy() {
        const req = indexedDB.deleteDatabase(dbOpts.name);
        req.onsuccess = function() {
            delete openDatabases[dbOpts.name];
            callback(null, {
                ok: true
            });
        };
    }
    // If the database is open we need to close it
    if (dbOpts.name in openDatabases) openDatabases[dbOpts.name].then(function(res) {
        res.idb.close();
        doDestroy();
    });
    else doDestroy();
}
// Adapted from
// https://github.com/pouchdb/pouchdb/blob/master/packages/node_modules/pouchdb-find/src/adapters/local/find/query-planner.js#L20-L24
// This could change / improve in the future?
const $00ee3510475588eb$var$COUCH_COLLATE_LO = null;
const $00ee3510475588eb$var$COUCH_COLLATE_HI = '\uffff'; // actually used as {"\uffff": {}}
// Adapted from: https://www.w3.org/TR/IndexedDB/#compare-two-keys
// Importantly, *there is no upper bound possible* in idb. The ideal data
// structure an infinitely deep array:
//   const IDB_COLLATE_HI = []; IDB_COLLATE_HI.push(IDB_COLLATE_HI)
// But IDBKeyRange is not a fan of shenanigans, so I've just gone with 12 layers
// because it looks nice and surely that's enough!
const $00ee3510475588eb$var$IDB_COLLATE_LO = Number.NEGATIVE_INFINITY;
const $00ee3510475588eb$var$IDB_COLLATE_HI = [
    [
        [
            [
                [
                    [
                        [
                            [
                                [
                                    [
                                        [
                                            []
                                        ]
                                    ]
                                ]
                            ]
                        ]
                    ]
                ]
            ]
        ]
    ]
];
//
// TODO: this should be made offical somewhere and used by AllDocs / get /
// changes etc as well.
//
function $00ee3510475588eb$var$externaliseRecord(idbDoc) {
    const doc = idbDoc.revs[idbDoc.rev].data;
    doc._id = idbDoc.id;
    doc._rev = idbDoc.rev;
    if (idbDoc.deleted) doc._deleted = true;
    return doc;
}
/**
 * Generates a keyrange based on the opts passed to query
 *
 * The first key is always 0, as that's how we're filtering out deleted entries.
 */ function $00ee3510475588eb$var$generateKeyRange(opts) {
    function defined(obj, k) {
        return obj[k] !== void 0;
    }
    // Converts a valid CouchDB key into a valid IndexedDB one
    function convert(key, exact) {
        // The first item in every native index is doc.deleted, and we always want
        // to only search documents that are not deleted.
        // "foo" -> [0, "foo"]
        const filterDeleted = [
            0
        ].concat(key);
        return filterDeleted.map(function(k) {
            // null, true and false are not indexable by indexeddb. When we write
            // these values we convert them to these constants, and so when we
            // query for them we need to convert the query also.
            if (k === null && exact) // for non-exact queries we treat null as a collate property
            // see `if (!exact)` block below
            return $00ee3510475588eb$var$IDB_NULL;
            else if (k === true) return $00ee3510475588eb$var$IDB_TRUE;
            else if (k === false) return $00ee3510475588eb$var$IDB_FALSE;
            if (!exact) {
                // We get passed CouchDB's collate low and high values, so for non-exact
                // ranged queries we're going to convert them to our IDB equivalents
                if (k === $00ee3510475588eb$var$COUCH_COLLATE_LO) return $00ee3510475588eb$var$IDB_COLLATE_LO;
                else if (Object.prototype.hasOwnProperty.call(k, $00ee3510475588eb$var$COUCH_COLLATE_HI)) return $00ee3510475588eb$var$IDB_COLLATE_HI;
            }
            return k;
        });
    }
    // CouchDB and so PouchdB defaults to true. We need to make this explicit as
    // we invert these later for IndexedDB.
    if (!defined(opts, 'inclusive_end')) opts.inclusive_end = true;
    if (!defined(opts, 'inclusive_start')) opts.inclusive_start = true;
    if (opts.descending) {
        // Flip before generating. We'll check descending again later when performing
        // an index request
        const realEndkey = opts.startkey, realInclusiveEnd = opts.inclusive_start;
        opts.startkey = opts.endkey;
        opts.endkey = realEndkey;
        opts.inclusive_start = opts.inclusive_end;
        opts.inclusive_end = realInclusiveEnd;
    }
    try {
        if (defined(opts, 'key')) return IDBKeyRange.only(convert(opts.key, true));
        if (defined(opts, 'startkey') && !defined(opts, 'endkey')) // lowerBound, but without the deleted docs.
        // [1] is the start of the deleted doc range, and we don't want to include then.
        return IDBKeyRange.bound(convert(opts.startkey), [
            1
        ], !opts.inclusive_start, true);
        if (!defined(opts, 'startkey') && defined(opts, 'endkey')) return IDBKeyRange.upperBound(convert(opts.endkey), !opts.inclusive_end);
        if (defined(opts, 'startkey') && defined(opts, 'endkey')) return IDBKeyRange.bound(convert(opts.startkey), convert(opts.endkey), !opts.inclusive_start, !opts.inclusive_end);
        return IDBKeyRange.only([
            0
        ]);
    } catch (err) {
        console.error('Could not generate keyRange', err, opts);
        throw Error('Could not generate key range with ' + JSON.stringify(opts));
    }
}
function $00ee3510475588eb$var$getIndexHandle(pdb, fields, reject) {
    const indexName = $00ee3510475588eb$var$naturalIndexName(fields);
    return new Promise(function(resolve) {
        pdb._openTransactionSafely([
            $00ee3510475588eb$var$DOC_STORE
        ], 'readonly', function(err, txn) {
            if (err) return $00ee3510475588eb$var$idbError(reject)(err);
            txn.onabort = $00ee3510475588eb$var$idbError(reject);
            txn.ontimeout = $00ee3510475588eb$var$idbError(reject);
            const existingIndexNames = Array.from(txn.objectStore($00ee3510475588eb$var$DOC_STORE).indexNames);
            if (existingIndexNames.indexOf(indexName) === -1) // The index is missing, force a db restart and try again
            pdb._freshen().then(function() {
                return $00ee3510475588eb$var$getIndexHandle(pdb, fields, reject);
            }).then(resolve);
            else resolve(txn.objectStore($00ee3510475588eb$var$DOC_STORE).index(indexName));
        });
    });
}
// In theory we should return something like the doc example below, but find
// only needs rows: [{doc: {...}}], so I think we can just not bother for now
// {
//   "offset" : 0,
//   "rows": [{
//     "id": "doc3",
//     "key": "Lisa Says",
//     "value": null,
//     "doc": {
//       "_id": "doc3",
//       "_rev": "1-z",
//       "title": "Lisa Says"
//     }
//   }],
//   "total_rows" : 4
// }
function $00ee3510475588eb$var$query(idb, signature, opts, fallback) {
    // At this stage, in the current implementation, find has already gone through
    // and determined if the index already exists from PouchDB's perspective (eg
    // there is a design doc for it).
    //
    // If we find that the index doesn't exist this means we have to close and
    // re-open the DB to correct indexes before proceeding, at which point the
    // index should exist.
    const pdb = this;
    // Assumption, there will be only one /, between the design document name
    // and the view name.
    const parts = signature.split('/');
    return new Promise(function(resolve, reject) {
        pdb.get('_design/' + parts[0]).then(function(ddoc) {
            if ($00ee3510475588eb$var$isPartialFilterView(ddoc, parts[1])) // Fix for #8522
            // An IndexedDB index is always over all entries. And there is no way to filter them.
            // Therefore the normal findAbstractMapper will be used
            // for indexes with partial_filter_selector.
            return fallback(signature, opts).then(resolve, reject);
            const fields = $00ee3510475588eb$var$rawIndexFields(ddoc, parts[1]);
            if (!fields) throw new Error('ddoc ' + ddoc._id + ' with view ' + parts[1] + ' does not have map.options.def.fields defined.');
            let skip = opts.skip;
            let limit = Number.isInteger(opts.limit) && opts.limit;
            return $00ee3510475588eb$var$getIndexHandle(pdb, fields, reject).then(function(indexHandle) {
                const keyRange = $00ee3510475588eb$var$generateKeyRange(opts);
                const req = indexHandle.openCursor(keyRange, opts.descending ? 'prev' : 'next');
                const rows = [];
                req.onerror = $00ee3510475588eb$var$idbError(reject);
                req.onsuccess = function(e) {
                    const cursor = e.target.result;
                    if (!cursor || limit === 0) return resolve({
                        rows: rows
                    });
                    if (skip) {
                        cursor.advance(skip);
                        skip = false;
                        return;
                    }
                    if (limit) limit = limit - 1;
                    rows.push({
                        doc: $00ee3510475588eb$var$externaliseRecord(cursor.value)
                    });
                    cursor.continue();
                };
            });
        }).catch(reject);
    });
}
function $00ee3510475588eb$var$viewCleanup(idb, fallback) {
    // I'm not sure we have to do anything here.
    //
    // One option is to just close and re-open the DB, which performs the same
    // action. The only reason you'd want to call this is if you deleted a bunch
    // of indexes and wanted the space back immediately.
    //
    // Otherwise index cleanup happens when:
    //  - A DB is opened
    //  - A find query is performed against an index that doesn't exist but should
    // Fix for #8522
    // On views with partial_filter_selector the standard find-abstract-mapper is used.
    // Its indexes must be cleaned up.
    // Fallback is the standard viewCleanup.
    return fallback();
}
function $00ee3510475588eb$var$purgeAttachments(doc, revs) {
    if (!doc.attachments) // If there are no attachments, doc.attachments is an empty object
    return {};
    // Iterate over all attachments and remove the respective revs
    for(let key in doc.attachments){
        const attachment = doc.attachments[key];
        for (let rev of revs)if (attachment.revs[rev]) delete attachment.revs[rev];
        if (Object.keys(attachment.revs).length === 0) delete doc.attachments[key];
    }
    return doc.attachments;
}
// `purge()` expects a path of revisions in its revs argument that:
// - starts with a leaf rev
// - continues sequentially with the remaining revs of that leaf’s branch
//
// eg. for this rev tree:
// 1-9692 ▶ 2-37aa ▶ 3-df22 ▶ 4-6e94 ▶ 5-df4a ▶ 6-6a3a ▶ 7-57e5
//          ┃                 ┗━━━━━━▶ 5-8d8c ▶ 6-65e0
//          ┗━━━━━━▶ 3-43f6 ▶ 4-a3b4
//
// …if you wanted to purge '7-57e5', you would provide ['7-57e5', '6-6a3a', '5-df4a']
//
// The purge adapter implementation in `pouchdb-core` uses the helper function `findPathToLeaf`
// from `pouchdb-merge` to construct this array correctly. Since this purge implementation is
// only ever called from there, we do no additional checks here as to whether `revs` actually
// fulfills the criteria above, since `findPathToLeaf` already does these.
function $00ee3510475588eb$var$purge(txn, docId, revs, callback) {
    if (txn.error) return callback(txn.error);
    const docStore = txn.txn.objectStore($00ee3510475588eb$var$DOC_STORE);
    const deletedRevs = [];
    let documentWasRemovedCompletely = false;
    docStore.get(docId).onsuccess = (e)=>{
        const doc = e.target.result;
        // we could do a dry run here to check if revs is a proper path towards a leaf in the rev tree
        for (const rev of revs){
            // purge rev from tree
            doc.rev_tree = (0, $eMG3m.removeLeafFromTree)(doc.rev_tree, rev);
            // assign new revs
            delete doc.revs[rev];
            deletedRevs.push(rev);
        }
        if (doc.rev_tree.length === 0) {
            // if the rev tree is empty, we can delete the entire document
            docStore.delete(doc.id);
            documentWasRemovedCompletely = true;
            return;
        }
        // find new winning rev
        doc.rev = (0, $eMG3m.winningRev)(doc);
        doc.data = doc.revs[doc.rev].data;
        doc.attachments = $00ee3510475588eb$var$purgeAttachments(doc, revs);
        // finally, write the purged doc
        docStore.put(doc);
    };
    txn.txn.oncomplete = function() {
        callback(null, {
            ok: true,
            deletedRevs: deletedRevs,
            documentWasRemovedCompletely: documentWasRemovedCompletely
        });
    };
}
const $00ee3510475588eb$var$ADAPTER_NAME = 'indexeddb';
// TODO: Constructor should be capitalised
const $00ee3510475588eb$var$idbChanges = new (0, $47bZj.changesHandler)();
// A shared list of database handles
const $00ee3510475588eb$var$openDatabases = {};
function $00ee3510475588eb$var$IndexeddbPouch(dbOpts, callback) {
    if (dbOpts.view_adapter) console.log('Please note that the indexeddb adapter manages _find indexes itself, therefore it is not using your specified view_adapter');
    const api = this;
    let metadata = {};
    // Wrapper that gives you an active DB handle. You probably want $t.
    const $ = function(fun) {
        return function() {
            const args = Array.prototype.slice.call(arguments);
            $00ee3510475588eb$var$setup($00ee3510475588eb$var$openDatabases, api, dbOpts).then(function(res) {
                metadata = res.metadata;
                args.unshift(res.idb);
                fun.apply(api, args);
            }).catch(function(err) {
                const last = args.pop();
                if (typeof last === 'function') last(err);
                else console.error(err);
            });
        };
    };
    // the promise version of $
    const $p = function(fun) {
        return function() {
            const args = Array.prototype.slice.call(arguments);
            return $00ee3510475588eb$var$setup($00ee3510475588eb$var$openDatabases, api, dbOpts).then(function(res) {
                metadata = res.metadata;
                args.unshift(res.idb);
                return fun.apply(api, args);
            });
        };
    };
    // Wrapper that gives you a safe transaction handle. It's important to use
    // this instead of opening your own transaction from a db handle got from $,
    // because in the time between getting the db handle and opening the
    // transaction it may have been invalidated by index changes.
    const $t = function(fun, stores, mode) {
        mode = mode || 'readonly';
        return function() {
            const args = Array.prototype.slice.call(arguments);
            const txn = {};
            $00ee3510475588eb$var$setup($00ee3510475588eb$var$openDatabases, api, dbOpts).then(function(res) {
                metadata = res.metadata;
                txn.txn = res.idb.transaction(stores, mode);
            }).catch(function(err) {
                console.error('Failed to establish transaction safely');
                console.error(err);
                txn.error = err;
            }).then(function() {
                args.unshift(txn);
                fun.apply(api, args);
            });
        };
    };
    api._openTransactionSafely = function(stores, mode, callback) {
        $t(function(txn, callback) {
            callback(txn.error, txn.txn);
        }, stores, mode)(callback);
    };
    api._remote = false;
    api.type = function() {
        return $00ee3510475588eb$var$ADAPTER_NAME;
    };
    api._id = $(function(_, cb) {
        cb(null, metadata.db_uuid);
    });
    api._info = $(function(_, cb) {
        return $00ee3510475588eb$var$info(metadata, cb);
    });
    api._get = $t($00ee3510475588eb$var$get, [
        $00ee3510475588eb$var$DOC_STORE
    ]);
    api._getLocal = $t(function(txn, id, callback) {
        return $00ee3510475588eb$var$getLocal(txn, id, api, callback);
    }, [
        $00ee3510475588eb$var$META_LOCAL_STORE
    ]);
    api._bulkDocs = $(function(_, req, opts, callback) {
        $00ee3510475588eb$var$bulkDocs(api, req, opts, metadata, dbOpts, $00ee3510475588eb$var$idbChanges, callback);
    });
    api._allDocs = $t(function(txn, opts, cb) {
        $00ee3510475588eb$var$allDocs(txn, metadata, opts, cb);
    }, [
        $00ee3510475588eb$var$DOC_STORE
    ]);
    api._getAttachment = $00ee3510475588eb$var$getAttachment;
    api._changes = $t(function(txn, opts) {
        $00ee3510475588eb$var$changes(txn, $00ee3510475588eb$var$idbChanges, api, dbOpts, opts);
    }, [
        $00ee3510475588eb$var$DOC_STORE
    ]);
    api._getRevisionTree = $t($00ee3510475588eb$var$getRevisionTree, [
        $00ee3510475588eb$var$DOC_STORE
    ]);
    api._doCompaction = $t($00ee3510475588eb$var$doCompaction, [
        $00ee3510475588eb$var$DOC_STORE
    ], 'readwrite');
    api._customFindAbstractMapper = {
        query: $p($00ee3510475588eb$var$query),
        viewCleanup: $p($00ee3510475588eb$var$viewCleanup)
    };
    api._destroy = function(opts, callback) {
        return $00ee3510475588eb$var$destroy(dbOpts, $00ee3510475588eb$var$openDatabases, $00ee3510475588eb$var$idbChanges, callback);
    };
    api._close = $(function(db, cb) {
        delete $00ee3510475588eb$var$openDatabases[dbOpts.name];
        db.close();
        cb();
    });
    // Closing and re-opening the DB re-generates native indexes
    api._freshen = function() {
        return new Promise(function(resolve) {
            api._close(function() {
                $(resolve)();
            });
        });
    };
    api._purge = $t($00ee3510475588eb$var$purge, [
        $00ee3510475588eb$var$DOC_STORE
    ], 'readwrite');
    // TODO: this setTimeout seems nasty, if its needed lets
    // figure out / explain why
    setTimeout(function() {
        callback(null, api);
    });
}
// TODO: this isnt really valid permanently, just being lazy to start
$00ee3510475588eb$var$IndexeddbPouch.valid = function() {
    return true;
};
function $00ee3510475588eb$var$index(PouchDB) {
    PouchDB.adapter($00ee3510475588eb$var$ADAPTER_NAME, $00ee3510475588eb$var$IndexeddbPouch, true);
}
var $00ee3510475588eb$export$2e2bcd8739ae039 = $00ee3510475588eb$var$index;

});
parcelRegister("4GdZ0", function(module, exports) {

$parcel$export(module.exports, "atob", () => $3685ee64af703018$export$1406ac7a6dfd7b7a);
$parcel$export(module.exports, "btoa", () => $3685ee64af703018$export$a32219e24f8d1e2);
$parcel$export(module.exports, "blob", () => $3685ee64af703018$export$8cf3c1c9f525ba2);
$parcel$export(module.exports, "binaryStringToBlobOrBuffer", () => $3685ee64af703018$export$f8affdb4ed24f842);
$parcel$export(module.exports, "base64StringToBlobOrBuffer", () => $3685ee64af703018$export$ebcfc2720544f18f);
$parcel$export(module.exports, "readAsBinaryString", () => $3685ee64af703018$export$fdd8f9ce05f169b5);
$parcel$export(module.exports, "blobOrBufferToBinaryString", () => $3685ee64af703018$export$5521aa1cc74b3680);
$parcel$export(module.exports, "blobOrBufferToBase64", () => $3685ee64af703018$export$49e89d37d58272c4);
$parcel$export(module.exports, "readAsArrayBuffer", () => $3685ee64af703018$export$742462d331993995);
var $3685ee64af703018$export$1406ac7a6dfd7b7a = function(str) {
    return atob(str);
};
var $3685ee64af703018$export$a32219e24f8d1e2 = function(str) {
    return btoa(str);
};
// Abstracts constructing a Blob object, so it also works in older
// browsers that don't support the native Blob constructor (e.g.
// old QtWebKit versions, Android < 4.4).
function $3685ee64af703018$export$8cf3c1c9f525ba2(parts, properties) {
    /* global BlobBuilder,MSBlobBuilder,MozBlobBuilder,WebKitBlobBuilder */ parts = parts || [];
    properties = properties || {};
    try {
        return new Blob(parts, properties);
    } catch (e) {
        if (e.name !== "TypeError") throw e;
        var Builder = typeof BlobBuilder !== 'undefined' ? BlobBuilder : typeof MSBlobBuilder !== 'undefined' ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined' ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for(var i = 0; i < parts.length; i += 1)builder.append(parts[i]);
        return builder.getBlob(properties.type);
    }
}
// From http://stackoverflow.com/questions/14967647/ (continues on next line)
// encode-decode-image-with-base64-breaks-image (2013-04-21)
function $3685ee64af703018$export$c320b6d4be31b980(bin) {
    var length = bin.length;
    var buf = new ArrayBuffer(length);
    var arr = new Uint8Array(buf);
    for(var i = 0; i < length; i++)arr[i] = bin.charCodeAt(i);
    return buf;
}
function $3685ee64af703018$export$f8affdb4ed24f842(binString, type) {
    return $3685ee64af703018$export$8cf3c1c9f525ba2([
        $3685ee64af703018$export$c320b6d4be31b980(binString)
    ], {
        type: type
    });
}
function $3685ee64af703018$export$ebcfc2720544f18f(b64, type) {
    return $3685ee64af703018$export$f8affdb4ed24f842($3685ee64af703018$export$1406ac7a6dfd7b7a(b64), type);
}
//Can't find original post, but this is close
//http://stackoverflow.com/questions/6965107/ (continues on next line)
//converting-between-strings-and-arraybuffers
function $3685ee64af703018$var$arrayBufferToBinaryString(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var length = bytes.byteLength;
    for(var i = 0; i < length; i++)binary += String.fromCharCode(bytes[i]);
    return binary;
}
// shim for browsers that don't support it
function $3685ee64af703018$export$fdd8f9ce05f169b5(blob, callback) {
    var reader = new FileReader();
    var hasBinaryString = typeof reader.readAsBinaryString === 'function';
    reader.onloadend = function(e) {
        var result = e.target.result || '';
        if (hasBinaryString) return callback(result);
        callback($3685ee64af703018$var$arrayBufferToBinaryString(result));
    };
    if (hasBinaryString) reader.readAsBinaryString(blob);
    else reader.readAsArrayBuffer(blob);
}
function $3685ee64af703018$export$5521aa1cc74b3680(blobOrBuffer, callback) {
    $3685ee64af703018$export$fdd8f9ce05f169b5(blobOrBuffer, function(bin) {
        callback(bin);
    });
}
function $3685ee64af703018$export$49e89d37d58272c4(blobOrBuffer, callback) {
    $3685ee64af703018$export$5521aa1cc74b3680(blobOrBuffer, function(base64) {
        callback($3685ee64af703018$export$a32219e24f8d1e2(base64));
    });
}
// simplified API. universal browser support is assumed
function $3685ee64af703018$export$742462d331993995(blob, callback) {
    var reader = new FileReader();
    reader.onloadend = function(e) {
        var result = e.target.result || new ArrayBuffer(0);
        callback(result);
    };
    reader.readAsArrayBuffer(blob);
}
// this is not used in the browser
function $3685ee64af703018$export$32c5cc57b6f0b4a() {}

});

parcelRegister("2QQ9m", function(module, exports) {

$parcel$export(module.exports, "checkBlobSupport", () => $2138e4015da5d937$export$422d2a858ee369d);
$parcel$export(module.exports, "parseDoc", () => $2138e4015da5d937$export$5db361593220645);
$parcel$export(module.exports, "isLocalId", () => (parcelRequire("eMG3m")).isLocalId);

var $47bZj = parcelRequire("47bZj");

var $4GdZ0 = parcelRequire("4GdZ0");

var $9Pw4Q = parcelRequire("9Pw4Q");

var $cqZVJ = parcelRequire("cqZVJ");

var $eMG3m = parcelRequire("eMG3m");
function $2138e4015da5d937$export$63f9f01545e70393(api, opts) {
    var keys = opts.keys;
    var finalResults = {
        offset: opts.skip
    };
    return Promise.all(keys.map(function(key) {
        var subOpts = Object.assign({
            key: key,
            deleted: 'ok'
        }, opts);
        [
            'limit',
            'skip',
            'keys'
        ].forEach(function(optKey) {
            delete subOpts[optKey];
        });
        return new Promise(function(resolve, reject) {
            api._allDocs(subOpts, function(err, res) {
                /* istanbul ignore if */ if (err) return reject(err);
                /* istanbul ignore if */ if (opts.update_seq && res.update_seq !== undefined) finalResults.update_seq = res.update_seq;
                finalResults.total_rows = res.total_rows;
                resolve(res.rows[0] || {
                    key: key,
                    error: 'not_found'
                });
            });
        });
    })).then(function(results) {
        finalResults.rows = results;
        return finalResults;
    });
}
//
// Blobs are not supported in all versions of IndexedDB, notably
// Chrome <37, Android <5 and (some?) webkit-based browsers.
// In those versions, storing a blob will throw.
//
// Example Webkit error:
// > DataCloneError: Failed to store record in an IDBObjectStore: BlobURLs are not yet supported.
//
// Various other blob bugs exist in Chrome v37-42 (inclusive).
// Detecting them is expensive and confusing to users, and Chrome 37-42
// is at very low usage worldwide, so we do a hacky userAgent check instead.
//
// content-type bug: https://code.google.com/p/chromium/issues/detail?id=408120
// 404 bug: https://code.google.com/p/chromium/issues/detail?id=447916
// FileReader bug: https://code.google.com/p/chromium/issues/detail?id=447836
//
function $2138e4015da5d937$export$422d2a858ee369d(txn, store, docIdOrCreateDoc) {
    return new Promise(function(resolve) {
        var blob$$1 = (0, $4GdZ0.blob)([
            ''
        ]);
        let req;
        if (typeof docIdOrCreateDoc === 'function') {
            // Store may require a specific key path, in which case we can't store the
            // blob directly in the store.
            const createDoc = docIdOrCreateDoc;
            const doc = createDoc(blob$$1);
            req = txn.objectStore(store).put(doc);
        } else {
            const docId = docIdOrCreateDoc;
            req = txn.objectStore(store).put(blob$$1, docId);
        }
        req.onsuccess = function() {
            var matchedChrome = navigator.userAgent.match(/Chrome\/(\d+)/);
            var matchedEdge = navigator.userAgent.match(/Edge\//);
            // MS Edge pretends to be Chrome 42:
            // https://msdn.microsoft.com/en-us/library/hh869301%28v=vs.85%29.aspx
            resolve(matchedEdge || !matchedChrome || parseInt(matchedChrome[1], 10) >= 43);
        };
        req.onerror = txn.onabort = function(e) {
            // If the transaction aborts now its due to not being able to
            // write to the database, likely due to the disk being full
            e.preventDefault();
            e.stopPropagation();
            resolve(false);
        };
    }).catch(function() {
        return false; // error, so assume unsupported
    });
}
function $2138e4015da5d937$var$toObject(array) {
    return array.reduce(function(obj, item) {
        obj[item] = true;
        return obj;
    }, {});
}
// List of top level reserved words for doc
var $2138e4015da5d937$var$reservedWords = $2138e4015da5d937$var$toObject([
    '_id',
    '_rev',
    '_access',
    '_attachments',
    '_deleted',
    '_revisions',
    '_revs_info',
    '_conflicts',
    '_deleted_conflicts',
    '_local_seq',
    '_rev_tree',
    // replication documents
    '_replication_id',
    '_replication_state',
    '_replication_state_time',
    '_replication_state_reason',
    '_replication_stats',
    // Specific to Couchbase Sync Gateway
    '_removed'
]);
// List of reserved words that should end up in the document
var $2138e4015da5d937$var$dataWords = $2138e4015da5d937$var$toObject([
    '_access',
    '_attachments',
    // replication documents
    '_replication_id',
    '_replication_state',
    '_replication_state_time',
    '_replication_state_reason',
    '_replication_stats'
]);
function $2138e4015da5d937$var$parseRevisionInfo(rev$$1) {
    if (!/^\d+-/.test(rev$$1)) return (0, $cqZVJ.createError)((0, $cqZVJ.INVALID_REV));
    var idx = rev$$1.indexOf('-');
    var left = rev$$1.substring(0, idx);
    var right = rev$$1.substring(idx + 1);
    return {
        prefix: parseInt(left, 10),
        id: right
    };
}
function $2138e4015da5d937$var$makeRevTreeFromRevisions(revisions, opts) {
    var pos = revisions.start - revisions.ids.length + 1;
    var revisionIds = revisions.ids;
    var ids = [
        revisionIds[0],
        opts,
        []
    ];
    for(var i = 1, len = revisionIds.length; i < len; i++)ids = [
        revisionIds[i],
        {
            status: 'missing'
        },
        [
            ids
        ]
    ];
    return [
        {
            pos: pos,
            ids: ids
        }
    ];
}
// Preprocess documents, parse their revisions, assign an id and a
// revision for new writes that are missing them, etc
function $2138e4015da5d937$export$5db361593220645(doc, newEdits, dbOpts) {
    if (!dbOpts) dbOpts = {
        deterministic_revs: true
    };
    var nRevNum;
    var newRevId;
    var revInfo;
    var opts = {
        status: 'available'
    };
    if (doc._deleted) opts.deleted = true;
    if (newEdits) {
        if (!doc._id) doc._id = (0, $47bZj.uuid)();
        newRevId = (0, $47bZj.rev)(doc, dbOpts.deterministic_revs);
        if (doc._rev) {
            revInfo = $2138e4015da5d937$var$parseRevisionInfo(doc._rev);
            if (revInfo.error) return revInfo;
            doc._rev_tree = [
                {
                    pos: revInfo.prefix,
                    ids: [
                        revInfo.id,
                        {
                            status: 'missing'
                        },
                        [
                            [
                                newRevId,
                                opts,
                                []
                            ]
                        ]
                    ]
                }
            ];
            nRevNum = revInfo.prefix + 1;
        } else {
            doc._rev_tree = [
                {
                    pos: 1,
                    ids: [
                        newRevId,
                        opts,
                        []
                    ]
                }
            ];
            nRevNum = 1;
        }
    } else {
        if (doc._revisions) {
            doc._rev_tree = $2138e4015da5d937$var$makeRevTreeFromRevisions(doc._revisions, opts);
            nRevNum = doc._revisions.start;
            newRevId = doc._revisions.ids[0];
        }
        if (!doc._rev_tree) {
            revInfo = $2138e4015da5d937$var$parseRevisionInfo(doc._rev);
            if (revInfo.error) return revInfo;
            nRevNum = revInfo.prefix;
            newRevId = revInfo.id;
            doc._rev_tree = [
                {
                    pos: nRevNum,
                    ids: [
                        newRevId,
                        opts,
                        []
                    ]
                }
            ];
        }
    }
    (0, $47bZj.invalidIdError)(doc._id);
    doc._rev = nRevNum + '-' + newRevId;
    var result = {
        metadata: {},
        data: {}
    };
    for(var key in doc)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(doc, key)) {
        var specialKey = key[0] === '_';
        if (specialKey && !$2138e4015da5d937$var$reservedWords[key]) {
            var error = (0, $cqZVJ.createError)((0, $cqZVJ.DOC_VALIDATION), key);
            error.message = (0, $cqZVJ.DOC_VALIDATION).message + ': ' + key;
            throw error;
        } else if (specialKey && !$2138e4015da5d937$var$dataWords[key]) result.metadata[key.slice(1)] = doc[key];
        else result.data[key] = doc[key];
    }
    return result;
}
function $2138e4015da5d937$var$parseBase64(data) {
    try {
        return (0, $4GdZ0.atob)(data);
    } catch (e) {
        var err = (0, $cqZVJ.createError)((0, $cqZVJ.BAD_ARG), 'Attachment is not a valid base64 string');
        return {
            error: err
        };
    }
}
function $2138e4015da5d937$var$preprocessString(att, blobType, callback) {
    var asBinary = $2138e4015da5d937$var$parseBase64(att.data);
    if (asBinary.error) return callback(asBinary.error);
    att.length = asBinary.length;
    if (blobType === 'blob') att.data = (0, $4GdZ0.binaryStringToBlobOrBuffer)(asBinary, att.content_type);
    else if (blobType === 'base64') att.data = (0, $4GdZ0.btoa)(asBinary);
    else att.data = asBinary;
    (0, $9Pw4Q.binaryMd5)(asBinary, function(result) {
        att.digest = 'md5-' + result;
        callback();
    });
}
function $2138e4015da5d937$var$preprocessBlob(att, blobType, callback) {
    (0, $9Pw4Q.binaryMd5)(att.data, function(md5) {
        att.digest = 'md5-' + md5;
        // size is for blobs (browser), length is for buffers (node)
        att.length = att.data.size || att.data.length || 0;
        if (blobType === 'binary') (0, $4GdZ0.blobOrBufferToBinaryString)(att.data, function(binString) {
            att.data = binString;
            callback();
        });
        else if (blobType === 'base64') (0, $4GdZ0.blobOrBufferToBase64)(att.data, function(b64) {
            att.data = b64;
            callback();
        });
        else callback();
    });
}
function $2138e4015da5d937$var$preprocessAttachment(att, blobType, callback) {
    if (att.stub) return callback();
    if (typeof att.data === 'string') $2138e4015da5d937$var$preprocessString(att, blobType, callback);
    else $2138e4015da5d937$var$preprocessBlob(att, blobType, callback);
}
function $2138e4015da5d937$export$df6eda7bab3ea23(docInfos, blobType, callback) {
    if (!docInfos.length) return callback();
    var docv = 0;
    var overallErr;
    docInfos.forEach(function(docInfo) {
        var attachments = docInfo.data && docInfo.data._attachments ? Object.keys(docInfo.data._attachments) : [];
        var recv = 0;
        if (!attachments.length) return done();
        function processedAttachment(err) {
            overallErr = err;
            recv++;
            if (recv === attachments.length) done();
        }
        for(var key in docInfo.data._attachments)if (Object.prototype.hasOwnProperty.call(docInfo.data._attachments, key)) $2138e4015da5d937$var$preprocessAttachment(docInfo.data._attachments[key], blobType, processedAttachment);
    });
    function done() {
        docv++;
        if (docInfos.length === docv) {
            if (overallErr) callback(overallErr);
            else callback();
        }
    }
}
function $2138e4015da5d937$export$22d1fdd1e73faff2(revLimit, prev, docInfo, results, i, cb, writeDoc, newEdits) {
    if ((0, $eMG3m.revExists)(prev.rev_tree, docInfo.metadata.rev) && !newEdits) {
        results[i] = docInfo;
        return cb();
    }
    // sometimes this is pre-calculated. historically not always
    var previousWinningRev = prev.winningRev || (0, $eMG3m.winningRev)(prev);
    var previouslyDeleted = 'deleted' in prev ? prev.deleted : (0, $eMG3m.isDeleted)(prev, previousWinningRev);
    var deleted = 'deleted' in docInfo.metadata ? docInfo.metadata.deleted : (0, $eMG3m.isDeleted)(docInfo.metadata);
    var isRoot = /^1-/.test(docInfo.metadata.rev);
    if (previouslyDeleted && !deleted && newEdits && isRoot) {
        var newDoc = docInfo.data;
        newDoc._rev = previousWinningRev;
        newDoc._id = docInfo.metadata.id;
        docInfo = $2138e4015da5d937$export$5db361593220645(newDoc, newEdits);
    }
    var merged = (0, $eMG3m.merge)(prev.rev_tree, docInfo.metadata.rev_tree[0], revLimit);
    var inConflict = newEdits && (previouslyDeleted && deleted && merged.conflicts !== 'new_leaf' || !previouslyDeleted && merged.conflicts !== 'new_leaf' || previouslyDeleted && !deleted && merged.conflicts === 'new_branch');
    if (inConflict) {
        var err = (0, $cqZVJ.createError)((0, $cqZVJ.REV_CONFLICT));
        results[i] = err;
        return cb();
    }
    var newRev = docInfo.metadata.rev;
    docInfo.metadata.rev_tree = merged.tree;
    docInfo.stemmedRevs = merged.stemmedRevs || [];
    /* istanbul ignore else */ if (prev.rev_map) docInfo.metadata.rev_map = prev.rev_map; // used only by leveldb
    // recalculate
    var winningRev$$1 = (0, $eMG3m.winningRev)(docInfo.metadata);
    var winningRevIsDeleted = (0, $eMG3m.isDeleted)(docInfo.metadata, winningRev$$1);
    // calculate the total number of documents that were added/removed,
    // from the perspective of total_rows/doc_count
    var delta = previouslyDeleted === winningRevIsDeleted ? 0 : previouslyDeleted < winningRevIsDeleted ? -1 : 1;
    var newRevIsDeleted;
    if (newRev === winningRev$$1) // if the new rev is the same as the winning rev, we can reuse that value
    newRevIsDeleted = winningRevIsDeleted;
    else // if they're not the same, then we need to recalculate
    newRevIsDeleted = (0, $eMG3m.isDeleted)(docInfo.metadata, newRev);
    writeDoc(docInfo, winningRev$$1, winningRevIsDeleted, newRevIsDeleted, true, delta, i, cb);
}
function $2138e4015da5d937$var$rootIsMissing(docInfo) {
    return docInfo.metadata.rev_tree[0].ids[1].status === 'missing';
}
function $2138e4015da5d937$export$303bc22fd1f47a5a(revLimit, docInfos, api, fetchedDocs, tx, results, writeDoc, opts, overallCallback) {
    // Default to 1000 locally
    revLimit = revLimit || 1000;
    function insertDoc(docInfo, resultsIdx, callback) {
        // Cant insert new deleted documents
        var winningRev$$1 = (0, $eMG3m.winningRev)(docInfo.metadata);
        var deleted = (0, $eMG3m.isDeleted)(docInfo.metadata, winningRev$$1);
        if ('was_delete' in opts && deleted) {
            results[resultsIdx] = (0, $cqZVJ.createError)((0, $cqZVJ.MISSING_DOC), 'deleted');
            return callback();
        }
        // 4712 - detect whether a new document was inserted with a _rev
        var inConflict = newEdits && $2138e4015da5d937$var$rootIsMissing(docInfo);
        if (inConflict) {
            var err = (0, $cqZVJ.createError)((0, $cqZVJ.REV_CONFLICT));
            results[resultsIdx] = err;
            return callback();
        }
        var delta = deleted ? 0 : 1;
        writeDoc(docInfo, winningRev$$1, deleted, deleted, false, delta, resultsIdx, callback);
    }
    var newEdits = opts.new_edits;
    var idsToDocs = new Map();
    var docsDone = 0;
    var docsToDo = docInfos.length;
    function checkAllDocsDone() {
        if (++docsDone === docsToDo && overallCallback) overallCallback();
    }
    docInfos.forEach(function(currentDoc, resultsIdx) {
        if (currentDoc._id && (0, $eMG3m.isLocalId)(currentDoc._id)) {
            var fun = currentDoc._deleted ? '_removeLocal' : '_putLocal';
            api[fun](currentDoc, {
                ctx: tx
            }, function(err, res) {
                results[resultsIdx] = err || res;
                checkAllDocsDone();
            });
            return;
        }
        var id = currentDoc.metadata.id;
        if (idsToDocs.has(id)) {
            docsToDo--; // duplicate
            idsToDocs.get(id).push([
                currentDoc,
                resultsIdx
            ]);
        } else idsToDocs.set(id, [
            [
                currentDoc,
                resultsIdx
            ]
        ]);
    });
    // in the case of new_edits, the user can provide multiple docs
    // with the same id. these need to be processed sequentially
    idsToDocs.forEach(function(docs, id) {
        var numDone = 0;
        function docWritten() {
            if (++numDone < docs.length) nextDoc();
            else checkAllDocsDone();
        }
        function nextDoc() {
            var value = docs[numDone];
            var currentDoc = value[0];
            var resultsIdx = value[1];
            if (fetchedDocs.has(id)) $2138e4015da5d937$export$22d1fdd1e73faff2(revLimit, fetchedDocs.get(id), currentDoc, results, resultsIdx, docWritten, writeDoc, newEdits);
            else {
                // Ensure stemming applies to new writes as well
                var merged = (0, $eMG3m.merge)([], currentDoc.metadata.rev_tree[0], revLimit);
                currentDoc.metadata.rev_tree = merged.tree;
                currentDoc.stemmedRevs = merged.stemmedRevs || [];
                insertDoc(currentDoc, resultsIdx, docWritten);
            }
        }
        nextDoc();
    });
}

});
parcelRegister("47bZj", function(module, exports) {

$parcel$export(module.exports, "clone", () => $2ff11d64fb07c789$export$9cd59f9826255e47);
$parcel$export(module.exports, "once", () => $2ff11d64fb07c789$export$d2de3aaeafa91619);
$parcel$export(module.exports, "adapterFun", () => $2ff11d64fb07c789$export$9c08e8d0fb09fefe);
$parcel$export(module.exports, "pick", () => $2ff11d64fb07c789$export$357523c63a2253b9);
$parcel$export(module.exports, "bulkGetShim", () => $2ff11d64fb07c789$export$8c43b5f81b7fedde);
$parcel$export(module.exports, "hasLocalStorage", () => $2ff11d64fb07c789$export$c65995f51d426373);
$parcel$export(module.exports, "nextTick", () => $2ff11d64fb07c789$export$bdd553fddd433dcb);
$parcel$export(module.exports, "changesHandler", () => $2ff11d64fb07c789$export$894f4f379d4fc404);
$parcel$export(module.exports, "guardedConsole", () => $2ff11d64fb07c789$export$f455835668ef8b19);
$parcel$export(module.exports, "defaultBackOff", () => $2ff11d64fb07c789$export$83825888f6107d83);
$parcel$export(module.exports, "explainError", () => $2ff11d64fb07c789$export$4d94562d06fe503b);
$parcel$export(module.exports, "filterChange", () => $2ff11d64fb07c789$export$11132bd71abbab0c);
$parcel$export(module.exports, "invalidIdError", () => $2ff11d64fb07c789$export$18b293cfb0ba6f8f);
$parcel$export(module.exports, "isRemote", () => $2ff11d64fb07c789$export$bf57a4ec28897b05);
$parcel$export(module.exports, "listenerCount", () => $2ff11d64fb07c789$export$68ec3fc188497192);
$parcel$export(module.exports, "parseDdocFunctionName", () => $2ff11d64fb07c789$export$2e89f61a5d4b173b);
$parcel$export(module.exports, "normalizeDdocFunctionName", () => $2ff11d64fb07c789$export$73cbec7175559a19);
$parcel$export(module.exports, "scopeEval", () => $2ff11d64fb07c789$export$a42befa6e53a739d);
$parcel$export(module.exports, "upsert", () => $2ff11d64fb07c789$export$c5b6061cfde15602);
$parcel$export(module.exports, "rev", () => $2ff11d64fb07c789$export$edb1c8e715f3944e);
$parcel$export(module.exports, "uuid", () => $2ff11d64fb07c789$export$31b40729666a4ae0);

var $cqZVJ = parcelRequire("cqZVJ");

var $9KgKE = parcelRequire("9KgKE");

var $6fzQb = parcelRequire("6fzQb");

var $9Pw4Q = parcelRequire("9Pw4Q");
function $2ff11d64fb07c789$var$isBinaryObject(object) {
    return typeof ArrayBuffer !== 'undefined' && object instanceof ArrayBuffer || typeof Blob !== 'undefined' && object instanceof Blob;
}
/**
 * @template {ArrayBuffer | Blob} T
 * @param {T} object
 * @returns {T}
 */ function $2ff11d64fb07c789$var$cloneBinaryObject(object) {
    return object instanceof ArrayBuffer ? object.slice(0) : object.slice(0, object.size, object.type);
}
// most of this is borrowed from lodash.isPlainObject:
// https://github.com/fis-components/lodash.isplainobject/
// blob/29c358140a74f252aeb08c9eb28bef86f2217d4a/index.js
var $2ff11d64fb07c789$var$funcToString = Function.prototype.toString;
var $2ff11d64fb07c789$var$objectCtorString = $2ff11d64fb07c789$var$funcToString.call(Object);
function $2ff11d64fb07c789$var$isPlainObject(value) {
    var proto = Object.getPrototypeOf(value);
    /* istanbul ignore if */ if (proto === null) return true;
    var Ctor = proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $2ff11d64fb07c789$var$funcToString.call(Ctor) == $2ff11d64fb07c789$var$objectCtorString;
}
function $2ff11d64fb07c789$export$9cd59f9826255e47(object) {
    var newObject;
    var i;
    var len;
    if (!object || typeof object !== 'object') return object;
    if (Array.isArray(object)) {
        newObject = [];
        for(i = 0, len = object.length; i < len; i++)newObject[i] = $2ff11d64fb07c789$export$9cd59f9826255e47(object[i]);
        return newObject;
    }
    // special case: to avoid inconsistencies between IndexedDB
    // and other backends, we automatically stringify Dates
    if (object instanceof Date && isFinite(object)) return object.toISOString();
    if ($2ff11d64fb07c789$var$isBinaryObject(object)) return $2ff11d64fb07c789$var$cloneBinaryObject(object);
    if (!$2ff11d64fb07c789$var$isPlainObject(object)) return object; // don't clone objects like Workers
    newObject = {};
    for(i in object)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(object, i)) {
        var value = $2ff11d64fb07c789$export$9cd59f9826255e47(object[i]);
        if (typeof value !== 'undefined') newObject[i] = value;
    }
    return newObject;
}
function $2ff11d64fb07c789$export$d2de3aaeafa91619(fun) {
    var called = false;
    return function(...args) {
        /* istanbul ignore if */ if (called) // this is a smoke test and should never actually happen
        throw new Error('once called more than once');
        else {
            called = true;
            fun.apply(this, args);
        }
    };
}
function $2ff11d64fb07c789$export$4dbaaf6c79705e6c(func) {
    //create the function we will be returning
    return function(...args) {
        // Clone arguments
        args = $2ff11d64fb07c789$export$9cd59f9826255e47(args);
        var self = this;
        // if the last argument is a function, assume its a callback
        var usedCB = typeof args[args.length - 1] === 'function' ? args.pop() : false;
        var promise = new Promise(function(fulfill, reject) {
            var resp;
            try {
                var callback = $2ff11d64fb07c789$export$d2de3aaeafa91619(function(err, mesg) {
                    if (err) reject(err);
                    else fulfill(mesg);
                });
                // create a callback for this invocation
                // apply the function in the orig context
                args.push(callback);
                resp = func.apply(self, args);
                if (resp && typeof resp.then === 'function') fulfill(resp);
            } catch (e) {
                reject(e);
            }
        });
        // if there is a callback, call it back
        if (usedCB) promise.then(function(result) {
            usedCB(null, result);
        }, usedCB);
        return promise;
    };
}
function $2ff11d64fb07c789$var$logApiCall(self, name, args) {
    /* istanbul ignore if */ if (self.constructor.listeners('debug').length) {
        var logArgs = [
            'api',
            self.name,
            name
        ];
        for(var i = 0; i < args.length - 1; i++)logArgs.push(args[i]);
        self.constructor.emit('debug', logArgs);
        // override the callback itself to log the response
        var origCallback = args[args.length - 1];
        args[args.length - 1] = function(err, res) {
            var responseArgs = [
                'api',
                self.name,
                name
            ];
            responseArgs = responseArgs.concat(err ? [
                'error',
                err
            ] : [
                'success',
                res
            ]);
            self.constructor.emit('debug', responseArgs);
            origCallback(err, res);
        };
    }
}
function $2ff11d64fb07c789$export$9c08e8d0fb09fefe(name, callback) {
    return $2ff11d64fb07c789$export$4dbaaf6c79705e6c(function(...args) {
        if (this._closed) return Promise.reject(new Error('database is closed'));
        if (this._destroyed) return Promise.reject(new Error('database is destroyed'));
        var self = this;
        $2ff11d64fb07c789$var$logApiCall(self, name, args);
        if (!this.taskqueue.isReady) return new Promise(function(fulfill, reject) {
            self.taskqueue.addTask(function(failed) {
                if (failed) reject(failed);
                else fulfill(self[name].apply(self, args));
            });
        });
        return callback.apply(this, args);
    });
}
// like underscore/lodash _.pick()
function $2ff11d64fb07c789$export$357523c63a2253b9(obj, arr) {
    var res = {};
    for(var i = 0, len = arr.length; i < len; i++){
        var prop = arr[i];
        if (prop in obj) res[prop] = obj[prop];
    }
    return res;
}
// Most browsers throttle concurrent requests at 6, so it's silly
// to shim _bulk_get by trying to launch potentially hundreds of requests
// and then letting the majority time out. We can handle this ourselves.
var $2ff11d64fb07c789$var$MAX_NUM_CONCURRENT_REQUESTS = 6;
function $2ff11d64fb07c789$var$identityFunction(x) {
    return x;
}
function $2ff11d64fb07c789$var$formatResultForOpenRevsGet(result) {
    return [
        {
            ok: result
        }
    ];
}
// shim for P/CouchDB adapters that don't directly implement _bulk_get
function $2ff11d64fb07c789$export$8c43b5f81b7fedde(db, opts, callback) {
    var requests = opts.docs;
    // consolidate into one request per doc if possible
    var requestsById = new Map();
    requests.forEach(function(request) {
        if (requestsById.has(request.id)) requestsById.get(request.id).push(request);
        else requestsById.set(request.id, [
            request
        ]);
    });
    var numDocs = requestsById.size;
    var numDone = 0;
    var perDocResults = new Array(numDocs);
    function collapseResultsAndFinish() {
        var results = [];
        perDocResults.forEach(function(res) {
            res.docs.forEach(function(info) {
                results.push({
                    id: res.id,
                    docs: [
                        info
                    ]
                });
            });
        });
        callback(null, {
            results: results
        });
    }
    function checkDone() {
        if (++numDone === numDocs) collapseResultsAndFinish();
    }
    function gotResult(docIndex, id, docs) {
        perDocResults[docIndex] = {
            id: id,
            docs: docs
        };
        checkDone();
    }
    var allRequests = [];
    requestsById.forEach(function(value, key) {
        allRequests.push(key);
    });
    var i = 0;
    function nextBatch() {
        if (i >= allRequests.length) return;
        var upTo = Math.min(i + $2ff11d64fb07c789$var$MAX_NUM_CONCURRENT_REQUESTS, allRequests.length);
        var batch = allRequests.slice(i, upTo);
        processBatch(batch, i);
        i += batch.length;
    }
    function processBatch(batch, offset) {
        batch.forEach(function(docId, j) {
            var docIdx = offset + j;
            var docRequests = requestsById.get(docId);
            // just use the first request as the "template"
            // TODO: The _bulk_get API allows for more subtle use cases than this,
            // but for now it is unlikely that there will be a mix of different
            // "atts_since" or "attachments" in the same request, since it's just
            // replicate.js that is using this for the moment.
            // Also, atts_since is aspirational, since we don't support it yet.
            var docOpts = $2ff11d64fb07c789$export$357523c63a2253b9(docRequests[0], [
                'atts_since',
                'attachments'
            ]);
            docOpts.open_revs = docRequests.map(function(request) {
                // rev is optional, open_revs disallowed
                return request.rev;
            });
            // remove falsey / undefined revisions
            docOpts.open_revs = docOpts.open_revs.filter($2ff11d64fb07c789$var$identityFunction);
            var formatResult = $2ff11d64fb07c789$var$identityFunction;
            if (docOpts.open_revs.length === 0) {
                delete docOpts.open_revs;
                // when fetching only the "winning" leaf,
                // transform the result so it looks like an open_revs
                // request
                formatResult = $2ff11d64fb07c789$var$formatResultForOpenRevsGet;
            }
            // globally-supplied options
            [
                'revs',
                'attachments',
                'binary',
                'ajax',
                'latest'
            ].forEach(function(param) {
                if (param in opts) docOpts[param] = opts[param];
            });
            db.get(docId, docOpts, function(err, res) {
                var result;
                /* istanbul ignore if */ if (err) result = [
                    {
                        error: err
                    }
                ];
                else result = formatResult(res);
                gotResult(docIdx, docId, result);
                nextBatch();
            });
        });
    }
    nextBatch();
}
var $2ff11d64fb07c789$var$hasLocal;
try {
    localStorage.setItem('_pouch_check_localstorage', 1);
    $2ff11d64fb07c789$var$hasLocal = !!localStorage.getItem('_pouch_check_localstorage');
} catch (e) {
    $2ff11d64fb07c789$var$hasLocal = false;
}
function $2ff11d64fb07c789$export$c65995f51d426373() {
    return $2ff11d64fb07c789$var$hasLocal;
}
const $2ff11d64fb07c789$export$bdd553fddd433dcb = typeof queueMicrotask === "function" ? queueMicrotask : function nextTick(fn) {
    Promise.resolve().then(fn);
};
class $2ff11d64fb07c789$export$894f4f379d4fc404 extends (0, (/*@__PURE__*/$parcel$interopDefault($9KgKE))) {
    constructor(){
        super();
        this._listeners = {};
        if ($2ff11d64fb07c789$export$c65995f51d426373()) addEventListener("storage", (e)=>{
            this.emit(e.key);
        });
    }
    addListener(dbName, id, db, opts) {
        if (this._listeners[id]) return;
        var inprogress = false;
        var self = this;
        function eventFunction() {
            if (!self._listeners[id]) return;
            if (inprogress) {
                inprogress = 'waiting';
                return;
            }
            inprogress = true;
            var changesOpts = $2ff11d64fb07c789$export$357523c63a2253b9(opts, [
                'style',
                'include_docs',
                'attachments',
                'conflicts',
                'filter',
                'doc_ids',
                'view',
                'since',
                'query_params',
                'binary',
                'return_docs'
            ]);
            function onError() {
                inprogress = false;
            }
            db.changes(changesOpts).on('change', function(c) {
                if (c.seq > opts.since && !opts.cancelled) {
                    opts.since = c.seq;
                    opts.onChange(c);
                }
            }).on('complete', function() {
                if (inprogress === 'waiting') $2ff11d64fb07c789$export$bdd553fddd433dcb(eventFunction);
                inprogress = false;
            }).on('error', onError);
        }
        this._listeners[id] = eventFunction;
        this.on(dbName, eventFunction);
    }
    removeListener(dbName, id) {
        if (!(id in this._listeners)) return;
        super.removeListener(dbName, this._listeners[id]);
        delete this._listeners[id];
    }
    notifyLocalWindows(dbName) {
        //do a useless change on a storage thing
        //in order to get other windows's listeners to activate
        if ($2ff11d64fb07c789$export$c65995f51d426373()) localStorage[dbName] = localStorage[dbName] === "a" ? "b" : "a";
    }
    notify(dbName) {
        this.emit(dbName);
        this.notifyLocalWindows(dbName);
    }
}
function $2ff11d64fb07c789$export$f455835668ef8b19(method) {
    /* istanbul ignore else */ if (typeof console !== 'undefined' && typeof console[method] === 'function') {
        var args = Array.prototype.slice.call(arguments, 1);
        console[method].apply(console, args);
    }
}
function $2ff11d64fb07c789$var$randomNumber(min, max) {
    var maxTimeout = 600000; // Hard-coded default of 10 minutes
    min = parseInt(min, 10) || 0;
    max = parseInt(max, 10);
    if (max !== max || max <= min) max = (min || 1) << 1; //doubling
    else max = max + 1;
    // In order to not exceed maxTimeout, pick a random value between half of maxTimeout and maxTimeout
    if (max > maxTimeout) {
        min = maxTimeout >> 1; // divide by two
        max = maxTimeout;
    }
    var ratio = Math.random();
    var range = max - min;
    return ~~(range * ratio + min); // ~~ coerces to an int, but fast.
}
function $2ff11d64fb07c789$export$83825888f6107d83(min) {
    var max = 0;
    if (!min) max = 2000;
    return $2ff11d64fb07c789$var$randomNumber(min, max);
}
// designed to give info to browser users, who are disturbed
// when they see http errors in the console
function $2ff11d64fb07c789$export$4d94562d06fe503b(status, str) {
    $2ff11d64fb07c789$export$f455835668ef8b19('info', 'The above ' + status + ' is totally normal. ' + str);
}
function $2ff11d64fb07c789$var$tryFilter(filter, doc, req) {
    try {
        return !filter(doc, req);
    } catch (err) {
        var msg = 'Filter function threw: ' + err.toString();
        return (0, $cqZVJ.createError)((0, $cqZVJ.BAD_REQUEST), msg);
    }
}
function $2ff11d64fb07c789$export$11132bd71abbab0c(opts) {
    var req = {};
    var hasFilter = opts.filter && typeof opts.filter === 'function';
    req.query = opts.query_params;
    return function filter(change) {
        if (!change.doc) // CSG sends events on the changes feed that don't have documents,
        // this hack makes a whole lot of existing code robust.
        change.doc = {};
        var filterReturn = hasFilter && $2ff11d64fb07c789$var$tryFilter(opts.filter, change.doc, req);
        if (typeof filterReturn === 'object') return filterReturn;
        if (filterReturn) return false;
        if (!opts.include_docs) delete change.doc;
        else if (!opts.attachments) {
            for(var att in change.doc._attachments)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(change.doc._attachments, att)) change.doc._attachments[att].stub = true;
        }
        return true;
    };
}
// shim for Function.prototype.name,
// for browsers that don't support it like IE
/* istanbul ignore next */ function $2ff11d64fb07c789$var$f() {}
var $2ff11d64fb07c789$var$hasName = $2ff11d64fb07c789$var$f.name;
var $2ff11d64fb07c789$var$res;
// We don't run coverage in IE
/* istanbul ignore else */ if ($2ff11d64fb07c789$var$hasName) $2ff11d64fb07c789$var$res = function(fun) {
    return fun.name;
};
else $2ff11d64fb07c789$var$res = function(fun) {
    var match = fun.toString().match(/^\s*function\s*(?:(\S+)\s*)?\(/);
    if (match && match[1]) return match[1];
    else return '';
};
var $2ff11d64fb07c789$export$84c48ba556ba6f42 = $2ff11d64fb07c789$var$res;
// Determine id an ID is valid
//   - invalid IDs begin with an underescore that does not begin '_design' or
//     '_local'
//   - any other string value is a valid id
// Returns the specific error object for each case
function $2ff11d64fb07c789$export$18b293cfb0ba6f8f(id) {
    var err;
    if (!id) err = (0, $cqZVJ.createError)((0, $cqZVJ.MISSING_ID));
    else if (typeof id !== 'string') err = (0, $cqZVJ.createError)((0, $cqZVJ.INVALID_ID));
    else if (/^_/.test(id) && !/^_(design|local)/.test(id)) err = (0, $cqZVJ.createError)((0, $cqZVJ.RESERVED_ID));
    if (err) throw err;
}
// Checks if a PouchDB object is "remote" or not. This is
function $2ff11d64fb07c789$export$bf57a4ec28897b05(db) {
    if (typeof db._remote === 'boolean') return db._remote;
    /* istanbul ignore next */ if (typeof db.type === 'function') {
        $2ff11d64fb07c789$export$f455835668ef8b19('warn', "db.type() is deprecated and will be removed in a future version of PouchDB");
        return db.type() === 'http';
    }
    /* istanbul ignore next */ return false;
}
function $2ff11d64fb07c789$export$68ec3fc188497192(ee, type) {
    return 'listenerCount' in ee ? ee.listenerCount(type) : (0, (/*@__PURE__*/$parcel$interopDefault($9KgKE))).listenerCount(ee, type);
}
function $2ff11d64fb07c789$export$2e89f61a5d4b173b(s) {
    if (!s) return null;
    var parts = s.split('/');
    if (parts.length === 2) return parts;
    if (parts.length === 1) return [
        s,
        s
    ];
    return null;
}
function $2ff11d64fb07c789$export$73cbec7175559a19(s) {
    var normalized = $2ff11d64fb07c789$export$2e89f61a5d4b173b(s);
    return normalized ? normalized.join('/') : null;
}
// originally parseUri 1.2.2, now patched by us
// (c) Steven Levithan <stevenlevithan.com>
// MIT License
var $2ff11d64fb07c789$var$keys = [
    "source",
    "protocol",
    "authority",
    "userInfo",
    "user",
    "password",
    "host",
    "port",
    "relative",
    "path",
    "directory",
    "file",
    "query",
    "anchor"
];
var $2ff11d64fb07c789$var$qName = "queryKey";
var $2ff11d64fb07c789$var$qParser = /(?:^|&)([^&=]*)=?([^&]*)/g;
// use the "loose" parser
/* eslint no-useless-escape: 0 */ var $2ff11d64fb07c789$var$parser = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
function $2ff11d64fb07c789$export$59f58847421cfb28(str) {
    var m = $2ff11d64fb07c789$var$parser.exec(str);
    var uri = {};
    var i = 14;
    while(i--){
        var key = $2ff11d64fb07c789$var$keys[i];
        var value = m[i] || "";
        var encoded = [
            'user',
            'password'
        ].indexOf(key) !== -1;
        uri[key] = encoded ? decodeURIComponent(value) : value;
    }
    uri[$2ff11d64fb07c789$var$qName] = {};
    uri[$2ff11d64fb07c789$var$keys[12]].replace($2ff11d64fb07c789$var$qParser, function($0, $1, $2) {
        if ($1) uri[$2ff11d64fb07c789$var$qName][$1] = $2;
    });
    return uri;
}
// Based on https://github.com/alexdavid/scope-eval v0.0.3
// (source: https://unpkg.com/scope-eval@0.0.3/scope_eval.js)
// This is basically just a wrapper around new Function()
function $2ff11d64fb07c789$export$a42befa6e53a739d(source, scope) {
    var keys = [];
    var values = [];
    for(var key in scope)if (Object.prototype.hasOwnProperty.call(scope, key)) {
        keys.push(key);
        values.push(scope[key]);
    }
    keys.push(source);
    return Function.apply(null, keys).apply(null, values);
}
// this is essentially the "update sugar" function from daleharvey/pouchdb#1388
// the diffFun tells us what delta to apply to the doc.  it either returns
// the doc, or false if it doesn't need to do an update after all
function $2ff11d64fb07c789$export$c5b6061cfde15602(db, docId, diffFun) {
    return db.get(docId).catch(function(err) {
        /* istanbul ignore next */ if (err.status !== 404) throw err;
        return {};
    }).then(function(doc) {
        // the user might change the _rev, so save it for posterity
        var docRev = doc._rev;
        var newDoc = diffFun(doc);
        if (!newDoc) // if the diffFun returns falsy, we short-circuit as
        // an optimization
        return {
            updated: false,
            rev: docRev
        };
        // users aren't allowed to modify these values,
        // so reset them here
        newDoc._id = docId;
        newDoc._rev = docRev;
        return $2ff11d64fb07c789$var$tryAndPut(db, newDoc, diffFun);
    });
}
function $2ff11d64fb07c789$var$tryAndPut(db, doc, diffFun) {
    return db.put(doc).then(function(res) {
        return {
            updated: true,
            rev: res.rev
        };
    }, function(err) {
        /* istanbul ignore next */ if (err.status !== 409) throw err;
        return $2ff11d64fb07c789$export$c5b6061cfde15602(db, doc._id, diffFun);
    });
}
/**
 * Creates a new revision string that does NOT include the revision height
 * For example '56649f1b0506c6ca9fda0746eb0cacdf'
 */ function $2ff11d64fb07c789$export$edb1c8e715f3944e(doc, deterministic_revs) {
    if (!deterministic_revs) return (0, $6fzQb.default)().replace(/-/g, '').toLowerCase();
    var mutateableDoc = Object.assign({}, doc);
    delete mutateableDoc._rev_tree;
    return (0, $9Pw4Q.stringMd5)(JSON.stringify(mutateableDoc));
}
var $2ff11d64fb07c789$export$31b40729666a4ae0 = (0, $6fzQb.default); // mimic old import, only v4 is ever used elsewhere

});
parcelRegister("cqZVJ", function(module, exports) {

$parcel$export(module.exports, "MISSING_BULK_DOCS", () => $90d7f3c5701fc606$export$b6dbe9d13c2c3ea0);
$parcel$export(module.exports, "MISSING_DOC", () => $90d7f3c5701fc606$export$3b7a625f54771430);
$parcel$export(module.exports, "REV_CONFLICT", () => $90d7f3c5701fc606$export$87dfbd133b9fd156);
$parcel$export(module.exports, "INVALID_ID", () => $90d7f3c5701fc606$export$f3931813aa797982);
$parcel$export(module.exports, "MISSING_ID", () => $90d7f3c5701fc606$export$5caa553dd7a1cf56);
$parcel$export(module.exports, "RESERVED_ID", () => $90d7f3c5701fc606$export$81f0f999acc3c37c);
$parcel$export(module.exports, "UNKNOWN_ERROR", () => $90d7f3c5701fc606$export$f10b32dfda12e96e);
$parcel$export(module.exports, "BAD_ARG", () => $90d7f3c5701fc606$export$7aca2dc2a982266d);
$parcel$export(module.exports, "QUERY_PARSE_ERROR", () => $90d7f3c5701fc606$export$ebcae161db85c6cf);
$parcel$export(module.exports, "DOC_VALIDATION", () => $90d7f3c5701fc606$export$8e96485f5819a055);
$parcel$export(module.exports, "BAD_REQUEST", () => $90d7f3c5701fc606$export$9de493bcd9b1d977);
$parcel$export(module.exports, "NOT_AN_OBJECT", () => $90d7f3c5701fc606$export$92ee7c3b740be11);
$parcel$export(module.exports, "IDB_ERROR", () => $90d7f3c5701fc606$export$d48fb67a0bfeb4c8);
$parcel$export(module.exports, "INVALID_REV", () => $90d7f3c5701fc606$export$822ae76cf9a8355f);
$parcel$export(module.exports, "MISSING_STUB", () => $90d7f3c5701fc606$export$fbd13c9329e752f);
$parcel$export(module.exports, "createError", () => $90d7f3c5701fc606$export$c8c8fcba3f9476cc);
$parcel$export(module.exports, "generateErrorFromResponse", () => $90d7f3c5701fc606$export$a5b025532a1e2490);
class $90d7f3c5701fc606$var$PouchError extends Error {
    constructor(status, error, reason){
        super();
        this.status = status;
        this.name = error;
        this.message = reason;
        this.error = true;
    }
    toString() {
        return JSON.stringify({
            status: this.status,
            name: this.name,
            message: this.message,
            reason: this.reason
        });
    }
}
var $90d7f3c5701fc606$export$67d19e9a991baa07 = new $90d7f3c5701fc606$var$PouchError(401, 'unauthorized', "Name or password is incorrect.");
var $90d7f3c5701fc606$export$b6dbe9d13c2c3ea0 = new $90d7f3c5701fc606$var$PouchError(400, 'bad_request', "Missing JSON list of 'docs'");
var $90d7f3c5701fc606$export$3b7a625f54771430 = new $90d7f3c5701fc606$var$PouchError(404, 'not_found', 'missing');
var $90d7f3c5701fc606$export$87dfbd133b9fd156 = new $90d7f3c5701fc606$var$PouchError(409, 'conflict', 'Document update conflict');
var $90d7f3c5701fc606$export$f3931813aa797982 = new $90d7f3c5701fc606$var$PouchError(400, 'bad_request', '_id field must contain a string');
var $90d7f3c5701fc606$export$5caa553dd7a1cf56 = new $90d7f3c5701fc606$var$PouchError(412, 'missing_id', '_id is required for puts');
var $90d7f3c5701fc606$export$81f0f999acc3c37c = new $90d7f3c5701fc606$var$PouchError(400, 'bad_request', 'Only reserved document ids may start with underscore.');
var $90d7f3c5701fc606$export$baae4244bd81b9f8 = new $90d7f3c5701fc606$var$PouchError(412, 'precondition_failed', 'Database not open');
var $90d7f3c5701fc606$export$f10b32dfda12e96e = new $90d7f3c5701fc606$var$PouchError(500, 'unknown_error', 'Database encountered an unknown error');
var $90d7f3c5701fc606$export$7aca2dc2a982266d = new $90d7f3c5701fc606$var$PouchError(500, 'badarg', 'Some query argument is invalid');
var $90d7f3c5701fc606$export$c77b2f9ece3946ce = new $90d7f3c5701fc606$var$PouchError(400, 'invalid_request', 'Request was invalid');
var $90d7f3c5701fc606$export$ebcae161db85c6cf = new $90d7f3c5701fc606$var$PouchError(400, 'query_parse_error', 'Some query parameter is invalid');
var $90d7f3c5701fc606$export$8e96485f5819a055 = new $90d7f3c5701fc606$var$PouchError(500, 'doc_validation', 'Bad special document member');
var $90d7f3c5701fc606$export$9de493bcd9b1d977 = new $90d7f3c5701fc606$var$PouchError(400, 'bad_request', 'Something wrong with the request');
var $90d7f3c5701fc606$export$92ee7c3b740be11 = new $90d7f3c5701fc606$var$PouchError(400, 'bad_request', 'Document must be a JSON object');
var $90d7f3c5701fc606$export$2ed8ab8e1b9458cf = new $90d7f3c5701fc606$var$PouchError(404, 'not_found', 'Database not found');
var $90d7f3c5701fc606$export$d48fb67a0bfeb4c8 = new $90d7f3c5701fc606$var$PouchError(500, 'indexed_db_went_bad', 'unknown');
var $90d7f3c5701fc606$export$10fd9621ef58c615 = new $90d7f3c5701fc606$var$PouchError(500, 'web_sql_went_bad', 'unknown');
var $90d7f3c5701fc606$export$6b095d4e4678be7e = new $90d7f3c5701fc606$var$PouchError(500, 'levelDB_went_went_bad', 'unknown');
var $90d7f3c5701fc606$export$a3269a3914b007e3 = new $90d7f3c5701fc606$var$PouchError(403, 'forbidden', 'Forbidden by design doc validate_doc_update function');
var $90d7f3c5701fc606$export$822ae76cf9a8355f = new $90d7f3c5701fc606$var$PouchError(400, 'bad_request', 'Invalid rev format');
var $90d7f3c5701fc606$export$ba88c91a5311620f = new $90d7f3c5701fc606$var$PouchError(412, 'file_exists', 'The database could not be created, the file already exists.');
var $90d7f3c5701fc606$export$fbd13c9329e752f = new $90d7f3c5701fc606$var$PouchError(412, 'missing_stub', 'A pre-existing attachment stub wasn\'t found');
var $90d7f3c5701fc606$export$3746846b4d8615c3 = new $90d7f3c5701fc606$var$PouchError(413, 'invalid_url', 'Provided URL is invalid');
function $90d7f3c5701fc606$export$c8c8fcba3f9476cc(error, reason) {
    function CustomPouchError(reason) {
        // inherit error properties from our parent error manually
        // so as to allow proper JSON parsing.
        var names = Object.getOwnPropertyNames(error);
        for(var i = 0, len = names.length; i < len; i++)if (typeof error[names[i]] !== 'function') this[names[i]] = error[names[i]];
        if (this.stack === undefined) this.stack = new Error().stack;
        if (reason !== undefined) this.reason = reason;
    }
    CustomPouchError.prototype = $90d7f3c5701fc606$var$PouchError.prototype;
    return new CustomPouchError(reason);
}
function $90d7f3c5701fc606$export$a5b025532a1e2490(err) {
    if (typeof err !== 'object') {
        var data = err;
        err = $90d7f3c5701fc606$export$f10b32dfda12e96e;
        err.data = data;
    }
    if ('error' in err && err.error === 'conflict') {
        err.name = 'conflict';
        err.status = 409;
    }
    if (!('name' in err)) err.name = err.error || 'unknown';
    if (!('status' in err)) err.status = 500;
    if (!('message' in err)) err.message = err.message || err.reason;
    if (!('stack' in err)) err.stack = new Error().stack;
    return err;
}

});

parcelRegister("9KgKE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $7185676dc7ed1f58$var$R = typeof Reflect === 'object' ? Reflect : null;
var $7185676dc7ed1f58$var$ReflectApply = $7185676dc7ed1f58$var$R && typeof $7185676dc7ed1f58$var$R.apply === 'function' ? $7185676dc7ed1f58$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $7185676dc7ed1f58$var$ReflectOwnKeys;
if ($7185676dc7ed1f58$var$R && typeof $7185676dc7ed1f58$var$R.ownKeys === 'function') $7185676dc7ed1f58$var$ReflectOwnKeys = $7185676dc7ed1f58$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $7185676dc7ed1f58$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $7185676dc7ed1f58$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $7185676dc7ed1f58$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $7185676dc7ed1f58$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $7185676dc7ed1f58$var$EventEmitter() {
    $7185676dc7ed1f58$var$EventEmitter.init.call(this);
}
module.exports = $7185676dc7ed1f58$var$EventEmitter;
module.exports.once = $7185676dc7ed1f58$var$once;
// Backwards-compat with node 0.10.x
$7185676dc7ed1f58$var$EventEmitter.EventEmitter = $7185676dc7ed1f58$var$EventEmitter;
$7185676dc7ed1f58$var$EventEmitter.prototype._events = undefined;
$7185676dc7ed1f58$var$EventEmitter.prototype._eventsCount = 0;
$7185676dc7ed1f58$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $7185676dc7ed1f58$var$defaultMaxListeners = 10;
function $7185676dc7ed1f58$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($7185676dc7ed1f58$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $7185676dc7ed1f58$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $7185676dc7ed1f58$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $7185676dc7ed1f58$var$defaultMaxListeners = arg;
    }
});
$7185676dc7ed1f58$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$7185676dc7ed1f58$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $7185676dc7ed1f58$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $7185676dc7ed1f58$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $7185676dc7ed1f58$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $7185676dc7ed1f58$var$_getMaxListeners(this);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $7185676dc7ed1f58$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $7185676dc7ed1f58$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$7185676dc7ed1f58$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $7185676dc7ed1f58$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $7185676dc7ed1f58$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $7185676dc7ed1f58$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $7185676dc7ed1f58$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $7185676dc7ed1f58$var$_addListener(this, type, listener, false);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.on = $7185676dc7ed1f58$var$EventEmitter.prototype.addListener;
$7185676dc7ed1f58$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $7185676dc7ed1f58$var$_addListener(this, type, listener, true);
};
function $7185676dc7ed1f58$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $7185676dc7ed1f58$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $7185676dc7ed1f58$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.once = function once(type, listener) {
    $7185676dc7ed1f58$var$checkListener(listener);
    this.on(type, $7185676dc7ed1f58$var$_onceWrap(this, type, listener));
    return this;
};
$7185676dc7ed1f58$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $7185676dc7ed1f58$var$checkListener(listener);
    this.prependListener(type, $7185676dc7ed1f58$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$7185676dc7ed1f58$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $7185676dc7ed1f58$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $7185676dc7ed1f58$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$7185676dc7ed1f58$var$EventEmitter.prototype.off = $7185676dc7ed1f58$var$EventEmitter.prototype.removeListener;
$7185676dc7ed1f58$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $7185676dc7ed1f58$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $7185676dc7ed1f58$var$unwrapListeners(evlistener) : $7185676dc7ed1f58$var$arrayClone(evlistener, evlistener.length);
}
$7185676dc7ed1f58$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $7185676dc7ed1f58$var$_listeners(this, type, true);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $7185676dc7ed1f58$var$_listeners(this, type, false);
};
$7185676dc7ed1f58$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $7185676dc7ed1f58$var$listenerCount.call(emitter, type);
};
$7185676dc7ed1f58$var$EventEmitter.prototype.listenerCount = $7185676dc7ed1f58$var$listenerCount;
function $7185676dc7ed1f58$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$7185676dc7ed1f58$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $7185676dc7ed1f58$var$ReflectOwnKeys(this._events) : [];
};
function $7185676dc7ed1f58$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $7185676dc7ed1f58$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $7185676dc7ed1f58$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $7185676dc7ed1f58$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $7185676dc7ed1f58$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $7185676dc7ed1f58$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $7185676dc7ed1f58$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("6fzQb", function(module, exports) {

$parcel$export(module.exports, "default", () => $48cff2060dd9bf40$export$2e2bcd8739ae039);

var $4UsLq = parcelRequire("4UsLq");

var $cyszw = parcelRequire("cyszw");
function $48cff2060dd9bf40$var$v4(options, buf, offset) {
    options = options || {};
    var rnds = options.random || (options.rng || (0, $4UsLq.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(var i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $cyszw.default)(rnds);
}
var $48cff2060dd9bf40$export$2e2bcd8739ae039 = $48cff2060dd9bf40$var$v4;

});
parcelRegister("4UsLq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3932b45211f8b2ac$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var $3932b45211f8b2ac$var$getRandomValues;
var $3932b45211f8b2ac$var$rnds8 = new Uint8Array(16);
function $3932b45211f8b2ac$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$3932b45211f8b2ac$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
        // find the complete implementation of crypto (msCrypto) on IE11.
        $3932b45211f8b2ac$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);
        if (!$3932b45211f8b2ac$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $3932b45211f8b2ac$var$getRandomValues($3932b45211f8b2ac$var$rnds8);
}

});

parcelRegister("cyszw", function(module, exports) {

$parcel$export(module.exports, "default", () => $923ed2ccd944d2b6$export$2e2bcd8739ae039);

var $6jPF4 = parcelRequire("6jPF4");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $923ed2ccd944d2b6$var$byteToHex = [];
for(var $923ed2ccd944d2b6$var$i = 0; $923ed2ccd944d2b6$var$i < 256; ++$923ed2ccd944d2b6$var$i)$923ed2ccd944d2b6$var$byteToHex.push(($923ed2ccd944d2b6$var$i + 0x100).toString(16).substr(1));
function $923ed2ccd944d2b6$var$stringify(arr) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    var uuid = ($923ed2ccd944d2b6$var$byteToHex[arr[offset + 0]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 1]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 2]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 3]] + '-' + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 4]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 5]] + '-' + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 6]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 7]] + '-' + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 8]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 9]] + '-' + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 10]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 11]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 12]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 13]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 14]] + $923ed2ccd944d2b6$var$byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $6jPF4.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $923ed2ccd944d2b6$export$2e2bcd8739ae039 = $923ed2ccd944d2b6$var$stringify;

});
parcelRegister("6jPF4", function(module, exports) {

$parcel$export(module.exports, "default", () => $499c9750349abc1d$export$2e2bcd8739ae039);

var $7yMkF = parcelRequire("7yMkF");
function $499c9750349abc1d$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $7yMkF.default).test(uuid);
}
var $499c9750349abc1d$export$2e2bcd8739ae039 = $499c9750349abc1d$var$validate;

});
parcelRegister("7yMkF", function(module, exports) {

$parcel$export(module.exports, "default", () => $58113331cb3833cb$export$2e2bcd8739ae039);
var $58113331cb3833cb$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});




parcelRegister("9Pw4Q", function(module, exports) {

$parcel$export(module.exports, "binaryMd5", () => $7281c2501c211e52$export$6429e982342b0d07);
$parcel$export(module.exports, "stringMd5", () => $7281c2501c211e52$export$150349e5929f9049);

var $4GdZ0 = parcelRequire("4GdZ0");

var $yohr5 = parcelRequire("yohr5");
var $7281c2501c211e52$var$setImmediateShim = self.setImmediate || self.setTimeout;
var $7281c2501c211e52$var$MD5_CHUNK_SIZE = 32768;
function $7281c2501c211e52$var$rawToBase64(raw) {
    return (0, $4GdZ0.btoa)(raw);
}
function $7281c2501c211e52$var$appendBlob(buffer, blob, start, end, callback) {
    if (start > 0 || end < blob.size) // only slice blob if we really need to
    blob = blob.slice(start, end);
    (0, $4GdZ0.readAsArrayBuffer)(blob, function(arrayBuffer) {
        buffer.append(arrayBuffer);
        callback();
    });
}
function $7281c2501c211e52$var$appendString(buffer, string, start, end, callback) {
    if (start > 0 || end < string.length) // only create a substring if we really need to
    string = string.substring(start, end);
    buffer.appendBinary(string);
    callback();
}
function $7281c2501c211e52$export$6429e982342b0d07(data, callback) {
    var inputIsString = typeof data === 'string';
    var len = inputIsString ? data.length : data.size;
    var chunkSize = Math.min($7281c2501c211e52$var$MD5_CHUNK_SIZE, len);
    var chunks = Math.ceil(len / chunkSize);
    var currentChunk = 0;
    var buffer = inputIsString ? new (0, (/*@__PURE__*/$parcel$interopDefault($yohr5)))() : new (0, (/*@__PURE__*/$parcel$interopDefault($yohr5))).ArrayBuffer();
    var append = inputIsString ? $7281c2501c211e52$var$appendString : $7281c2501c211e52$var$appendBlob;
    function next() {
        $7281c2501c211e52$var$setImmediateShim(loadNextChunk);
    }
    function done() {
        var raw = buffer.end(true);
        var base64 = $7281c2501c211e52$var$rawToBase64(raw);
        callback(base64);
        buffer.destroy();
    }
    function loadNextChunk() {
        var start = currentChunk * chunkSize;
        var end = start + chunkSize;
        currentChunk++;
        if (currentChunk < chunks) append(buffer, data, start, end, next);
        else append(buffer, data, start, end, done);
    }
    loadNextChunk();
}
function $7281c2501c211e52$export$150349e5929f9049(string) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($yohr5))).hash(string);
}

});
parcelRegister("yohr5", function(module, exports) {
(function(factory) {
    var glob, e;
    // Node/CommonJS
    module.exports = factory();
})(function(undefined) {
    'use strict';
    /*
     * Fastest md5 implementation around (JKM md5).
     * Credits: Joseph Myers
     *
     * @see http://www.myersdaily.org/joseph/javascript/md5-text.html
     * @see http://jsperf.com/md5-shootout/7
     */ /* this function is much faster,
      so if possible we use it. Some IEs
      are the only ones I know of that
      need the idiotic second function,
      generated by an if clause.  */ var add32 = function(a, b) {
        return a + b & 0xFFFFFFFF;
    }, hex_chr = [
        '0',
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        'a',
        'b',
        'c',
        'd',
        'e',
        'f'
    ];
    function cmn(q, a, b, x, s, t) {
        a = add32(add32(a, q), add32(x, t));
        return add32(a << s | a >>> 32 - s, b);
    }
    function md5cycle(x, k) {
        var a = x[0], b = x[1], c = x[2], d = x[3];
        a += (b & c | ~b & d) + k[0] - 680876936 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[1] - 389564586 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[2] + 606105819 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[3] - 1044525330 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[4] - 176418897 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[5] + 1200080426 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[6] - 1473231341 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[7] - 45705983 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[8] + 1770035416 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[9] - 1958414417 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[10] - 42063 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[11] - 1990404162 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & c | ~b & d) + k[12] + 1804603682 | 0;
        a = (a << 7 | a >>> 25) + b | 0;
        d += (a & b | ~a & c) + k[13] - 40341101 | 0;
        d = (d << 12 | d >>> 20) + a | 0;
        c += (d & a | ~d & b) + k[14] - 1502002290 | 0;
        c = (c << 17 | c >>> 15) + d | 0;
        b += (c & d | ~c & a) + k[15] + 1236535329 | 0;
        b = (b << 22 | b >>> 10) + c | 0;
        a += (b & d | c & ~d) + k[1] - 165796510 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[6] - 1069501632 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[11] + 643717713 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[0] - 373897302 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[5] - 701558691 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[10] + 38016083 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[15] - 660478335 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[4] - 405537848 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[9] + 568446438 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[14] - 1019803690 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[3] - 187363961 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[8] + 1163531501 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b & d | c & ~d) + k[13] - 1444681467 | 0;
        a = (a << 5 | a >>> 27) + b | 0;
        d += (a & c | b & ~c) + k[2] - 51403784 | 0;
        d = (d << 9 | d >>> 23) + a | 0;
        c += (d & b | a & ~b) + k[7] + 1735328473 | 0;
        c = (c << 14 | c >>> 18) + d | 0;
        b += (c & a | d & ~a) + k[12] - 1926607734 | 0;
        b = (b << 20 | b >>> 12) + c | 0;
        a += (b ^ c ^ d) + k[5] - 378558 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[8] - 2022574463 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[11] + 1839030562 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[14] - 35309556 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[1] - 1530992060 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[4] + 1272893353 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[7] - 155497632 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[10] - 1094730640 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[13] + 681279174 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[0] - 358537222 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[3] - 722521979 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[6] + 76029189 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (b ^ c ^ d) + k[9] - 640364487 | 0;
        a = (a << 4 | a >>> 28) + b | 0;
        d += (a ^ b ^ c) + k[12] - 421815835 | 0;
        d = (d << 11 | d >>> 21) + a | 0;
        c += (d ^ a ^ b) + k[15] + 530742520 | 0;
        c = (c << 16 | c >>> 16) + d | 0;
        b += (c ^ d ^ a) + k[2] - 995338651 | 0;
        b = (b << 23 | b >>> 9) + c | 0;
        a += (c ^ (b | ~d)) + k[0] - 198630844 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[7] + 1126891415 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[14] - 1416354905 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[5] - 57434055 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[12] + 1700485571 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[3] - 1894986606 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[10] - 1051523 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[1] - 2054922799 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[8] + 1873313359 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[15] - 30611744 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[6] - 1560198380 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[13] + 1309151649 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        a += (c ^ (b | ~d)) + k[4] - 145523070 | 0;
        a = (a << 6 | a >>> 26) + b | 0;
        d += (b ^ (a | ~c)) + k[11] - 1120210379 | 0;
        d = (d << 10 | d >>> 22) + a | 0;
        c += (a ^ (d | ~b)) + k[2] + 718787259 | 0;
        c = (c << 15 | c >>> 17) + d | 0;
        b += (d ^ (c | ~a)) + k[9] - 343485551 | 0;
        b = (b << 21 | b >>> 11) + c | 0;
        x[0] = a + x[0] | 0;
        x[1] = b + x[1] | 0;
        x[2] = c + x[2] | 0;
        x[3] = d + x[3] | 0;
    }
    function md5blk(s) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    function md5blk_array(a) {
        var md5blks = [], i; /* Andy King said do it this way. */ 
        for(i = 0; i < 64; i += 4)md5blks[i >> 2] = a[i] + (a[i + 1] << 8) + (a[i + 2] << 16) + (a[i + 3] << 24);
        return md5blks;
    }
    function md51(s) {
        var n = s.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        length = s.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function md51_array(a) {
        var n = a.length, state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ], i, length, tail, tmp, lo, hi;
        for(i = 64; i <= n; i += 64)md5cycle(state, md5blk_array(a.subarray(i - 64, i)));
        // Not sure if it is a bug, however IE10 will always produce a sub array of length 1
        // containing the last element of the parent array if the sub array specified starts
        // beyond the length of the parent array - weird.
        // https://connect.microsoft.com/IE/feedback/details/771452/typed-array-subarray-issue
        a = i - 64 < n ? a.subarray(i - 64) : new Uint8Array(0);
        length = a.length;
        tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < length; i += 1)tail[i >> 2] |= a[i] << (i % 4 << 3);
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(state, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Beware that the final length might not fit in 32 bits so we take care of that
        tmp = n * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(state, tail);
        return state;
    }
    function rhex(n) {
        var s = '', j;
        for(j = 0; j < 4; j += 1)s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
        return s;
    }
    function hex(x) {
        var i;
        for(i = 0; i < x.length; i += 1)x[i] = rhex(x[i]);
        return x.join('');
    }
    // In some cases the fast add32 function cannot be used..
    if (hex(md51('hello')) !== '5d41402abc4b2a76b9719d911017c592') add32 = function(x, y) {
        var lsw = (x & 0xFFFF) + (y & 0xFFFF), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 0xFFFF;
    };
    // ---------------------------------------------------
    /**
     * ArrayBuffer slice polyfill.
     *
     * @see https://github.com/ttaubert/node-arraybuffer-slice
     */ if (typeof ArrayBuffer !== 'undefined' && !ArrayBuffer.prototype.slice) (function() {
        function clamp(val, length) {
            val = val | 0 || 0;
            if (val < 0) return Math.max(val + length, 0);
            return Math.min(val, length);
        }
        ArrayBuffer.prototype.slice = function(from, to) {
            var length = this.byteLength, begin = clamp(from, length), end = length, num, target, targetArray, sourceArray;
            if (to !== undefined) end = clamp(to, length);
            if (begin > end) return new ArrayBuffer(0);
            num = end - begin;
            target = new ArrayBuffer(num);
            targetArray = new Uint8Array(target);
            sourceArray = new Uint8Array(this, begin, num);
            targetArray.set(sourceArray);
            return target;
        };
    })();
    // ---------------------------------------------------
    /**
     * Helpers.
     */ function toUtf8(str) {
        if (/[\u0080-\uFFFF]/.test(str)) str = unescape(encodeURIComponent(str));
        return str;
    }
    function utf8Str2ArrayBuffer(str, returnUInt8Array) {
        var length = str.length, buff = new ArrayBuffer(length), arr = new Uint8Array(buff), i;
        for(i = 0; i < length; i += 1)arr[i] = str.charCodeAt(i);
        return returnUInt8Array ? arr : buff;
    }
    function arrayBuffer2Utf8Str(buff) {
        return String.fromCharCode.apply(null, new Uint8Array(buff));
    }
    function concatenateArrayBuffers(first, second, returnUInt8Array) {
        var result = new Uint8Array(first.byteLength + second.byteLength);
        result.set(new Uint8Array(first));
        result.set(new Uint8Array(second), first.byteLength);
        return returnUInt8Array ? result : result.buffer;
    }
    function hexToBinaryString(hex) {
        var bytes = [], length = hex.length, x;
        for(x = 0; x < length - 1; x += 2)bytes.push(parseInt(hex.substr(x, 2), 16));
        return String.fromCharCode.apply(String, bytes);
    }
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation.
     *
     * Use this class to perform an incremental md5, otherwise use the
     * static methods instead.
     */ function SparkMD5() {
        // call reset to init the instance
        this.reset();
    }
    /**
     * Appends a string.
     * A conversion will be applied if an utf8 string is detected.
     *
     * @param {String} str The string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.append = function(str) {
        // Converts the string to utf8 bytes if necessary
        // Then append as binary
        this.appendBinary(toUtf8(str));
        return this;
    };
    /**
     * Appends a binary string.
     *
     * @param {String} contents The binary string to be appended
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.appendBinary = function(contents) {
        this._buff += contents;
        this._length += contents.length;
        var length = this._buff.length, i;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk(this._buff.substring(i - 64, i)));
        this._buff = this._buff.substring(i - 64);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, i, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff.charCodeAt(i) << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.reset = function() {
        this._buff = '';
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.prototype.getState = function() {
        return {
            buff: this._buff,
            length: this._length,
            hash: this._hash.slice()
        };
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5} The instance itself
     */ SparkMD5.prototype.setState = function(state) {
        this._buff = state.buff;
        this._length = state.length;
        this._hash = state.hash;
        return this;
    };
    /**
     * Releases memory used by the incremental buffer and other additional
     * resources. If you plan to use the instance again, use reset instead.
     */ SparkMD5.prototype.destroy = function() {
        delete this._hash;
        delete this._buff;
        delete this._length;
    };
    /**
     * Finish the final calculation based on the tail.
     *
     * @param {Array}  tail   The tail (will be modified)
     * @param {Number} length The length of the remaining buffer
     */ SparkMD5.prototype._finish = function(tail, length) {
        var i = length, tmp, lo, hi;
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            md5cycle(this._hash, tail);
            for(i = 0; i < 16; i += 1)tail[i] = 0;
        }
        // Do the final computation based on the tail and length
        // Beware that the final length may not fit in 32 bits so we take care of that
        tmp = this._length * 8;
        tmp = tmp.toString(16).match(/(.*?)(.{0,8})$/);
        lo = parseInt(tmp[2], 16);
        hi = parseInt(tmp[1], 16) || 0;
        tail[14] = lo;
        tail[15] = hi;
        md5cycle(this._hash, tail);
    };
    /**
     * Performs the md5 hash on a string.
     * A conversion will be applied if utf8 string is detected.
     *
     * @param {String}  str The string
     * @param {Boolean} [raw] True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hash = function(str, raw) {
        // Converts the string to utf8 bytes if necessary
        // Then compute it using the binary function
        return SparkMD5.hashBinary(toUtf8(str), raw);
    };
    /**
     * Performs the md5 hash on a binary string.
     *
     * @param {String}  content The binary string
     * @param {Boolean} [raw]     True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.hashBinary = function(content, raw) {
        var hash = md51(content), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    // ---------------------------------------------------
    /**
     * SparkMD5 OOP implementation for array buffers.
     *
     * Use this class to perform an incremental md5 ONLY for array buffers.
     */ SparkMD5.ArrayBuffer = function() {
        // call reset to init the instance
        this.reset();
    };
    /**
     * Appends an array buffer.
     *
     * @param {ArrayBuffer} arr The array to be appended
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.append = function(arr) {
        var buff = concatenateArrayBuffers(this._buff.buffer, arr, true), length = buff.length, i;
        this._length += arr.byteLength;
        for(i = 64; i <= length; i += 64)md5cycle(this._hash, md5blk_array(buff.subarray(i - 64, i)));
        this._buff = i - 64 < length ? new Uint8Array(buff.buffer.slice(i - 64)) : new Uint8Array(0);
        return this;
    };
    /**
     * Finishes the incremental computation, reseting the internal state and
     * returning the result.
     *
     * @param {Boolean} raw True to get the raw string, false to get the hex string
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.prototype.end = function(raw) {
        var buff = this._buff, length = buff.length, tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ], i, ret;
        for(i = 0; i < length; i += 1)tail[i >> 2] |= buff[i] << (i % 4 << 3);
        this._finish(tail, length);
        ret = hex(this._hash);
        if (raw) ret = hexToBinaryString(ret);
        this.reset();
        return ret;
    };
    /**
     * Resets the internal state of the computation.
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.reset = function() {
        this._buff = new Uint8Array(0);
        this._length = 0;
        this._hash = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        return this;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @return {Object} The state
     */ SparkMD5.ArrayBuffer.prototype.getState = function() {
        var state = SparkMD5.prototype.getState.call(this);
        // Convert buffer to a string
        state.buff = arrayBuffer2Utf8Str(state.buff);
        return state;
    };
    /**
     * Gets the internal state of the computation.
     *
     * @param {Object} state The state
     *
     * @return {SparkMD5.ArrayBuffer} The instance itself
     */ SparkMD5.ArrayBuffer.prototype.setState = function(state) {
        // Convert string to buffer
        state.buff = utf8Str2ArrayBuffer(state.buff, true);
        return SparkMD5.prototype.setState.call(this, state);
    };
    SparkMD5.ArrayBuffer.prototype.destroy = SparkMD5.prototype.destroy;
    SparkMD5.ArrayBuffer.prototype._finish = SparkMD5.prototype._finish;
    /**
     * Performs the md5 hash on an array buffer.
     *
     * @param {ArrayBuffer} arr The array buffer
     * @param {Boolean}     [raw] True to get the raw string, false to get the hex one
     *
     * @return {String} The result
     */ SparkMD5.ArrayBuffer.hash = function(arr, raw) {
        var hash = md51_array(new Uint8Array(arr)), ret = hex(hash);
        return raw ? hexToBinaryString(ret) : ret;
    };
    return SparkMD5;
});

});



parcelRegister("eMG3m", function(module, exports) {

$parcel$export(module.exports, "winningRev", () => $ac362b4076d99d09$export$2f94a787d993a0ba);
$parcel$export(module.exports, "traverseRevTree", () => $ac362b4076d99d09$export$86eeecabb3a3b3ff);
$parcel$export(module.exports, "collectLeaves", () => $ac362b4076d99d09$export$35136b08c83a6ae6);
$parcel$export(module.exports, "collectConflicts", () => $ac362b4076d99d09$export$a06103ec99e4e394);
$parcel$export(module.exports, "compactTree", () => $ac362b4076d99d09$export$1d8caa5e38ebe21e);
$parcel$export(module.exports, "findPathToLeaf", () => $ac362b4076d99d09$export$7f1afeea1b5b1dd8);
$parcel$export(module.exports, "rootToLeaf", () => $ac362b4076d99d09$export$11ed85e02319bd07);
$parcel$export(module.exports, "merge", () => $ac362b4076d99d09$export$4950aa0f605343fb);
$parcel$export(module.exports, "removeLeafFromTree", () => $ac362b4076d99d09$export$e9d54748b60473cc);
$parcel$export(module.exports, "revExists", () => $ac362b4076d99d09$export$5186a05c94accd14);
$parcel$export(module.exports, "isDeleted", () => $ac362b4076d99d09$export$dcb04af092e44fde);
$parcel$export(module.exports, "isLocalId", () => $ac362b4076d99d09$export$2baa98e25a805ec6);
$parcel$export(module.exports, "latest", () => $ac362b4076d99d09$export$b8064d1c42a6b8);

var $47bZj = parcelRequire("47bZj");
// We fetch all leafs of the revision tree, and sort them based on tree length
// and whether they were deleted, undeleted documents with the longest revision
// tree (most edits) win
// The final sort algorithm is slightly documented in a sidebar here:
// http://guide.couchdb.org/draft/conflicts.html
function $ac362b4076d99d09$export$2f94a787d993a0ba(metadata) {
    var winningId;
    var winningPos;
    var winningDeleted;
    var toVisit = metadata.rev_tree.slice();
    var node;
    while(node = toVisit.pop()){
        var tree = node.ids;
        var branches = tree[2];
        var pos = node.pos;
        if (branches.length) {
            for(var i = 0, len = branches.length; i < len; i++)toVisit.push({
                pos: pos + 1,
                ids: branches[i]
            });
            continue;
        }
        var deleted = !!tree[1].deleted;
        var id = tree[0];
        // sort by deleted, then pos, then id
        if (!winningId || (winningDeleted !== deleted ? winningDeleted : winningPos !== pos ? winningPos < pos : winningId < id)) {
            winningId = id;
            winningPos = pos;
            winningDeleted = deleted;
        }
    }
    return winningPos + '-' + winningId;
}
// Pretty much all below can be combined into a higher order function to
// traverse revisions
// The return value from the callback will be passed as context to all
// children of that node
function $ac362b4076d99d09$export$86eeecabb3a3b3ff(revs, callback) {
    var toVisit = revs.slice();
    var node;
    while(node = toVisit.pop()){
        var pos = node.pos;
        var tree = node.ids;
        var branches = tree[2];
        var newCtx = callback(branches.length === 0, pos, tree[0], node.ctx, tree[1]);
        for(var i = 0, len = branches.length; i < len; i++)toVisit.push({
            pos: pos + 1,
            ids: branches[i],
            ctx: newCtx
        });
    }
}
function $ac362b4076d99d09$var$sortByPos(a, b) {
    return a.pos - b.pos;
}
function $ac362b4076d99d09$export$35136b08c83a6ae6(revs) {
    var leaves = [];
    $ac362b4076d99d09$export$86eeecabb3a3b3ff(revs, function(isLeaf, pos, id, acc, opts) {
        if (isLeaf) leaves.push({
            rev: pos + "-" + id,
            pos: pos,
            opts: opts
        });
    });
    leaves.sort($ac362b4076d99d09$var$sortByPos).reverse();
    for(var i = 0, len = leaves.length; i < len; i++)delete leaves[i].pos;
    return leaves;
}
// returns revs of all conflicts that is leaves such that
// 1. are not deleted and
// 2. are different than winning revision
function $ac362b4076d99d09$export$a06103ec99e4e394(metadata) {
    var win = $ac362b4076d99d09$export$2f94a787d993a0ba(metadata);
    var leaves = $ac362b4076d99d09$export$35136b08c83a6ae6(metadata.rev_tree);
    var conflicts = [];
    for(var i = 0, len = leaves.length; i < len; i++){
        var leaf = leaves[i];
        if (leaf.rev !== win && !leaf.opts.deleted) conflicts.push(leaf.rev);
    }
    return conflicts;
}
// compact a tree by marking its non-leafs as missing,
// and return a list of revs to delete
function $ac362b4076d99d09$export$1d8caa5e38ebe21e(metadata) {
    var revs = [];
    $ac362b4076d99d09$export$86eeecabb3a3b3ff(metadata.rev_tree, function(isLeaf, pos, revHash, ctx, opts) {
        if (opts.status === 'available' && !isLeaf) {
            revs.push(pos + '-' + revHash);
            opts.status = 'missing';
        }
    });
    return revs;
}
// `findPathToLeaf()` returns an array of revs that goes from the specified
// leaf rev to the root of that leaf’s branch.
//
// eg. for this rev tree:
// 1-9692 ▶ 2-37aa ▶ 3-df22 ▶ 4-6e94 ▶ 5-df4a ▶ 6-6a3a ▶ 7-57e5
//          ┃                 ┗━━━━━━▶ 5-8d8c ▶ 6-65e0
//          ┗━━━━━━▶ 3-43f6 ▶ 4-a3b4
//
// For a `targetRev` of '7-57e5', `findPathToLeaf()` would return ['7-57e5', '6-6a3a', '5-df4a']
// The `revs` argument has the same structure as what `revs_tree` has on e.g.
// the IndexedDB representation of the rev tree datastructure. Please refer to
// tests/unit/test.purge.js for examples of what these look like.
//
// This function will throw an error if:
// - The requested revision does not exist
// - The requested revision is not a leaf
function $ac362b4076d99d09$export$7f1afeea1b5b1dd8(revs, targetRev) {
    let path = [];
    const toVisit = revs.slice();
    let node;
    while(node = toVisit.pop()){
        const { pos: pos, ids: tree } = node;
        const rev = `${pos}-${tree[0]}`;
        const branches = tree[2];
        // just assuming we're already working on the path up towards our desired leaf.
        path.push(rev);
        // we've reached the leaf of our dreams, so return the computed path.
        if (rev === targetRev) {
            //…unleeeeess
            if (branches.length !== 0) throw new Error('The requested revision is not a leaf');
            return path.reverse();
        }
        // this is based on the assumption that after we have a leaf (`branches.length == 0`), we handle the next
        // branch. this is true for all branches other than the path leading to the winning rev (which is 7-57e5 in
        // the example above. i've added a reset condition for branching nodes (`branches.length > 1`) as well.
        if (branches.length === 0 || branches.length > 1) path = [];
        // as a next step, we push the branches of this node to `toVisit` for visiting it during the next iteration
        for(let i = 0, len = branches.length; i < len; i++)toVisit.push({
            pos: pos + 1,
            ids: branches[i]
        });
    }
    if (path.length === 0) throw new Error('The requested revision does not exist');
    return path.reverse();
}
// build up a list of all the paths to the leafs in this revision tree
function $ac362b4076d99d09$export$11ed85e02319bd07(revs) {
    var paths = [];
    var toVisit = revs.slice();
    var node;
    while(node = toVisit.pop()){
        var pos = node.pos;
        var tree = node.ids;
        var id = tree[0];
        var opts = tree[1];
        var branches = tree[2];
        var isLeaf = branches.length === 0;
        var history = node.history ? node.history.slice() : [];
        history.push({
            id: id,
            opts: opts
        });
        if (isLeaf) paths.push({
            pos: pos + 1 - history.length,
            ids: history
        });
        for(var i = 0, len = branches.length; i < len; i++)toVisit.push({
            pos: pos + 1,
            ids: branches[i],
            history: history
        });
    }
    return paths.reverse();
}
// for a better overview of what this is doing, read:
function $ac362b4076d99d09$var$sortByPos$1(a, b) {
    return a.pos - b.pos;
}
// classic binary search
function $ac362b4076d99d09$var$binarySearch(arr, item, comparator) {
    var low = 0;
    var high = arr.length;
    var mid;
    while(low < high){
        mid = low + high >>> 1;
        if (comparator(arr[mid], item) < 0) low = mid + 1;
        else high = mid;
    }
    return low;
}
// assuming the arr is sorted, insert the item in the proper place
function $ac362b4076d99d09$var$insertSorted(arr, item, comparator) {
    var idx = $ac362b4076d99d09$var$binarySearch(arr, item, comparator);
    arr.splice(idx, 0, item);
}
// Turn a path as a flat array into a tree with a single branch.
// If any should be stemmed from the beginning of the array, that's passed
// in as the second argument
function $ac362b4076d99d09$var$pathToTree(path, numStemmed) {
    var root;
    var leaf;
    for(var i = numStemmed, len = path.length; i < len; i++){
        var node = path[i];
        var currentLeaf = [
            node.id,
            node.opts,
            []
        ];
        if (leaf) {
            leaf[2].push(currentLeaf);
            leaf = currentLeaf;
        } else root = leaf = currentLeaf;
    }
    return root;
}
// compare the IDs of two trees
function $ac362b4076d99d09$var$compareTree(a, b) {
    return a[0] < b[0] ? -1 : 1;
}
// Merge two trees together
// The roots of tree1 and tree2 must be the same revision
function $ac362b4076d99d09$var$mergeTree(in_tree1, in_tree2) {
    var queue = [
        {
            tree1: in_tree1,
            tree2: in_tree2
        }
    ];
    var conflicts = false;
    while(queue.length > 0){
        var item = queue.pop();
        var tree1 = item.tree1;
        var tree2 = item.tree2;
        if (tree1[1].status || tree2[1].status) tree1[1].status = tree1[1].status === 'available' || tree2[1].status === 'available' ? 'available' : 'missing';
        for(var i = 0; i < tree2[2].length; i++){
            if (!tree1[2][0]) {
                conflicts = 'new_leaf';
                tree1[2][0] = tree2[2][i];
                continue;
            }
            var merged = false;
            for(var j = 0; j < tree1[2].length; j++)if (tree1[2][j][0] === tree2[2][i][0]) {
                queue.push({
                    tree1: tree1[2][j],
                    tree2: tree2[2][i]
                });
                merged = true;
            }
            if (!merged) {
                conflicts = 'new_branch';
                $ac362b4076d99d09$var$insertSorted(tree1[2], tree2[2][i], $ac362b4076d99d09$var$compareTree);
            }
        }
    }
    return {
        conflicts: conflicts,
        tree: in_tree1
    };
}
function $ac362b4076d99d09$var$doMerge(tree, path, dontExpand) {
    var restree = [];
    var conflicts = false;
    var merged = false;
    var res;
    if (!tree.length) return {
        tree: [
            path
        ],
        conflicts: 'new_leaf'
    };
    for(var i = 0, len = tree.length; i < len; i++){
        var branch = tree[i];
        if (branch.pos === path.pos && branch.ids[0] === path.ids[0]) {
            // Paths start at the same position and have the same root, so they need
            // merged
            res = $ac362b4076d99d09$var$mergeTree(branch.ids, path.ids);
            restree.push({
                pos: branch.pos,
                ids: res.tree
            });
            conflicts = conflicts || res.conflicts;
            merged = true;
        } else if (dontExpand !== true) {
            // The paths start at a different position, take the earliest path and
            // traverse up until it as at the same point from root as the path we
            // want to merge.  If the keys match we return the longer path with the
            // other merged After stemming we don't want to expand the trees
            var t1 = branch.pos < path.pos ? branch : path;
            var t2 = branch.pos < path.pos ? path : branch;
            var diff = t2.pos - t1.pos;
            var candidateParents = [];
            var trees = [];
            trees.push({
                ids: t1.ids,
                diff: diff,
                parent: null,
                parentIdx: null
            });
            while(trees.length > 0){
                var item = trees.pop();
                if (item.diff === 0) {
                    if (item.ids[0] === t2.ids[0]) candidateParents.push(item);
                    continue;
                }
                var elements = item.ids[2];
                for(var j = 0, elementsLen = elements.length; j < elementsLen; j++)trees.push({
                    ids: elements[j],
                    diff: item.diff - 1,
                    parent: item.ids,
                    parentIdx: j
                });
            }
            var el = candidateParents[0];
            if (!el) restree.push(branch);
            else {
                res = $ac362b4076d99d09$var$mergeTree(el.ids, t2.ids);
                el.parent[2][el.parentIdx] = res.tree;
                restree.push({
                    pos: t1.pos,
                    ids: t1.ids
                });
                conflicts = conflicts || res.conflicts;
                merged = true;
            }
        } else restree.push(branch);
    }
    // We didnt find
    if (!merged) restree.push(path);
    restree.sort($ac362b4076d99d09$var$sortByPos$1);
    return {
        tree: restree,
        conflicts: conflicts || 'internal_node'
    };
}
// To ensure we don't grow the revision tree infinitely, we stem old revisions
function $ac362b4076d99d09$var$stem(tree, depth) {
    // First we break out the tree into a complete list of root to leaf paths
    var paths = $ac362b4076d99d09$export$11ed85e02319bd07(tree);
    var stemmedRevs;
    var result;
    for(var i = 0, len = paths.length; i < len; i++){
        // Then for each path, we cut off the start of the path based on the
        // `depth` to stem to, and generate a new set of flat trees
        var path = paths[i];
        var stemmed = path.ids;
        var node;
        if (stemmed.length > depth) {
            // only do the stemming work if we actually need to stem
            if (!stemmedRevs) stemmedRevs = {}; // avoid allocating this object unnecessarily
            var numStemmed = stemmed.length - depth;
            node = {
                pos: path.pos + numStemmed,
                ids: $ac362b4076d99d09$var$pathToTree(stemmed, numStemmed)
            };
            for(var s = 0; s < numStemmed; s++){
                var rev = path.pos + s + '-' + stemmed[s].id;
                stemmedRevs[rev] = true;
            }
        } else node = {
            pos: path.pos,
            ids: $ac362b4076d99d09$var$pathToTree(stemmed, 0)
        };
        // Then we remerge all those flat trees together, ensuring that we don't
        // connect trees that would go beyond the depth limit
        if (result) result = $ac362b4076d99d09$var$doMerge(result, node, true).tree;
        else result = [
            node
        ];
    }
    // this is memory-heavy per Chrome profiler, avoid unless we actually stemmed
    if (stemmedRevs) $ac362b4076d99d09$export$86eeecabb3a3b3ff(result, function(isLeaf, pos, revHash) {
        // some revisions may have been removed in a branch but not in another
        delete stemmedRevs[pos + '-' + revHash];
    });
    return {
        tree: result,
        revs: stemmedRevs ? Object.keys(stemmedRevs) : []
    };
}
function $ac362b4076d99d09$export$4950aa0f605343fb(tree, path, depth) {
    var newTree = $ac362b4076d99d09$var$doMerge(tree, path);
    var stemmed = $ac362b4076d99d09$var$stem(newTree.tree, depth);
    return {
        tree: stemmed.tree,
        stemmedRevs: stemmed.revs,
        conflicts: newTree.conflicts
    };
}
// this method removes a leaf from a rev tree, independent of its status.
// e.g., by removing an available leaf, it could leave its predecessor as
// a missing leaf and corrupting the tree.
function $ac362b4076d99d09$export$e9d54748b60473cc(tree, leafRev) {
    return tree.flatMap((path)=>{
        path = $ac362b4076d99d09$var$removeLeafFromPath(path, leafRev);
        return path ? [
            path
        ] : [];
    });
}
function $ac362b4076d99d09$var$removeLeafFromPath(path, leafRev) {
    const tree = (0, $47bZj.clone)(path);
    const toVisit = [
        tree
    ];
    let node;
    while(node = toVisit.pop()){
        const { pos: pos, ids: [id, , branches], parent: parent } = node;
        const isLeaf = branches.length === 0;
        const hash = `${pos}-${id}`;
        if (isLeaf && hash === leafRev) {
            if (!parent) // FIXME: we're facing the root, and probably shouldn't just return an empty array (object? null?).
            return null;
            parent.ids[2] = parent.ids[2].filter(function(branchNode) {
                return branchNode[0] !== id;
            });
            return tree;
        }
        for(let i = 0, len = branches.length; i < len; i++)toVisit.push({
            pos: pos + 1,
            ids: branches[i],
            parent: node
        });
    }
    return tree;
}
// return true if a rev exists in the rev tree, false otherwise
function $ac362b4076d99d09$export$5186a05c94accd14(revs, rev) {
    var toVisit = revs.slice();
    var splitRev = rev.split('-');
    var targetPos = parseInt(splitRev[0], 10);
    var targetId = splitRev[1];
    var node;
    while(node = toVisit.pop()){
        if (node.pos === targetPos && node.ids[0] === targetId) return true;
        var branches = node.ids[2];
        for(var i = 0, len = branches.length; i < len; i++)toVisit.push({
            pos: node.pos + 1,
            ids: branches[i]
        });
    }
    return false;
}
function $ac362b4076d99d09$var$getTrees(node) {
    return node.ids;
}
// check if a specific revision of a doc has been deleted
//  - metadata: the metadata object from the doc store
//  - rev: (optional) the revision to check. defaults to winning revision
function $ac362b4076d99d09$export$dcb04af092e44fde(metadata, rev) {
    if (!rev) rev = $ac362b4076d99d09$export$2f94a787d993a0ba(metadata);
    var id = rev.substring(rev.indexOf('-') + 1);
    var toVisit = metadata.rev_tree.map($ac362b4076d99d09$var$getTrees);
    var tree;
    while(tree = toVisit.pop()){
        if (tree[0] === id) return !!tree[1].deleted;
        toVisit = toVisit.concat(tree[2]);
    }
}
function $ac362b4076d99d09$export$2baa98e25a805ec6(id) {
    return typeof id === 'string' && id.startsWith('_local/');
}
// returns the current leaf node for a given revision
function $ac362b4076d99d09$export$b8064d1c42a6b8(rev, metadata) {
    var toVisit = metadata.rev_tree.slice();
    var node;
    while(node = toVisit.pop()){
        var pos = node.pos;
        var tree = node.ids;
        var id = tree[0];
        var opts = tree[1];
        var branches = tree[2];
        var isLeaf = branches.length === 0;
        var history = node.history ? node.history.slice() : [];
        history.push({
            id: id,
            pos: pos,
            opts: opts
        });
        if (isLeaf) for(var i = 0, len = history.length; i < len; i++){
            var historyNode = history[i];
            var historyRev = historyNode.pos + '-' + historyNode.id;
            if (historyRev === rev) // return the rev of this leaf
            return pos + '-' + id;
        }
        for(var j = 0, l = branches.length; j < l; j++)toVisit.push({
            pos: pos + 1,
            ids: branches[j],
            history: history
        });
    }
    /* istanbul ignore next */ throw new Error('Unable to resolve latest revision for id ' + metadata.id + ', rev ' + rev);
}

});



parcelRegister("iw6Kb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7b0725bde674e9b$export$2e2bcd8739ae039);

var $eMG3m = parcelRequire("eMG3m");

var $cqZVJ = parcelRequire("cqZVJ");

var $47bZj = parcelRequire("47bZj");

var $9KgKE = parcelRequire("9KgKE");

var $7zAYS = parcelRequire("7zAYS");

var $6fzQb = parcelRequire("6fzQb");

var $b6VZA = parcelRequire("b6VZA");
function $d7b0725bde674e9b$var$tryCatchInChangeListener(self1, change, pending, lastSeq) {
    // isolate try/catches to avoid V8 deoptimizations
    try {
        self1.emit('change', change, pending, lastSeq);
    } catch (e) {
        (0, $47bZj.guardedConsole)('error', 'Error in .on("change", function):', e);
    }
}
function $d7b0725bde674e9b$var$processChange(doc, metadata, opts) {
    var changeList = [
        {
            rev: doc._rev
        }
    ];
    if (opts.style === 'all_docs') changeList = (0, $eMG3m.collectLeaves)(metadata.rev_tree).map(function(x) {
        return {
            rev: x.rev
        };
    });
    var change = {
        id: metadata.id,
        changes: changeList,
        doc: doc
    };
    if ((0, $eMG3m.isDeleted)(metadata, doc._rev)) change.deleted = true;
    if (opts.conflicts) {
        change.doc._conflicts = (0, $eMG3m.collectConflicts)(metadata);
        if (!change.doc._conflicts.length) delete change.doc._conflicts;
    }
    return change;
}
class $d7b0725bde674e9b$var$Changes extends (0, (/*@__PURE__*/$parcel$interopDefault($9KgKE))) {
    constructor(db, opts, callback){
        super();
        this.db = db;
        opts = opts ? (0, $47bZj.clone)(opts) : {};
        var complete = opts.complete = (0, $47bZj.once)((err, resp)=>{
            if (err) {
                if ((0, $47bZj.listenerCount)(this, 'error') > 0) this.emit('error', err);
            } else this.emit('complete', resp);
            this.removeAllListeners();
            db.removeListener('destroyed', onDestroy);
        });
        if (callback) {
            this.on('complete', function(resp) {
                callback(null, resp);
            });
            this.on('error', callback);
        }
        const onDestroy = ()=>{
            this.cancel();
        };
        db.once('destroyed', onDestroy);
        opts.onChange = (change, pending, lastSeq)=>{
            /* istanbul ignore if */ if (this.isCancelled) return;
            $d7b0725bde674e9b$var$tryCatchInChangeListener(this, change, pending, lastSeq);
        };
        var promise = new Promise(function(fulfill, reject) {
            opts.complete = function(err, res) {
                if (err) reject(err);
                else fulfill(res);
            };
        });
        this.once('cancel', function() {
            db.removeListener('destroyed', onDestroy);
            opts.complete(null, {
                status: 'cancelled'
            });
        });
        this.then = promise.then.bind(promise);
        this['catch'] = promise['catch'].bind(promise);
        this.then(function(result) {
            complete(null, result);
        }, complete);
        if (!db.taskqueue.isReady) db.taskqueue.addTask((failed)=>{
            if (failed) opts.complete(failed);
            else if (this.isCancelled) this.emit('cancel');
            else this.validateChanges(opts);
        });
        else this.validateChanges(opts);
    }
    cancel() {
        this.isCancelled = true;
        if (this.db.taskqueue.isReady) this.emit('cancel');
    }
    validateChanges(opts) {
        var callback = opts.complete;
        /* istanbul ignore else */ if ($d7b0725bde674e9b$var$PouchDB._changesFilterPlugin) $d7b0725bde674e9b$var$PouchDB._changesFilterPlugin.validate(opts, (err)=>{
            if (err) return callback(err);
            this.doChanges(opts);
        });
        else this.doChanges(opts);
    }
    doChanges(opts) {
        var callback = opts.complete;
        opts = (0, $47bZj.clone)(opts);
        if ('live' in opts && !('continuous' in opts)) opts.continuous = opts.live;
        opts.processChange = $d7b0725bde674e9b$var$processChange;
        if (opts.since === 'latest') opts.since = 'now';
        if (!opts.since) opts.since = 0;
        if (opts.since === 'now') {
            this.db.info().then((info)=>{
                /* istanbul ignore if */ if (this.isCancelled) {
                    callback(null, {
                        status: 'cancelled'
                    });
                    return;
                }
                opts.since = info.update_seq;
                this.doChanges(opts);
            }, callback);
            return;
        }
        /* istanbul ignore else */ if ($d7b0725bde674e9b$var$PouchDB._changesFilterPlugin) {
            $d7b0725bde674e9b$var$PouchDB._changesFilterPlugin.normalize(opts);
            if ($d7b0725bde674e9b$var$PouchDB._changesFilterPlugin.shouldFilter(this, opts)) return $d7b0725bde674e9b$var$PouchDB._changesFilterPlugin.filter(this, opts);
        } else [
            'doc_ids',
            'filter',
            'selector',
            'view'
        ].forEach(function(key) {
            if (key in opts) (0, $47bZj.guardedConsole)('warn', 'The "' + key + '" option was passed in to changes/replicate, ' + 'but pouchdb-changes-filter plugin is not installed, so it ' + 'was ignored. Please install the plugin to enable filtering.');
        });
        if (!('descending' in opts)) opts.descending = false;
        // 0 and 1 should return 1 document
        opts.limit = opts.limit === 0 ? 1 : opts.limit;
        opts.complete = callback;
        var newPromise = this.db._changes(opts);
        /* istanbul ignore else */ if (newPromise && typeof newPromise.cancel === 'function') {
            const cancel = this.cancel;
            this.cancel = (...args)=>{
                newPromise.cancel();
                cancel.apply(this, args);
            };
        }
    }
}
/*
 * A generic pouch adapter
 */ // Wrapper for functions that call the bulkdocs api with a single doc,
// if the first result is an error, return an error
function $d7b0725bde674e9b$var$yankError(callback, docId) {
    return function(err, results) {
        if (err || results[0] && results[0].error) {
            err = err || results[0];
            err.docId = docId;
            callback(err);
        } else callback(null, results.length ? results[0] : results);
    };
}
// clean docs given to us by the user
function $d7b0725bde674e9b$var$cleanDocs(docs) {
    for(var i = 0; i < docs.length; i++){
        var doc = docs[i];
        if (doc._deleted) delete doc._attachments; // ignore atts for deleted docs
        else if (doc._attachments) {
            // filter out extraneous keys from _attachments
            var atts = Object.keys(doc._attachments);
            for(var j = 0; j < atts.length; j++){
                var att = atts[j];
                doc._attachments[att] = (0, $47bZj.pick)(doc._attachments[att], [
                    'data',
                    'digest',
                    'content_type',
                    'length',
                    'revpos',
                    'stub'
                ]);
            }
        }
    }
}
// compare two docs, first by _id then by _rev
function $d7b0725bde674e9b$var$compareByIdThenRev(a, b) {
    if (a._id === b._id) {
        const aStart = a._revisions ? a._revisions.start : 0;
        const bStart = b._revisions ? b._revisions.start : 0;
        return aStart - bStart;
    }
    return a._id < b._id ? -1 : 1;
}
// for every node in a revision tree computes its distance from the closest
// leaf
function $d7b0725bde674e9b$var$computeHeight(revs) {
    var height = {};
    var edges = [];
    (0, $eMG3m.traverseRevTree)(revs, function(isLeaf, pos, id, prnt) {
        var rev$$1 = pos + "-" + id;
        if (isLeaf) height[rev$$1] = 0;
        if (prnt !== undefined) edges.push({
            from: prnt,
            to: rev$$1
        });
        return rev$$1;
    });
    edges.reverse();
    edges.forEach(function(edge) {
        if (height[edge.from] === undefined) height[edge.from] = 1 + height[edge.to];
        else height[edge.from] = Math.min(height[edge.from], 1 + height[edge.to]);
    });
    return height;
}
function $d7b0725bde674e9b$var$allDocsKeysParse(opts) {
    var keys = 'limit' in opts ? opts.keys.slice(opts.skip, opts.limit + opts.skip) : opts.skip > 0 ? opts.keys.slice(opts.skip) : opts.keys;
    opts.keys = keys;
    opts.skip = 0;
    delete opts.limit;
    if (opts.descending) {
        keys.reverse();
        opts.descending = false;
    }
}
// all compaction is done in a queue, to avoid attaching
// too many listeners at once
function $d7b0725bde674e9b$var$doNextCompaction(self1) {
    var task = self1._compactionQueue[0];
    var opts = task.opts;
    var callback = task.callback;
    self1.get('_local/compaction').catch(function() {
        return false;
    }).then(function(doc) {
        if (doc && doc.last_seq) opts.last_seq = doc.last_seq;
        self1._compact(opts, function(err, res) {
            /* istanbul ignore if */ if (err) callback(err);
            else callback(null, res);
            (0, $47bZj.nextTick)(function() {
                self1._compactionQueue.shift();
                if (self1._compactionQueue.length) $d7b0725bde674e9b$var$doNextCompaction(self1);
            });
        });
    });
}
function $d7b0725bde674e9b$var$appendPurgeSeq(db, docId, rev$$1) {
    return db.get('_local/purges').then(function(doc) {
        const purgeSeq = doc.purgeSeq + 1;
        doc.purges.push({
            docId: docId,
            rev: rev$$1,
            purgeSeq: purgeSeq
        });
        if (doc.purges.length > self.purged_infos_limit) doc.purges.splice(0, doc.purges.length - self.purged_infos_limit);
        doc.purgeSeq = purgeSeq;
        return doc;
    }).catch(function(err) {
        if (err.status !== 404) throw err;
        return {
            _id: '_local/purges',
            purges: [
                {
                    docId: docId,
                    rev: rev$$1,
                    purgeSeq: 0
                }
            ],
            purgeSeq: 0
        };
    }).then(function(doc) {
        return db.put(doc);
    });
}
function $d7b0725bde674e9b$var$attachmentNameError(name) {
    if (name.charAt(0) === '_') return name + ' is not a valid attachment name, attachment ' + 'names cannot start with \'_\'';
    return false;
}
function $d7b0725bde674e9b$var$isNotSingleDoc(doc) {
    return doc === null || typeof doc !== 'object' || Array.isArray(doc);
}
const $d7b0725bde674e9b$var$validRevRegex = /^\d+-[^-]*$/;
function $d7b0725bde674e9b$var$isValidRev(rev$$1) {
    return typeof rev$$1 === 'string' && $d7b0725bde674e9b$var$validRevRegex.test(rev$$1);
}
class $d7b0725bde674e9b$var$AbstractPouchDB extends (0, (/*@__PURE__*/$parcel$interopDefault($9KgKE))) {
    _setup() {
        this.post = (0, $47bZj.adapterFun)('post', function(doc, opts, callback) {
            if (typeof opts === 'function') {
                callback = opts;
                opts = {};
            }
            if ($d7b0725bde674e9b$var$isNotSingleDoc(doc)) return callback((0, $cqZVJ.createError)((0, $cqZVJ.NOT_AN_OBJECT)));
            this.bulkDocs({
                docs: [
                    doc
                ]
            }, opts, $d7b0725bde674e9b$var$yankError(callback, doc._id));
        }).bind(this);
        this.put = (0, $47bZj.adapterFun)('put', function(doc, opts, cb) {
            if (typeof opts === 'function') {
                cb = opts;
                opts = {};
            }
            if ($d7b0725bde674e9b$var$isNotSingleDoc(doc)) return cb((0, $cqZVJ.createError)((0, $cqZVJ.NOT_AN_OBJECT)));
            (0, $47bZj.invalidIdError)(doc._id);
            if ('_rev' in doc && !$d7b0725bde674e9b$var$isValidRev(doc._rev)) return cb((0, $cqZVJ.createError)((0, $cqZVJ.INVALID_REV)));
            if ((0, $eMG3m.isLocalId)(doc._id) && typeof this._putLocal === 'function') {
                if (doc._deleted) return this._removeLocal(doc, cb);
                else return this._putLocal(doc, cb);
            }
            const putDoc = (next)=>{
                if (typeof this._put === 'function' && opts.new_edits !== false) this._put(doc, opts, next);
                else this.bulkDocs({
                    docs: [
                        doc
                    ]
                }, opts, $d7b0725bde674e9b$var$yankError(next, doc._id));
            };
            if (opts.force && doc._rev) {
                transformForceOptionToNewEditsOption();
                putDoc(function(err) {
                    var result = err ? null : {
                        ok: true,
                        id: doc._id,
                        rev: doc._rev
                    };
                    cb(err, result);
                });
            } else putDoc(cb);
            function transformForceOptionToNewEditsOption() {
                var parts = doc._rev.split('-');
                var oldRevId = parts[1];
                var oldRevNum = parseInt(parts[0], 10);
                var newRevNum = oldRevNum + 1;
                var newRevId = (0, $47bZj.rev)();
                doc._revisions = {
                    start: newRevNum,
                    ids: [
                        newRevId,
                        oldRevId
                    ]
                };
                doc._rev = newRevNum + '-' + newRevId;
                opts.new_edits = false;
            }
        }).bind(this);
        this.putAttachment = (0, $47bZj.adapterFun)('putAttachment', function(docId, attachmentId, rev$$1, blob, type) {
            var api = this;
            if (typeof type === 'function') {
                type = blob;
                blob = rev$$1;
                rev$$1 = null;
            }
            // Lets fix in https://github.com/pouchdb/pouchdb/issues/3267
            /* istanbul ignore if */ if (typeof type === 'undefined') {
                type = blob;
                blob = rev$$1;
                rev$$1 = null;
            }
            if (!type) (0, $47bZj.guardedConsole)('warn', 'Attachment', attachmentId, 'on document', docId, 'is missing content_type');
            function createAttachment(doc) {
                var prevrevpos = '_rev' in doc ? parseInt(doc._rev, 10) : 0;
                doc._attachments = doc._attachments || {};
                doc._attachments[attachmentId] = {
                    content_type: type,
                    data: blob,
                    revpos: ++prevrevpos
                };
                return api.put(doc);
            }
            return api.get(docId).then(function(doc) {
                if (doc._rev !== rev$$1) throw (0, $cqZVJ.createError)((0, $cqZVJ.REV_CONFLICT));
                return createAttachment(doc);
            }, function(err) {
                // create new doc
                /* istanbul ignore else */ if (err.reason === (0, $cqZVJ.MISSING_DOC).message) return createAttachment({
                    _id: docId
                });
                else throw err;
            });
        }).bind(this);
        this.removeAttachment = (0, $47bZj.adapterFun)('removeAttachment', function(docId, attachmentId, rev$$1, callback) {
            this.get(docId, (err, obj)=>{
                /* istanbul ignore if */ if (err) {
                    callback(err);
                    return;
                }
                if (obj._rev !== rev$$1) {
                    callback((0, $cqZVJ.createError)((0, $cqZVJ.REV_CONFLICT)));
                    return;
                }
                /* istanbul ignore if */ if (!obj._attachments) return callback();
                delete obj._attachments[attachmentId];
                if (Object.keys(obj._attachments).length === 0) delete obj._attachments;
                this.put(obj, callback);
            });
        }).bind(this);
        this.remove = (0, $47bZj.adapterFun)('remove', function(docOrId, optsOrRev, opts, callback) {
            var doc;
            if (typeof optsOrRev === 'string') {
                // id, rev, opts, callback style
                doc = {
                    _id: docOrId,
                    _rev: optsOrRev
                };
                if (typeof opts === 'function') {
                    callback = opts;
                    opts = {};
                }
            } else {
                // doc, opts, callback style
                doc = docOrId;
                if (typeof optsOrRev === 'function') {
                    callback = optsOrRev;
                    opts = {};
                } else {
                    callback = opts;
                    opts = optsOrRev;
                }
            }
            opts = opts || {};
            opts.was_delete = true;
            var newDoc = {
                _id: doc._id,
                _rev: doc._rev || opts.rev
            };
            newDoc._deleted = true;
            if ((0, $eMG3m.isLocalId)(newDoc._id) && typeof this._removeLocal === 'function') return this._removeLocal(doc, callback);
            this.bulkDocs({
                docs: [
                    newDoc
                ]
            }, opts, $d7b0725bde674e9b$var$yankError(callback, newDoc._id));
        }).bind(this);
        this.revsDiff = (0, $47bZj.adapterFun)('revsDiff', function(req, opts, callback) {
            if (typeof opts === 'function') {
                callback = opts;
                opts = {};
            }
            var ids = Object.keys(req);
            if (!ids.length) return callback(null, {});
            var count = 0;
            var missing = new Map();
            function addToMissing(id, revId) {
                if (!missing.has(id)) missing.set(id, {
                    missing: []
                });
                missing.get(id).missing.push(revId);
            }
            function processDoc(id, rev_tree) {
                // Is this fast enough? Maybe we should switch to a set simulated by a map
                var missingForId = req[id].slice(0);
                (0, $eMG3m.traverseRevTree)(rev_tree, function(isLeaf, pos, revHash, ctx, opts) {
                    var rev$$1 = pos + '-' + revHash;
                    var idx = missingForId.indexOf(rev$$1);
                    if (idx === -1) return;
                    missingForId.splice(idx, 1);
                    /* istanbul ignore if */ if (opts.status !== 'available') addToMissing(id, rev$$1);
                });
                // Traversing the tree is synchronous, so now `missingForId` contains
                // revisions that were not found in the tree
                missingForId.forEach(function(rev$$1) {
                    addToMissing(id, rev$$1);
                });
            }
            ids.forEach(function(id) {
                this._getRevisionTree(id, function(err, rev_tree) {
                    if (err && err.status === 404 && err.message === 'missing') missing.set(id, {
                        missing: req[id]
                    });
                    else if (err) /* istanbul ignore next */ return callback(err);
                    else processDoc(id, rev_tree);
                    if (++count === ids.length) {
                        // convert LazyMap to object
                        var missingObj = {};
                        missing.forEach(function(value, key) {
                            missingObj[key] = value;
                        });
                        return callback(null, missingObj);
                    }
                });
            }, this);
        }).bind(this);
        // _bulk_get API for faster replication, as described in
        // https://github.com/apache/couchdb-chttpd/pull/33
        // At the "abstract" level, it will just run multiple get()s in
        // parallel, because this isn't much of a performance cost
        // for local databases (except the cost of multiple transactions, which is
        // small). The http adapter overrides this in order
        // to do a more efficient single HTTP request.
        this.bulkGet = (0, $47bZj.adapterFun)('bulkGet', function(opts, callback) {
            (0, $47bZj.bulkGetShim)(this, opts, callback);
        }).bind(this);
        // compact one document and fire callback
        // by compacting we mean removing all revisions which
        // are further from the leaf in revision tree than max_height
        this.compactDocument = (0, $47bZj.adapterFun)('compactDocument', function(docId, maxHeight, callback) {
            this._getRevisionTree(docId, (err, revTree)=>{
                /* istanbul ignore if */ if (err) return callback(err);
                var height = $d7b0725bde674e9b$var$computeHeight(revTree);
                var candidates = [];
                var revs = [];
                Object.keys(height).forEach(function(rev$$1) {
                    if (height[rev$$1] > maxHeight) candidates.push(rev$$1);
                });
                (0, $eMG3m.traverseRevTree)(revTree, function(isLeaf, pos, revHash, ctx, opts) {
                    var rev$$1 = pos + '-' + revHash;
                    if (opts.status === 'available' && candidates.indexOf(rev$$1) !== -1) revs.push(rev$$1);
                });
                this._doCompaction(docId, revs, callback);
            });
        }).bind(this);
        // compact the whole database using single document
        // compaction
        this.compact = (0, $47bZj.adapterFun)('compact', function(opts, callback) {
            if (typeof opts === 'function') {
                callback = opts;
                opts = {};
            }
            opts = opts || {};
            this._compactionQueue = this._compactionQueue || [];
            this._compactionQueue.push({
                opts: opts,
                callback: callback
            });
            if (this._compactionQueue.length === 1) $d7b0725bde674e9b$var$doNextCompaction(this);
        }).bind(this);
        /* Begin api wrappers. Specific functionality to storage belongs in the _[method] */ this.get = (0, $47bZj.adapterFun)('get', function(id, opts, cb) {
            if (typeof opts === 'function') {
                cb = opts;
                opts = {};
            }
            opts = opts || {};
            if (typeof id !== 'string') return cb((0, $cqZVJ.createError)((0, $cqZVJ.INVALID_ID)));
            if ((0, $eMG3m.isLocalId)(id) && typeof this._getLocal === 'function') return this._getLocal(id, cb);
            var leaves = [];
            const finishOpenRevs = ()=>{
                var result = [];
                var count = leaves.length;
                /* istanbul ignore if */ if (!count) return cb(null, result);
                // order with open_revs is unspecified
                leaves.forEach((leaf)=>{
                    this.get(id, {
                        rev: leaf,
                        revs: opts.revs,
                        latest: opts.latest,
                        attachments: opts.attachments,
                        binary: opts.binary
                    }, function(err, doc) {
                        if (!err) {
                            // using latest=true can produce duplicates
                            var existing;
                            for(var i = 0, l = result.length; i < l; i++)if (result[i].ok && result[i].ok._rev === doc._rev) {
                                existing = true;
                                break;
                            }
                            if (!existing) result.push({
                                ok: doc
                            });
                        } else result.push({
                            missing: leaf
                        });
                        count--;
                        if (!count) cb(null, result);
                    });
                });
            };
            if (opts.open_revs) {
                if (opts.open_revs === "all") this._getRevisionTree(id, function(err, rev_tree) {
                    /* istanbul ignore if */ if (err) return cb(err);
                    leaves = (0, $eMG3m.collectLeaves)(rev_tree).map(function(leaf) {
                        return leaf.rev;
                    });
                    finishOpenRevs();
                });
                else {
                    if (Array.isArray(opts.open_revs)) {
                        leaves = opts.open_revs;
                        for(var i = 0; i < leaves.length; i++){
                            var l = leaves[i];
                            // looks like it's the only thing couchdb checks
                            if (!$d7b0725bde674e9b$var$isValidRev(l)) return cb((0, $cqZVJ.createError)((0, $cqZVJ.INVALID_REV)));
                        }
                        finishOpenRevs();
                    } else return cb((0, $cqZVJ.createError)((0, $cqZVJ.UNKNOWN_ERROR), 'function_clause'));
                }
                return; // open_revs does not like other options
            }
            return this._get(id, opts, (err, result)=>{
                if (err) {
                    err.docId = id;
                    return cb(err);
                }
                var doc = result.doc;
                var metadata = result.metadata;
                var ctx = result.ctx;
                if (opts.conflicts) {
                    var conflicts = (0, $eMG3m.collectConflicts)(metadata);
                    if (conflicts.length) doc._conflicts = conflicts;
                }
                if ((0, $eMG3m.isDeleted)(metadata, doc._rev)) doc._deleted = true;
                if (opts.revs || opts.revs_info) {
                    var splittedRev = doc._rev.split('-');
                    var revNo = parseInt(splittedRev[0], 10);
                    var revHash = splittedRev[1];
                    var paths = (0, $eMG3m.rootToLeaf)(metadata.rev_tree);
                    var path = null;
                    for(var i = 0; i < paths.length; i++){
                        var currentPath = paths[i];
                        const hashIndex = currentPath.ids.findIndex((x)=>x.id === revHash);
                        var hashFoundAtRevPos = hashIndex === revNo - 1;
                        if (hashFoundAtRevPos || !path && hashIndex !== -1) path = currentPath;
                    }
                    /* istanbul ignore if */ if (!path) {
                        err = new Error('invalid rev tree');
                        err.docId = id;
                        return cb(err);
                    }
                    const pathId = doc._rev.split('-')[1];
                    const indexOfRev = path.ids.findIndex((x)=>x.id === pathId) + 1;
                    var howMany = path.ids.length - indexOfRev;
                    path.ids.splice(indexOfRev, howMany);
                    path.ids.reverse();
                    if (opts.revs) doc._revisions = {
                        start: path.pos + path.ids.length - 1,
                        ids: path.ids.map(function(rev$$1) {
                            return rev$$1.id;
                        })
                    };
                    if (opts.revs_info) {
                        var pos = path.pos + path.ids.length;
                        doc._revs_info = path.ids.map(function(rev$$1) {
                            pos--;
                            return {
                                rev: pos + '-' + rev$$1.id,
                                status: rev$$1.opts.status
                            };
                        });
                    }
                }
                if (opts.attachments && doc._attachments) {
                    var attachments = doc._attachments;
                    var count = Object.keys(attachments).length;
                    if (count === 0) return cb(null, doc);
                    Object.keys(attachments).forEach((key)=>{
                        this._getAttachment(doc._id, key, attachments[key], {
                            binary: opts.binary,
                            metadata: metadata,
                            ctx: ctx
                        }, function(err, data) {
                            var att = doc._attachments[key];
                            att.data = data;
                            delete att.stub;
                            delete att.length;
                            if (!--count) cb(null, doc);
                        });
                    });
                } else {
                    if (doc._attachments) {
                        for(var key in doc._attachments)/* istanbul ignore else */ if (Object.prototype.hasOwnProperty.call(doc._attachments, key)) doc._attachments[key].stub = true;
                    }
                    cb(null, doc);
                }
            });
        }).bind(this);
        // TODO: I don't like this, it forces an extra read for every
        // attachment read and enforces a confusing api between
        // adapter.js and the adapter implementation
        this.getAttachment = (0, $47bZj.adapterFun)('getAttachment', function(docId, attachmentId, opts, callback) {
            if (opts instanceof Function) {
                callback = opts;
                opts = {};
            }
            this._get(docId, opts, (err, res)=>{
                if (err) return callback(err);
                if (res.doc._attachments && res.doc._attachments[attachmentId]) {
                    opts.ctx = res.ctx;
                    opts.binary = true;
                    opts.metadata = res.metadata;
                    this._getAttachment(docId, attachmentId, res.doc._attachments[attachmentId], opts, callback);
                } else return callback((0, $cqZVJ.createError)((0, $cqZVJ.MISSING_DOC)));
            });
        }).bind(this);
        this.allDocs = (0, $47bZj.adapterFun)('allDocs', function(opts, callback) {
            if (typeof opts === 'function') {
                callback = opts;
                opts = {};
            }
            opts.skip = typeof opts.skip !== 'undefined' ? opts.skip : 0;
            if (opts.start_key) opts.startkey = opts.start_key;
            if (opts.end_key) opts.endkey = opts.end_key;
            if ('keys' in opts) {
                if (!Array.isArray(opts.keys)) return callback(new TypeError('options.keys must be an array'));
                var incompatibleOpt = [
                    'startkey',
                    'endkey',
                    'key'
                ].filter(function(incompatibleOpt) {
                    return incompatibleOpt in opts;
                })[0];
                if (incompatibleOpt) {
                    callback((0, $cqZVJ.createError)((0, $cqZVJ.QUERY_PARSE_ERROR), 'Query parameter `' + incompatibleOpt + '` is not compatible with multi-get'));
                    return;
                }
                if (!(0, $47bZj.isRemote)(this)) {
                    $d7b0725bde674e9b$var$allDocsKeysParse(opts);
                    if (opts.keys.length === 0) return this._allDocs({
                        limit: 0
                    }, callback);
                }
            }
            return this._allDocs(opts, callback);
        }).bind(this);
        this.close = (0, $47bZj.adapterFun)('close', function(callback) {
            this._closed = true;
            this.emit('closed');
            return this._close(callback);
        }).bind(this);
        this.info = (0, $47bZj.adapterFun)('info', function(callback) {
            this._info((err, info)=>{
                if (err) return callback(err);
                // assume we know better than the adapter, unless it informs us
                info.db_name = info.db_name || this.name;
                info.auto_compaction = !!(this.auto_compaction && !(0, $47bZj.isRemote)(this));
                info.adapter = this.adapter;
                callback(null, info);
            });
        }).bind(this);
        this.id = (0, $47bZj.adapterFun)('id', function(callback) {
            return this._id(callback);
        }).bind(this);
        this.bulkDocs = (0, $47bZj.adapterFun)('bulkDocs', function(req, opts, callback) {
            if (typeof opts === 'function') {
                callback = opts;
                opts = {};
            }
            opts = opts || {};
            if (Array.isArray(req)) req = {
                docs: req
            };
            if (!req || !req.docs || !Array.isArray(req.docs)) return callback((0, $cqZVJ.createError)((0, $cqZVJ.MISSING_BULK_DOCS)));
            for(var i = 0; i < req.docs.length; ++i){
                const doc = req.docs[i];
                if ($d7b0725bde674e9b$var$isNotSingleDoc(doc)) return callback((0, $cqZVJ.createError)((0, $cqZVJ.NOT_AN_OBJECT)));
                if ('_rev' in doc && !$d7b0725bde674e9b$var$isValidRev(doc._rev)) return callback((0, $cqZVJ.createError)((0, $cqZVJ.INVALID_REV)));
            }
            var attachmentError;
            req.docs.forEach(function(doc) {
                if (doc._attachments) Object.keys(doc._attachments).forEach(function(name) {
                    attachmentError = attachmentError || $d7b0725bde674e9b$var$attachmentNameError(name);
                    if (!doc._attachments[name].content_type) (0, $47bZj.guardedConsole)('warn', 'Attachment', name, 'on document', doc._id, 'is missing content_type');
                });
            });
            if (attachmentError) return callback((0, $cqZVJ.createError)((0, $cqZVJ.BAD_REQUEST), attachmentError));
            if (!('new_edits' in opts)) {
                if ('new_edits' in req) opts.new_edits = req.new_edits;
                else opts.new_edits = true;
            }
            var adapter = this;
            if (!opts.new_edits && !(0, $47bZj.isRemote)(adapter)) // ensure revisions of the same doc are sorted, so that
            // the local adapter processes them correctly (#2935)
            req.docs.sort($d7b0725bde674e9b$var$compareByIdThenRev);
            $d7b0725bde674e9b$var$cleanDocs(req.docs);
            // in the case of conflicts, we want to return the _ids to the user
            // however, the underlying adapter may destroy the docs array, so
            // create a copy here
            var ids = req.docs.map(function(doc) {
                return doc._id;
            });
            this._bulkDocs(req, opts, function(err, res) {
                if (err) return callback(err);
                if (!opts.new_edits) // this is what couch does when new_edits is false
                res = res.filter(function(x) {
                    return x.error;
                });
                // add ids for error/conflict responses (not required for CouchDB)
                if (!(0, $47bZj.isRemote)(adapter)) for(var i = 0, l = res.length; i < l; i++)res[i].id = res[i].id || ids[i];
                callback(null, res);
            });
        }).bind(this);
        this.registerDependentDatabase = (0, $47bZj.adapterFun)('registerDependentDatabase', function(dependentDb, callback) {
            var dbOptions = (0, $47bZj.clone)(this.__opts);
            if (this.__opts.view_adapter) dbOptions.adapter = this.__opts.view_adapter;
            var depDB = new this.constructor(dependentDb, dbOptions);
            function diffFun(doc) {
                doc.dependentDbs = doc.dependentDbs || {};
                if (doc.dependentDbs[dependentDb]) return false; // no update required
                doc.dependentDbs[dependentDb] = true;
                return doc;
            }
            (0, $47bZj.upsert)(this, '_local/_pouch_dependentDbs', diffFun).then(function() {
                callback(null, {
                    db: depDB
                });
            }).catch(callback);
        }).bind(this);
        this.destroy = (0, $47bZj.adapterFun)('destroy', function(opts, callback) {
            if (typeof opts === 'function') {
                callback = opts;
                opts = {};
            }
            var usePrefix = 'use_prefix' in this ? this.use_prefix : true;
            const destroyDb = ()=>{
                // call destroy method of the particular adaptor
                this._destroy(opts, (err, resp)=>{
                    if (err) return callback(err);
                    this._destroyed = true;
                    this.emit('destroyed');
                    callback(null, resp || {
                        'ok': true
                    });
                });
            };
            if ((0, $47bZj.isRemote)(this)) // no need to check for dependent DBs if it's a remote DB
            return destroyDb();
            this.get('_local/_pouch_dependentDbs', (err, localDoc)=>{
                if (err) {
                    /* istanbul ignore if */ if (err.status !== 404) return callback(err);
                    else return destroyDb();
                }
                var dependentDbs = localDoc.dependentDbs;
                var PouchDB = this.constructor;
                var deletedMap = Object.keys(dependentDbs).map((name)=>{
                    // use_prefix is only false in the browser
                    /* istanbul ignore next */ var trueName = usePrefix ? name.replace(new RegExp('^' + PouchDB.prefix), '') : name;
                    return new PouchDB(trueName, this.__opts).destroy();
                });
                Promise.all(deletedMap).then(destroyDb, callback);
            });
        }).bind(this);
    }
    _compact(opts, callback) {
        var changesOpts = {
            return_docs: false,
            last_seq: opts.last_seq || 0,
            since: opts.last_seq || 0
        };
        var promises = [];
        var taskId;
        var compactedDocs = 0;
        const onChange = (row)=>{
            this.activeTasks.update(taskId, {
                completed_items: ++compactedDocs
            });
            promises.push(this.compactDocument(row.id, 0));
        };
        const onError = (err)=>{
            this.activeTasks.remove(taskId, err);
            callback(err);
        };
        const onComplete = (resp)=>{
            var lastSeq = resp.last_seq;
            Promise.all(promises).then(()=>{
                return (0, $47bZj.upsert)(this, '_local/compaction', (doc)=>{
                    if (!doc.last_seq || doc.last_seq < lastSeq) {
                        doc.last_seq = lastSeq;
                        return doc;
                    }
                    return false; // somebody else got here first, don't update
                });
            }).then(()=>{
                this.activeTasks.remove(taskId);
                callback(null, {
                    ok: true
                });
            }).catch(onError);
        };
        this.info().then((info)=>{
            taskId = this.activeTasks.add({
                name: 'database_compaction',
                total_items: info.update_seq - changesOpts.last_seq
            });
            this.changes(changesOpts).on('change', onChange).on('complete', onComplete).on('error', onError);
        });
    }
    changes(opts, callback) {
        if (typeof opts === 'function') {
            callback = opts;
            opts = {};
        }
        opts = opts || {};
        // By default set return_docs to false if the caller has opts.live = true,
        // this will prevent us from collecting the set of changes indefinitely
        // resulting in growing memory
        opts.return_docs = 'return_docs' in opts ? opts.return_docs : !opts.live;
        return new $d7b0725bde674e9b$var$Changes(this, opts, callback);
    }
    type() {
        return typeof this._type === 'function' ? this._type() : this.adapter;
    }
}
// The abstract purge implementation expects a doc id and the rev of a leaf node in that doc.
// It will return errors if the rev doesn’t exist or isn’t a leaf.
$d7b0725bde674e9b$var$AbstractPouchDB.prototype.purge = (0, $47bZj.adapterFun)('_purge', function(docId, rev$$1, callback) {
    if (typeof this._purge === 'undefined') return callback((0, $cqZVJ.createError)((0, $cqZVJ.UNKNOWN_ERROR), 'Purge is not implemented in the ' + this.adapter + ' adapter.'));
    var self1 = this;
    self1._getRevisionTree(docId, (error, revs)=>{
        if (error) return callback(error);
        if (!revs) return callback((0, $cqZVJ.createError)((0, $cqZVJ.MISSING_DOC)));
        let path;
        try {
            path = (0, $eMG3m.findPathToLeaf)(revs, rev$$1);
        } catch (error) {
            return callback(error.message || error);
        }
        self1._purge(docId, path, (error, result)=>{
            if (error) return callback(error);
            else $d7b0725bde674e9b$var$appendPurgeSeq(self1, docId, rev$$1).then(function() {
                return callback(null, result);
            });
        });
    });
});
class $d7b0725bde674e9b$var$TaskQueue {
    constructor(){
        this.isReady = false;
        this.failed = false;
        this.queue = [];
    }
    execute() {
        var fun;
        if (this.failed) while(fun = this.queue.shift())fun(this.failed);
        else while(fun = this.queue.shift())fun();
    }
    fail(err) {
        this.failed = err;
        this.execute();
    }
    ready(db) {
        this.isReady = true;
        this.db = db;
        this.execute();
    }
    addTask(fun) {
        this.queue.push(fun);
        if (this.failed) this.execute();
    }
}
function $d7b0725bde674e9b$var$parseAdapter(name, opts) {
    var match = name.match(/([a-z-]*):\/\/(.*)/);
    if (match) // the http adapter expects the fully qualified name
    return {
        name: /https?/.test(match[1]) ? match[1] + '://' + match[2] : match[2],
        adapter: match[1]
    };
    var adapters = $d7b0725bde674e9b$var$PouchDB.adapters;
    var preferredAdapters = $d7b0725bde674e9b$var$PouchDB.preferredAdapters;
    var prefix = $d7b0725bde674e9b$var$PouchDB.prefix;
    var adapterName = opts.adapter;
    if (!adapterName) for(var i = 0; i < preferredAdapters.length; ++i){
        adapterName = preferredAdapters[i];
        // check for browsers that have been upgraded from websql-only to websql+idb
        /* istanbul ignore if */ if (adapterName === 'idb' && 'websql' in adapters && (0, $47bZj.hasLocalStorage)() && localStorage['_pouch__websqldb_' + prefix + name]) {
            // log it, because this can be confusing during development
            (0, $47bZj.guardedConsole)('log', 'PouchDB is downgrading "' + name + '" to WebSQL to' + ' avoid data loss, because it was already opened with WebSQL.');
            continue; // keep using websql to avoid user data loss
        }
        break;
    }
    var adapter = adapters[adapterName];
    // if adapter is invalid, then an error will be thrown later
    var usePrefix = adapter && 'use_prefix' in adapter ? adapter.use_prefix : true;
    return {
        name: usePrefix ? prefix + name : name,
        adapter: adapterName
    };
}
function $d7b0725bde674e9b$var$inherits(A, B) {
    A.prototype = Object.create(B.prototype, {
        constructor: {
            value: A
        }
    });
}
function $d7b0725bde674e9b$var$createClass(parent, init) {
    let klass = function(...args) {
        if (!(this instanceof klass)) return new klass(...args);
        init.apply(this, args);
    };
    $d7b0725bde674e9b$var$inherits(klass, parent);
    return klass;
}
// OK, so here's the deal. Consider this code:
//     var db1 = new PouchDB('foo');
//     var db2 = new PouchDB('foo');
//     db1.destroy();
// ^ these two both need to emit 'destroyed' events,
// as well as the PouchDB constructor itself.
// So we have one db object (whichever one got destroy() called on it)
// responsible for emitting the initial event, which then gets emitted
// by the constructor, which then broadcasts it to any other dbs
// that may have been created with the same name.
function $d7b0725bde674e9b$var$prepareForDestruction(self1) {
    function onDestroyed(from_constructor) {
        self1.removeListener('closed', onClosed);
        if (!from_constructor) self1.constructor.emit('destroyed', self1.name);
    }
    function onClosed() {
        self1.removeListener('destroyed', onDestroyed);
        self1.constructor.emit('unref', self1);
    }
    self1.once('destroyed', onDestroyed);
    self1.once('closed', onClosed);
    self1.constructor.emit('ref', self1);
}
class $d7b0725bde674e9b$var$PouchInternal extends $d7b0725bde674e9b$var$AbstractPouchDB {
    constructor(name, opts){
        super();
        this._setup(name, opts);
    }
    _setup(name, opts) {
        super._setup();
        opts = opts || {};
        if (name && typeof name === 'object') {
            opts = name;
            name = opts.name;
            delete opts.name;
        }
        if (opts.deterministic_revs === undefined) opts.deterministic_revs = true;
        this.__opts = opts = (0, $47bZj.clone)(opts);
        this.auto_compaction = opts.auto_compaction;
        this.purged_infos_limit = opts.purged_infos_limit || 1000;
        this.prefix = $d7b0725bde674e9b$var$PouchDB.prefix;
        if (typeof name !== 'string') throw new Error('Missing/invalid DB name');
        var prefixedName = (opts.prefix || '') + name;
        var backend = $d7b0725bde674e9b$var$parseAdapter(prefixedName, opts);
        opts.name = backend.name;
        opts.adapter = opts.adapter || backend.adapter;
        this.name = name;
        this._adapter = opts.adapter;
        $d7b0725bde674e9b$var$PouchDB.emit('debug', [
            'adapter',
            'Picked adapter: ',
            opts.adapter
        ]);
        if (!$d7b0725bde674e9b$var$PouchDB.adapters[opts.adapter] || !$d7b0725bde674e9b$var$PouchDB.adapters[opts.adapter].valid()) throw new Error('Invalid Adapter: ' + opts.adapter);
        if (opts.view_adapter) {
            if (!$d7b0725bde674e9b$var$PouchDB.adapters[opts.view_adapter] || !$d7b0725bde674e9b$var$PouchDB.adapters[opts.view_adapter].valid()) throw new Error('Invalid View Adapter: ' + opts.view_adapter);
        }
        this.taskqueue = new $d7b0725bde674e9b$var$TaskQueue();
        this.adapter = opts.adapter;
        $d7b0725bde674e9b$var$PouchDB.adapters[opts.adapter].call(this, opts, (err)=>{
            if (err) return this.taskqueue.fail(err);
            $d7b0725bde674e9b$var$prepareForDestruction(this);
            this.emit('created', this);
            $d7b0725bde674e9b$var$PouchDB.emit('created', this.name);
            this.taskqueue.ready(this);
        });
    }
}
const $d7b0725bde674e9b$var$PouchDB = $d7b0725bde674e9b$var$createClass($d7b0725bde674e9b$var$PouchInternal, function(name, opts) {
    $d7b0725bde674e9b$var$PouchInternal.prototype._setup.call(this, name, opts);
});
class $d7b0725bde674e9b$var$ActiveTasks {
    constructor(){
        this.tasks = {};
    }
    list() {
        return Object.values(this.tasks);
    }
    add(task) {
        const id = (0, $6fzQb.default)();
        this.tasks[id] = {
            id: id,
            name: task.name,
            total_items: task.total_items,
            created_at: new Date().toJSON()
        };
        return id;
    }
    get(id) {
        return this.tasks[id];
    }
    /* eslint-disable no-unused-vars */ remove(id, reason) {
        delete this.tasks[id];
        return this.tasks;
    }
    update(id, updatedTask) {
        const task = this.tasks[id];
        if (typeof task !== 'undefined') {
            const mergedTask = {
                id: task.id,
                name: task.name,
                created_at: task.created_at,
                total_items: updatedTask.total_items || task.total_items,
                completed_items: updatedTask.completed_items || task.completed_items,
                updated_at: new Date().toJSON()
            };
            this.tasks[id] = mergedTask;
        }
        return this.tasks;
    }
}
$d7b0725bde674e9b$var$PouchDB.adapters = {};
$d7b0725bde674e9b$var$PouchDB.preferredAdapters = [];
$d7b0725bde674e9b$var$PouchDB.prefix = '_pouch_';
var $d7b0725bde674e9b$var$eventEmitter = new (0, (/*@__PURE__*/$parcel$interopDefault($9KgKE)))();
function $d7b0725bde674e9b$var$setUpEventEmitter(Pouch) {
    Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($9KgKE))).prototype).forEach(function(key) {
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($9KgKE))).prototype[key] === 'function') Pouch[key] = $d7b0725bde674e9b$var$eventEmitter[key].bind($d7b0725bde674e9b$var$eventEmitter);
    });
    // these are created in constructor.js, and allow us to notify each DB with
    // the same name that it was destroyed, via the constructor object
    var destructListeners = Pouch._destructionListeners = new Map();
    Pouch.on('ref', function onConstructorRef(db) {
        if (!destructListeners.has(db.name)) destructListeners.set(db.name, []);
        destructListeners.get(db.name).push(db);
    });
    Pouch.on('unref', function onConstructorUnref(db) {
        if (!destructListeners.has(db.name)) return;
        var dbList = destructListeners.get(db.name);
        var pos = dbList.indexOf(db);
        if (pos < 0) /* istanbul ignore next */ return;
        dbList.splice(pos, 1);
        if (dbList.length > 1) /* istanbul ignore next */ destructListeners.set(db.name, dbList);
        else destructListeners.delete(db.name);
    });
    Pouch.on('destroyed', function onConstructorDestroyed(name) {
        if (!destructListeners.has(name)) return;
        var dbList = destructListeners.get(name);
        destructListeners.delete(name);
        dbList.forEach(function(db) {
            db.emit('destroyed', true);
        });
    });
}
$d7b0725bde674e9b$var$setUpEventEmitter($d7b0725bde674e9b$var$PouchDB);
$d7b0725bde674e9b$var$PouchDB.adapter = function(id, obj, addToPreferredAdapters) {
    /* istanbul ignore else */ if (obj.valid()) {
        $d7b0725bde674e9b$var$PouchDB.adapters[id] = obj;
        if (addToPreferredAdapters) $d7b0725bde674e9b$var$PouchDB.preferredAdapters.push(id);
    }
};
$d7b0725bde674e9b$var$PouchDB.plugin = function(obj) {
    if (typeof obj === 'function') obj($d7b0725bde674e9b$var$PouchDB);
    else if (typeof obj !== 'object' || Object.keys(obj).length === 0) throw new Error('Invalid plugin: got "' + obj + '", expected an object or a function');
    else Object.keys(obj).forEach(function(id) {
        $d7b0725bde674e9b$var$PouchDB.prototype[id] = obj[id];
    });
    if (this.__defaults) $d7b0725bde674e9b$var$PouchDB.__defaults = Object.assign({}, this.__defaults);
    return $d7b0725bde674e9b$var$PouchDB;
};
$d7b0725bde674e9b$var$PouchDB.defaults = function(defaultOpts) {
    let PouchWithDefaults = $d7b0725bde674e9b$var$createClass($d7b0725bde674e9b$var$PouchDB, function(name, opts) {
        opts = opts || {};
        if (name && typeof name === 'object') {
            opts = name;
            name = opts.name;
            delete opts.name;
        }
        opts = Object.assign({}, PouchWithDefaults.__defaults, opts);
        $d7b0725bde674e9b$var$PouchDB.call(this, name, opts);
    });
    PouchWithDefaults.preferredAdapters = $d7b0725bde674e9b$var$PouchDB.preferredAdapters.slice();
    Object.keys($d7b0725bde674e9b$var$PouchDB).forEach(function(key) {
        if (!(key in PouchWithDefaults)) PouchWithDefaults[key] = $d7b0725bde674e9b$var$PouchDB[key];
    });
    // make default options transitive
    // https://github.com/pouchdb/pouchdb/issues/5922
    PouchWithDefaults.__defaults = Object.assign({}, this.__defaults, defaultOpts);
    return PouchWithDefaults;
};
$d7b0725bde674e9b$var$PouchDB.fetch = function(url, opts) {
    return (0, $7zAYS.fetch)(url, opts);
};
$d7b0725bde674e9b$var$PouchDB.prototype.activeTasks = $d7b0725bde674e9b$var$PouchDB.activeTasks = new $d7b0725bde674e9b$var$ActiveTasks();
// managed automatically by set-version.js
var $d7b0725bde674e9b$var$version = "9.0.0";
// TODO: remove from pouchdb-core (breaking)
$d7b0725bde674e9b$var$PouchDB.plugin((0, $b6VZA.default));
$d7b0725bde674e9b$var$PouchDB.version = $d7b0725bde674e9b$var$version;
var $d7b0725bde674e9b$export$2e2bcd8739ae039 = $d7b0725bde674e9b$var$PouchDB;

});
parcelRegister("7zAYS", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $58387ce7753c1abd$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "Headers", () => $58387ce7753c1abd$export$79b704688b15c0f4);
var $58387ce7753c1abd$export$e7aa7bc5c1b3cfb3 = fetch;
var $58387ce7753c1abd$export$79b704688b15c0f4 = Headers;

});

parcelRegister("b6VZA", function(module, exports) {

$parcel$export(module.exports, "default", () => $816d3d50c9751846$export$2e2bcd8739ae039);

var $cqZVJ = parcelRequire("cqZVJ");

var $fir5e = parcelRequire("fir5e");

var $47bZj = parcelRequire("47bZj");
function $816d3d50c9751846$var$evalFilter(input) {
    return (0, $47bZj.scopeEval)('"use strict";\nreturn ' + input + ';', {});
}
function $816d3d50c9751846$var$evalView(input) {
    var code = [
        'return function(doc) {',
        '  "use strict";',
        '  var emitted = false;',
        '  var emit = function (a, b) {',
        '    emitted = true;',
        '  };',
        '  var view = ' + input + ';',
        '  view(doc);',
        '  if (emitted) {',
        '    return true;',
        '  }',
        '};'
    ].join('\n');
    return (0, $47bZj.scopeEval)(code, {});
}
function $816d3d50c9751846$var$validate(opts, callback) {
    if (opts.selector) {
        if (opts.filter && opts.filter !== '_selector') {
            var filterName = typeof opts.filter === 'string' ? opts.filter : 'function';
            return callback(new Error('selector invalid for filter "' + filterName + '"'));
        }
    }
    callback();
}
function $816d3d50c9751846$var$normalize(opts) {
    if (opts.view && !opts.filter) opts.filter = '_view';
    if (opts.selector && !opts.filter) opts.filter = '_selector';
    if (opts.filter && typeof opts.filter === 'string') {
        if (opts.filter === '_view') opts.view = (0, $47bZj.normalizeDdocFunctionName)(opts.view);
        else opts.filter = (0, $47bZj.normalizeDdocFunctionName)(opts.filter);
    }
}
function $816d3d50c9751846$var$shouldFilter(changesHandler, opts) {
    return opts.filter && typeof opts.filter === 'string' && !opts.doc_ids && !(0, $47bZj.isRemote)(changesHandler.db);
}
function $816d3d50c9751846$var$filter(changesHandler, opts) {
    var callback = opts.complete;
    if (opts.filter === '_view') {
        if (!opts.view || typeof opts.view !== 'string') {
            var err = (0, $cqZVJ.createError)((0, $cqZVJ.BAD_REQUEST), '`view` filter parameter not found or invalid.');
            return callback(err);
        }
        // fetch a view from a design doc, make it behave like a filter
        var viewName = (0, $47bZj.parseDdocFunctionName)(opts.view);
        changesHandler.db.get('_design/' + viewName[0], function(err, ddoc) {
            /* istanbul ignore if */ if (changesHandler.isCancelled) return callback(null, {
                status: 'cancelled'
            });
            /* istanbul ignore next */ if (err) return callback((0, $cqZVJ.generateErrorFromResponse)(err));
            var mapFun = ddoc && ddoc.views && ddoc.views[viewName[1]] && ddoc.views[viewName[1]].map;
            if (!mapFun) return callback((0, $cqZVJ.createError)((0, $cqZVJ.MISSING_DOC), ddoc.views ? 'missing json key: ' + viewName[1] : 'missing json key: views'));
            opts.filter = $816d3d50c9751846$var$evalView(mapFun);
            changesHandler.doChanges(opts);
        });
    } else if (opts.selector) {
        opts.filter = function(doc) {
            return (0, $fir5e.matchesSelector)(doc, opts.selector);
        };
        changesHandler.doChanges(opts);
    } else {
        // fetch a filter from a design doc
        var filterName = (0, $47bZj.parseDdocFunctionName)(opts.filter);
        changesHandler.db.get('_design/' + filterName[0], function(err, ddoc) {
            /* istanbul ignore if */ if (changesHandler.isCancelled) return callback(null, {
                status: 'cancelled'
            });
            /* istanbul ignore next */ if (err) return callback((0, $cqZVJ.generateErrorFromResponse)(err));
            var filterFun = ddoc && ddoc.filters && ddoc.filters[filterName[1]];
            if (!filterFun) return callback((0, $cqZVJ.createError)((0, $cqZVJ.MISSING_DOC), ddoc && ddoc.filters ? 'missing json key: ' + filterName[1] : 'missing json key: filters'));
            opts.filter = $816d3d50c9751846$var$evalFilter(filterFun);
            changesHandler.doChanges(opts);
        });
    }
}
function $816d3d50c9751846$var$applyChangesFilterPlugin(PouchDB) {
    PouchDB._changesFilterPlugin = {
        validate: $816d3d50c9751846$var$validate,
        normalize: $816d3d50c9751846$var$normalize,
        shouldFilter: $816d3d50c9751846$var$shouldFilter,
        filter: $816d3d50c9751846$var$filter
    };
}
var $816d3d50c9751846$export$2e2bcd8739ae039 = $816d3d50c9751846$var$applyChangesFilterPlugin;

});
parcelRegister("fir5e", function(module, exports) {

$parcel$export(module.exports, "getFieldFromDoc", () => $b22d8ba9efab55d4$export$15fd855db9a2dbf7);
$parcel$export(module.exports, "setFieldInDoc", () => $b22d8ba9efab55d4$export$b8de7c81f44e04ce);
$parcel$export(module.exports, "compare", () => $b22d8ba9efab55d4$export$398604a469f7de9a);
$parcel$export(module.exports, "parseField", () => $b22d8ba9efab55d4$export$616eedde42a218b);
$parcel$export(module.exports, "getKey", () => $b22d8ba9efab55d4$export$a47fb462a08de82f);
$parcel$export(module.exports, "getValue", () => $b22d8ba9efab55d4$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "massageSelector", () => $b22d8ba9efab55d4$export$baf68476d5cf83f7);
$parcel$export(module.exports, "filterInMemoryFields", () => $b22d8ba9efab55d4$export$604c36f3edeff3a0);
$parcel$export(module.exports, "matchesSelector", () => $b22d8ba9efab55d4$export$b06a2f5618961e1e);

var $47bZj = parcelRequire("47bZj");

var $j8fka = parcelRequire("j8fka");
// this would just be "return doc[field]", but fields
// can be "deep" due to dot notation
function $b22d8ba9efab55d4$export$15fd855db9a2dbf7(doc, parsedField) {
    var value = doc;
    for(var i = 0, len = parsedField.length; i < len; i++){
        var key = parsedField[i];
        value = value[key];
        if (!value) break;
    }
    return value;
}
function $b22d8ba9efab55d4$export$b8de7c81f44e04ce(doc, parsedField, value) {
    for(var i = 0, len = parsedField.length; i < len - 1; i++){
        var elem = parsedField[i];
        doc = doc[elem] = doc[elem] || {};
    }
    doc[parsedField[len - 1]] = value;
}
function $b22d8ba9efab55d4$export$398604a469f7de9a(left, right) {
    return left < right ? -1 : left > right ? 1 : 0;
}
// Converts a string in dot notation to an array of its components, with backslash escaping
function $b22d8ba9efab55d4$export$616eedde42a218b(fieldName) {
    // fields may be deep (e.g. "foo.bar.baz"), so parse
    var fields = [];
    var current = '';
    for(var i = 0, len = fieldName.length; i < len; i++){
        var ch = fieldName[i];
        if (i > 0 && fieldName[i - 1] === '\\' && (ch === '$' || ch === '.')) // escaped delimiter
        current = current.substring(0, current.length - 1) + ch;
        else if (ch === '.') {
            // When `.` is not escaped (above), it is a field delimiter
            fields.push(current);
            current = '';
        } else current += ch;
    }
    fields.push(current);
    return fields;
}
var $b22d8ba9efab55d4$var$combinationFields = [
    '$or',
    '$nor',
    '$not'
];
function $b22d8ba9efab55d4$export$21fcfbdc979d5d7c(field) {
    return $b22d8ba9efab55d4$var$combinationFields.indexOf(field) > -1;
}
function $b22d8ba9efab55d4$export$a47fb462a08de82f(obj) {
    return Object.keys(obj)[0];
}
function $b22d8ba9efab55d4$export$bf7199a9ebcb84a9(obj) {
    return obj[$b22d8ba9efab55d4$export$a47fb462a08de82f(obj)];
}
// flatten an array of selectors joined by an $and operator
function $b22d8ba9efab55d4$var$mergeAndedSelectors(selectors) {
    // sort to ensure that e.g. if the user specified
    // $and: [{$gt: 'a'}, {$gt: 'b'}], then it's collapsed into
    // just {$gt: 'b'}
    var res = {};
    var first = {
        $or: true,
        $nor: true
    };
    selectors.forEach(function(selector) {
        Object.keys(selector).forEach(function(field) {
            var matcher = selector[field];
            if (typeof matcher !== 'object') matcher = {
                $eq: matcher
            };
            if ($b22d8ba9efab55d4$export$21fcfbdc979d5d7c(field)) {
                // or, nor
                if (matcher instanceof Array) {
                    if (first[field]) {
                        first[field] = false;
                        res[field] = matcher;
                        return;
                    }
                    var entries = [];
                    res[field].forEach(function(existing) {
                        Object.keys(matcher).forEach(function(key) {
                            var m = matcher[key];
                            var longest = Math.max(Object.keys(existing).length, Object.keys(m).length);
                            var merged = $b22d8ba9efab55d4$var$mergeAndedSelectors([
                                existing,
                                m
                            ]);
                            if (Object.keys(merged).length <= longest) // we have a situation like: (a :{$eq :1} || ...) && (a {$eq: 2} || ...)
                            // merging would produce a $eq 2 when actually we shouldn't ever match against these merged conditions
                            // merged should always contain more values to be valid
                            return;
                            entries.push(merged);
                        });
                    });
                    res[field] = entries;
                } else // not
                res[field] = $b22d8ba9efab55d4$var$mergeAndedSelectors([
                    matcher
                ]);
            } else {
                var fieldMatchers = res[field] = res[field] || {};
                Object.keys(matcher).forEach(function(operator) {
                    var value = matcher[operator];
                    if (operator === '$gt' || operator === '$gte') return $b22d8ba9efab55d4$var$mergeGtGte(operator, value, fieldMatchers);
                    else if (operator === '$lt' || operator === '$lte') return $b22d8ba9efab55d4$var$mergeLtLte(operator, value, fieldMatchers);
                    else if (operator === '$ne') return $b22d8ba9efab55d4$var$mergeNe(value, fieldMatchers);
                    else if (operator === '$eq') return $b22d8ba9efab55d4$var$mergeEq(value, fieldMatchers);
                    else if (operator === "$regex") return $b22d8ba9efab55d4$var$mergeRegex(value, fieldMatchers);
                    fieldMatchers[operator] = value;
                });
            }
        });
    });
    return res;
}
// collapse logically equivalent gt/gte values
function $b22d8ba9efab55d4$var$mergeGtGte(operator, value, fieldMatchers) {
    if (typeof fieldMatchers.$eq !== 'undefined') return; // do nothing
    if (typeof fieldMatchers.$gte !== 'undefined') {
        if (operator === '$gte') {
            if (value > fieldMatchers.$gte) fieldMatchers.$gte = value;
        } else if (value >= fieldMatchers.$gte) {
            delete fieldMatchers.$gte;
            fieldMatchers.$gt = value;
        }
    } else if (typeof fieldMatchers.$gt !== 'undefined') {
        if (operator === '$gte') {
            if (value > fieldMatchers.$gt) {
                delete fieldMatchers.$gt;
                fieldMatchers.$gte = value;
            }
        } else if (value > fieldMatchers.$gt) fieldMatchers.$gt = value;
    } else fieldMatchers[operator] = value;
}
// collapse logically equivalent lt/lte values
function $b22d8ba9efab55d4$var$mergeLtLte(operator, value, fieldMatchers) {
    if (typeof fieldMatchers.$eq !== 'undefined') return; // do nothing
    if (typeof fieldMatchers.$lte !== 'undefined') {
        if (operator === '$lte') {
            if (value < fieldMatchers.$lte) fieldMatchers.$lte = value;
        } else if (value <= fieldMatchers.$lte) {
            delete fieldMatchers.$lte;
            fieldMatchers.$lt = value;
        }
    } else if (typeof fieldMatchers.$lt !== 'undefined') {
        if (operator === '$lte') {
            if (value < fieldMatchers.$lt) {
                delete fieldMatchers.$lt;
                fieldMatchers.$lte = value;
            }
        } else if (value < fieldMatchers.$lt) fieldMatchers.$lt = value;
    } else fieldMatchers[operator] = value;
}
// combine $ne values into one array
function $b22d8ba9efab55d4$var$mergeNe(value, fieldMatchers) {
    if ('$ne' in fieldMatchers) // there are many things this could "not" be
    fieldMatchers.$ne.push(value);
    else fieldMatchers.$ne = [
        value
    ];
}
// add $eq into the mix
function $b22d8ba9efab55d4$var$mergeEq(value, fieldMatchers) {
    // these all have less specificity than the $eq
    // TODO: check for user errors here
    delete fieldMatchers.$gt;
    delete fieldMatchers.$gte;
    delete fieldMatchers.$lt;
    delete fieldMatchers.$lte;
    delete fieldMatchers.$ne;
    fieldMatchers.$eq = value;
}
// combine $regex values into one array
function $b22d8ba9efab55d4$var$mergeRegex(value, fieldMatchers) {
    if ('$regex' in fieldMatchers) // a value could match multiple regexes
    fieldMatchers.$regex.push(value);
    else fieldMatchers.$regex = [
        value
    ];
}
//#7458: execute function mergeAndedSelectors on nested $and
function $b22d8ba9efab55d4$var$mergeAndedSelectorsNested(obj) {
    for(var prop in obj){
        if (Array.isArray(obj)) {
            for(var i in obj)if (obj[i]['$and']) obj[i] = $b22d8ba9efab55d4$var$mergeAndedSelectors(obj[i]['$and']);
        }
        var value = obj[prop];
        if (typeof value === 'object') $b22d8ba9efab55d4$var$mergeAndedSelectorsNested(value); // <- recursive call
    }
    return obj;
}
//#7458: determine id $and is present in selector (at any level)
function $b22d8ba9efab55d4$var$isAndInSelector(obj, isAnd) {
    for(var prop in obj){
        if (prop === '$and') isAnd = true;
        var value = obj[prop];
        if (typeof value === 'object') isAnd = $b22d8ba9efab55d4$var$isAndInSelector(value, isAnd); // <- recursive call
    }
    return isAnd;
}
//
// normalize the selector
//
function $b22d8ba9efab55d4$export$baf68476d5cf83f7(input) {
    var result = (0, $47bZj.clone)(input);
    //#7458: if $and is present in selector (at any level) merge nested $and
    if ($b22d8ba9efab55d4$var$isAndInSelector(result, false)) {
        result = $b22d8ba9efab55d4$var$mergeAndedSelectorsNested(result);
        if ('$and' in result) result = $b22d8ba9efab55d4$var$mergeAndedSelectors(result['$and']);
    }
    [
        '$or',
        '$nor'
    ].forEach(function(orOrNor) {
        if (orOrNor in result) // message each individual selector
        // e.g. {foo: 'bar'} becomes {foo: {$eq: 'bar'}}
        result[orOrNor].forEach(function(subSelector) {
            var fields = Object.keys(subSelector);
            for(var i = 0; i < fields.length; i++){
                var field = fields[i];
                var matcher = subSelector[field];
                if (typeof matcher !== 'object' || matcher === null) subSelector[field] = {
                    $eq: matcher
                };
            }
        });
    });
    if ('$not' in result) //This feels a little like forcing, but it will work for now,
    //I would like to come back to this and make the merging of selectors a little more generic
    result['$not'] = $b22d8ba9efab55d4$var$mergeAndedSelectors([
        result['$not']
    ]);
    var fields = Object.keys(result);
    for(var i = 0; i < fields.length; i++){
        var field = fields[i];
        var matcher = result[field];
        if (typeof matcher !== 'object' || matcher === null) matcher = {
            $eq: matcher
        };
        result[field] = matcher;
    }
    $b22d8ba9efab55d4$var$normalizeArrayOperators(result);
    return result;
}
//
// The $ne and $regex values must be placed in an array because these operators can be used multiple times on the same field.
// When $and is used, mergeAndedSelectors takes care of putting some of them into arrays, otherwise it's done here.
//
function $b22d8ba9efab55d4$var$normalizeArrayOperators(selector) {
    Object.keys(selector).forEach(function(field) {
        var matcher = selector[field];
        if (Array.isArray(matcher)) matcher.forEach(function(matcherItem) {
            if (matcherItem && typeof matcherItem === 'object') $b22d8ba9efab55d4$var$normalizeArrayOperators(matcherItem);
        });
        else if (field === '$ne') selector.$ne = [
            matcher
        ];
        else if (field === '$regex') selector.$regex = [
            matcher
        ];
        else if (matcher && typeof matcher === 'object') $b22d8ba9efab55d4$var$normalizeArrayOperators(matcher);
    });
}
// create a comparator based on the sort object
function $b22d8ba9efab55d4$export$ba1d58924a4fd5d6(sort) {
    function getFieldValuesAsArray(doc) {
        return sort.map(function(sorting) {
            var fieldName = $b22d8ba9efab55d4$export$a47fb462a08de82f(sorting);
            var parsedField = $b22d8ba9efab55d4$export$616eedde42a218b(fieldName);
            var docFieldValue = $b22d8ba9efab55d4$export$15fd855db9a2dbf7(doc, parsedField);
            return docFieldValue;
        });
    }
    return function(aRow, bRow) {
        var aFieldValues = getFieldValuesAsArray(aRow.doc);
        var bFieldValues = getFieldValuesAsArray(bRow.doc);
        var collation = (0, $j8fka.collate)(aFieldValues, bFieldValues);
        if (collation !== 0) return collation;
        // this is what mango seems to do
        return $b22d8ba9efab55d4$export$398604a469f7de9a(aRow.doc._id, bRow.doc._id);
    };
}
function $b22d8ba9efab55d4$export$604c36f3edeff3a0(rows, requestDef, inMemoryFields) {
    rows = rows.filter(function(row) {
        return $b22d8ba9efab55d4$export$7c8ff75694efd18e(row.doc, requestDef.selector, inMemoryFields);
    });
    if (requestDef.sort) {
        // in-memory sort
        var fieldSorter = $b22d8ba9efab55d4$export$ba1d58924a4fd5d6(requestDef.sort);
        rows = rows.sort(fieldSorter);
        if (typeof requestDef.sort[0] !== 'string' && $b22d8ba9efab55d4$export$bf7199a9ebcb84a9(requestDef.sort[0]) === 'desc') rows = rows.reverse();
    }
    if ('limit' in requestDef || 'skip' in requestDef) {
        // have to do the limit in-memory
        var skip = requestDef.skip || 0;
        var limit = ('limit' in requestDef ? requestDef.limit : rows.length) + skip;
        rows = rows.slice(skip, limit);
    }
    return rows;
}
function $b22d8ba9efab55d4$export$7c8ff75694efd18e(doc, selector, inMemoryFields) {
    return inMemoryFields.every(function(field) {
        var matcher = selector[field];
        var parsedField = $b22d8ba9efab55d4$export$616eedde42a218b(field);
        var docFieldValue = $b22d8ba9efab55d4$export$15fd855db9a2dbf7(doc, parsedField);
        if ($b22d8ba9efab55d4$export$21fcfbdc979d5d7c(field)) return $b22d8ba9efab55d4$var$matchCominationalSelector(field, matcher, doc);
        return $b22d8ba9efab55d4$var$matchSelector(matcher, doc, parsedField, docFieldValue);
    });
}
function $b22d8ba9efab55d4$var$matchSelector(matcher, doc, parsedField, docFieldValue) {
    if (!matcher) // no filtering necessary; this field is just needed for sorting
    return true;
    // is matcher an object, if so continue recursion
    if (typeof matcher === 'object') return Object.keys(matcher).every(function(maybeUserOperator) {
        var userValue = matcher[maybeUserOperator];
        // explicit operator
        if (maybeUserOperator.indexOf("$") === 0) return $b22d8ba9efab55d4$var$match(maybeUserOperator, doc, userValue, parsedField, docFieldValue);
        else {
            var subParsedField = $b22d8ba9efab55d4$export$616eedde42a218b(maybeUserOperator);
            if (docFieldValue === undefined && typeof userValue !== "object" && subParsedField.length > 0) // the field does not exist, return or getFieldFromDoc will throw
            return false;
            var subDocFieldValue = $b22d8ba9efab55d4$export$15fd855db9a2dbf7(docFieldValue, subParsedField);
            if (typeof userValue === "object") // field value is an object that might contain more operators
            return $b22d8ba9efab55d4$var$matchSelector(userValue, doc, parsedField, subDocFieldValue);
            // implicit operator
            return $b22d8ba9efab55d4$var$match("$eq", doc, userValue, subParsedField, subDocFieldValue);
        }
    });
    // no more depth, No need to recurse further
    return matcher === docFieldValue;
}
function $b22d8ba9efab55d4$var$matchCominationalSelector(field, matcher, doc) {
    if (field === '$or') return matcher.some(function(orMatchers) {
        return $b22d8ba9efab55d4$export$7c8ff75694efd18e(doc, orMatchers, Object.keys(orMatchers));
    });
    if (field === '$not') return !$b22d8ba9efab55d4$export$7c8ff75694efd18e(doc, matcher, Object.keys(matcher));
    //`$nor`
    return !matcher.find(function(orMatchers) {
        return $b22d8ba9efab55d4$export$7c8ff75694efd18e(doc, orMatchers, Object.keys(orMatchers));
    });
}
function $b22d8ba9efab55d4$var$match(userOperator, doc, userValue, parsedField, docFieldValue) {
    if (!$b22d8ba9efab55d4$var$matchers[userOperator]) /* istanbul ignore next */ throw new Error('unknown operator "' + userOperator + '" - should be one of $eq, $lte, $lt, $gt, $gte, $exists, $ne, $in, ' + '$nin, $size, $mod, $regex, $elemMatch, $type, $allMatch or $all');
    return $b22d8ba9efab55d4$var$matchers[userOperator](doc, userValue, parsedField, docFieldValue);
}
function $b22d8ba9efab55d4$var$fieldExists(docFieldValue) {
    return typeof docFieldValue !== 'undefined' && docFieldValue !== null;
}
function $b22d8ba9efab55d4$var$fieldIsNotUndefined(docFieldValue) {
    return typeof docFieldValue !== 'undefined';
}
function $b22d8ba9efab55d4$var$modField(docFieldValue, userValue) {
    if (typeof docFieldValue !== "number" || parseInt(docFieldValue, 10) !== docFieldValue) return false;
    var divisor = userValue[0];
    var mod = userValue[1];
    return docFieldValue % divisor === mod;
}
function $b22d8ba9efab55d4$var$arrayContainsValue(docFieldValue, userValue) {
    return userValue.some(function(val) {
        if (docFieldValue instanceof Array) return docFieldValue.some(function(docFieldValueItem) {
            return (0, $j8fka.collate)(val, docFieldValueItem) === 0;
        });
        return (0, $j8fka.collate)(val, docFieldValue) === 0;
    });
}
function $b22d8ba9efab55d4$var$arrayContainsAllValues(docFieldValue, userValue) {
    return userValue.every(function(val) {
        return docFieldValue.some(function(docFieldValueItem) {
            return (0, $j8fka.collate)(val, docFieldValueItem) === 0;
        });
    });
}
function $b22d8ba9efab55d4$var$arraySize(docFieldValue, userValue) {
    return docFieldValue.length === userValue;
}
function $b22d8ba9efab55d4$var$regexMatch(docFieldValue, userValue) {
    var re = new RegExp(userValue);
    return re.test(docFieldValue);
}
function $b22d8ba9efab55d4$var$typeMatch(docFieldValue, userValue) {
    switch(userValue){
        case 'null':
            return docFieldValue === null;
        case 'boolean':
            return typeof docFieldValue === 'boolean';
        case 'number':
            return typeof docFieldValue === 'number';
        case 'string':
            return typeof docFieldValue === 'string';
        case 'array':
            return docFieldValue instanceof Array;
        case 'object':
            return ({}).toString.call(docFieldValue) === '[object Object]';
    }
}
var $b22d8ba9efab55d4$var$matchers = {
    '$elemMatch': function(doc, userValue, parsedField, docFieldValue) {
        if (!Array.isArray(docFieldValue)) return false;
        if (docFieldValue.length === 0) return false;
        if (typeof docFieldValue[0] === 'object' && docFieldValue[0] !== null) return docFieldValue.some(function(val) {
            return $b22d8ba9efab55d4$export$7c8ff75694efd18e(val, userValue, Object.keys(userValue));
        });
        return docFieldValue.some(function(val) {
            return $b22d8ba9efab55d4$var$matchSelector(userValue, doc, parsedField, val);
        });
    },
    '$allMatch': function(doc, userValue, parsedField, docFieldValue) {
        if (!Array.isArray(docFieldValue)) return false;
        /* istanbul ignore next */ if (docFieldValue.length === 0) return false;
        if (typeof docFieldValue[0] === 'object' && docFieldValue[0] !== null) return docFieldValue.every(function(val) {
            return $b22d8ba9efab55d4$export$7c8ff75694efd18e(val, userValue, Object.keys(userValue));
        });
        return docFieldValue.every(function(val) {
            return $b22d8ba9efab55d4$var$matchSelector(userValue, doc, parsedField, val);
        });
    },
    '$eq': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$fieldIsNotUndefined(docFieldValue) && (0, $j8fka.collate)(docFieldValue, userValue) === 0;
    },
    '$gte': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$fieldIsNotUndefined(docFieldValue) && (0, $j8fka.collate)(docFieldValue, userValue) >= 0;
    },
    '$gt': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$fieldIsNotUndefined(docFieldValue) && (0, $j8fka.collate)(docFieldValue, userValue) > 0;
    },
    '$lte': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$fieldIsNotUndefined(docFieldValue) && (0, $j8fka.collate)(docFieldValue, userValue) <= 0;
    },
    '$lt': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$fieldIsNotUndefined(docFieldValue) && (0, $j8fka.collate)(docFieldValue, userValue) < 0;
    },
    '$exists': function(doc, userValue, parsedField, docFieldValue) {
        //a field that is null is still considered to exist
        if (userValue) return $b22d8ba9efab55d4$var$fieldIsNotUndefined(docFieldValue);
        return !$b22d8ba9efab55d4$var$fieldIsNotUndefined(docFieldValue);
    },
    '$mod': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$fieldExists(docFieldValue) && $b22d8ba9efab55d4$var$modField(docFieldValue, userValue);
    },
    '$ne': function(doc, userValue, parsedField, docFieldValue) {
        return userValue.every(function(neValue) {
            return (0, $j8fka.collate)(docFieldValue, neValue) !== 0;
        });
    },
    '$in': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$fieldExists(docFieldValue) && $b22d8ba9efab55d4$var$arrayContainsValue(docFieldValue, userValue);
    },
    '$nin': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$fieldExists(docFieldValue) && !$b22d8ba9efab55d4$var$arrayContainsValue(docFieldValue, userValue);
    },
    '$size': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$fieldExists(docFieldValue) && Array.isArray(docFieldValue) && $b22d8ba9efab55d4$var$arraySize(docFieldValue, userValue);
    },
    '$all': function(doc, userValue, parsedField, docFieldValue) {
        return Array.isArray(docFieldValue) && $b22d8ba9efab55d4$var$arrayContainsAllValues(docFieldValue, userValue);
    },
    '$regex': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$fieldExists(docFieldValue) && typeof docFieldValue == "string" && userValue.every(function(regexValue) {
            return $b22d8ba9efab55d4$var$regexMatch(docFieldValue, regexValue);
        });
    },
    '$type': function(doc, userValue, parsedField, docFieldValue) {
        return $b22d8ba9efab55d4$var$typeMatch(docFieldValue, userValue);
    }
};
// return true if the given doc matches the supplied selector
function $b22d8ba9efab55d4$export$b06a2f5618961e1e(doc, selector) {
    /* istanbul ignore if */ if (typeof selector !== 'object') // match the CouchDB error message
    throw new Error('Selector error: expected a JSON object');
    selector = $b22d8ba9efab55d4$export$baf68476d5cf83f7(selector);
    var row = {
        doc: doc
    };
    var rowsMatched = $b22d8ba9efab55d4$export$604c36f3edeff3a0([
        row
    ], {
        selector: selector
    }, Object.keys(selector));
    return rowsMatched && rowsMatched.length === 1;
}

});
parcelRegister("j8fka", function(module, exports) {

$parcel$export(module.exports, "collate", () => $dedaa6be37fdbc17$export$55dd608f42cbbfed);
$parcel$export(module.exports, "normalizeKey", () => $dedaa6be37fdbc17$export$e0c709538cb8ae18);
$parcel$export(module.exports, "toIndexableString", () => $dedaa6be37fdbc17$export$72523ea74d6f8011);
$parcel$export(module.exports, "parseIndexableString", () => $dedaa6be37fdbc17$export$96dca2a45fbb978e);
function $dedaa6be37fdbc17$var$pad(str, padWith, upToLength) {
    var padding = '';
    var targetLength = upToLength - str.length;
    /* istanbul ignore next */ while(padding.length < targetLength)padding += padWith;
    return padding;
}
function $dedaa6be37fdbc17$var$padLeft(str, padWith, upToLength) {
    var padding = $dedaa6be37fdbc17$var$pad(str, padWith, upToLength);
    return padding + str;
}
var $dedaa6be37fdbc17$var$MIN_MAGNITUDE = -324; // verified by -Number.MIN_VALUE
var $dedaa6be37fdbc17$var$MAGNITUDE_DIGITS = 3; // ditto
var $dedaa6be37fdbc17$var$SEP = ''; // set to '_' for easier debugging
function $dedaa6be37fdbc17$export$55dd608f42cbbfed(a, b) {
    if (a === b) return 0;
    a = $dedaa6be37fdbc17$export$e0c709538cb8ae18(a);
    b = $dedaa6be37fdbc17$export$e0c709538cb8ae18(b);
    var ai = $dedaa6be37fdbc17$var$collationIndex(a);
    var bi = $dedaa6be37fdbc17$var$collationIndex(b);
    if (ai - bi !== 0) return ai - bi;
    switch(typeof a){
        case 'number':
            return a - b;
        case 'boolean':
            return a < b ? -1 : 1;
        case 'string':
            return $dedaa6be37fdbc17$var$stringCollate(a, b);
    }
    return Array.isArray(a) ? $dedaa6be37fdbc17$var$arrayCollate(a, b) : $dedaa6be37fdbc17$var$objectCollate(a, b);
}
// couch considers null/NaN/Infinity/-Infinity === undefined,
// for the purposes of mapreduce indexes. also, dates get stringified.
function $dedaa6be37fdbc17$export$e0c709538cb8ae18(key) {
    switch(typeof key){
        case 'undefined':
            return null;
        case 'number':
            if (key === Infinity || key === -Infinity || isNaN(key)) return null;
            return key;
        case 'object':
            var origKey = key;
            if (Array.isArray(key)) {
                var len = key.length;
                key = new Array(len);
                for(var i = 0; i < len; i++)key[i] = $dedaa6be37fdbc17$export$e0c709538cb8ae18(origKey[i]);
            /* istanbul ignore next */ } else if (key instanceof Date) return key.toJSON();
            else if (key !== null) {
                key = {};
                for(var k in origKey)if (Object.prototype.hasOwnProperty.call(origKey, k)) {
                    var val = origKey[k];
                    if (typeof val !== 'undefined') key[k] = $dedaa6be37fdbc17$export$e0c709538cb8ae18(val);
                }
            }
    }
    return key;
}
function $dedaa6be37fdbc17$var$indexify(key) {
    if (key !== null) switch(typeof key){
        case 'boolean':
            return key ? 1 : 0;
        case 'number':
            return $dedaa6be37fdbc17$var$numToIndexableString(key);
        case 'string':
            // We've to be sure that key does not contain \u0000
            // Do order-preserving replacements:
            // 0 -> 1, 1
            // 1 -> 1, 2
            // 2 -> 2, 2
            /* eslint-disable no-control-regex */ return key.replace(/\u0002/g, '\u0002\u0002').replace(/\u0001/g, '\u0001\u0002').replace(/\u0000/g, '\u0001\u0001');
        /* eslint-enable no-control-regex */ case 'object':
            var isArray = Array.isArray(key);
            var arr = isArray ? key : Object.keys(key);
            var i = -1;
            var len = arr.length;
            var result = '';
            if (isArray) while(++i < len)result += $dedaa6be37fdbc17$export$72523ea74d6f8011(arr[i]);
            else while(++i < len){
                var objKey = arr[i];
                result += $dedaa6be37fdbc17$export$72523ea74d6f8011(objKey) + $dedaa6be37fdbc17$export$72523ea74d6f8011(key[objKey]);
            }
            return result;
    }
    return '';
}
// convert the given key to a string that would be appropriate
// for lexical sorting, e.g. within a database, where the
// sorting is the same given by the collate() function.
function $dedaa6be37fdbc17$export$72523ea74d6f8011(key) {
    var zero = '\u0000';
    key = $dedaa6be37fdbc17$export$e0c709538cb8ae18(key);
    return $dedaa6be37fdbc17$var$collationIndex(key) + $dedaa6be37fdbc17$var$SEP + $dedaa6be37fdbc17$var$indexify(key) + zero;
}
function $dedaa6be37fdbc17$var$parseNumber(str, i) {
    var originalIdx = i;
    var num;
    var zero = str[i] === '1';
    if (zero) {
        num = 0;
        i++;
    } else {
        var neg = str[i] === '0';
        i++;
        var numAsString = '';
        var magAsString = str.substring(i, i + $dedaa6be37fdbc17$var$MAGNITUDE_DIGITS);
        var magnitude = parseInt(magAsString, 10) + $dedaa6be37fdbc17$var$MIN_MAGNITUDE;
        /* istanbul ignore next */ if (neg) magnitude = -magnitude;
        i += $dedaa6be37fdbc17$var$MAGNITUDE_DIGITS;
        while(true){
            var ch = str[i];
            if (ch === '\u0000') break;
            else numAsString += ch;
            i++;
        }
        numAsString = numAsString.split('.');
        if (numAsString.length === 1) num = parseInt(numAsString, 10);
        else /* istanbul ignore next */ num = parseFloat(numAsString[0] + '.' + numAsString[1]);
        /* istanbul ignore next */ if (neg) num = num - 10;
        /* istanbul ignore next */ if (magnitude !== 0) // parseFloat is more reliable than pow due to rounding errors
        // e.g. Number.MAX_VALUE would return Infinity if we did
        // num * Math.pow(10, magnitude);
        num = parseFloat(num + 'e' + magnitude);
    }
    return {
        num: num,
        length: i - originalIdx
    };
}
// move up the stack while parsing
// this function moved outside of parseIndexableString for performance
function $dedaa6be37fdbc17$var$pop(stack, metaStack) {
    var obj = stack.pop();
    if (metaStack.length) {
        var lastMetaElement = metaStack[metaStack.length - 1];
        if (obj === lastMetaElement.element) {
            // popping a meta-element, e.g. an object whose value is another object
            metaStack.pop();
            lastMetaElement = metaStack[metaStack.length - 1];
        }
        var element = lastMetaElement.element;
        var lastElementIndex = lastMetaElement.index;
        if (Array.isArray(element)) element.push(obj);
        else if (lastElementIndex === stack.length - 2) {
            var key = stack.pop();
            element[key] = obj;
        } else stack.push(obj); // obj with key only
    }
}
function $dedaa6be37fdbc17$export$96dca2a45fbb978e(str) {
    var stack = [];
    var metaStack = []; // stack for arrays and objects
    var i = 0;
    /*eslint no-constant-condition: ["error", { "checkLoops": false }]*/ while(true){
        var collationIndex = str[i++];
        if (collationIndex === '\u0000') {
            if (stack.length === 1) return stack.pop();
            else {
                $dedaa6be37fdbc17$var$pop(stack, metaStack);
                continue;
            }
        }
        switch(collationIndex){
            case '1':
                stack.push(null);
                break;
            case '2':
                stack.push(str[i] === '1');
                i++;
                break;
            case '3':
                var parsedNum = $dedaa6be37fdbc17$var$parseNumber(str, i);
                stack.push(parsedNum.num);
                i += parsedNum.length;
                break;
            case '4':
                var parsedStr = '';
                /*eslint no-constant-condition: ["error", { "checkLoops": false }]*/ while(true){
                    var ch = str[i];
                    if (ch === '\u0000') break;
                    parsedStr += ch;
                    i++;
                }
                // perform the reverse of the order-preserving replacement
                // algorithm (see above)
                /* eslint-disable no-control-regex */ parsedStr = parsedStr.replace(/\u0001\u0001/g, '\u0000').replace(/\u0001\u0002/g, '\u0001').replace(/\u0002\u0002/g, '\u0002');
                /* eslint-enable no-control-regex */ stack.push(parsedStr);
                break;
            case '5':
                var arrayElement = {
                    element: [],
                    index: stack.length
                };
                stack.push(arrayElement.element);
                metaStack.push(arrayElement);
                break;
            case '6':
                var objElement = {
                    element: {},
                    index: stack.length
                };
                stack.push(objElement.element);
                metaStack.push(objElement);
                break;
            /* istanbul ignore next */ default:
                throw new Error('bad collationIndex or unexpectedly reached end of input: ' + collationIndex);
        }
    }
}
function $dedaa6be37fdbc17$var$arrayCollate(a, b) {
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; i++){
        var sort = $dedaa6be37fdbc17$export$55dd608f42cbbfed(a[i], b[i]);
        if (sort !== 0) return sort;
    }
    return a.length === b.length ? 0 : a.length > b.length ? 1 : -1;
}
function $dedaa6be37fdbc17$var$stringCollate(a, b) {
    // See: https://github.com/daleharvey/pouchdb/issues/40
    // This is incompatible with the CouchDB implementation, but its the
    // best we can do for now
    return a === b ? 0 : a > b ? 1 : -1;
}
function $dedaa6be37fdbc17$var$objectCollate(a, b) {
    var ak = Object.keys(a), bk = Object.keys(b);
    var len = Math.min(ak.length, bk.length);
    for(var i = 0; i < len; i++){
        // First sort the keys
        var sort = $dedaa6be37fdbc17$export$55dd608f42cbbfed(ak[i], bk[i]);
        if (sort !== 0) return sort;
        // if the keys are equal sort the values
        sort = $dedaa6be37fdbc17$export$55dd608f42cbbfed(a[ak[i]], b[bk[i]]);
        if (sort !== 0) return sort;
    }
    return ak.length === bk.length ? 0 : ak.length > bk.length ? 1 : -1;
}
// The collation is defined by erlangs ordered terms
// the atoms null, true, false come first, then numbers, strings,
// arrays, then objects
// null/undefined/NaN/Infinity/-Infinity are all considered null
function $dedaa6be37fdbc17$var$collationIndex(x) {
    var id = [
        'boolean',
        'number',
        'string',
        'object'
    ];
    var idx = id.indexOf(typeof x);
    //false if -1 otherwise true, but fast!!!!1
    if (~idx) {
        if (x === null) return 1;
        if (Array.isArray(x)) return 5;
        return idx < 3 ? idx + 2 : idx + 3;
    }
    /* istanbul ignore next */ if (Array.isArray(x)) return 5;
}
// conversion:
// x yyy zz...zz
// x = 0 for negative, 1 for 0, 2 for positive
// y = exponent (for negative numbers negated) moved so that it's >= 0
// z = mantisse
function $dedaa6be37fdbc17$var$numToIndexableString(num) {
    if (num === 0) return '1';
    // convert number to exponential format for easier and
    // more succinct string sorting
    var expFormat = num.toExponential().split(/e\+?/);
    var magnitude = parseInt(expFormat[1], 10);
    var neg = num < 0;
    var result = neg ? '0' : '2';
    // first sort by magnitude
    // it's easier if all magnitudes are positive
    var magForComparison = (neg ? -magnitude : magnitude) - $dedaa6be37fdbc17$var$MIN_MAGNITUDE;
    var magString = $dedaa6be37fdbc17$var$padLeft(magForComparison.toString(), '0', $dedaa6be37fdbc17$var$MAGNITUDE_DIGITS);
    result += $dedaa6be37fdbc17$var$SEP + magString;
    // then sort by the factor
    var factor = Math.abs(parseFloat(expFormat[0])); // [1..10)
    /* istanbul ignore next */ if (neg) factor = 10 - factor;
    var factorStr = factor.toFixed(20);
    // strip zeros from the end
    factorStr = factorStr.replace(/\.?0+$/, '');
    result += $dedaa6be37fdbc17$var$SEP + factorStr;
    return result;
}

});




parcelRegister("lVt6m", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff657ecc00b66cae$export$2e2bcd8739ae039);

var $cqZVJ = parcelRequire("cqZVJ");

var $7zAYS = parcelRequire("7zAYS");

var $doDnd = parcelRequire("doDnd");

var $9Pw4Q = parcelRequire("9Pw4Q");

var $j8fka = parcelRequire("j8fka");

var $fir5e = parcelRequire("fir5e");

var $47bZj = parcelRequire("47bZj");
const $ff657ecc00b66cae$var$nativeFlat = (...args)=>args.flat(Infinity);
const $ff657ecc00b66cae$var$polyFlat = (...args)=>{
    let res = [];
    for (const subArr of args)if (Array.isArray(subArr)) res = res.concat($ff657ecc00b66cae$var$polyFlat(...subArr));
    else res.push(subArr);
    return res;
};
const $ff657ecc00b66cae$var$flatten = typeof Array.prototype.flat === 'function' ? $ff657ecc00b66cae$var$nativeFlat : $ff657ecc00b66cae$var$polyFlat;
function $ff657ecc00b66cae$var$mergeObjects(arr) {
    const res = {};
    for (const element of arr)Object.assign(res, element);
    return res;
}
// Selects a list of fields defined in dot notation from one doc
// and copies them to a new doc. Like underscore _.pick but supports nesting.
function $ff657ecc00b66cae$var$pick(obj, arr) {
    const res = {};
    for (const field of arr){
        const parsedField = (0, $fir5e.parseField)(field);
        const value = (0, $fir5e.getFieldFromDoc)(obj, parsedField);
        if (typeof value !== 'undefined') (0, $fir5e.setFieldInDoc)(res, parsedField, value);
    }
    return res;
}
// e.g. ['a'], ['a', 'b'] is true, but ['b'], ['a', 'b'] is false
function $ff657ecc00b66cae$var$oneArrayIsSubArrayOfOther(left, right) {
    for(let i = 0, len = Math.min(left.length, right.length); i < len; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
// e.g.['a', 'b', 'c'], ['a', 'b'] is false
function $ff657ecc00b66cae$var$oneArrayIsStrictSubArrayOfOther(left, right) {
    if (left.length > right.length) return false;
    return $ff657ecc00b66cae$var$oneArrayIsSubArrayOfOther(left, right);
}
// same as above, but treat the left array as an unordered set
// e.g. ['b', 'a'], ['a', 'b', 'c'] is true, but ['c'], ['a', 'b', 'c'] is false
function $ff657ecc00b66cae$var$oneSetIsSubArrayOfOther(left, right) {
    left = left.slice();
    for (const field of right){
        if (!left.length) break;
        const leftIdx = left.indexOf(field);
        if (leftIdx === -1) return false;
        else left.splice(leftIdx, 1);
    }
    return true;
}
function $ff657ecc00b66cae$var$arrayToObject(arr) {
    const res = {};
    for (const field of arr)res[field] = true;
    return res;
}
function $ff657ecc00b66cae$var$max(arr, fun) {
    let max = null;
    let maxScore = -1;
    for (const element of arr){
        const score = fun(element);
        if (score > maxScore) {
            maxScore = score;
            max = element;
        }
    }
    return max;
}
function $ff657ecc00b66cae$var$arrayEquals(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    for(let i = 0, len = arr1.length; i < len; i++){
        if (arr1[i] !== arr2[i]) return false;
    }
    return true;
}
function $ff657ecc00b66cae$var$uniq(arr) {
    return Array.from(new Set(arr));
}
/**
 * Callbackifyable wrapper for async functions
 *
 * @template T, Args
 * @param {(...args: Args) => Promise<T>} fun
 * @returns {<CBArgs = [...Args, (err: any, value: T) => void], InnerArgs extends Args | CBArgs>(...innerArgs: InnerArgs) => InnerArgs extends CBArgs ? void : Promise<T>}
 *
 * @example
 * const fn = resolveToCallback(async () => { return 42; })
 * // with callback:
 * fn((err, value) => { ... })
 * // with await:
 * const value = await fn()
 */ function $ff657ecc00b66cae$var$resolveToCallback(fun) {
    return function(...args) {
        const maybeCallback = args[args.length - 1];
        if (typeof maybeCallback === "function") {
            const fulfilled = maybeCallback.bind(null, null);
            const rejected = maybeCallback.bind(null);
            fun.apply(this, args.slice(0, -1)).then(fulfilled, rejected);
        } else return fun.apply(this, args);
    };
}
// we restructure the supplied JSON considerably, because the official
// Mango API is very particular about a lot of this stuff, but we like
// to be liberal with what we accept in order to prevent mental
// breakdowns in our users
function $ff657ecc00b66cae$var$massageCreateIndexRequest(requestDef) {
    requestDef = (0, $47bZj.clone)(requestDef);
    if (!requestDef.index) requestDef.index = {};
    for (const key of [
        'type',
        'name',
        'ddoc'
    ])if (requestDef.index[key]) {
        requestDef[key] = requestDef.index[key];
        delete requestDef.index[key];
    }
    if (requestDef.fields) {
        requestDef.index.fields = requestDef.fields;
        delete requestDef.fields;
    }
    if (!requestDef.type) requestDef.type = 'json';
    return requestDef;
}
function $ff657ecc00b66cae$var$isNonNullObject(value) {
    return typeof value === 'object' && value !== null;
}
// throws if the user is using the wrong query field value type
function $ff657ecc00b66cae$var$checkFieldValueType(name, value, isHttp) {
    let message = '';
    let received = value;
    let addReceived = true;
    if ([
        '$in',
        '$nin',
        '$or',
        '$and',
        '$mod',
        '$nor',
        '$all'
    ].indexOf(name) !== -1) {
        if (!Array.isArray(value)) message = 'Query operator ' + name + ' must be an array.';
    }
    if ([
        '$not',
        '$elemMatch',
        '$allMatch'
    ].indexOf(name) !== -1) {
        if (!(!Array.isArray(value) && $ff657ecc00b66cae$var$isNonNullObject(value))) message = 'Query operator ' + name + ' must be an object.';
    }
    if (name === '$mod' && Array.isArray(value)) {
        if (value.length !== 2) message = "Query operator $mod must be in the format [divisor, remainder], where divisor and remainder are both integers.";
        else {
            const divisor = value[0];
            const mod = value[1];
            if (divisor === 0) {
                message = 'Query operator $mod\'s divisor cannot be 0, cannot divide by zero.';
                addReceived = false;
            }
            if (typeof divisor !== 'number' || parseInt(divisor, 10) !== divisor) {
                message = 'Query operator $mod\'s divisor is not an integer.';
                received = divisor;
            }
            if (parseInt(mod, 10) !== mod) {
                message = 'Query operator $mod\'s remainder is not an integer.';
                received = mod;
            }
        }
    }
    if (name === '$exists') {
        if (typeof value !== 'boolean') message = 'Query operator $exists must be a boolean.';
    }
    if (name === '$type') {
        const allowed = [
            'null',
            'boolean',
            'number',
            'string',
            'array',
            'object'
        ];
        const allowedStr = '"' + allowed.slice(0, allowed.length - 1).join('", "') + '", or "' + allowed[allowed.length - 1] + '"';
        if (typeof value !== 'string') message = 'Query operator $type must be a string. Supported values: ' + allowedStr + '.';
        else if (allowed.indexOf(value) == -1) message = 'Query operator $type must be a string. Supported values: ' + allowedStr + '.';
    }
    if (name === '$size') {
        if (parseInt(value, 10) !== value) message = 'Query operator $size must be a integer.';
    }
    if (name === '$regex') {
        if (typeof value !== 'string') {
            if (isHttp) message = 'Query operator $regex must be a string.';
            else if (!(value instanceof RegExp)) message = "Query operator $regex must be a string or an instance of a javascript regular expression.";
        }
    }
    if (message) {
        if (addReceived) {
            const type = received === null ? ' ' : Array.isArray(received) ? ' array' : ' ' + typeof received;
            const receivedStr = $ff657ecc00b66cae$var$isNonNullObject(received) ? JSON.stringify(received, null, '\t') : received;
            message += ' Received' + type + ': ' + receivedStr;
        }
        throw new Error(message);
    }
}
const $ff657ecc00b66cae$var$requireValidation = [
    '$all',
    '$allMatch',
    '$and',
    '$elemMatch',
    '$exists',
    '$in',
    '$mod',
    '$nin',
    '$nor',
    '$not',
    '$or',
    '$regex',
    '$size',
    '$type'
];
const $ff657ecc00b66cae$var$arrayTypeComparisonOperators = [
    '$in',
    '$nin',
    '$mod',
    '$all'
];
const $ff657ecc00b66cae$var$equalityOperators = [
    '$eq',
    '$gt',
    '$gte',
    '$lt',
    '$lte'
];
// recursively walks down the a query selector validating any operators
function $ff657ecc00b66cae$var$validateSelector(input, isHttp) {
    if (Array.isArray(input)) {
        for (const entry of input)if ($ff657ecc00b66cae$var$isNonNullObject(entry)) $ff657ecc00b66cae$var$validateSelector(entry, isHttp);
    } else for (const [key, value] of Object.entries(input)){
        if ($ff657ecc00b66cae$var$requireValidation.indexOf(key) !== -1) $ff657ecc00b66cae$var$checkFieldValueType(key, value, isHttp);
        if ($ff657ecc00b66cae$var$equalityOperators.indexOf(key) !== -1) continue;
        if ($ff657ecc00b66cae$var$arrayTypeComparisonOperators.indexOf(key) !== -1) continue;
        if ($ff657ecc00b66cae$var$isNonNullObject(value)) $ff657ecc00b66cae$var$validateSelector(value, isHttp);
    }
}
async function $ff657ecc00b66cae$var$dbFetch(db, path, opts) {
    if (opts.body) {
        opts.body = JSON.stringify(opts.body);
        opts.headers = new (0, $7zAYS.Headers)({
            'Content-type': 'application/json'
        });
    }
    const response = await db.fetch(path, opts);
    const json = await response.json();
    if (!response.ok) {
        json.status = response.status;
        const pouchError = (0, $cqZVJ.createError)(json);
        throw (0, $cqZVJ.generateErrorFromResponse)(pouchError);
    }
    return json;
}
async function $ff657ecc00b66cae$var$createIndex(db, requestDef) {
    return await $ff657ecc00b66cae$var$dbFetch(db, '_index', {
        method: 'POST',
        body: $ff657ecc00b66cae$var$massageCreateIndexRequest(requestDef)
    });
}
async function $ff657ecc00b66cae$var$find(db, requestDef) {
    $ff657ecc00b66cae$var$validateSelector(requestDef.selector, true);
    return await $ff657ecc00b66cae$var$dbFetch(db, '_find', {
        method: 'POST',
        body: requestDef
    });
}
async function $ff657ecc00b66cae$var$explain(db, requestDef) {
    return await $ff657ecc00b66cae$var$dbFetch(db, '_explain', {
        method: 'POST',
        body: requestDef
    });
}
async function $ff657ecc00b66cae$var$getIndexes(db) {
    return await $ff657ecc00b66cae$var$dbFetch(db, '_index', {
        method: 'GET'
    });
}
async function $ff657ecc00b66cae$var$deleteIndex(db, indexDef) {
    const ddoc = indexDef.ddoc;
    const type = indexDef.type || 'json';
    const name = indexDef.name;
    if (!ddoc) throw new Error('you must provide an index\'s ddoc');
    if (!name) throw new Error('you must provide an index\'s name');
    const url = '_index/' + [
        ddoc,
        type,
        name
    ].map(encodeURIComponent).join('/');
    return await $ff657ecc00b66cae$var$dbFetch(db, url, {
        method: 'DELETE'
    });
}
//
// One thing about these mappers:
//
// Per the advice of John-David Dalton (http://youtu.be/NthmeLEhDDM),
// what you want to do in this case is optimize for the smallest possible
// function, since that's the thing that gets run over and over again.
//
// This code would be a lot simpler if all the if/elses were inside
// the function, but it would also be a lot less performant.
//
function $ff657ecc00b66cae$var$getDeepValue(value, path) {
    for (const key of path){
        value = value[key];
        if (value === undefined) return undefined;
    }
    return value;
}
function $ff657ecc00b66cae$var$createDeepMultiMapper(fields, emit, selector) {
    return function(doc) {
        if (selector && !(0, $fir5e.matchesSelector)(doc, selector)) return;
        const toEmit = [];
        for (const field of fields){
            const value = $ff657ecc00b66cae$var$getDeepValue(doc, (0, $fir5e.parseField)(field));
            if (value === undefined) return;
            toEmit.push(value);
        }
        emit(toEmit);
    };
}
function $ff657ecc00b66cae$var$createDeepSingleMapper(field, emit, selector) {
    const parsedField = (0, $fir5e.parseField)(field);
    return function(doc) {
        if (selector && !(0, $fir5e.matchesSelector)(doc, selector)) return;
        const value = $ff657ecc00b66cae$var$getDeepValue(doc, parsedField);
        if (value !== undefined) emit(value);
    };
}
function $ff657ecc00b66cae$var$createShallowSingleMapper(field, emit, selector) {
    return function(doc) {
        if (selector && !(0, $fir5e.matchesSelector)(doc, selector)) return;
        emit(doc[field]);
    };
}
function $ff657ecc00b66cae$var$createShallowMultiMapper(fields, emit, selector) {
    return function(doc) {
        if (selector && !(0, $fir5e.matchesSelector)(doc, selector)) return;
        const toEmit = fields.map((field)=>doc[field]);
        emit(toEmit);
    };
}
function $ff657ecc00b66cae$var$checkShallow(fields) {
    return fields.every((field)=>field.indexOf('.') === -1);
}
function $ff657ecc00b66cae$var$createMapper(fields, emit, selector) {
    const isShallow = $ff657ecc00b66cae$var$checkShallow(fields);
    const isSingle = fields.length === 1;
    // notice we try to optimize for the most common case,
    // i.e. single shallow indexes
    if (isShallow) {
        if (isSingle) return $ff657ecc00b66cae$var$createShallowSingleMapper(fields[0], emit, selector);
        else return $ff657ecc00b66cae$var$createShallowMultiMapper(fields, emit, selector);
    } else {
        if (isSingle) return $ff657ecc00b66cae$var$createDeepSingleMapper(fields[0], emit, selector);
        else return $ff657ecc00b66cae$var$createDeepMultiMapper(fields, emit, selector);
    }
}
function $ff657ecc00b66cae$var$mapper(mapFunDef, emit) {
    // mapFunDef is a list of fields
    const fields = Object.keys(mapFunDef.fields);
    const partialSelector = mapFunDef.partial_filter_selector;
    return $ff657ecc00b66cae$var$createMapper(fields, emit, partialSelector);
}
/* istanbul ignore next */ function $ff657ecc00b66cae$var$reducer() {
    throw new Error('reduce not supported');
}
function $ff657ecc00b66cae$var$ddocValidator(ddoc, viewName) {
    const view = ddoc.views[viewName];
    // This doesn't actually need to be here apparently, but
    // I feel safer keeping it.
    /* istanbul ignore if */ if (!view.map || !view.map.fields) throw new Error('ddoc ' + ddoc._id + ' with view ' + viewName + ' doesn\'t have map.fields defined. ' + 'maybe it wasn\'t created by this plugin?');
}
const $ff657ecc00b66cae$var$abstractMapper = (0, $doDnd.default)(/* localDocName */ 'indexes', $ff657ecc00b66cae$var$mapper, $ff657ecc00b66cae$var$reducer, $ff657ecc00b66cae$var$ddocValidator);
function $ff657ecc00b66cae$var$abstractMapper$1(db) {
    if (db._customFindAbstractMapper) return {
        // Calls the _customFindAbstractMapper, but with a third argument:
        // the standard findAbstractMapper query/viewCleanup.
        // This allows the indexeddb adapter to support partial_filter_selector.
        query: function addQueryFallback(signature, opts) {
            const fallback = $ff657ecc00b66cae$var$abstractMapper.query.bind(this);
            return db._customFindAbstractMapper.query.call(this, signature, opts, fallback);
        },
        viewCleanup: function addViewCleanupFallback() {
            const fallback = $ff657ecc00b66cae$var$abstractMapper.viewCleanup.bind(this);
            return db._customFindAbstractMapper.viewCleanup.call(this, fallback);
        }
    };
    return $ff657ecc00b66cae$var$abstractMapper;
}
// normalize the "sort" value
function $ff657ecc00b66cae$var$massageSort(sort) {
    if (!Array.isArray(sort)) throw new Error('invalid sort json - should be an array');
    return sort.map(function(sorting) {
        if (typeof sorting === 'string') {
            const obj = {};
            obj[sorting] = 'asc';
            return obj;
        } else return sorting;
    });
}
const $ff657ecc00b66cae$var$ddocIdPrefix = /^_design\//;
function $ff657ecc00b66cae$var$massageUseIndex(useIndex) {
    let cleanedUseIndex = [];
    if (typeof useIndex === 'string') cleanedUseIndex.push(useIndex);
    else cleanedUseIndex = useIndex;
    return cleanedUseIndex.map(function(name) {
        return name.replace($ff657ecc00b66cae$var$ddocIdPrefix, '');
    });
}
function $ff657ecc00b66cae$var$massageIndexDef(indexDef) {
    indexDef.fields = indexDef.fields.map(function(field) {
        if (typeof field === 'string') {
            const obj = {};
            obj[field] = 'asc';
            return obj;
        }
        return field;
    });
    if (indexDef.partial_filter_selector) indexDef.partial_filter_selector = (0, $fir5e.massageSelector)(indexDef.partial_filter_selector);
    return indexDef;
}
function $ff657ecc00b66cae$var$getKeyFromDoc(doc, index) {
    return index.def.fields.map((obj)=>{
        const field = (0, $fir5e.getKey)(obj);
        return (0, $fir5e.getFieldFromDoc)(doc, (0, $fir5e.parseField)(field));
    });
}
// have to do this manually because REASONS. I don't know why
// CouchDB didn't implement inclusive_start
function $ff657ecc00b66cae$var$filterInclusiveStart(rows, targetValue, index) {
    const indexFields = index.def.fields;
    let startAt = 0;
    for (const row of rows){
        // shave off any docs at the beginning that are <= the
        // target value
        let docKey = $ff657ecc00b66cae$var$getKeyFromDoc(row.doc, index);
        if (indexFields.length === 1) docKey = docKey[0]; // only one field, not multi-field
        else // in the case where e.g. the user is searching {$gt: {a: 1}}
        // but the index is [a, b], then we need to shorten the doc key
        while(docKey.length > targetValue.length)docKey.pop();
        //ABS as we just looking for values that don't match
        if (Math.abs((0, $j8fka.collate)(docKey, targetValue)) > 0) break;
        ++startAt;
    }
    return startAt > 0 ? rows.slice(startAt) : rows;
}
function $ff657ecc00b66cae$var$reverseOptions(opts) {
    const newOpts = (0, $47bZj.clone)(opts);
    delete newOpts.startkey;
    delete newOpts.endkey;
    delete newOpts.inclusive_start;
    delete newOpts.inclusive_end;
    if ('endkey' in opts) newOpts.startkey = opts.endkey;
    if ('startkey' in opts) newOpts.endkey = opts.startkey;
    if ('inclusive_start' in opts) newOpts.inclusive_end = opts.inclusive_start;
    if ('inclusive_end' in opts) newOpts.inclusive_start = opts.inclusive_end;
    return newOpts;
}
function $ff657ecc00b66cae$var$validateIndex(index) {
    const ascFields = index.fields.filter(function(field) {
        return (0, $fir5e.getValue)(field) === 'asc';
    });
    if (ascFields.length !== 0 && ascFields.length !== index.fields.length) throw new Error('unsupported mixed sorting');
}
function $ff657ecc00b66cae$var$validateSort(requestDef, index) {
    if (index.defaultUsed && requestDef.sort) {
        const noneIdSorts = requestDef.sort.filter(function(sortItem) {
            return Object.keys(sortItem)[0] !== '_id';
        }).map(function(sortItem) {
            return Object.keys(sortItem)[0];
        });
        if (noneIdSorts.length > 0) throw new Error('Cannot sort on field(s) "' + noneIdSorts.join(',') + '" when using the default index');
    }
    if (index.defaultUsed) return;
}
function $ff657ecc00b66cae$var$validateFindRequest(requestDef) {
    if (typeof requestDef.selector !== 'object') throw new Error('you must provide a selector when you find()');
/*var selectors = requestDef.selector['$and'] || [requestDef.selector];
  for (var i = 0; i < selectors.length; i++) {
    var selector = selectors[i];
    var keys = Object.keys(selector);
    if (keys.length === 0) {
      throw new Error('invalid empty selector');
    }
    //var selection = selector[keys[0]];
    /*if (Object.keys(selection).length !== 1) {
      throw new Error('invalid selector: ' + JSON.stringify(selection) +
        ' - it must have exactly one key/value');
    }
  }*/ }
// determine the maximum number of fields
// we're going to need to query, e.g. if the user
// has selection ['a'] and sorting ['a', 'b'], then we
// need to use the longer of the two: ['a', 'b']
function $ff657ecc00b66cae$var$getUserFields(selector, sort) {
    const selectorFields = Object.keys(selector);
    const sortFields = sort ? sort.map((0, $fir5e.getKey)) : [];
    let userFields;
    if (selectorFields.length >= sortFields.length) userFields = selectorFields;
    else userFields = sortFields;
    if (sortFields.length === 0) return {
        fields: userFields
    };
    // sort according to the user's preferred sorting
    userFields = userFields.sort(function(left, right) {
        let leftIdx = sortFields.indexOf(left);
        if (leftIdx === -1) leftIdx = Number.MAX_VALUE;
        let rightIdx = sortFields.indexOf(right);
        if (rightIdx === -1) rightIdx = Number.MAX_VALUE;
        return leftIdx < rightIdx ? -1 : leftIdx > rightIdx ? 1 : 0;
    });
    return {
        fields: userFields,
        sortOrder: sort.map((0, $fir5e.getKey))
    };
}
async function $ff657ecc00b66cae$var$createIndex$1(db, requestDef) {
    requestDef = $ff657ecc00b66cae$var$massageCreateIndexRequest(requestDef);
    const originalIndexDef = (0, $47bZj.clone)(requestDef.index);
    requestDef.index = $ff657ecc00b66cae$var$massageIndexDef(requestDef.index);
    $ff657ecc00b66cae$var$validateIndex(requestDef.index);
    // calculating md5 is expensive - memoize and only
    // run if required
    let md5;
    function getMd5() {
        return md5 || (md5 = (0, $9Pw4Q.stringMd5)(JSON.stringify(requestDef)));
    }
    const viewName = requestDef.name || 'idx-' + getMd5();
    const ddocName = requestDef.ddoc || 'idx-' + getMd5();
    const ddocId = '_design/' + ddocName;
    let hasInvalidLanguage = false;
    let viewExists = false;
    function updateDdoc(doc) {
        if (doc._rev && doc.language !== 'query') hasInvalidLanguage = true;
        doc.language = 'query';
        doc.views = doc.views || {};
        viewExists = !!doc.views[viewName];
        if (viewExists) return false;
        doc.views[viewName] = {
            map: {
                fields: $ff657ecc00b66cae$var$mergeObjects(requestDef.index.fields),
                partial_filter_selector: requestDef.index.partial_filter_selector
            },
            reduce: '_count',
            options: {
                def: originalIndexDef
            }
        };
        return doc;
    }
    db.constructor.emit('debug', [
        'find',
        'creating index',
        ddocId
    ]);
    await (0, $47bZj.upsert)(db, ddocId, updateDdoc);
    if (hasInvalidLanguage) throw new Error('invalid language for ddoc with id "' + ddocId + '" (should be "query")');
    // kick off a build
    // TODO: abstract-pouchdb-mapreduce should support auto-updating
    // TODO: should also use update_after, but pouchdb/pouchdb#3415 blocks me
    const signature = ddocName + '/' + viewName;
    await $ff657ecc00b66cae$var$abstractMapper$1(db).query.call(db, signature, {
        limit: 0,
        reduce: false
    });
    return {
        id: ddocId,
        name: viewName,
        result: viewExists ? 'exists' : 'created'
    };
}
async function $ff657ecc00b66cae$var$getIndexes$1(db) {
    // just search through all the design docs and filter in-memory.
    // hopefully there aren't that many ddocs.
    const allDocsRes = await db.allDocs({
        startkey: '_design/',
        endkey: '_design/\uffff',
        include_docs: true
    });
    const res = {
        indexes: [
            {
                ddoc: null,
                name: '_all_docs',
                type: 'special',
                def: {
                    fields: [
                        {
                            _id: 'asc'
                        }
                    ]
                }
            }
        ]
    };
    res.indexes = $ff657ecc00b66cae$var$flatten(res.indexes, allDocsRes.rows.filter(function(row) {
        return row.doc.language === 'query';
    }).map(function(row) {
        const viewNames = row.doc.views !== undefined ? Object.keys(row.doc.views) : [];
        return viewNames.map(function(viewName) {
            const view = row.doc.views[viewName];
            return {
                ddoc: row.id,
                name: viewName,
                type: 'json',
                def: $ff657ecc00b66cae$var$massageIndexDef(view.options.def)
            };
        });
    }));
    // these are sorted by view name for some reason
    res.indexes.sort(function(left, right) {
        return (0, $fir5e.compare)(left.name, right.name);
    });
    res.total_rows = res.indexes.length;
    return res;
}
// couchdb lowest collation value
const $ff657ecc00b66cae$var$COLLATE_LO = null;
// couchdb highest collation value (TODO: well not really, but close enough amirite)
const $ff657ecc00b66cae$var$COLLATE_HI = {
    "\uffff": {}
};
const $ff657ecc00b66cae$var$SHORT_CIRCUIT_QUERY = {
    queryOpts: {
        limit: 0,
        startkey: $ff657ecc00b66cae$var$COLLATE_HI,
        endkey: $ff657ecc00b66cae$var$COLLATE_LO
    },
    inMemoryFields: []
};
// couchdb second-lowest collation value
function $ff657ecc00b66cae$var$checkFieldInIndex(index, field) {
    return index.def.fields.some((key)=>(0, $fir5e.getKey)(key) === field);
}
// so when you do e.g. $eq/$eq, we can do it entirely in the database.
// but when you do e.g. $gt/$eq, the first part can be done
// in the database, but the second part has to be done in-memory,
// because $gt has forced us to lose precision.
// so that's what this determines
function $ff657ecc00b66cae$var$userOperatorLosesPrecision(selector, field) {
    const matcher = selector[field];
    const userOperator = (0, $fir5e.getKey)(matcher);
    return userOperator !== '$eq';
}
// sort the user fields by their position in the index,
// if they're in the index
function $ff657ecc00b66cae$var$sortFieldsByIndex(userFields, index) {
    const indexFields = index.def.fields.map((0, $fir5e.getKey));
    return userFields.slice().sort(function(a, b) {
        let aIdx = indexFields.indexOf(a);
        let bIdx = indexFields.indexOf(b);
        if (aIdx === -1) aIdx = Number.MAX_VALUE;
        if (bIdx === -1) bIdx = Number.MAX_VALUE;
        return (0, $fir5e.compare)(aIdx, bIdx);
    });
}
// first pass to try to find fields that will need to be sorted in-memory
function $ff657ecc00b66cae$var$getBasicInMemoryFields(index, selector, userFields) {
    userFields = $ff657ecc00b66cae$var$sortFieldsByIndex(userFields, index);
    // check if any of the user selectors lose precision
    let needToFilterInMemory = false;
    for(let i = 0, len = userFields.length; i < len; i++){
        const field = userFields[i];
        if (needToFilterInMemory || !$ff657ecc00b66cae$var$checkFieldInIndex(index, field)) return userFields.slice(i);
        if (i < len - 1 && $ff657ecc00b66cae$var$userOperatorLosesPrecision(selector, field)) needToFilterInMemory = true;
    }
    return [];
}
function $ff657ecc00b66cae$var$getInMemoryFieldsFromNe(selector) {
    const fields = [];
    for (const [field, matcher] of Object.entries(selector)){
        for (const operator of Object.keys(matcher))if (operator === '$ne') fields.push(field);
    }
    return fields;
}
function $ff657ecc00b66cae$var$getInMemoryFields(coreInMemoryFields, index, selector, userFields) {
    const result = $ff657ecc00b66cae$var$flatten(// in-memory fields reported as necessary by the query planner
    coreInMemoryFields, // combine with another pass that checks for any we may have missed
    $ff657ecc00b66cae$var$getBasicInMemoryFields(index, selector, userFields), // combine with another pass that checks for $ne's
    $ff657ecc00b66cae$var$getInMemoryFieldsFromNe(selector));
    return $ff657ecc00b66cae$var$sortFieldsByIndex($ff657ecc00b66cae$var$uniq(result), index);
}
// check that at least one field in the user's query is represented
// in the index. order matters in the case of sorts
function $ff657ecc00b66cae$var$checkIndexFieldsMatch(indexFields, sortOrder, fields) {
    if (sortOrder) {
        // array has to be a strict subarray of index array. furthermore,
        // the sortOrder fields need to all be represented in the index
        const sortMatches = $ff657ecc00b66cae$var$oneArrayIsStrictSubArrayOfOther(sortOrder, indexFields);
        const selectorMatches = $ff657ecc00b66cae$var$oneArrayIsSubArrayOfOther(fields, indexFields);
        return sortMatches && selectorMatches;
    }
    // all of the user's specified fields still need to be
    // on the left side of the index array, although the order
    // doesn't matter
    return $ff657ecc00b66cae$var$oneSetIsSubArrayOfOther(fields, indexFields);
}
const $ff657ecc00b66cae$var$logicalMatchers = [
    '$eq',
    '$gt',
    '$gte',
    '$lt',
    '$lte'
];
function $ff657ecc00b66cae$var$isNonLogicalMatcher(matcher) {
    return $ff657ecc00b66cae$var$logicalMatchers.indexOf(matcher) === -1;
}
// check all the index fields for usages of '$ne'
// e.g. if the user queries {foo: {$ne: 'foo'}, bar: {$eq: 'bar'}},
// then we can neither use an index on ['foo'] nor an index on
// ['foo', 'bar'], but we can use an index on ['bar'] or ['bar', 'foo']
function $ff657ecc00b66cae$var$checkFieldsLogicallySound(indexFields, selector) {
    const firstField = indexFields[0];
    const matcher = selector[firstField];
    if (typeof matcher === 'undefined') /* istanbul ignore next */ return true;
    const isInvalidNe = Object.keys(matcher).length === 1 && (0, $fir5e.getKey)(matcher) === '$ne';
    return !isInvalidNe;
}
function $ff657ecc00b66cae$var$checkIndexMatches(index, sortOrder, fields, selector) {
    const indexFields = index.def.fields.map((0, $fir5e.getKey));
    const fieldsMatch = $ff657ecc00b66cae$var$checkIndexFieldsMatch(indexFields, sortOrder, fields);
    if (!fieldsMatch) return false;
    return $ff657ecc00b66cae$var$checkFieldsLogicallySound(indexFields, selector);
}
//
// the algorithm is very simple:
// take all the fields the user supplies, and if those fields
// are a strict subset of the fields in some index,
// then use that index
//
function $ff657ecc00b66cae$var$findMatchingIndexes(selector, userFields, sortOrder, indexes) {
    return indexes.filter(function(index) {
        return $ff657ecc00b66cae$var$checkIndexMatches(index, sortOrder, userFields, selector);
    });
}
// find the best index, i.e. the one that matches the most fields
// in the user's query
function $ff657ecc00b66cae$var$findBestMatchingIndex(selector, userFields, sortOrder, indexes, useIndex) {
    const matchingIndexes = $ff657ecc00b66cae$var$findMatchingIndexes(selector, userFields, sortOrder, indexes);
    if (matchingIndexes.length === 0) {
        if (useIndex) throw {
            error: "no_usable_index",
            message: "There is no index available for this selector."
        };
        // return `all_docs` as a default index;
        // I'm assuming that _all_docs is always first
        const defaultIndex = indexes[0];
        defaultIndex.defaultUsed = true;
        return defaultIndex;
    }
    if (matchingIndexes.length === 1 && !useIndex) return matchingIndexes[0];
    const userFieldsMap = $ff657ecc00b66cae$var$arrayToObject(userFields);
    function scoreIndex(index) {
        const indexFields = index.def.fields.map((0, $fir5e.getKey));
        let score = 0;
        for (const indexField of indexFields)if (userFieldsMap[indexField]) score++;
        return score;
    }
    if (useIndex) {
        const useIndexDdoc = '_design/' + useIndex[0];
        const useIndexName = useIndex.length === 2 ? useIndex[1] : false;
        const index = matchingIndexes.find(function(index) {
            if (useIndexName && index.ddoc === useIndexDdoc && useIndexName === index.name) return true;
            if (index.ddoc === useIndexDdoc) /* istanbul ignore next */ return true;
            return false;
        });
        if (!index) throw {
            error: "unknown_error",
            message: "Could not find that index or could not use that index for the query"
        };
        return index;
    }
    return $ff657ecc00b66cae$var$max(matchingIndexes, scoreIndex);
}
function $ff657ecc00b66cae$var$getSingleFieldQueryOptsFor(userOperator, userValue) {
    switch(userOperator){
        case '$eq':
            return {
                key: userValue
            };
        case '$lte':
            return {
                endkey: userValue
            };
        case '$gte':
            return {
                startkey: userValue
            };
        case '$lt':
            return {
                endkey: userValue,
                inclusive_end: false
            };
        case '$gt':
            return {
                startkey: userValue,
                inclusive_start: false
            };
    }
    return {
        startkey: $ff657ecc00b66cae$var$COLLATE_LO
    };
}
function $ff657ecc00b66cae$var$getSingleFieldCoreQueryPlan(selector, index) {
    const field = (0, $fir5e.getKey)(index.def.fields[0]);
    //ignoring this because the test to exercise the branch is skipped at the moment
    /* istanbul ignore next */ const matcher = selector[field] || {};
    const inMemoryFields = [];
    const userOperators = Object.keys(matcher);
    let combinedOpts;
    for (const userOperator of userOperators){
        if ($ff657ecc00b66cae$var$isNonLogicalMatcher(userOperator)) inMemoryFields.push(field);
        const userValue = matcher[userOperator];
        const newQueryOpts = $ff657ecc00b66cae$var$getSingleFieldQueryOptsFor(userOperator, userValue);
        if (combinedOpts) combinedOpts = $ff657ecc00b66cae$var$mergeObjects([
            combinedOpts,
            newQueryOpts
        ]);
        else combinedOpts = newQueryOpts;
    }
    return {
        queryOpts: combinedOpts,
        inMemoryFields: inMemoryFields
    };
}
function $ff657ecc00b66cae$var$getMultiFieldCoreQueryPlan(userOperator, userValue) {
    switch(userOperator){
        case '$eq':
            return {
                startkey: userValue,
                endkey: userValue
            };
        case '$lte':
            return {
                endkey: userValue
            };
        case '$gte':
            return {
                startkey: userValue
            };
        case '$lt':
            return {
                endkey: userValue,
                inclusive_end: false
            };
        case '$gt':
            return {
                startkey: userValue,
                inclusive_start: false
            };
    }
}
function $ff657ecc00b66cae$var$getMultiFieldQueryOpts(selector, index) {
    const indexFields = index.def.fields.map((0, $fir5e.getKey));
    let inMemoryFields = [];
    const startkey = [];
    const endkey = [];
    let inclusiveStart;
    let inclusiveEnd;
    function finish(i) {
        if (inclusiveStart !== false) startkey.push($ff657ecc00b66cae$var$COLLATE_LO);
        if (inclusiveEnd !== false) endkey.push($ff657ecc00b66cae$var$COLLATE_HI);
        // keep track of the fields where we lost specificity,
        // and therefore need to filter in-memory
        inMemoryFields = indexFields.slice(i);
    }
    for(let i = 0, len = indexFields.length; i < len; i++){
        const indexField = indexFields[i];
        const matcher = selector[indexField];
        if (!matcher || !Object.keys(matcher).length) {
            finish(i);
            break;
        } else if (Object.keys(matcher).some($ff657ecc00b66cae$var$isNonLogicalMatcher)) {
            finish(i);
            break;
        } else if (i > 0) {
            const usingGtlt = '$gt' in matcher || '$gte' in matcher || '$lt' in matcher || '$lte' in matcher;
            const previousKeys = Object.keys(selector[indexFields[i - 1]]);
            const previousWasEq = $ff657ecc00b66cae$var$arrayEquals(previousKeys, [
                '$eq'
            ]);
            const previousWasSame = $ff657ecc00b66cae$var$arrayEquals(previousKeys, Object.keys(matcher));
            const gtltLostSpecificity = usingGtlt && !previousWasEq && !previousWasSame;
            if (gtltLostSpecificity) {
                finish(i);
                break;
            }
        }
        const userOperators = Object.keys(matcher);
        let combinedOpts = null;
        for (const userOperator of userOperators){
            const userValue = matcher[userOperator];
            const newOpts = $ff657ecc00b66cae$var$getMultiFieldCoreQueryPlan(userOperator, userValue);
            if (combinedOpts) combinedOpts = $ff657ecc00b66cae$var$mergeObjects([
                combinedOpts,
                newOpts
            ]);
            else combinedOpts = newOpts;
        }
        startkey.push('startkey' in combinedOpts ? combinedOpts.startkey : $ff657ecc00b66cae$var$COLLATE_LO);
        endkey.push('endkey' in combinedOpts ? combinedOpts.endkey : $ff657ecc00b66cae$var$COLLATE_HI);
        if ('inclusive_start' in combinedOpts) inclusiveStart = combinedOpts.inclusive_start;
        if ('inclusive_end' in combinedOpts) inclusiveEnd = combinedOpts.inclusive_end;
    }
    const res = {
        startkey: startkey,
        endkey: endkey
    };
    if (typeof inclusiveStart !== 'undefined') res.inclusive_start = inclusiveStart;
    if (typeof inclusiveEnd !== 'undefined') res.inclusive_end = inclusiveEnd;
    return {
        queryOpts: res,
        inMemoryFields: inMemoryFields
    };
}
function $ff657ecc00b66cae$var$shouldShortCircuit(selector) {
    // We have a field to select from, but not a valid value
    // this should result in a short circuited query
    // just like the http adapter (couchdb) and mongodb
    // see tests for issue #7810
    // @todo Use 'Object.values' when Node.js v6 support is dropped.
    const values = Object.keys(selector).map(function(key) {
        return selector[key];
    });
    return values.some(function(val) {
        return typeof val === 'object' && Object.keys(val).length === 0;
    });
}
function $ff657ecc00b66cae$var$getDefaultQueryPlan(selector) {
    //using default index, so all fields need to be done in memory
    return {
        queryOpts: {
            startkey: null
        },
        inMemoryFields: [
            Object.keys(selector)
        ]
    };
}
function $ff657ecc00b66cae$var$getCoreQueryPlan(selector, index) {
    if (index.defaultUsed) return $ff657ecc00b66cae$var$getDefaultQueryPlan(selector, index);
    if (index.def.fields.length === 1) // one field in index, so the value was indexed as a singleton
    return $ff657ecc00b66cae$var$getSingleFieldCoreQueryPlan(selector, index);
    // else index has multiple fields, so the value was indexed as an array
    return $ff657ecc00b66cae$var$getMultiFieldQueryOpts(selector, index);
}
function $ff657ecc00b66cae$var$planQuery(request, indexes) {
    const selector = request.selector;
    const sort = request.sort;
    if ($ff657ecc00b66cae$var$shouldShortCircuit(selector)) return Object.assign({}, $ff657ecc00b66cae$var$SHORT_CIRCUIT_QUERY, {
        index: indexes[0]
    });
    const userFieldsRes = $ff657ecc00b66cae$var$getUserFields(selector, sort);
    const userFields = userFieldsRes.fields;
    const sortOrder = userFieldsRes.sortOrder;
    const index = $ff657ecc00b66cae$var$findBestMatchingIndex(selector, userFields, sortOrder, indexes, request.use_index);
    const coreQueryPlan = $ff657ecc00b66cae$var$getCoreQueryPlan(selector, index);
    const queryOpts = coreQueryPlan.queryOpts;
    const coreInMemoryFields = coreQueryPlan.inMemoryFields;
    const inMemoryFields = $ff657ecc00b66cae$var$getInMemoryFields(coreInMemoryFields, index, selector, userFields);
    return {
        queryOpts: queryOpts,
        index: index,
        inMemoryFields: inMemoryFields
    };
}
function $ff657ecc00b66cae$var$indexToSignature(index) {
    // remove '_design/'
    return index.ddoc.substring(8) + '/' + index.name;
}
async function $ff657ecc00b66cae$var$doAllDocs(db, originalOpts) {
    const opts = (0, $47bZj.clone)(originalOpts);
    // CouchDB responds in weird ways when you provide a non-string to _id;
    // we mimic the behavior for consistency. See issue66 tests for details.
    if (opts.descending) {
        if ('endkey' in opts && typeof opts.endkey !== 'string') opts.endkey = '';
        if ('startkey' in opts && typeof opts.startkey !== 'string') opts.limit = 0;
    } else {
        if ('startkey' in opts && typeof opts.startkey !== 'string') opts.startkey = '';
        if ('endkey' in opts && typeof opts.endkey !== 'string') opts.limit = 0;
    }
    if ('key' in opts && typeof opts.key !== 'string') opts.limit = 0;
    if (opts.limit > 0 && opts.indexes_count) {
        // brute force and quite naive impl.
        // amp up the limit with the amount of (indexes) design docs
        // or is this too naive? How about skip?
        opts.original_limit = opts.limit;
        opts.limit += opts.indexes_count;
    }
    const res = await db.allDocs(opts);
    // filter out any design docs that _all_docs might return
    res.rows = res.rows.filter(function(row) {
        return !/^_design\//.test(row.id);
    });
    // put back original limit
    if (opts.original_limit) opts.limit = opts.original_limit;
    // enforce the rows to respect the given limit
    res.rows = res.rows.slice(0, opts.limit);
    return res;
}
async function $ff657ecc00b66cae$var$queryAllOrIndex(db, opts, indexToUse) {
    if (indexToUse.name === '_all_docs') return $ff657ecc00b66cae$var$doAllDocs(db, opts);
    return $ff657ecc00b66cae$var$abstractMapper$1(db).query.call(db, $ff657ecc00b66cae$var$indexToSignature(indexToUse), opts);
}
async function $ff657ecc00b66cae$var$find$1(db, requestDef, explain) {
    if (requestDef.selector) {
        // must be validated before massaging
        $ff657ecc00b66cae$var$validateSelector(requestDef.selector, false);
        requestDef.selector = (0, $fir5e.massageSelector)(requestDef.selector);
    }
    if (requestDef.sort) requestDef.sort = $ff657ecc00b66cae$var$massageSort(requestDef.sort);
    if (requestDef.use_index) requestDef.use_index = $ff657ecc00b66cae$var$massageUseIndex(requestDef.use_index);
    if (!('limit' in requestDef)) // Match the default limit of CouchDB
    requestDef.limit = 25;
    $ff657ecc00b66cae$var$validateFindRequest(requestDef);
    const getIndexesRes = await $ff657ecc00b66cae$var$getIndexes$1(db);
    db.constructor.emit('debug', [
        'find',
        'planning query',
        requestDef
    ]);
    const queryPlan = $ff657ecc00b66cae$var$planQuery(requestDef, getIndexesRes.indexes);
    db.constructor.emit('debug', [
        'find',
        'query plan',
        queryPlan
    ]);
    const indexToUse = queryPlan.index;
    $ff657ecc00b66cae$var$validateSort(requestDef, indexToUse);
    let opts = Object.assign({
        include_docs: true,
        reduce: false,
        // Add amount of index for doAllDocs to use (related to issue #7810)
        indexes_count: getIndexesRes.total_rows
    }, queryPlan.queryOpts);
    if ('startkey' in opts && 'endkey' in opts && (0, $j8fka.collate)(opts.startkey, opts.endkey) > 0) // can't possibly return any results, startkey > endkey
    /* istanbul ignore next */ return {
        docs: []
    };
    const isDescending = requestDef.sort && typeof requestDef.sort[0] !== 'string' && (0, $fir5e.getValue)(requestDef.sort[0]) === 'desc';
    if (isDescending) {
        // either all descending or all ascending
        opts.descending = true;
        opts = $ff657ecc00b66cae$var$reverseOptions(opts);
    }
    if (!queryPlan.inMemoryFields.length) {
        // no in-memory filtering necessary, so we can let the
        // database do the limit/skip for us
        opts.limit = requestDef.limit;
        if ('skip' in requestDef) opts.skip = requestDef.skip;
    }
    if (explain) return Promise.resolve(queryPlan, opts);
    const res = await $ff657ecc00b66cae$var$queryAllOrIndex(db, opts, indexToUse);
    if (opts.inclusive_start === false) // may have to manually filter the first one,
    // since couchdb has no true inclusive_start option
    res.rows = $ff657ecc00b66cae$var$filterInclusiveStart(res.rows, opts.startkey, indexToUse);
    if (queryPlan.inMemoryFields.length) // need to filter some stuff in-memory
    res.rows = (0, $fir5e.filterInMemoryFields)(res.rows, requestDef, queryPlan.inMemoryFields);
    const resp = {
        docs: res.rows.map(function(row) {
            const doc = row.doc;
            if (requestDef.fields) return $ff657ecc00b66cae$var$pick(doc, requestDef.fields);
            return doc;
        })
    };
    if (indexToUse.defaultUsed) resp.warning = 'No matching index found, create an index to optimize query time.';
    return resp;
}
async function $ff657ecc00b66cae$var$explain$1(db, requestDef) {
    const queryPlan = await $ff657ecc00b66cae$var$find$1(db, requestDef, true);
    return {
        dbname: db.name,
        index: queryPlan.index,
        selector: requestDef.selector,
        range: {
            start_key: queryPlan.queryOpts.startkey,
            end_key: queryPlan.queryOpts.endkey
        },
        opts: {
            use_index: requestDef.use_index || [],
            bookmark: "nil",
            limit: requestDef.limit,
            skip: requestDef.skip,
            sort: requestDef.sort || {},
            fields: requestDef.fields,
            conflicts: false,
            r: [
                49
            ]
        },
        limit: requestDef.limit,
        skip: requestDef.skip || 0,
        fields: requestDef.fields
    };
}
async function $ff657ecc00b66cae$var$deleteIndex$1(db, index) {
    if (!index.ddoc) throw new Error('you must supply an index.ddoc when deleting');
    if (!index.name) throw new Error('you must supply an index.name when deleting');
    const docId = index.ddoc;
    const viewName = index.name;
    function deltaFun(doc) {
        if (Object.keys(doc.views).length === 1 && doc.views[viewName]) // only one view in this ddoc, delete the whole ddoc
        return {
            _id: docId,
            _deleted: true
        };
        // more than one view here, just remove the view
        delete doc.views[viewName];
        return doc;
    }
    await (0, $47bZj.upsert)(db, docId, deltaFun);
    await $ff657ecc00b66cae$var$abstractMapper$1(db).viewCleanup.apply(db);
    return {
        ok: true
    };
}
const $ff657ecc00b66cae$var$plugin = {};
$ff657ecc00b66cae$var$plugin.createIndex = $ff657ecc00b66cae$var$resolveToCallback(async function(requestDef) {
    if (typeof requestDef !== 'object') throw new Error('you must provide an index to create');
    const createIndex$$1 = (0, $47bZj.isRemote)(this) ? $ff657ecc00b66cae$var$createIndex : $ff657ecc00b66cae$var$createIndex$1;
    return createIndex$$1(this, requestDef);
});
$ff657ecc00b66cae$var$plugin.find = $ff657ecc00b66cae$var$resolveToCallback(async function(requestDef) {
    if (typeof requestDef !== 'object') throw new Error('you must provide search parameters to find()');
    const find$$1 = (0, $47bZj.isRemote)(this) ? $ff657ecc00b66cae$var$find : $ff657ecc00b66cae$var$find$1;
    return find$$1(this, requestDef);
});
$ff657ecc00b66cae$var$plugin.explain = $ff657ecc00b66cae$var$resolveToCallback(async function(requestDef) {
    if (typeof requestDef !== 'object') throw new Error('you must provide search parameters to explain()');
    const find$$1 = (0, $47bZj.isRemote)(this) ? $ff657ecc00b66cae$var$explain : $ff657ecc00b66cae$var$explain$1;
    return find$$1(this, requestDef);
});
$ff657ecc00b66cae$var$plugin.getIndexes = $ff657ecc00b66cae$var$resolveToCallback(async function() {
    const getIndexes$$1 = (0, $47bZj.isRemote)(this) ? $ff657ecc00b66cae$var$getIndexes : $ff657ecc00b66cae$var$getIndexes$1;
    return getIndexes$$1(this);
});
$ff657ecc00b66cae$var$plugin.deleteIndex = $ff657ecc00b66cae$var$resolveToCallback(async function(indexDef) {
    if (typeof indexDef !== 'object') throw new Error('you must provide an index to delete');
    const deleteIndex$$1 = (0, $47bZj.isRemote)(this) ? $ff657ecc00b66cae$var$deleteIndex : $ff657ecc00b66cae$var$deleteIndex$1;
    return deleteIndex$$1(this, indexDef);
});
var $ff657ecc00b66cae$export$2e2bcd8739ae039 = $ff657ecc00b66cae$var$plugin;

});
parcelRegister("doDnd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c0c0efadc2cda23$export$2e2bcd8739ae039);

var $4GdZ0 = parcelRequire("4GdZ0");

var $j8fka = parcelRequire("j8fka");

var $cqZVJ = parcelRequire("cqZVJ");

var $7zAYS = parcelRequire("7zAYS");

var $47bZj = parcelRequire("47bZj");

var $9Pw4Q = parcelRequire("9Pw4Q");

var $jqlHH = parcelRequire("jqlHH");
/*
 * Simple task queue to sequentialize actions. Assumes
 * callbacks will eventually fire (once).
 */ class $9c0c0efadc2cda23$var$TaskQueue {
    constructor(){
        this.promise = Promise.resolve();
    }
    add(promiseFactory) {
        this.promise = this.promise// just recover
        .catch(()=>{}).then(()=>promiseFactory());
        return this.promise;
    }
    finish() {
        return this.promise;
    }
}
function $9c0c0efadc2cda23$var$stringify(input) {
    if (!input) return 'undefined'; // backwards compat for empty reduce
    // for backwards compat with mapreduce, functions/strings are stringified
    // as-is. everything else is JSON-stringified.
    switch(typeof input){
        case 'function':
            // e.g. a mapreduce map
            return input.toString();
        case 'string':
            // e.g. a mapreduce built-in _reduce function
            return input.toString();
        default:
            // e.g. a JSON object in the case of mango queries
            return JSON.stringify(input);
    }
}
/* create a string signature for a view so we can cache it and uniq it */ function $9c0c0efadc2cda23$var$createViewSignature(mapFun, reduceFun) {
    // the "undefined" part is for backwards compatibility
    return $9c0c0efadc2cda23$var$stringify(mapFun) + $9c0c0efadc2cda23$var$stringify(reduceFun) + 'undefined';
}
async function $9c0c0efadc2cda23$var$createView(sourceDB, viewName, mapFun, reduceFun, temporary, localDocName) {
    const viewSignature = $9c0c0efadc2cda23$var$createViewSignature(mapFun, reduceFun);
    let cachedViews;
    if (!temporary) {
        // cache this to ensure we don't try to update the same view twice
        cachedViews = sourceDB._cachedViews = sourceDB._cachedViews || {};
        if (cachedViews[viewSignature]) return cachedViews[viewSignature];
    }
    const promiseForView = sourceDB.info().then(async function(info) {
        const depDbName = info.db_name + '-mrview-' + (temporary ? 'temp' : (0, $9Pw4Q.stringMd5)(viewSignature));
        // save the view name in the source db so it can be cleaned up if necessary
        // (e.g. when the _design doc is deleted, remove all associated view data)
        function diffFunction(doc) {
            doc.views = doc.views || {};
            let fullViewName = viewName;
            if (fullViewName.indexOf('/') === -1) fullViewName = viewName + '/' + viewName;
            const depDbs = doc.views[fullViewName] = doc.views[fullViewName] || {};
            /* istanbul ignore if */ if (depDbs[depDbName]) return; // no update necessary
            depDbs[depDbName] = true;
            return doc;
        }
        await (0, $47bZj.upsert)(sourceDB, '_local/' + localDocName, diffFunction);
        const res = await sourceDB.registerDependentDatabase(depDbName);
        const db = res.db;
        db.auto_compaction = true;
        const view = {
            name: depDbName,
            db: db,
            sourceDB: sourceDB,
            adapter: sourceDB.adapter,
            mapFun: mapFun,
            reduceFun: reduceFun
        };
        let lastSeqDoc;
        try {
            lastSeqDoc = await view.db.get('_local/lastSeq');
        } catch (err) {
            /* istanbul ignore if */ if (err.status !== 404) throw err;
        }
        view.seq = lastSeqDoc ? lastSeqDoc.seq : 0;
        if (cachedViews) view.db.once('destroyed', function() {
            delete cachedViews[viewSignature];
        });
        return view;
    });
    if (cachedViews) cachedViews[viewSignature] = promiseForView;
    return promiseForView;
}
const $9c0c0efadc2cda23$var$persistentQueues = {};
const $9c0c0efadc2cda23$var$tempViewQueue = new $9c0c0efadc2cda23$var$TaskQueue();
const $9c0c0efadc2cda23$var$CHANGES_BATCH_SIZE = 50;
function $9c0c0efadc2cda23$var$parseViewName(name) {
    // can be either 'ddocname/viewname' or just 'viewname'
    // (where the ddoc name is the same)
    return name.indexOf('/') === -1 ? [
        name,
        name
    ] : name.split('/');
}
function $9c0c0efadc2cda23$var$isGenOne(changes) {
    // only return true if the current change is 1-
    // and there are no other leafs
    return changes.length === 1 && /^1-/.test(changes[0].rev);
}
function $9c0c0efadc2cda23$var$emitError(db, e, data) {
    try {
        db.emit('error', e);
    } catch (err) {
        (0, $47bZj.guardedConsole)('error', "The user's map/reduce function threw an uncaught error.\nYou can debug this error by doing:\nmyDatabase.on('error', function (err) { debugger; });\nPlease double-check your map/reduce function.");
        (0, $47bZj.guardedConsole)('error', e, data);
    }
}
/**
 * Returns an "abstract" mapreduce object of the form:
 *
 *   {
 *     query: queryFun,
 *     viewCleanup: viewCleanupFun
 *   }
 *
 * Arguments are:
 *
 * localDoc: string
 *   This is for the local doc that gets saved in order to track the
 *   "dependent" DBs and clean them up for viewCleanup. It should be
 *   unique, so that indexer plugins don't collide with each other.
 * mapper: function (mapFunDef, emit)
 *   Returns a map function based on the mapFunDef, which in the case of
 *   normal map/reduce is just the de-stringified function, but may be
 *   something else, such as an object in the case of pouchdb-find.
 * reducer: function (reduceFunDef)
 *   Ditto, but for reducing. Modules don't have to support reducing
 *   (e.g. pouchdb-find).
 * ddocValidator: function (ddoc, viewName)
 *   Throws an error if the ddoc or viewName is not valid.
 *   This could be a way to communicate to the user that the configuration for the
 *   indexer is invalid.
 */ function $9c0c0efadc2cda23$var$createAbstractMapReduce(localDocName, mapper, reducer, ddocValidator) {
    function tryMap(db, fun, doc) {
        // emit an event if there was an error thrown by a map function.
        // putting try/catches in a single function also avoids deoptimizations.
        try {
            fun(doc);
        } catch (e) {
            $9c0c0efadc2cda23$var$emitError(db, e, {
                fun: fun,
                doc: doc
            });
        }
    }
    function tryReduce(db, fun, keys, values, rereduce) {
        // same as above, but returning the result or an error. there are two separate
        // functions to avoid extra memory allocations since the tryCode() case is used
        // for custom map functions (common) vs this function, which is only used for
        // custom reduce functions (rare)
        try {
            return {
                output: fun(keys, values, rereduce)
            };
        } catch (e) {
            $9c0c0efadc2cda23$var$emitError(db, e, {
                fun: fun,
                keys: keys,
                values: values,
                rereduce: rereduce
            });
            return {
                error: e
            };
        }
    }
    function sortByKeyThenValue(x, y) {
        const keyCompare = (0, $j8fka.collate)(x.key, y.key);
        return keyCompare !== 0 ? keyCompare : (0, $j8fka.collate)(x.value, y.value);
    }
    function sliceResults(results, limit, skip) {
        skip = skip || 0;
        if (typeof limit === 'number') return results.slice(skip, limit + skip);
        else if (skip > 0) return results.slice(skip);
        return results;
    }
    function rowToDocId(row) {
        const val = row.value;
        // Users can explicitly specify a joined doc _id, or it
        // defaults to the doc _id that emitted the key/value.
        const docId = val && typeof val === 'object' && val._id || row.id;
        return docId;
    }
    function readAttachmentsAsBlobOrBuffer(res) {
        for (const row of res.rows){
            const atts = row.doc && row.doc._attachments;
            if (!atts) continue;
            for (const filename of Object.keys(atts)){
                const att = atts[filename];
                atts[filename].data = (0, $4GdZ0.base64StringToBlobOrBuffer)(att.data, att.content_type);
            }
        }
    }
    function postprocessAttachments(opts) {
        return function(res) {
            if (opts.include_docs && opts.attachments && opts.binary) readAttachmentsAsBlobOrBuffer(res);
            return res;
        };
    }
    function addHttpParam(paramName, opts, params, asJson) {
        // add an http param from opts to params, optionally json-encoded
        let val = opts[paramName];
        if (typeof val !== 'undefined') {
            if (asJson) val = encodeURIComponent(JSON.stringify(val));
            params.push(paramName + '=' + val);
        }
    }
    function coerceInteger(integerCandidate) {
        if (typeof integerCandidate !== 'undefined') {
            const asNumber = Number(integerCandidate);
            // prevents e.g. '1foo' or '1.1' being coerced to 1
            if (!isNaN(asNumber) && asNumber === parseInt(integerCandidate, 10)) return asNumber;
            else return integerCandidate;
        }
    }
    function coerceOptions(opts) {
        opts.group_level = coerceInteger(opts.group_level);
        opts.limit = coerceInteger(opts.limit);
        opts.skip = coerceInteger(opts.skip);
        return opts;
    }
    function checkPositiveInteger(number) {
        if (number) {
            if (typeof number !== 'number') return new (0, $jqlHH.QueryParseError)(`Invalid value for integer: "${number}"`);
            if (number < 0) return new (0, $jqlHH.QueryParseError)(`Invalid value for positive integer: "${number}"`);
        }
    }
    function checkQueryParseError(options, fun) {
        const startkeyName = options.descending ? 'endkey' : 'startkey';
        const endkeyName = options.descending ? 'startkey' : 'endkey';
        if (typeof options[startkeyName] !== 'undefined' && typeof options[endkeyName] !== 'undefined' && (0, $j8fka.collate)(options[startkeyName], options[endkeyName]) > 0) throw new (0, $jqlHH.QueryParseError)("No rows can match your key range, reverse your start_key and end_key or set {descending : true}");
        else if (fun.reduce && options.reduce !== false) {
            if (options.include_docs) throw new (0, $jqlHH.QueryParseError)('{include_docs:true} is invalid for reduce');
            else if (options.keys && options.keys.length > 1 && !options.group && !options.group_level) throw new (0, $jqlHH.QueryParseError)("Multi-key fetches for reduce views must use {group: true}");
        }
        for (const optionName of [
            'group_level',
            'limit',
            'skip'
        ]){
            const error = checkPositiveInteger(options[optionName]);
            if (error) throw error;
        }
    }
    async function httpQuery(db, fun, opts) {
        // List of parameters to add to the PUT request
        let params = [];
        let body;
        let method = 'GET';
        let ok;
        // If opts.reduce exists and is defined, then add it to the list
        // of parameters.
        // If reduce=false then the results are that of only the map function
        // not the final result of map and reduce.
        addHttpParam('reduce', opts, params);
        addHttpParam('include_docs', opts, params);
        addHttpParam('attachments', opts, params);
        addHttpParam('limit', opts, params);
        addHttpParam('descending', opts, params);
        addHttpParam('group', opts, params);
        addHttpParam('group_level', opts, params);
        addHttpParam('skip', opts, params);
        addHttpParam('stale', opts, params);
        addHttpParam('conflicts', opts, params);
        addHttpParam('startkey', opts, params, true);
        addHttpParam('start_key', opts, params, true);
        addHttpParam('endkey', opts, params, true);
        addHttpParam('end_key', opts, params, true);
        addHttpParam('inclusive_end', opts, params);
        addHttpParam('key', opts, params, true);
        addHttpParam('update_seq', opts, params);
        // Format the list of parameters into a valid URI query string
        params = params.join('&');
        params = params === '' ? '' : '?' + params;
        // If keys are supplied, issue a POST to circumvent GET query string limits
        // see http://wiki.apache.org/couchdb/HTTP_view_API#Querying_Options
        if (typeof opts.keys !== 'undefined') {
            const MAX_URL_LENGTH = 2000;
            // according to http://stackoverflow.com/a/417184/680742,
            // the de facto URL length limit is 2000 characters
            const keysAsString = `keys=${encodeURIComponent(JSON.stringify(opts.keys))}`;
            if (keysAsString.length + params.length + 1 <= MAX_URL_LENGTH) // If the keys are short enough, do a GET. we do this to work around
            // Safari not understanding 304s on POSTs (see pouchdb/pouchdb#1239)
            params += (params[0] === '?' ? '&' : '?') + keysAsString;
            else {
                method = 'POST';
                if (typeof fun === 'string') body = {
                    keys: opts.keys
                };
                else fun.keys = opts.keys;
            }
        }
        // We are referencing a query defined in the design doc
        if (typeof fun === 'string') {
            const parts = $9c0c0efadc2cda23$var$parseViewName(fun);
            const response = await db.fetch('_design/' + parts[0] + '/_view/' + parts[1] + params, {
                headers: new (0, $7zAYS.Headers)({
                    'Content-Type': 'application/json'
                }),
                method: method,
                body: JSON.stringify(body)
            });
            ok = response.ok;
            // status = response.status;
            const result = await response.json();
            if (!ok) {
                result.status = response.status;
                throw (0, $cqZVJ.generateErrorFromResponse)(result);
            }
            // fail the entire request if the result contains an error
            for (const row of result.rows){
                /* istanbul ignore if */ if (row.value && row.value.error && row.value.error === "builtin_reduce_error") throw new Error(row.reason);
            }
            return new Promise(function(resolve) {
                resolve(result);
            }).then(postprocessAttachments(opts));
        }
        // We are using a temporary view, terrible for performance, good for testing
        body = body || {};
        for (const key of Object.keys(fun))if (Array.isArray(fun[key])) body[key] = fun[key];
        else body[key] = fun[key].toString();
        const response = await db.fetch('_temp_view' + params, {
            headers: new (0, $7zAYS.Headers)({
                'Content-Type': 'application/json'
            }),
            method: 'POST',
            body: JSON.stringify(body)
        });
        ok = response.ok;
        // status = response.status;
        const result = await response.json();
        if (!ok) {
            result.status = response.status;
            throw (0, $cqZVJ.generateErrorFromResponse)(result);
        }
        return new Promise(function(resolve) {
            resolve(result);
        }).then(postprocessAttachments(opts));
    }
    // custom adapters can define their own api._query
    // and override the default behavior
    /* istanbul ignore next */ function customQuery(db, fun, opts) {
        return new Promise(function(resolve, reject) {
            db._query(fun, opts, function(err, res) {
                if (err) return reject(err);
                resolve(res);
            });
        });
    }
    // custom adapters can define their own api._viewCleanup
    // and override the default behavior
    /* istanbul ignore next */ function customViewCleanup(db) {
        return new Promise(function(resolve, reject) {
            db._viewCleanup(function(err, res) {
                if (err) return reject(err);
                resolve(res);
            });
        });
    }
    function defaultsTo(value) {
        return function(reason) {
            /* istanbul ignore else */ if (reason.status === 404) return value;
            else throw reason;
        };
    }
    // returns a promise for a list of docs to update, based on the input docId.
    // the order doesn't matter, because post-3.2.0, bulkDocs
    // is an atomic operation in all three adapters.
    async function getDocsToPersist(docId, view, docIdsToChangesAndEmits) {
        const metaDocId = '_local/doc_' + docId;
        const defaultMetaDoc = {
            _id: metaDocId,
            keys: []
        };
        const docData = docIdsToChangesAndEmits.get(docId);
        const indexableKeysToKeyValues = docData[0];
        const changes = docData[1];
        function getMetaDoc() {
            if ($9c0c0efadc2cda23$var$isGenOne(changes)) // generation 1, so we can safely assume initial state
            // for performance reasons (avoids unnecessary GETs)
            return Promise.resolve(defaultMetaDoc);
            return view.db.get(metaDocId).catch(defaultsTo(defaultMetaDoc));
        }
        function getKeyValueDocs(metaDoc) {
            if (!metaDoc.keys.length) // no keys, no need for a lookup
            return Promise.resolve({
                rows: []
            });
            return view.db.allDocs({
                keys: metaDoc.keys,
                include_docs: true
            });
        }
        function processKeyValueDocs(metaDoc, kvDocsRes) {
            const kvDocs = [];
            const oldKeys = new Set();
            for (const row of kvDocsRes.rows){
                const doc = row.doc;
                if (!doc) continue;
                kvDocs.push(doc);
                oldKeys.add(doc._id);
                doc._deleted = !indexableKeysToKeyValues.has(doc._id);
                if (!doc._deleted) {
                    const keyValue = indexableKeysToKeyValues.get(doc._id);
                    if ('value' in keyValue) doc.value = keyValue.value;
                }
            }
            const newKeys = (0, $jqlHH.mapToKeysArray)(indexableKeysToKeyValues);
            for (const key of newKeys)if (!oldKeys.has(key)) {
                // new doc
                const kvDoc = {
                    _id: key
                };
                const keyValue = indexableKeysToKeyValues.get(key);
                if ('value' in keyValue) kvDoc.value = keyValue.value;
                kvDocs.push(kvDoc);
            }
            metaDoc.keys = (0, $jqlHH.uniq)(newKeys.concat(metaDoc.keys));
            kvDocs.push(metaDoc);
            return kvDocs;
        }
        const metaDoc = await getMetaDoc();
        const keyValueDocs = await getKeyValueDocs(metaDoc);
        return processKeyValueDocs(metaDoc, keyValueDocs);
    }
    function updatePurgeSeq(view) {
        // with this approach, we just assume to have processed all missing purges and write the latest
        // purgeSeq into the _local/purgeSeq doc.
        return view.sourceDB.get('_local/purges').then(function(res) {
            const purgeSeq = res.purgeSeq;
            return view.db.get('_local/purgeSeq').then(function(res) {
                return res._rev;
            }).catch(defaultsTo(undefined)).then(function(rev) {
                return view.db.put({
                    _id: '_local/purgeSeq',
                    _rev: rev,
                    purgeSeq: purgeSeq
                });
            });
        }).catch(function(err) {
            if (err.status !== 404) throw err;
        });
    }
    // updates all emitted key/value docs and metaDocs in the mrview database
    // for the given batch of documents from the source database
    function saveKeyValues(view, docIdsToChangesAndEmits, seq) {
        var seqDocId = '_local/lastSeq';
        return view.db.get(seqDocId).catch(defaultsTo({
            _id: seqDocId,
            seq: 0
        })).then(function(lastSeqDoc) {
            var docIds = (0, $jqlHH.mapToKeysArray)(docIdsToChangesAndEmits);
            return Promise.all(docIds.map(function(docId) {
                return getDocsToPersist(docId, view, docIdsToChangesAndEmits);
            })).then(function(listOfDocsToPersist) {
                var docsToPersist = listOfDocsToPersist.flat();
                lastSeqDoc.seq = seq;
                docsToPersist.push(lastSeqDoc);
                // write all docs in a single operation, update the seq once
                return view.db.bulkDocs({
                    docs: docsToPersist
                });
            })// TODO: this should be placed somewhere else, probably? we're querying both docs twice
            //   (first time when getting the actual purges).
            .then(()=>updatePurgeSeq(view));
        });
    }
    function getQueue(view) {
        const viewName = typeof view === 'string' ? view : view.name;
        let queue = $9c0c0efadc2cda23$var$persistentQueues[viewName];
        if (!queue) queue = $9c0c0efadc2cda23$var$persistentQueues[viewName] = new $9c0c0efadc2cda23$var$TaskQueue();
        return queue;
    }
    async function updateView(view, opts) {
        return (0, $jqlHH.sequentialize)(getQueue(view), function() {
            return updateViewInQueue(view, opts);
        })();
    }
    async function updateViewInQueue(view, opts) {
        // bind the emit function once
        let mapResults;
        let doc;
        let taskId;
        function emit(key, value) {
            const output = {
                id: doc._id,
                key: (0, $j8fka.normalizeKey)(key)
            };
            // Don't explicitly store the value unless it's defined and non-null.
            // This saves on storage space, because often people don't use it.
            if (typeof value !== 'undefined' && value !== null) output.value = (0, $j8fka.normalizeKey)(value);
            mapResults.push(output);
        }
        const mapFun = mapper(view.mapFun, emit);
        let currentSeq = view.seq || 0;
        function createTask() {
            return view.sourceDB.info().then(function(info) {
                taskId = view.sourceDB.activeTasks.add({
                    name: 'view_indexing',
                    total_items: info.update_seq - currentSeq
                });
            });
        }
        function processChange(docIdsToChangesAndEmits, seq) {
            return function() {
                return saveKeyValues(view, docIdsToChangesAndEmits, seq);
            };
        }
        let indexed_docs = 0;
        const progress = {
            view: view.name,
            indexed_docs: indexed_docs
        };
        view.sourceDB.emit('indexing', progress);
        const queue = new $9c0c0efadc2cda23$var$TaskQueue();
        async function processNextBatch() {
            const response = await view.sourceDB.changes({
                return_docs: true,
                conflicts: true,
                include_docs: true,
                style: 'all_docs',
                since: currentSeq,
                limit: opts.changes_batch_size
            });
            const purges = await getRecentPurges();
            return processBatch(response, purges);
        }
        function getRecentPurges() {
            return view.db.get('_local/purgeSeq').then(function(res) {
                return res.purgeSeq;
            }).catch(defaultsTo(-1)).then(function(purgeSeq) {
                return view.sourceDB.get('_local/purges').then(function(res) {
                    const recentPurges = res.purges.filter(function(purge, index) {
                        return index > purgeSeq;
                    }).map((purge)=>purge.docId);
                    const uniquePurges = recentPurges.filter(function(docId, index) {
                        return recentPurges.indexOf(docId) === index;
                    });
                    return Promise.all(uniquePurges.map(function(docId) {
                        return view.sourceDB.get(docId).then(function(doc) {
                            return {
                                docId: docId,
                                doc: doc
                            };
                        }).catch(defaultsTo({
                            docId: docId
                        }));
                    }));
                }).catch(defaultsTo([]));
            });
        }
        function processBatch(response, purges) {
            const results = response.results;
            if (!results.length && !purges.length) return;
            for (const purge of purges){
                const index = results.findIndex(function(change) {
                    return change.id === purge.docId;
                });
                if (index < 0) {
                    // mimic a db.remove() on the changes feed
                    const entry = {
                        _id: purge.docId,
                        doc: {
                            _id: purge.docId,
                            _deleted: 1
                        },
                        changes: []
                    };
                    if (purge.doc) {
                        // update with new winning rev after purge
                        entry.doc = purge.doc;
                        entry.changes.push({
                            rev: purge.doc._rev
                        });
                    }
                    results.push(entry);
                }
            }
            const docIdsToChangesAndEmits = createDocIdsToChangesAndEmits(results);
            queue.add(processChange(docIdsToChangesAndEmits, currentSeq));
            indexed_docs = indexed_docs + results.length;
            const progress = {
                view: view.name,
                last_seq: response.last_seq,
                results_count: results.length,
                indexed_docs: indexed_docs
            };
            view.sourceDB.emit('indexing', progress);
            view.sourceDB.activeTasks.update(taskId, {
                completed_items: indexed_docs
            });
            if (results.length < opts.changes_batch_size) return;
            return processNextBatch();
        }
        function createDocIdsToChangesAndEmits(results) {
            const docIdsToChangesAndEmits = new Map();
            for (const change of results){
                if (change.doc._id[0] !== '_') {
                    mapResults = [];
                    doc = change.doc;
                    if (!doc._deleted) tryMap(view.sourceDB, mapFun, doc);
                    mapResults.sort(sortByKeyThenValue);
                    const indexableKeysToKeyValues = createIndexableKeysToKeyValues(mapResults);
                    docIdsToChangesAndEmits.set(change.doc._id, [
                        indexableKeysToKeyValues,
                        change.changes
                    ]);
                }
                currentSeq = change.seq;
            }
            return docIdsToChangesAndEmits;
        }
        function createIndexableKeysToKeyValues(mapResults) {
            const indexableKeysToKeyValues = new Map();
            let lastKey;
            for(let i = 0, len = mapResults.length; i < len; i++){
                const emittedKeyValue = mapResults[i];
                const complexKey = [
                    emittedKeyValue.key,
                    emittedKeyValue.id
                ];
                if (i > 0 && (0, $j8fka.collate)(emittedKeyValue.key, lastKey) === 0) complexKey.push(i); // dup key+id, so make it unique
                indexableKeysToKeyValues.set((0, $j8fka.toIndexableString)(complexKey), emittedKeyValue);
                lastKey = emittedKeyValue.key;
            }
            return indexableKeysToKeyValues;
        }
        try {
            await createTask();
            await processNextBatch();
            await queue.finish();
            view.seq = currentSeq;
            view.sourceDB.activeTasks.remove(taskId);
        } catch (error) {
            view.sourceDB.activeTasks.remove(taskId, error);
        }
    }
    function reduceView(view, results, options) {
        if (options.group_level === 0) delete options.group_level;
        const shouldGroup = options.group || options.group_level;
        const reduceFun = reducer(view.reduceFun);
        const groups = [];
        const lvl = isNaN(options.group_level) ? Number.POSITIVE_INFINITY : options.group_level;
        for (const result of results){
            const last = groups[groups.length - 1];
            let groupKey = shouldGroup ? result.key : null;
            // only set group_level for array keys
            if (shouldGroup && Array.isArray(groupKey)) groupKey = groupKey.slice(0, lvl);
            if (last && (0, $j8fka.collate)(last.groupKey, groupKey) === 0) {
                last.keys.push([
                    result.key,
                    result.id
                ]);
                last.values.push(result.value);
                continue;
            }
            groups.push({
                keys: [
                    [
                        result.key,
                        result.id
                    ]
                ],
                values: [
                    result.value
                ],
                groupKey: groupKey
            });
        }
        results = [];
        for (const group of groups){
            const reduceTry = tryReduce(view.sourceDB, reduceFun, group.keys, group.values, false);
            if (reduceTry.error && reduceTry.error instanceof (0, $jqlHH.BuiltInError)) // CouchDB returns an error if a built-in errors out
            throw reduceTry.error;
            results.push({
                // CouchDB just sets the value to null if a non-built-in errors out
                value: reduceTry.error ? null : reduceTry.output,
                key: group.groupKey
            });
        }
        // no total_rows/offset when reducing
        return {
            rows: sliceResults(results, options.limit, options.skip)
        };
    }
    function queryView(view, opts) {
        return (0, $jqlHH.sequentialize)(getQueue(view), function() {
            return queryViewInQueue(view, opts);
        })();
    }
    async function queryViewInQueue(view, opts) {
        let totalRows;
        const shouldReduce = view.reduceFun && opts.reduce !== false;
        const skip = opts.skip || 0;
        if (typeof opts.keys !== 'undefined' && !opts.keys.length) {
            // equivalent query
            opts.limit = 0;
            delete opts.keys;
        }
        async function fetchFromView(viewOpts) {
            viewOpts.include_docs = true;
            const res = await view.db.allDocs(viewOpts);
            totalRows = res.total_rows;
            return res.rows.map(function(result) {
                // implicit migration - in older versions of PouchDB,
                // we explicitly stored the doc as {id: ..., key: ..., value: ...}
                // this is tested in a migration test
                /* istanbul ignore next */ if ('value' in result.doc && typeof result.doc.value === 'object' && result.doc.value !== null) {
                    const keys = Object.keys(result.doc.value).sort();
                    // this detection method is not perfect, but it's unlikely the user
                    // emitted a value which was an object with these 3 exact keys
                    const expectedKeys = [
                        'id',
                        'key',
                        'value'
                    ];
                    if (!(keys < expectedKeys || keys > expectedKeys)) return result.doc.value;
                }
                const parsedKeyAndDocId = (0, $j8fka.parseIndexableString)(result.doc._id);
                return {
                    key: parsedKeyAndDocId[0],
                    id: parsedKeyAndDocId[1],
                    value: 'value' in result.doc ? result.doc.value : null
                };
            });
        }
        async function onMapResultsReady(rows) {
            let finalResults;
            if (shouldReduce) finalResults = reduceView(view, rows, opts);
            else if (typeof opts.keys === 'undefined') finalResults = {
                total_rows: totalRows,
                offset: skip,
                rows: rows
            };
            else // support limit, skip for keys query
            finalResults = {
                total_rows: totalRows,
                offset: skip,
                rows: sliceResults(rows, opts.limit, opts.skip)
            };
            /* istanbul ignore if */ if (opts.update_seq) finalResults.update_seq = view.seq;
            if (opts.include_docs) {
                const docIds = (0, $jqlHH.uniq)(rows.map(rowToDocId));
                const allDocsRes = await view.sourceDB.allDocs({
                    keys: docIds,
                    include_docs: true,
                    conflicts: opts.conflicts,
                    attachments: opts.attachments,
                    binary: opts.binary
                });
                const docIdsToDocs = new Map();
                for (const row of allDocsRes.rows)docIdsToDocs.set(row.id, row.doc);
                for (const row of rows){
                    const docId = rowToDocId(row);
                    const doc = docIdsToDocs.get(docId);
                    if (doc) row.doc = doc;
                }
            }
            return finalResults;
        }
        if (typeof opts.keys !== 'undefined') {
            const keys = opts.keys;
            const fetchPromises = keys.map(function(key) {
                const viewOpts = {
                    startkey: (0, $j8fka.toIndexableString)([
                        key
                    ]),
                    endkey: (0, $j8fka.toIndexableString)([
                        key,
                        {}
                    ])
                };
                /* istanbul ignore if */ if (opts.update_seq) viewOpts.update_seq = true;
                return fetchFromView(viewOpts);
            });
            const result = await Promise.all(fetchPromises);
            const flattenedResult = result.flat();
            return onMapResultsReady(flattenedResult);
        } else {
            const viewOpts = {
                descending: opts.descending
            };
            /* istanbul ignore if */ if (opts.update_seq) viewOpts.update_seq = true;
            let startkey;
            let endkey;
            if ('start_key' in opts) startkey = opts.start_key;
            if ('startkey' in opts) startkey = opts.startkey;
            if ('end_key' in opts) endkey = opts.end_key;
            if ('endkey' in opts) endkey = opts.endkey;
            if (typeof startkey !== 'undefined') viewOpts.startkey = opts.descending ? (0, $j8fka.toIndexableString)([
                startkey,
                {}
            ]) : (0, $j8fka.toIndexableString)([
                startkey
            ]);
            if (typeof endkey !== 'undefined') {
                let inclusiveEnd = opts.inclusive_end !== false;
                if (opts.descending) inclusiveEnd = !inclusiveEnd;
                viewOpts.endkey = (0, $j8fka.toIndexableString)(inclusiveEnd ? [
                    endkey,
                    {}
                ] : [
                    endkey
                ]);
            }
            if (typeof opts.key !== 'undefined') {
                const keyStart = (0, $j8fka.toIndexableString)([
                    opts.key
                ]);
                const keyEnd = (0, $j8fka.toIndexableString)([
                    opts.key,
                    {}
                ]);
                if (viewOpts.descending) {
                    viewOpts.endkey = keyStart;
                    viewOpts.startkey = keyEnd;
                } else {
                    viewOpts.startkey = keyStart;
                    viewOpts.endkey = keyEnd;
                }
            }
            if (!shouldReduce) {
                if (typeof opts.limit === 'number') viewOpts.limit = opts.limit;
                viewOpts.skip = skip;
            }
            const result = await fetchFromView(viewOpts);
            return onMapResultsReady(result);
        }
    }
    async function httpViewCleanup(db) {
        const response = await db.fetch('_view_cleanup', {
            headers: new (0, $7zAYS.Headers)({
                'Content-Type': 'application/json'
            }),
            method: 'POST'
        });
        return response.json();
    }
    async function localViewCleanup(db) {
        try {
            const metaDoc = await db.get('_local/' + localDocName);
            const docsToViews = new Map();
            for (const fullViewName of Object.keys(metaDoc.views)){
                const parts = $9c0c0efadc2cda23$var$parseViewName(fullViewName);
                const designDocName = '_design/' + parts[0];
                const viewName = parts[1];
                let views = docsToViews.get(designDocName);
                if (!views) {
                    views = new Set();
                    docsToViews.set(designDocName, views);
                }
                views.add(viewName);
            }
            const opts = {
                keys: (0, $jqlHH.mapToKeysArray)(docsToViews),
                include_docs: true
            };
            const res = await db.allDocs(opts);
            const viewsToStatus = {};
            for (const row of res.rows){
                const ddocName = row.key.substring(8); // cuts off '_design/'
                for (const viewName of docsToViews.get(row.key)){
                    let fullViewName = ddocName + '/' + viewName;
                    /* istanbul ignore if */ if (!metaDoc.views[fullViewName]) // new format, without slashes, to support PouchDB 2.2.0
                    // migration test in pouchdb's browser.migration.js verifies this
                    fullViewName = viewName;
                    const viewDBNames = Object.keys(metaDoc.views[fullViewName]);
                    // design doc deleted, or view function nonexistent
                    const statusIsGood = row.doc && row.doc.views && row.doc.views[viewName];
                    for (const viewDBName of viewDBNames)viewsToStatus[viewDBName] = viewsToStatus[viewDBName] || statusIsGood;
                }
            }
            const dbsToDelete = Object.keys(viewsToStatus).filter(function(viewDBName) {
                return !viewsToStatus[viewDBName];
            });
            const destroyPromises = dbsToDelete.map(function(viewDBName) {
                return (0, $jqlHH.sequentialize)(getQueue(viewDBName), function() {
                    return new db.constructor(viewDBName, db.__opts).destroy();
                })();
            });
            return Promise.all(destroyPromises).then(function() {
                return {
                    ok: true
                };
            });
        } catch (err) {
            if (err.status === 404) return {
                ok: true
            };
            else throw err;
        }
    }
    async function queryPromised(db, fun, opts) {
        /* istanbul ignore next */ if (typeof db._query === 'function') return customQuery(db, fun, opts);
        if ((0, $47bZj.isRemote)(db)) return httpQuery(db, fun, opts);
        const updateViewOpts = {
            changes_batch_size: db.__opts.view_update_changes_batch_size || $9c0c0efadc2cda23$var$CHANGES_BATCH_SIZE
        };
        if (typeof fun !== 'string') {
            // temp_view
            checkQueryParseError(opts, fun);
            $9c0c0efadc2cda23$var$tempViewQueue.add(async function() {
                const view = await $9c0c0efadc2cda23$var$createView(/* sourceDB */ db, /* viewName */ 'temp_view/temp_view', /* mapFun */ fun.map, /* reduceFun */ fun.reduce, /* temporary */ true, /* localDocName */ localDocName);
                return (0, $jqlHH.fin)(updateView(view, updateViewOpts).then(function() {
                    return queryView(view, opts);
                }), function() {
                    return view.db.destroy();
                });
            });
            return $9c0c0efadc2cda23$var$tempViewQueue.finish();
        } else {
            // persistent view
            const fullViewName = fun;
            const parts = $9c0c0efadc2cda23$var$parseViewName(fullViewName);
            const designDocName = parts[0];
            const viewName = parts[1];
            const doc = await db.get('_design/' + designDocName);
            fun = doc.views && doc.views[viewName];
            if (!fun) // basic validator; it's assumed that every subclass would want this
            throw new (0, $jqlHH.NotFoundError)(`ddoc ${doc._id} has no view named ${viewName}`);
            ddocValidator(doc, viewName);
            checkQueryParseError(opts, fun);
            const view = await $9c0c0efadc2cda23$var$createView(/* sourceDB */ db, /* viewName */ fullViewName, /* mapFun */ fun.map, /* reduceFun */ fun.reduce, /* temporary */ false, /* localDocName */ localDocName);
            if (opts.stale === 'ok' || opts.stale === 'update_after') {
                if (opts.stale === 'update_after') (0, $47bZj.nextTick)(function() {
                    updateView(view, updateViewOpts);
                });
                return queryView(view, opts);
            } else {
                await updateView(view, updateViewOpts);
                return queryView(view, opts);
            }
        }
    }
    function abstractQuery(fun, opts, callback) {
        const db = this;
        if (typeof opts === 'function') {
            callback = opts;
            opts = {};
        }
        opts = opts ? coerceOptions(opts) : {};
        if (typeof fun === 'function') fun = {
            map: fun
        };
        const promise = Promise.resolve().then(function() {
            return queryPromised(db, fun, opts);
        });
        (0, $jqlHH.promisedCallback)(promise, callback);
        return promise;
    }
    const abstractViewCleanup = (0, $jqlHH.callbackify)(function() {
        const db = this;
        /* istanbul ignore next */ if (typeof db._viewCleanup === 'function') return customViewCleanup(db);
        if ((0, $47bZj.isRemote)(db)) return httpViewCleanup(db);
        return localViewCleanup(db);
    });
    return {
        query: abstractQuery,
        viewCleanup: abstractViewCleanup
    };
}
var $9c0c0efadc2cda23$export$2e2bcd8739ae039 = $9c0c0efadc2cda23$var$createAbstractMapReduce;

});
parcelRegister("jqlHH", function(module, exports) {

$parcel$export(module.exports, "QueryParseError", () => $e24147f7ae85f94b$export$8b5aa59681a27ae5);
$parcel$export(module.exports, "NotFoundError", () => $e24147f7ae85f94b$export$78c95b58762d2106);
$parcel$export(module.exports, "BuiltInError", () => $e24147f7ae85f94b$export$5117417b7927f466);
$parcel$export(module.exports, "promisedCallback", () => $e24147f7ae85f94b$export$eb0f4d4069cc08d0);
$parcel$export(module.exports, "callbackify", () => $e24147f7ae85f94b$export$3da8666cc157adcc);
$parcel$export(module.exports, "fin", () => $e24147f7ae85f94b$export$fd6ed3c1eb9a7694);
$parcel$export(module.exports, "sequentialize", () => $e24147f7ae85f94b$export$c7a694233347547e);
$parcel$export(module.exports, "uniq", () => $e24147f7ae85f94b$export$f70730c3d1fc524e);
$parcel$export(module.exports, "mapToKeysArray", () => $e24147f7ae85f94b$export$23e82a9ea0930e3e);

var $47bZj = parcelRequire("47bZj");
class $e24147f7ae85f94b$export$8b5aa59681a27ae5 extends Error {
    constructor(message){
        super();
        this.status = 400;
        this.name = 'query_parse_error';
        this.message = message;
        this.error = true;
        try {
            Error.captureStackTrace(this, $e24147f7ae85f94b$export$8b5aa59681a27ae5);
        } catch (e) {}
    }
}
class $e24147f7ae85f94b$export$78c95b58762d2106 extends Error {
    constructor(message){
        super();
        this.status = 404;
        this.name = 'not_found';
        this.message = message;
        this.error = true;
        try {
            Error.captureStackTrace(this, $e24147f7ae85f94b$export$78c95b58762d2106);
        } catch (e) {}
    }
}
class $e24147f7ae85f94b$export$5117417b7927f466 extends Error {
    constructor(message){
        super();
        this.status = 500;
        this.name = 'invalid_value';
        this.message = message;
        this.error = true;
        try {
            Error.captureStackTrace(this, $e24147f7ae85f94b$export$5117417b7927f466);
        } catch (e) {}
    }
}
function $e24147f7ae85f94b$export$eb0f4d4069cc08d0(promise, callback) {
    if (callback) promise.then(function(res) {
        (0, $47bZj.nextTick)(function() {
            callback(null, res);
        });
    }, function(reason) {
        (0, $47bZj.nextTick)(function() {
            callback(reason);
        });
    });
    return promise;
}
function $e24147f7ae85f94b$export$3da8666cc157adcc(fun) {
    return function(...args) {
        var cb = args.pop();
        var promise = fun.apply(this, args);
        if (typeof cb === 'function') $e24147f7ae85f94b$export$eb0f4d4069cc08d0(promise, cb);
        return promise;
    };
}
// Promise finally util similar to Q.finally
function $e24147f7ae85f94b$export$fd6ed3c1eb9a7694(promise, finalPromiseFactory) {
    return promise.then(function(res) {
        return finalPromiseFactory().then(function() {
            return res;
        });
    }, function(reason) {
        return finalPromiseFactory().then(function() {
            throw reason;
        });
    });
}
function $e24147f7ae85f94b$export$c7a694233347547e(queue, promiseFactory) {
    return function() {
        var args = arguments;
        var that = this;
        return queue.add(function() {
            return promiseFactory.apply(that, args);
        });
    };
}
// uniq an array of strings, order not guaranteed
// similar to underscore/lodash _.uniq
function $e24147f7ae85f94b$export$f70730c3d1fc524e(arr) {
    var theSet = new Set(arr);
    var result = new Array(theSet.size);
    var index = -1;
    theSet.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
function $e24147f7ae85f94b$export$23e82a9ea0930e3e(map) {
    var result = new Array(map.size);
    var index = -1;
    map.forEach(function(value, key) {
        result[++index] = key;
    });
    return result;
}

});



parcelRegister("5xV4Q", function(module, exports) {

$parcel$export(module.exports, "State", () => $44adb19172acd991$export$7254cc27399e90bd);
$parcel$export(module.exports, "markStale", () => $44adb19172acd991$export$d6420bf04efd761d);
$parcel$export(module.exports, "requestSync", () => $44adb19172acd991$export$918f5f559011cccc);
$parcel$export(module.exports, "startSync", () => $44adb19172acd991$export$e4744af56b43e3ee);
$parcel$export(module.exports, "updateProgress", () => $44adb19172acd991$export$7a67bd6f3a0feb1e);
$parcel$export(module.exports, "completeSync", () => $44adb19172acd991$export$818687ab0c070db5);
$parcel$export(module.exports, "syncError", () => $44adb19172acd991$export$ae5f934cb17bc78);
$parcel$export(module.exports, "socketConnected", () => $44adb19172acd991$export$48b6ca2220db698a);
$parcel$export(module.exports, "socketDisconnected", () => $44adb19172acd991$export$7b77b29673fc6d37);
$parcel$export(module.exports, "default", () => $44adb19172acd991$export$2e2bcd8739ae039);
$parcel$export(module.exports, "syncMiddleware", () => $44adb19172acd991$export$6a29f8b8d330280a);

var $8WGgv = parcelRequire("8WGgv");

var $ioiHS = parcelRequire("ioiHS");

var $rbG4f = parcelRequire("rbG4f");
const $44adb19172acd991$var$debug = (0, $ioiHS.debugClient)('sync');
var $44adb19172acd991$export$7254cc27399e90bd = /*#__PURE__*/ function(State) {
    /** full sync requested (either manually by the user or by the socket conneecting) */ State["requested"] = "requested";
    /** initial, or socket is disconnected */ State["disconnected"] = "disconnected";
    /** a full sync is in progress, the socket is still disconnected */ State["syncing"] = "syncing";
    /** full sync completed successfully */ State["completed"] = "completed";
    /** the socket is connected, ready and waiting */ State["connected"] = "connected";
    /** something went 'orribly wrong */ State["error"] = "error";
    return State;
}({});
const $44adb19172acd991$export$a157aa5bc56d44a7 = (0, $8WGgv.createSlice)({
    name: 'sync',
    initialState: {
        stale: {},
        state: "disconnected"
    },
    reducers: {
        // TODO: refactor only mark stale when connected
        markStale: (state, action)=>{
            state.stale[action.payload._id] = action.payload;
        },
        cleanStale: (state, action)=>{
            for (const doc of action.payload){
                const dirty = state.stale[doc._id];
                if (dirty?._rev === doc._rev) delete state.stale[doc._id];
            }
        },
        requestSync: (state)=>{
            state.state = "requested";
        },
        startSync: (state)=>{
            state.state = "syncing";
            state.progress = undefined;
            state.error = undefined;
            state.stale = {};
        },
        // TODO: should we store the count and total, do this math on display?
        updateProgress: (state, action)=>{
            state.progress = Math.floor(action.payload.count / action.payload.total * 100);
        },
        completeSync: (state)=>{
            state.state = "completed";
            state.progress = undefined;
        },
        // biome-ignore lint/suspicious/noExplicitAny: TODO type this properly
        syncError: (state, action)=>{
            const error = {
                name: action.payload.name,
                message: action.payload.message
            };
            if (error.message === 'Network Error') state.state = "disconnected";
            else {
                state.error = error;
                state.state = "error";
            }
        },
        socketConnected: (state)=>{
            state.state = "connected";
        },
        socketDisconnected: (state)=>{
            state.state = "disconnected";
        }
    }
});
const { markStale: $44adb19172acd991$export$d6420bf04efd761d, cleanStale: $44adb19172acd991$export$a71c0ef1726a30e0, requestSync: $44adb19172acd991$export$918f5f559011cccc, startSync: $44adb19172acd991$export$e4744af56b43e3ee, updateProgress: $44adb19172acd991$export$7a67bd6f3a0feb1e, completeSync: $44adb19172acd991$export$818687ab0c070db5, syncError: $44adb19172acd991$export$ae5f934cb17bc78, socketConnected: $44adb19172acd991$export$48b6ca2220db698a, socketDisconnected: $44adb19172acd991$export$7b77b29673fc6d37 } = $44adb19172acd991$export$a157aa5bc56d44a7.actions;
var $44adb19172acd991$export$2e2bcd8739ae039 = $44adb19172acd991$export$a157aa5bc56d44a7.reducer;
const $44adb19172acd991$export$6a29f8b8d330280a = (storeApi)=>(next)=>(action)=>{
            const result = next(action);
            if ($44adb19172acd991$export$a157aa5bc56d44a7.actions.markStale.match(action)) {
                const state = storeApi.getState();
                const socket = (0, $rbG4f.getSocket)();
                // Only emit if we're fully connected (not during initial sync)
                if (socket?.connected && state.sync.state === "connected") {
                    const doc = action.payload;
                    $44adb19172acd991$var$debug(`emitting docUpdate for ${doc._id}`);
                    socket.emit('docUpdate', [
                        doc
                    ]);
                }
                // Always clean stale docs after processing
                // If offline, the full sync on reconnect will handle them
                storeApi.dispatch($44adb19172acd991$export$a71c0ef1726a30e0([
                    action.payload
                ]));
            }
            return result;
        };

});
parcelRegister("8WGgv", function(module, exports) {

$parcel$export(module.exports, "configureStore", () => $171627766113ddc2$export$7d8a5b498da695ac);
$parcel$export(module.exports, "createSlice", () => $171627766113ddc2$export$4d8d9bd83c24ae8b);
// src/index.ts

var $hV595 = parcelRequire("hV595");

var $bXF6r = parcelRequire("bXF6r");

var $ahJpD = parcelRequire("ahJpD");

var $40YCe = parcelRequire("40YCe");
// src/createDraftSafeSelector.ts
var $171627766113ddc2$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $ahJpD.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $bXF6r.isDraft)(value) ? (0, $bXF6r.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $171627766113ddc2$export$a5d3c27355e35910 = /* @__PURE__ */ $171627766113ddc2$export$aab6de9e3dbb1473((0, $ahJpD.weakMapMemoize));
// src/devtoolsExtension.ts
var $171627766113ddc2$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $hV595.compose;
    return (0, $hV595.compose).apply(null, arguments);
};
var $171627766113ddc2$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $171627766113ddc2$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $171627766113ddc2$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($171627766113ddc2$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $hV595.isAction)(action) && action.type === type;
    return actionCreator;
}
function $171627766113ddc2$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $171627766113ddc2$var$hasMatchFunction(action);
}
function $171627766113ddc2$export$ebd532f9034651f3(action) {
    return (0, $hV595.isAction)(action) && Object.keys(action).every($171627766113ddc2$var$isValidKey);
}
function $171627766113ddc2$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $171627766113ddc2$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $171627766113ddc2$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function $171627766113ddc2$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var $171627766113ddc2$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $171627766113ddc2$var$freezeDraftable(val) {
    return (0, $bXF6r.isDraftable)(val) ? (0, $bXF6r.produce)(val, ()=>{}) : val;
}
function $171627766113ddc2$var$getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function $171627766113ddc2$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $171627766113ddc2$var$trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = $171627766113ddc2$var$trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return $171627766113ddc2$var$detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function $171627766113ddc2$var$trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = $171627766113ddc2$var$trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function $171627766113ddc2$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $171627766113ddc2$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $171627766113ddc2$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function $171627766113ddc2$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $hV595.isPlainObject)(val);
}
function $171627766113ddc2$export$ada5dca0b571bc7(value, path = "", isSerializable = $171627766113ddc2$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $171627766113ddc2$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $171627766113ddc2$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $171627766113ddc2$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$171627766113ddc2$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $171627766113ddc2$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $171627766113ddc2$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $171627766113ddc2$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $171627766113ddc2$export$1908877435b1d5e9();
        if (thunk) {
            if ($171627766113ddc2$var$isBoolean(thunk)) middlewareArray.push((0, $40YCe.thunk));
            else middlewareArray.push((0, $40YCe.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $171627766113ddc2$export$8fb31c0f05df007b = "RTK_autoBatch";
var $171627766113ddc2$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$171627766113ddc2$export$8fb31c0f05df007b]: true
            }
        });
var $171627766113ddc2$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $171627766113ddc2$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $171627766113ddc2$var$createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : $171627766113ddc2$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$171627766113ddc2$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $171627766113ddc2$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $171627766113ddc2$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($171627766113ddc2$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function $171627766113ddc2$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $171627766113ddc2$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, duplicateMiddlewareCheck: duplicateMiddlewareCheck = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $hV595.isPlainObject)(reducer)) rootReducer = (0, $hV595.combineReducers)(reducer);
    else throw new Error($171627766113ddc2$export$378fa86b259c0280(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, $hV595.compose);
    if (devTools) finalCompose = $171627766113ddc2$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $hV595.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = $171627766113ddc2$var$buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $hV595.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $171627766113ddc2$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($171627766113ddc2$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($171627766113ddc2$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $171627766113ddc2$var$isStateFunction(x) {
    return typeof x === "function";
}
function $171627766113ddc2$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $171627766113ddc2$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($171627766113ddc2$var$isStateFunction(initialState)) getInitialState = ()=>$171627766113ddc2$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $171627766113ddc2$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $bXF6r.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $bXF6r.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $bXF6r.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var $171627766113ddc2$var$matches = (matcher, action)=>{
    if ($171627766113ddc2$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $171627766113ddc2$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$171627766113ddc2$var$matches(matcher, action));
    };
}
function $171627766113ddc2$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$171627766113ddc2$var$matches(matcher, action));
    };
}
function $171627766113ddc2$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $171627766113ddc2$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $171627766113ddc2$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$171627766113ddc2$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$171627766113ddc2$var$isAsyncThunkArray(asyncThunks)) return $171627766113ddc2$export$872dec21e9a69476()(asyncThunks[0]);
    return $171627766113ddc2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function $171627766113ddc2$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$171627766113ddc2$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$171627766113ddc2$var$isAsyncThunkArray(asyncThunks)) return $171627766113ddc2$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return $171627766113ddc2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function $171627766113ddc2$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return $171627766113ddc2$export$9dd1fb32974da385($171627766113ddc2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
    if (!$171627766113ddc2$var$isAsyncThunkArray(asyncThunks)) return $171627766113ddc2$export$fcc3388fb56de601()(asyncThunks[0]);
    return $171627766113ddc2$export$9dd1fb32974da385($171627766113ddc2$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
}
function $171627766113ddc2$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$171627766113ddc2$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$171627766113ddc2$var$isAsyncThunkArray(asyncThunks)) return $171627766113ddc2$export$1da80a6ef1307441()(asyncThunks[0]);
    return $171627766113ddc2$export$2c3435c7647f7b0d(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function $171627766113ddc2$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$171627766113ddc2$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$171627766113ddc2$var$isAsyncThunkArray(asyncThunks)) return $171627766113ddc2$export$6aa4142d99c1abce()(asyncThunks[0]);
    return $171627766113ddc2$export$2c3435c7647f7b0d(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var $171627766113ddc2$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $171627766113ddc2$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $171627766113ddc2$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $171627766113ddc2$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $171627766113ddc2$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $171627766113ddc2$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $171627766113ddc2$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $171627766113ddc2$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $171627766113ddc2$var$externalAbortMessage = "External signal was aborted";
var $171627766113ddc2$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $171627766113ddc2$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $171627766113ddc2$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $171627766113ddc2$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $171627766113ddc2$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg, { signal: signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $171627766113ddc2$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort($171627766113ddc2$var$externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort($171627766113ddc2$var$externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($171627766113ddc2$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $171627766113ddc2$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $171627766113ddc2$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $171627766113ddc2$var$RejectWithValue) throw result;
                                if (result instanceof $171627766113ddc2$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $171627766113ddc2$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($171627766113ddc2$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $171627766113ddc2$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $171627766113ddc2$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $171627766113ddc2$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $171627766113ddc2$var$asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var $171627766113ddc2$export$343355ed40c51c46 = {
    [$171627766113ddc2$var$asyncThunkSymbol]: $171627766113ddc2$export$6abd22dc03e5063f
};
var $171627766113ddc2$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($171627766113ddc2$export$23a094319a4b586 || {});
function $171627766113ddc2$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $171627766113ddc2$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$171627766113ddc2$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($171627766113ddc2$export$378fa86b259c0280(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers($171627766113ddc2$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($171627766113ddc2$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($171627766113ddc2$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $171627766113ddc2$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($171627766113ddc2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $171627766113ddc2$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $171627766113ddc2$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $171627766113ddc2$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $171627766113ddc2$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = $171627766113ddc2$var$getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $171627766113ddc2$var$getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return $171627766113ddc2$var$getOrInsertComputed(selectorCache, selectState, ()=>{
                    const map = {};
                    for (const [name2, selector] of Object.entries(options.selectors ?? {}))map[name2] = $171627766113ddc2$var$wrapSelector(selector, selectState, ()=>$171627766113ddc2$var$getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt ?? reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $171627766113ddc2$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $171627766113ddc2$export$4d8d9bd83c24ae8b = /* @__PURE__ */ $171627766113ddc2$export$affdea4146de9cf5();
function $171627766113ddc2$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $171627766113ddc2$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$171627766113ddc2$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($171627766113ddc2$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $171627766113ddc2$export$309c7a02b0b0bc62(type, prepareCallback) : $171627766113ddc2$export$309c7a02b0b0bc62(type));
}
function $171627766113ddc2$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $171627766113ddc2$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $171627766113ddc2$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($171627766113ddc2$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $171627766113ddc2$var$noop,
        pending: pending || $171627766113ddc2$var$noop,
        rejected: rejected || $171627766113ddc2$var$noop,
        settled: settled || $171627766113ddc2$var$noop
    });
}
function $171627766113ddc2$var$noop() {}
// src/entities/entity_state.ts
function $171627766113ddc2$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $171627766113ddc2$var$createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign($171627766113ddc2$var$getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $171627766113ddc2$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $171627766113ddc2$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
// src/entities/state_adapter.ts
var $171627766113ddc2$var$isDraftTyped = (0, $bXF6r.isDraft);
function $171627766113ddc2$var$createSingleArgumentStateOperator(mutator) {
    const operator = $171627766113ddc2$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $171627766113ddc2$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $171627766113ddc2$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($171627766113ddc2$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $bXF6r.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function $171627766113ddc2$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $171627766113ddc2$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $171627766113ddc2$var$getCurrent(value) {
    return (0, $bXF6r.isDraft)(value) ? (0, $bXF6r.current)(value) : value;
}
function $171627766113ddc2$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $171627766113ddc2$var$ensureEntitiesArray(newEntities);
    const existingIdsArray = $171627766113ddc2$var$getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = $171627766113ddc2$var$selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id: id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function $171627766113ddc2$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $171627766113ddc2$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $171627766113ddc2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $171627766113ddc2$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $171627766113ddc2$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $171627766113ddc2$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $171627766113ddc2$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...updatesPerEntity[update.id]?.changes,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$171627766113ddc2$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $171627766113ddc2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: $171627766113ddc2$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $171627766113ddc2$var$createStateOperator(addOneMutably),
        addMany: $171627766113ddc2$var$createStateOperator(addManyMutably),
        setOne: $171627766113ddc2$var$createStateOperator(setOneMutably),
        setMany: $171627766113ddc2$var$createStateOperator(setManyMutably),
        setAll: $171627766113ddc2$var$createStateOperator(setAllMutably),
        updateOne: $171627766113ddc2$var$createStateOperator(updateOneMutably),
        updateMany: $171627766113ddc2$var$createStateOperator(updateManyMutably),
        upsertOne: $171627766113ddc2$var$createStateOperator(upsertOneMutably),
        upsertMany: $171627766113ddc2$var$createStateOperator(upsertManyMutably),
        removeOne: $171627766113ddc2$var$createStateOperator(removeOneMutably),
        removeMany: $171627766113ddc2$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $171627766113ddc2$var$findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function $171627766113ddc2$var$insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = $171627766113ddc2$var$findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function $171627766113ddc2$var$createSortedStateAdapter(selectId, comparer) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $171627766113ddc2$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = $171627766113ddc2$var$ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds ?? $171627766113ddc2$var$getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = $171627766113ddc2$var$selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = $171627766113ddc2$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = $171627766113ddc2$var$ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $171627766113ddc2$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = $171627766113ddc2$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = $171627766113ddc2$var$getCurrent(state.entities);
        const currentIds = $171627766113ddc2$var$getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) $171627766113ddc2$var$insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $171627766113ddc2$var$createStateOperator(addOneMutably),
        updateOne: $171627766113ddc2$var$createStateOperator(updateOneMutably),
        upsertOne: $171627766113ddc2$var$createStateOperator(upsertOneMutably),
        setOne: $171627766113ddc2$var$createStateOperator(setOneMutably),
        setMany: $171627766113ddc2$var$createStateOperator(setManyMutably),
        setAll: $171627766113ddc2$var$createStateOperator(setAllMutably),
        addMany: $171627766113ddc2$var$createStateOperator(addManyMutably),
        updateMany: $171627766113ddc2$var$createStateOperator(updateManyMutably),
        upsertMany: $171627766113ddc2$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $171627766113ddc2$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateAdapter = sortComparer ? $171627766113ddc2$var$createSortedStateAdapter(selectId, sortComparer) : $171627766113ddc2$var$createUnsortedStateAdapter(selectId);
    const stateFactory = $171627766113ddc2$var$createInitialStateFactory(stateAdapter);
    const selectorsFactory = $171627766113ddc2$var$createSelectorsFactory();
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $171627766113ddc2$var$task = "task";
var $171627766113ddc2$var$listener = "listener";
var $171627766113ddc2$var$completed = "completed";
var $171627766113ddc2$var$cancelled = "cancelled";
var $171627766113ddc2$var$taskCancelled = `task-${$171627766113ddc2$var$cancelled}`;
var $171627766113ddc2$var$taskCompleted = `task-${$171627766113ddc2$var$completed}`;
var $171627766113ddc2$var$listenerCancelled = `${$171627766113ddc2$var$listener}-${$171627766113ddc2$var$cancelled}`;
var $171627766113ddc2$var$listenerCompleted = `${$171627766113ddc2$var$listener}-${$171627766113ddc2$var$completed}`;
var $171627766113ddc2$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        this.message = `${$171627766113ddc2$var$task} ${$171627766113ddc2$var$cancelled} (reason: ${code})`;
    }
    name = "TaskAbortError";
    message;
};
// src/listenerMiddleware/utils.ts
var $171627766113ddc2$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError($171627766113ddc2$export$378fa86b259c0280(32));
};
var $171627766113ddc2$var$noop2 = ()=>{};
var $171627766113ddc2$var$catchRejection = (promise, onError = $171627766113ddc2$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $171627766113ddc2$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var $171627766113ddc2$var$validateActive = (signal)=>{
    if (signal.aborted) throw new $171627766113ddc2$export$cb1bdac908fed7f(signal.reason);
};
function $171627766113ddc2$var$raceWithSignal(signal, promise) {
    let cleanup = $171627766113ddc2$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $171627766113ddc2$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $171627766113ddc2$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $171627766113ddc2$var$noop2;
    });
}
var $171627766113ddc2$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $171627766113ddc2$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
var $171627766113ddc2$var$createPause = (signal)=>{
    return (promise)=>{
        return $171627766113ddc2$var$catchRejection($171627766113ddc2$var$raceWithSignal(signal, promise).then((output)=>{
            $171627766113ddc2$var$validateActive(signal);
            return output;
        }));
    };
};
var $171627766113ddc2$var$createDelay = (signal)=>{
    const pause = $171627766113ddc2$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $171627766113ddc2$var$assign } = Object;
var $171627766113ddc2$var$INTERNAL_NIL_TOKEN = {};
var $171627766113ddc2$var$alm = "listenerMiddleware";
var $171627766113ddc2$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$171627766113ddc2$var$addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $171627766113ddc2$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $171627766113ddc2$var$runTask(async ()=>{
            $171627766113ddc2$var$validateActive(parentAbortSignal);
            $171627766113ddc2$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $171627766113ddc2$var$createPause(childAbortController.signal),
                delay: $171627766113ddc2$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $171627766113ddc2$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort($171627766113ddc2$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result.catch($171627766113ddc2$var$noop2));
        return {
            result: $171627766113ddc2$var$createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort($171627766113ddc2$var$taskCancelled);
            }
        };
    };
};
var $171627766113ddc2$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $171627766113ddc2$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $171627766113ddc2$var$raceWithSignal(signal, Promise.race(promises));
            $171627766113ddc2$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$171627766113ddc2$var$catchRejection(take(predicate, timeout));
};
var $171627766113ddc2$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $171627766113ddc2$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($171627766113ddc2$export$378fa86b259c0280(21));
    $171627766113ddc2$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $171627766113ddc2$var$createListenerEntry = /* @__PURE__ */ $171627766113ddc2$var$assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $171627766113ddc2$var$getListenerEntryPropsFrom(options);
    const entry = {
        id: $171627766113ddc2$export$ac4959f4f1338dfc(),
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($171627766113ddc2$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$171627766113ddc2$var$createListenerEntry
});
var $171627766113ddc2$var$findListenerEntry = (listenerMap, options)=>{
    const { type: type, effect: effect, predicate: predicate } = $171627766113ddc2$var$getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var $171627766113ddc2$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort($171627766113ddc2$var$listenerCancelled);
    });
};
var $171627766113ddc2$var$createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())$171627766113ddc2$var$cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var $171627766113ddc2$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $171627766113ddc2$export$f03a6b845d3fb58b = /* @__PURE__ */ $171627766113ddc2$var$assign(/* @__PURE__ */ $171627766113ddc2$export$309c7a02b0b0bc62(`${$171627766113ddc2$var$alm}/add`), {
    withTypes: ()=>$171627766113ddc2$export$f03a6b845d3fb58b
});
var $171627766113ddc2$export$b1b8022855fb2b71 = /* @__PURE__ */ $171627766113ddc2$export$309c7a02b0b0bc62(`${$171627766113ddc2$var$alm}/removeAll`);
var $171627766113ddc2$export$b03e9483f936dccb = /* @__PURE__ */ $171627766113ddc2$var$assign(/* @__PURE__ */ $171627766113ddc2$export$309c7a02b0b0bc62(`${$171627766113ddc2$var$alm}/remove`), {
    withTypes: ()=>$171627766113ddc2$export$b03e9483f936dccb
});
var $171627766113ddc2$var$defaultErrorHandler = (...args)=>{
    console.error(`${$171627766113ddc2$var$alm}/error`, ...args);
};
var $171627766113ddc2$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        const count = executingListeners.get(entry) ?? 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        const count = executingListeners.get(entry) ?? 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra: extra, onError: onError = $171627766113ddc2$var$defaultErrorHandler } = middlewareOptions;
    $171627766113ddc2$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $171627766113ddc2$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        const entry = $171627766113ddc2$var$findListenerEntry(listenerMap, options) ?? $171627766113ddc2$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    $171627766113ddc2$var$assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = $171627766113ddc2$var$findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $171627766113ddc2$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    $171627766113ddc2$var$assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $171627766113ddc2$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $171627766113ddc2$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $171627766113ddc2$var$createDelay(internalTaskController.signal),
                pause: $171627766113ddc2$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $171627766113ddc2$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort($171627766113ddc2$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort($171627766113ddc2$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $171627766113ddc2$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $171627766113ddc2$export$cb1bdac908fed7f)) $171627766113ddc2$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort($171627766113ddc2$var$listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $171627766113ddc2$var$createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $hV595.isAction)(action)) return next(action);
                if ($171627766113ddc2$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($171627766113ddc2$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($171627766113ddc2$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $171627766113ddc2$var$INTERNAL_NIL_TOKEN) throw new Error($171627766113ddc2$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $171627766113ddc2$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $171627766113ddc2$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var $171627766113ddc2$var$createMiddlewareEntry = (middleware)=>({
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $171627766113ddc2$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
var $171627766113ddc2$export$4bb1606a79445586 = ()=>{
    const instanceId = $171627766113ddc2$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($171627766113ddc2$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            $171627766113ddc2$var$getOrInsertComputed(middlewareMap, middleware2, $171627766113ddc2$var$createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$171627766113ddc2$var$getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, $hV595.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = $171627766113ddc2$export$9dd1fb32974da385(withMiddleware, $171627766113ddc2$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $171627766113ddc2$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $171627766113ddc2$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$171627766113ddc2$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $171627766113ddc2$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $171627766113ddc2$var$isStateProxy = (value)=>!!value && !!value[$171627766113ddc2$var$ORIGINAL_STATE];
var $171627766113ddc2$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $171627766113ddc2$var$createStateProxy = (state, reducerMap, initialStateCache)=>$171627766113ddc2$var$getOrInsertComputed($171627766113ddc2$var$stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === $171627766113ddc2$var$ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: $171627766113ddc2$export$ac4959f4f1338dfc()
                        });
                        if (typeof reducerResult === "undefined") throw new Error($171627766113ddc2$export$378fa86b259c0280(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var $171627766113ddc2$var$original = (state)=>{
    if (!$171627766113ddc2$var$isStateProxy(state)) throw new Error($171627766113ddc2$export$378fa86b259c0280(25));
    return state[$171627766113ddc2$var$ORIGINAL_STATE];
};
var $171627766113ddc2$var$emptyObject = {};
var $171627766113ddc2$var$noopReducer = (state = $171627766113ddc2$var$emptyObject)=>state;
function $171627766113ddc2$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($171627766113ddc2$var$getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, $hV595.combineReducers)(reducerMap) : $171627766113ddc2$var$noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($171627766113ddc2$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original: $171627766113ddc2$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $171627766113ddc2$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

});
parcelRegister("hV595", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", () => $1c14903861290e49$export$53b83ca8eaab0383);
$parcel$export(module.exports, "createStore", () => $1c14903861290e49$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $1c14903861290e49$export$66e4520cdb265d18);
$parcel$export(module.exports, "compose", () => $1c14903861290e49$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $1c14903861290e49$export$9ff26e0402cc7b7);
$parcel$export(module.exports, "isAction", () => $1c14903861290e49$export$b956e38827fca970);
// src/utils/formatProdErrorMessage.ts
function $1c14903861290e49$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $1c14903861290e49$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $1c14903861290e49$var$symbol_observable_default = $1c14903861290e49$var$$$observable;
// src/utils/actionTypes.ts
var $1c14903861290e49$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $1c14903861290e49$var$ActionTypes = {
    INIT: `@@redux/INIT${$1c14903861290e49$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$1c14903861290e49$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$1c14903861290e49$var$randomString()}`
};
var $1c14903861290e49$export$4219e499db7ca678 = $1c14903861290e49$var$ActionTypes;
// src/utils/isPlainObject.ts
function $1c14903861290e49$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $1c14903861290e49$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($1c14903861290e49$var$isDate(val)) return "date";
    if ($1c14903861290e49$var$isError(val)) return "error";
    const constructorName = $1c14903861290e49$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $1c14903861290e49$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $1c14903861290e49$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $1c14903861290e49$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $1c14903861290e49$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $1c14903861290e49$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($1c14903861290e49$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($1c14903861290e49$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($1c14903861290e49$var$formatProdErrorMessage(1));
        return enhancer($1c14903861290e49$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($1c14903861290e49$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($1c14903861290e49$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($1c14903861290e49$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($1c14903861290e49$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$1c14903861290e49$export$53b83ca8eaab0383(action)) throw new Error($1c14903861290e49$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($1c14903861290e49$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($1c14903861290e49$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($1c14903861290e49$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($1c14903861290e49$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $1c14903861290e49$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($1c14903861290e49$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$1c14903861290e49$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $1c14903861290e49$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$1c14903861290e49$var$symbol_observable_default]: observable
    };
    return store;
}
function $1c14903861290e49$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $1c14903861290e49$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $1c14903861290e49$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $1c14903861290e49$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $1c14903861290e49$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$1c14903861290e49$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$1c14903861290e49$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $1c14903861290e49$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $1c14903861290e49$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $1c14903861290e49$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($1c14903861290e49$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $1c14903861290e49$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($1c14903861290e49$var$formatProdErrorMessage(13));
    });
}
function $1c14903861290e49$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $1c14903861290e49$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($1c14903861290e49$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $1c14903861290e49$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $1c14903861290e49$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $1c14903861290e49$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($1c14903861290e49$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $1c14903861290e49$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $1c14903861290e49$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $1c14903861290e49$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($1c14903861290e49$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $1c14903861290e49$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $1c14903861290e49$export$b956e38827fca970(action) {
    return $1c14903861290e49$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}

});

parcelRegister("bXF6r", function(module, exports) {

$parcel$export(module.exports, "isDraft", () => $76b79a89ba1ca1d5$export$541ac630993a4c84);
$parcel$export(module.exports, "isDraftable", () => $76b79a89ba1ca1d5$export$16e3aed3edb85946);
$parcel$export(module.exports, "current", () => $76b79a89ba1ca1d5$export$97aac956da55dae9);
$parcel$export(module.exports, "produce", () => $76b79a89ba1ca1d5$export$b46cabe22e78bc00);
// src/utils/env.ts
var $76b79a89ba1ca1d5$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $76b79a89ba1ca1d5$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $76b79a89ba1ca1d5$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $76b79a89ba1ca1d5$var$errors = [];
function $76b79a89ba1ca1d5$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $76b79a89ba1ca1d5$var$O = Object;
var $76b79a89ba1ca1d5$var$getPrototypeOf = $76b79a89ba1ca1d5$var$O.getPrototypeOf;
var $76b79a89ba1ca1d5$var$CONSTRUCTOR = "constructor";
var $76b79a89ba1ca1d5$var$PROTOTYPE = "prototype";
var $76b79a89ba1ca1d5$var$CONFIGURABLE = "configurable";
var $76b79a89ba1ca1d5$var$ENUMERABLE = "enumerable";
var $76b79a89ba1ca1d5$var$WRITABLE = "writable";
var $76b79a89ba1ca1d5$var$VALUE = "value";
var $76b79a89ba1ca1d5$export$541ac630993a4c84 = (value)=>!!value && !!value[$76b79a89ba1ca1d5$var$DRAFT_STATE];
function $76b79a89ba1ca1d5$export$16e3aed3edb85946(value) {
    if (!value) return false;
    return $76b79a89ba1ca1d5$var$isPlainObject(value) || $76b79a89ba1ca1d5$var$isArray(value) || !!value[$76b79a89ba1ca1d5$export$6ee2082928bcb0ee] || !!value[$76b79a89ba1ca1d5$var$CONSTRUCTOR]?.[$76b79a89ba1ca1d5$export$6ee2082928bcb0ee] || $76b79a89ba1ca1d5$var$isMap(value) || $76b79a89ba1ca1d5$var$isSet(value);
}
var $76b79a89ba1ca1d5$var$objectCtorString = $76b79a89ba1ca1d5$var$O[$76b79a89ba1ca1d5$var$PROTOTYPE][$76b79a89ba1ca1d5$var$CONSTRUCTOR].toString();
var $76b79a89ba1ca1d5$var$cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function $76b79a89ba1ca1d5$var$isPlainObject(value) {
    if (!value || !$76b79a89ba1ca1d5$var$isObjectish(value)) return false;
    const proto = $76b79a89ba1ca1d5$var$getPrototypeOf(value);
    if (proto === null || proto === $76b79a89ba1ca1d5$var$O[$76b79a89ba1ca1d5$var$PROTOTYPE]) return true;
    const Ctor = $76b79a89ba1ca1d5$var$O.hasOwnProperty.call(proto, $76b79a89ba1ca1d5$var$CONSTRUCTOR) && proto[$76b79a89ba1ca1d5$var$CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!$76b79a89ba1ca1d5$var$isFunction(Ctor)) return false;
    let ctorString = $76b79a89ba1ca1d5$var$cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        $76b79a89ba1ca1d5$var$cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === $76b79a89ba1ca1d5$var$objectCtorString;
}
function $76b79a89ba1ca1d5$export$22e8af3f75a010e3(value) {
    if (!$76b79a89ba1ca1d5$export$541ac630993a4c84(value)) $76b79a89ba1ca1d5$var$die(15, value);
    return value[$76b79a89ba1ca1d5$var$DRAFT_STATE].base_;
}
function $76b79a89ba1ca1d5$var$each(obj, iter, strict = true) {
    if ($76b79a89ba1ca1d5$var$getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : $76b79a89ba1ca1d5$var$O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $76b79a89ba1ca1d5$var$getArchtype(thing) {
    const state = thing[$76b79a89ba1ca1d5$var$DRAFT_STATE];
    return state ? state.type_ : $76b79a89ba1ca1d5$var$isArray(thing) ? 1 /* Array */  : $76b79a89ba1ca1d5$var$isMap(thing) ? 2 /* Map */  : $76b79a89ba1ca1d5$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var $76b79a89ba1ca1d5$var$has = (thing, prop, type = $76b79a89ba1ca1d5$var$getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : $76b79a89ba1ca1d5$var$O[$76b79a89ba1ca1d5$var$PROTOTYPE].hasOwnProperty.call(thing, prop);
var $76b79a89ba1ca1d5$var$get = (thing, prop, type = $76b79a89ba1ca1d5$var$getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var $76b79a89ba1ca1d5$var$set = (thing, propOrOldValue, value, type = $76b79a89ba1ca1d5$var$getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function $76b79a89ba1ca1d5$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var $76b79a89ba1ca1d5$var$isArray = Array.isArray;
var $76b79a89ba1ca1d5$var$isMap = (target)=>target instanceof Map;
var $76b79a89ba1ca1d5$var$isSet = (target)=>target instanceof Set;
var $76b79a89ba1ca1d5$var$isObjectish = (target)=>typeof target === "object";
var $76b79a89ba1ca1d5$var$isFunction = (target)=>typeof target === "function";
var $76b79a89ba1ca1d5$var$isBoolean = (target)=>typeof target === "boolean";
function $76b79a89ba1ca1d5$var$isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var $76b79a89ba1ca1d5$var$getProxyDraft = (value)=>{
    if (!$76b79a89ba1ca1d5$var$isObjectish(value)) return null;
    return value?.[$76b79a89ba1ca1d5$var$DRAFT_STATE];
};
var $76b79a89ba1ca1d5$var$latest = (state)=>state.copy_ || state.base_;
var $76b79a89ba1ca1d5$var$getValue = (value)=>{
    const proxyDraft = $76b79a89ba1ca1d5$var$getProxyDraft(value);
    return proxyDraft ? proxyDraft.copy_ ?? proxyDraft.base_ : value;
};
var $76b79a89ba1ca1d5$var$getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function $76b79a89ba1ca1d5$var$shallowCopy(base, strict) {
    if ($76b79a89ba1ca1d5$var$isMap(base)) return new Map(base);
    if ($76b79a89ba1ca1d5$var$isSet(base)) return new Set(base);
    if ($76b79a89ba1ca1d5$var$isArray(base)) return Array[$76b79a89ba1ca1d5$var$PROTOTYPE].slice.call(base);
    const isPlain = $76b79a89ba1ca1d5$var$isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = $76b79a89ba1ca1d5$var$O.getOwnPropertyDescriptors(base);
        delete descriptors[$76b79a89ba1ca1d5$var$DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[$76b79a89ba1ca1d5$var$WRITABLE] === false) {
                desc[$76b79a89ba1ca1d5$var$WRITABLE] = true;
                desc[$76b79a89ba1ca1d5$var$CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [$76b79a89ba1ca1d5$var$CONFIGURABLE]: true,
                [$76b79a89ba1ca1d5$var$WRITABLE]: true,
                // could live with !!desc.set as well here...
                [$76b79a89ba1ca1d5$var$ENUMERABLE]: desc[$76b79a89ba1ca1d5$var$ENUMERABLE],
                [$76b79a89ba1ca1d5$var$VALUE]: base[key]
            };
        }
        return $76b79a89ba1ca1d5$var$O.create($76b79a89ba1ca1d5$var$getPrototypeOf(base), descriptors);
    } else {
        const proto = $76b79a89ba1ca1d5$var$getPrototypeOf(base);
        if (proto !== null && isPlain) return {
            ...base
        };
        const obj = $76b79a89ba1ca1d5$var$O.create(proto);
        return $76b79a89ba1ca1d5$var$O.assign(obj, base);
    }
}
function $76b79a89ba1ca1d5$export$792f3d81ea979f55(obj, deep = false) {
    if ($76b79a89ba1ca1d5$var$isFrozen(obj) || $76b79a89ba1ca1d5$export$541ac630993a4c84(obj) || !$76b79a89ba1ca1d5$export$16e3aed3edb85946(obj)) return obj;
    if ($76b79a89ba1ca1d5$var$getArchtype(obj) > 1) $76b79a89ba1ca1d5$var$O.defineProperties(obj, {
        set: $76b79a89ba1ca1d5$var$dontMutateMethodOverride,
        add: $76b79a89ba1ca1d5$var$dontMutateMethodOverride,
        clear: $76b79a89ba1ca1d5$var$dontMutateMethodOverride,
        delete: $76b79a89ba1ca1d5$var$dontMutateMethodOverride
    });
    $76b79a89ba1ca1d5$var$O.freeze(obj);
    if (deep) $76b79a89ba1ca1d5$var$each(obj, (_key, value)=>{
        $76b79a89ba1ca1d5$export$792f3d81ea979f55(value, true);
    }, false);
    return obj;
}
function $76b79a89ba1ca1d5$var$dontMutateFrozenCollections() {
    $76b79a89ba1ca1d5$var$die(2);
}
var $76b79a89ba1ca1d5$var$dontMutateMethodOverride = {
    [$76b79a89ba1ca1d5$var$VALUE]: $76b79a89ba1ca1d5$var$dontMutateFrozenCollections
};
function $76b79a89ba1ca1d5$var$isFrozen(obj) {
    if (obj === null || !$76b79a89ba1ca1d5$var$isObjectish(obj)) return true;
    return $76b79a89ba1ca1d5$var$O.isFrozen(obj);
}
// src/utils/plugins.ts
var $76b79a89ba1ca1d5$var$PluginMapSet = "MapSet";
var $76b79a89ba1ca1d5$var$PluginPatches = "Patches";
var $76b79a89ba1ca1d5$var$PluginArrayMethods = "ArrayMethods";
var $76b79a89ba1ca1d5$var$plugins = {};
function $76b79a89ba1ca1d5$var$getPlugin(pluginKey) {
    const plugin = $76b79a89ba1ca1d5$var$plugins[pluginKey];
    if (!plugin) $76b79a89ba1ca1d5$var$die(0, pluginKey);
    return plugin;
}
var $76b79a89ba1ca1d5$var$isPluginLoaded = (pluginKey)=>!!$76b79a89ba1ca1d5$var$plugins[pluginKey];
function $76b79a89ba1ca1d5$var$loadPlugin(pluginKey, implementation) {
    if (!$76b79a89ba1ca1d5$var$plugins[pluginKey]) $76b79a89ba1ca1d5$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $76b79a89ba1ca1d5$var$currentScope;
var $76b79a89ba1ca1d5$var$getCurrentScope = ()=>$76b79a89ba1ca1d5$var$currentScope;
var $76b79a89ba1ca1d5$var$createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: $76b79a89ba1ca1d5$var$isPluginLoaded($76b79a89ba1ca1d5$var$PluginMapSet) ? $76b79a89ba1ca1d5$var$getPlugin($76b79a89ba1ca1d5$var$PluginMapSet) : void 0,
        arrayMethodsPlugin_: $76b79a89ba1ca1d5$var$isPluginLoaded($76b79a89ba1ca1d5$var$PluginArrayMethods) ? $76b79a89ba1ca1d5$var$getPlugin($76b79a89ba1ca1d5$var$PluginArrayMethods) : void 0
    });
function $76b79a89ba1ca1d5$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = $76b79a89ba1ca1d5$var$getPlugin($76b79a89ba1ca1d5$var$PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $76b79a89ba1ca1d5$var$revokeScope(scope) {
    $76b79a89ba1ca1d5$var$leaveScope(scope);
    scope.drafts_.forEach($76b79a89ba1ca1d5$var$revokeDraft);
    scope.drafts_ = null;
}
function $76b79a89ba1ca1d5$var$leaveScope(scope) {
    if (scope === $76b79a89ba1ca1d5$var$currentScope) $76b79a89ba1ca1d5$var$currentScope = scope.parent_;
}
var $76b79a89ba1ca1d5$var$enterScope = (immer2)=>$76b79a89ba1ca1d5$var$currentScope = $76b79a89ba1ca1d5$var$createScope($76b79a89ba1ca1d5$var$currentScope, immer2);
function $76b79a89ba1ca1d5$var$revokeDraft(draft) {
    const state = draft[$76b79a89ba1ca1d5$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $76b79a89ba1ca1d5$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$76b79a89ba1ca1d5$var$DRAFT_STATE].modified_) {
            $76b79a89ba1ca1d5$var$revokeScope(scope);
            $76b79a89ba1ca1d5$var$die(4);
        }
        if ($76b79a89ba1ca1d5$export$16e3aed3edb85946(result)) result = $76b79a89ba1ca1d5$var$finalize(scope, result);
        const { patchPlugin_: patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[$76b79a89ba1ca1d5$var$DRAFT_STATE].base_, result, scope);
    } else result = $76b79a89ba1ca1d5$var$finalize(scope, baseDraft);
    $76b79a89ba1ca1d5$var$maybeFreeze(scope, result, true);
    $76b79a89ba1ca1d5$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $76b79a89ba1ca1d5$export$45b790e32b2810ee ? result : void 0;
}
function $76b79a89ba1ca1d5$var$finalize(rootScope, value) {
    if ($76b79a89ba1ca1d5$var$isFrozen(value)) return value;
    const state = value[$76b79a89ba1ca1d5$var$DRAFT_STATE];
    if (!state) {
        const finalValue = $76b79a89ba1ca1d5$var$handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!$76b79a89ba1ca1d5$var$isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_: callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        $76b79a89ba1ca1d5$var$generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function $76b79a89ba1ca1d5$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $76b79a89ba1ca1d5$export$792f3d81ea979f55(value, deep);
}
function $76b79a89ba1ca1d5$var$markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var $76b79a89ba1ca1d5$var$isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var $76b79a89ba1ca1d5$var$EMPTY_LOCATIONS_RESULT = [];
function $76b79a89ba1ca1d5$var$updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    const parentCopy = $76b79a89ba1ca1d5$var$latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = $76b79a89ba1ca1d5$var$get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            $76b79a89ba1ca1d5$var$set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        $76b79a89ba1ca1d5$var$each(parentCopy, (key, value)=>{
            if ($76b79a89ba1ca1d5$export$541ac630993a4c84(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = parent.draftLocations_.get(draftValue) ?? $76b79a89ba1ca1d5$var$EMPTY_LOCATIONS_RESULT;
    for (const location of locations)$76b79a89ba1ca1d5$var$set(parentCopy, location, finalizedValue, parentType);
}
function $76b79a89ba1ca1d5$var$registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        const state = child;
        if (!state || !$76b79a89ba1ca1d5$var$isSameScope(state, rootScope)) return;
        rootScope.mapSetPlugin_?.fixSetContents(state);
        const finalizedValue = $76b79a89ba1ca1d5$var$getFinalValue(state);
        $76b79a89ba1ca1d5$var$updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
        $76b79a89ba1ca1d5$var$generatePatchesAndFinalize(state, rootScope);
    });
}
function $76b79a89ba1ca1d5$var$generatePatchesAndFinalize(state, rootScope) {
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || (state.assigned_?.size ?? 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_: patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        $76b79a89ba1ca1d5$var$markStateFinalized(state);
    }
}
function $76b79a89ba1ca1d5$var$handleCrossReference(target, key, value) {
    const { scope_: scope_ } = target;
    if ($76b79a89ba1ca1d5$export$541ac630993a4c84(value)) {
        const state = value[$76b79a89ba1ca1d5$var$DRAFT_STATE];
        if ($76b79a89ba1ca1d5$var$isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            $76b79a89ba1ca1d5$var$prepareCopy(target);
            const finalizedValue = $76b79a89ba1ca1d5$var$getFinalValue(state);
            $76b79a89ba1ca1d5$var$updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if ($76b79a89ba1ca1d5$export$16e3aed3edb85946(value)) target.callbacks_.push(function nestedDraftCleanup() {
        const targetCopy = $76b79a89ba1ca1d5$var$latest(target);
        if (target.type_ === 3 /* Set */ ) {
            if (targetCopy.has(value)) $76b79a89ba1ca1d5$var$handleValue(value, scope_.handledSet_, scope_);
        } else {
            if ($76b79a89ba1ca1d5$var$get(targetCopy, key, target.type_) === value) {
                if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) $76b79a89ba1ca1d5$var$handleValue($76b79a89ba1ca1d5$var$get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
            }
        }
    });
}
function $76b79a89ba1ca1d5$var$handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if ($76b79a89ba1ca1d5$export$541ac630993a4c84(target) || handledSet.has(target) || !$76b79a89ba1ca1d5$export$16e3aed3edb85946(target) || $76b79a89ba1ca1d5$var$isFrozen(target)) return target;
    handledSet.add(target);
    $76b79a89ba1ca1d5$var$each(target, (key, value)=>{
        if ($76b79a89ba1ca1d5$export$541ac630993a4c84(value)) {
            const state = value[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            if ($76b79a89ba1ca1d5$var$isSameScope(state, rootScope)) {
                const updatedValue = $76b79a89ba1ca1d5$var$getFinalValue(state);
                $76b79a89ba1ca1d5$var$set(target, key, updatedValue, target.type_);
                $76b79a89ba1ca1d5$var$markStateFinalized(state);
            }
        } else if ($76b79a89ba1ca1d5$export$16e3aed3edb85946(value)) $76b79a89ba1ca1d5$var$handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function $76b79a89ba1ca1d5$var$createProxyProxy(base, parent) {
    const baseIsArray = $76b79a89ba1ca1d5$var$isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $76b79a89ba1ca1d5$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = $76b79a89ba1ca1d5$var$objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = $76b79a89ba1ca1d5$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var $76b79a89ba1ca1d5$var$objectTraps = {
    get (state, prop) {
        if (prop === $76b79a89ba1ca1d5$var$DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin?.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = $76b79a89ba1ca1d5$var$latest(state);
        if (!$76b79a89ba1ca1d5$var$has(source, prop, state.type_)) return $76b79a89ba1ca1d5$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$76b79a89ba1ca1d5$export$16e3aed3edb85946(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && arrayPlugin?.isMutatingArrayMethod(state.operationMethod) && $76b79a89ba1ca1d5$var$isArrayIndex(prop)) return value;
        if (value === $76b79a89ba1ca1d5$var$peek(state.base_, prop)) {
            $76b79a89ba1ca1d5$var$prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = $76b79a89ba1ca1d5$var$createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in $76b79a89ba1ca1d5$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($76b79a89ba1ca1d5$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $76b79a89ba1ca1d5$var$getDescriptorFromProto($76b79a89ba1ca1d5$var$latest(state), prop);
        if (desc?.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $76b79a89ba1ca1d5$var$peek($76b79a89ba1ca1d5$var$latest(state), prop);
            const currentState = current2?.[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if ($76b79a89ba1ca1d5$var$is(value, current2) && (value !== void 0 || $76b79a89ba1ca1d5$var$has(state.base_, prop, state.type_))) return true;
            $76b79a89ba1ca1d5$var$prepareCopy(state);
            $76b79a89ba1ca1d5$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        $76b79a89ba1ca1d5$var$handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        $76b79a89ba1ca1d5$var$prepareCopy(state);
        if ($76b79a89ba1ca1d5$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            $76b79a89ba1ca1d5$var$markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $76b79a89ba1ca1d5$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [$76b79a89ba1ca1d5$var$WRITABLE]: true,
            [$76b79a89ba1ca1d5$var$CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [$76b79a89ba1ca1d5$var$ENUMERABLE]: desc[$76b79a89ba1ca1d5$var$ENUMERABLE],
            [$76b79a89ba1ca1d5$var$VALUE]: owner[prop]
        };
    },
    defineProperty () {
        $76b79a89ba1ca1d5$var$die(11);
    },
    getPrototypeOf (state) {
        return $76b79a89ba1ca1d5$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $76b79a89ba1ca1d5$var$die(12);
    }
};
var $76b79a89ba1ca1d5$var$arrayTraps = {};
for(let key in $76b79a89ba1ca1d5$var$objectTraps){
    let fn = $76b79a89ba1ca1d5$var$objectTraps[key];
    $76b79a89ba1ca1d5$var$arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
}
$76b79a89ba1ca1d5$var$arrayTraps.deleteProperty = function(state, prop) {
    return $76b79a89ba1ca1d5$var$arrayTraps.set.call(this, state, prop, void 0);
};
$76b79a89ba1ca1d5$var$arrayTraps.set = function(state, prop, value) {
    return $76b79a89ba1ca1d5$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $76b79a89ba1ca1d5$var$peek(draft, prop) {
    const state = draft[$76b79a89ba1ca1d5$var$DRAFT_STATE];
    const source = state ? $76b79a89ba1ca1d5$var$latest(state) : draft;
    return source[prop];
}
function $76b79a89ba1ca1d5$var$readPropFromProto(state, source, prop) {
    const desc = $76b79a89ba1ca1d5$var$getDescriptorFromProto(source, prop);
    return desc ? $76b79a89ba1ca1d5$var$VALUE in desc ? desc[$76b79a89ba1ca1d5$var$VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_) : void 0;
}
function $76b79a89ba1ca1d5$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $76b79a89ba1ca1d5$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $76b79a89ba1ca1d5$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $76b79a89ba1ca1d5$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $76b79a89ba1ca1d5$var$markChanged(state.parent_);
    }
}
function $76b79a89ba1ca1d5$var$prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = $76b79a89ba1ca1d5$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var $76b79a89ba1ca1d5$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if ($76b79a89ba1ca1d5$var$isFunction(base) && !$76b79a89ba1ca1d5$var$isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!$76b79a89ba1ca1d5$var$isFunction(recipe)) $76b79a89ba1ca1d5$var$die(6);
            if (patchListener !== void 0 && !$76b79a89ba1ca1d5$var$isFunction(patchListener)) $76b79a89ba1ca1d5$var$die(7);
            let result;
            if ($76b79a89ba1ca1d5$export$16e3aed3edb85946(base)) {
                const scope = $76b79a89ba1ca1d5$var$enterScope(this);
                const proxy = $76b79a89ba1ca1d5$var$createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $76b79a89ba1ca1d5$var$revokeScope(scope);
                    else $76b79a89ba1ca1d5$var$leaveScope(scope);
                }
                $76b79a89ba1ca1d5$var$usePatchesInScope(scope, patchListener);
                return $76b79a89ba1ca1d5$var$processResult(result, scope);
            } else if (!base || !$76b79a89ba1ca1d5$var$isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $76b79a89ba1ca1d5$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $76b79a89ba1ca1d5$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $76b79a89ba1ca1d5$var$getPlugin($76b79a89ba1ca1d5$var$PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else $76b79a89ba1ca1d5$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if ($76b79a89ba1ca1d5$var$isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if ($76b79a89ba1ca1d5$var$isBoolean(config?.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if ($76b79a89ba1ca1d5$var$isBoolean(config?.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if ($76b79a89ba1ca1d5$var$isBoolean(config?.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!$76b79a89ba1ca1d5$export$16e3aed3edb85946(base)) $76b79a89ba1ca1d5$var$die(8);
        if ($76b79a89ba1ca1d5$export$541ac630993a4c84(base)) base = $76b79a89ba1ca1d5$export$97aac956da55dae9(base);
        const scope = $76b79a89ba1ca1d5$var$enterScope(this);
        const proxy = $76b79a89ba1ca1d5$var$createProxy(scope, base, void 0);
        proxy[$76b79a89ba1ca1d5$var$DRAFT_STATE].isManual_ = true;
        $76b79a89ba1ca1d5$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$76b79a89ba1ca1d5$var$DRAFT_STATE];
        if (!state || !state.isManual_) $76b79a89ba1ca1d5$var$die(9);
        const { scope_: scope } = state;
        $76b79a89ba1ca1d5$var$usePatchesInScope(scope, patchListener);
        return $76b79a89ba1ca1d5$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $76b79a89ba1ca1d5$var$getPlugin($76b79a89ba1ca1d5$var$PluginPatches).applyPatches_;
        if ($76b79a89ba1ca1d5$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $76b79a89ba1ca1d5$var$createProxy(rootScope, value, parent, key) {
    const [draft, state] = $76b79a89ba1ca1d5$var$isMap(value) ? $76b79a89ba1ca1d5$var$getPlugin($76b79a89ba1ca1d5$var$PluginMapSet).proxyMap_(value, parent) : $76b79a89ba1ca1d5$var$isSet(value) ? $76b79a89ba1ca1d5$var$getPlugin($76b79a89ba1ca1d5$var$PluginMapSet).proxySet_(value, parent) : $76b79a89ba1ca1d5$var$createProxyProxy(value, parent);
    const scope = parent?.scope_ ?? $76b79a89ba1ca1d5$var$getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = parent?.callbacks_ ?? [];
    state.key_ = key;
    if (parent && key !== void 0) $76b79a89ba1ca1d5$var$registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        rootScope2.mapSetPlugin_?.fixSetContents(state);
        const { patchPlugin_: patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function $76b79a89ba1ca1d5$export$97aac956da55dae9(value) {
    if (!$76b79a89ba1ca1d5$export$541ac630993a4c84(value)) $76b79a89ba1ca1d5$var$die(10, value);
    return $76b79a89ba1ca1d5$var$currentImpl(value);
}
function $76b79a89ba1ca1d5$var$currentImpl(value) {
    if (!$76b79a89ba1ca1d5$export$16e3aed3edb85946(value) || $76b79a89ba1ca1d5$var$isFrozen(value)) return value;
    const state = value[$76b79a89ba1ca1d5$var$DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $76b79a89ba1ca1d5$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = $76b79a89ba1ca1d5$var$shallowCopy(value, true);
    $76b79a89ba1ca1d5$var$each(copy, (key, childValue)=>{
        $76b79a89ba1ca1d5$var$set(copy, key, $76b79a89ba1ca1d5$var$currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $76b79a89ba1ca1d5$export$d3a6659991a0696c() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        if (state.key_ !== void 0) {
            const parentCopy = state.parent_.copy_ ?? state.parent_.base_;
            const proxyDraft = $76b79a89ba1ca1d5$var$getProxyDraft($76b79a89ba1ca1d5$var$get(parentCopy, state.key_));
            const valueAtKey = $76b79a89ba1ca1d5$var$get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || $76b79a89ba1ca1d5$var$has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = $76b79a89ba1ca1d5$var$get(current2, key);
            if (!$76b79a89ba1ca1d5$var$isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || assigned_?.get(i.toString());
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem?.[$76b79a89ba1ca1d5$var$DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path: path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path: path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_, type_: type_ } = state;
        $76b79a89ba1ca1d5$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $76b79a89ba1ca1d5$var$get(base_, key, type_);
            const value = $76b79a89ba1ca1d5$var$get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : $76b79a89ba1ca1d5$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_: patches_, inversePatches_: inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === $76b79a89ba1ca1d5$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $76b79a89ba1ca1d5$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === $76b79a89ba1ca1d5$var$CONSTRUCTOR)) $76b79a89ba1ca1d5$var$die(errorOffset + 3);
                if ($76b79a89ba1ca1d5$var$isFunction(base) && p === $76b79a89ba1ca1d5$var$PROTOTYPE) $76b79a89ba1ca1d5$var$die(errorOffset + 3);
                base = $76b79a89ba1ca1d5$var$get(base, p);
                if (!$76b79a89ba1ca1d5$var$isObjectish(base)) $76b79a89ba1ca1d5$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $76b79a89ba1ca1d5$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $76b79a89ba1ca1d5$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $76b79a89ba1ca1d5$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$76b79a89ba1ca1d5$export$16e3aed3edb85946(obj)) return obj;
        if ($76b79a89ba1ca1d5$var$isArray(obj)) return obj.map(deepClonePatchValue);
        if ($76b79a89ba1ca1d5$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($76b79a89ba1ca1d5$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($76b79a89ba1ca1d5$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($76b79a89ba1ca1d5$var$has(obj, $76b79a89ba1ca1d5$export$6ee2082928bcb0ee)) cloned[$76b79a89ba1ca1d5$export$6ee2082928bcb0ee] = obj[$76b79a89ba1ca1d5$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($76b79a89ba1ca1d5$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $76b79a89ba1ca1d5$var$loadPlugin($76b79a89ba1ca1d5$var$PluginPatches, {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_,
        getPath: getPath
    });
}
// src/plugins/mapset.ts
function $76b79a89ba1ca1d5$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$76b79a89ba1ca1d5$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $76b79a89ba1ca1d5$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return $76b79a89ba1ca1d5$var$latest(this[$76b79a89ba1ca1d5$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $76b79a89ba1ca1d5$var$latest(this[$76b79a89ba1ca1d5$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$76b79a89ba1ca1d5$var$latest(state).has(key) || $76b79a89ba1ca1d5$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $76b79a89ba1ca1d5$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
                $76b79a89ba1ca1d5$var$handleCrossReference(state, key, value);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $76b79a89ba1ca1d5$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($76b79a89ba1ca1d5$var$latest(state).size) {
                prepareMapCopy(state);
                $76b79a89ba1ca1d5$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $76b79a89ba1ca1d5$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            $76b79a89ba1ca1d5$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $76b79a89ba1ca1d5$var$latest(state).get(key);
            if (state.finalized_ || !$76b79a89ba1ca1d5$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $76b79a89ba1ca1d5$var$createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $76b79a89ba1ca1d5$var$latest(this[$76b79a89ba1ca1d5$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($76b79a89ba1ca1d5$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[$76b79a89ba1ca1d5$var$DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$76b79a89ba1ca1d5$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $76b79a89ba1ca1d5$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return $76b79a89ba1ca1d5$var$latest(this[$76b79a89ba1ca1d5$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $76b79a89ba1ca1d5$var$markChanged(state);
                state.copy_.add(value);
                $76b79a89ba1ca1d5$var$handleCrossReference(state, value, value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $76b79a89ba1ca1d5$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($76b79a89ba1ca1d5$var$latest(state).size) {
                prepareSetCopy(state);
                $76b79a89ba1ca1d5$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$76b79a89ba1ca1d5$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($76b79a89ba1ca1d5$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[$76b79a89ba1ca1d5$var$DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($76b79a89ba1ca1d5$export$16e3aed3edb85946(value)) {
                    const draft = $76b79a89ba1ca1d5$var$createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $76b79a89ba1ca1d5$var$die(3, JSON.stringify($76b79a89ba1ca1d5$var$latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add($76b79a89ba1ca1d5$var$getValue(value));
            });
        }
    }
    $76b79a89ba1ca1d5$var$loadPlugin($76b79a89ba1ca1d5$var$PluginMapSet, {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_,
        fixSetContents: fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function $76b79a89ba1ca1d5$export$5ecc5ed53f504cc5() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        $76b79a89ba1ca1d5$var$prepareCopy(state);
        const result = operation();
        $76b79a89ba1ca1d5$var$markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleInsertedValues(state, startIndex, values) {
        for(let i = 0; i < values.length; i++){
            const index = startIndex + i;
            state.assigned_.set(index, true);
            $76b79a89ba1ca1d5$var$handleCrossReference(state, index, values[i]);
        }
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const lengthBefore = state.copy_.length;
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            if (method === "push" && args.length > 0) handleInsertedValues(state, lengthBefore, args);
            else if (method === "unshift" && args.length > 0) handleInsertedValues(state, 0, args);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        if (args.length > 2) {
                            const startIndex = normalizeSliceIndex(args[0] ?? 0, state.copy_.length);
                            handleInsertedValues(state, startIndex, args.slice(2));
                        }
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        const source = $76b79a89ba1ca1d5$var$latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = args[0] ?? 0;
            const rawEnd = args[1] ?? source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    $76b79a89ba1ca1d5$var$loadPlugin($76b79a89ba1ca1d5$var$PluginArrayMethods, {
        createMethodInterceptor: createMethodInterceptor,
        isArrayOperationMethod: isArrayOperationMethod,
        isMutatingArrayMethod: isMutatingArrayMethod
    });
}
// src/immer.ts
var $76b79a89ba1ca1d5$var$immer = new $76b79a89ba1ca1d5$export$aaadc6ff0f822719();
var $76b79a89ba1ca1d5$export$b46cabe22e78bc00 = $76b79a89ba1ca1d5$var$immer.produce;
var $76b79a89ba1ca1d5$export$4da66d41c9492c78 = /* @__PURE__ */ $76b79a89ba1ca1d5$var$immer.produceWithPatches.bind($76b79a89ba1ca1d5$var$immer);
var $76b79a89ba1ca1d5$export$573f26f60825c493 = /* @__PURE__ */ $76b79a89ba1ca1d5$var$immer.setAutoFreeze.bind($76b79a89ba1ca1d5$var$immer);
var $76b79a89ba1ca1d5$export$333ce65961cbe047 = /* @__PURE__ */ $76b79a89ba1ca1d5$var$immer.setUseStrictShallowCopy.bind($76b79a89ba1ca1d5$var$immer);
var $76b79a89ba1ca1d5$export$1045b3be3904c489 = /* @__PURE__ */ $76b79a89ba1ca1d5$var$immer.setUseStrictIteration.bind($76b79a89ba1ca1d5$var$immer);
var $76b79a89ba1ca1d5$export$a8b8e03e6bbe5473 = /* @__PURE__ */ $76b79a89ba1ca1d5$var$immer.applyPatches.bind($76b79a89ba1ca1d5$var$immer);
var $76b79a89ba1ca1d5$export$3c3214997190395f = /* @__PURE__ */ $76b79a89ba1ca1d5$var$immer.createDraft.bind($76b79a89ba1ca1d5$var$immer);
var $76b79a89ba1ca1d5$export$c60f5e69c521b528 = /* @__PURE__ */ $76b79a89ba1ca1d5$var$immer.finishDraft.bind($76b79a89ba1ca1d5$var$immer);
var $76b79a89ba1ca1d5$export$c05b21e3257751e5 = (value)=>value;
var $76b79a89ba1ca1d5$export$20f911b3f8cf0b74 = (value)=>value;

});

parcelRegister("ahJpD", function(module, exports) {

$parcel$export(module.exports, "weakMapMemoize", () => $df2c37335b49bbfe$export$8402dc26d96f6902);
$parcel$export(module.exports, "createSelectorCreator", () => $df2c37335b49bbfe$export$5943f4447f6ef248);
$parcel$export(module.exports, "createSelector", () => $df2c37335b49bbfe$export$595d22ed68ca2841);
// src/devModeChecks/identityFunctionCheck.ts
var $df2c37335b49bbfe$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch  {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $df2c37335b49bbfe$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $df2c37335b49bbfe$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $df2c37335b49bbfe$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($df2c37335b49bbfe$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $df2c37335b49bbfe$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $df2c37335b49bbfe$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $df2c37335b49bbfe$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $df2c37335b49bbfe$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $df2c37335b49bbfe$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $df2c37335b49bbfe$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $df2c37335b49bbfe$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $df2c37335b49bbfe$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $df2c37335b49bbfe$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = {
        ...$df2c37335b49bbfe$var$globalDevModeChecks,
        ...devModeChecks
    };
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $df2c37335b49bbfe$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $df2c37335b49bbfe$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $df2c37335b49bbfe$var$$REVISION = 0;
var $df2c37335b49bbfe$var$CURRENT_TRACKER = null;
var $df2c37335b49bbfe$var$Cell = class {
    revision = $df2c37335b49bbfe$var$$REVISION;
    _value;
    _lastValue;
    _isEqual = $df2c37335b49bbfe$var$tripleEq;
    constructor(initialValue, isEqual = $df2c37335b49bbfe$var$tripleEq){
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $df2c37335b49bbfe$var$CURRENT_TRACKER?.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$df2c37335b49bbfe$var$$REVISION;
    }
};
function $df2c37335b49bbfe$var$tripleEq(a, b) {
    return a === b;
}
var $df2c37335b49bbfe$var$TrackingCache = class {
    _cachedValue;
    _cachedRevision = -1;
    _deps = [];
    hits = 0;
    fn;
    constructor(fn){
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $df2c37335b49bbfe$var$CURRENT_TRACKER;
            $df2c37335b49bbfe$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $df2c37335b49bbfe$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $df2c37335b49bbfe$var$CURRENT_TRACKER?.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $df2c37335b49bbfe$var$getValue(cell) {
    if (!(cell instanceof $df2c37335b49bbfe$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $df2c37335b49bbfe$var$setValue(storage, value) {
    if (!(storage instanceof $df2c37335b49bbfe$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $df2c37335b49bbfe$var$createCell(initialValue, isEqual = $df2c37335b49bbfe$var$tripleEq) {
    return new $df2c37335b49bbfe$var$Cell(initialValue, isEqual);
}
function $df2c37335b49bbfe$var$createCache(fn) {
    $df2c37335b49bbfe$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $df2c37335b49bbfe$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $df2c37335b49bbfe$var$neverEq = (a, b)=>false;
function $df2c37335b49bbfe$var$createTag() {
    return $df2c37335b49bbfe$var$createCell(null, $df2c37335b49bbfe$var$neverEq);
}
function $df2c37335b49bbfe$var$dirtyTag(tag, value) {
    $df2c37335b49bbfe$var$setValue(tag, value);
}
var $df2c37335b49bbfe$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $df2c37335b49bbfe$var$createTag();
    $df2c37335b49bbfe$var$getValue(tag);
};
var $df2c37335b49bbfe$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $df2c37335b49bbfe$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $df2c37335b49bbfe$var$REDUX_PROXY_LABEL = Symbol();
var $df2c37335b49bbfe$var$nextId = 0;
var $df2c37335b49bbfe$var$proto = Object.getPrototypeOf({});
var $df2c37335b49bbfe$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
    proxy = new Proxy(this, $df2c37335b49bbfe$var$objectProxyHandler);
    tag = $df2c37335b49bbfe$var$createTag();
    tags = {};
    children = {};
    collectionTag = null;
    id = $df2c37335b49bbfe$var$nextId++;
};
var $df2c37335b49bbfe$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $df2c37335b49bbfe$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $df2c37335b49bbfe$var$createNode(childValue);
                if (childNode.tag) $df2c37335b49bbfe$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $df2c37335b49bbfe$var$createTag();
                    tag.value = childValue;
                }
                $df2c37335b49bbfe$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $df2c37335b49bbfe$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $df2c37335b49bbfe$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
    proxy = new Proxy([
        this
    ], $df2c37335b49bbfe$var$arrayProxyHandler);
    tag = $df2c37335b49bbfe$var$createTag();
    tags = {};
    children = {};
    collectionTag = null;
    id = $df2c37335b49bbfe$var$nextId++;
};
var $df2c37335b49bbfe$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $df2c37335b49bbfe$var$consumeCollection(node);
        return $df2c37335b49bbfe$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $df2c37335b49bbfe$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $df2c37335b49bbfe$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $df2c37335b49bbfe$var$objectProxyHandler.has(node, prop);
    }
};
function $df2c37335b49bbfe$var$createNode(value) {
    if (Array.isArray(value)) return new $df2c37335b49bbfe$var$ArrayTreeNode(value);
    return new $df2c37335b49bbfe$var$ObjectTreeNode(value);
}
function $df2c37335b49bbfe$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $df2c37335b49bbfe$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $df2c37335b49bbfe$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $df2c37335b49bbfe$var$dirtyCollection(node);
            $df2c37335b49bbfe$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $df2c37335b49bbfe$var$updateNode(childNode, newChildValue);
        else {
            $df2c37335b49bbfe$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $df2c37335b49bbfe$var$deleteNode(node) {
    if (node.tag) $df2c37335b49bbfe$var$dirtyTag(node.tag, null);
    $df2c37335b49bbfe$var$dirtyCollection(node);
    for(const key in node.tags)$df2c37335b49bbfe$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$df2c37335b49bbfe$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $df2c37335b49bbfe$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $df2c37335b49bbfe$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $df2c37335b49bbfe$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $df2c37335b49bbfe$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $df2c37335b49bbfe$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $df2c37335b49bbfe$export$3f025202a230c6dd = (a, b)=>a === b;
function $df2c37335b49bbfe$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $df2c37335b49bbfe$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $df2c37335b49bbfe$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $df2c37335b49bbfe$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $df2c37335b49bbfe$var$createSingletonCache(comparator) : $df2c37335b49bbfe$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $df2c37335b49bbfe$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $df2c37335b49bbfe$export$c8f9cf88d9fdee55(func) {
    const node = $df2c37335b49bbfe$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $df2c37335b49bbfe$var$createCacheKeyComparator($df2c37335b49bbfe$export$3f025202a230c6dd);
    const cache = $df2c37335b49bbfe$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $df2c37335b49bbfe$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $df2c37335b49bbfe$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $df2c37335b49bbfe$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $df2c37335b49bbfe$var$StrongRef;
var $df2c37335b49bbfe$var$UNTERMINATED = 0;
var $df2c37335b49bbfe$var$TERMINATED = 1;
function $df2c37335b49bbfe$var$createCacheNode() {
    return {
        s: $df2c37335b49bbfe$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $df2c37335b49bbfe$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $df2c37335b49bbfe$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $df2c37335b49bbfe$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $df2c37335b49bbfe$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $df2c37335b49bbfe$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = lastResult?.deref?.() ?? lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $df2c37335b49bbfe$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $df2c37335b49bbfe$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $df2c37335b49bbfe$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $df2c37335b49bbfe$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $df2c37335b49bbfe$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = {
            ...createSelectorCreatorOptions,
            ...directlyPassedOptions
        };
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $df2c37335b49bbfe$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $df2c37335b49bbfe$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $df2c37335b49bbfe$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $df2c37335b49bbfe$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $df2c37335b49bbfe$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $df2c37335b49bbfe$export$595d22ed68ca2841 = /* @__PURE__ */ $df2c37335b49bbfe$export$5943f4447f6ef248($df2c37335b49bbfe$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $df2c37335b49bbfe$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $df2c37335b49bbfe$export$595d22ed68ca2841)=>{
    $df2c37335b49bbfe$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$df2c37335b49bbfe$export$75979cfcd91bf38f
});

});

parcelRegister("40YCe", function(module, exports) {

$parcel$export(module.exports, "thunk", () => $941641f2a11fa825$export$dd164f5517779f15);
$parcel$export(module.exports, "withExtraArgument", () => $941641f2a11fa825$export$16d06542a1949d9e);
// src/index.ts
function $941641f2a11fa825$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $941641f2a11fa825$export$dd164f5517779f15 = $941641f2a11fa825$var$createThunkMiddleware();
var $941641f2a11fa825$export$16d06542a1949d9e = $941641f2a11fa825$var$createThunkMiddleware;

});


parcelRegister("ioiHS", function(module, exports) {

$parcel$export(module.exports, "debugClient", () => $52d2774a9576ce94$export$784bd6e1cd9d0412);

var $5Dd0Z = parcelRequire("5Dd0Z");
const $52d2774a9576ce94$export$784bd6e1cd9d0412 = (...postfix)=>(0, $5Dd0Z.debugSanremo)('client', ...postfix);

});
parcelRegister("5Dd0Z", function(module, exports) {

$parcel$export(module.exports, "debugSanremo", () => $3fb26b0f87a2f83a$export$be5c85dde00ec3e3);

var $40Oqt = parcelRequire("40Oqt");
const $3fb26b0f87a2f83a$export$be5c85dde00ec3e3 = (...postfix)=>(0, (/*@__PURE__*/$parcel$interopDefault($40Oqt)))(`sanremo:${postfix.join(':')}`);

});
parcelRegister("40Oqt", function(module, exports) {
/* eslint-env browser */ /**
 * This is the web browser implementation of `debug()`.
 */ exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (()=>{
    let warned = false;
    return ()=>{
        if (!warned) {
            warned = true;
            console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
        }
    };
})();
/**
 * Colors.
 */ exports.colors = [
    '#0000CC',
    '#0000FF',
    '#0033CC',
    '#0033FF',
    '#0066CC',
    '#0066FF',
    '#0099CC',
    '#0099FF',
    '#00CC00',
    '#00CC33',
    '#00CC66',
    '#00CC99',
    '#00CCCC',
    '#00CCFF',
    '#3300CC',
    '#3300FF',
    '#3333CC',
    '#3333FF',
    '#3366CC',
    '#3366FF',
    '#3399CC',
    '#3399FF',
    '#33CC00',
    '#33CC33',
    '#33CC66',
    '#33CC99',
    '#33CCCC',
    '#33CCFF',
    '#6600CC',
    '#6600FF',
    '#6633CC',
    '#6633FF',
    '#66CC00',
    '#66CC33',
    '#9900CC',
    '#9900FF',
    '#9933CC',
    '#9933FF',
    '#99CC00',
    '#99CC33',
    '#CC0000',
    '#CC0033',
    '#CC0066',
    '#CC0099',
    '#CC00CC',
    '#CC00FF',
    '#CC3300',
    '#CC3333',
    '#CC3366',
    '#CC3399',
    '#CC33CC',
    '#CC33FF',
    '#CC6600',
    '#CC6633',
    '#CC9900',
    '#CC9933',
    '#CCCC00',
    '#CCCC33',
    '#FF0000',
    '#FF0033',
    '#FF0066',
    '#FF0099',
    '#FF00CC',
    '#FF00FF',
    '#FF3300',
    '#FF3333',
    '#FF3366',
    '#FF3399',
    '#FF33CC',
    '#FF33FF',
    '#FF6600',
    '#FF6633',
    '#FF9900',
    '#FF9933',
    '#FFCC00',
    '#FFCC33'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ // eslint-disable-next-line complexity
function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) return true;
    // Internet Explorer and Edge do not support colors.
    if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) return false;
    let m;
    // Is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    // eslint-disable-next-line no-return-assign
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && (m = navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)) && parseInt(m[1], 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);
    if (!this.useColors) return;
    const c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // The final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    let index = 0;
    let lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, (match)=>{
        if (match === '%%') return;
        index++;
        if (match === '%c') // We only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */ exports.log = console.debug || console.log || (()=>{});
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (namespaces) exports.storage.setItem('debug', namespaces);
        else exports.storage.removeItem('debug');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    let r;
    try {
        r = exports.storage.getItem('debug') || exports.storage.getItem('DEBUG');
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    r;
    return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
    } catch (error) {
    // Swallow
    // XXX (@Qix-) should we be logging these?
    }
}

module.exports = (parcelRequire("fcGCN"))(exports);
const { formatters } = module.exports;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
    }
};

});
parcelRegister("fcGCN", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */ 
function $02db3e1a5325e737$var$setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = (parcelRequire("asXcv"));
    createDebug.destroy = destroy;
    Object.keys(env).forEach((key)=>{
        createDebug[key] = env[key];
    });
    /**
	* The currently active debug mode names, and names to skip.
	*/ createDebug.names = [];
    createDebug.skips = [];
    /**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/ createDebug.formatters = {};
    /**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/ function selectColor(namespace) {
        let hash = 0;
        for(let i = 0; i < namespace.length; i++){
            hash = (hash << 5) - hash + namespace.charCodeAt(i);
            hash |= 0; // Convert to 32bit integer
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }
    createDebug.selectColor = selectColor;
    /**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/ function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
            // Disabled?
            if (!debug.enabled) return;
            const self = debug;
            // Set `diff` timestamp
            const curr = Number(new Date());
            const ms = curr - (prevTime || curr);
            self.diff = ms;
            self.prev = prevTime;
            self.curr = curr;
            prevTime = curr;
            args[0] = createDebug.coerce(args[0]);
            if (typeof args[0] !== 'string') // Anything else let's inspect with %O
            args.unshift('%O');
            // Apply any `formatters` transformations
            let index = 0;
            args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format)=>{
                // If we encounter an escaped % then don't increase the array index
                if (match === '%%') return '%';
                index++;
                const formatter = createDebug.formatters[format];
                if (typeof formatter === 'function') {
                    const val = args[index];
                    match = formatter.call(self, val);
                    // Now we need to remove `args[index]` since it's inlined in the `format`
                    args.splice(index, 1);
                    index--;
                }
                return match;
            });
            // Apply env-specific formatting (colors, etc.)
            createDebug.formatArgs.call(self, args);
            const logFn = self.log || createDebug.log;
            logFn.apply(self, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.
        Object.defineProperty(debug, 'enabled', {
            enumerable: true,
            configurable: false,
            get: ()=>{
                if (enableOverride !== null) return enableOverride;
                if (namespacesCache !== createDebug.namespaces) {
                    namespacesCache = createDebug.namespaces;
                    enabledCache = createDebug.enabled(namespace);
                }
                return enabledCache;
            },
            set: (v)=>{
                enableOverride = v;
            }
        });
        // Env-specific initialization logic for debug instances
        if (typeof createDebug.init === 'function') createDebug.init(debug);
        return debug;
    }
    function extend(namespace, delimiter) {
        const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
        newDebug.log = this.log;
        return newDebug;
    }
    /**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/ function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        const split = (typeof namespaces === 'string' ? namespaces : '').trim().replace(/\s+/g, ',').split(',').filter(Boolean);
        for (const ns of split)if (ns[0] === '-') createDebug.skips.push(ns.slice(1));
        else createDebug.names.push(ns);
    }
    /**
	 * Checks if the given string matches a namespace template, honoring
	 * asterisks as wildcards.
	 *
	 * @param {String} search
	 * @param {String} template
	 * @return {Boolean}
	 */ function matchesTemplate(search, template) {
        let searchIndex = 0;
        let templateIndex = 0;
        let starIndex = -1;
        let matchIndex = 0;
        while(searchIndex < search.length){
            if (templateIndex < template.length && (template[templateIndex] === search[searchIndex] || template[templateIndex] === '*')) {
                // Match character or proceed with wildcard
                if (template[templateIndex] === '*') {
                    starIndex = templateIndex;
                    matchIndex = searchIndex;
                    templateIndex++; // Skip the '*'
                } else {
                    searchIndex++;
                    templateIndex++;
                }
            } else if (starIndex !== -1) {
                // Backtrack to the last '*' and try to match more characters
                templateIndex = starIndex + 1;
                matchIndex++;
                searchIndex = matchIndex;
            } else return false; // No match
        }
        // Handle trailing '*' in template
        while(templateIndex < template.length && template[templateIndex] === '*')templateIndex++;
        return templateIndex === template.length;
    }
    /**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/ function disable() {
        const namespaces = [
            ...createDebug.names,
            ...createDebug.skips.map((namespace)=>'-' + namespace)
        ].join(',');
        createDebug.enable('');
        return namespaces;
    }
    /**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/ function enabled(name) {
        for (const skip of createDebug.skips){
            if (matchesTemplate(name, skip)) return false;
        }
        for (const ns of createDebug.names){
            if (matchesTemplate(name, ns)) return true;
        }
        return false;
    }
    /**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/ function coerce(val) {
        if (val instanceof Error) return val.stack || val.message;
        return val;
    }
    /**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/ function destroy() {
        console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
    }
    createDebug.enable(createDebug.load());
    return createDebug;
}
module.exports = $02db3e1a5325e737$var$setup;

});
parcelRegister("asXcv", function(module, exports) {
/**
 * Helpers.
 */ var $79ea70ecaf5f1c48$var$s = 1000;
var $79ea70ecaf5f1c48$var$m = $79ea70ecaf5f1c48$var$s * 60;
var $79ea70ecaf5f1c48$var$h = $79ea70ecaf5f1c48$var$m * 60;
var $79ea70ecaf5f1c48$var$d = $79ea70ecaf5f1c48$var$h * 24;
var $79ea70ecaf5f1c48$var$w = $79ea70ecaf5f1c48$var$d * 7;
var $79ea70ecaf5f1c48$var$y = $79ea70ecaf5f1c48$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $79ea70ecaf5f1c48$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $79ea70ecaf5f1c48$var$fmtLong(val) : $79ea70ecaf5f1c48$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $79ea70ecaf5f1c48$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $79ea70ecaf5f1c48$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $79ea70ecaf5f1c48$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $79ea70ecaf5f1c48$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $79ea70ecaf5f1c48$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $79ea70ecaf5f1c48$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $79ea70ecaf5f1c48$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $79ea70ecaf5f1c48$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $79ea70ecaf5f1c48$var$d) return Math.round(ms / $79ea70ecaf5f1c48$var$d) + 'd';
    if (msAbs >= $79ea70ecaf5f1c48$var$h) return Math.round(ms / $79ea70ecaf5f1c48$var$h) + 'h';
    if (msAbs >= $79ea70ecaf5f1c48$var$m) return Math.round(ms / $79ea70ecaf5f1c48$var$m) + 'm';
    if (msAbs >= $79ea70ecaf5f1c48$var$s) return Math.round(ms / $79ea70ecaf5f1c48$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $79ea70ecaf5f1c48$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $79ea70ecaf5f1c48$var$d) return $79ea70ecaf5f1c48$var$plural(ms, msAbs, $79ea70ecaf5f1c48$var$d, 'day');
    if (msAbs >= $79ea70ecaf5f1c48$var$h) return $79ea70ecaf5f1c48$var$plural(ms, msAbs, $79ea70ecaf5f1c48$var$h, 'hour');
    if (msAbs >= $79ea70ecaf5f1c48$var$m) return $79ea70ecaf5f1c48$var$plural(ms, msAbs, $79ea70ecaf5f1c48$var$m, 'minute');
    if (msAbs >= $79ea70ecaf5f1c48$var$s) return $79ea70ecaf5f1c48$var$plural(ms, msAbs, $79ea70ecaf5f1c48$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $79ea70ecaf5f1c48$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});





parcelRegister("rbG4f", function(module, exports) {

$parcel$export(module.exports, "registerSocket", () => $0a71f8bc73613caf$export$638aee9229976b07);
$parcel$export(module.exports, "getSocket", () => $0a71f8bc73613caf$export$361cf94c2d913fd4);
// Simple registry to make the socket accessible outside of React components
// This allows middleware to emit socket events without prop drilling
let $0a71f8bc73613caf$var$registeredSocket = null;
function $0a71f8bc73613caf$export$638aee9229976b07(socket) {
    $0a71f8bc73613caf$var$registeredSocket = socket;
}
function $0a71f8bc73613caf$export$361cf94c2d913fd4() {
    return $0a71f8bc73613caf$var$registeredSocket;
}

});


parcelRegister("gi5DA", function(module, exports) {

$parcel$export(module.exports, "GuestUser", () => $62567938c26b112a$export$5039d1ddceb5d352);
$parcel$export(module.exports, "setUserAsLoggedIn", () => $62567938c26b112a$export$5eea9bd178595d52);
$parcel$export(module.exports, "setUserAsGuest", () => $62567938c26b112a$export$87bfe881aa371db4);
$parcel$export(module.exports, "setUserAsUnauthenticated", () => $62567938c26b112a$export$f9c797a0c788e28d);
$parcel$export(module.exports, "selectIsGuest", () => $62567938c26b112a$export$6cfe49608287a964);
$parcel$export(module.exports, "default", () => $62567938c26b112a$export$2e2bcd8739ae039);

var $ahJpD = parcelRequire("ahJpD");
var $8WGgv = parcelRequire("8WGgv");
const $62567938c26b112a$export$5039d1ddceb5d352 = {
    id: -1,
    name: 'guest',
    guest: true
};
const $62567938c26b112a$export$c90edb45b5aad092 = (0, $8WGgv.createSlice)({
    name: 'user',
    initialState: {
        value: undefined,
        needsServerAuthentication: false
    },
    reducers: {
        setUserAsLoggedIn: (state, action)=>{
            state.value = action.payload.user;
            state.needsServerAuthentication = !!action.payload.needsServerAuthentication;
        },
        setUserAsUnauthenticated: (state)=>{
            state.needsServerAuthentication = true;
        },
        setUserAsGuest: (state)=>{
            state.value = $62567938c26b112a$export$5039d1ddceb5d352;
        }
    }
});
const { setUserAsLoggedIn: $62567938c26b112a$export$5eea9bd178595d52, setUserAsGuest: $62567938c26b112a$export$87bfe881aa371db4, setUserAsUnauthenticated: $62567938c26b112a$export$f9c797a0c788e28d } = $62567938c26b112a$export$c90edb45b5aad092.actions;
const $62567938c26b112a$export$6cfe49608287a964 = (0, $ahJpD.createSelector)((state)=>state.user.value, (user)=>user && 'guest' in user && user.guest);
var $62567938c26b112a$export$2e2bcd8739ae039 = $62567938c26b112a$export$c90edb45b5aad092.reducer;

});

parcelRegister("4EGLj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e2713fabd495041$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useSelector", () => $1e2713fabd495041$export$2105062e25df4afe);
$parcel$export(module.exports, "useDispatch", () => $1e2713fabd495041$export$8ad76b76a4c905f8);

var $8WGgv = parcelRequire("8WGgv");

var $bw3ua = parcelRequire("bw3ua");

var $iFck6 = parcelRequire("iFck6");

var $gM33V = parcelRequire("gM33V");

var $5xV4Q = parcelRequire("5xV4Q");

var $GLFsL = parcelRequire("GLFsL");

var $gi5DA = parcelRequire("gi5DA");

var $4zIwb = parcelRequire("4zIwb");
function $1e2713fabd495041$export$f51a9068ac82ea43() {
    return (0, $8WGgv.configureStore)({
        reducer: {
            user: (0, $gi5DA.default),
            docs: (0, $4zIwb.default),
            page: (0, $gM33V.default),
            sync: (0, $5xV4Q.default),
            debug: (0, $iFck6.default),
            update: (0, $GLFsL.default)
        },
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, $iFck6.debugMiddleware), (0, $5xV4Q.syncMiddleware))
    });
}
const $1e2713fabd495041$var$store = $1e2713fabd495041$export$f51a9068ac82ea43();
var $1e2713fabd495041$export$2e2bcd8739ae039 = $1e2713fabd495041$var$store;
const $1e2713fabd495041$export$2105062e25df4afe = $bw3ua.useSelector;
const $1e2713fabd495041$export$8ad76b76a4c905f8 = ()=>$bw3ua.useDispatch();

});
parcelRegister("iFck6", function(module, exports) {

$parcel$export(module.exports, "debugMiddleware", () => $d88107198da91585$export$9fc3e5f2061ac9f9);
$parcel$export(module.exports, "set", () => $d88107198da91585$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "default", () => $d88107198da91585$export$2e2bcd8739ae039);

var $8WGgv = parcelRequire("8WGgv");

var $40Oqt = parcelRequire("40Oqt");
const $d88107198da91585$var$DEBUG_KEY = 'debug-filter';
// Initialize from localStorage at module load time
function $d88107198da91585$var$getInitialDebugValue() {
    const stored = localStorage.getItem($d88107198da91585$var$DEBUG_KEY);
    if (stored) (0, (/*@__PURE__*/$parcel$interopDefault($40Oqt))).enable(stored);
    else (0, (/*@__PURE__*/$parcel$interopDefault($40Oqt))).disable();
    return stored;
}
const $d88107198da91585$export$bed619c57be0cc61 = (0, $8WGgv.createSlice)({
    name: 'debug',
    initialState: {
        value: $d88107198da91585$var$getInitialDebugValue()
    },
    reducers: {
        set: (state, action)=>{
            state.value = action.payload;
        }
    }
});
const $d88107198da91585$export$9fc3e5f2061ac9f9 = ()=>(next)=>(action)=>{
            const result = next(action);
            if ($d88107198da91585$export$bed619c57be0cc61.actions.set.match(action)) {
                const newValue = action.payload;
                if (!newValue) {
                    // null or empty string - clear debug
                    (0, (/*@__PURE__*/$parcel$interopDefault($40Oqt))).disable();
                    localStorage.removeItem($d88107198da91585$var$DEBUG_KEY);
                } else {
                    (0, (/*@__PURE__*/$parcel$interopDefault($40Oqt))).enable(newValue);
                    localStorage.setItem($d88107198da91585$var$DEBUG_KEY, newValue);
                }
            }
            return result;
        };
const { set: $d88107198da91585$export$adaa4cf7ef1b65be } = $d88107198da91585$export$bed619c57be0cc61.actions;
var $d88107198da91585$export$2e2bcd8739ae039 = $d88107198da91585$export$bed619c57be0cc61.reducer;

});

parcelRegister("gM33V", function(module, exports) {

$parcel$export(module.exports, "default", () => $13538dc6c0d7de2f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "usePageContext", () => $13538dc6c0d7de2f$export$9c25024bdfe755f7);

var $8WGgv = parcelRequire("8WGgv");

var $jXEQt = parcelRequire("jXEQt");

var $4EGLj = parcelRequire("4EGLj");
const $13538dc6c0d7de2f$export$2660a47c412cb681 = (0, $8WGgv.createSlice)({
    name: 'page',
    initialState: {
        value: {}
    },
    reducers: {
        set: (state, action)=>{
            state.value = action.payload;
        }
    }
});
const { set: $13538dc6c0d7de2f$export$adaa4cf7ef1b65be } = $13538dc6c0d7de2f$export$2660a47c412cb681.actions;
var $13538dc6c0d7de2f$export$2e2bcd8739ae039 = $13538dc6c0d7de2f$export$2660a47c412cb681.reducer;
function $13538dc6c0d7de2f$export$9c25024bdfe755f7(context) {
    const dispatch = (0, $4EGLj.useDispatch)();
    const { title: title, back: back, under: under } = context;
    (0, $jXEQt.useLayoutEffect)(()=>{
        dispatch($13538dc6c0d7de2f$export$adaa4cf7ef1b65be({
            title: title,
            back: back,
            under: under
        }));
    }, [
        dispatch,
        title,
        back,
        under
    ]);
}

});

parcelRegister("GLFsL", function(module, exports) {

$parcel$export(module.exports, "noUpdateReady", () => $30e66d1e7def0ff7$export$591d63e118d9f771);
$parcel$export(module.exports, "updateReadyToInstall", () => $30e66d1e7def0ff7$export$d13405bb5e8f4850);
$parcel$export(module.exports, "checkForUpdate", () => $30e66d1e7def0ff7$export$fbb89371845af2fd);
$parcel$export(module.exports, "default", () => $30e66d1e7def0ff7$export$2e2bcd8739ae039);

var $8WGgv = parcelRequire("8WGgv");
const $30e66d1e7def0ff7$export$d05f0a647efeb87e = (0, $8WGgv.createSlice)({
    name: 'update',
    initialState: {
        waitingToInstall: false
    },
    reducers: {
        // TODO: we are using redux as a primitive message passing system. This is probably wrong
        // (eg by wiping lastChecked we trigger the Update component to check for an update)
        updateReadyToInstall: (state)=>{
            state.lastChecked = Date.now();
            state.waitingToInstall = true;
        },
        noUpdateReady: (state)=>{
            state.lastChecked = Date.now();
        },
        checkForUpdate: (state)=>{
            state.lastChecked = undefined;
        }
    }
});
const { noUpdateReady: $30e66d1e7def0ff7$export$591d63e118d9f771, updateReadyToInstall: $30e66d1e7def0ff7$export$d13405bb5e8f4850, checkForUpdate: $30e66d1e7def0ff7$export$fbb89371845af2fd } = $30e66d1e7def0ff7$export$d05f0a647efeb87e.actions;
var $30e66d1e7def0ff7$export$2e2bcd8739ae039 = $30e66d1e7def0ff7$export$d05f0a647efeb87e.reducer;

});

parcelRegister("4zIwb", function(module, exports) {

$parcel$export(module.exports, "setRepeatable", () => $806d9181a2904563$export$bf20312cd111ec5a);
$parcel$export(module.exports, "setTemplate", () => $806d9181a2904563$export$1704277140908755);
$parcel$export(module.exports, "clearRepeatable", () => $806d9181a2904563$export$b428c628c26b1250);
$parcel$export(module.exports, "clearTemplate", () => $806d9181a2904563$export$e91240b311006225);
$parcel$export(module.exports, "update", () => $806d9181a2904563$export$722fbec263ad908a);
$parcel$export(module.exports, "default", () => $806d9181a2904563$export$2e2bcd8739ae039);

var $8WGgv = parcelRequire("8WGgv");
const $806d9181a2904563$export$c97ebe3895a6609a = (0, $8WGgv.createSlice)({
    name: 'docs',
    initialState: {
        repeatable: undefined,
        template: undefined,
        /**
     * Trigger to refresh lists. In the future we could more intelligently detect
     * if a list has to be refreshed, but that involves the list-filtering logic
     * either being only here or being here and the list's origin
     */ lastSynced: undefined
    },
    reducers: {
        setRepeatable: (state, action)=>{
            state.repeatable = action.payload;
        },
        setTemplate: (state, action)=>{
            state.template = action.payload;
        },
        clearRepeatable: (state)=>{
            state.repeatable = undefined;
        },
        clearTemplate: (state)=>{
            state.template = undefined;
        },
        update: (state, action)=>{
            const updatedDocs = action.payload;
            for (const doc of updatedDocs){
                if (state.repeatable?._id === doc._id) state.repeatable = doc;
                // It's not clear how this could happen, considering we version these in the _id
                // Putting it here anyway
                if (state.template?._id === doc._id) state.template = doc;
            }
            state.lastSynced = Date.now();
        }
    }
});
const { setRepeatable: $806d9181a2904563$export$bf20312cd111ec5a, setTemplate: $806d9181a2904563$export$1704277140908755, clearRepeatable: $806d9181a2904563$export$b428c628c26b1250, clearTemplate: $806d9181a2904563$export$e91240b311006225, update: $806d9181a2904563$export$722fbec263ad908a } = $806d9181a2904563$export$c97ebe3895a6609a.actions;
var $806d9181a2904563$export$2e2bcd8739ae039 = $806d9181a2904563$export$c97ebe3895a6609a.reducer;

});


parcelRegister("cBzxi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dfee4cb79047a70$export$2e2bcd8739ae039);

var $dLayU = parcelRequire("dLayU");
function $9dfee4cb79047a70$export$2e2bcd8739ae039(db) {
    db.createIndex({
        index: {
            fields: [
                'updated'
            ]
        }
    });
    db.createIndex({
        index: {
            fields: [
                'completed'
            ]
        }
    });
    db.createIndex({
        index: {
            fields: [
                'template'
            ]
        }
    });
    // TODO: add index for finding via slug
    db.changes({
        live: true,
        conflicts: true,
        include_docs: true
    }).on('change', (change)=>{
        if (change.doc?._conflicts?.length) console.error(`Conflict detected in write to ${db.name}`, change);
    });
    (0, $dLayU.default)(db);
}

});
parcelRegister("dLayU", function(module, exports) {

$parcel$export(module.exports, "default", () => $860cd95687ff315d$export$2e2bcd8739ae039);
const $860cd95687ff315d$var$doc = {
    // Making it version 2 so that when the user deletes it's always a soft delete
    _id: 'repeatable:template:0.0.4:2',
    title: 'Click Me First',
    slug: {
        type: 'date'
    },
    created: Date.now(),
    schemaVersion: 2,
    values: [
        {
            id: 'abc',
            default: false
        }
    ],
    markdown: `# Hello There!

Hello and welcome to my not-well-documented experiment in repeatable checklists!

## What is Going on?

Inspired by things like pilot checklists, this is [my](https://sdufresne.info) attempt at repeatable, reusable checklists.

I wanted something like this for myself to help me get into the habit of using checklists, and also as a project to work on while learning [Talon](https://talonvoice.com/).

## What Would You Use This for?

Anytime you find yourself repeatedly performing the same set of actions. A list of jobs every time you clean the house. Your pre-exercise warmups and post-exercise cooldowns. Things to check before you merge a code branch. A list of stretches you can do at your desk. Things to check before sending off that angry email.

Lots of stuff?

## How Does It Work?

You create a template for each set of steps, and use that template every time you want to perform those steps.

Templates are written in [Markdown](https://commonmark.org/help/), with the syntax addition of checkboxes by starting a new line with the \` -
  []\` tag.

- [ ] here is a checkbox you can check! <!-- cb:abc -->

If you go back to the main page you can edit this template to see an example.

You can also link each instance to a particular thing, or "slug", for reference (and in the future, searching).

### Slugs

A slug is a way to link a particular instance of a template with something: a particular day or time, a url, or just some text.

For example: if you create a pre-merge checklist you can set the slug to a url and link to the PR.

Or you can just ignore it (it defaults to a datetime that defaults to now).

## Logging in

The app works completely offline, but optionally if you want to sync between devices you can create an account to do that.

## Anything else?

More information:

- [Some technical details](https://github.com/SCdF/sanremo/blob/main/ARCHITECTURE.md)
- [My contact details are](https://sdufresne.info).`
};
async function $860cd95687ff315d$export$2e2bcd8739ae039(db) {
    if (!await db.get($860cd95687ff315d$var$doc._id).catch(()=>undefined)) return db.put($860cd95687ff315d$var$doc);
}

});


parcelRegister("gVYQt", function(module, exports) {
module.exports = $parcel$import("lQNug").then(()=>parcelRequire('7N4oO'));

});


parcelRegister("4DpeF", function(module, exports) {

$parcel$export(module.exports, "parseCheckboxIds", () => $a0d41fee2f542a67$export$d2f343db9e988355);
$parcel$export(module.exports, "ensureCheckboxIds", () => $a0d41fee2f542a67$export$a5d1bc73cc41abbc);

var $gxTLK = parcelRequire("gxTLK");
// Regex to match checkbox ID comments: <!-- cb:id -->
// IDs can be alphanumeric with hyphens and underscores
const $a0d41fee2f542a67$var$CHECKBOX_ID_REGEX = /<!--\s*cb:([a-zA-Z0-9_-]+)\s*-->/;
// Regex to match a checkbox in markdown: - [ ] or - [x] or * [ ] or * [x]
const $a0d41fee2f542a67$var$CHECKBOX_LINE_REGEX = /^(\s*[-*]\s*\[[ xX]\])/;
function $a0d41fee2f542a67$export$d2f343db9e988355(markdown) {
    const lines = markdown.split('\n');
    const result = [];
    for(let i = 0; i < lines.length; i++){
        const line = lines[i];
        // Check if this line has a checkbox
        if (!$a0d41fee2f542a67$var$CHECKBOX_LINE_REGEX.test(line)) continue;
        // Look for an ID comment on this line
        const idMatch = line.match($a0d41fee2f542a67$var$CHECKBOX_ID_REGEX);
        if (idMatch) result.push({
            id: idMatch[1],
            lineIndex: i
        });
    }
    return result;
}
function $a0d41fee2f542a67$export$e9d4e3a654f1611a() {
    // FIXME: make this more robust. Hash of markdown up to and including the checkbox line?
    return (0, $gxTLK.default)().substring(0, 8);
}
function $a0d41fee2f542a67$export$a5d1bc73cc41abbc(markdown) {
    const lines = markdown.split('\n');
    const result = [];
    for (const line of lines){
        // Check if this line has a checkbox
        if (!$a0d41fee2f542a67$var$CHECKBOX_LINE_REGEX.test(line)) {
            result.push(line);
            continue;
        }
        // Check if it already has an ID
        if ($a0d41fee2f542a67$var$CHECKBOX_ID_REGEX.test(line)) {
            result.push(line);
            continue;
        }
        // Add an ID to this checkbox
        const id = $a0d41fee2f542a67$export$e9d4e3a654f1611a();
        // Insert the ID comment at the end of the line
        result.push(`${line} <!-- cb:${id} -->`);
    }
    return result.join('\n');
}
function $a0d41fee2f542a67$export$7dfc4ad4dfbf199a(markdown, index) {
    const checkboxes = $a0d41fee2f542a67$export$d2f343db9e988355(markdown);
    return checkboxes[index]?.id;
}
function $a0d41fee2f542a67$export$9de9f3fe2644e37d(markdown) {
    return $a0d41fee2f542a67$export$d2f343db9e988355(markdown).map((info)=>info.id);
}
function $a0d41fee2f542a67$export$26426f1d3563b45d(markdown) {
    const lines = markdown.split('\n');
    let count = 0;
    for (const line of lines)if ($a0d41fee2f542a67$var$CHECKBOX_LINE_REGEX.test(line)) count++;
    return count;
}

});
parcelRegister("gxTLK", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0bafcfb3f048806$export$2e2bcd8739ae039);

var $1wbsm = parcelRequire("1wbsm");

var $gGBC3 = parcelRequire("gGBC3");

var $12vj4 = parcelRequire("12vj4");
function $c0bafcfb3f048806$var$_v4(options, buf, offset) {
    options = options || {};
    const rnds = options.random ?? options.rng?.() ?? (0, $gGBC3.default)();
    if (rnds.length < 16) throw new Error('Random bytes length must be >= 16');
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    if (buf) {
        offset = offset || 0;
        if (offset < 0 || offset + 16 > buf.length) throw new RangeError(`UUID byte range ${offset}:${offset + 15} is out of buffer bounds`);
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $12vj4.unsafeStringify)(rnds);
}
function $c0bafcfb3f048806$var$v4(options, buf, offset) {
    if ((0, $1wbsm.default).randomUUID && !buf && !options) return (0, $1wbsm.default).randomUUID();
    return $c0bafcfb3f048806$var$_v4(options, buf, offset);
}
var $c0bafcfb3f048806$export$2e2bcd8739ae039 = $c0bafcfb3f048806$var$v4;

});
parcelRegister("1wbsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $11b1aa9e4096dee0$export$2e2bcd8739ae039);
const $11b1aa9e4096dee0$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $11b1aa9e4096dee0$export$2e2bcd8739ae039 = {
    randomUUID: $11b1aa9e4096dee0$var$randomUUID
};

});

parcelRegister("gGBC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c25dbead58cf32d0$export$2e2bcd8739ae039);
let $c25dbead58cf32d0$var$getRandomValues;
const $c25dbead58cf32d0$var$rnds8 = new Uint8Array(16);
function $c25dbead58cf32d0$export$2e2bcd8739ae039() {
    if (!$c25dbead58cf32d0$var$getRandomValues) {
        if (typeof crypto === 'undefined' || !crypto.getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
        $c25dbead58cf32d0$var$getRandomValues = crypto.getRandomValues.bind(crypto);
    }
    return $c25dbead58cf32d0$var$getRandomValues($c25dbead58cf32d0$var$rnds8);
}

});

parcelRegister("12vj4", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $0c1e432c99444302$export$8fb373d660548968);

var $k9jOw = parcelRequire("k9jOw");
const $0c1e432c99444302$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$0c1e432c99444302$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $0c1e432c99444302$export$8fb373d660548968(arr, offset = 0) {
    return ($0c1e432c99444302$var$byteToHex[arr[offset + 0]] + $0c1e432c99444302$var$byteToHex[arr[offset + 1]] + $0c1e432c99444302$var$byteToHex[arr[offset + 2]] + $0c1e432c99444302$var$byteToHex[arr[offset + 3]] + '-' + $0c1e432c99444302$var$byteToHex[arr[offset + 4]] + $0c1e432c99444302$var$byteToHex[arr[offset + 5]] + '-' + $0c1e432c99444302$var$byteToHex[arr[offset + 6]] + $0c1e432c99444302$var$byteToHex[arr[offset + 7]] + '-' + $0c1e432c99444302$var$byteToHex[arr[offset + 8]] + $0c1e432c99444302$var$byteToHex[arr[offset + 9]] + '-' + $0c1e432c99444302$var$byteToHex[arr[offset + 10]] + $0c1e432c99444302$var$byteToHex[arr[offset + 11]] + $0c1e432c99444302$var$byteToHex[arr[offset + 12]] + $0c1e432c99444302$var$byteToHex[arr[offset + 13]] + $0c1e432c99444302$var$byteToHex[arr[offset + 14]] + $0c1e432c99444302$var$byteToHex[arr[offset + 15]]).toLowerCase();
}
function $0c1e432c99444302$var$stringify(arr, offset = 0) {
    const uuid = $0c1e432c99444302$export$8fb373d660548968(arr, offset);
    if (!(0, $k9jOw.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $0c1e432c99444302$export$2e2bcd8739ae039 = $0c1e432c99444302$var$stringify;

});
parcelRegister("k9jOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eab40482fb23b994$export$2e2bcd8739ae039);

var $buTuZ = parcelRequire("buTuZ");
function $eab40482fb23b994$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $buTuZ.default).test(uuid);
}
var $eab40482fb23b994$export$2e2bcd8739ae039 = $eab40482fb23b994$var$validate;

});
parcelRegister("buTuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ed8bfbbb8956ec$export$2e2bcd8739ae039);
var $85ed8bfbbb8956ec$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/i;

});





parcelRegister("a6yjU", function(module, exports) {

$parcel$export(module.exports, "default", () => $01e6047c890807c0$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");

var $fuPJe = parcelRequire("fuPJe");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $01e6047c890807c0$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $7rM61.jsx)((0, $fuPJe.default), {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $fuPJe.default).muiName;
    return /*#__PURE__*/ $jXEQt.memo(/*#__PURE__*/ $jXEQt.forwardRef(Component));
}

});
parcelRegister("fuPJe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b481c8969e25eeed$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $dvg8e = parcelRequire("dvg8e");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $3Li8S = parcelRequire("3Li8S");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $b481c8969e25eeed$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $dvg8e.default)(color)}`,
            `fontSize${(0, $dvg8e.default)(fontSize)}`
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $3Li8S.getSvgIconUtilityClass), classes);
};
const $b481c8969e25eeed$var$SvgIconRoot = (0, $3EMXY.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $dvg8e.default)(ownerState.color)}`],
            styles[`fontSize${(0, $dvg8e.default)(ownerState.fontSize)}`]
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $b481c8969e25eeed$var$SvgIcon = /*#__PURE__*/ $jXEQt.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $jXEQt.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b481c8969e25eeed$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsxs)($b481c8969e25eeed$var$SvgIconRoot, {
        as: component,
        className: (0, $fQojQ.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $7rM61.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$b481c8969e25eeed$var$SvgIcon.muiName = 'SvgIcon';
var $b481c8969e25eeed$export$2e2bcd8739ae039 = $b481c8969e25eeed$var$SvgIcon;

});
parcelRegister("3Li8S", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", () => $2bd3d58d9e6d8177$export$c7c50641356bdfa5);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $2bd3d58d9e6d8177$export$c7c50641356bdfa5(slot) {
    return (0, $5KipK.default)('MuiSvgIcon', slot);
}
const $2bd3d58d9e6d8177$var$svgIconClasses = (0, $1XfUG.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $2bd3d58d9e6d8177$export$2e2bcd8739ae039 = $2bd3d58d9e6d8177$var$svgIconClasses;

});



parcelRegister("b1cIR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8059a825c78ba627$export$2e2bcd8739ae039);

var $7K7Bw = parcelRequire("7K7Bw");

var $gvt33 = parcelRequire("gvt33");
'use client';
function $8059a825c78ba627$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $gvt33.default)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $7K7Bw.default)({
        theme: theme,
        name: name,
        props: props
    });
}

});
parcelRegister("7K7Bw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a32ba4e4fd58bfe$export$2e2bcd8739ae039);

var $5ZtsM = parcelRequire("5ZtsM");
function $5a32ba4e4fd58bfe$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $5ZtsM.default)(theme.components[name].defaultProps, props);
}

});


parcelRegister("75a0P", function(module, exports) {

$parcel$export(module.exports, "default", () => $5280c444fd2aa5a9$export$2e2bcd8739ae039);

var $283M5 = parcelRequire("283M5");
const $5280c444fd2aa5a9$var$styled = (0, $283M5.default)();
var $5280c444fd2aa5a9$export$2e2bcd8739ae039 = $5280c444fd2aa5a9$var$styled;

});

parcelRegister("1AHpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $128ad466e9167330$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $WhJhk = parcelRequire("WhJhk");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $128ad466e9167330$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $WhJhk.getDividerUtilityClass), classes);
};
const $128ad466e9167330$var$DividerRoot = (0, $3EMXY.default)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.alpha((theme.vars || theme).palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $128ad466e9167330$var$DividerWrapper = (0, $3EMXY.default)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $128ad466e9167330$var$Divider = /*#__PURE__*/ $jXEQt.forwardRef(function Divider(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $128ad466e9167330$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($128ad466e9167330$var$DividerRoot, {
        as: component,
        className: (0, $fQojQ.default)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $7rM61.jsx)($128ad466e9167330$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($128ad466e9167330$var$Divider) $128ad466e9167330$var$Divider.muiSkipListHighlight = true;
var $128ad466e9167330$export$2e2bcd8739ae039 = $128ad466e9167330$var$Divider;

});
parcelRegister("WhJhk", function(module, exports) {

$parcel$export(module.exports, "getDividerUtilityClass", () => $0af32b905cd0888f$export$46f01d01378ec5a2);
$parcel$export(module.exports, "default", () => $0af32b905cd0888f$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $0af32b905cd0888f$export$46f01d01378ec5a2(slot) {
    return (0, $5KipK.default)('MuiDivider', slot);
}
const $0af32b905cd0888f$var$dividerClasses = (0, $1XfUG.default)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $0af32b905cd0888f$export$2e2bcd8739ae039 = $0af32b905cd0888f$var$dividerClasses;

});


parcelRegister("7lGG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $559b994066d358b2$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");



var $3ptEP = parcelRequire("3ptEP");

var $03ESf = parcelRequire("03ESf");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");

var $89QD5 = parcelRequire("89QD5");

var $jU5Pn = parcelRequire("jU5Pn");

var $jDTVB = parcelRequire("jDTVB");

var $6CkEU = parcelRequire("6CkEU");

var $5WfeQ = parcelRequire("5WfeQ");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $559b994066d358b2$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $3ptEP.default)(slots, (0, $5WfeQ.getButtonBaseUtilityClass), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $559b994066d358b2$export$7ec0dcc5e3cdcd36 = (0, $3EMXY.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $5WfeQ.default).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $559b994066d358b2$var$ButtonBase = /*#__PURE__*/ $jXEQt.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $jXEQt.useRef(null);
    const ripple = (0, $jDTVB.default)();
    const handleRippleRef = (0, $89QD5.default)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $jXEQt.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $jXEQt.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $jXEQt.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $559b994066d358b2$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $559b994066d358b2$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $559b994066d358b2$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $559b994066d358b2$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $559b994066d358b2$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $559b994066d358b2$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $559b994066d358b2$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $559b994066d358b2$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $559b994066d358b2$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $03ESf.default)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $jU5Pn.default)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $03ESf.default)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $jU5Pn.default)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $jU5Pn.default)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        const hasFormAttributes = !!other.formAction;
        // ButtonBase was defaulting to type="button" when no type prop was provided, which prevented form submission and broke formAction functionality.
        // The fix checks for form-related attributes and skips the default type to allow the browser's natural submit behavior (type="submit").
        buttonProps.type = type === undefined && !hasFormAttributes ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $89QD5.default)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $559b994066d358b2$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsxs)($559b994066d358b2$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $7rM61.jsx)((0, $6CkEU.default), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $559b994066d358b2$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $jU5Pn.default)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $559b994066d358b2$export$2e2bcd8739ae039 = $559b994066d358b2$var$ButtonBase;

});
parcelRegister("03ESf", function(module, exports) {

$parcel$export(module.exports, "default", () => $00affca34aa47f86$export$2e2bcd8739ae039);
/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $00affca34aa47f86$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}

});

parcelRegister("89QD5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f07fd1d5e9ec03e$export$2e2bcd8739ae039);

var $15Pai = parcelRequire("15Pai");
'use client';
var $5f07fd1d5e9ec03e$export$2e2bcd8739ae039 = (0, $15Pai.default);

});
parcelRegister("15Pai", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cbdf2630d1011a2$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
'use client';
function $0cbdf2630d1011a2$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $jXEQt.useRef(undefined);
    const refEffect = $jXEQt.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $jXEQt.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}

});


parcelRegister("jU5Pn", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7c4833bb41858$export$2e2bcd8739ae039);

var $g4Q41 = parcelRequire("g4Q41");
'use client';
var $e7d7c4833bb41858$export$2e2bcd8739ae039 = (0, $g4Q41.default);

});
parcelRegister("g4Q41", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb4567dfaf5ca811$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");

var $dbTJ5 = parcelRequire("dbTJ5");
'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $bb4567dfaf5ca811$var$useEventCallback(fn) {
    const ref = $jXEQt.useRef(fn);
    (0, $dbTJ5.default)(()=>{
        ref.current = fn;
    });
    return $jXEQt.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $bb4567dfaf5ca811$export$2e2bcd8739ae039 = $bb4567dfaf5ca811$var$useEventCallback;

});
parcelRegister("dbTJ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $99a78784d634a57b$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $99a78784d634a57b$var$useEnhancedEffect = typeof window !== 'undefined' ? $jXEQt.useLayoutEffect : $jXEQt.useEffect;
var $99a78784d634a57b$export$2e2bcd8739ae039 = $99a78784d634a57b$var$useEnhancedEffect;

});



parcelRegister("jDTVB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4cd0b02d5307c0d$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");

var $bV5Of = parcelRequire("bV5Of");
'use client';
class $e4cd0b02d5307c0d$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $e4cd0b02d5307c0d$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $bV5Of.default)($e4cd0b02d5307c0d$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $jXEQt.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $jXEQt.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $e4cd0b02d5307c0d$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $e4cd0b02d5307c0d$export$2e2bcd8739ae039() {
    return $e4cd0b02d5307c0d$export$f5de0641c7db4154.use();
}
function $e4cd0b02d5307c0d$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}

});
parcelRegister("bV5Of", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ad986323a8f0a1d$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
'use client';
const $8ad986323a8f0a1d$var$UNINITIALIZED = {};
function $8ad986323a8f0a1d$export$2e2bcd8739ae039(init, initArg) {
    const ref = $jXEQt.useRef($8ad986323a8f0a1d$var$UNINITIALIZED);
    if (ref.current === $8ad986323a8f0a1d$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}

});


parcelRegister("6CkEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d165118d94c1757$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $kpCg3 = parcelRequire("kpCg3");

var $fQojQ = parcelRequire("fQojQ");

var $iyI9C = parcelRequire("iyI9C");

var $IRdXs = parcelRequire("IRdXs");
var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");

var $ff8aE = parcelRequire("ff8aE");

var $aZkNq = parcelRequire("aZkNq");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $4d165118d94c1757$var$DURATION = 550;
const $4d165118d94c1757$export$95d0c9356b2231a3 = 80;
const $4d165118d94c1757$var$enterKeyframe = (0, $IRdXs.keyframes)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $4d165118d94c1757$var$exitKeyframe = (0, $IRdXs.keyframes)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $4d165118d94c1757$var$pulsateKeyframe = (0, $IRdXs.keyframes)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $4d165118d94c1757$export$f6b7418508c72c25 = (0, $3EMXY.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $4d165118d94c1757$export$676cfe7b12693c4b = (0, $3EMXY.default)((0, $ff8aE.default), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $aZkNq.default).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$4d165118d94c1757$var$enterKeyframe};
    animation-duration: ${$4d165118d94c1757$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $aZkNq.default).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $aZkNq.default).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $aZkNq.default).childLeaving} {
    opacity: 0;
    animation-name: ${$4d165118d94c1757$var$exitKeyframe};
    animation-duration: ${$4d165118d94c1757$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $aZkNq.default).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$4d165118d94c1757$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $4d165118d94c1757$var$TouchRipple = /*#__PURE__*/ $jXEQt.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $jXEQt.useState([]);
    const nextKey = $jXEQt.useRef(0);
    const rippleCallback = $jXEQt.useRef(null);
    $jXEQt.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $jXEQt.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $iyI9C.default)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $jXEQt.useRef(null);
    const container = $jXEQt.useRef(null);
    const startCommit = $jXEQt.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $7rM61.jsx)($4d165118d94c1757$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $fQojQ.default)(classes.ripple, (0, $aZkNq.default).ripple),
                        rippleVisible: (0, $fQojQ.default)(classes.rippleVisible, (0, $aZkNq.default).rippleVisible),
                        ripplePulsate: (0, $fQojQ.default)(classes.ripplePulsate, (0, $aZkNq.default).ripplePulsate),
                        child: (0, $fQojQ.default)(classes.child, (0, $aZkNq.default).child),
                        childLeaving: (0, $fQojQ.default)(classes.childLeaving, (0, $aZkNq.default).childLeaving),
                        childPulsate: (0, $fQojQ.default)(classes.childPulsate, (0, $aZkNq.default).childPulsate)
                    },
                    timeout: $4d165118d94c1757$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $jXEQt.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touch devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($4d165118d94c1757$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $jXEQt.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $jXEQt.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $jXEQt.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $7rM61.jsx)($4d165118d94c1757$export$f6b7418508c72c25, {
        className: (0, $fQojQ.default)((0, $aZkNq.default).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $kpCg3.default), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $4d165118d94c1757$export$2e2bcd8739ae039 = $4d165118d94c1757$var$TouchRipple;

});
parcelRegister("kpCg3", function(module, exports) {

$parcel$export(module.exports, "default", () => $edc3d1ad73b12e76$export$2e2bcd8739ae039);

var $hphT8 = parcelRequire("hphT8");

var $eR4tV = parcelRequire("eR4tV");

var $jzHgM = parcelRequire("jzHgM");

var $3W2J1 = parcelRequire("3W2J1");


var $jXEQt = parcelRequire("jXEQt");

var $cZFmH = parcelRequire("cZFmH");

var $96Ymh = parcelRequire("96Ymh");
var $edc3d1ad73b12e76$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $edc3d1ad73b12e76$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $edc3d1ad73b12e76$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $3W2J1.default)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $jzHgM.default)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $96Ymh.getInitialChildMapping)(nextProps, handleExited) : (0, $96Ymh.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $96Ymh.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $eR4tV.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $hphT8.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $edc3d1ad73b12e76$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement((0, $cZFmH.default).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement((0, $cZFmH.default).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).Component);
$edc3d1ad73b12e76$var$TransitionGroup.propTypes = {};
$edc3d1ad73b12e76$var$TransitionGroup.defaultProps = $edc3d1ad73b12e76$var$defaultProps;
var $edc3d1ad73b12e76$export$2e2bcd8739ae039 = $edc3d1ad73b12e76$var$TransitionGroup;

});
parcelRegister("hphT8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cac2a5b4a9896ae9$export$2e2bcd8739ae039);
function $cac2a5b4a9896ae9$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("jzHgM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e402d9a55f71ea62$export$2e2bcd8739ae039);
function $e402d9a55f71ea62$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("3W2J1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2dd8e70d018bc7f8$export$2e2bcd8739ae039);

var $3DDpj = parcelRequire("3DDpj");
function $2dd8e70d018bc7f8$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $3DDpj.default)(t, o);
}

});
parcelRegister("3DDpj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a639517b6163a6c$export$2e2bcd8739ae039);
function $2a639517b6163a6c$export$2e2bcd8739ae039(t, e) {
    return $2a639517b6163a6c$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $2a639517b6163a6c$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("cZFmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $975b44cfa70a7f75$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
var $975b44cfa70a7f75$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createContext(null);

});

parcelRegister("96Ymh", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $6a237e8005d8d50e$export$bbc8a025727ea824);
$parcel$export(module.exports, "getInitialChildMapping", () => $6a237e8005d8d50e$export$fa71e2345c31d7a2);
$parcel$export(module.exports, "getNextChildMapping", () => $6a237e8005d8d50e$export$36fd1af28d383ec0);

var $jXEQt = parcelRequire("jXEQt");
function $6a237e8005d8d50e$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $jXEQt.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $jXEQt.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $6a237e8005d8d50e$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $6a237e8005d8d50e$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $6a237e8005d8d50e$export$fa71e2345c31d7a2(props, onExited) {
    return $6a237e8005d8d50e$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $jXEQt.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $6a237e8005d8d50e$var$getProp(child, 'appear', props),
            enter: $6a237e8005d8d50e$var$getProp(child, 'enter', props),
            exit: $6a237e8005d8d50e$var$getProp(child, 'exit', props)
        });
    });
}
function $6a237e8005d8d50e$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $6a237e8005d8d50e$export$bbc8a025727ea824(nextProps.children);
    var children = $6a237e8005d8d50e$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $jXEQt.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $jXEQt.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $jXEQt.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $6a237e8005d8d50e$var$getProp(child, 'exit', nextProps),
            enter: $6a237e8005d8d50e$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $jXEQt.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $jXEQt.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $jXEQt.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $6a237e8005d8d50e$var$getProp(child, 'exit', nextProps),
            enter: $6a237e8005d8d50e$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}

});


parcelRegister("iyI9C", function(module, exports) {

$parcel$export(module.exports, "Timeout", () => $d82da70a220aab5e$export$786b4da70f00938b);
$parcel$export(module.exports, "default", () => $d82da70a220aab5e$export$2e2bcd8739ae039);

var $bV5Of = parcelRequire("bV5Of");

var $euftY = parcelRequire("euftY");
'use client';
class $d82da70a220aab5e$export$786b4da70f00938b {
    static create() {
        return new $d82da70a220aab5e$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $d82da70a220aab5e$export$2e2bcd8739ae039() {
    const timeout = (0, $bV5Of.default)($d82da70a220aab5e$export$786b4da70f00938b.create).current;
    (0, $euftY.default)(timeout.disposeEffect);
    return timeout;
}

});
parcelRegister("euftY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8bfe085d7279e08$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
'use client';
const $a8bfe085d7279e08$var$EMPTY = [];
function $a8bfe085d7279e08$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $jXEQt.useEffect(fn, $a8bfe085d7279e08$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }

});


parcelRegister("ff8aE", function(module, exports) {

$parcel$export(module.exports, "default", () => $b18e984970b7b448$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $b18e984970b7b448$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $jXEQt.useState(false);
    const rippleClassName = (0, $fQojQ.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $fQojQ.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $jXEQt.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $7rM61.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $7rM61.jsx)("span", {
            className: childClassName
        })
    });
}
var $b18e984970b7b448$export$2e2bcd8739ae039 = $b18e984970b7b448$var$Ripple;

});

parcelRegister("aZkNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fffbb8d609098e9$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $7fffbb8d609098e9$export$b464606f735ab902(slot) {
    return (0, $5KipK.default)('MuiTouchRipple', slot);
}
const $7fffbb8d609098e9$var$touchRippleClasses = (0, $1XfUG.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $7fffbb8d609098e9$export$2e2bcd8739ae039 = $7fffbb8d609098e9$var$touchRippleClasses;

});


parcelRegister("5WfeQ", function(module, exports) {

$parcel$export(module.exports, "getButtonBaseUtilityClass", () => $452e30944482df52$export$fccb0498dcd99783);
$parcel$export(module.exports, "default", () => $452e30944482df52$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $452e30944482df52$export$fccb0498dcd99783(slot) {
    return (0, $5KipK.default)('MuiButtonBase', slot);
}
const $452e30944482df52$var$buttonBaseClasses = (0, $1XfUG.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $452e30944482df52$export$2e2bcd8739ae039 = $452e30944482df52$var$buttonBaseClasses;

});


parcelRegister("ab5Dn", function(module, exports) {

$parcel$export(module.exports, "default", () => $768f4d46532bca42$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");


var $3ptEP = parcelRequire("3ptEP");

var $IRdXs = parcelRequire("IRdXs");
var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $dvg8e = parcelRequire("dvg8e");

var $8oH7q = parcelRequire("8oH7q");

var $a6wpk = parcelRequire("a6wpk");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $768f4d46532bca42$var$SIZE = 44;
const $768f4d46532bca42$var$circularRotateKeyframe = (0, $IRdXs.keyframes)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $768f4d46532bca42$var$circularDashKeyframe = (0, $IRdXs.keyframes)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $768f4d46532bca42$var$rotateAnimation = typeof $768f4d46532bca42$var$circularRotateKeyframe !== 'string' ? (0, $IRdXs.css)`
        animation: ${$768f4d46532bca42$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $768f4d46532bca42$var$dashAnimation = typeof $768f4d46532bca42$var$circularDashKeyframe !== 'string' ? (0, $IRdXs.css)`
        animation: ${$768f4d46532bca42$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $768f4d46532bca42$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $dvg8e.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        track: [
            'track'
        ],
        circle: [
            'circle',
            `circle${(0, $dvg8e.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $a6wpk.getCircularProgressUtilityClass), classes);
};
const $768f4d46532bca42$var$CircularProgressRoot = (0, $3EMXY.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $dvg8e.default)(ownerState.color)}`]
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $768f4d46532bca42$var$rotateAnimation || {
                    animation: `${$768f4d46532bca42$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $768f4d46532bca42$var$CircularProgressSVG = (0, $3EMXY.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $768f4d46532bca42$var$CircularProgressCircle = (0, $3EMXY.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $dvg8e.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $768f4d46532bca42$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$768f4d46532bca42$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
const $768f4d46532bca42$var$CircularProgressTrack = (0, $3EMXY.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Track'
})((0, $31RRc.default)(({ theme: theme })=>({
        stroke: 'currentColor',
        opacity: (theme.vars || theme).palette.action.activatedOpacity
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $768f4d46532bca42$var$CircularProgress = /*#__PURE__*/ $jXEQt.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, enableTrackSlot: enableTrackSlot = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant,
        enableTrackSlot: enableTrackSlot
    };
    const classes = $768f4d46532bca42$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($768f4d46532bca42$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $7rM61.jsx)($768f4d46532bca42$var$CircularProgressRoot, {
        className: (0, $fQojQ.default)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $7rM61.jsxs)($768f4d46532bca42$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$768f4d46532bca42$var$SIZE / 2} ${$768f4d46532bca42$var$SIZE / 2} ${$768f4d46532bca42$var$SIZE} ${$768f4d46532bca42$var$SIZE}`,
            children: [
                enableTrackSlot ? /*#__PURE__*/ (0, $7rM61.jsx)($768f4d46532bca42$var$CircularProgressTrack, {
                    className: classes.track,
                    ownerState: ownerState,
                    cx: $768f4d46532bca42$var$SIZE,
                    cy: $768f4d46532bca42$var$SIZE,
                    r: ($768f4d46532bca42$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness,
                    "aria-hidden": "true"
                }) : null,
                /*#__PURE__*/ (0, $7rM61.jsx)($768f4d46532bca42$var$CircularProgressCircle, {
                    className: classes.circle,
                    style: circleStyle,
                    ownerState: ownerState,
                    cx: $768f4d46532bca42$var$SIZE,
                    cy: $768f4d46532bca42$var$SIZE,
                    r: ($768f4d46532bca42$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness
                })
            ]
        })
    });
});
var $768f4d46532bca42$export$2e2bcd8739ae039 = $768f4d46532bca42$var$CircularProgress;

});
parcelRegister("a6wpk", function(module, exports) {

$parcel$export(module.exports, "getCircularProgressUtilityClass", () => $75b39a61d40759cd$export$29cad1383b3f235d);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $75b39a61d40759cd$export$29cad1383b3f235d(slot) {
    return (0, $5KipK.default)('MuiCircularProgress', slot);
}
const $75b39a61d40759cd$var$circularProgressClasses = (0, $1XfUG.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'track',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $75b39a61d40759cd$export$2e2bcd8739ae039 = $75b39a61d40759cd$var$circularProgressClasses;

});


parcelRegister("cSdwB", function(module, exports) {

$parcel$export(module.exports, "default", () => $026b2d7fcd3b1c0d$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $1eucE = parcelRequire("1eucE");

var $2XKgW = parcelRequire("2XKgW");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $026b2d7fcd3b1c0d$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $1eucE.getListItemIconUtilityClass), classes);
};
const $026b2d7fcd3b1c0d$var$ListItemIconRoot = (0, $3EMXY.default)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $026b2d7fcd3b1c0d$var$ListItemIcon = /*#__PURE__*/ $jXEQt.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $jXEQt.useContext((0, $2XKgW.default));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $026b2d7fcd3b1c0d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($026b2d7fcd3b1c0d$var$ListItemIconRoot, {
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $026b2d7fcd3b1c0d$export$2e2bcd8739ae039 = $026b2d7fcd3b1c0d$var$ListItemIcon;

});
parcelRegister("1eucE", function(module, exports) {

$parcel$export(module.exports, "getListItemIconUtilityClass", () => $0e5e86f90dc16720$export$81478e24460c57f2);
$parcel$export(module.exports, "default", () => $0e5e86f90dc16720$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $0e5e86f90dc16720$export$81478e24460c57f2(slot) {
    return (0, $5KipK.default)('MuiListItemIcon', slot);
}
const $0e5e86f90dc16720$var$listItemIconClasses = (0, $1XfUG.default)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $0e5e86f90dc16720$export$2e2bcd8739ae039 = $0e5e86f90dc16720$var$listItemIconClasses;

});

parcelRegister("2XKgW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2284fc2e97d3a27a$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
'use client';
/**
 * @ignore - internal component.
 */ const $2284fc2e97d3a27a$var$ListContext = /*#__PURE__*/ $jXEQt.createContext({});
var $2284fc2e97d3a27a$export$2e2bcd8739ae039 = $2284fc2e97d3a27a$var$ListContext;

});


parcelRegister("9viLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb591671367914c$export$2e2bcd8739ae039);
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $6eb591671367914c$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $6eb591671367914c$export$2e2bcd8739ae039 = $6eb591671367914c$var$isHostComponent;

});

parcelRegister("kM5Ix", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1fcb9b6bd01b988$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");

var $2XKgW = parcelRequire("2XKgW");

var $fbooN = parcelRequire("fbooN");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $f1fcb9b6bd01b988$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $fbooN.getListUtilityClass), classes);
};
const $f1fcb9b6bd01b988$var$ListRoot = (0, $3EMXY.default)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $f1fcb9b6bd01b988$var$List = /*#__PURE__*/ $jXEQt.forwardRef(function List(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $jXEQt.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $f1fcb9b6bd01b988$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $2XKgW.default).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $7rM61.jsxs)($f1fcb9b6bd01b988$var$ListRoot, {
            as: component,
            className: (0, $fQojQ.default)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $f1fcb9b6bd01b988$export$2e2bcd8739ae039 = $f1fcb9b6bd01b988$var$List;

});
parcelRegister("fbooN", function(module, exports) {

$parcel$export(module.exports, "getListUtilityClass", () => $b0dacf38fb7b14e0$export$c6bd6795ed6e3203);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $b0dacf38fb7b14e0$export$c6bd6795ed6e3203(slot) {
    return (0, $5KipK.default)('MuiList', slot);
}
const $b0dacf38fb7b14e0$var$listClasses = (0, $1XfUG.default)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $b0dacf38fb7b14e0$export$2e2bcd8739ae039 = $b0dacf38fb7b14e0$var$listClasses;

});


parcelRegister("kJD0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1864441edb2bd36$export$2e2bcd8739ae039);

var $dbTJ5 = parcelRequire("dbTJ5");
'use client';
var $f1864441edb2bd36$export$2e2bcd8739ae039 = (0, $dbTJ5.default);

});

parcelRegister("f92r2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b06995d67766e4cd$export$2e2bcd8739ae039);

var $15Pai = parcelRequire("15Pai");

var $bxjbZ = parcelRequire("bxjbZ");

var $bOwbu = parcelRequire("bOwbu");

var $iZtpD = parcelRequire("iZtpD");
'use client';
function $b06995d67766e4cd$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $bOwbu.default)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $iZtpD.default)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $15Pai.default)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $bxjbZ.default)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}

});
parcelRegister("bxjbZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $8661a9fedf79b374$export$2e2bcd8739ae039);

var $9viLJ = parcelRequire("9viLJ");
/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $8661a9fedf79b374$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $9viLJ.default)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $8661a9fedf79b374$export$2e2bcd8739ae039 = $8661a9fedf79b374$var$appendOwnerState;

});

parcelRegister("bOwbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $899d545a369a9969$export$2e2bcd8739ae039);
/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $899d545a369a9969$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $899d545a369a9969$export$2e2bcd8739ae039 = $899d545a369a9969$var$resolveComponentProps;

});

parcelRegister("iZtpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd34bd3923b95753$export$2e2bcd8739ae039);

var $fQojQ = parcelRequire("fQojQ");

var $7vuxm = parcelRequire("7vuxm");

var $7FQx4 = parcelRequire("7FQx4");
/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $dd34bd3923b95753$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $fQojQ.default)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $7vuxm.default)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $7FQx4.default)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $7FQx4.default)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $fQojQ.default)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $dd34bd3923b95753$export$2e2bcd8739ae039 = $dd34bd3923b95753$var$mergeSlotProps;

});
parcelRegister("7vuxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $57731daab100db4d$export$2e2bcd8739ae039);
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $57731daab100db4d$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $57731daab100db4d$export$2e2bcd8739ae039 = $57731daab100db4d$var$extractEventHandlers;

});

parcelRegister("7FQx4", function(module, exports) {

$parcel$export(module.exports, "default", () => $59651c991cc8baeb$export$2e2bcd8739ae039);
/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $59651c991cc8baeb$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $59651c991cc8baeb$export$2e2bcd8739ae039 = $59651c991cc8baeb$var$omitEventHandlers;

});



parcelRegister("9okRN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d668aa70d7a9532$export$2e2bcd8739ae039);

var $fQojQ = parcelRequire("fQojQ");
// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $6d668aa70d7a9532$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $6d668aa70d7a9532$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($6d668aa70d7a9532$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $fQojQ.default)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $fQojQ.default)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}

});

parcelRegister("5IqKW", function(module, exports) {

$parcel$export(module.exports, "default", () => $4295d10afcf2615b$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $i29Fs = parcelRequire("i29Fs");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $2XKgW = parcelRequire("2XKgW");

var $7lGG0 = parcelRequire("7lGG0");

var $kJD0o = parcelRequire("kJD0o");

var $89QD5 = parcelRequire("89QD5");

var $WhJhk = parcelRequire("WhJhk");

var $1eucE = parcelRequire("1eucE");

var $4tnEh = parcelRequire("4tnEh");

var $coiF1 = parcelRequire("coiF1");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $4295d10afcf2615b$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $4295d10afcf2615b$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $3ptEP.default)(slots, (0, $coiF1.getMenuItemUtilityClass), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $4295d10afcf2615b$var$MenuItemRoot = (0, $3EMXY.default)((0, $7lGG0.default), {
    shouldForwardProp: (prop)=>(0, $i29Fs.default)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $4295d10afcf2615b$export$4334bb34c76fef24
})((0, $31RRc.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $coiF1.default).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${(0, $coiF1.default).focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${(0, $coiF1.default).selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $coiF1.default).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $coiF1.default).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $WhJhk.default).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $WhJhk.default).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $4tnEh.default).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $4tnEh.default).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $1eucE.default).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $1eucE.default).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $4295d10afcf2615b$var$MenuItem = /*#__PURE__*/ $jXEQt.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $jXEQt.useContext((0, $2XKgW.default));
    const childContext = $jXEQt.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $jXEQt.useRef(null);
    (0, $kJD0o.default)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $4295d10afcf2615b$var$useUtilityClasses(props);
    const handleRef = (0, $89QD5.default)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $2XKgW.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $7rM61.jsx)($4295d10afcf2615b$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $fQojQ.default)(classes.focusVisible, focusVisibleClassName),
            className: (0, $fQojQ.default)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $4295d10afcf2615b$export$2e2bcd8739ae039 = $4295d10afcf2615b$var$MenuItem;

});
parcelRegister("4tnEh", function(module, exports) {

$parcel$export(module.exports, "getListItemTextUtilityClass", () => $341c36ff257ca3cf$export$1061006a0db3aeb5);
$parcel$export(module.exports, "default", () => $341c36ff257ca3cf$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $341c36ff257ca3cf$export$1061006a0db3aeb5(slot) {
    return (0, $5KipK.default)('MuiListItemText', slot);
}
const $341c36ff257ca3cf$var$listItemTextClasses = (0, $1XfUG.default)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $341c36ff257ca3cf$export$2e2bcd8739ae039 = $341c36ff257ca3cf$var$listItemTextClasses;

});

parcelRegister("coiF1", function(module, exports) {

$parcel$export(module.exports, "getMenuItemUtilityClass", () => $905633849be4f5cc$export$515f8c67b5305377);
$parcel$export(module.exports, "default", () => $905633849be4f5cc$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $905633849be4f5cc$export$515f8c67b5305377(slot) {
    return (0, $5KipK.default)('MuiMenuItem', slot);
}
const $905633849be4f5cc$var$menuItemClasses = (0, $1XfUG.default)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $905633849be4f5cc$export$2e2bcd8739ae039 = $905633849be4f5cc$var$menuItemClasses;

});


parcelRegister("1D77Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $12fef6682c498fe5$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");

var $ejO7q = parcelRequire("ejO7q");
'use client';
function $12fef6682c498fe5$export$2e2bcd8739ae039() {
    return $jXEQt.useContext((0, $ejO7q.default));
}

});
parcelRegister("ejO7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6c9b7991fa9ec65$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
'use client';
/**
 * @ignore - internal component.
 */ const $a6c9b7991fa9ec65$var$FormControlContext = /*#__PURE__*/ $jXEQt.createContext(undefined);
var $a6c9b7991fa9ec65$export$2e2bcd8739ae039 = $a6c9b7991fa9ec65$var$FormControlContext;

});


parcelRegister("8iAmL", function(module, exports) {

$parcel$export(module.exports, "SlugType", () => $a4f93e6b0e8d6984$export$c211aa78aeb956e7);
$parcel$export(module.exports, "CURRENT_SCHEMA_VERSION", () => $a4f93e6b0e8d6984$export$7d60d2226b6abfe);
// FIXME: replace as much of this with PouchDB types
// type Foo = PouchDB.Core.ExistingDocument<RepeatableDoc>;
var $a4f93e6b0e8d6984$export$c211aa78aeb956e7 = /*#__PURE__*/ function(SlugType) {
    SlugType["Date"] = "date";
    SlugType["Timestamp"] = "timestamp";
    SlugType["URL"] = "url";
    SlugType["String"] = "string";
    return SlugType;
}({});
const $a4f93e6b0e8d6984$export$7d60d2226b6abfe = 2;

});

parcelRegister("25tlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $1852d041239ebc2b$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $iyI9C = parcelRequire("iyI9C");


var $3ptEP = parcelRequire("3ptEP");

var $39dKT = parcelRequire("39dKT");

var $03ESf = parcelRequire("03ESf");

var $e4lkb = parcelRequire("e4lkb");

var $3EMXY = parcelRequire("3EMXY");
var $k3tJq = parcelRequire("k3tJq");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $dvg8e = parcelRequire("dvg8e");

var $4k8GK = parcelRequire("4k8GK");

var $18ttW = parcelRequire("18ttW");

var $jU5Pn = parcelRequire("jU5Pn");

var $89QD5 = parcelRequire("89QD5");

var $8H6A5 = parcelRequire("8H6A5");

var $3e8Jg = parcelRequire("3e8Jg");

var $f92r2 = parcelRequire("f92r2");

var $fKXvC = parcelRequire("fKXvC");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $1852d041239ebc2b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $1852d041239ebc2b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $dvg8e.default)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $fKXvC.getTooltipUtilityClass), classes);
};
const $1852d041239ebc2b$var$TooltipPopper = (0, $3EMXY.default)((0, $18ttW.default), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $fKXvC.default).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $fKXvC.default).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $fKXvC.default).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $fKXvC.default).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $fKXvC.default).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $fKXvC.default).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $fKXvC.default).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $fKXvC.default).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $1852d041239ebc2b$var$TooltipTooltip = (0, $3EMXY.default)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $dvg8e.default)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $fKXvC.default).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $fKXvC.default).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $fKXvC.default).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $fKXvC.default).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$1852d041239ebc2b$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $fKXvC.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $fKXvC.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $fKXvC.default).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $fKXvC.default).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $fKXvC.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $fKXvC.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $fKXvC.default).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $fKXvC.default).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $fKXvC.default).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $fKXvC.default).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $1852d041239ebc2b$var$TooltipArrow = (0, $3EMXY.default)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow'
})((0, $31RRc.default)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $1852d041239ebc2b$var$hystersisOpen = false;
const $1852d041239ebc2b$var$hystersisTimer = new (0, $iyI9C.Timeout)();
let $1852d041239ebc2b$var$cursorPosition = {
    x: 0,
    y: 0
};
function $1852d041239ebc2b$export$b9ee5a7ace0541f8() {
    $1852d041239ebc2b$var$hystersisOpen = false;
    $1852d041239ebc2b$var$hystersisTimer.clear();
}
function $1852d041239ebc2b$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $1852d041239ebc2b$var$Tooltip = /*#__PURE__*/ $jXEQt.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $jXEQt.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $7rM61.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $k3tJq.default)();
    const isRtl = (0, $39dKT.useRtl)();
    const [childNode, setChildNode] = $jXEQt.useState();
    const [arrowRef, setArrowRef] = $jXEQt.useState(null);
    const ignoreNonTouchEvents = $jXEQt.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $iyI9C.default)();
    const enterTimer = (0, $iyI9C.default)();
    const leaveTimer = (0, $iyI9C.default)();
    const touchTimer = (0, $iyI9C.default)();
    const [openState, setOpenState] = (0, $3e8Jg.default)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $8H6A5.default)(idProp);
    const prevUserSelect = $jXEQt.useRef();
    const stopTouchInteraction = (0, $jU5Pn.default)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $jXEQt.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $1852d041239ebc2b$var$hystersisTimer.clear();
        $1852d041239ebc2b$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $jU5Pn.default)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $1852d041239ebc2b$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $1852d041239ebc2b$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $1852d041239ebc2b$var$hystersisOpen && enterNextDelay) enterTimer.start($1852d041239ebc2b$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $jXEQt.useState(false);
    const handleBlur = (event)=>{
        // Needed for https://github.com/mui/material-ui/issues/45373
        const target = event?.target ?? childNode;
        if (!target || !(0, $03ESf.default)(target)) {
            setChildIsFocusVisible(false);
            // InputBase can call onBlur() without an event when the input becomes disabled.
            // Tooltip must not assume an event object exists.
            const closeEvent = event ?? new Event('blur');
            // `new Event('blur')` has `target/currentTarget === null`, but Tooltip's close logic
            // (and user callbacks like onClose) may expect them to reference the anchor element.
            if (!event && target) {
                Object.defineProperty(closeEvent, 'target', {
                    value: target
                });
                Object.defineProperty(closeEvent, 'currentTarget', {
                    value: target
                });
            }
            handleMouseLeave(closeEvent);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $03ESf.default)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $jXEQt.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $89QD5.default)((0, $e4lkb.default)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $jXEQt.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $1852d041239ebc2b$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $fQojQ.default)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $1852d041239ebc2b$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $1852d041239ebc2b$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $1852d041239ebc2b$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $1852d041239ebc2b$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $jXEQt.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $1852d041239ebc2b$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $f92r2.default)('popper', {
        elementType: $1852d041239ebc2b$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $f92r2.default)('transition', {
        elementType: (0, $4k8GK.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $f92r2.default)('tooltip', {
        elementType: $1852d041239ebc2b$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $f92r2.default)('arrow', {
        elementType: $1852d041239ebc2b$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $7rM61.jsxs)($jXEQt.Fragment, {
        children: [
            /*#__PURE__*/ $jXEQt.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $7rM61.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $18ttW.default),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $1852d041239ebc2b$var$cursorPosition.y,
                            left: $1852d041239ebc2b$var$cursorPosition.x,
                            right: $1852d041239ebc2b$var$cursorPosition.x,
                            bottom: $1852d041239ebc2b$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $7rM61.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $7rM61.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $7rM61.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $1852d041239ebc2b$export$2e2bcd8739ae039 = $1852d041239ebc2b$var$Tooltip;

});
parcelRegister("39dKT", function(module, exports) {

$parcel$export(module.exports, "useRtl", () => $24ace1e6a3ea876f$export$b2dd014b6c321cb);
$parcel$export(module.exports, "default", () => $24ace1e6a3ea876f$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $7rM61 = parcelRequire("7rM61");
'use client';
const $24ace1e6a3ea876f$var$RtlContext = /*#__PURE__*/ $jXEQt.createContext();
function $24ace1e6a3ea876f$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $7rM61.jsx)($24ace1e6a3ea876f$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $24ace1e6a3ea876f$export$b2dd014b6c321cb = ()=>{
    const value = $jXEQt.useContext($24ace1e6a3ea876f$var$RtlContext);
    return value ?? false;
};
var $24ace1e6a3ea876f$export$2e2bcd8739ae039 = $24ace1e6a3ea876f$var$RtlProvider;

});

parcelRegister("e4lkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e1fb071511a5c3$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
function $a3e1fb071511a5c3$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($jXEQt.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}

});

parcelRegister("4k8GK", function(module, exports) {

$parcel$export(module.exports, "default", () => $325fc50c861387b8$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $iyI9C = parcelRequire("iyI9C");


var $e4lkb = parcelRequire("e4lkb");

var $7HOFt = parcelRequire("7HOFt");

var $k3tJq = parcelRequire("k3tJq");

var $avf4Y = parcelRequire("avf4Y");

var $89QD5 = parcelRequire("89QD5");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $325fc50c861387b8$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $325fc50c861387b8$var$styles = {
    entering: {
        opacity: 1,
        transform: $325fc50c861387b8$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $325fc50c861387b8$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $325fc50c861387b8$var$Grow = /*#__PURE__*/ $jXEQt.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7HOFt.default), ...other } = props;
    const timer = (0, $iyI9C.default)();
    const autoTimeout = $jXEQt.useRef();
    const theme = (0, $k3tJq.default)();
    const nodeRef = $jXEQt.useRef(null);
    const handleRef = (0, $89QD5.default)(nodeRef, (0, $e4lkb.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $avf4Y.reflow)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $avf4Y.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $325fc50c861387b8$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $avf4Y.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $325fc50c861387b8$var$isWebKit154 ? duration : duration * 0.666,
                delay: $325fc50c861387b8$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $325fc50c861387b8$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $7rM61.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $jXEQt.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $325fc50c861387b8$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$325fc50c861387b8$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($325fc50c861387b8$var$Grow) $325fc50c861387b8$var$Grow.muiSupportAuto = true;
var $325fc50c861387b8$export$2e2bcd8739ae039 = $325fc50c861387b8$var$Grow;

});
parcelRegister("7HOFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $59c3da2660902059$export$2e2bcd8739ae039);

var $hphT8 = parcelRequire("hphT8");

var $3W2J1 = parcelRequire("3W2J1");


var $jXEQt = parcelRequire("jXEQt");

var $8vWo2 = parcelRequire("8vWo2");

var $iWUVW = parcelRequire("iWUVW");


var $cZFmH = parcelRequire("cZFmH");

var $1r4Vy = parcelRequire("1r4Vy");
var $59c3da2660902059$export$bb38bb9a1161268 = 'unmounted';
var $59c3da2660902059$export$84cbff306f539230 = 'exited';
var $59c3da2660902059$export$df38205c966be359 = 'entering';
var $59c3da2660902059$export$78e9e6e3e014d60a = 'entered';
var $59c3da2660902059$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $59c3da2660902059$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $3W2J1.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $59c3da2660902059$export$84cbff306f539230;
                _this.appearStatus = $59c3da2660902059$export$df38205c966be359;
            } else initialStatus = $59c3da2660902059$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $59c3da2660902059$export$bb38bb9a1161268;
        else initialStatus = $59c3da2660902059$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $59c3da2660902059$export$bb38bb9a1161268) return {
            status: $59c3da2660902059$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $59c3da2660902059$export$df38205c966be359 && status !== $59c3da2660902059$export$78e9e6e3e014d60a) nextStatus = $59c3da2660902059$export$df38205c966be359;
            } else if (status === $59c3da2660902059$export$df38205c966be359 || status === $59c3da2660902059$export$78e9e6e3e014d60a) nextStatus = $59c3da2660902059$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $59c3da2660902059$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($8vWo2))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $1r4Vy.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $59c3da2660902059$export$84cbff306f539230) this.setState({
            status: $59c3da2660902059$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($8vWo2))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $iWUVW.default).disabled) {
            this.safeSetState({
                status: $59c3da2660902059$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $59c3da2660902059$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $59c3da2660902059$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($8vWo2))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $iWUVW.default).disabled) {
            this.safeSetState({
                status: $59c3da2660902059$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $59c3da2660902059$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $59c3da2660902059$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($8vWo2))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $59c3da2660902059$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $hphT8.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).createElement((0, $cZFmH.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).Component);
$59c3da2660902059$var$Transition.contextType = (0, $cZFmH.default);
$59c3da2660902059$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $59c3da2660902059$var$noop() {}
$59c3da2660902059$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $59c3da2660902059$var$noop,
    onEntering: $59c3da2660902059$var$noop,
    onEntered: $59c3da2660902059$var$noop,
    onExit: $59c3da2660902059$var$noop,
    onExiting: $59c3da2660902059$var$noop,
    onExited: $59c3da2660902059$var$noop
};
$59c3da2660902059$var$Transition.UNMOUNTED = $59c3da2660902059$export$bb38bb9a1161268;
$59c3da2660902059$var$Transition.EXITED = $59c3da2660902059$export$84cbff306f539230;
$59c3da2660902059$var$Transition.ENTERING = $59c3da2660902059$export$df38205c966be359;
$59c3da2660902059$var$Transition.ENTERED = $59c3da2660902059$export$78e9e6e3e014d60a;
$59c3da2660902059$var$Transition.EXITING = $59c3da2660902059$export$4aacc83d4d59139f;
var $59c3da2660902059$export$2e2bcd8739ae039 = $59c3da2660902059$var$Transition;

});
parcelRegister("iWUVW", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcb9ce9c66c45066$export$2e2bcd8739ae039);
var $dcb9ce9c66c45066$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("1r4Vy", function(module, exports) {

$parcel$export(module.exports, "forceReflow", () => $10bc22805cb6413a$export$7d26bbb1236dafd6);
var $10bc22805cb6413a$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("avf4Y", function(module, exports) {

$parcel$export(module.exports, "reflow", () => $7a587f10019cda5d$export$b7a864e1eaef9de5);
$parcel$export(module.exports, "getTransitionProps", () => $7a587f10019cda5d$export$8cb1e9b404609ae9);
const $7a587f10019cda5d$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $7a587f10019cda5d$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}

});


parcelRegister("18ttW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d3d684ec828fc25$export$2e2bcd8739ae039);

var $39dKT = parcelRequire("39dKT");




var $jXEQt = parcelRequire("jXEQt");

var $2xUTB = parcelRequire("2xUTB");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $0d3d684ec828fc25$var$PopperRoot = (0, $3EMXY.default)((0, $2xUTB.default), {
    name: 'MuiPopper',
    slot: 'Root'
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $0d3d684ec828fc25$var$Popper = /*#__PURE__*/ $jXEQt.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $39dKT.useRtl)();
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $7rM61.jsx)($0d3d684ec828fc25$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $0d3d684ec828fc25$export$2e2bcd8739ae039 = $0d3d684ec828fc25$var$Popper;

});
parcelRegister("2xUTB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1daacc27a57b0f7b$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");

var $049bd = parcelRequire("049bd");

var $dbTJ5 = parcelRequire("dbTJ5");

var $15Pai = parcelRequire("15Pai");




var $k75Nn = parcelRequire("k75Nn");


var $3ptEP = parcelRequire("3ptEP");

var $1Oxdt = parcelRequire("1Oxdt");


var $j1Xwx = parcelRequire("j1Xwx");

var $6dPAN = parcelRequire("6dPAN");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $1daacc27a57b0f7b$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $1daacc27a57b0f7b$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $1daacc27a57b0f7b$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $1daacc27a57b0f7b$var$isVirtualElement(element) {
    return !$1daacc27a57b0f7b$var$isHTMLElement(element);
}
const $1daacc27a57b0f7b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $6dPAN.getPopperUtilityClass), classes);
};
const $1daacc27a57b0f7b$var$defaultPopperOptions = {};
const $1daacc27a57b0f7b$var$PopperTooltip = /*#__PURE__*/ $jXEQt.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $jXEQt.useRef(null);
    const ownRef = (0, $15Pai.default)(tooltipRef, forwardedRef);
    const popperRef = $jXEQt.useRef(null);
    const handlePopperRef = (0, $15Pai.default)(popperRef, popperRefProp);
    const handlePopperRefRef = $jXEQt.useRef(handlePopperRef);
    (0, $dbTJ5.default)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $jXEQt.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $1daacc27a57b0f7b$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $jXEQt.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $jXEQt.useState($1daacc27a57b0f7b$var$resolveAnchorEl(anchorEl));
    $jXEQt.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $jXEQt.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($1daacc27a57b0f7b$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $dbTJ5.default)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $k75Nn.createPopper)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $1daacc27a57b0f7b$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $1Oxdt.default)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $7rM61.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $1daacc27a57b0f7b$var$Popper = /*#__PURE__*/ $jXEQt.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $1daacc27a57b0f7b$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $jXEQt.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $1daacc27a57b0f7b$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $1daacc27a57b0f7b$var$isHTMLElement(resolvedAnchorEl) ? (0, $049bd.default)(resolvedAnchorEl).body : (0, $049bd.default)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $j1Xwx.default), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $7rM61.jsx)($1daacc27a57b0f7b$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $1daacc27a57b0f7b$export$2e2bcd8739ae039 = $1daacc27a57b0f7b$var$Popper;

});
parcelRegister("049bd", function(module, exports) {

$parcel$export(module.exports, "default", () => $00c77eca07dbc226$export$2e2bcd8739ae039);
function $00c77eca07dbc226$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}

});

parcelRegister("k75Nn", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $ea48f4f61b10800e$export$8f7491d57c8f97a9);

var $f6X8P = parcelRequire("f6X8P");

var $aDDto = parcelRequire("aDDto");

var $lJMws = parcelRequire("lJMws");

var $g87Ka = parcelRequire("g87Ka");

var $j3NRo = parcelRequire("j3NRo");

var $8lu61 = parcelRequire("8lu61");

var $9OQN1 = parcelRequire("9OQN1");

var $duXMG = parcelRequire("duXMG");

var $6fRL5 = parcelRequire("6fRL5");

var $iwOwV = parcelRequire("iwOwV");


var $ea48f4f61b10800e$export$d34966752335dd47 = [
    (0, $aDDto.default),
    (0, $lJMws.default),
    (0, $g87Ka.default),
    (0, $j3NRo.default),
    (0, $8lu61.default),
    (0, $9OQN1.default),
    (0, $duXMG.default),
    (0, $6fRL5.default),
    (0, $iwOwV.default)
];
var $ea48f4f61b10800e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $f6X8P.popperGenerator)({
    defaultModifiers: $ea48f4f61b10800e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("f6X8P", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $b0054ad10f2e8753$export$ed5e13716264f202);

var $iSIMg = parcelRequire("iSIMg");

var $150O2 = parcelRequire("150O2");

var $h5cF9 = parcelRequire("h5cF9");

var $cbrCY = parcelRequire("cbrCY");

var $aXvuZ = parcelRequire("aXvuZ");

var $4vGTc = parcelRequire("4vGTc");

var $asNAh = parcelRequire("asNAh");


var $fkZ9S = parcelRequire("fkZ9S");
var $b0054ad10f2e8753$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b0054ad10f2e8753$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b0054ad10f2e8753$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b0054ad10f2e8753$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b0054ad10f2e8753$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $fkZ9S.isElement)(reference) ? (0, $h5cF9.default)(reference) : reference.contextElement ? (0, $h5cF9.default)(reference.contextElement) : [],
                    popper: (0, $h5cF9.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $aXvuZ.default)((0, $asNAh.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $iSIMg.default)(reference, (0, $cbrCY.default)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $150O2.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $4vGTc.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b0054ad10f2e8753$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b0054ad10f2e8753$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("iSIMg", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf000ff4b3c4664$export$2e2bcd8739ae039);

var $3s7bc = parcelRequire("3s7bc");

var $ftdTG = parcelRequire("ftdTG");

var $4J6FJ = parcelRequire("4J6FJ");

var $fkZ9S = parcelRequire("fkZ9S");

var $7a9Wo = parcelRequire("7a9Wo");

var $cFIMZ = parcelRequire("cFIMZ");

var $gNrKz = parcelRequire("gNrKz");

var $oyBem = parcelRequire("oyBem");
function $dbf000ff4b3c4664$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $oyBem.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $oyBem.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $dbf000ff4b3c4664$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fkZ9S.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $fkZ9S.isHTMLElement)(offsetParent) && $dbf000ff4b3c4664$var$isElementScaled(offsetParent);
    var documentElement = (0, $cFIMZ.default)(offsetParent);
    var rect = (0, $3s7bc.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4J6FJ.default)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $gNrKz.default)(documentElement)) scroll = (0, $ftdTG.default)(offsetParent);
        if ((0, $fkZ9S.isHTMLElement)(offsetParent)) {
            offsets = (0, $3s7bc.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $7a9Wo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("3s7bc", function(module, exports) {

$parcel$export(module.exports, "default", () => $28398e533bd4cb4a$export$2e2bcd8739ae039);

var $fkZ9S = parcelRequire("fkZ9S");

var $oyBem = parcelRequire("oyBem");

var $itJII = parcelRequire("itJII");

var $4OOct = parcelRequire("4OOct");
function $28398e533bd4cb4a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fkZ9S.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $oyBem.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $oyBem.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fkZ9S.isElement)(element) ? (0, $itJII.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $4OOct.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("fkZ9S", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $b2a82a0945aa8fd0$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $b2a82a0945aa8fd0$export$af51f0f06c0f328a);

var $itJII = parcelRequire("itJII");
function $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $itJII.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b2a82a0945aa8fd0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $itJII.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b2a82a0945aa8fd0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $itJII.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("itJII", function(module, exports) {

$parcel$export(module.exports, "default", () => $d73e6687a1d925d1$export$2e2bcd8739ae039);
function $d73e6687a1d925d1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("oyBem", function(module, exports) {

$parcel$export(module.exports, "max", () => $049d14be9b4f15bb$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $049d14be9b4f15bb$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $049d14be9b4f15bb$export$2077e0241d6afd3c);
var $049d14be9b4f15bb$export$8960430cfd85939f = Math.max;
var $049d14be9b4f15bb$export$96ec731ed4dcb222 = Math.min;
var $049d14be9b4f15bb$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("4OOct", function(module, exports) {

$parcel$export(module.exports, "default", () => $3822c5a08263882b$export$2e2bcd8739ae039);

var $21bjM = parcelRequire("21bjM");
function $3822c5a08263882b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $21bjM.default)());
}

});
parcelRegister("21bjM", function(module, exports) {

$parcel$export(module.exports, "default", () => $17847447eb3676eb$export$2e2bcd8739ae039);
function $17847447eb3676eb$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}

});



parcelRegister("ftdTG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b434581b465cb432$export$2e2bcd8739ae039);

var $jVJlU = parcelRequire("jVJlU");

var $itJII = parcelRequire("itJII");

var $fkZ9S = parcelRequire("fkZ9S");

var $dH7x4 = parcelRequire("dH7x4");
function $b434581b465cb432$export$2e2bcd8739ae039(node) {
    if (node === (0, $itJII.default)(node) || !(0, $fkZ9S.isHTMLElement)(node)) return (0, $jVJlU.default)(node);
    else return (0, $dH7x4.default)(node);
}

});
parcelRegister("jVJlU", function(module, exports) {

$parcel$export(module.exports, "default", () => $e826853427a61d24$export$2e2bcd8739ae039);

var $itJII = parcelRequire("itJII");
function $e826853427a61d24$export$2e2bcd8739ae039(node) {
    var win = (0, $itJII.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("dH7x4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f852250855e3d87$export$2e2bcd8739ae039);
function $9f852250855e3d87$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("4J6FJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37108a593d5d5f50$export$2e2bcd8739ae039);
function $37108a593d5d5f50$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}

});

parcelRegister("7a9Wo", function(module, exports) {

$parcel$export(module.exports, "default", () => $53712d9fbfe608a5$export$2e2bcd8739ae039);

var $3s7bc = parcelRequire("3s7bc");

var $cFIMZ = parcelRequire("cFIMZ");

var $jVJlU = parcelRequire("jVJlU");
function $53712d9fbfe608a5$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $3s7bc.default)((0, $cFIMZ.default)(element)).left + (0, $jVJlU.default)(element).scrollLeft;
}

});
parcelRegister("cFIMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $939c0e8e0ce2cee6$export$2e2bcd8739ae039);

var $fkZ9S = parcelRequire("fkZ9S");
function $939c0e8e0ce2cee6$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fkZ9S.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("gNrKz", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3a6bf84ff18f738$export$2e2bcd8739ae039);

var $inPKD = parcelRequire("inPKD");
function $c3a6bf84ff18f738$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $inPKD.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("inPKD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62284b4ca370c21$export$2e2bcd8739ae039);

var $itJII = parcelRequire("itJII");
function $d62284b4ca370c21$export$2e2bcd8739ae039(element) {
    return (0, $itJII.default)(element).getComputedStyle(element);
}

});



parcelRegister("150O2", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c96e22a9b1659c4$export$2e2bcd8739ae039);

var $3s7bc = parcelRequire("3s7bc");
function $0c96e22a9b1659c4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $3s7bc.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("h5cF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6fcb9ddb0a619f3$export$2e2bcd8739ae039);

var $e0fSj = parcelRequire("e0fSj");

var $lk0oF = parcelRequire("lk0oF");

var $itJII = parcelRequire("itJII");

var $gNrKz = parcelRequire("gNrKz");
function $c6fcb9ddb0a619f3$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $e0fSj.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $itJII.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $gNrKz.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6fcb9ddb0a619f3$export$2e2bcd8739ae039((0, $lk0oF.default)(target)));
}

});
parcelRegister("e0fSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $a31d6136541392dc$export$2e2bcd8739ae039);

var $lk0oF = parcelRequire("lk0oF");

var $gNrKz = parcelRequire("gNrKz");

var $4J6FJ = parcelRequire("4J6FJ");

var $fkZ9S = parcelRequire("fkZ9S");
function $a31d6136541392dc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $4J6FJ.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fkZ9S.isHTMLElement)(node) && (0, $gNrKz.default)(node)) return node;
    return $a31d6136541392dc$export$2e2bcd8739ae039((0, $lk0oF.default)(node));
}

});
parcelRegister("lk0oF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f85bc6099bdeb764$export$2e2bcd8739ae039);

var $4J6FJ = parcelRequire("4J6FJ");

var $cFIMZ = parcelRequire("cFIMZ");

var $fkZ9S = parcelRequire("fkZ9S");
function $f85bc6099bdeb764$export$2e2bcd8739ae039(element) {
    if ((0, $4J6FJ.default)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fkZ9S.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $cFIMZ.default)(element) // fallback
    );
}

});



parcelRegister("cbrCY", function(module, exports) {

$parcel$export(module.exports, "default", () => $8debf15f2d350881$export$2e2bcd8739ae039);

var $itJII = parcelRequire("itJII");

var $4J6FJ = parcelRequire("4J6FJ");

var $inPKD = parcelRequire("inPKD");

var $fkZ9S = parcelRequire("fkZ9S");

var $cLXD3 = parcelRequire("cLXD3");

var $lk0oF = parcelRequire("lk0oF");

var $21bjM = parcelRequire("21bjM");
function $8debf15f2d350881$var$getTrueOffsetParent(element) {
    if (!(0, $fkZ9S.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $inPKD.default)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $8debf15f2d350881$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $21bjM.default)());
    var isIE = /Trident/i.test((0, $21bjM.default)());
    if (isIE && (0, $fkZ9S.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $inPKD.default)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $lk0oF.default)(element);
    if ((0, $fkZ9S.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $fkZ9S.isHTMLElement)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $4J6FJ.default)(currentNode)) < 0){
        var css = (0, $inPKD.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $8debf15f2d350881$export$2e2bcd8739ae039(element) {
    var window = (0, $itJII.default)(element);
    var offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $cLXD3.default)(offsetParent) && (0, $inPKD.default)(offsetParent).position === 'static')offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4J6FJ.default)(offsetParent) === 'html' || (0, $4J6FJ.default)(offsetParent) === 'body' && (0, $inPKD.default)(offsetParent).position === 'static')) return window;
    return offsetParent || $8debf15f2d350881$var$getContainingBlock(element) || window;
}

});
parcelRegister("cLXD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $94c820df5d403ed2$export$2e2bcd8739ae039);

var $4J6FJ = parcelRequire("4J6FJ");
function $94c820df5d403ed2$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $4J6FJ.default)(element)) >= 0;
}

});


parcelRegister("aXvuZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7fa7d91227c213a7$export$2e2bcd8739ae039);

var $cT3u7 = parcelRequire("cT3u7");
function $7fa7d91227c213a7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7fa7d91227c213a7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7fa7d91227c213a7$var$order(modifiers); // order based on phase
    return (0, $cT3u7.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("cT3u7", function(module, exports) {

$parcel$export(module.exports, "top", () => $961d5315ffabf519$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $961d5315ffabf519$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $961d5315ffabf519$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $961d5315ffabf519$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $961d5315ffabf519$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $961d5315ffabf519$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $961d5315ffabf519$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $961d5315ffabf519$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $961d5315ffabf519$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $961d5315ffabf519$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $961d5315ffabf519$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $961d5315ffabf519$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $961d5315ffabf519$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $961d5315ffabf519$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $961d5315ffabf519$export$d087d3878fdf71d5);
var $961d5315ffabf519$export$1e95b668f3b82d = 'top';
var $961d5315ffabf519$export$40e543e69a8b3fbb = 'bottom';
var $961d5315ffabf519$export$79ffe56a765070d2 = 'right';
var $961d5315ffabf519$export$eabcd2c8791e7bf4 = 'left';
var $961d5315ffabf519$export$dfb5619354ba860 = 'auto';
var $961d5315ffabf519$export$aec2ce47c367b8c3 = [
    $961d5315ffabf519$export$1e95b668f3b82d,
    $961d5315ffabf519$export$40e543e69a8b3fbb,
    $961d5315ffabf519$export$79ffe56a765070d2,
    $961d5315ffabf519$export$eabcd2c8791e7bf4
];
var $961d5315ffabf519$export$b3571188c770cc5a = 'start';
var $961d5315ffabf519$export$bd5df0f255a350f8 = 'end';
var $961d5315ffabf519$export$390fd549c5303b4d = 'clippingParents';
var $961d5315ffabf519$export$d7b7311ec04a3e8f = 'viewport';
var $961d5315ffabf519$export$ae5ab1c730825774 = 'popper';
var $961d5315ffabf519$export$ca50aac9f3ba507f = 'reference';
var $961d5315ffabf519$export$368f9a87e87fa4e1 = /*#__PURE__*/ $961d5315ffabf519$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []);
var $961d5315ffabf519$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($961d5315ffabf519$export$aec2ce47c367b8c3, [
    $961d5315ffabf519$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $961d5315ffabf519$export$421679a7c3d56e = 'beforeRead';
var $961d5315ffabf519$export$aafa59e2e03f2942 = 'read';
var $961d5315ffabf519$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $961d5315ffabf519$export$c65e99957a05207c = 'beforeMain';
var $961d5315ffabf519$export$f22da7240b7add18 = 'main';
var $961d5315ffabf519$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $961d5315ffabf519$export$8d4d2d70e7d46032 = 'beforeWrite';
var $961d5315ffabf519$export$68d8715fc104d294 = 'write';
var $961d5315ffabf519$export$70a6e5159acce2e6 = 'afterWrite';
var $961d5315ffabf519$export$d087d3878fdf71d5 = [
    $961d5315ffabf519$export$421679a7c3d56e,
    $961d5315ffabf519$export$aafa59e2e03f2942,
    $961d5315ffabf519$export$6964f6c886723980,
    $961d5315ffabf519$export$c65e99957a05207c,
    $961d5315ffabf519$export$f22da7240b7add18,
    $961d5315ffabf519$export$bab79516f2d662fe,
    $961d5315ffabf519$export$8d4d2d70e7d46032,
    $961d5315ffabf519$export$68d8715fc104d294,
    $961d5315ffabf519$export$70a6e5159acce2e6
];

});


parcelRegister("4vGTc", function(module, exports) {

$parcel$export(module.exports, "default", () => $348b53990a67b9f2$export$2e2bcd8739ae039);
function $348b53990a67b9f2$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("asNAh", function(module, exports) {

$parcel$export(module.exports, "default", () => $79e2fb482cad3d90$export$2e2bcd8739ae039);
function $79e2fb482cad3d90$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("aDDto", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bec2a6e2c97de64$export$2e2bcd8739ae039);

var $itJII = parcelRequire("itJII");
var $7bec2a6e2c97de64$var$passive = {
    passive: true
};
function $7bec2a6e2c97de64$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $itJII.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $7bec2a6e2c97de64$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $7bec2a6e2c97de64$var$effect,
    data: {}
};

});

parcelRegister("lJMws", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd3370820cf4bcb1$export$2e2bcd8739ae039);

var $7N2G9 = parcelRequire("7N2G9");
function $fd3370820cf4bcb1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $7N2G9.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $fd3370820cf4bcb1$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $fd3370820cf4bcb1$var$popperOffsets,
    data: {}
};

});
parcelRegister("7N2G9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5abf2ff6da597e22$export$2e2bcd8739ae039);

var $572Wi = parcelRequire("572Wi");

var $5EfCl = parcelRequire("5EfCl");

var $laHqy = parcelRequire("laHqy");

var $cT3u7 = parcelRequire("cT3u7");
function $5abf2ff6da597e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $572Wi.default)(placement) : null;
    var variation = placement ? (0, $5EfCl.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $cT3u7.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $cT3u7.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $cT3u7.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $cT3u7.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $laHqy.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $cT3u7.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $cT3u7.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("572Wi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b8fe2dc5ff68c07$export$2e2bcd8739ae039);

function $3b8fe2dc5ff68c07$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}

});

parcelRegister("5EfCl", function(module, exports) {

$parcel$export(module.exports, "default", () => $41cccd7fabe05f63$export$2e2bcd8739ae039);
function $41cccd7fabe05f63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}

});

parcelRegister("laHqy", function(module, exports) {

$parcel$export(module.exports, "default", () => $f69c37e7bc9eb348$export$2e2bcd8739ae039);
function $f69c37e7bc9eb348$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}

});



parcelRegister("g87Ka", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbe366718497d634$export$2e2bcd8739ae039);

var $cT3u7 = parcelRequire("cT3u7");

var $cbrCY = parcelRequire("cbrCY");

var $itJII = parcelRequire("itJII");

var $cFIMZ = parcelRequire("cFIMZ");

var $inPKD = parcelRequire("inPKD");

var $572Wi = parcelRequire("572Wi");

var $5EfCl = parcelRequire("5EfCl");

var $oyBem = parcelRequire("oyBem");
var $bbe366718497d634$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $bbe366718497d634$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $oyBem.round)(x * dpr) / dpr || 0,
        y: (0, $oyBem.round)(y * dpr) / dpr || 0
    };
}
function $bbe366718497d634$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $cT3u7.left);
    var sideY = (0, $cT3u7.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $cbrCY.default)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $itJII.default)(popper)) {
            offsetParent = (0, $cFIMZ.default)(popper);
            if ((0, $inPKD.default)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $cT3u7.top) || (placement === (0, $cT3u7.left) || placement === (0, $cT3u7.right)) && variation === (0, $cT3u7.end)) {
            sideY = (0, $cT3u7.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $cT3u7.left) || (placement === (0, $cT3u7.top) || placement === (0, $cT3u7.bottom)) && variation === (0, $cT3u7.end)) {
            sideX = (0, $cT3u7.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $bbe366718497d634$var$unsetSides);
    var _ref4 = roundOffsets === true ? $bbe366718497d634$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $itJII.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $bbe366718497d634$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $572Wi.default)(state.placement),
        variation: (0, $5EfCl.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bbe366718497d634$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $bbe366718497d634$var$computeStyles,
    data: {}
};

});

parcelRegister("j3NRo", function(module, exports) {

$parcel$export(module.exports, "default", () => $de04f959dc6fc8a8$export$2e2bcd8739ae039);

var $4J6FJ = parcelRequire("4J6FJ");

var $fkZ9S = parcelRequire("fkZ9S");
// and applies them to the HTMLElements such as popper and arrow
function $de04f959dc6fc8a8$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fkZ9S.isHTMLElement)(element) || !(0, $4J6FJ.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $de04f959dc6fc8a8$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fkZ9S.isHTMLElement)(element) || !(0, $4J6FJ.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $de04f959dc6fc8a8$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $de04f959dc6fc8a8$var$applyStyles,
    effect: $de04f959dc6fc8a8$var$effect,
    requires: [
        'computeStyles'
    ]
};

});

parcelRegister("8lu61", function(module, exports) {

$parcel$export(module.exports, "default", () => $6137a161b4896709$export$2e2bcd8739ae039);

var $572Wi = parcelRequire("572Wi");

var $cT3u7 = parcelRequire("cT3u7");
function $6137a161b4896709$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $572Wi.default)(placement);
    var invertDistance = [
        (0, $cT3u7.left),
        (0, $cT3u7.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $cT3u7.left),
        (0, $cT3u7.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $6137a161b4896709$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $cT3u7.placements).reduce(function(acc, placement) {
        acc[placement] = $6137a161b4896709$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6137a161b4896709$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $6137a161b4896709$var$offset
};

});

parcelRegister("9OQN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7261bb7a28c6c261$export$2e2bcd8739ae039);

var $bMXA3 = parcelRequire("bMXA3");

var $572Wi = parcelRequire("572Wi");

var $4fQ2B = parcelRequire("4fQ2B");

var $kZYf8 = parcelRequire("kZYf8");

var $8a0jo = parcelRequire("8a0jo");

var $cT3u7 = parcelRequire("cT3u7");

var $5EfCl = parcelRequire("5EfCl");
function $7261bb7a28c6c261$var$getExpandedFallbackPlacements(placement) {
    if ((0, $572Wi.default)(placement) === (0, $cT3u7.auto)) return [];
    var oppositePlacement = (0, $bMXA3.default)(placement);
    return [
        (0, $4fQ2B.default)(placement),
        oppositePlacement,
        (0, $4fQ2B.default)(oppositePlacement)
    ];
}
function $7261bb7a28c6c261$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $572Wi.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $bMXA3.default)(preferredPlacement)
    ] : $7261bb7a28c6c261$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $572Wi.default)(placement) === (0, $cT3u7.auto) ? (0, $8a0jo.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $572Wi.default)(placement);
        var isStartVariation = (0, $5EfCl.default)(placement) === (0, $cT3u7.start);
        var isVertical = [
            (0, $cT3u7.top),
            (0, $cT3u7.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $kZYf8.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $cT3u7.right) : (0, $cT3u7.left) : isStartVariation ? (0, $cT3u7.bottom) : (0, $cT3u7.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $bMXA3.default)(mainVariationSide);
        var altVariationSide = (0, $bMXA3.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7261bb7a28c6c261$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $7261bb7a28c6c261$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("bMXA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $895264d7f1285abd$export$2e2bcd8739ae039);
var $895264d7f1285abd$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $895264d7f1285abd$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $895264d7f1285abd$var$hash[matched];
    });
}

});

parcelRegister("4fQ2B", function(module, exports) {

$parcel$export(module.exports, "default", () => $3190ee6894c64586$export$2e2bcd8739ae039);
var $3190ee6894c64586$var$hash = {
    start: 'end',
    end: 'start'
};
function $3190ee6894c64586$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3190ee6894c64586$var$hash[matched];
    });
}

});

parcelRegister("kZYf8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4983c2f7b82930e$export$2e2bcd8739ae039);

var $5opUK = parcelRequire("5opUK");

var $cFIMZ = parcelRequire("cFIMZ");

var $3s7bc = parcelRequire("3s7bc");

var $7N2G9 = parcelRequire("7N2G9");

var $44Es0 = parcelRequire("44Es0");

var $cT3u7 = parcelRequire("cT3u7");

var $fkZ9S = parcelRequire("fkZ9S");

var $6IvoO = parcelRequire("6IvoO");

var $bygJQ = parcelRequire("bygJQ");
function $f4983c2f7b82930e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $cT3u7.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $cT3u7.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $cT3u7.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $6IvoO.default)(typeof padding !== 'number' ? padding : (0, $bygJQ.default)(padding, (0, $cT3u7.basePlacements)));
    var altContext = elementContext === (0, $cT3u7.popper) ? (0, $cT3u7.reference) : (0, $cT3u7.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5opUK.default)((0, $fkZ9S.isElement)(element) ? element : element.contextElement || (0, $cFIMZ.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $3s7bc.default)(state.elements.reference);
    var popperOffsets = (0, $7N2G9.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $44Es0.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $cT3u7.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $cT3u7.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $cT3u7.right),
                (0, $cT3u7.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $cT3u7.top),
                (0, $cT3u7.bottom)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5opUK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed34baa7075c065$export$2e2bcd8739ae039);

var $cT3u7 = parcelRequire("cT3u7");

var $6yAX0 = parcelRequire("6yAX0");

var $4mnAn = parcelRequire("4mnAn");

var $h5cF9 = parcelRequire("h5cF9");

var $cbrCY = parcelRequire("cbrCY");

var $cFIMZ = parcelRequire("cFIMZ");

var $inPKD = parcelRequire("inPKD");

var $fkZ9S = parcelRequire("fkZ9S");

var $3s7bc = parcelRequire("3s7bc");

var $lk0oF = parcelRequire("lk0oF");

var $kpfPD = parcelRequire("kpfPD");

var $4J6FJ = parcelRequire("4J6FJ");

var $44Es0 = parcelRequire("44Es0");

var $oyBem = parcelRequire("oyBem");
function $3ed34baa7075c065$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $3s7bc.default)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $cT3u7.viewport) ? (0, $44Es0.default)((0, $6yAX0.default)(element, strategy)) : (0, $fkZ9S.isElement)(clippingParent) ? $3ed34baa7075c065$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $44Es0.default)((0, $4mnAn.default)((0, $cFIMZ.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $3ed34baa7075c065$var$getClippingParents(element) {
    var clippingParents = (0, $h5cF9.default)((0, $lk0oF.default)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $inPKD.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fkZ9S.isHTMLElement)(element) ? (0, $cbrCY.default)(element) : element;
    if (!(0, $fkZ9S.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fkZ9S.isElement)(clippingParent) && (0, $kpfPD.default)(clippingParent, clipperElement) && (0, $4J6FJ.default)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $3ed34baa7075c065$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $3ed34baa7075c065$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $oyBem.max)(rect.top, accRect.top);
        accRect.right = (0, $oyBem.min)(rect.right, accRect.right);
        accRect.bottom = (0, $oyBem.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $oyBem.max)(rect.left, accRect.left);
        return accRect;
    }, $3ed34baa7075c065$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("6yAX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c6294ad0a5a884e$export$2e2bcd8739ae039);

var $itJII = parcelRequire("itJII");

var $cFIMZ = parcelRequire("cFIMZ");

var $7a9Wo = parcelRequire("7a9Wo");

var $4OOct = parcelRequire("4OOct");
function $4c6294ad0a5a884e$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $itJII.default)(element);
    var html = (0, $cFIMZ.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $4OOct.default)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $7a9Wo.default)(element),
        y: y
    };
}

});

parcelRegister("4mnAn", function(module, exports) {

$parcel$export(module.exports, "default", () => $32cb83235cf6af6b$export$2e2bcd8739ae039);

var $cFIMZ = parcelRequire("cFIMZ");

var $inPKD = parcelRequire("inPKD");

var $7a9Wo = parcelRequire("7a9Wo");

var $jVJlU = parcelRequire("jVJlU");

var $oyBem = parcelRequire("oyBem");
function $32cb83235cf6af6b$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $cFIMZ.default)(element);
    var winScroll = (0, $jVJlU.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $oyBem.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $oyBem.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $7a9Wo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $inPKD.default)(body || html).direction === 'rtl') x += (0, $oyBem.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("kpfPD", function(module, exports) {

$parcel$export(module.exports, "default", () => $edb26c5020cedcb8$export$2e2bcd8739ae039);

var $fkZ9S = parcelRequire("fkZ9S");
function $edb26c5020cedcb8$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fkZ9S.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("44Es0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f76e9cca25369aa$export$2e2bcd8739ae039);
function $2f76e9cca25369aa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("6IvoO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e3f355f6e420d75$export$2e2bcd8739ae039);

var $7lIdl = parcelRequire("7lIdl");
function $4e3f355f6e420d75$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $7lIdl.default)(), paddingObject);
}

});
parcelRegister("7lIdl", function(module, exports) {

$parcel$export(module.exports, "default", () => $559cca984964a2c1$export$2e2bcd8739ae039);
function $559cca984964a2c1$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("bygJQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $868fda9c4887b436$export$2e2bcd8739ae039);
function $868fda9c4887b436$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("8a0jo", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f0f7fd33e6df374$export$2e2bcd8739ae039);

var $5EfCl = parcelRequire("5EfCl");

var $cT3u7 = parcelRequire("cT3u7");

var $kZYf8 = parcelRequire("kZYf8");

var $572Wi = parcelRequire("572Wi");
function $5f0f7fd33e6df374$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $cT3u7.placements) : _options$allowedAutoP;
    var variation = (0, $5EfCl.default)(placement);
    var placements = variation ? flipVariations ? (0, $cT3u7.variationPlacements) : (0, $cT3u7.variationPlacements).filter(function(placement) {
        return (0, $5EfCl.default)(placement) === variation;
    }) : (0, $cT3u7.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $kZYf8.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $572Wi.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("duXMG", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d3c739e2059661f$export$2e2bcd8739ae039);

var $cT3u7 = parcelRequire("cT3u7");

var $572Wi = parcelRequire("572Wi");

var $laHqy = parcelRequire("laHqy");

var $5YRgx = parcelRequire("5YRgx");

var $4lFCJ = parcelRequire("4lFCJ");

var $150O2 = parcelRequire("150O2");

var $cbrCY = parcelRequire("cbrCY");

var $kZYf8 = parcelRequire("kZYf8");

var $5EfCl = parcelRequire("5EfCl");

var $7lIdl = parcelRequire("7lIdl");

var $oyBem = parcelRequire("oyBem");
function $9d3c739e2059661f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $kZYf8.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $572Wi.default)(state.placement);
    var variation = (0, $5EfCl.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $laHqy.default)(basePlacement);
    var altAxis = (0, $5YRgx.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $cT3u7.top) : (0, $cT3u7.left);
        var altSide = mainAxis === 'y' ? (0, $cT3u7.bottom) : (0, $cT3u7.right);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $cT3u7.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $cT3u7.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $150O2.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $7lIdl.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $4lFCJ.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $cbrCY.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $4lFCJ.within)(tether ? (0, $oyBem.min)(min, tetherMin) : min, offset, tether ? (0, $oyBem.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $cT3u7.top) : (0, $cT3u7.left);
        var _altSide = mainAxis === 'x' ? (0, $cT3u7.bottom) : (0, $cT3u7.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $cT3u7.top),
            (0, $cT3u7.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $4lFCJ.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $4lFCJ.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9d3c739e2059661f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9d3c739e2059661f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};

});
parcelRegister("5YRgx", function(module, exports) {

$parcel$export(module.exports, "default", () => $45abdfcc61968a12$export$2e2bcd8739ae039);
function $45abdfcc61968a12$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}

});

parcelRegister("4lFCJ", function(module, exports) {

$parcel$export(module.exports, "within", () => $32a9692ec37d141e$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $32a9692ec37d141e$export$86c8af6d3ef0b4a);

var $oyBem = parcelRequire("oyBem");
function $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max) {
    return (0, $oyBem.max)(min, (0, $oyBem.min)(value, max));
}
function $32a9692ec37d141e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("6fRL5", function(module, exports) {

$parcel$export(module.exports, "default", () => $48ddd81393695a53$export$2e2bcd8739ae039);

var $572Wi = parcelRequire("572Wi");

var $150O2 = parcelRequire("150O2");

var $kpfPD = parcelRequire("kpfPD");

var $cbrCY = parcelRequire("cbrCY");

var $laHqy = parcelRequire("laHqy");

var $4lFCJ = parcelRequire("4lFCJ");

var $6IvoO = parcelRequire("6IvoO");

var $bygJQ = parcelRequire("bygJQ");

var $cT3u7 = parcelRequire("cT3u7");
var $48ddd81393695a53$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $6IvoO.default)(typeof padding !== 'number' ? padding : (0, $bygJQ.default)(padding, (0, $cT3u7.basePlacements)));
};
function $48ddd81393695a53$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $572Wi.default)(state.placement);
    var axis = (0, $laHqy.default)(basePlacement);
    var isVertical = [
        (0, $cT3u7.left),
        (0, $cT3u7.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $48ddd81393695a53$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $150O2.default)(arrowElement);
    var minProp = axis === 'y' ? (0, $cT3u7.top) : (0, $cT3u7.left);
    var maxProp = axis === 'y' ? (0, $cT3u7.bottom) : (0, $cT3u7.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $cbrCY.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $4lFCJ.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $48ddd81393695a53$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $kpfPD.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $48ddd81393695a53$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $48ddd81393695a53$var$arrow,
    effect: $48ddd81393695a53$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};

});

parcelRegister("iwOwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7d2695ea28b2aa6$export$2e2bcd8739ae039);

var $cT3u7 = parcelRequire("cT3u7");

var $kZYf8 = parcelRequire("kZYf8");
function $d7d2695ea28b2aa6$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d7d2695ea28b2aa6$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $cT3u7.top),
        (0, $cT3u7.right),
        (0, $cT3u7.bottom),
        (0, $cT3u7.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d7d2695ea28b2aa6$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $kZYf8.default)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $kZYf8.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d7d2695ea28b2aa6$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d7d2695ea28b2aa6$var$hide
};

});


parcelRegister("1Oxdt", function(module, exports) {

$parcel$export(module.exports, "default", () => $15243a0278f5fe06$export$2e2bcd8739ae039);

var $15Pai = parcelRequire("15Pai");

var $bxjbZ = parcelRequire("bxjbZ");

var $iZtpD = parcelRequire("iZtpD");

var $bOwbu = parcelRequire("bOwbu");
'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $15243a0278f5fe06$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $bOwbu.default)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $iZtpD.default)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $15Pai.default)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $bxjbZ.default)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $15243a0278f5fe06$export$2e2bcd8739ae039 = $15243a0278f5fe06$var$useSlotProps;

});

parcelRegister("j1Xwx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddac487f30060dc3$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");

var $8vWo2 = parcelRequire("8vWo2");


var $dbTJ5 = parcelRequire("dbTJ5");

var $15Pai = parcelRequire("15Pai");

var $k0W9t = parcelRequire("k0W9t");

var $e4lkb = parcelRequire("e4lkb");


'use client';
function $ddac487f30060dc3$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $ddac487f30060dc3$var$Portal = /*#__PURE__*/ $jXEQt.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $jXEQt.useState(null);
    const handleRef = (0, $15Pai.default)(/*#__PURE__*/ $jXEQt.isValidElement(children) ? (0, $e4lkb.default)(children) : null, forwardedRef);
    (0, $dbTJ5.default)(()=>{
        if (!disablePortal) setMountNode($ddac487f30060dc3$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $dbTJ5.default)(()=>{
        if (mountNode && !disablePortal) {
            (0, $k0W9t.default)(forwardedRef, mountNode);
            return ()=>{
                (0, $k0W9t.default)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $jXEQt.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $jXEQt.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $8vWo2.createPortal(children, mountNode) : mountNode;
});
var $ddac487f30060dc3$export$2e2bcd8739ae039 = $ddac487f30060dc3$var$Portal;

});
parcelRegister("k0W9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $e920ea722cd56019$export$2e2bcd8739ae039);
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $e920ea722cd56019$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}

});


parcelRegister("6dPAN", function(module, exports) {

$parcel$export(module.exports, "getPopperUtilityClass", () => $487bfa2eaa35fcfb$export$1b69b6cd0fa638a1);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $487bfa2eaa35fcfb$export$1b69b6cd0fa638a1(slot) {
    return (0, $5KipK.default)('MuiPopper', slot);
}
const $487bfa2eaa35fcfb$var$popperClasses = (0, $1XfUG.default)('MuiPopper', [
    'root'
]);
var $487bfa2eaa35fcfb$export$2e2bcd8739ae039 = $487bfa2eaa35fcfb$var$popperClasses;

});



parcelRegister("8H6A5", function(module, exports) {

$parcel$export(module.exports, "default", () => $654771c0d7731481$export$2e2bcd8739ae039);

var $ab4rY = parcelRequire("ab4rY");
'use client';
var $654771c0d7731481$export$2e2bcd8739ae039 = (0, $ab4rY.default);

});
parcelRegister("ab4rY", function(module, exports) {

$parcel$export(module.exports, "default", () => $768e622819c435ac$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
'use client';
let $768e622819c435ac$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $768e622819c435ac$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $jXEQt.useState(idOverride);
    const id = idOverride || defaultId;
    $jXEQt.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $768e622819c435ac$var$globalId += 1;
            setDefaultId(`mui-${$768e622819c435ac$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $768e622819c435ac$var$safeReact = {
    ...$jXEQt
};
const $768e622819c435ac$var$maybeReactUseId = $768e622819c435ac$var$safeReact.useId;
function $768e622819c435ac$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($768e622819c435ac$var$maybeReactUseId !== undefined) {
        const reactId = $768e622819c435ac$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $768e622819c435ac$var$useGlobalId(idOverride);
}

});


parcelRegister("3e8Jg", function(module, exports) {

$parcel$export(module.exports, "default", () => $25997351edcdd9ea$export$2e2bcd8739ae039);

var $7PXt3 = parcelRequire("7PXt3");
'use client';
var $25997351edcdd9ea$export$2e2bcd8739ae039 = (0, $7PXt3.default);

});
parcelRegister("7PXt3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b4b6ce0ab6be320$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
'use client';
function $5b4b6ce0ab6be320$export$2e2bcd8739ae039(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $jXEQt.useRef(controlled !== undefined);
    const [valueState, setValue] = $jXEQt.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $jXEQt.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefined.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}

});


parcelRegister("fKXvC", function(module, exports) {

$parcel$export(module.exports, "getTooltipUtilityClass", () => $b78950245a853afd$export$837848f5f6cee923);
$parcel$export(module.exports, "default", () => $b78950245a853afd$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $b78950245a853afd$export$837848f5f6cee923(slot) {
    return (0, $5KipK.default)('MuiTooltip', slot);
}
const $b78950245a853afd$var$tooltipClasses = (0, $1XfUG.default)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $b78950245a853afd$export$2e2bcd8739ae039 = $b78950245a853afd$var$tooltipClasses;

});


parcelRegister("eS20P", function(module, exports) {

$parcel$export(module.exports, "setRegistration", () => $c9aa9bf2d714c10d$export$759f8a34124786ad);
$parcel$export(module.exports, "getRegistration", () => $c9aa9bf2d714c10d$export$a35b37ee90a58202);
$parcel$export(module.exports, "triggerUpdate", () => $c9aa9bf2d714c10d$export$a919c1a90625f75a);
// Store the service worker registration outside of React/Redux since it's not serializable
// Similar pattern to how we store the PouchDB handle in src/client/db/index.ts
let $c9aa9bf2d714c10d$var$registration;
function $c9aa9bf2d714c10d$export$759f8a34124786ad(reg) {
    $c9aa9bf2d714c10d$var$registration = reg;
}
function $c9aa9bf2d714c10d$export$a35b37ee90a58202() {
    return $c9aa9bf2d714c10d$var$registration;
}
function $c9aa9bf2d714c10d$export$a919c1a90625f75a() {
    $c9aa9bf2d714c10d$var$registration?.waiting?.postMessage({
        type: 'SKIP_WAITING'
    });
}

});

parcelRegister("jAvTI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e42a1f53fc377116$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $5ZtsM = parcelRequire("5ZtsM");

var $3ptEP = parcelRequire("3ptEP");

var $8H6A5 = parcelRequire("8H6A5");

var $i29Fs = parcelRequire("i29Fs");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $7lGG0 = parcelRequire("7lGG0");

var $ab5Dn = parcelRequire("ab5Dn");

var $dvg8e = parcelRequire("dvg8e");

var $8oH7q = parcelRequire("8oH7q");

var $bqzgJ = parcelRequire("bqzgJ");

var $7DLqq = parcelRequire("7DLqq");

var $bhZk4 = parcelRequire("bhZk4");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $e42a1f53fc377116$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $dvg8e.default)(color)}`,
            `size${(0, $dvg8e.default)(size)}`,
            `${variant}Size${(0, $dvg8e.default)(size)}`,
            `color${(0, $dvg8e.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $dvg8e.default)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $dvg8e.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $dvg8e.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $3ptEP.default)(slots, (0, $bqzgJ.getButtonUtilityClass), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $e42a1f53fc377116$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $e42a1f53fc377116$var$ButtonRoot = (0, $3EMXY.default)((0, $7lGG0.default), {
    shouldForwardProp: (prop)=>(0, $i29Fs.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $dvg8e.default)(ownerState.color)}`],
            styles[`size${(0, $dvg8e.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $dvg8e.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $bqzgJ.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $bqzgJ.default).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $bqzgJ.default).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $bqzgJ.default).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.alpha((theme.vars || theme).palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $bqzgJ.default).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $bqzgJ.default).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $bqzgJ.default).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $e42a1f53fc377116$var$ButtonStartIcon = (0, $3EMXY.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $dvg8e.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$e42a1f53fc377116$var$commonIconStyles
        ]
    }));
const $e42a1f53fc377116$var$ButtonEndIcon = (0, $3EMXY.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $dvg8e.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$e42a1f53fc377116$var$commonIconStyles
        ]
    }));
const $e42a1f53fc377116$var$ButtonLoadingIndicator = (0, $3EMXY.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $e42a1f53fc377116$var$ButtonLoadingIconPlaceholder = (0, $3EMXY.default)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $e42a1f53fc377116$var$Button = /*#__PURE__*/ $jXEQt.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $jXEQt.useContext((0, $7DLqq.default));
    const buttonGroupButtonContextPositionClassName = $jXEQt.useContext((0, $bhZk4.default));
    const resolvedProps = (0, $5ZtsM.default)(contextProps, inProps);
    const props = (0, $5MTiZ.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $8H6A5.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $7rM61.jsx)((0, $ab5Dn.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $e42a1f53fc377116$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $7rM61.jsx)($e42a1f53fc377116$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $7rM61.jsx)($e42a1f53fc377116$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $7rM61.jsx)($e42a1f53fc377116$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $7rM61.jsx)($e42a1f53fc377116$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $7rM61.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $7rM61.jsx)($e42a1f53fc377116$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $7rM61.jsxs)($e42a1f53fc377116$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $fQojQ.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $fQojQ.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $e42a1f53fc377116$export$2e2bcd8739ae039 = $e42a1f53fc377116$var$Button;

});
parcelRegister("bqzgJ", function(module, exports) {

$parcel$export(module.exports, "getButtonUtilityClass", () => $851d7b19f60c5777$export$5a6f9035944c8119);
$parcel$export(module.exports, "default", () => $851d7b19f60c5777$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $851d7b19f60c5777$export$5a6f9035944c8119(slot) {
    return (0, $5KipK.default)('MuiButton', slot);
}
const $851d7b19f60c5777$var$buttonClasses = (0, $1XfUG.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $851d7b19f60c5777$export$2e2bcd8739ae039 = $851d7b19f60c5777$var$buttonClasses;

});

parcelRegister("7DLqq", function(module, exports) {

$parcel$export(module.exports, "default", () => $5900f695f6b66fc8$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
'use client';
/**
 * @ignore - internal component.
 */ const $5900f695f6b66fc8$var$ButtonGroupContext = /*#__PURE__*/ $jXEQt.createContext({});
var $5900f695f6b66fc8$export$2e2bcd8739ae039 = $5900f695f6b66fc8$var$ButtonGroupContext;

});

parcelRegister("bhZk4", function(module, exports) {

$parcel$export(module.exports, "default", () => $8380d9a80527a7c8$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
'use client';
/**
 * @ignore - internal component.
 */ const $8380d9a80527a7c8$var$ButtonGroupButtonContext = /*#__PURE__*/ $jXEQt.createContext(undefined);
var $8380d9a80527a7c8$export$2e2bcd8739ae039 = $8380d9a80527a7c8$var$ButtonGroupButtonContext;

});


parcelRegister("DjMuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0762fcbf02b7b5db$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $ab4rY = parcelRequire("ab4rY");


var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");

var $jpsSb = parcelRequire("jpsSb");

var $64c0d = parcelRequire("64c0d");

var $iudyD = parcelRequire("iudyD");

var $25XC6 = parcelRequire("25XC6");

var $arJ8O = parcelRequire("arJ8O");

var $1eyRb = parcelRequire("1eyRb");

var $8dth4 = parcelRequire("8dth4");

var $fgESc = parcelRequire("fgESc");

var $f92r2 = parcelRequire("f92r2");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $0762fcbf02b7b5db$var$variantComponent = {
    standard: (0, $jpsSb.default),
    filled: (0, $64c0d.default),
    outlined: (0, $iudyD.default)
};
const $0762fcbf02b7b5db$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $fgESc.getTextFieldUtilityClass), classes);
};
const $0762fcbf02b7b5db$var$TextFieldRoot = (0, $3EMXY.default)((0, $arJ8O.default), {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $0762fcbf02b7b5db$var$TextField = /*#__PURE__*/ $jXEQt.forwardRef(function TextField(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $0762fcbf02b7b5db$var$useUtilityClasses(ownerState);
    const id = (0, $ab4rY.default)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $0762fcbf02b7b5db$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $f92r2.default)('root', {
        elementType: $0762fcbf02b7b5db$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $f92r2.default)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $f92r2.default)('inputLabel', {
        elementType: (0, $25XC6.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $f92r2.default)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $f92r2.default)('formHelperText', {
        elementType: (0, $1eyRb.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $f92r2.default)('select', {
        elementType: (0, $8dth4.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $7rM61.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $7rM61.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $7rM61.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $7rM61.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $7rM61.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $0762fcbf02b7b5db$export$2e2bcd8739ae039 = $0762fcbf02b7b5db$var$TextField;

});
parcelRegister("jpsSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $e216bfaca921ba77$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $3ptEP = parcelRequire("3ptEP");

var $cqtAx = parcelRequire("cqtAx");


var $fSntC = parcelRequire("fSntC");

var $i29Fs = parcelRequire("i29Fs");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $8oH7q = parcelRequire("8oH7q");

var $5MTiZ = parcelRequire("5MTiZ");

var $6nBZ2 = parcelRequire("6nBZ2");

var $fSntC = parcelRequire("fSntC");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $e216bfaca921ba77$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $3ptEP.default)(slots, (0, $6nBZ2.getInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $e216bfaca921ba77$var$InputRoot = (0, $3EMXY.default)((0, $fSntC.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $i29Fs.default)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $fSntC.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $6nBZ2.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $6nBZ2.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $6nBZ2.default).disabled}, .${(0, $6nBZ2.default).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $6nBZ2.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $e216bfaca921ba77$var$InputInput = (0, $3EMXY.default)((0, $fSntC.InputBaseInput), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $fSntC.inputOverridesResolver)
})({});
const $e216bfaca921ba77$var$Input = /*#__PURE__*/ $jXEQt.forwardRef(function Input(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $e216bfaca921ba77$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $cqtAx.default)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $e216bfaca921ba77$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $e216bfaca921ba77$var$InputInput;
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $fSntC.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$e216bfaca921ba77$var$Input.muiName = 'Input';
var $e216bfaca921ba77$export$2e2bcd8739ae039 = $e216bfaca921ba77$var$Input;

});
parcelRegister("fSntC", function(module, exports) {

$parcel$export(module.exports, "rootOverridesResolver", () => $b8ee1c2214b6dabd$export$965edad20a84fa75);
$parcel$export(module.exports, "inputOverridesResolver", () => $b8ee1c2214b6dabd$export$cf507b112810e72d);
$parcel$export(module.exports, "InputBaseRoot", () => $b8ee1c2214b6dabd$export$298a043133d72a38);
$parcel$export(module.exports, "InputBaseInput", () => $b8ee1c2214b6dabd$export$ee10465db6ff6017);
$parcel$export(module.exports, "default", () => $b8ee1c2214b6dabd$export$2e2bcd8739ae039);

var $fskif = parcelRequire("fskif");

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");



var $3ptEP = parcelRequire("3ptEP");

var $9viLJ = parcelRequire("9viLJ");

var $eOeM6 = parcelRequire("eOeM6");

var $eSieo = parcelRequire("eSieo");

var $ejO7q = parcelRequire("ejO7q");

var $1D77Z = parcelRequire("1D77Z");

var $2KJEQ = parcelRequire("2KJEQ");
var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $dvg8e = parcelRequire("dvg8e");

var $89QD5 = parcelRequire("89QD5");

var $kJD0o = parcelRequire("kJD0o");

var $eAUw7 = parcelRequire("eAUw7");

var $dX94m = parcelRequire("dX94m");

var $7rM61 = parcelRequire("7rM61");
'use client';
var $b8ee1c2214b6dabd$var$_InputGlobalStyles;
const $b8ee1c2214b6dabd$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $dvg8e.default)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $b8ee1c2214b6dabd$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $b8ee1c2214b6dabd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $dvg8e.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $dvg8e.default)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $dX94m.getInputBaseUtilityClass), classes);
};
const $b8ee1c2214b6dabd$export$298a043133d72a38 = (0, $3EMXY.default)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $b8ee1c2214b6dabd$export$965edad20a84fa75
})((0, $31RRc.default)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $dX94m.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $b8ee1c2214b6dabd$export$ee10465db6ff6017 = (0, $3EMXY.default)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $b8ee1c2214b6dabd$export$cf507b112810e72d
})((0, $31RRc.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $dX94m.default).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $dX94m.default).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $b8ee1c2214b6dabd$var$InputGlobalStyles = (0, $2KJEQ.globalCss)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $b8ee1c2214b6dabd$var$InputBase = /*#__PURE__*/ $jXEQt.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $jXEQt.useRef(value != null);
    const inputRef = $jXEQt.useRef();
    const handleInputRefWarning = $jXEQt.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $89QD5.default)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $jXEQt.useState(false);
    const muiFormControl = (0, $1D77Z.default)();
    const fcs = (0, $eSieo.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $jXEQt.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $jXEQt.useCallback((obj)=>{
        if ((0, $eAUw7.isFilled)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $kJD0o.default)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $fskif.default)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $jXEQt.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $eOeM6.default);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $jXEQt.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $b8ee1c2214b6dabd$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $b8ee1c2214b6dabd$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $b8ee1c2214b6dabd$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $7rM61.jsxs)($jXEQt.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $b8ee1c2214b6dabd$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($b8ee1c2214b6dabd$var$_InputGlobalStyles || ($b8ee1c2214b6dabd$var$_InputGlobalStyles = /*#__PURE__*/ (0, $7rM61.jsx)($b8ee1c2214b6dabd$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $7rM61.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $9viLJ.default)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $fQojQ.default)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $ejO7q.default).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $7rM61.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $9viLJ.default)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $fQojQ.default)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $b8ee1c2214b6dabd$export$2e2bcd8739ae039 = $b8ee1c2214b6dabd$var$InputBase;

});
parcelRegister("eOeM6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac813229d32b0805$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $6qLqS = parcelRequire("6qLqS");

var $15Pai = parcelRequire("15Pai");

var $dbTJ5 = parcelRequire("dbTJ5");

var $g4Q41 = parcelRequire("g4Q41");

var $1tgCk = parcelRequire("1tgCk");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $ac813229d32b0805$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $ac813229d32b0805$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $ac813229d32b0805$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $ac813229d32b0805$var$isEmpty(obj) {
    return $ac813229d32b0805$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $ac813229d32b0805$var$TextareaAutosize = /*#__PURE__*/ $jXEQt.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $jXEQt.useRef(value != null);
    const textareaRef = $jXEQt.useRef(null);
    const handleRef = (0, $15Pai.default)(forwardedRef, textareaRef);
    const heightRef = $jXEQt.useRef(null);
    const hiddenTextareaRef = $jXEQt.useRef(null);
    const calculateTextareaStyles = $jXEQt.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $1tgCk.default)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $ac813229d32b0805$var$getStyleValue(computedStyle.paddingBottom) + $ac813229d32b0805$var$getStyleValue(computedStyle.paddingTop);
        const border = $ac813229d32b0805$var$getStyleValue(computedStyle.borderBottomWidth) + $ac813229d32b0805$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $g4Q41.default)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $ac813229d32b0805$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $jXEQt.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $ac813229d32b0805$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $jXEQt.useRef(-1);
    (0, $dbTJ5.default)(()=>{
        const debouncedHandleResize = (0, $6qLqS.default)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $1tgCk.default)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $dbTJ5.default)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $7rM61.jsxs)($jXEQt.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7rM61.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $7rM61.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$ac813229d32b0805$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $ac813229d32b0805$export$2e2bcd8739ae039 = $ac813229d32b0805$var$TextareaAutosize;

});
parcelRegister("6qLqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ae9f6e4e00d6872$export$2e2bcd8739ae039);
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $4ae9f6e4e00d6872$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}

});

parcelRegister("1tgCk", function(module, exports) {

$parcel$export(module.exports, "default", () => $112563b9a336edad$export$2e2bcd8739ae039);

var $049bd = parcelRequire("049bd");
function $112563b9a336edad$export$2e2bcd8739ae039(node) {
    const doc = (0, $049bd.default)(node);
    return doc.defaultView || window;
}

});


parcelRegister("eSieo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad44402937b0b0b1$export$2e2bcd8739ae039);
function $ad44402937b0b0b1$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}

});

parcelRegister("eAUw7", function(module, exports) {

$parcel$export(module.exports, "isFilled", () => $aa004491bdc11c48$export$d652b828d7fdeff8);
$parcel$export(module.exports, "isAdornedStart", () => $aa004491bdc11c48$export$1b68bdfa56faeb5d);
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $aa004491bdc11c48$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $aa004491bdc11c48$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($aa004491bdc11c48$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $aa004491bdc11c48$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $aa004491bdc11c48$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}

});

parcelRegister("dX94m", function(module, exports) {

$parcel$export(module.exports, "getInputBaseUtilityClass", () => $a287d20d02633733$export$ef57d5c8ca2278f6);
$parcel$export(module.exports, "default", () => $a287d20d02633733$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $a287d20d02633733$export$ef57d5c8ca2278f6(slot) {
    return (0, $5KipK.default)('MuiInputBase', slot);
}
const $a287d20d02633733$var$inputBaseClasses = (0, $1XfUG.default)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $a287d20d02633733$export$2e2bcd8739ae039 = $a287d20d02633733$var$inputBaseClasses;

});


parcelRegister("6nBZ2", function(module, exports) {

$parcel$export(module.exports, "getInputUtilityClass", () => $4a525acc7120bf22$export$cdb270390122322b);
$parcel$export(module.exports, "default", () => $4a525acc7120bf22$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");

var $dX94m = parcelRequire("dX94m");
function $4a525acc7120bf22$export$cdb270390122322b(slot) {
    return (0, $5KipK.default)('MuiInput', slot);
}
const $4a525acc7120bf22$var$inputClasses = {
    ...(0, $dX94m.default),
    ...(0, $1XfUG.default)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $4a525acc7120bf22$export$2e2bcd8739ae039 = $4a525acc7120bf22$var$inputClasses;

});


parcelRegister("64c0d", function(module, exports) {

$parcel$export(module.exports, "default", () => $46ac6d3bfa8d071b$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");

var $cqtAx = parcelRequire("cqtAx");



var $3ptEP = parcelRequire("3ptEP");

var $fSntC = parcelRequire("fSntC");

var $i29Fs = parcelRequire("i29Fs");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $8oH7q = parcelRequire("8oH7q");

var $5MTiZ = parcelRequire("5MTiZ");

var $SnNxd = parcelRequire("SnNxd");

var $fSntC = parcelRequire("fSntC");

var $dvg8e = parcelRequire("dvg8e");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $46ac6d3bfa8d071b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $dvg8e.default)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $3ptEP.default)(slots, (0, $SnNxd.getFilledInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $46ac6d3bfa8d071b$var$FilledInputRoot = (0, $3EMXY.default)((0, $fSntC.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $i29Fs.default)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $fSntC.rootOverridesResolver)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $SnNxd.default).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $SnNxd.default).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $SnNxd.default).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $SnNxd.default).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $SnNxd.default).disabled}, .${(0, $SnNxd.default).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $SnNxd.default).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $46ac6d3bfa8d071b$var$FilledInputInput = (0, $3EMXY.default)((0, $fSntC.InputBaseInput), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $fSntC.inputOverridesResolver)
})((0, $31RRc.default)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $46ac6d3bfa8d071b$var$FilledInput = /*#__PURE__*/ $jXEQt.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $46ac6d3bfa8d071b$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $cqtAx.default)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $46ac6d3bfa8d071b$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $46ac6d3bfa8d071b$var$FilledInputInput;
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $fSntC.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$46ac6d3bfa8d071b$var$FilledInput.muiName = 'Input';
var $46ac6d3bfa8d071b$export$2e2bcd8739ae039 = $46ac6d3bfa8d071b$var$FilledInput;

});
parcelRegister("SnNxd", function(module, exports) {

$parcel$export(module.exports, "getFilledInputUtilityClass", () => $0a378109821e07d6$export$3331e419f1a48437);
$parcel$export(module.exports, "default", () => $0a378109821e07d6$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");

var $dX94m = parcelRequire("dX94m");
function $0a378109821e07d6$export$3331e419f1a48437(slot) {
    return (0, $5KipK.default)('MuiFilledInput', slot);
}
const $0a378109821e07d6$var$filledInputClasses = {
    ...(0, $dX94m.default),
    ...(0, $1XfUG.default)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $0a378109821e07d6$export$2e2bcd8739ae039 = $0a378109821e07d6$var$filledInputClasses;

});


parcelRegister("iudyD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7558b97352054bf$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");



var $3ptEP = parcelRequire("3ptEP");

var $kcopw = parcelRequire("kcopw");

var $1D77Z = parcelRequire("1D77Z");

var $eSieo = parcelRequire("eSieo");

var $i29Fs = parcelRequire("i29Fs");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $8oH7q = parcelRequire("8oH7q");

var $5MTiZ = parcelRequire("5MTiZ");

var $j0S3Y = parcelRequire("j0S3Y");

var $fSntC = parcelRequire("fSntC");

var $f92r2 = parcelRequire("f92r2");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $d7558b97352054bf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $3ptEP.default)(slots, (0, $j0S3Y.getOutlinedInputUtilityClass), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $d7558b97352054bf$var$OutlinedInputRoot = (0, $3EMXY.default)((0, $fSntC.InputBaseRoot), {
    shouldForwardProp: (prop)=>(0, $i29Fs.default)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $fSntC.rootOverridesResolver)
})((0, $31RRc.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $j0S3Y.default).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $j0S3Y.default).notchedOutline}`]: {
                borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
            }
        },
        [`&.${(0, $j0S3Y.default).focused} .${(0, $j0S3Y.default).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $j0S3Y.default).focused} .${(0, $j0S3Y.default).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to override the above style
                style: {
                    [`&.${(0, $j0S3Y.default).error} .${(0, $j0S3Y.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $j0S3Y.default).disabled} .${(0, $j0S3Y.default).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $d7558b97352054bf$var$NotchedOutlineRoot = (0, $3EMXY.default)((0, $kcopw.default), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, $31RRc.default)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
    };
}));
const $d7558b97352054bf$var$OutlinedInputInput = (0, $3EMXY.default)((0, $fSntC.InputBaseInput), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $fSntC.inputOverridesResolver)
})((0, $31RRc.default)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $d7558b97352054bf$var$OutlinedInput = /*#__PURE__*/ $jXEQt.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $d7558b97352054bf$var$useUtilityClasses(props);
    const muiFormControl = (0, $1D77Z.default)();
    const fcs = (0, $eSieo.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $d7558b97352054bf$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $d7558b97352054bf$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $f92r2.default)('notchedOutline', {
        elementType: $d7558b97352054bf$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $7rM61.jsxs)($jXEQt.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $fSntC.default), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $7rM61.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$d7558b97352054bf$var$OutlinedInput.muiName = 'Input';
var $d7558b97352054bf$export$2e2bcd8739ae039 = $d7558b97352054bf$var$OutlinedInput;

});
parcelRegister("kcopw", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb47dd17968d8ff9$export$2e2bcd8739ae039);


var $i29Fs = parcelRequire("i29Fs");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $7rM61 = parcelRequire("7rM61");
'use client';
var $eb47dd17968d8ff9$var$_span;
const $eb47dd17968d8ff9$var$NotchedOutlineRoot = (0, $3EMXY.default)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $i29Fs.default)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $eb47dd17968d8ff9$var$NotchedOutlineLegend = (0, $3EMXY.default)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $i29Fs.default)
})((0, $31RRc.default)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $eb47dd17968d8ff9$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $7rM61.jsx)($eb47dd17968d8ff9$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $7rM61.jsx)($eb47dd17968d8ff9$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $7rM61.jsx)("span", {
                children: label
            }) : $eb47dd17968d8ff9$var$_span || ($eb47dd17968d8ff9$var$_span = /*#__PURE__*/ (0, $7rM61.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}

});

parcelRegister("j0S3Y", function(module, exports) {

$parcel$export(module.exports, "getOutlinedInputUtilityClass", () => $dd77f43c29d8357b$export$89922944c7227687);
$parcel$export(module.exports, "default", () => $dd77f43c29d8357b$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");

var $dX94m = parcelRequire("dX94m");
function $dd77f43c29d8357b$export$89922944c7227687(slot) {
    return (0, $5KipK.default)('MuiOutlinedInput', slot);
}
const $dd77f43c29d8357b$var$outlinedInputClasses = {
    ...(0, $dX94m.default),
    ...(0, $1XfUG.default)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $dd77f43c29d8357b$export$2e2bcd8739ae039 = $dd77f43c29d8357b$var$outlinedInputClasses;

});


parcelRegister("25XC6", function(module, exports) {

$parcel$export(module.exports, "default", () => $186a4a62decf699d$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $3ptEP = parcelRequire("3ptEP");

var $fQojQ = parcelRequire("fQojQ");

var $eSieo = parcelRequire("eSieo");

var $1D77Z = parcelRequire("1D77Z");

var $4tCNU = parcelRequire("4tCNU");
var $8H2CF = parcelRequire("8H2CF");

var $dvg8e = parcelRequire("dvg8e");

var $i29Fs = parcelRequire("i29Fs");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $iT5Ou = parcelRequire("iT5Ou");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $186a4a62decf699d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, $dvg8e.default)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $3ptEP.default)(slots, (0, $iT5Ou.getInputLabelUtilityClasses), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $186a4a62decf699d$var$InputLabelRoot = (0, $3EMXY.default)((0, $4tCNU.default), {
    shouldForwardProp: (prop)=>(0, $i29Fs.default)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8H2CF.default).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $186a4a62decf699d$var$InputLabel = /*#__PURE__*/ $jXEQt.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $1D77Z.default)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $eSieo.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $186a4a62decf699d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($186a4a62decf699d$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $fQojQ.default)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $186a4a62decf699d$export$2e2bcd8739ae039 = $186a4a62decf699d$var$InputLabel;

});
parcelRegister("4tCNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3427f88aa767f0b7$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $eSieo = parcelRequire("eSieo");

var $1D77Z = parcelRequire("1D77Z");

var $dvg8e = parcelRequire("dvg8e");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $8oH7q = parcelRequire("8oH7q");

var $5MTiZ = parcelRequire("5MTiZ");

var $8H2CF = parcelRequire("8H2CF");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $3427f88aa767f0b7$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $dvg8e.default)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $8H2CF.getFormLabelUtilityClasses), classes);
};
const $3427f88aa767f0b7$export$aa5bc7f8a4705b27 = (0, $3EMXY.default)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $8H2CF.default).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $8H2CF.default).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $8H2CF.default).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $3427f88aa767f0b7$var$AsteriskComponent = (0, $3EMXY.default)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, $31RRc.default)(({ theme: theme })=>({
        [`&.${(0, $8H2CF.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $3427f88aa767f0b7$var$FormLabel = /*#__PURE__*/ $jXEQt.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $1D77Z.default)();
    const fcs = (0, $eSieo.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $3427f88aa767f0b7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsxs)($3427f88aa767f0b7$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $7rM61.jsxs)($3427f88aa767f0b7$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $3427f88aa767f0b7$export$2e2bcd8739ae039 = $3427f88aa767f0b7$var$FormLabel;

});
parcelRegister("8H2CF", function(module, exports) {

$parcel$export(module.exports, "getFormLabelUtilityClasses", () => $65445fb5ff8b0dd6$export$f7d501e40371cd17);
$parcel$export(module.exports, "default", () => $65445fb5ff8b0dd6$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $65445fb5ff8b0dd6$export$f7d501e40371cd17(slot) {
    return (0, $5KipK.default)('MuiFormLabel', slot);
}
const $65445fb5ff8b0dd6$var$formLabelClasses = (0, $1XfUG.default)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $65445fb5ff8b0dd6$export$2e2bcd8739ae039 = $65445fb5ff8b0dd6$var$formLabelClasses;

});


parcelRegister("iT5Ou", function(module, exports) {

$parcel$export(module.exports, "getInputLabelUtilityClasses", () => $dc01df7364630a0c$export$c1c4b4545ad2ea5f);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $dc01df7364630a0c$export$c1c4b4545ad2ea5f(slot) {
    return (0, $5KipK.default)('MuiInputLabel', slot);
}
const $dc01df7364630a0c$var$inputLabelClasses = (0, $1XfUG.default)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $dc01df7364630a0c$export$2e2bcd8739ae039 = $dc01df7364630a0c$var$inputLabelClasses;

});


parcelRegister("arJ8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $79af7117d0a32707$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");

var $eAUw7 = parcelRequire("eAUw7");

var $dvg8e = parcelRequire("dvg8e");

var $bco4i = parcelRequire("bco4i");

var $ejO7q = parcelRequire("ejO7q");

var $i1SBM = parcelRequire("i1SBM");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $79af7117d0a32707$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $dvg8e.default)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $i1SBM.getFormControlUtilityClasses), classes);
};
const $79af7117d0a32707$var$FormControlRoot = (0, $3EMXY.default)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $dvg8e.default)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $79af7117d0a32707$var$FormControl = /*#__PURE__*/ $jXEQt.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $79af7117d0a32707$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $jXEQt.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $jXEQt.Children.forEach(children, (child)=>{
            if (!(0, $bco4i.default)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $bco4i.default)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $eAUw7.isAdornedStart)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $jXEQt.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $jXEQt.Children.forEach(children, (child)=>{
            if (!(0, $bco4i.default)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $eAUw7.isFilled)(child.props, true) || (0, $eAUw7.isFilled)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $jXEQt.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $jXEQt.useRef(false);
    const onFilled = $jXEQt.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $jXEQt.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $jXEQt.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $ejO7q.default).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $7rM61.jsx)($79af7117d0a32707$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $fQojQ.default)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $79af7117d0a32707$export$2e2bcd8739ae039 = $79af7117d0a32707$var$FormControl;

});
parcelRegister("bco4i", function(module, exports) {

$parcel$export(module.exports, "default", () => $82737c22a13dee5a$export$2e2bcd8739ae039);

var $dV0nG = parcelRequire("dV0nG");
var $82737c22a13dee5a$export$2e2bcd8739ae039 = (0, $dV0nG.default);

});
parcelRegister("dV0nG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a220e4e7323da6c9$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");
function $a220e4e7323da6c9$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $jXEQt.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}

});


parcelRegister("i1SBM", function(module, exports) {

$parcel$export(module.exports, "getFormControlUtilityClasses", () => $d202ae1180314858$export$149c8b8bab2289d1);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $d202ae1180314858$export$149c8b8bab2289d1(slot) {
    return (0, $5KipK.default)('MuiFormControl', slot);
}
const $d202ae1180314858$var$formControlClasses = (0, $1XfUG.default)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $d202ae1180314858$export$2e2bcd8739ae039 = $d202ae1180314858$var$formControlClasses;

});


parcelRegister("1eyRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e622317c8d4e083$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $eSieo = parcelRequire("eSieo");

var $1D77Z = parcelRequire("1D77Z");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $dvg8e = parcelRequire("dvg8e");

var $43spN = parcelRequire("43spN");

var $7rM61 = parcelRequire("7rM61");
'use client';
var $0e622317c8d4e083$var$_span;
const $0e622317c8d4e083$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $dvg8e.default)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $43spN.getFormHelperTextUtilityClasses), classes);
};
const $0e622317c8d4e083$var$FormHelperTextRoot = (0, $3EMXY.default)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $dvg8e.default)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $43spN.default).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $43spN.default).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $0e622317c8d4e083$var$FormHelperText = /*#__PURE__*/ $jXEQt.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $1D77Z.default)();
    const fcs = (0, $eSieo.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $0e622317c8d4e083$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($0e622317c8d4e083$var$FormHelperTextRoot, {
        as: component,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $0e622317c8d4e083$var$_span || ($0e622317c8d4e083$var$_span = /*#__PURE__*/ (0, $7rM61.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $0e622317c8d4e083$export$2e2bcd8739ae039 = $0e622317c8d4e083$var$FormHelperText;

});
parcelRegister("43spN", function(module, exports) {

$parcel$export(module.exports, "getFormHelperTextUtilityClasses", () => $2f3d7be628704823$export$a394fa61b1d583a9);
$parcel$export(module.exports, "default", () => $2f3d7be628704823$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $2f3d7be628704823$export$a394fa61b1d583a9(slot) {
    return (0, $5KipK.default)('MuiFormHelperText', slot);
}
const $2f3d7be628704823$var$formHelperTextClasses = (0, $1XfUG.default)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $2f3d7be628704823$export$2e2bcd8739ae039 = $2f3d7be628704823$var$formHelperTextClasses;

});


parcelRegister("8dth4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fb63eea48f28203$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $cqtAx = parcelRequire("cqtAx");

var $3ptEP = parcelRequire("3ptEP");

var $e4lkb = parcelRequire("e4lkb");

var $lc7w5 = parcelRequire("lc7w5");

var $eSieo = parcelRequire("eSieo");

var $1D77Z = parcelRequire("1D77Z");

var $5VkM0 = parcelRequire("5VkM0");

var $jpsSb = parcelRequire("jpsSb");

var $8OTRS = parcelRequire("8OTRS");

var $64c0d = parcelRequire("64c0d");

var $iudyD = parcelRequire("iudyD");

var $5MTiZ = parcelRequire("5MTiZ");

var $89QD5 = parcelRequire("89QD5");

var $3EMXY = parcelRequire("3EMXY");

var $i29Fs = parcelRequire("i29Fs");

var $dyqeq = parcelRequire("dyqeq");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $5fb63eea48f28203$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $3ptEP.default)(slots, (0, $dyqeq.getSelectUtilityClasses), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $5fb63eea48f28203$var$styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $i29Fs.default)(prop) && prop !== 'variant'
};
const $5fb63eea48f28203$var$StyledInput = (0, $3EMXY.default)((0, $jpsSb.default), $5fb63eea48f28203$var$styledRootConfig)('');
const $5fb63eea48f28203$var$StyledOutlinedInput = (0, $3EMXY.default)((0, $iudyD.default), $5fb63eea48f28203$var$styledRootConfig)('');
const $5fb63eea48f28203$var$StyledFilledInput = (0, $3EMXY.default)((0, $64c0d.default), $5fb63eea48f28203$var$styledRootConfig)('');
const $5fb63eea48f28203$var$Select = /*#__PURE__*/ $jXEQt.forwardRef(function Select(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $5VkM0.default), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $8OTRS.default) : (0, $lc7w5.default);
    const muiFormControl = (0, $1D77Z.default)();
    const fcs = (0, $eSieo.default)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $5fb63eea48f28203$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $7rM61.jsx)($5fb63eea48f28203$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $7rM61.jsx)($5fb63eea48f28203$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $7rM61.jsx)($5fb63eea48f28203$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $89QD5.default)(ref, (0, $e4lkb.default)(InputComponent));
    return /*#__PURE__*/ (0, $7rM61.jsx)($jXEQt.Fragment, {
        children: /*#__PURE__*/ $jXEQt.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $cqtAx.default)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $fQojQ.default)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$5fb63eea48f28203$var$Select.muiName = 'Select';
var $5fb63eea48f28203$export$2e2bcd8739ae039 = $5fb63eea48f28203$var$Select;

});
parcelRegister("lc7w5", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6e08c9425d23bd3$export$2e2bcd8739ae039);

var $fskif = parcelRequire("fskif");

var $jXEQt = parcelRequire("jXEQt");



var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $ab4rY = parcelRequire("ab4rY");


var $9qR5V = parcelRequire("9qR5V");

var $dvg8e = parcelRequire("dvg8e");

var $gS6ai = parcelRequire("gS6ai");

var $8OTRS = parcelRequire("8OTRS");

var $eAUw7 = parcelRequire("eAUw7");

var $3EMXY = parcelRequire("3EMXY");

var $7jAyz = parcelRequire("7jAyz");

var $89QD5 = parcelRequire("89QD5");

var $3e8Jg = parcelRequire("3e8Jg");

var $dyqeq = parcelRequire("dyqeq");

var $7rM61 = parcelRequire("7rM61");
'use client';
var $f6e08c9425d23bd3$var$_span;
const $f6e08c9425d23bd3$var$SelectSelect = (0, $3EMXY.default)((0, $8OTRS.StyledSelectSelect), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $dyqeq.default).select}`]: styles.select
            },
            {
                [`&.${(0, $dyqeq.default).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $dyqeq.default).error}`]: styles.error
            },
            {
                [`&.${(0, $dyqeq.default).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $dyqeq.default).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $f6e08c9425d23bd3$var$SelectIcon = (0, $3EMXY.default)((0, $8OTRS.StyledSelectIcon), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $dvg8e.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $f6e08c9425d23bd3$var$SelectNativeInput = (0, $3EMXY.default)('input', {
    shouldForwardProp: (prop)=>(0, $7jAyz.default)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $f6e08c9425d23bd3$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $f6e08c9425d23bd3$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $f6e08c9425d23bd3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $dvg8e.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $dyqeq.getSelectUtilityClasses), classes);
};
/**
 * @ignore - internal component.
 */ const $f6e08c9425d23bd3$var$SelectInput = /*#__PURE__*/ $jXEQt.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onKeyDown: // eslint-disable-next-line react/prop-types
    onKeyDown, onMouseDown: // eslint-disable-next-line react/prop-types
    onMouseDown, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $3e8Jg.default)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $3e8Jg.default)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $jXEQt.useRef(null);
    const displayRef = $jXEQt.useRef(null);
    const [displayNode, setDisplayNode] = $jXEQt.useState(null);
    const { current: isOpenControlled } = $jXEQt.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $jXEQt.useState();
    const handleRef = (0, $89QD5.default)(ref, inputRefProp);
    const handleDisplayRef = $jXEQt.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $jXEQt.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    const open = displayNode !== null && openState;
    $jXEQt.useEffect(()=>{
        if (!open || !anchorElement || autoWidth) return undefined;
        if (typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver(()=>{
            setMenuMinWidthState(anchorElement.clientWidth);
        });
        observer.observe(anchorElement);
        return ()=>{
            observer.disconnect();
        };
    }, [
        open,
        anchorElement,
        autoWidth
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $jXEQt.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $jXEQt.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $jXEQt.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $9qR5V.default)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (openParam, event)=>{
        if (openParam) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(openParam);
        }
    };
    const handleMouseDown = (event)=>{
        onMouseDown?.(event);
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $jXEQt.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
            onKeyDown?.(event);
        }
    };
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $eAUw7.isFilled)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $jXEQt.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $fskif.default)(2));
            selected = value.some((v)=>$f6e08c9425d23bd3$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $f6e08c9425d23bd3$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $jXEQt.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $f6e08c9425d23bd3$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...typeof MenuProps.slotProps?.paper === 'function' ? MenuProps.slotProps.paper(ownerState) : MenuProps.slotProps?.paper
    };
    const listProps = {
        ...MenuProps.MenuListProps,
        ...typeof MenuProps.slotProps?.list === 'function' ? MenuProps.slotProps.list(ownerState) : MenuProps.slotProps?.list
    };
    const listboxId = (0, $ab4rY.default)();
    return /*#__PURE__*/ (0, $7rM61.jsxs)($jXEQt.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7rM61.jsx)($f6e08c9425d23bd3$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $fQojQ.default)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $f6e08c9425d23bd3$var$isEmpty(display) ? $f6e08c9425d23bd3$var$_span || ($f6e08c9425d23bd3$var$_span = /*#__PURE__*/ (0, $7rM61.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $7rM61.jsx)($f6e08c9425d23bd3$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $7rM61.jsx)($f6e08c9425d23bd3$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $gS6ai.default), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...listProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $f6e08c9425d23bd3$export$2e2bcd8739ae039 = $f6e08c9425d23bd3$var$SelectInput;

});
parcelRegister("9qR5V", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ddfba3cf7ab1095$export$2e2bcd8739ae039);

var $049bd = parcelRequire("049bd");
var $6ddfba3cf7ab1095$export$2e2bcd8739ae039 = (0, $049bd.default);

});

parcelRegister("gS6ai", function(module, exports) {

$parcel$export(module.exports, "default", () => $c48678b8f0ca1dc8$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");



var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");


var $39dKT = parcelRequire("39dKT");

var $1Oxdt = parcelRequire("1Oxdt");

var $9fMMi = parcelRequire("9fMMi");

var $kahzK = parcelRequire("kahzK");

var $i29Fs = parcelRequire("i29Fs");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");

var $9vi4d = parcelRequire("9vi4d");

var $f92r2 = parcelRequire("f92r2");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $c48678b8f0ca1dc8$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $c48678b8f0ca1dc8$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $c48678b8f0ca1dc8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $9vi4d.getMenuUtilityClass), classes);
};
const $c48678b8f0ca1dc8$var$MenuRoot = (0, $3EMXY.default)((0, $kahzK.default), {
    shouldForwardProp: (prop)=>(0, $i29Fs.default)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const $c48678b8f0ca1dc8$export$4f7c51a5920c9f33 = (0, $3EMXY.default)((0, $kahzK.PopoverPaper), {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $c48678b8f0ca1dc8$var$MenuMenuList = (0, $3EMXY.default)((0, $9fMMi.default), {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $c48678b8f0ca1dc8$var$Menu = /*#__PURE__*/ $jXEQt.forwardRef(function Menu(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $39dKT.useRtl)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $c48678b8f0ca1dc8$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $jXEQt.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $jXEQt.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $jXEQt.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $1Oxdt.default)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $f92r2.default)('paper', {
        className: classes.paper,
        elementType: $c48678b8f0ca1dc8$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $f92r2.default)('list', {
        className: (0, $fQojQ.default)(classes.list, MenuListProps.className),
        elementType: $c48678b8f0ca1dc8$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $7rM61.jsx)($c48678b8f0ca1dc8$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $c48678b8f0ca1dc8$var$RTL_ORIGIN : $c48678b8f0ca1dc8$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $7rM61.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $c48678b8f0ca1dc8$export$2e2bcd8739ae039 = $c48678b8f0ca1dc8$var$Menu;

});
parcelRegister("9fMMi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6bcb5a09fea58a96$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");



var $9qR5V = parcelRequire("9qR5V");

var $kM5Ix = parcelRequire("kM5Ix");

var $7qnZX = parcelRequire("7qnZX");

var $l4Hsq = parcelRequire("l4Hsq");

var $89QD5 = parcelRequire("89QD5");

var $kJD0o = parcelRequire("kJD0o");

var $cdkBN = parcelRequire("cdkBN");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $6bcb5a09fea58a96$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $6bcb5a09fea58a96$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $6bcb5a09fea58a96$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $6bcb5a09fea58a96$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$6bcb5a09fea58a96$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $6bcb5a09fea58a96$var$MenuList = /*#__PURE__*/ $jXEQt.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $jXEQt.useRef(null);
    const textCriteriaRef = $jXEQt.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $kJD0o.default)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $jXEQt.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $l4Hsq.default)((0, $cdkBN.default)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $7qnZX.default)((0, $9qR5V.default)(list));
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $6bcb5a09fea58a96$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $6bcb5a09fea58a96$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $6bcb5a09fea58a96$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $6bcb5a09fea58a96$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $6bcb5a09fea58a96$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $6bcb5a09fea58a96$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $6bcb5a09fea58a96$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $6bcb5a09fea58a96$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $6bcb5a09fea58a96$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $6bcb5a09fea58a96$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $6bcb5a09fea58a96$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $89QD5.default)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $jXEQt.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $jXEQt.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $jXEQt.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $jXEQt.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $kM5Ix.default), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $6bcb5a09fea58a96$export$2e2bcd8739ae039 = $6bcb5a09fea58a96$var$MenuList;

});
parcelRegister("7qnZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $567d93ab76a6d42f$export$2e2bcd8739ae039);

var $42rQD = parcelRequire("42rQD");
var $567d93ab76a6d42f$export$2e2bcd8739ae039 = (0, $42rQD.default);

});
parcelRegister("42rQD", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f0cf35f97bd6e50$export$2e2bcd8739ae039);
/**
 * Gets the actual active element, traversing through shadow roots if necessary.
 *
 * When an element inside a shadow root has focus, `document.activeElement` returns
 * the shadow host element. This function recursively traverses shadow roots to find
 * the actual focused element.
 *
 * @param root - The document or shadow root to start the search from.
 * @returns The actual focused element, or null if no element has focus.
 *
 * @example
 * // In a shadow DOM context
 * const activeElement = getActiveElement(document);
 * // Returns the actual focused element inside the shadow root
 *
 * @example
 * // Starting from a specific document
 * const activeElement = getActiveElement(ownerDocument(element));
 */ function $2f0cf35f97bd6e50$export$2e2bcd8739ae039(doc) {
    let element = doc.activeElement;
    while(element?.shadowRoot?.activeElement != null)element = element.shadowRoot.activeElement;
    return element;
}

});


parcelRegister("l4Hsq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57bae70fd2a4d0a$export$2e2bcd8739ae039);

var $azjF9 = parcelRequire("azjF9");
var $f57bae70fd2a4d0a$export$2e2bcd8739ae039 = (0, $azjF9.default);

});
parcelRegister("azjF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b1c6ce1f0d596c1$export$2e2bcd8739ae039);
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $7b1c6ce1f0d596c1$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}

});


parcelRegister("cdkBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e46af59f2b4950a$export$2e2bcd8739ae039);

var $1tgCk = parcelRequire("1tgCk");
var $8e46af59f2b4950a$export$2e2bcd8739ae039 = (0, $1tgCk.default);

});


parcelRegister("kahzK", function(module, exports) {

$parcel$export(module.exports, "PopoverPaper", () => $eae25ff7527e44e5$export$821346c38a2d9390);
$parcel$export(module.exports, "default", () => $eae25ff7527e44e5$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");






var $9viLJ = parcelRequire("9viLJ");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");


var $uEZtr = parcelRequire("uEZtr");

var $9qR5V = parcelRequire("9qR5V");

var $cdkBN = parcelRequire("cdkBN");

var $4k8GK = parcelRequire("4k8GK");

var $3M6AT = parcelRequire("3M6AT");

var $IcFU1 = parcelRequire("IcFU1");

var $2k7pn = parcelRequire("2k7pn");

var $f92r2 = parcelRequire("f92r2");

var $9okRN = parcelRequire("9okRN");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $eae25ff7527e44e5$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $eae25ff7527e44e5$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $eae25ff7527e44e5$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $eae25ff7527e44e5$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $eae25ff7527e44e5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $2k7pn.getPopoverUtilityClass), classes);
};
const $eae25ff7527e44e5$export$bcce13685275fc99 = (0, $3EMXY.default)((0, $3M6AT.default), {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const $eae25ff7527e44e5$export$821346c38a2d9390 = (0, $3EMXY.default)((0, $IcFU1.default), {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $eae25ff7527e44e5$var$Popover = /*#__PURE__*/ $jXEQt.forwardRef(function Popover(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $jXEQt.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $eae25ff7527e44e5$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $jXEQt.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $eae25ff7527e44e5$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $9qR5V.default)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $eae25ff7527e44e5$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $eae25ff7527e44e5$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $jXEQt.useCallback((elemRect)=>{
        return {
            vertical: $eae25ff7527e44e5$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $eae25ff7527e44e5$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $jXEQt.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $eae25ff7527e44e5$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $cdkBN.default)($eae25ff7527e44e5$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $eae25ff7527e44e5$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $jXEQt.useState(open);
    const setPositioningStyles = $jXEQt.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $jXEQt.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $jXEQt.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $jXEQt.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $jXEQt.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $uEZtr.default)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $cdkBN.default)($eae25ff7527e44e5$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $f92r2.default)('transition', {
        elementType: (0, $4k8GK.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $9qR5V.default)($eae25ff7527e44e5$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $f92r2.default)('root', {
        ref: ref,
        elementType: $eae25ff7527e44e5$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $9okRN.default)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $f92r2.default)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $eae25ff7527e44e5$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7rM61.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $9viLJ.default)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $7rM61.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $7rM61.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $eae25ff7527e44e5$export$2e2bcd8739ae039 = $eae25ff7527e44e5$var$Popover;

});
parcelRegister("uEZtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $05c2995189dc93ad$export$2e2bcd8739ae039);

var $6qLqS = parcelRequire("6qLqS");
var $05c2995189dc93ad$export$2e2bcd8739ae039 = (0, $6qLqS.default);

});

parcelRegister("3M6AT", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bfaf840fba8292b$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");



var $3ptEP = parcelRequire("3ptEP");

var $gdA2G = parcelRequire("gdA2G");

var $j1Xwx = parcelRequire("j1Xwx");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $9AB1p = parcelRequire("9AB1p");

var $9FzKF = parcelRequire("9FzKF");

var $h9cBZ = parcelRequire("h9cBZ");

var $f92r2 = parcelRequire("f92r2");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $2bfaf840fba8292b$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $h9cBZ.getModalUtilityClass), classes);
};
const $2bfaf840fba8292b$var$ModalRoot = (0, $3EMXY.default)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $2bfaf840fba8292b$var$ModalBackdrop = (0, $3EMXY.default)((0, $9AB1p.default), {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $2bfaf840fba8292b$var$Modal = /*#__PURE__*/ $jXEQt.forwardRef(function Modal(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $2bfaf840fba8292b$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $9FzKF.default)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $2bfaf840fba8292b$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $f92r2.default)('root', {
        ref: ref,
        elementType: $2bfaf840fba8292b$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $fQojQ.default)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $f92r2.default)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $fQojQ.default)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $j1Xwx.default), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $7rM61.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $7rM61.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $7rM61.jsx)((0, $gdA2G.default), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $jXEQt.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $2bfaf840fba8292b$export$2e2bcd8739ae039 = $2bfaf840fba8292b$var$Modal;

});
parcelRegister("gdA2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $bce9d17c72d688bf$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $15Pai = parcelRequire("15Pai");

var $049bd = parcelRequire("049bd");

var $e4lkb = parcelRequire("e4lkb");



var $7qnZX = parcelRequire("7qnZX");

var $7rM61 = parcelRequire("7rM61");
'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $bce9d17c72d688bf$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $bce9d17c72d688bf$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $bce9d17c72d688bf$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $bce9d17c72d688bf$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $bce9d17c72d688bf$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $bce9d17c72d688bf$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($bce9d17c72d688bf$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $bce9d17c72d688bf$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$bce9d17c72d688bf$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $bce9d17c72d688bf$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $bce9d17c72d688bf$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $bce9d17c72d688bf$var$defaultGetTabbable, isEnabled: isEnabled = $bce9d17c72d688bf$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $jXEQt.useRef(false);
    const sentinelStart = $jXEQt.useRef(null);
    const sentinelEnd = $jXEQt.useRef(null);
    const nodeToRestore = $jXEQt.useRef(null);
    const reactFocusEventTarget = $jXEQt.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $jXEQt.useRef(false);
    const rootRef = $jXEQt.useRef(null);
    const handleRef = (0, $15Pai.default)((0, $e4lkb.default)(children), rootRef);
    const lastKeydown = $jXEQt.useRef(null);
    $jXEQt.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $jXEQt.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $049bd.default)(rootRef.current);
        const activeElement = (0, $7qnZX.default)(doc);
        if (!rootRef.current.contains(activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $jXEQt.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $049bd.default)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            const activeElement = (0, $7qnZX.default)(doc);
            // Make sure the next tab starts from the right place.
            // activeElement refers to the origin.
            if (activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            const activeEl = (0, $7qnZX.default)(doc);
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(activeEl)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && activeEl !== sentinelStart.current && activeEl !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (activeEl !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (activeEl === sentinelStart.current || activeEl === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            const activeEl = (0, $7qnZX.default)(doc);
            if (activeEl && activeEl.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $7rM61.jsxs)($jXEQt.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7rM61.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $jXEQt.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $7rM61.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $bce9d17c72d688bf$export$2e2bcd8739ae039 = $bce9d17c72d688bf$var$FocusTrap;

});

parcelRegister("9AB1p", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fb43198b2a4cf87$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");

var $f92r2 = parcelRequire("f92r2");

var $8A5c0 = parcelRequire("8A5c0");

var $hgBXx = parcelRequire("hgBXx");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $6fb43198b2a4cf87$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $hgBXx.getBackdropUtilityClass), classes);
};
const $6fb43198b2a4cf87$var$BackdropRoot = (0, $3EMXY.default)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $6fb43198b2a4cf87$var$Backdrop = /*#__PURE__*/ $jXEQt.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $6fb43198b2a4cf87$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        component: component,
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $f92r2.default)('root', {
        elementType: $6fb43198b2a4cf87$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $f92r2.default)('transition', {
        elementType: (0, $8A5c0.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7rM61.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $7rM61.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            ref: ref,
            children: children
        })
    });
});
var $6fb43198b2a4cf87$export$2e2bcd8739ae039 = $6fb43198b2a4cf87$var$Backdrop;

});
parcelRegister("8A5c0", function(module, exports) {

$parcel$export(module.exports, "default", () => $63f5b6a964394cfc$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $7HOFt = parcelRequire("7HOFt");


var $e4lkb = parcelRequire("e4lkb");

var $k3tJq = parcelRequire("k3tJq");

var $avf4Y = parcelRequire("avf4Y");

var $89QD5 = parcelRequire("89QD5");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $63f5b6a964394cfc$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $63f5b6a964394cfc$var$Fade = /*#__PURE__*/ $jXEQt.forwardRef(function Fade(props, ref) {
    const theme = (0, $k3tJq.default)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $7HOFt.default), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $jXEQt.useRef(null);
    const handleRef = (0, $89QD5.default)(nodeRef, (0, $e4lkb.default)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $avf4Y.reflow)(node); // So the animation always start from the start.
        const transitionProps = (0, $avf4Y.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $avf4Y.getTransitionProps)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $7rM61.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $jXEQt.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$63f5b6a964394cfc$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $63f5b6a964394cfc$export$2e2bcd8739ae039 = $63f5b6a964394cfc$var$Fade;

});

parcelRegister("hgBXx", function(module, exports) {

$parcel$export(module.exports, "getBackdropUtilityClass", () => $c921603ce07a03bd$export$9927a91fd93152bd);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $c921603ce07a03bd$export$9927a91fd93152bd(slot) {
    return (0, $5KipK.default)('MuiBackdrop', slot);
}
const $c921603ce07a03bd$var$backdropClasses = (0, $1XfUG.default)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $c921603ce07a03bd$export$2e2bcd8739ae039 = $c921603ce07a03bd$var$backdropClasses;

});


parcelRegister("9FzKF", function(module, exports) {

$parcel$export(module.exports, "default", () => $70a3acf040a025c3$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");

var $049bd = parcelRequire("049bd");

var $15Pai = parcelRequire("15Pai");

var $g4Q41 = parcelRequire("g4Q41");

var $9mPic = parcelRequire("9mPic");

var $7vuxm = parcelRequire("7vuxm");

var $drHNz = parcelRequire("drHNz");
'use client';
function $70a3acf040a025c3$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $70a3acf040a025c3$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $70a3acf040a025c3$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $70a3acf040a025c3$var$manager = new (0, $drHNz.ModalManager)();
function $70a3acf040a025c3$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $jXEQt.useRef({});
    const mountNodeRef = $jXEQt.useRef(null);
    const modalRef = $jXEQt.useRef(null);
    const handleRef = (0, $15Pai.default)(modalRef, rootRef);
    const [exited, setExited] = $jXEQt.useState(!open);
    const hasTransition = $70a3acf040a025c3$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $049bd.default)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $70a3acf040a025c3$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $g4Q41.default)(()=>{
        const resolvedContainer = $70a3acf040a025c3$var$getContainer(container) || getDoc().body;
        $70a3acf040a025c3$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$70a3acf040a025c3$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $g4Q41.default)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $drHNz.ariaHidden)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $jXEQt.useCallback(()=>{
        $70a3acf040a025c3$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $jXEQt.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $jXEQt.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $7vuxm.default)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $9mPic.default)(handleEnter, children?.props.onEnter ?? $70a3acf040a025c3$var$noop),
            onExited: (0, $9mPic.default)(handleExited, children?.props.onExited ?? $70a3acf040a025c3$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $70a3acf040a025c3$export$2e2bcd8739ae039 = $70a3acf040a025c3$var$useModal;

});
parcelRegister("9mPic", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d1df4c0702ca2ff$export$2e2bcd8739ae039);
/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $6d1df4c0702ca2ff$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}

});

parcelRegister("drHNz", function(module, exports) {

$parcel$export(module.exports, "ariaHidden", () => $9c9fc57a57a8ab40$export$e1bd0c6150f13d96);
$parcel$export(module.exports, "ModalManager", () => $9c9fc57a57a8ab40$export$ce11c4ecd08cea67);

var $1tgCk = parcelRequire("1tgCk");

var $049bd = parcelRequire("049bd");

var $azjF9 = parcelRequire("azjF9");
// Is a vertical scrollbar displayed?
function $9c9fc57a57a8ab40$var$isOverflowing(container) {
    const doc = (0, $049bd.default)(container);
    if (doc.body === container) return (0, $1tgCk.default)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $9c9fc57a57a8ab40$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $9c9fc57a57a8ab40$var$getPaddingRight(element) {
    return parseFloat((0, $1tgCk.default)(element).getComputedStyle(element).paddingRight) || 0;
}
function $9c9fc57a57a8ab40$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $9c9fc57a57a8ab40$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$9c9fc57a57a8ab40$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $9c9fc57a57a8ab40$export$e1bd0c6150f13d96(element, hide);
    });
}
function $9c9fc57a57a8ab40$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $9c9fc57a57a8ab40$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($9c9fc57a57a8ab40$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $azjF9.default)((0, $1tgCk.default)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$9c9fc57a57a8ab40$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $049bd.default)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$9c9fc57a57a8ab40$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $049bd.default)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $1tgCk.default)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $9c9fc57a57a8ab40$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $9c9fc57a57a8ab40$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $9c9fc57a57a8ab40$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $9c9fc57a57a8ab40$var$getHiddenSiblings(container);
        $9c9fc57a57a8ab40$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $9c9fc57a57a8ab40$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $9c9fc57a57a8ab40$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $9c9fc57a57a8ab40$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $9c9fc57a57a8ab40$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $9c9fc57a57a8ab40$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $9c9fc57a57a8ab40$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $9c9fc57a57a8ab40$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}

});


parcelRegister("h9cBZ", function(module, exports) {

$parcel$export(module.exports, "getModalUtilityClass", () => $c7bd0f5a77a7ca36$export$67960e22b12a638d);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $c7bd0f5a77a7ca36$export$67960e22b12a638d(slot) {
    return (0, $5KipK.default)('MuiModal', slot);
}
const $c7bd0f5a77a7ca36$var$modalClasses = (0, $1XfUG.default)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $c7bd0f5a77a7ca36$export$2e2bcd8739ae039 = $c7bd0f5a77a7ca36$var$modalClasses;

});


parcelRegister("IcFU1", function(module, exports) {

$parcel$export(module.exports, "default", () => $084df122e309fea7$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");



var $3ptEP = parcelRequire("3ptEP");

var $h5VeH = parcelRequire("h5VeH");

var $3EMXY = parcelRequire("3EMXY");
var $k3tJq = parcelRequire("k3tJq");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $bdgU1 = parcelRequire("bdgU1");

var $1QJqm = parcelRequire("1QJqm");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $084df122e309fea7$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $1QJqm.getPaperUtilityClass), classes);
};
const $084df122e309fea7$var$PaperRoot = (0, $3EMXY.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $084df122e309fea7$var$Paper = /*#__PURE__*/ $jXEQt.forwardRef(function Paper(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $k3tJq.default)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $084df122e309fea7$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($084df122e309fea7$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $h5VeH.alpha)('#fff', (0, $bdgU1.default)(elevation))}, ${(0, $h5VeH.alpha)('#fff', (0, $bdgU1.default)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $084df122e309fea7$export$2e2bcd8739ae039 = $084df122e309fea7$var$Paper;

});
parcelRegister("1QJqm", function(module, exports) {

$parcel$export(module.exports, "getPaperUtilityClass", () => $158de215aa9db010$export$29cdb466b9b6f20b);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $158de215aa9db010$export$29cdb466b9b6f20b(slot) {
    return (0, $5KipK.default)('MuiPaper', slot);
}
const $158de215aa9db010$var$paperClasses = (0, $1XfUG.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $158de215aa9db010$export$2e2bcd8739ae039 = $158de215aa9db010$var$paperClasses;

});


parcelRegister("2k7pn", function(module, exports) {

$parcel$export(module.exports, "getPopoverUtilityClass", () => $1b1332252cc77d46$export$88f455dd56c95edb);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $1b1332252cc77d46$export$88f455dd56c95edb(slot) {
    return (0, $5KipK.default)('MuiPopover', slot);
}
const $1b1332252cc77d46$var$popoverClasses = (0, $1XfUG.default)('MuiPopover', [
    'root',
    'paper'
]);
var $1b1332252cc77d46$export$2e2bcd8739ae039 = $1b1332252cc77d46$var$popoverClasses;

});


parcelRegister("9vi4d", function(module, exports) {

$parcel$export(module.exports, "getMenuUtilityClass", () => $6eb5060408a644d0$export$2cf86a63a84fe23d);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $6eb5060408a644d0$export$2cf86a63a84fe23d(slot) {
    return (0, $5KipK.default)('MuiMenu', slot);
}
const $6eb5060408a644d0$var$menuClasses = (0, $1XfUG.default)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $6eb5060408a644d0$export$2e2bcd8739ae039 = $6eb5060408a644d0$var$menuClasses;

});


parcelRegister("8OTRS", function(module, exports) {

$parcel$export(module.exports, "StyledSelectSelect", () => $66be5471b3e0c6eb$export$50b3545a8ccd87af);
$parcel$export(module.exports, "StyledSelectIcon", () => $66be5471b3e0c6eb$export$7dd4d92f143902e3);
$parcel$export(module.exports, "default", () => $66be5471b3e0c6eb$export$2e2bcd8739ae039);

var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");


var $3ptEP = parcelRequire("3ptEP");

var $dvg8e = parcelRequire("dvg8e");

var $6UFJL = parcelRequire("6UFJL");

var $3EMXY = parcelRequire("3EMXY");

var $i29Fs = parcelRequire("i29Fs");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $66be5471b3e0c6eb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $dvg8e.default)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $6UFJL.getNativeSelectUtilityClasses), classes);
};
const $66be5471b3e0c6eb$export$50b3545a8ccd87af = (0, $3EMXY.default)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $6UFJL.default).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $66be5471b3e0c6eb$var$NativeSelectSelect = (0, $3EMXY.default)($66be5471b3e0c6eb$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $i29Fs.default),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $6UFJL.default).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $66be5471b3e0c6eb$export$7dd4d92f143902e3 = (0, $3EMXY.default)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $6UFJL.default).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $66be5471b3e0c6eb$var$NativeSelectIcon = (0, $3EMXY.default)($66be5471b3e0c6eb$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $dvg8e.default)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $66be5471b3e0c6eb$var$NativeSelectInput = /*#__PURE__*/ $jXEQt.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $66be5471b3e0c6eb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsxs)($jXEQt.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7rM61.jsx)($66be5471b3e0c6eb$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $fQojQ.default)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $7rM61.jsx)($66be5471b3e0c6eb$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $66be5471b3e0c6eb$export$2e2bcd8739ae039 = $66be5471b3e0c6eb$var$NativeSelectInput;

});
parcelRegister("6UFJL", function(module, exports) {

$parcel$export(module.exports, "getNativeSelectUtilityClasses", () => $5088592f66494ec0$export$1ee13051fd9e2ab5);
$parcel$export(module.exports, "default", () => $5088592f66494ec0$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $5088592f66494ec0$export$1ee13051fd9e2ab5(slot) {
    return (0, $5KipK.default)('MuiNativeSelect', slot);
}
const $5088592f66494ec0$var$nativeSelectClasses = (0, $1XfUG.default)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $5088592f66494ec0$export$2e2bcd8739ae039 = $5088592f66494ec0$var$nativeSelectClasses;

});


parcelRegister("dyqeq", function(module, exports) {

$parcel$export(module.exports, "getSelectUtilityClasses", () => $9de2cc64b7b6f404$export$2c0c1ee5a3392e);
$parcel$export(module.exports, "default", () => $9de2cc64b7b6f404$export$2e2bcd8739ae039);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $9de2cc64b7b6f404$export$2c0c1ee5a3392e(slot) {
    return (0, $5KipK.default)('MuiSelect', slot);
}
const $9de2cc64b7b6f404$var$selectClasses = (0, $1XfUG.default)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $9de2cc64b7b6f404$export$2e2bcd8739ae039 = $9de2cc64b7b6f404$var$selectClasses;

});


parcelRegister("5VkM0", function(module, exports) {

$parcel$export(module.exports, "default", () => $450263c6ccf8027a$export$2e2bcd8739ae039);

var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
'use client';
var $450263c6ccf8027a$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

});


parcelRegister("fgESc", function(module, exports) {

$parcel$export(module.exports, "getTextFieldUtilityClass", () => $b1d80e3919999c26$export$c1bdcbaf0596aeda);

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $b1d80e3919999c26$export$c1bdcbaf0596aeda(slot) {
    return (0, $5KipK.default)('MuiTextField', slot);
}
const $b1d80e3919999c26$var$textFieldClasses = (0, $1XfUG.default)('MuiTextField', [
    'root'
]);
var $b1d80e3919999c26$export$2e2bcd8739ae039 = $b1d80e3919999c26$var$textFieldClasses;

});


parcelRegister("hrh4V", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("qKLka"),
    $parcel$import("1Bjlq")
]).then(()=>parcelRequire('hHzgW'));

});

parcelRegister("cFYuO", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("2y6Wf"),
    $parcel$import("qKLka"),
    $parcel$import("4JBv9")
]).then(()=>parcelRequire('dLhi7'));

});

parcelRegister("c7ZIy", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("2y6Wf"),
    $parcel$import("qKLka"),
    $parcel$import("izBze")
]).then(()=>parcelRequire('4aaV1'));

});

parcelRegister("9Es5b", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("2z2FG"),
    $parcel$import("2y6Wf"),
    $parcel$import("99Ovk")
]).then(()=>parcelRequire('eSkk9'));

});

parcelRegister("94Evl", function(module, exports) {
module.exports = Promise.all([
    $parcel$import("2z2FG"),
    $parcel$import("2y6Wf"),
    $parcel$import("7nOBa")
]).then(()=>parcelRequire('d7afa'));

});

var $4ff4552195c17226$exports = {};
$parcel$extendImportMap({
    "lQNug": "index.es.ba30048e.js",
    "kHABB": "service-worker.js",
    "1Bjlq": "About.ed2b0acc.js",
    "qKLka": "About.8da2c415.js",
    "4JBv9": "History.d3840304.js",
    "2y6Wf": "History.5fc9deea.js",
    "izBze": "Home.9e119ab1.js",
    "99Ovk": "Repeatable.de845cb7.js",
    "2z2FG": "Repeatable.a4bed887.js",
    "7nOBa": "Template.2bce8f86.js"
});


var $7rM61 = parcelRequire("7rM61");


var $jXEQt = parcelRequire("jXEQt");
var $bb6cb2ce16bd7b19$exports = {};
'use strict';
function $bb6cb2ce16bd7b19$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($bb6cb2ce16bd7b19$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$bb6cb2ce16bd7b19$var$checkDCE();

$bb6cb2ce16bd7b19$exports = (parcelRequire("fbV55"));



var $bw3ua = parcelRequire("bw3ua");

var $4Tpzr = parcelRequire("4Tpzr");

var $7rM61 = parcelRequire("7rM61");


var $1MCB7 = parcelRequire("1MCB7");

var $jXEQt = parcelRequire("jXEQt");

var $4Tpzr = parcelRequire("4Tpzr");

var $7rM61 = parcelRequire("7rM61");

var $jXEQt = parcelRequire("jXEQt");

var $1jMLP = parcelRequire("1jMLP");

var $4EGLj = parcelRequire("4EGLj");

var $7rM61 = parcelRequire("7rM61");

var $jXEQt = parcelRequire("jXEQt");

var $fQojQ = parcelRequire("fQojQ");

var $jaCzf = parcelRequire("jaCzf");

var $iBnPH = parcelRequire("iBnPH");
var $ilrFM = parcelRequire("ilrFM");

var $gvt33 = parcelRequire("gvt33");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $ddfca3c66224f043$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $jaCzf.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $iBnPH.default));
    const Box = /*#__PURE__*/ $jXEQt.forwardRef(function Box(inProps, ref) {
        const theme = (0, $gvt33.default)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $ilrFM.default)(inProps);
        return /*#__PURE__*/ (0, $7rM61.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $fQojQ.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}




var $jZ8iZ = parcelRequire("jZ8iZ");

var $8sdmv = parcelRequire("8sdmv");

var $lyEQv = parcelRequire("lyEQv");

var $1XfUG = parcelRequire("1XfUG");
const $c46d8bb3177a48ff$var$boxClasses = (0, $1XfUG.default)('MuiBox', [
    'root'
]);
var $c46d8bb3177a48ff$export$2e2bcd8739ae039 = $c46d8bb3177a48ff$var$boxClasses;


'use client';
const $a3bb9d4cbb88f3af$var$defaultTheme = (0, $8sdmv.default)();
const $a3bb9d4cbb88f3af$var$Box = (0, $ddfca3c66224f043$export$2e2bcd8739ae039)({
    themeId: (0, $lyEQv.default),
    defaultTheme: $a3bb9d4cbb88f3af$var$defaultTheme,
    defaultClassName: (0, $c46d8bb3177a48ff$export$2e2bcd8739ae039).root,
    generateClassName: (0, $jZ8iZ.default).generate
});
var $a3bb9d4cbb88f3af$export$2e2bcd8739ae039 = $a3bb9d4cbb88f3af$var$Box;


var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $39dKT = parcelRequire("39dKT");

var $IRdXs = parcelRequire("IRdXs");
var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $8oH7q = parcelRequire("8oH7q");

var $5MTiZ = parcelRequire("5MTiZ");

var $dvg8e = parcelRequire("dvg8e");

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $5d0e5f72f223e361$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $5KipK.default)('MuiLinearProgress', slot);
}
const $5d0e5f72f223e361$var$linearProgressClasses = (0, $1XfUG.default)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $5d0e5f72f223e361$export$2e2bcd8739ae039 = $5d0e5f72f223e361$var$linearProgressClasses;



var $7rM61 = parcelRequire("7rM61");
'use client';
const $2be3aa8f7b0ea4eb$var$TRANSITION_DURATION = 4; // seconds
const $2be3aa8f7b0ea4eb$var$indeterminate1Keyframe = (0, $IRdXs.keyframes)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $2be3aa8f7b0ea4eb$var$indeterminate1Animation = typeof $2be3aa8f7b0ea4eb$var$indeterminate1Keyframe !== 'string' ? (0, $IRdXs.css)`
        animation: ${$2be3aa8f7b0ea4eb$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $2be3aa8f7b0ea4eb$var$indeterminate2Keyframe = (0, $IRdXs.keyframes)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $2be3aa8f7b0ea4eb$var$indeterminate2Animation = typeof $2be3aa8f7b0ea4eb$var$indeterminate2Keyframe !== 'string' ? (0, $IRdXs.css)`
        animation: ${$2be3aa8f7b0ea4eb$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $2be3aa8f7b0ea4eb$var$bufferKeyframe = (0, $IRdXs.keyframes)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $2be3aa8f7b0ea4eb$var$bufferAnimation = typeof $2be3aa8f7b0ea4eb$var$bufferKeyframe !== 'string' ? (0, $IRdXs.css)`
        animation: ${$2be3aa8f7b0ea4eb$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $2be3aa8f7b0ea4eb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $dvg8e.default)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $dvg8e.default)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $dvg8e.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $dvg8e.default)(color)}`,
            variant === 'buffer' && `color${(0, $dvg8e.default)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $5d0e5f72f223e361$export$bc8a6ea1eb17d7c6), classes);
};
const $2be3aa8f7b0ea4eb$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.5);
};
const $2be3aa8f7b0ea4eb$var$LinearProgressRoot = (0, $3EMXY.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $dvg8e.default)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $2be3aa8f7b0ea4eb$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $2be3aa8f7b0ea4eb$var$LinearProgressDashed = (0, $3EMXY.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $dvg8e.default)(ownerState.color)}`]
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>{
                const backgroundColor = $2be3aa8f7b0ea4eb$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $2be3aa8f7b0ea4eb$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$2be3aa8f7b0ea4eb$var$bufferKeyframe} 3s infinite linear`
});
const $2be3aa8f7b0ea4eb$var$LinearProgressBar1 = (0, $3EMXY.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $dvg8e.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$2be3aa8f7b0ea4eb$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$2be3aa8f7b0ea4eb$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $2be3aa8f7b0ea4eb$var$indeterminate1Animation || {
                    animation: `${$2be3aa8f7b0ea4eb$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $2be3aa8f7b0ea4eb$var$LinearProgressBar2 = (0, $3EMXY.default)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $dvg8e.default)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $2be3aa8f7b0ea4eb$var$getColorShade(theme, color),
                        transition: `transform .${$2be3aa8f7b0ea4eb$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $2be3aa8f7b0ea4eb$var$indeterminate2Animation || {
                    animation: `${$2be3aa8f7b0ea4eb$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $2be3aa8f7b0ea4eb$var$LinearProgress = /*#__PURE__*/ $jXEQt.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $2be3aa8f7b0ea4eb$var$useUtilityClasses(ownerState);
    const isRtl = (0, $39dKT.useRtl)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $7rM61.jsxs)($2be3aa8f7b0ea4eb$var$LinearProgressRoot, {
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $7rM61.jsx)($2be3aa8f7b0ea4eb$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $7rM61.jsx)($2be3aa8f7b0ea4eb$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $7rM61.jsx)($2be3aa8f7b0ea4eb$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $2be3aa8f7b0ea4eb$export$2e2bcd8739ae039 = $2be3aa8f7b0ea4eb$var$LinearProgress;


var $1MCB7 = parcelRequire("1MCB7");

var $jXEQt = parcelRequire("jXEQt");

var $4DpeF = parcelRequire("4DpeF");
function $66c542d2f5f3138f$export$ae720cfaa84af465(doc) {
    if (!doc || typeof doc !== 'object') return false;
    const d = doc;
    return typeof d._id === 'string' && d._id.startsWith('repeatable:instance:') && d.schemaVersion === undefined && Array.isArray(d.values) && (d.values.length === 0 || typeof d.values[0] === 'boolean');
}
function $66c542d2f5f3138f$export$4263640bc1346916(repeatable, template) {
    // Get checkbox IDs from the migrated template's markdown
    const checkboxInfos = (0, $4DpeF.parseCheckboxIds)(template.markdown);
    // Convert boolean[] to Record<string, boolean>
    // Map positional values to the checkbox IDs
    const migratedValues = {};
    for(let i = 0; i < checkboxInfos.length; i++){
        const info = checkboxInfos[i];
        // Use the positional value if available, otherwise use template default
        if (i < repeatable.values.length) migratedValues[info.id] = repeatable.values[i];
        else {
            // Find the template default for this checkbox
            const templateValue = template.values.find((v)=>v.id === info.id);
            migratedValues[info.id] = templateValue?.default ?? false;
        }
    }
    return {
        ...repeatable,
        values: migratedValues,
        schemaVersion: 2
    };
}



var $4DpeF = parcelRequire("4DpeF");
function $5509c90f46c6d069$export$c85282b0c3759222(doc) {
    if (!doc || typeof doc !== 'object') return false;
    const d = doc;
    // Must be a template document without schema version
    if (typeof d._id !== 'string' || !d._id.startsWith('repeatable:template:')) return false;
    if (d.schemaVersion !== undefined) return false;
    // Legacy if values is missing/undefined
    if (d.values === undefined) return true;
    // Legacy if values is boolean[] (empty array or first element is boolean)
    if (Array.isArray(d.values)) return d.values.length === 0 || typeof d.values[0] === 'boolean';
    return false;
}
function $5509c90f46c6d069$export$8b9d5804a661aaee(template) {
    // Ensure all checkboxes have IDs embedded in the markdown
    const migratedMarkdown = (0, $4DpeF.ensureCheckboxIds)(template.markdown);
    // Parse the checkbox IDs from the updated markdown
    const checkboxInfos = (0, $4DpeF.parseCheckboxIds)(migratedMarkdown);
    // Convert boolean[] to CheckboxValue[]
    // Map positional values to the checkbox IDs
    // Use optional chaining since legacy templates may have no values array
    const migratedValues = checkboxInfos.map((info, index)=>({
            id: info.id,
            default: template.values?.[index] ?? false
        }));
    return {
        ...template,
        markdown: migratedMarkdown,
        values: migratedValues,
        schemaVersion: 2
    };
}


async function $a0449dd1ac778dcd$export$706e47ccfb64ae53(db) {
    const allDocs = await db.allDocs({
        include_docs: true
    });
    for (const row of allDocs.rows){
        if ((0, $5509c90f46c6d069$export$c85282b0c3759222)(row.doc) || (0, $66c542d2f5f3138f$export$ae720cfaa84af465)(row.doc)) return true;
    }
    return false;
}
async function $a0449dd1ac778dcd$export$15caca2637f8f026(db, onProgress) {
    const allDocs = await db.allDocs({
        include_docs: true
    });
    const legacyTemplates = [];
    const legacyRepeatables = [];
    for (const row of allDocs.rows){
        if ((0, $5509c90f46c6d069$export$c85282b0c3759222)(row.doc)) legacyTemplates.push(row.doc);
        else if ((0, $66c542d2f5f3138f$export$ae720cfaa84af465)(row.doc)) legacyRepeatables.push(row.doc);
    }
    const totalTemplates = legacyTemplates.length;
    const totalRepeatables = legacyRepeatables.length;
    const migratedTemplates = new Map();
    // Phase 1: Migrate templates
    for(let i = 0; i < legacyTemplates.length; i++){
        const template = legacyTemplates[i];
        const migrated = (0, $5509c90f46c6d069$export$8b9d5804a661aaee)(template);
        // Save the migrated template
        await db.put(migrated);
        migratedTemplates.set(migrated._id, migrated);
        onProgress?.({
            phase: 'templates',
            current: i + 1,
            total: totalTemplates
        });
    }
    // Phase 2: Migrate repeatables
    for(let i = 0; i < legacyRepeatables.length; i++){
        const repeatable = legacyRepeatables[i];
        let template = migratedTemplates.get(repeatable.template);
        if (!template) // Template wasn't in the migration set - fetch it from DB
        // It may already be schema version 2
        try {
            template = await db.get(repeatable.template);
        } catch  {
            // Template not found - skip this repeatable
            console.warn(`Template ${repeatable.template} not found for repeatable ${repeatable._id}`);
            continue;
        }
        const migrated = (0, $66c542d2f5f3138f$export$4263640bc1346916)(repeatable, template);
        await db.put(migrated);
        onProgress?.({
            phase: 'repeatables',
            current: i + 1,
            total: totalRepeatables
        });
    }
}


/**
 * Full-screen overlay that blocks the app until migration completes.
 * Shows progress bar and handles errors with retry capability.
 */ function $5ab9708dbcb8063f$var$MigrationScreen({ db: db, onComplete: onComplete }) {
    const [checking, setChecking] = (0, $jXEQt.useState)(true);
    const [migrating, setMigrating] = (0, $jXEQt.useState)(false);
    const [progress, setProgress] = (0, $jXEQt.useState)(null);
    const [error, setError] = (0, $jXEQt.useState)(null);
    const handleProgress = (0, $jXEQt.useCallback)((p)=>{
        setProgress(p);
    }, []);
    const runMigration = (0, $jXEQt.useCallback)(async ()=>{
        setError(null);
        setMigrating(true);
        try {
            await (0, $a0449dd1ac778dcd$export$15caca2637f8f026)(db, handleProgress);
            onComplete();
        } catch (err) {
            console.error('Migration failed:', err);
            setError(err instanceof Error ? err.message : 'Migration failed');
            setMigrating(false);
        }
    }, [
        db,
        handleProgress,
        onComplete
    ]);
    (0, $jXEQt.useEffect)(()=>{
        async function checkAndMigrate() {
            try {
                const needs = await (0, $a0449dd1ac778dcd$export$706e47ccfb64ae53)(db);
                setChecking(false);
                if (needs) await runMigration();
                else onComplete();
            } catch (err) {
                console.error('Migration check failed:', err);
                setError(err instanceof Error ? err.message : 'Failed to check migration status');
                setChecking(false);
            }
        }
        checkAndMigrate();
    }, [
        db,
        onComplete,
        runMigration
    ]);
    // Calculate progress percentage
    let progressPercent = 0;
    let progressText = 'Checking database...';
    // FIXME: migration screen shouldn't understand internals of progress like this
    if (progress) {
        if (progress.phase === 'templates') {
            progressPercent = progress.current / progress.total * 50;
            progressText = `Migrating templates: ${progress.current} / ${progress.total}`;
        } else {
            progressPercent = 50 + progress.current / progress.total * 50;
            progressText = `Migrating repeatables: ${progress.current} / ${progress.total}`;
        }
    } else if (migrating) progressText = 'Starting migration...';
    return /*#__PURE__*/ (0, $7rM61.jsxs)((0, $a3bb9d4cbb88f3af$export$2e2bcd8739ae039), {
        sx: {
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            bgcolor: 'background.paper',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
            p: 4
        },
        children: [
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                variant: "h5",
                gutterBottom: true,
                children: "Updating Database"
            }),
            checking && /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                color: "text.secondary",
                children: "Checking database version..."
            }),
            migrating && !error && /*#__PURE__*/ (0, $7rM61.jsxs)((0, $7rM61.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $a3bb9d4cbb88f3af$export$2e2bcd8739ae039), {
                        sx: {
                            width: '100%',
                            maxWidth: 400,
                            mt: 2
                        },
                        children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $2be3aa8f7b0ea4eb$export$2e2bcd8739ae039), {
                            variant: "determinate",
                            value: progressPercent
                        })
                    }),
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                        sx: {
                            mt: 1
                        },
                        color: "text.secondary",
                        children: progressText
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $7rM61.jsxs)((0, $7rM61.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                        color: "error",
                        sx: {
                            mt: 2
                        },
                        children: error
                    }),
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                        component: "button",
                        onClick: runMigration,
                        sx: {
                            mt: 2,
                            cursor: 'pointer',
                            color: 'primary.main',
                            textDecoration: 'underline',
                            border: 'none',
                            background: 'none',
                            fontSize: 'inherit'
                        },
                        children: "Retry"
                    })
                ]
            })
        ]
    });
}
var $5ab9708dbcb8063f$export$2e2bcd8739ae039 = $5ab9708dbcb8063f$var$MigrationScreen;


/**
 * Provider component that checks for and performs database migration on startup.
 * Blocks the app with a full-screen overlay until migration is complete.
 *
 * Must be rendered inside UserProvider (needs user state to access database).
 */ const $4a0fd26d5ccde34c$var$MigrationProvider = ({ children: children })=>{
    const user = (0, $4EGLj.useSelector)((state)=>state.user.value);
    const [migrationComplete, setMigrationComplete] = (0, $jXEQt.useState)(false);
    // User should always be defined here since we're inside UserProvider
    // but guard against it just in case
    if (!user) return null;
    const handle = (0, $1jMLP.default)(user);
    if (!migrationComplete) return /*#__PURE__*/ (0, $7rM61.jsx)((0, $5ab9708dbcb8063f$export$2e2bcd8739ae039), {
        db: handle,
        onComplete: ()=>setMigrationComplete(true)
    });
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $7rM61.Fragment), {
        children: children
    });
};
var $4a0fd26d5ccde34c$export$2e2bcd8739ae039 = $4a0fd26d5ccde34c$var$MigrationProvider;





// PERF: configure babel properly so we can use { ArrowBack } etc instead
// https://material-ui.com/guides/minimizing-bundle-size/#option-2

var $7rM61 = parcelRequire("7rM61");

var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $efad375d2b35b2de$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20z"
}), 'ArrowBack');



var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $a196c28bed0b6c84$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckBox');



var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $302181e27fe30bdb$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9m-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8z"
}), 'History');



var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $ebde45f929f80ed4$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z"
}), 'Info');



var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $dvg8e = parcelRequire("dvg8e");

var $8oH7q = parcelRequire("8oH7q");

var $IcFU1 = parcelRequire("IcFU1");

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $a728948cf4dd827a$export$47a2da616e55e8e9(slot) {
    return (0, $5KipK.default)('MuiAppBar', slot);
}
const $a728948cf4dd827a$var$appBarClasses = (0, $1XfUG.default)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $a728948cf4dd827a$export$2e2bcd8739ae039 = $a728948cf4dd827a$var$appBarClasses;



var $7rM61 = parcelRequire("7rM61");
'use client';
const $1dd73e25187d7e5a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $dvg8e.default)(color)}`,
            `position${(0, $dvg8e.default)(position)}`
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $a728948cf4dd827a$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $1dd73e25187d7e5a$var$joinVars = (var1, var2)=>var1 ? `${var1.replace(')', '')}, ${var2})` : var2;
const $1dd73e25187d7e5a$var$AppBarRoot = (0, $3EMXY.default)((0, $IcFU1.default), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $dvg8e.default)(ownerState.position)}`],
            styles[`color${(0, $dvg8e.default)(ownerState.color)}`]
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0,
        variants: [
            {
                props: {
                    position: 'fixed'
                },
                style: {
                    position: 'fixed',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0,
                    '@media print': {
                        // Prevent the app bar to be visible on each printed page.
                        position: 'absolute'
                    }
                }
            },
            {
                props: {
                    position: 'absolute'
                },
                style: {
                    position: 'absolute',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'sticky'
                },
                style: {
                    position: 'sticky',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'static'
                },
                style: {
                    position: 'static'
                }
            },
            {
                props: {
                    position: 'relative'
                },
                style: {
                    position: 'relative'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    '--AppBar-color': 'inherit',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: {
                    color: 'default'
                },
                style: {
                    '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
                    '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
                    ...theme.applyStyles('dark', {
                        '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
                        '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
                    })
                }
            },
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--AppBar-background': (theme.vars ?? theme).palette[color].main,
                        '--AppBar-color': (theme.vars ?? theme).palette[color].contrastText
                    }
                })),
            {
                props: (props)=>props.enableColorOnDark === true && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: (props)=>props.enableColorOnDark === false && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundColor: theme.vars ? $1dd73e25187d7e5a$var$joinVars(theme.vars.palette.AppBar.darkBg, 'var(--AppBar-background)') : null,
                        color: theme.vars ? $1dd73e25187d7e5a$var$joinVars(theme.vars.palette.AppBar.darkColor, 'var(--AppBar-color)') : null
                    })
                }
            },
            {
                props: {
                    color: 'transparent'
                },
                style: {
                    '--AppBar-background': 'transparent',
                    '--AppBar-color': 'inherit',
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundImage: 'none'
                    })
                }
            }
        ]
    })));
const $1dd73e25187d7e5a$var$AppBar = /*#__PURE__*/ $jXEQt.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    };
    const classes = $1dd73e25187d7e5a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($1dd73e25187d7e5a$var$AppBarRoot, {
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $fQojQ.default)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref,
        ...other
    });
});
var $1dd73e25187d7e5a$export$2e2bcd8739ae039 = $1dd73e25187d7e5a$var$AppBar;



var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $5KipK = parcelRequire("5KipK");

var $3ptEP = parcelRequire("3ptEP");

var $l7dVi = parcelRequire("l7dVi");

var $b1cIR = parcelRequire("b1cIR");

var $75a0P = parcelRequire("75a0P");

var $jECx5 = parcelRequire("jECx5");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $0b529c304bac4bc3$var$defaultTheme = (0, $jECx5.default)();
const $0b529c304bac4bc3$var$defaultCreateStyledComponent = (0, $75a0P.default)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $l7dVi.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $0b529c304bac4bc3$var$useThemePropsDefault = (inProps)=>(0, $b1cIR.default)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $0b529c304bac4bc3$var$defaultTheme
    });
const $0b529c304bac4bc3$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $5KipK.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $l7dVi.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $3ptEP.default)(slots, getContainerUtilityClass, classes);
};
function $0b529c304bac4bc3$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $0b529c304bac4bc3$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $0b529c304bac4bc3$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $jXEQt.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $0b529c304bac4bc3$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $7rM61.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $fQojQ.default)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}



var $dvg8e = parcelRequire("dvg8e");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");
'use client';
const $8759857c9e39fe72$var$Container = (0, $0b529c304bac4bc3$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $3EMXY.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $dvg8e.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $5MTiZ.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $8759857c9e39fe72$export$2e2bcd8739ae039 = $8759857c9e39fe72$var$Container;


var $1AHpK = parcelRequire("1AHpK");
var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");


var $3ptEP = parcelRequire("3ptEP");

var $8H6A5 = parcelRequire("8H6A5");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $8oH7q = parcelRequire("8oH7q");

var $5MTiZ = parcelRequire("5MTiZ");

var $7lGG0 = parcelRequire("7lGG0");

var $ab5Dn = parcelRequire("ab5Dn");

var $dvg8e = parcelRequire("dvg8e");

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $ef5137838ad200c7$export$5e8702d71474f093(slot) {
    return (0, $5KipK.default)('MuiIconButton', slot);
}
const $ef5137838ad200c7$var$iconButtonClasses = (0, $1XfUG.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $ef5137838ad200c7$export$2e2bcd8739ae039 = $ef5137838ad200c7$var$iconButtonClasses;



var $7rM61 = parcelRequire("7rM61");
'use client';
const $f614096fb9c79cdb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $dvg8e.default)(color)}`,
            edge && `edge${(0, $dvg8e.default)(edge)}`,
            `size${(0, $dvg8e.default)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $ef5137838ad200c7$export$5e8702d71474f093), classes);
};
const $f614096fb9c79cdb$var$IconButtonRoot = (0, $3EMXY.default)((0, $7lGG0.default), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $dvg8e.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $dvg8e.default)(ownerState.edge)}`],
            styles[`size${(0, $dvg8e.default)(ownerState.size)}`]
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $31RRc.default)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $ef5137838ad200c7$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $ef5137838ad200c7$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $f614096fb9c79cdb$var$IconButtonLoadingIndicator = (0, $3EMXY.default)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $f614096fb9c79cdb$var$IconButton = /*#__PURE__*/ $jXEQt.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $8H6A5.default)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $7rM61.jsx)((0, $ab5Dn.default), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $f614096fb9c79cdb$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsxs)($f614096fb9c79cdb$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $fQojQ.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $7rM61.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $7rM61.jsx)($f614096fb9c79cdb$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $f614096fb9c79cdb$export$2e2bcd8739ae039 = $f614096fb9c79cdb$var$IconButton;


var $cSdwB = parcelRequire("cSdwB");
var $gS6ai = parcelRequire("gS6ai");
var $5IqKW = parcelRequire("5IqKW");
var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $4b8ffaf6b45c09e0$export$b12cb262231eef32(slot) {
    return (0, $5KipK.default)('MuiToolbar', slot);
}
const $4b8ffaf6b45c09e0$var$toolbarClasses = (0, $1XfUG.default)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $4b8ffaf6b45c09e0$export$2e2bcd8739ae039 = $4b8ffaf6b45c09e0$var$toolbarClasses;



var $7rM61 = parcelRequire("7rM61");
'use client';
const $cce24f072f43f2cc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $4b8ffaf6b45c09e0$export$b12cb262231eef32), classes);
};
const $cce24f072f43f2cc$var$ToolbarRoot = (0, $3EMXY.default)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $cce24f072f43f2cc$var$Toolbar = /*#__PURE__*/ $jXEQt.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $cce24f072f43f2cc$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($cce24f072f43f2cc$var$ToolbarRoot, {
        as: component,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $cce24f072f43f2cc$export$2e2bcd8739ae039 = $cce24f072f43f2cc$var$Toolbar;


var $1MCB7 = parcelRequire("1MCB7");

var $jXEQt = parcelRequire("jXEQt");

var $4Tpzr = parcelRequire("4Tpzr");

var $4EGLj = parcelRequire("4EGLj");

var $7rM61 = parcelRequire("7rM61");

var $jpsSb = parcelRequire("jpsSb");

var $jXEQt = parcelRequire("jXEQt");

var $8iAmL = parcelRequire("8iAmL");

var $1jMLP = parcelRequire("1jMLP");

var $4zIwb = parcelRequire("4zIwb");

var $4EGLj = parcelRequire("4EGLj");
const $7b995d39a8ab379a$var$inputStyle = {
    paddingLeft: '0.5em',
    color: 'inherit'
};
function $7b995d39a8ab379a$export$5c7cf5df8b66b0f5() {
    const dispatch = (0, $4EGLj.useDispatch)();
    const user = (0, $4EGLj.useSelector)((state)=>state.user.value);
    const handle = (0, $1jMLP.default)(user);
    const repeatable = (0, $4EGLj.useSelector)((state)=>state.docs.repeatable);
    const [slug, setSlug] = (0, $jXEQt.useState)(repeatable?.slug);
    const template = (0, $4EGLj.useSelector)((state)=>state.docs.template);
    function changeSlug({ target: target }) {
        // @ts-expect-error FIXME: check if nodeValue works
        const targetValue = target.value;
        // we know that if anyone calls this function template has a value
        const slugType = template.slug.type;
        const value = slugType === (0, $8iAmL.SlugType).Date || slugType === (0, $8iAmL.SlugType).Timestamp ? new Date(targetValue).getTime() : targetValue;
        setSlug(value);
    }
    async function storeSlugChange() {
        // we know that if anyone calls this function repeatable has a value
        const copy = Object.assign({}, repeatable);
        copy.slug = slug;
        await handle.userPut(copy);
        dispatch((0, $4zIwb.setRepeatable)(copy));
    }
    if (!(repeatable && template)) return null;
    let slugInput;
    if (template.slug.type === (0, $8iAmL.SlugType).URL || template.slug.type === (0, $8iAmL.SlugType).String) slugInput = /*#__PURE__*/ (0, $7rM61.jsx)((0, $jpsSb.default), {
        type: "text",
        sx: $7b995d39a8ab379a$var$inputStyle,
        placeholder: template.slug.placeholder,
        value: slug,
        onChange: changeSlug,
        onBlur: storeSlugChange
    });
    else if (template.slug.type === (0, $8iAmL.SlugType).Date) {
        // FIXME: Clean This Up! The format required for the native date input type cannot
        // be manufactured from the native JavaScript date type. If we were in raw HTML
        // we could post-set it with Javascript by using valueAsNumber, but not in situ
        const slugDate = new Date(slug);
        const awkwardlyFormattedSlug = [
            slugDate.getFullYear(),
            `${slugDate.getMonth() + 1}`.padStart(2, '0'),
            `${slugDate.getDate()}`.padStart(2, '0')
        ].join('-');
        slugInput = /*#__PURE__*/ (0, $7rM61.jsx)((0, $jpsSb.default), {
            type: "date",
            // TODO: make sure this works for accessibility
            inputProps: {
                role: 'entry'
            },
            sx: $7b995d39a8ab379a$var$inputStyle,
            value: awkwardlyFormattedSlug,
            onChange: changeSlug,
            onBlur: storeSlugChange
        });
    } else {
        // FIXME: Clean This Up! The format required for the native date input type cannot
        // be manufactured from the native JavaScript date type. If we were in raw HTML
        // we could post-set it with Javascript by using valueAsNumber, but not in situ
        const slugDate = new Date(slug);
        const awkwardlyFormattedSlug = `${[
            slugDate.getFullYear(),
            `${slugDate.getMonth() + 1}`.padStart(2, '0'),
            `${slugDate.getDate()}`.padStart(2, '0')
        ].join('-')}T${[
            `${slugDate.getHours()}`.padStart(2, '0'),
            `${slugDate.getMinutes()}`.padStart(2, '0')
        ].join(':')}`;
        slugInput = /*#__PURE__*/ (0, $7rM61.jsx)((0, $jpsSb.default), {
            type: "datetime-local",
            // TODO: make sure this works for accessibility
            inputProps: {
                role: 'entry'
            },
            sx: $7b995d39a8ab379a$var$inputStyle,
            value: awkwardlyFormattedSlug,
            onChange: changeSlug,
            onBlur: storeSlugChange
        });
    }
    return slugInput;
}
$7b995d39a8ab379a$export$5c7cf5df8b66b0f5.relevant = (state)=>{
    return state.docs.repeatable && state.docs.template?.slug?.type;
};



var $7rM61 = parcelRequire("7rM61");

var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $40826f720b0103b1$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96m-8.64 6.25c-.39.39-1.02.39-1.41 0L7.2 14.2a.996.996 0 0 1 0-1.41c.39-.39 1.02-.39 1.41 0L10 14.18l4.48-4.48c.39-.39 1.02-.39 1.41 0s.39 1.02 0 1.41z"
}), 'CloudDoneRounded');



var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $86342d8c3347fe8e$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M24 15c0-2.64-2.05-4.78-4.65-4.96C18.67 6.59 15.64 4 12 4c-1.33 0-2.57.36-3.65.97l1.49 1.49C10.51 6.17 11.23 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 .99-.48 1.85-1.21 2.4l1.41 1.41c1.09-.92 1.8-2.27 1.8-3.81M3.71 4.56c-.39.39-.39 1.02 0 1.41l2.06 2.06h-.42c-3.28.35-5.76 3.34-5.29 6.79C.46 17.84 3.19 20 6.22 20h11.51l1.29 1.29c.39.39 1.02.39 1.41 0s.39-1.02 0-1.41L5.12 4.56a.996.996 0 0 0-1.41 0M6 18c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73l8 8z"
}), 'CloudOffRounded');



var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $e6170fb2adbd958d$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96"
}), 'CloudRounded');



var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $7be5906fd236b0bb$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1m-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8m1-3h-2v-2h2z"
}), 'ErrorOutlineRounded');



var $ab5Dn = parcelRequire("ab5Dn");
var $8A5c0 = parcelRequire("8A5c0");
var $25tlC = parcelRequire("25tlC");

var $jXEQt = parcelRequire("jXEQt");

var $4Tpzr = parcelRequire("4Tpzr");

var $4EGLj = parcelRequire("4EGLj");

var $gi5DA = parcelRequire("gi5DA");

var $5xV4Q = parcelRequire("5xV4Q");
function $122bb16f4b5f75a7$var$SyncWidget() {
    const dispatch = (0, $4EGLj.useDispatch)();
    const location = (0, $4Tpzr.useLocation)();
    const isGuest = (0, $4EGLj.useSelector)((0, $gi5DA.selectIsGuest));
    const state = (0, $4EGLj.useSelector)((state)=>state.sync.state);
    const error = (0, $4EGLj.useSelector)((state)=>state.sync.error);
    const progress = (0, $4EGLj.useSelector)((state)=>state.sync.progress);
    if (isGuest) return null;
    const fadeOutConnected = state === (0, $5xV4Q.State).connected && location.pathname !== '/about';
    // TODO: map the states more cleanly in an if else block (we are missing some)
    return(// instantly "fade in" other states, slowly fade out connected state
    /*#__PURE__*/ (0, $7rM61.jsx)((0, $8A5c0.default), {
        in: !fadeOutConnected,
        timeout: fadeOutConnected ? 2000 : 0,
        children: /*#__PURE__*/ (0, $7rM61.jsxs)((0, $f614096fb9c79cdb$export$2e2bcd8739ae039), {
            color: "inherit",
            onClick: ()=>dispatch((0, $5xV4Q.requestSync)()),
            children: [
                state === (0, $5xV4Q.State).error && error && /*#__PURE__*/ (0, $7rM61.jsx)((0, $25tlC.default), {
                    title: `${error.name}: ${error.message}, tap to try again`,
                    children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $7be5906fd236b0bb$export$2e2bcd8739ae039), {})
                }),
                state === (0, $5xV4Q.State).disconnected && /*#__PURE__*/ (0, $7rM61.jsx)((0, $86342d8c3347fe8e$export$2e2bcd8739ae039), {}),
                state === (0, $5xV4Q.State).syncing && /*#__PURE__*/ (0, $7rM61.jsxs)((0, $jXEQt.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $e6170fb2adbd958d$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $ab5Dn.default), {
                            color: "secondary",
                            sx: {
                                position: 'absolute'
                            },
                            size: "33px"
                        }),
                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $ab5Dn.default), {
                            color: "secondary",
                            sx: {
                                position: 'absolute'
                            },
                            variant: "determinate",
                            value: progress
                        })
                    ]
                }),
                state === (0, $5xV4Q.State).connected && /*#__PURE__*/ (0, $7rM61.jsx)((0, $40826f720b0103b1$export$2e2bcd8739ae039), {})
            ]
        })
    }));
}
var $122bb16f4b5f75a7$export$2e2bcd8739ae039 = $122bb16f4b5f75a7$var$SyncWidget;



var $7rM61 = parcelRequire("7rM61");

var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $12896c774edc1821$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M19 9h-4V3H9v6H5l7 7zM5 18v2h14v-2z"
}), 'GetApp');



var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $jXEQt = parcelRequire("jXEQt");
'use client';
function $8abd555a91d32eb5$var$usePreviousProps(value) {
    const ref = $jXEQt.useRef({});
    $jXEQt.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
}
var $8abd555a91d32eb5$export$2e2bcd8739ae039 = $8abd555a91d32eb5$var$usePreviousProps;



var $3ptEP = parcelRequire("3ptEP");

'use client';
function $421887b3ff8fab2c$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $8abd555a91d32eb5$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $421887b3ff8fab2c$export$2e2bcd8739ae039 = $421887b3ff8fab2c$var$useBadge;



var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $8oH7q = parcelRequire("8oH7q");

var $5MTiZ = parcelRequire("5MTiZ");

var $dvg8e = parcelRequire("dvg8e");

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $cdba59c993e44cad$export$aaccef17e6dab084(slot) {
    return (0, $5KipK.default)('MuiBadge', slot);
}
const $cdba59c993e44cad$var$badgeClasses = (0, $1XfUG.default)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $cdba59c993e44cad$export$2e2bcd8739ae039 = $cdba59c993e44cad$var$badgeClasses;



var $f92r2 = parcelRequire("f92r2");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $2d332b327cd2e7ee$var$RADIUS_STANDARD = 10;
const $2d332b327cd2e7ee$var$RADIUS_DOT = 4;
const $2d332b327cd2e7ee$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $dvg8e.default)(anchorOrigin.vertical)}${(0, $dvg8e.default)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $dvg8e.default)(anchorOrigin.vertical)}${(0, $dvg8e.default)(anchorOrigin.horizontal)}${(0, $dvg8e.default)(overlap)}`,
            `overlap${(0, $dvg8e.default)(overlap)}`,
            color !== 'default' && `color${(0, $dvg8e.default)(color)}`
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $cdba59c993e44cad$export$aaccef17e6dab084), classes);
};
const $2d332b327cd2e7ee$var$BadgeRoot = (0, $3EMXY.default)('span', {
    name: 'MuiBadge',
    slot: 'Root'
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $2d332b327cd2e7ee$var$BadgeBadge = (0, $3EMXY.default)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $dvg8e.default)(ownerState.anchorOrigin.vertical)}${(0, $dvg8e.default)(ownerState.anchorOrigin.horizontal)}${(0, $dvg8e.default)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $dvg8e.default)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $2d332b327cd2e7ee$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $2d332b327cd2e7ee$var$RADIUS_STANDARD * 2,
        borderRadius: $2d332b327cd2e7ee$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $8oH7q.default)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $2d332b327cd2e7ee$var$RADIUS_DOT,
                    height: $2d332b327cd2e7ee$var$RADIUS_DOT * 2,
                    minWidth: $2d332b327cd2e7ee$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            },
            {
                style: ({ ownerState: ownerState })=>{
                    const { vertical: vertical, horizontal: horizontal } = ownerState.anchorOrigin;
                    const offset = ownerState.overlap === 'circular' ? '14%' : 0;
                    return {
                        '--Badge-translateX': horizontal === 'right' ? '50%' : '-50%',
                        '--Badge-translateY': vertical === 'top' ? '-50%' : '50%',
                        top: vertical === 'top' ? offset : 'initial',
                        bottom: vertical === 'bottom' ? offset : 'initial',
                        right: horizontal === 'right' ? offset : 'initial',
                        left: horizontal === 'left' ? offset : 'initial',
                        transform: 'scale(1) translate(var(--Badge-translateX), var(--Badge-translateY))',
                        transformOrigin: `${horizontal === 'right' ? '100%' : '0%'} ${vertical === 'top' ? '0%' : '100%'}`,
                        [`&.${(0, $cdba59c993e44cad$export$2e2bcd8739ae039).invisible}`]: {
                            transform: 'scale(0) translate(var(--Badge-translateX), var(--Badge-translateY))'
                        }
                    };
                }
            }
        ]
    })));
function $2d332b327cd2e7ee$var$getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const $2d332b327cd2e7ee$var$Badge = /*#__PURE__*/ $jXEQt.forwardRef(function Badge(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $421887b3ff8fab2c$export$2e2bcd8739ae039)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $8abd555a91d32eb5$export$2e2bcd8739ae039)({
        anchorOrigin: $2d332b327cd2e7ee$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $2d332b327cd2e7ee$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $2d332b327cd2e7ee$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const externalForwardedProps = {
        slots: {
            root: slots?.root ?? components.Root,
            badge: slots?.badge ?? components.Badge
        },
        slotProps: {
            root: slotProps?.root ?? componentsProps.root,
            badge: slotProps?.badge ?? componentsProps.badge
        }
    };
    const [RootSlot, rootProps] = (0, $f92r2.default)('root', {
        elementType: $2d332b327cd2e7ee$var$BadgeRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref,
        additionalProps: {
            as: component
        }
    });
    const [BadgeSlot, badgeProps] = (0, $f92r2.default)('badge', {
        elementType: $2d332b327cd2e7ee$var$BadgeBadge,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.badge
    });
    return /*#__PURE__*/ (0, $7rM61.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $7rM61.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var $2d332b327cd2e7ee$export$2e2bcd8739ae039 = $2d332b327cd2e7ee$var$Badge;


var $cSdwB = parcelRequire("cSdwB");
var $5IqKW = parcelRequire("5IqKW");
var $1MCB7 = parcelRequire("1MCB7");

var $4EGLj = parcelRequire("4EGLj");

var $eS20P = parcelRequire("eS20P");
function $49bd2d7a93ad06c6$var$UpdateMenuItem(props) {
    const updateNeeded = (0, $4EGLj.useSelector)((state)=>state.update.waitingToInstall);
    function handleOnClick() {
        (0, $eS20P.triggerUpdate)();
        props.onClick();
    }
    if (updateNeeded) return /*#__PURE__*/ (0, $7rM61.jsxs)((0, $5IqKW.default), {
        onClick: handleOnClick,
        children: [
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $cSdwB.default), {
                children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $2d332b327cd2e7ee$export$2e2bcd8739ae039), {
                    color: "secondary",
                    variant: "dot",
                    invisible: !updateNeeded,
                    children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $12896c774edc1821$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                children: "Update"
            })
        ]
    }, "update");
    return null;
}
var $49bd2d7a93ad06c6$export$2e2bcd8739ae039 = $49bd2d7a93ad06c6$var$UpdateMenuItem;



var $7rM61 = parcelRequire("7rM61");

var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $986f29f3bd8038c0$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M10.09 15.59 11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2"
}), 'ExitToApp');



var $jAvTI = parcelRequire("jAvTI");
var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $ab4rY = parcelRequire("ab4rY");

var $dvg8e = parcelRequire("dvg8e");

var $3M6AT = parcelRequire("3M6AT");

var $8A5c0 = parcelRequire("8A5c0");

var $IcFU1 = parcelRequire("IcFU1");

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $f5a87bc71769817d$export$2177af0aa15c34c2(slot) {
    return (0, $5KipK.default)('MuiDialog', slot);
}
const $f5a87bc71769817d$var$dialogClasses = (0, $1XfUG.default)('MuiDialog', [
    'root',
    'backdrop',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $f5a87bc71769817d$export$2e2bcd8739ae039 = $f5a87bc71769817d$var$dialogClasses;



var $jXEQt = parcelRequire("jXEQt");
'use client';
const $3024ab11506a3458$var$DialogContext = /*#__PURE__*/ $jXEQt.createContext({});
var $3024ab11506a3458$export$2e2bcd8739ae039 = $3024ab11506a3458$var$DialogContext;



var $9AB1p = parcelRequire("9AB1p");

var $3EMXY = parcelRequire("3EMXY");
var $k3tJq = parcelRequire("k3tJq");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $f92r2 = parcelRequire("f92r2");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $889790aee0bf1605$var$DialogBackdrop = (0, $3EMXY.default)((0, $9AB1p.default), {
    name: 'MuiDialog',
    slot: 'Backdrop'
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $889790aee0bf1605$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        backdrop: [
            'backdrop'
        ],
        container: [
            'container',
            `scroll${(0, $dvg8e.default)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $dvg8e.default)(scroll)}`,
            `paperWidth${(0, $dvg8e.default)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $f5a87bc71769817d$export$2177af0aa15c34c2), classes);
};
const $889790aee0bf1605$var$DialogRoot = (0, $3EMXY.default)((0, $3M6AT.default), {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $889790aee0bf1605$var$DialogContainer = (0, $3EMXY.default)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $dvg8e.default)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $889790aee0bf1605$var$DialogPaper = (0, $3EMXY.default)((0, $IcFU1.default), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $dvg8e.default)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $dvg8e.default)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $f5a87bc71769817d$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $f5a87bc71769817d$export$2e2bcd8739ae039).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $f5a87bc71769817d$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $889790aee0bf1605$var$Dialog = /*#__PURE__*/ $jXEQt.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $k3tJq.default)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $IcFU1.default), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $8A5c0.default), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $889790aee0bf1605$var$useUtilityClasses(ownerState);
    const backdropClick = $jXEQt.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $ab4rY.default)(ariaLabelledbyProp);
    const dialogContextValue = $jXEQt.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $f92r2.default)('root', {
        elementType: $889790aee0bf1605$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $f92r2.default)('backdrop', {
        elementType: $889790aee0bf1605$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.backdrop
    });
    const [PaperSlot, paperSlotProps] = (0, $f92r2.default)('paper', {
        elementType: $889790aee0bf1605$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $f92r2.default)('container', {
        elementType: $889790aee0bf1605$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, $f92r2.default)('transition', {
        elementType: (0, $8A5c0.default),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $7rM61.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $7rM61.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $7rM61.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $7rM61.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $3024ab11506a3458$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $889790aee0bf1605$export$2e2bcd8739ae039 = $889790aee0bf1605$var$Dialog;


var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $3381477a8fb646f2$export$5e57a444791c63be(slot) {
    return (0, $5KipK.default)('MuiDialogActions', slot);
}
const $3381477a8fb646f2$var$dialogActionsClasses = (0, $1XfUG.default)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $3381477a8fb646f2$export$2e2bcd8739ae039 = $3381477a8fb646f2$var$dialogActionsClasses;



var $7rM61 = parcelRequire("7rM61");
'use client';
const $67fe27d384958346$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $3381477a8fb646f2$export$5e57a444791c63be), classes);
};
const $67fe27d384958346$var$DialogActionsRoot = (0, $3EMXY.default)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $67fe27d384958346$var$DialogActions = /*#__PURE__*/ $jXEQt.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $67fe27d384958346$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($67fe27d384958346$var$DialogActionsRoot, {
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $67fe27d384958346$export$2e2bcd8739ae039 = $67fe27d384958346$var$DialogActions;


var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $3EMXY = parcelRequire("3EMXY");

var $31RRc = parcelRequire("31RRc");

var $5MTiZ = parcelRequire("5MTiZ");

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $27fc5b9c8a71453c$export$61b0ee1f05fb344e(slot) {
    return (0, $5KipK.default)('MuiDialogContent', slot);
}
const $27fc5b9c8a71453c$var$dialogContentClasses = (0, $1XfUG.default)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $27fc5b9c8a71453c$export$2e2bcd8739ae039 = $27fc5b9c8a71453c$var$dialogContentClasses;



var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $1c773e47d20aa4da$export$f5d2ec7e4c47e088(slot) {
    return (0, $5KipK.default)('MuiDialogTitle', slot);
}
const $1c773e47d20aa4da$var$dialogTitleClasses = (0, $1XfUG.default)('MuiDialogTitle', [
    'root'
]);
var $1c773e47d20aa4da$export$2e2bcd8739ae039 = $1c773e47d20aa4da$var$dialogTitleClasses;



var $7rM61 = parcelRequire("7rM61");
'use client';
const $4f9eb8a6b98ab127$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $27fc5b9c8a71453c$export$61b0ee1f05fb344e), classes);
};
const $4f9eb8a6b98ab127$var$DialogContentRoot = (0, $3EMXY.default)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $31RRc.default)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $1c773e47d20aa4da$export$2e2bcd8739ae039).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $4f9eb8a6b98ab127$var$DialogContent = /*#__PURE__*/ $jXEQt.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $4f9eb8a6b98ab127$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($4f9eb8a6b98ab127$var$DialogContentRoot, {
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $4f9eb8a6b98ab127$export$2e2bcd8739ae039 = $4f9eb8a6b98ab127$var$DialogContent;


var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $i29Fs = parcelRequire("i29Fs");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");

var $1MCB7 = parcelRequire("1MCB7");

var $1XfUG = parcelRequire("1XfUG");

var $5KipK = parcelRequire("5KipK");
function $80f46b56e83d8c4c$export$d9c6dc45f75b0e4f(slot) {
    return (0, $5KipK.default)('MuiDialogContentText', slot);
}
const $80f46b56e83d8c4c$var$dialogContentTextClasses = (0, $1XfUG.default)('MuiDialogContentText', [
    'root'
]);
var $80f46b56e83d8c4c$export$2e2bcd8739ae039 = $80f46b56e83d8c4c$var$dialogContentTextClasses;



var $7rM61 = parcelRequire("7rM61");
'use client';
const $8344f2ed89560e40$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $3ptEP.default)(slots, (0, $80f46b56e83d8c4c$export$d9c6dc45f75b0e4f), classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $8344f2ed89560e40$var$DialogContentTextRoot = (0, $3EMXY.default)((0, $1MCB7.default), {
    shouldForwardProp: (prop)=>(0, $i29Fs.default)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root'
})({});
const $8344f2ed89560e40$var$DialogContentText = /*#__PURE__*/ $jXEQt.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $8344f2ed89560e40$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7rM61.jsx)($8344f2ed89560e40$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $fQojQ.default)(classes.root, className),
        ...props,
        classes: classes
    });
});
var $8344f2ed89560e40$export$2e2bcd8739ae039 = $8344f2ed89560e40$var$DialogContentText;


var $jXEQt = parcelRequire("jXEQt");


var $fQojQ = parcelRequire("fQojQ");

var $3ptEP = parcelRequire("3ptEP");

var $1MCB7 = parcelRequire("1MCB7");

var $3EMXY = parcelRequire("3EMXY");

var $5MTiZ = parcelRequire("5MTiZ");



var $7rM61 = parcelRequire("7rM61");
'use client';
const $9603a419f7908c56$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $3ptEP.default)(slots, (0, $1c773e47d20aa4da$export$f5d2ec7e4c47e088), classes);
};
const $9603a419f7908c56$var$DialogTitleRoot = (0, $3EMXY.default)((0, $1MCB7.default), {
    name: 'MuiDialogTitle',
    slot: 'Root'
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $9603a419f7908c56$var$DialogTitle = /*#__PURE__*/ $jXEQt.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $9603a419f7908c56$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $jXEQt.useContext((0, $3024ab11506a3458$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $7rM61.jsx)($9603a419f7908c56$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $fQojQ.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $9603a419f7908c56$export$2e2bcd8739ae039 = $9603a419f7908c56$var$DialogTitle;


var $cSdwB = parcelRequire("cSdwB");
var $5IqKW = parcelRequire("5IqKW");
var $1MCB7 = parcelRequire("1MCB7");

var $jXEQt = parcelRequire("jXEQt");

var $1jMLP = parcelRequire("1jMLP");

var $4EGLj = parcelRequire("4EGLj");

var $gi5DA = parcelRequire("gi5DA");
function $95d7ebe72b751606$var$LogoutMenuItem(props) {
    const isGuest = (0, $4EGLj.useSelector)((0, $gi5DA.selectIsGuest));
    const [open, setOpen] = (0, $jXEQt.useState)(false);
    const user = (0, $4EGLj.useSelector)((state)=>state.user.value);
    const handle = (0, $1jMLP.default)(user);
    async function handleLogout() {
        // biome-ignore lint/suspicious/noDocumentCookie: Required for dual-cookie auth system
        document.cookie = 'sanremo-client='; // ugly-wipe client-side cookie
        await handle.destroy();
        window.location.reload();
    }
    function showConfirm() {
        props.onClick();
        setOpen(true);
    }
    function hideConfirm() {
        setOpen(false);
    }
    let menuTitle;
    let dialogTitle;
    let dialogSentence;
    if (isGuest) {
        menuTitle = 'Wipe Local';
        dialogTitle = 'Wipe local data?';
        dialogSentence = 'Your data is not stored elsewhere: this action will delete everything.';
    } else {
        menuTitle = 'Logout';
        dialogTitle = 'Are you sure?';
        // TODO: detect not synced changes, and show a different, angrier, warning
        dialogSentence = 'You will be logged out and all your local data will be deleted.';
    }
    return /*#__PURE__*/ (0, $7rM61.jsxs)((0, $jXEQt.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7rM61.jsxs)((0, $5IqKW.default), {
                onClick: showConfirm,
                children: [
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $cSdwB.default), {
                        children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $986f29f3bd8038c0$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                        children: menuTitle
                    })
                ]
            }, "logout"),
            /*#__PURE__*/ (0, $7rM61.jsxs)((0, $889790aee0bf1605$export$2e2bcd8739ae039), {
                open: open,
                onClose: hideConfirm,
                children: [
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $9603a419f7908c56$export$2e2bcd8739ae039), {
                        children: dialogTitle
                    }),
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $4f9eb8a6b98ab127$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $8344f2ed89560e40$export$2e2bcd8739ae039), {
                            children: dialogSentence
                        })
                    }),
                    /*#__PURE__*/ (0, $7rM61.jsxs)((0, $67fe27d384958346$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7rM61.jsx)((0, $jAvTI.default), {
                                onClick: handleLogout,
                                children: menuTitle
                            }),
                            /*#__PURE__*/ (0, $7rM61.jsx)((0, $jAvTI.default), {
                                onClick: hideConfirm,
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $95d7ebe72b751606$export$2e2bcd8739ae039 = $95d7ebe72b751606$var$LogoutMenuItem;



var $7rM61 = parcelRequire("7rM61");

var $a6yjU = parcelRequire("a6yjU");

var $7rM61 = parcelRequire("7rM61");
"use client";
var $456297168568b719$export$2e2bcd8739ae039 = (0, $a6yjU.default)(/*#__PURE__*/ (0, $7rM61.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 4c1.93 0 3.5 1.57 3.5 3.5S13.93 13 12 13s-3.5-1.57-3.5-3.5S10.07 6 12 6m0 14c-2.03 0-4.43-.82-6.14-2.88C7.55 15.8 9.68 15 12 15s4.45.8 6.14 2.12C16.43 19.18 14.03 20 12 20"
}), 'AccountCircle');




var $4EGLj = parcelRequire("4EGLj");
function $910479503193aa51$var$UserMenuBadge() {
    const updateNeeded = (0, $4EGLj.useSelector)((state)=>state.update.waitingToInstall);
    const requiresReauthentication = (0, $4EGLj.useSelector)((state)=>state.user.needsServerAuthentication);
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $2d332b327cd2e7ee$export$2e2bcd8739ae039), {
        color: "secondary",
        variant: "dot",
        invisible: !(updateNeeded || requiresReauthentication),
        children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $456297168568b719$export$2e2bcd8739ae039), {})
    });
}
var $910479503193aa51$export$2e2bcd8739ae039 = $910479503193aa51$var$UserMenuBadge;



var $7rM61 = parcelRequire("7rM61");


var $cSdwB = parcelRequire("cSdwB");
var $5IqKW = parcelRequire("5IqKW");
var $1MCB7 = parcelRequire("1MCB7");

var $jXEQt = parcelRequire("jXEQt");

var $4EGLj = parcelRequire("4EGLj");

var $7rM61 = parcelRequire("7rM61");

var $jAvTI = parcelRequire("jAvTI");
var $1eyRb = parcelRequire("1eyRb");
var $DjMuq = parcelRequire("DjMuq");

var $jXEQt = parcelRequire("jXEQt");

var $bw3ua = parcelRequire("bw3ua");

var $1jMLP = parcelRequire("1jMLP");

var $gi5DA = parcelRequire("gi5DA");
var $1224e4fcd191dcd8$export$e19cd5f9376f8cee = /*#__PURE__*/ function(Action) {
    Action[Action["Create"] = 0] = "Create";
    Action[Action["Authenticate"] = 1] = "Authenticate";
    return Action;
}({});
function $1224e4fcd191dcd8$var$UserAuthenticationWidget(props) {
    const dispatch = (0, $bw3ua.useDispatch)();
    const [username, setUsername] = (0, $jXEQt.useState)(props.username);
    const [password, setPassword] = (0, $jXEQt.useState)(undefined);
    const [error, setError] = (0, $jXEQt.useState)(undefined);
    async function submit(event) {
        event.preventDefault();
        if (!username) return setError('No username!');
        if (!password) return setError('No password!');
        try {
            const response = await fetch('/api/auth', {
                method: props.action === 0 ? 'PUT' : 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    username: username,
                    password: password
                })
            });
            if (!response.ok) {
                if ([
                    401,
                    403
                ].includes(response.status)) {
                    setError('Incorrect credentials');
                    return;
                }
                throw new Error(`HTTP ${response.status}`);
            }
            const user = await response.json();
            if (props.action === 0) await (0, $1jMLP.migrateFromGuest)(user);
            // TODO: consider what to do with guest data when logging in.
            // is it weird that if you've touched local data and then log in, the local data stays but hidden?
            dispatch((0, $gi5DA.setUserAsLoggedIn)({
                user: user
            }));
        } catch (error) {
            setError(error.message || 'Unknown Error');
        }
    }
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $8759857c9e39fe72$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7rM61.jsxs)("form", {
            onSubmit: submit,
            children: [
                /*#__PURE__*/ (0, $7rM61.jsx)((0, $DjMuq.default), {
                    variant: "filled",
                    fullWidth: true,
                    onChange: (e)=>setUsername(e.target.value),
                    label: "Username",
                    name: "username",
                    autoComplete: "username"
                }),
                /*#__PURE__*/ (0, $7rM61.jsx)((0, $DjMuq.default), {
                    variant: "filled",
                    fullWidth: true,
                    type: "password",
                    onChange: (e)=>setPassword(e.target.value),
                    label: "Password",
                    name: "password",
                    autoComplete: props.action === 1 ? 'current-password' : 'new-password'
                }),
                error && /*#__PURE__*/ (0, $7rM61.jsx)((0, $1eyRb.default), {
                    error: true,
                    children: error
                }),
                /*#__PURE__*/ (0, $7rM61.jsx)((0, $jAvTI.default), {
                    variant: "contained",
                    color: "primary",
                    type: "submit",
                    children: "Submit"
                })
            ]
        })
    });
}
var $1224e4fcd191dcd8$export$2e2bcd8739ae039 = $1224e4fcd191dcd8$var$UserAuthenticationWidget;



var $gi5DA = parcelRequire("gi5DA");
const $9239b6299fafdf53$export$d01dd4137cbca327 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).forwardRef(({ onClick: onClick }, ref)=>{
    const username = (0, $4EGLj.useSelector)((state)=>state.user.value?.name);
    const isGuest = (0, $4EGLj.useSelector)((0, $gi5DA.selectIsGuest));
    const requiresReauthentication = (0, $4EGLj.useSelector)((state)=>state.user.needsServerAuthentication);
    let title;
    if (isGuest) title = 'Create / Login';
    else if (requiresReauthentication) title = 'Login required';
    else title = username;
    return /*#__PURE__*/ (0, $7rM61.jsxs)((0, $5IqKW.default), {
        onClick: onClick,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $cSdwB.default), {
                children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $2d332b327cd2e7ee$export$2e2bcd8739ae039), {
                    color: "secondary",
                    variant: "dot",
                    invisible: !requiresReauthentication,
                    children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $456297168568b719$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                children: title
            })
        ]
    });
});
const $9239b6299fafdf53$export$d73070cc4280f036 = ({ open: open, onClose: onClose })=>{
    const username = (0, $4EGLj.useSelector)((state)=>state.user.value?.name);
    const isGuest = (0, $4EGLj.useSelector)((0, $gi5DA.selectIsGuest));
    const requiresReauthentication = (0, $4EGLj.useSelector)((state)=>state.user.needsServerAuthentication);
    let title;
    let content;
    if (isGuest) {
        title = 'Create / Login';
        content = /*#__PURE__*/ (0, $7rM61.jsxs)((0, $jXEQt.Fragment), {
            children: [
                /*#__PURE__*/ (0, $7rM61.jsx)("p", {
                    children: "Log into an existing account:"
                }),
                /*#__PURE__*/ (0, $7rM61.jsx)((0, $1224e4fcd191dcd8$export$2e2bcd8739ae039), {
                    action: (0, $1224e4fcd191dcd8$export$e19cd5f9376f8cee).Authenticate
                }),
                /*#__PURE__*/ (0, $7rM61.jsx)("p", {
                    children: "Or create a new one:"
                }),
                /*#__PURE__*/ (0, $7rM61.jsx)((0, $1224e4fcd191dcd8$export$2e2bcd8739ae039), {
                    action: (0, $1224e4fcd191dcd8$export$e19cd5f9376f8cee).Create
                })
            ]
        });
    } else if (requiresReauthentication) {
        title = 'Login required';
        content = /*#__PURE__*/ (0, $7rM61.jsx)((0, $1224e4fcd191dcd8$export$2e2bcd8739ae039), {
            action: (0, $1224e4fcd191dcd8$export$e19cd5f9376f8cee).Authenticate,
            username: username
        });
    } else title = username;
    return /*#__PURE__*/ (0, $7rM61.jsxs)((0, $889790aee0bf1605$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $9603a419f7908c56$export$2e2bcd8739ae039), {
                children: title
            }),
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $4f9eb8a6b98ab127$export$2e2bcd8739ae039), {
                children: content
            })
        ]
    });
};



var $gi5DA = parcelRequire("gi5DA");
/**
 * Wrapper for Pages. Manages headers, sidebar etc
 */ const $621415f2107ea2be$var$Page = ({ children: children })=>{
    const rrdNavigate = (0, $4Tpzr.useNavigate)();
    const context = (0, $4EGLj.useSelector)((state)=>state.page.value);
    const [anchorEl, setAnchorEl] = (0, $jXEQt.useState)(null);
    const isMenuOpen = !!anchorEl;
    // Due to a MUI bug, Page has to be aware of the user dialogue, as it cannot be contained
    // inside the UserMenuItem, as a Dialog cannot be inside a Menu
    // FIXME https://github.com/mui-org/material-ui/issues/20173
    // This means we've had to pull in a lot more stuff into Page than we wanted
    const [userDialogOpen, setUserDialogOpen] = (0, $jXEQt.useState)(false);
    const isGuest = (0, $4EGLj.useSelector)((0, $gi5DA.selectIsGuest));
    const requiresReauthentication = (0, $4EGLj.useSelector)((state)=>state.user.needsServerAuthentication);
    const canSeeUserDialog = userDialogOpen && (isGuest || requiresReauthentication);
    function handleMenuOpen(event) {
        setAnchorEl(event.currentTarget);
    }
    function handleMenuClose() {
        setAnchorEl(null);
    }
    function navigate(to) {
        handleMenuClose();
        /*
    export declare type To = string | PartialPath;
    export interface NavigateFunction {
      (to: To, options?: NavigateOptions): void;
      (delta: number): void;
    }
    */ // @ts-expect-error this should work??? See above. Guessing it's because it crosses two definitions
        rrdNavigate(to);
    }
    function showUserDialog() {
        handleMenuClose();
        setUserDialogOpen(true);
    }
    document.title = context.title ? `${context.title} | Sanremo` : 'Sanremo';
    let title;
    if ((0, $7b995d39a8ab379a$export$5c7cf5df8b66b0f5).relevant((0, $4EGLj.default).getState())) title = /*#__PURE__*/ (0, $7rM61.jsxs)("div", {
        children: [
            context.title,
            " ",
            /*#__PURE__*/ (0, $7rM61.jsx)("i", {
                children: "for"
            }),
            " ",
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $7b995d39a8ab379a$export$5c7cf5df8b66b0f5), {})
        ]
    });
    else title = context.title;
    return /*#__PURE__*/ (0, $7rM61.jsxs)((0, $8759857c9e39fe72$export$2e2bcd8739ae039), {
        disableGutters: true,
        maxWidth: "xl",
        children: [
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $1dd73e25187d7e5a$export$2e2bcd8739ae039), {
                position: "sticky",
                children: /*#__PURE__*/ (0, $7rM61.jsxs)((0, $cce24f072f43f2cc$export$2e2bcd8739ae039), {
                    children: [
                        context.back && // TODO: we should probably rethink this back button logic
                        // If we know our own URL we can work this one out? Anything but '/' should mean going back?
                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $f614096fb9c79cdb$export$2e2bcd8739ae039), {
                            edge: "start",
                            color: "inherit",
                            onClick: ()=>navigate(-1),
                            children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $efad375d2b35b2de$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                            variant: "h6",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $a3bb9d4cbb88f3af$export$2e2bcd8739ae039), {
                            sx: {
                                flexGrow: 1
                            }
                        }),
                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $122bb16f4b5f75a7$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $f614096fb9c79cdb$export$2e2bcd8739ae039), {
                            edge: "end",
                            color: "inherit",
                            onClick: handleMenuOpen,
                            children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $910479503193aa51$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7rM61.jsxs)((0, $gS6ai.default), {
                anchorEl: anchorEl,
                anchorOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right'
                },
                keepMounted: true,
                open: isMenuOpen,
                onClose: handleMenuClose,
                children: [
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $9239b6299fafdf53$export$d01dd4137cbca327), {
                        onClick: showUserDialog
                    }),
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $1AHpK.default), {}),
                    /*#__PURE__*/ (0, $7rM61.jsxs)((0, $5IqKW.default), {
                        selected: context.under === 'home',
                        onClick: ()=>navigate('/'),
                        children: [
                            /*#__PURE__*/ (0, $7rM61.jsx)((0, $cSdwB.default), {
                                children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $a196c28bed0b6c84$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                                children: "Active"
                            })
                        ]
                    }, "home"),
                    /*#__PURE__*/ (0, $7rM61.jsxs)((0, $5IqKW.default), {
                        selected: context.under === 'history',
                        onClick: ()=>navigate('/history'),
                        children: [
                            /*#__PURE__*/ (0, $7rM61.jsx)((0, $cSdwB.default), {
                                children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $302181e27fe30bdb$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                                children: "History"
                            })
                        ]
                    }, "history"),
                    /*#__PURE__*/ (0, $7rM61.jsxs)((0, $5IqKW.default), {
                        selected: context.under === 'about',
                        onClick: ()=>navigate('/about'),
                        children: [
                            /*#__PURE__*/ (0, $7rM61.jsx)((0, $cSdwB.default), {
                                children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $ebde45f929f80ed4$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                                children: "About"
                            })
                        ]
                    }, "about"),
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $49bd2d7a93ad06c6$export$2e2bcd8739ae039), {
                        onClick: handleMenuClose
                    }),
                    /*#__PURE__*/ (0, $7rM61.jsx)((0, $95d7ebe72b751606$export$2e2bcd8739ae039), {
                        onClick: handleMenuClose
                    })
                ]
            }),
            canSeeUserDialog && /*#__PURE__*/ (0, $7rM61.jsx)((0, $9239b6299fafdf53$export$d73070cc4280f036), {
                open: true,
                onClose: ()=>setUserDialogOpen(false)
            }),
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $a3bb9d4cbb88f3af$export$2e2bcd8739ae039), {
                sx: {
                    margin: 1
                },
                component: "main",
                children: children
            })
        ]
    });
};
var $621415f2107ea2be$export$2e2bcd8739ae039 = $621415f2107ea2be$var$Page;



var $jXEQt = parcelRequire("jXEQt");
const $13c844c378cde70c$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$13c844c378cde70c$export$c169aefb7330cccb["open"] = "0";
$13c844c378cde70c$export$c169aefb7330cccb["close"] = "1";
$13c844c378cde70c$export$c169aefb7330cccb["ping"] = "2";
$13c844c378cde70c$export$c169aefb7330cccb["pong"] = "3";
$13c844c378cde70c$export$c169aefb7330cccb["message"] = "4";
$13c844c378cde70c$export$c169aefb7330cccb["upgrade"] = "5";
$13c844c378cde70c$export$c169aefb7330cccb["noop"] = "6";
const $13c844c378cde70c$export$47791e8004edd485 = Object.create(null);
Object.keys($13c844c378cde70c$export$c169aefb7330cccb).forEach((key)=>{
    $13c844c378cde70c$export$47791e8004edd485[$13c844c378cde70c$export$c169aefb7330cccb[key]] = key;
});
const $13c844c378cde70c$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $8bfaab9a6e95b441$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8bfaab9a6e95b441$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8bfaab9a6e95b441$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8bfaab9a6e95b441$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8bfaab9a6e95b441$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8bfaab9a6e95b441$var$encodeBlobAsBase64(data, callback);
    } else if ($8bfaab9a6e95b441$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8bfaab9a6e95b441$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8bfaab9a6e95b441$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $13c844c378cde70c$export$c169aefb7330cccb)[type] + (data || ""));
};
const $8bfaab9a6e95b441$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $8bfaab9a6e95b441$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $8bfaab9a6e95b441$var$TEXT_ENCODER;
function $8bfaab9a6e95b441$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($8bfaab9a6e95b441$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($8bfaab9a6e95b441$var$toArray).then(callback);
    else if ($8bfaab9a6e95b441$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $8bfaab9a6e95b441$var$isView(packet.data))) return callback($8bfaab9a6e95b441$var$toArray(packet.data));
    $8bfaab9a6e95b441$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$8bfaab9a6e95b441$var$TEXT_ENCODER) $8bfaab9a6e95b441$var$TEXT_ENCODER = new TextEncoder();
        callback($8bfaab9a6e95b441$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $33ef33a314477a59$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $33ef33a314477a59$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $33ef33a314477a59$var$chars.length; i++)$33ef33a314477a59$var$lookup[$33ef33a314477a59$var$chars.charCodeAt(i)] = i;
const $33ef33a314477a59$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $33ef33a314477a59$var$chars[bytes[i] >> 2];
        base64 += $33ef33a314477a59$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $33ef33a314477a59$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $33ef33a314477a59$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $33ef33a314477a59$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $33ef33a314477a59$var$lookup[base64.charCodeAt(i)];
        encoded2 = $33ef33a314477a59$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $33ef33a314477a59$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $33ef33a314477a59$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $13c8571930c28862$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $13c8571930c28862$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $13c8571930c28862$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $13c8571930c28862$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $13c844c378cde70c$export$47791e8004edd485)[type];
    if (!packetType) return 0, $13c844c378cde70c$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $13c844c378cde70c$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $13c844c378cde70c$export$47791e8004edd485)[type]
    };
};
const $13c8571930c28862$var$decodeBase64Packet = (data, binaryType)=>{
    if ($13c8571930c28862$var$withNativeArrayBuffer) {
        const decoded = (0, $33ef33a314477a59$export$2f872c0f2117be69)(data);
        return $13c8571930c28862$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $13c8571930c28862$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $b8dc189c2869ee5c$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $b8dc189c2869ee5c$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $8bfaab9a6e95b441$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($b8dc189c2869ee5c$var$SEPARATOR));
        });
    });
};
const $b8dc189c2869ee5c$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($b8dc189c2869ee5c$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $13c8571930c28862$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $b8dc189c2869ee5c$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $8bfaab9a6e95b441$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $b8dc189c2869ee5c$var$TEXT_DECODER;
function $b8dc189c2869ee5c$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $b8dc189c2869ee5c$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $b8dc189c2869ee5c$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$b8dc189c2869ee5c$var$TEXT_DECODER) $b8dc189c2869ee5c$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($b8dc189c2869ee5c$var$totalLength(chunks) < 1) break;
                    const header = $b8dc189c2869ee5c$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($b8dc189c2869ee5c$var$totalLength(chunks) < 2) break;
                    const headerArray = $b8dc189c2869ee5c$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($b8dc189c2869ee5c$var$totalLength(chunks) < 8) break;
                    const headerArray = $b8dc189c2869ee5c$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $13c844c378cde70c$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($b8dc189c2869ee5c$var$totalLength(chunks) < expectedLength) break;
                    const data = $b8dc189c2869ee5c$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $13c8571930c28862$export$4647901878f33f31)(isBinary ? data : $b8dc189c2869ee5c$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $13c844c378cde70c$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $b8dc189c2869ee5c$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $0f2fae2c15407398$export$4293555f241ae35a(obj) {
    if (obj) return $0f2fae2c15407398$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $0f2fae2c15407398$var$mixin(obj) {
    for(var key in $0f2fae2c15407398$export$4293555f241ae35a.prototype)obj[key] = $0f2fae2c15407398$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $0f2fae2c15407398$export$4293555f241ae35a.prototype.on = $0f2fae2c15407398$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $0f2fae2c15407398$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $0f2fae2c15407398$export$4293555f241ae35a.prototype.off = $0f2fae2c15407398$export$4293555f241ae35a.prototype.removeListener = $0f2fae2c15407398$export$4293555f241ae35a.prototype.removeAllListeners = $0f2fae2c15407398$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $0f2fae2c15407398$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$0f2fae2c15407398$export$4293555f241ae35a.prototype.emitReserved = $0f2fae2c15407398$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $0f2fae2c15407398$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $0f2fae2c15407398$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $f896d27326634814$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $f896d27326634814$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $f896d27326634814$export$790dcbc41e2d75d5 = "arraybuffer";
function $f896d27326634814$export$19413efcf2fac759() {}


function $24bf110c8c2ad1af$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $24bf110c8c2ad1af$var$NATIVE_SET_TIMEOUT = (0, $f896d27326634814$export$394f9358f6231289).setTimeout;
const $24bf110c8c2ad1af$var$NATIVE_CLEAR_TIMEOUT = (0, $f896d27326634814$export$394f9358f6231289).clearTimeout;
function $24bf110c8c2ad1af$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $24bf110c8c2ad1af$var$NATIVE_SET_TIMEOUT.bind((0, $f896d27326634814$export$394f9358f6231289));
        obj.clearTimeoutFn = $24bf110c8c2ad1af$var$NATIVE_CLEAR_TIMEOUT.bind((0, $f896d27326634814$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $f896d27326634814$export$394f9358f6231289).setTimeout.bind((0, $f896d27326634814$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $f896d27326634814$export$394f9358f6231289).clearTimeout.bind((0, $f896d27326634814$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $24bf110c8c2ad1af$var$BASE64_OVERHEAD = 1.33;
function $24bf110c8c2ad1af$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $24bf110c8c2ad1af$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $24bf110c8c2ad1af$var$BASE64_OVERHEAD);
}
function $24bf110c8c2ad1af$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $24bf110c8c2ad1af$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $d69e60c89b8cb98b$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $d69e60c89b8cb98b$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $eb4f87e71ec0eb8d$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $eb4f87e71ec0eb8d$export$86495b081fef8e52 extends (0, $0f2fae2c15407398$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $24bf110c8c2ad1af$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $eb4f87e71ec0eb8d$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $13c8571930c28862$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $d69e60c89b8cb98b$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}




class $ec2610b8a494193f$export$265ee5eefd4c309b extends (0, $eb4f87e71ec0eb8d$export$86495b081fef8e52) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $b8dc189c2869ee5c$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $b8dc189c2869ee5c$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $24bf110c8c2ad1af$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}





// imported from https://github.com/component/has-cors
let $a95449187af90a15$var$value = false;
try {
    $a95449187af90a15$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $a95449187af90a15$export$5235bbd4a1ef06e = $a95449187af90a15$var$value;


function $43d812741c532626$var$empty() {}
class $43d812741c532626$export$c959f2344155d309 extends (0, $ec2610b8a494193f$export$265ee5eefd4c309b) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $43d812741c532626$export$7fa6c5b6f8193917 extends (0, $0f2fae2c15407398$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $24bf110c8c2ad1af$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $24bf110c8c2ad1af$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $43d812741c532626$export$7fa6c5b6f8193917.requestsCount++;
            $43d812741c532626$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $43d812741c532626$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $43d812741c532626$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$43d812741c532626$export$7fa6c5b6f8193917.requestsCount = 0;
$43d812741c532626$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $43d812741c532626$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $f896d27326634814$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $43d812741c532626$var$unloadHandler, false);
    }
}
function $43d812741c532626$var$unloadHandler() {
    for(let i in $43d812741c532626$export$7fa6c5b6f8193917.requests)if ($43d812741c532626$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $43d812741c532626$export$7fa6c5b6f8193917.requests[i].abort();
}
const $43d812741c532626$var$hasXHR2 = function() {
    const xhr = $43d812741c532626$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $43d812741c532626$export$a2d42eb087c10497 extends $43d812741c532626$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $43d812741c532626$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $43d812741c532626$export$7fa6c5b6f8193917($43d812741c532626$var$newRequest, this.uri(), opts);
    }
}
function $43d812741c532626$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $a95449187af90a15$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $f896d27326634814$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $2a0def5414880d2d$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $2a0def5414880d2d$export$570bf71d2367e261 extends (0, $eb4f87e71ec0eb8d$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $2a0def5414880d2d$var$isReactNative ? {} : (0, $24bf110c8c2ad1af$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $8bfaab9a6e95b441$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $f896d27326634814$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $24bf110c8c2ad1af$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $2a0def5414880d2d$var$WebSocketCtor = (0, $f896d27326634814$export$394f9358f6231289).WebSocket || (0, $f896d27326634814$export$394f9358f6231289).MozWebSocket;
class $2a0def5414880d2d$export$911baa0677ac404c extends $2a0def5414880d2d$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$2a0def5414880d2d$var$isReactNative ? protocols ? new $2a0def5414880d2d$var$WebSocketCtor(uri, protocols) : new $2a0def5414880d2d$var$WebSocketCtor(uri) : new $2a0def5414880d2d$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $705261a6bef0dd51$export$961c930859384407 extends (0, $eb4f87e71ec0eb8d$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $b8dc189c2869ee5c$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $b8dc189c2869ee5c$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $f896d27326634814$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $6527ad0be3794756$export$46dec00755c1153b = {
    websocket: (0, $2a0def5414880d2d$export$911baa0677ac404c),
    webtransport: (0, $705261a6bef0dd51$export$961c930859384407),
    polling: (0, $43d812741c532626$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $13aafce5393d34ad$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $13aafce5393d34ad$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $13aafce5393d34ad$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $13aafce5393d34ad$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$13aafce5393d34ad$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $13aafce5393d34ad$var$pathNames(uri, uri['path']);
    uri.queryKey = $13aafce5393d34ad$var$queryKey(uri, uri['query']);
    return uri;
}
function $13aafce5393d34ad$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $13aafce5393d34ad$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $630cf7e9920bd242$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $630cf7e9920bd242$var$OFFLINE_EVENT_LISTENERS = [];
if ($630cf7e9920bd242$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $630cf7e9920bd242$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $630cf7e9920bd242$export$3874118029a0ee0d extends (0, $0f2fae2c15407398$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $f896d27326634814$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $13aafce5393d34ad$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $13aafce5393d34ad$export$98e6a39c04603d36)(opts.host).host;
        (0, $24bf110c8c2ad1af$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $d69e60c89b8cb98b$export$2f872c0f2117be69)(this.opts.query);
        if ($630cf7e9920bd242$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $630cf7e9920bd242$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $f896d27326634814$export$19413efcf2fac759)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $b8dc189c2869ee5c$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $630cf7e9920bd242$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $630cf7e9920bd242$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $24bf110c8c2ad1af$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $f896d27326634814$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $630cf7e9920bd242$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($630cf7e9920bd242$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $630cf7e9920bd242$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $630cf7e9920bd242$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$630cf7e9920bd242$export$3874118029a0ee0d.protocol = (0, $b8dc189c2869ee5c$export$a51d6b395ff4c65a);
class $630cf7e9920bd242$export$cc521fcb1004e85c extends $630cf7e9920bd242$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $630cf7e9920bd242$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $630cf7e9920bd242$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $630cf7e9920bd242$export$4798917dbf149b79 extends $630cf7e9920bd242$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $6527ad0be3794756$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}








class $d0f4eeabeddafaa4$export$1e7deca84b429035 extends (0, $ec2610b8a494193f$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $6181d13c2f1e0719$export$a51d6b395ff4c65a = (0, $630cf7e9920bd242$export$4798917dbf149b79).protocol;


function $c9aaaabc780f5906$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $13aafce5393d34ad$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $c56fa7a59da08d62$exports = {};

$parcel$export($c56fa7a59da08d62$exports, "protocol", () => $c56fa7a59da08d62$export$a51d6b395ff4c65a);
$parcel$export($c56fa7a59da08d62$exports, "PacketType", () => $c56fa7a59da08d62$export$84d4095e16c6fc19);
$parcel$export($c56fa7a59da08d62$exports, "Encoder", () => $c56fa7a59da08d62$export$a50aceb0e02a00aa);
$parcel$export($c56fa7a59da08d62$exports, "Decoder", () => $c56fa7a59da08d62$export$f9de6ca0bc043724);
$parcel$export($c56fa7a59da08d62$exports, "isPacketValid", () => $c56fa7a59da08d62$export$1a38ed17dcb5458e);

const $603e266d466a2d1a$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $603e266d466a2d1a$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $603e266d466a2d1a$var$toString = Object.prototype.toString;
const $603e266d466a2d1a$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $603e266d466a2d1a$var$toString.call(Blob) === "[object BlobConstructor]";
const $603e266d466a2d1a$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $603e266d466a2d1a$var$toString.call(File) === "[object FileConstructor]";
function $603e266d466a2d1a$export$37488ff1135b1696(obj) {
    return $603e266d466a2d1a$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $603e266d466a2d1a$var$isView(obj)) || $603e266d466a2d1a$var$withNativeBlob && obj instanceof Blob || $603e266d466a2d1a$var$withNativeFile && obj instanceof File;
}
function $603e266d466a2d1a$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($603e266d466a2d1a$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($603e266d466a2d1a$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $603e266d466a2d1a$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $603e266d466a2d1a$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $68a8a2cbb71ee659$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $68a8a2cbb71ee659$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $68a8a2cbb71ee659$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $603e266d466a2d1a$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $68a8a2cbb71ee659$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $68a8a2cbb71ee659$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $68a8a2cbb71ee659$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $68a8a2cbb71ee659$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $68a8a2cbb71ee659$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $68a8a2cbb71ee659$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $68a8a2cbb71ee659$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $c56fa7a59da08d62$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $c56fa7a59da08d62$export$a51d6b395ff4c65a = 5;
var $c56fa7a59da08d62$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($c56fa7a59da08d62$export$84d4095e16c6fc19 || ($c56fa7a59da08d62$export$84d4095e16c6fc19 = {}));
class $c56fa7a59da08d62$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $c56fa7a59da08d62$export$84d4095e16c6fc19.EVENT || obj.type === $c56fa7a59da08d62$export$84d4095e16c6fc19.ACK) {
            if ((0, $603e266d466a2d1a$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $c56fa7a59da08d62$export$84d4095e16c6fc19.EVENT ? $c56fa7a59da08d62$export$84d4095e16c6fc19.BINARY_EVENT : $c56fa7a59da08d62$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $c56fa7a59da08d62$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $c56fa7a59da08d62$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $68a8a2cbb71ee659$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
class $c56fa7a59da08d62$export$f9de6ca0bc043724 extends (0, $0f2fae2c15407398$export$4293555f241ae35a) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $c56fa7a59da08d62$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $c56fa7a59da08d62$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $c56fa7a59da08d62$export$84d4095e16c6fc19.EVENT : $c56fa7a59da08d62$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $c56fa7a59da08d62$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $603e266d466a2d1a$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($c56fa7a59da08d62$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $c56fa7a59da08d62$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $c56fa7a59da08d62$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($c56fa7a59da08d62$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $c56fa7a59da08d62$export$84d4095e16c6fc19.CONNECT:
                return $c56fa7a59da08d62$var$isObject(payload);
            case $c56fa7a59da08d62$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $c56fa7a59da08d62$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $c56fa7a59da08d62$var$isObject(payload);
            case $c56fa7a59da08d62$export$84d4095e16c6fc19.EVENT:
            case $c56fa7a59da08d62$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $c56fa7a59da08d62$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $c56fa7a59da08d62$export$84d4095e16c6fc19.ACK:
            case $c56fa7a59da08d62$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $c56fa7a59da08d62$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $68a8a2cbb71ee659$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}
function $c56fa7a59da08d62$var$isNamespaceValid(nsp) {
    return typeof nsp === "string";
}
// see https://caniuse.com/mdn-javascript_builtins_number_isinteger
const $c56fa7a59da08d62$var$isInteger = Number.isInteger || function(value) {
    return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
};
function $c56fa7a59da08d62$var$isAckIdValid(id) {
    return id === undefined || $c56fa7a59da08d62$var$isInteger(id);
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $c56fa7a59da08d62$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
function $c56fa7a59da08d62$var$isDataValid(type, payload) {
    switch(type){
        case $c56fa7a59da08d62$export$84d4095e16c6fc19.CONNECT:
            return payload === undefined || $c56fa7a59da08d62$var$isObject(payload);
        case $c56fa7a59da08d62$export$84d4095e16c6fc19.DISCONNECT:
            return payload === undefined;
        case $c56fa7a59da08d62$export$84d4095e16c6fc19.EVENT:
            return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $c56fa7a59da08d62$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
        case $c56fa7a59da08d62$export$84d4095e16c6fc19.ACK:
            return Array.isArray(payload);
        case $c56fa7a59da08d62$export$84d4095e16c6fc19.CONNECT_ERROR:
            return typeof payload === "string" || $c56fa7a59da08d62$var$isObject(payload);
        default:
            return false;
    }
}
function $c56fa7a59da08d62$export$1a38ed17dcb5458e(packet) {
    return $c56fa7a59da08d62$var$isNamespaceValid(packet.nsp) && $c56fa7a59da08d62$var$isAckIdValid(packet.id) && $c56fa7a59da08d62$var$isDataValid(packet.type, packet.data);
}


function $343c2ace89930ae9$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $4475b0aaf3efa0ec$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $4475b0aaf3efa0ec$export$4798917dbf149b79 extends (0, $0f2fae2c15407398$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $343c2ace89930ae9$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $343c2ace89930ae9$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $343c2ace89930ae9$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $343c2ace89930ae9$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($4475b0aaf3efa0ec$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            this._queue[0];
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).EVENT:
            case (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).ACK:
            case (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this._drainQueue(true);
        this.emitReserved("connect");
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $c56fa7a59da08d62$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $55647dc8f552dfe5$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $55647dc8f552dfe5$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $55647dc8f552dfe5$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $55647dc8f552dfe5$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $55647dc8f552dfe5$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $55647dc8f552dfe5$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $c0726b871cf6ee9b$export$d0d38e7dec7a1a61 extends (0, $0f2fae2c15407398$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $24bf110c8c2ad1af$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $55647dc8f552dfe5$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $c56fa7a59da08d62$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $630cf7e9920bd242$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $343c2ace89930ae9$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $343c2ace89930ae9$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $343c2ace89930ae9$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $343c2ace89930ae9$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $343c2ace89930ae9$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $343c2ace89930ae9$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $343c2ace89930ae9$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $f896d27326634814$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $4475b0aaf3efa0ec$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}





/**
 * Managers cache.
 */ const $514315a5d1ff7864$var$cache = {};
function $514315a5d1ff7864$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $c9aaaabc780f5906$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $514315a5d1ff7864$var$cache[id] && path in $514315a5d1ff7864$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $c0726b871cf6ee9b$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$514315a5d1ff7864$var$cache[id]) $514315a5d1ff7864$var$cache[id] = new (0, $c0726b871cf6ee9b$export$d0d38e7dec7a1a61)(source, opts);
        io = $514315a5d1ff7864$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($514315a5d1ff7864$export$841407ceb083bd74, {
    Manager: $c0726b871cf6ee9b$export$d0d38e7dec7a1a61,
    Socket: $4475b0aaf3efa0ec$export$4798917dbf149b79,
    io: $514315a5d1ff7864$export$841407ceb083bd74,
    connect: $514315a5d1ff7864$export$841407ceb083bd74
});



var $1jMLP = parcelRequire("1jMLP");

var $ioiHS = parcelRequire("ioiHS");

var $4zIwb = parcelRequire("4zIwb");

var $4EGLj = parcelRequire("4EGLj");

var $GLFsL = parcelRequire("GLFsL");

var $gi5DA = parcelRequire("gi5DA");

var $rbG4f = parcelRequire("rbG4f");

var $5xV4Q = parcelRequire("5xV4Q");
const $a530c20420a15eba$var$debug = (0, $ioiHS.debugClient)('sync');
const $a530c20420a15eba$var$BATCH_SIZE = 20;
// FIXME: https://github.com/pouchdb/pouchdb/issues/7841 means we have to performed deletes
// specifically, instead of generically alongside other writes
// This also means that the server has to treat deletes specifically, otherwise the
// revs that increments here will cause an infinite loop with other clients. On the server
// revs on deleted documents are ignored and they are all considered the same
function $a530c20420a15eba$var$splitDeletes(batch) {
    return batch.reduce((acc, doc)=>{
        if (doc._deleted) acc.deletes.push(doc);
        else acc.writes.push(doc);
        return acc;
    }, {
        deletes: [],
        writes: []
    });
}
async function $a530c20420a15eba$var$writesFromRemote(handle, writes) {
    // To avoid conflicts, AND to write the exact rev we're given, we need both write with
    // `new_edits: false` so we get to specify any _rev we want, AND delete any "conflicts".
    // Unfortunately, `new_edits: false` always creates conflicts, so we preemptively delete
    // the docs and then re-write them with their correct data and remote _rev
    await $a530c20420a15eba$var$deletesFromRemote(handle, writes);
    await handle.bulkDocs(writes, {
        new_edits: false
    });
}
async function $a530c20420a15eba$var$deletesFromRemote(handle, deletes) {
    const deleteResults = await handle.allDocs({
        keys: deletes.map((d)=>d._id)
    });
    const deletedDocs = deleteResults.rows.map((row)=>({
            _id: row.key,
            // If the client doesn't have this document, the row will have
            //error: "not_found"
            // and no _rev. No _rev is okay, pouch will create one
            // @ts-expect-error FIXME the types changed, work out what to do with erroring rows
            _rev: row?.value?.rev,
            _deleted: true
        }));
    await handle.bulkDocs(deletedDocs);
}
function $a530c20420a15eba$var$SyncManager() {
    const dispatch = (0, $4EGLj.useDispatch)();
    const user = (0, $4EGLj.useSelector)((state)=>state.user.value);
    const isGuest = (0, $4EGLj.useSelector)((0, $gi5DA.selectIsGuest));
    const handle = (0, $1jMLP.default)(user);
    const state = (0, $4EGLj.useSelector)((state)=>state.sync.state);
    const [socket, setSocket] = (0, $jXEQt.useState)(undefined);
    // Ref to access current socket from sync handlers without adding socket to dependencies
    const socketRef = (0, $jXEQt.useRef)(socket);
    socketRef.current = socket;
    (0, $jXEQt.useEffect)(()=>{
        // PERF: make this work more in parallel, benchmark it to see if it makes a difference etc
        const handleFullSync = async ()=>{
            try {
                // Get the docs we have locally. The only way to see deleted documents with PouchDB
                // is with the changes feed to get all ids
                const changes = await handle.changes({
                    filter: (d)=>!d._id.startsWith('_design/')
                });
                const stubs = changes.results.map((row)=>{
                    return {
                        _id: row.id,
                        // FIXME: work out if I ever need to care about more than one change
                        _rev: row.changes[0].rev,
                        _deleted: row.deleted
                    };
                });
                $a530c20420a15eba$var$debug(`locally we have ${stubs.length} docs`);
                // Work out the difference between us and the server
                $a530c20420a15eba$var$debug('checking with the server');
                const beginResponse = await fetch('/api/sync/begin', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        docs: stubs
                    })
                });
                if (!beginResponse.ok) {
                    if (beginResponse.status === 401) {
                        $a530c20420a15eba$var$debug('sync failed as user is no longer authenticated');
                        dispatch((0, $gi5DA.setUserAsUnauthenticated)());
                        dispatch((0, $5xV4Q.socketDisconnected)());
                        return;
                    }
                    throw new Error(`Sync begin failed: HTTP ${beginResponse.status}`);
                }
                const serverState = await beginResponse.json();
                $a530c20420a15eba$var$debug(`the server needs ${serverState.server.length}, we need ${serverState.client.length}`);
                const docTotal = serverState.client.length + serverState.server.length;
                if (docTotal > 0) {
                    let docCount = 0;
                    $a530c20420a15eba$var$debug('starting transfers');
                    dispatch((0, $5xV4Q.updateProgress)({
                        count: docCount,
                        total: docTotal
                    }));
                    // Give the server what they need
                    while(serverState.server.length > 0){
                        const batch = serverState.server.splice(0, $a530c20420a15eba$var$BATCH_SIZE);
                        $a530c20420a15eba$var$debug(`-> preparing ${batch.length}`);
                        const result = await handle.allDocs({
                            include_docs: true,
                            keys: batch.map((d)=>d._id)
                        });
                        $a530c20420a15eba$var$debug('-> got local');
                        const updateResponse = await fetch('/api/sync/update', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({
                                docs: result.rows.map(// @ts-expect-error FIXME the types changed, work out what to do with erroring rows
                                (r)=>r.doc || {
                                        _id: r.id,
                                        _rev: r.value.rev,
                                        _deleted: r.value.deleted
                                    })
                            })
                        });
                        if (!updateResponse.ok) {
                            if (updateResponse.status === 401) {
                                $a530c20420a15eba$var$debug('sync failed as user is no longer authenticated');
                                dispatch((0, $gi5DA.setUserAsUnauthenticated)());
                                dispatch((0, $5xV4Q.socketDisconnected)());
                                return;
                            }
                            throw new Error(`Sync update failed: HTTP ${updateResponse.status}`);
                        }
                        $a530c20420a15eba$var$debug('-> sent');
                        docCount += batch.length;
                        dispatch((0, $5xV4Q.updateProgress)({
                            count: docCount,
                            total: docTotal
                        }));
                    }
                    // Get what we need from the server
                    while(serverState.client.length > 0){
                        const batch = serverState.client.splice(0, $a530c20420a15eba$var$BATCH_SIZE);
                        $a530c20420a15eba$var$debug(`<- preparing ${batch.length}`);
                        const { deletes: deletes, writes: writes } = $a530c20420a15eba$var$splitDeletes(batch);
                        let changes = [];
                        if (deletes.length) {
                            await $a530c20420a15eba$var$deletesFromRemote(handle, deletes);
                            changes = changes.concat(deletes);
                            $a530c20420a15eba$var$debug('<- deleted deletes');
                        }
                        if (writes.length) {
                            const requestResponse = await fetch('/api/sync/request', {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({
                                    docs: writes
                                })
                            });
                            if (!requestResponse.ok) {
                                if (requestResponse.status === 401) {
                                    $a530c20420a15eba$var$debug('sync failed as user is no longer authenticated');
                                    dispatch((0, $gi5DA.setUserAsUnauthenticated)());
                                    dispatch((0, $5xV4Q.socketDisconnected)());
                                    return;
                                }
                                throw new Error(`Sync request failed: HTTP ${requestResponse.status}`);
                            }
                            const result = await requestResponse.json();
                            $a530c20420a15eba$var$debug('<- got server');
                            await $a530c20420a15eba$var$writesFromRemote(handle, result);
                            $a530c20420a15eba$var$debug('<- stored');
                            changes = changes.concat(result);
                        }
                        dispatch((0, $4zIwb.update)(changes));
                        $a530c20420a15eba$var$debug('<- state updated');
                        docCount += batch.length;
                        dispatch((0, $5xV4Q.updateProgress)({
                            count: docCount,
                            total: docTotal
                        }));
                    }
                }
                dispatch((0, $5xV4Q.completeSync)());
                // Signal ready and transition to connected state directly after sync completes
                // Using socketRef to access current socket without adding it to useEffect dependencies
                const currentSocket = socketRef.current;
                if (currentSocket?.connected) {
                    $a530c20420a15eba$var$debug('sync complete, emitting ready signal');
                    currentSocket.emit('ready');
                    dispatch((0, $5xV4Q.socketConnected)());
                }
            } catch (e) {
                console.error('Failed to sync', e);
                dispatch((0, $5xV4Q.syncError)(e));
            } finally{
                $a530c20420a15eba$var$debug('finished');
            }
        };
        if (state === (0, $5xV4Q.State).requested) {
            $a530c20420a15eba$var$debug('starting full sync');
            dispatch((0, $5xV4Q.startSync)());
            handleFullSync();
        }
    }, [
        handle,
        dispatch,
        state
    ]);
    // we are using the trigger of this to
    // close the socket, so we can't also pass in the socket because when it's created it would be
    // deleted again straight away
    // biome-ignore lint/correctness/useExhaustiveDependencies: see above
    (0, $jXEQt.useEffect)(()=>{
        const initSocket = ()=>{
            if (socket) {
                socket.close();
                (0, $rbG4f.registerSocket)(null);
            }
            if (isGuest) return;
            $a530c20420a15eba$var$debug('initializing server socket');
            const localSocket = (0, $514315a5d1ff7864$export$841407ceb083bd74)();
            localSocket.on('connect', async ()=>{
                $a530c20420a15eba$var$debug('socket connected');
                dispatch((0, $5xV4Q.requestSync)());
                dispatch((0, $GLFsL.checkForUpdate)());
            });
            localSocket.on('docUpdate', async (docs)=>{
                $a530c20420a15eba$var$debug('got update from socket');
                const { writes: writes, deletes: deletes } = $a530c20420a15eba$var$splitDeletes(docs);
                // PERF: do these in parallel, see if it's faster
                if (deletes.length) await $a530c20420a15eba$var$deletesFromRemote(handle, deletes);
                if (writes.length) await $a530c20420a15eba$var$writesFromRemote(handle, writes);
                dispatch((0, $4zIwb.update)(docs));
            });
            localSocket.on('disconnect', ()=>{
                $a530c20420a15eba$var$debug('socket disconnected');
                dispatch((0, $5xV4Q.socketDisconnected)());
            });
            setSocket(localSocket);
            (0, $rbG4f.registerSocket)(localSocket);
        };
        initSocket();
    }, [
        isGuest,
        handle,
        dispatch
    ]);
    return null;
}
var $a530c20420a15eba$export$2e2bcd8739ae039 = $a530c20420a15eba$var$SyncManager;



var $jXEQt = parcelRequire("jXEQt");

var $ioiHS = parcelRequire("ioiHS");
var $58f6eb176a8e0dfb$exports = {};
$58f6eb176a8e0dfb$exports = $parcel$resolve("kHABB");


function $8cc33608117774ed$export$6503ec6e8aabbaf(config) {
    navigator.serviceWorker.register($58f6eb176a8e0dfb$exports).then((registration)=>{
        if (config?.onReady) config.onReady(registration);
        if (registration.waiting) {
            if (config?.onUpdate) config.onUpdate(registration);
        }
        registration.onupdatefound = ()=>{
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = ()=>{
                if (installingWorker.state === 'installed') {
                    if (navigator.serviceWorker.controller) {
                        console.log('New content is available and will be used when all tabs for this page are closed');
                        if (config?.onUpdate) config.onUpdate(registration);
                    } else {
                        console.log('Content is cached for offline use.');
                        if (config?.onSuccess) config.onSuccess(registration);
                    }
                }
            };
        };
    }).catch((error)=>{
        console.error('Error during service worker registration:', error);
    });
}
function $8cc33608117774ed$export$d07f55d4c15c0440() {
    if ('serviceWorker' in navigator) navigator.serviceWorker.ready.then((registration)=>{
        registration.unregister();
    }).catch((error)=>{
        console.error(error.message);
    });
}



var $4EGLj = parcelRequire("4EGLj");

var $eS20P = parcelRequire("eS20P");

var $GLFsL = parcelRequire("GLFsL");
const $df8cf38ef266cdfe$var$debug = (0, $ioiHS.debugClient)('update');
// TODO: benchmark this and see if it's actually worth it
// the idea is that your browser can concentrate on loading the app and do this later
// unclear if this makes a meaningful difference to performance though
const $df8cf38ef266cdfe$var$INITIALIZATION_DELAY = 5000;
const $df8cf38ef266cdfe$var$UPDATE_CHECK_INTERVAL = 14400000;
function $df8cf38ef266cdfe$var$UpdateManager() {
    const dispatch = (0, $4EGLj.useDispatch)();
    const lastChecked = (0, $4EGLj.useSelector)((state)=>state.update.lastChecked);
    // Track when registration becomes available for the update check effect
    const [registrationReady, setRegistrationReady] = (0, $jXEQt.useState)(false);
    (0, $jXEQt.useEffect)(()=>{
        const updateCheck = async ()=>{
            const registration = (0, $eS20P.getRegistration)();
            if (registrationReady && registration && !lastChecked) {
                $df8cf38ef266cdfe$var$debug('checking for updates');
                const reg = await registration.update();
                if (reg?.waiting) dispatch((0, $GLFsL.updateReadyToInstall)());
                else dispatch((0, $GLFsL.noUpdateReady)());
            }
        };
        updateCheck();
    }, [
        dispatch,
        lastChecked,
        registrationReady
    ]);
    (0, $jXEQt.useEffect)(()=>{
        const initializeServiceWorker = ()=>{
            navigator.serviceWorker.onmessage = (event)=>{
                if (event?.data?.type === 'reload_ready') window.location.reload();
            };
            $8cc33608117774ed$export$6503ec6e8aabbaf({
                onUpdate: ()=>{
                    $df8cf38ef266cdfe$var$debug('update is possible');
                    dispatch((0, $GLFsL.updateReadyToInstall)());
                },
                onReady: (reg)=>{
                    $df8cf38ef266cdfe$var$debug('service worker registered successfully');
                    dispatch((0, $GLFsL.noUpdateReady)());
                    (0, $eS20P.setRegistration)(reg);
                    setRegistrationReady(true);
                    setInterval(()=>{
                        dispatch((0, $GLFsL.checkForUpdate)());
                    }, $df8cf38ef266cdfe$var$UPDATE_CHECK_INTERVAL);
                }
            });
        };
        setTimeout(initializeServiceWorker, $df8cf38ef266cdfe$var$INITIALIZATION_DELAY);
    }, [
        dispatch
    ]);
    return null;
}
var $df8cf38ef266cdfe$export$2e2bcd8739ae039 = $df8cf38ef266cdfe$var$UpdateManager;



var $7rM61 = parcelRequire("7rM61");
var $67f0b7290f312aa9$exports = {};
"use strict";
Object.defineProperty($67f0b7290f312aa9$exports, "__esModule", {
    value: true
});
$67f0b7290f312aa9$exports.parseCookie = $67f0b7290f312aa9$var$parseCookie;
$67f0b7290f312aa9$exports.parse = $67f0b7290f312aa9$var$parseCookie;
$67f0b7290f312aa9$exports.stringifyCookie = $67f0b7290f312aa9$var$stringifyCookie;
$67f0b7290f312aa9$exports.stringifySetCookie = $67f0b7290f312aa9$var$stringifySetCookie;
$67f0b7290f312aa9$exports.serialize = $67f0b7290f312aa9$var$stringifySetCookie;
$67f0b7290f312aa9$exports.parseSetCookie = $67f0b7290f312aa9$var$parseSetCookie;
$67f0b7290f312aa9$exports.stringifySetCookie = $67f0b7290f312aa9$var$stringifySetCookie;
$67f0b7290f312aa9$exports.serialize = $67f0b7290f312aa9$var$stringifySetCookie;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $67f0b7290f312aa9$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $67f0b7290f312aa9$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $67f0b7290f312aa9$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $67f0b7290f312aa9$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
/**
 * RegExp to match max-age-value in RFC 6265 sec 5.6.2
 */ const $67f0b7290f312aa9$var$maxAgeRegExp = /^-?\d+$/;
const $67f0b7290f312aa9$var$__toString = Object.prototype.toString;
const $67f0b7290f312aa9$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a `Cookie` header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $67f0b7290f312aa9$var$parseCookie(str, options) {
    const obj = new $67f0b7290f312aa9$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $67f0b7290f312aa9$var$decode;
    let index = 0;
    do {
        const eqIdx = $67f0b7290f312aa9$var$eqIndex(str, index, len);
        if (eqIdx === -1) break; // No more cookie pairs.
        const endIdx = $67f0b7290f312aa9$var$endIndex(str, index, len);
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = $67f0b7290f312aa9$var$valueSlice(str, index, eqIdx);
        // only assign once
        if (obj[key] === undefined) obj[key] = dec($67f0b7290f312aa9$var$valueSlice(str, eqIdx + 1, endIdx));
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
/**
 * Stringifies an object into an HTTP `Cookie` header.
 */ function $67f0b7290f312aa9$var$stringifyCookie(cookie, options) {
    const enc = options?.encode || encodeURIComponent;
    const cookieStrings = [];
    for (const name of Object.keys(cookie)){
        const val = cookie[name];
        if (val === undefined) continue;
        if (!$67f0b7290f312aa9$var$cookieNameRegExp.test(name)) throw new TypeError(`cookie name is invalid: ${name}`);
        const value = enc(val);
        if (!$67f0b7290f312aa9$var$cookieValueRegExp.test(value)) throw new TypeError(`cookie val is invalid: ${val}`);
        cookieStrings.push(`${name}=${value}`);
    }
    return cookieStrings.join("; ");
}
function $67f0b7290f312aa9$var$stringifySetCookie(_name, _val, _opts) {
    const cookie = typeof _name === "object" ? _name : {
        ..._opts,
        name: _name,
        value: String(_val)
    };
    const options = typeof _val === "object" ? _val : _opts;
    const enc = options?.encode || encodeURIComponent;
    if (!$67f0b7290f312aa9$var$cookieNameRegExp.test(cookie.name)) throw new TypeError(`argument name is invalid: ${cookie.name}`);
    const value = cookie.value ? enc(cookie.value) : "";
    if (!$67f0b7290f312aa9$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${cookie.value}`);
    let str = cookie.name + "=" + value;
    if (cookie.maxAge !== undefined) {
        if (!Number.isInteger(cookie.maxAge)) throw new TypeError(`option maxAge is invalid: ${cookie.maxAge}`);
        str += "; Max-Age=" + cookie.maxAge;
    }
    if (cookie.domain) {
        if (!$67f0b7290f312aa9$var$domainValueRegExp.test(cookie.domain)) throw new TypeError(`option domain is invalid: ${cookie.domain}`);
        str += "; Domain=" + cookie.domain;
    }
    if (cookie.path) {
        if (!$67f0b7290f312aa9$var$pathValueRegExp.test(cookie.path)) throw new TypeError(`option path is invalid: ${cookie.path}`);
        str += "; Path=" + cookie.path;
    }
    if (cookie.expires) {
        if (!$67f0b7290f312aa9$var$isDate(cookie.expires) || !Number.isFinite(cookie.expires.valueOf())) throw new TypeError(`option expires is invalid: ${cookie.expires}`);
        str += "; Expires=" + cookie.expires.toUTCString();
    }
    if (cookie.httpOnly) str += "; HttpOnly";
    if (cookie.secure) str += "; Secure";
    if (cookie.partitioned) str += "; Partitioned";
    if (cookie.priority) {
        const priority = typeof cookie.priority === "string" ? cookie.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${cookie.priority}`);
        }
    }
    if (cookie.sameSite) {
        const sameSite = typeof cookie.sameSite === "string" ? cookie.sameSite.toLowerCase() : cookie.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${cookie.sameSite}`);
        }
    }
    return str;
}
/**
 * Deserialize a `Set-Cookie` header into an object.
 *
 * deserialize('foo=bar; httpOnly')
 *   => { name: 'foo', value: 'bar', httpOnly: true }
 */ function $67f0b7290f312aa9$var$parseSetCookie(str, options) {
    const dec = options?.decode || $67f0b7290f312aa9$var$decode;
    const len = str.length;
    const endIdx = $67f0b7290f312aa9$var$endIndex(str, 0, len);
    const eqIdx = $67f0b7290f312aa9$var$eqIndex(str, 0, endIdx);
    const setCookie = eqIdx === -1 ? {
        name: "",
        value: dec($67f0b7290f312aa9$var$valueSlice(str, 0, endIdx))
    } : {
        name: $67f0b7290f312aa9$var$valueSlice(str, 0, eqIdx),
        value: dec($67f0b7290f312aa9$var$valueSlice(str, eqIdx + 1, endIdx))
    };
    let index = endIdx + 1;
    while(index < len){
        const endIdx = $67f0b7290f312aa9$var$endIndex(str, index, len);
        const eqIdx = $67f0b7290f312aa9$var$eqIndex(str, index, endIdx);
        const attr = eqIdx === -1 ? $67f0b7290f312aa9$var$valueSlice(str, index, endIdx) : $67f0b7290f312aa9$var$valueSlice(str, index, eqIdx);
        const val = eqIdx === -1 ? undefined : $67f0b7290f312aa9$var$valueSlice(str, eqIdx + 1, endIdx);
        switch(attr.toLowerCase()){
            case "httponly":
                setCookie.httpOnly = true;
                break;
            case "secure":
                setCookie.secure = true;
                break;
            case "partitioned":
                setCookie.partitioned = true;
                break;
            case "domain":
                setCookie.domain = val;
                break;
            case "path":
                setCookie.path = val;
                break;
            case "max-age":
                if (val && $67f0b7290f312aa9$var$maxAgeRegExp.test(val)) setCookie.maxAge = Number(val);
                break;
            case "expires":
                if (!val) break;
                const date = new Date(val);
                if (Number.isFinite(date.valueOf())) setCookie.expires = date;
                break;
            case "priority":
                if (!val) break;
                const priority = val.toLowerCase();
                if (priority === "low" || priority === "medium" || priority === "high") setCookie.priority = priority;
                break;
            case "samesite":
                if (!val) break;
                const sameSite = val.toLowerCase();
                if (sameSite === "lax" || sameSite === "strict" || sameSite === "none") setCookie.sameSite = sameSite;
                break;
        }
        index = endIdx + 1;
    }
    return setCookie;
}
/**
 * Find the `;` character between `min` and `len` in str.
 */ function $67f0b7290f312aa9$var$endIndex(str, min, len) {
    const index = str.indexOf(";", min);
    return index === -1 ? len : index;
}
/**
 * Find the `=` character between `min` and `max` in str.
 */ function $67f0b7290f312aa9$var$eqIndex(str, min, max) {
    const index = str.indexOf("=", min);
    return index < max ? index : -1;
}
/**
 * Slice out a value between startPod to max.
 */ function $67f0b7290f312aa9$var$valueSlice(str, min, max) {
    let start = min;
    let end = max;
    do {
        const code = str.charCodeAt(start);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
    }while (++start < end);
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
        end--;
    }
    return str.slice(start, end);
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $67f0b7290f312aa9$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $67f0b7290f312aa9$var$isDate(val) {
    return $67f0b7290f312aa9$var$__toString.call(val) === "[object Date]";
}



var $jXEQt = parcelRequire("jXEQt");

var $ioiHS = parcelRequire("ioiHS");

var $7rM61 = parcelRequire("7rM61");

var $9AB1p = parcelRequire("9AB1p");
var $ab5Dn = parcelRequire("ab5Dn");
const $9e8f868fa914def9$var$Loading = ({ open: open })=>{
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $9AB1p.default), {
        sx: {
            color: '#fff',
            zIndex: (theme)=>theme.zIndex.drawer + 1
        },
        open: open !== undefined ? open : true,
        children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $ab5Dn.default), {})
    });
};
var $9e8f868fa914def9$export$2e2bcd8739ae039 = $9e8f868fa914def9$var$Loading;



var $4EGLj = parcelRequire("4EGLj");

var $gi5DA = parcelRequire("gi5DA");
const $48d0fad962f4c1ae$var$debug = (0, $ioiHS.debugClient)('auth');
const $48d0fad962f4c1ae$var$UserProvider = ({ children: children })=>{
    const dispatch = (0, $4EGLj.useDispatch)();
    const user = (0, $4EGLj.useSelector)((state)=>state.user.value);
    (0, $jXEQt.useEffect)(()=>{
        // Check the server for authentication against the server-side cookie
        async function networkCheck() {
            $48d0fad962f4c1ae$var$debug('server authentication check');
            const controller = new AbortController();
            const timeoutId = setTimeout(()=>controller.abort(), 1000);
            try {
                const response = await fetch('/api/auth', {
                    signal: controller.signal,
                    headers: {
                        'Cache-Control': 'no-cache'
                    }
                });
                clearTimeout(timeoutId);
                if (!response.ok) {
                    if (response.status === 401) {
                        // authentication failed, either because they have no cookie or because it's wrong / outdated
                        $48d0fad962f4c1ae$var$debug('server authentication check failed');
                        return 'auth_error';
                    }
                    $48d0fad962f4c1ae$var$debug(`network issues: HTTP ${response.status}`);
                    return undefined;
                }
                $48d0fad962f4c1ae$var$debug('got valid server response');
                return await response.json();
            } catch (error) {
                clearTimeout(timeoutId);
                if (error instanceof Error && error.name === 'AbortError') $48d0fad962f4c1ae$var$debug('server authentication check timed out');
                else console.error('unexpected error in networkCheck', error);
            }
        }
        // Parse the user from the client-side cookie.
        function localCookieCheck() {
            $48d0fad962f4c1ae$var$debug('local cookie check');
            try {
                // 's:j:{...data...}.<secret-signed-signature>'
                const clientCookie = (0, (/*@__PURE__*/$parcel$interopDefault($67f0b7290f312aa9$exports))).parse(document.cookie)['sanremo-client'];
                if (clientCookie) {
                    // '{...data...}.<secret-signed-signature>'
                    const frontStripped = clientCookie.slice(4);
                    // '{...data...}'
                    const backStripped = frontStripped.slice(0, frontStripped.lastIndexOf('.'));
                    const user = JSON.parse(backStripped);
                    return user;
                }
                // no client cookie at all means not logged in
                $48d0fad962f4c1ae$var$debug('no local cookie found');
            } catch (error) {
                // Something went wrong with parsing. This indicates a bug or nefarious behaviour.
                // Treat as logged out, though maybe we should consider something stronger here.
                $48d0fad962f4c1ae$var$debug('failed to parse cookie, corrupted?');
                console.error('Failed to parse user from client cookie', error);
            }
        }
        async function determineUserState() {
            const localUserCheck = localCookieCheck();
            const serverUserCheck = await networkCheck();
            if (!localUserCheck) {
                // Intentionally not logged in
                $48d0fad962f4c1ae$var$debug('not logged in, proceeding as guest');
                dispatch((0, $gi5DA.setUserAsGuest)());
            } else if (!serverUserCheck) {
                // Offline with a valid local user
                $48d0fad962f4c1ae$var$debug('probably offline with valid local user, proceeding as user');
                dispatch((0, $gi5DA.setUserAsLoggedIn)({
                    user: localUserCheck
                }));
            } else if (serverUserCheck === 'auth_error') {
                // Server auth was unsuccessful, but we have a valid local (and thus insecure) cookie:
                //     This could imply normal things: the user being offline for weeks, the server changing secrets
                //     Or it could imply someone trying to log in with a stolen local cookie
                // TODO: check for the existence of a local database. If it doesn't exist, that means the user is a bad hacker man probably
                //       This isn't really a security issue: they still don't have server access, and if they have access to the client machine
                //       they have access to any indexeddb data on their regardless of cookie hacks.
                //       Worst case this is a weird logic issue: steal userA's local cookie, deploy it write to sanremo-a, then log in as userB
                //       and "lose" your work against sanremo-a as you'll now use sanremo-b.
                // For now though, proceed like it's valid, but mark the user as requiring re-auth with the server
                $48d0fad962f4c1ae$var$debug('server auth unsuccessful, local cookie valid, proceeding as user on existing local data');
                dispatch((0, $gi5DA.setUserAsLoggedIn)({
                    user: localUserCheck,
                    needsServerAuthentication: true
                }));
            } else {
                // Server auth (+ client cookie as it's validated on the server) was successful
                $48d0fad962f4c1ae$var$debug('online with validated user, proceeding as user');
                dispatch((0, $gi5DA.setUserAsLoggedIn)({
                    user: serverUserCheck
                }));
            }
        }
        determineUserState();
    }, [
        dispatch
    ]);
    // TODO: collapse these returns into one
    // This will look much nicer as the children will render in the background while we wait for the network
    // However, either we default to a guest while we wait for the network, or we change all components to support no database
    if (user === undefined) return /*#__PURE__*/ (0, $7rM61.jsx)((0, $9e8f868fa914def9$export$2e2bcd8739ae039), {});
    // Fragment needed here for type compatibility
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $jXEQt.Fragment), {
        children: children
    });
};
var $48d0fad962f4c1ae$export$2e2bcd8739ae039 = $48d0fad962f4c1ae$var$UserProvider;



var $gi5DA = parcelRequire("gi5DA");


var $4EGLj = parcelRequire("4EGLj");

var $7rM61 = parcelRequire("7rM61");

var $jXEQt = parcelRequire("jXEQt");


var $2KJEQ = parcelRequire("2KJEQ");

var $5MTiZ = parcelRequire("5MTiZ");

var $7rM61 = parcelRequire("7rM61");
'use client';
const $3abb06978ddc4590$var$isDynamicSupport = typeof (0, $2KJEQ.globalCss)({}) === 'function';
const $3abb06978ddc4590$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
const $3abb06978ddc4590$export$32180ef41b15b513 = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $3abb06978ddc4590$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $3abb06978ddc4590$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$3abb06978ddc4590$export$32180ef41b15b513(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
const $3abb06978ddc4590$var$SELECTOR = 'mui-ecs';
const $3abb06978ddc4590$var$staticStyles = (theme)=>{
    const result = $3abb06978ddc4590$export$9dd6ff9ea0189349(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$3abb06978ddc4590$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$3abb06978ddc4590$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$3abb06978ddc4590$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $3abb06978ddc4590$var$GlobalStyles = (0, $2KJEQ.globalCss)($3abb06978ddc4590$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$3abb06978ddc4590$export$9dd6ff9ea0189349(theme, enableColorScheme) : ({ theme: theme })=>$3abb06978ddc4590$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $3abb06978ddc4590$var$CssBaseline(inProps) {
    const props = (0, $5MTiZ.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $7rM61.jsxs)($jXEQt.Fragment, {
        children: [
            $3abb06978ddc4590$var$isDynamicSupport && /*#__PURE__*/ (0, $7rM61.jsx)($3abb06978ddc4590$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$3abb06978ddc4590$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $7rM61.jsx)("span", {
                className: $3abb06978ddc4590$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $3abb06978ddc4590$export$2e2bcd8739ae039 = $3abb06978ddc4590$var$CssBaseline;



var $8sdmv = parcelRequire("8sdmv");
var $dAPbx = parcelRequire("dAPbx");
var $jXEQt = parcelRequire("jXEQt");
parcelRequire("jXEQt");

var $jXEQt = parcelRequire("jXEQt");


var $jXEQt = parcelRequire("jXEQt");



var $jXEQt = parcelRequire("jXEQt");
'use client';
const $200112168b5ff966$var$ThemeContext = /*#__PURE__*/ $jXEQt.createContext(null);
var $200112168b5ff966$export$2e2bcd8739ae039 = $200112168b5ff966$var$ThemeContext;



var $jXEQt = parcelRequire("jXEQt");

'use client';
function $83026da6fcc23604$export$2e2bcd8739ae039() {
    const theme = $jXEQt.useContext((0, $200112168b5ff966$export$2e2bcd8739ae039));
    return theme;
}


const $ee81260a5d08e80f$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $ee81260a5d08e80f$export$2e2bcd8739ae039 = $ee81260a5d08e80f$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $7rM61 = parcelRequire("7rM61");
function $b9191f413bbfa78b$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $b9191f413bbfa78b$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $83026da6fcc23604$export$2e2bcd8739ae039)();
    const theme = $jXEQt.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $b9191f413bbfa78b$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $ee81260a5d08e80f$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $200112168b5ff966$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $b9191f413bbfa78b$export$2e2bcd8739ae039 = $b9191f413bbfa78b$var$ThemeProvider;



parcelRequire("IRdXs");
var $h1PbY = parcelRequire("h1PbY");

var $dDbWc = parcelRequire("dDbWc");

var $39dKT = parcelRequire("39dKT");

var $k6Apu = parcelRequire("k6Apu");

var $dbTJ5 = parcelRequire("dbTJ5");

var $ab4rY = parcelRequire("ab4rY");

var $e7ggv = parcelRequire("e7ggv");

var $dDbWc = parcelRequire("dDbWc");

var $7rM61 = parcelRequire("7rM61");
function $0a70073151fcba34$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $dDbWc.default)();
    const id = (0, $ab4rY.default)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $dbTJ5.default)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $e7ggv.default), {
        styles: layerOrder
    });
}



var $7rM61 = parcelRequire("7rM61");
'use client';
const $3c1400c95e5ffb30$var$EMPTY_THEME = {};
function $3c1400c95e5ffb30$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $jXEQt.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $3c1400c95e5ffb30$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $dDbWc.default)($3c1400c95e5ffb30$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $83026da6fcc23604$export$2e2bcd8739ae039)() || $3c1400c95e5ffb30$var$EMPTY_THEME;
    const engineTheme = $3c1400c95e5ffb30$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $3c1400c95e5ffb30$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $0a70073151fcba34$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $b9191f413bbfa78b$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $h1PbY.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $39dKT.default), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $7rM61.jsxs)((0, $k6Apu.default), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $3c1400c95e5ffb30$export$2e2bcd8739ae039 = $3c1400c95e5ffb30$var$ThemeProvider;



var $lyEQv = parcelRequire("lyEQv");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $0f38c8a8f2f68c02$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $lyEQv.default) in themeInput ? themeInput[0, $lyEQv.default] : undefined;
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $3c1400c95e5ffb30$export$2e2bcd8739ae039), {
        ...props,
        themeId: scopedTheme ? (0, $lyEQv.default) : undefined,
        theme: scopedTheme || themeInput
    });
}



var $iBnPH = parcelRequire("iBnPH");

var $jXEQt = parcelRequire("jXEQt");


var $8QDCO = parcelRequire("8QDCO");


var $dbTJ5 = parcelRequire("dbTJ5");


var $7rM61 = parcelRequire("7rM61");
const $98449b8faa4b448a$export$ff0fa3047d11164c = 'mode';
const $98449b8faa4b448a$export$665054ea9d94dab9 = 'color-scheme';
const $98449b8faa4b448a$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $98449b8faa4b448a$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $98449b8faa4b448a$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $98449b8faa4b448a$export$665054ea9d94dab9, attribute: initialAttribute = $98449b8faa4b448a$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else if (attribute !== '.%s') setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $7rM61.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $jXEQt = parcelRequire("jXEQt");

function $1fea887966fa16e6$var$noop() {}
const $1fea887966fa16e6$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $1fea887966fa16e6$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $1fea887966fa16e6$export$2e2bcd8739ae039 = $1fea887966fa16e6$var$localStorageManager;


'use client';
function $88a56742b8276057$var$noop() {}
function $88a56742b8276057$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $88a56742b8276057$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $88a56742b8276057$export$3caa7590cc1987bd(state) {
    return $88a56742b8276057$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $88a56742b8276057$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $98449b8faa4b448a$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $98449b8faa4b448a$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $1fea887966fa16e6$export$2e2bcd8739ae039), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $jXEQt.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $jXEQt.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $jXEQt.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $jXEQt.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $88a56742b8276057$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $jXEQt.useState(noSsr || !isMultiSchemes);
    $jXEQt.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $88a56742b8276057$export$3caa7590cc1987bd(state);
    const setMode = $jXEQt.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $88a56742b8276057$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $jXEQt.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $88a56742b8276057$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $jXEQt.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $jXEQt.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $jXEQt.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $jXEQt.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $88a56742b8276057$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $88a56742b8276057$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $88a56742b8276057$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}



var $7rM61 = parcelRequire("7rM61");
'use client';
const $527fee34976adbd2$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $527fee34976adbd2$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $98449b8faa4b448a$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $98449b8faa4b448a$export$665054ea9d94dab9), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $jXEQt.createContext(undefined);
    const useColorScheme = ()=>$jXEQt.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $jXEQt.useRef(false);
        const upperTheme = (0, $83026da6fcc23604$export$2e2bcd8739ae039)();
        const ctx = $jXEQt.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $jXEQt.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $jXEQt.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $88a56742b8276057$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $jXEQt.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $dbTJ5.default)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $jXEQt.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($527fee34976adbd2$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $jXEQt.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $jXEQt.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $7rM61.jsxs)($jXEQt.Fragment, {
            children: [
                /*#__PURE__*/ (0, $7rM61.jsx)((0, $3c1400c95e5ffb30$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $7rM61.jsx)((0, $8QDCO.default), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $7rM61.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $98449b8faa4b448a$export$2e2bcd8739ae039)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}



var $8sdmv = parcelRequire("8sdmv");

var $bzMhy = parcelRequire("bzMhy");

var $lyEQv = parcelRequire("lyEQv");



var $7rM61 = parcelRequire("7rM61");
const $4ba77e56018a7e20$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function $4ba77e56018a7e20$var$InitColorSchemeScript(props) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = $4ba77e56018a7e20$export$f84bd70098573c5c.defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme = $4ba77e56018a7e20$export$f84bd70098573c5c.defaultDarkColorScheme, modeStorageKey: modeStorageKey = $4ba77e56018a7e20$export$f84bd70098573c5c.modeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = $4ba77e56018a7e20$export$f84bd70098573c5c.colorSchemeStorageKey, attribute: initialAttribute = $4ba77e56018a7e20$export$f84bd70098573c5c.attribute, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = props;
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $98449b8faa4b448a$export$2e2bcd8739ae039), {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var $4ba77e56018a7e20$export$2e2bcd8739ae039 = $4ba77e56018a7e20$var$InitColorSchemeScript;



var $7rM61 = parcelRequire("7rM61");
'use client';
const { CssVarsProvider: $a2887729f2708b79$var$InternalCssVarsProvider, useColorScheme: $a2887729f2708b79$export$6343629ee1b29116, getInitColorSchemeScript: $a2887729f2708b79$var$deprecatedGetInitColorSchemeScript } = (0, $527fee34976adbd2$export$2e2bcd8739ae039)({
    themeId: (0, $lyEQv.default),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $8sdmv.default)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $4ba77e56018a7e20$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $4ba77e56018a7e20$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $4ba77e56018a7e20$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $4ba77e56018a7e20$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $bzMhy.default)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $iBnPH.default)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $a2887729f2708b79$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $a2887729f2708b79$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $7rM61.jsx)($a2887729f2708b79$var$InternalCssVarsProvider, {
        ...props
    });
}
let $a2887729f2708b79$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $a2887729f2708b79$export$f9a57b4a2abf8ed = (params)=>{
    if (!$a2887729f2708b79$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $a2887729f2708b79$var$warnedInitScriptOnce = true;
    }
    return $a2887729f2708b79$var$deprecatedGetInitColorSchemeScript(params);
};
const $a2887729f2708b79$export$50ec01b133c61652 = $a2887729f2708b79$var$InternalCssVarsProvider;



var $lyEQv = parcelRequire("lyEQv");

var $7rM61 = parcelRequire("7rM61");
'use client';
function $f4664ba7086ec4aa$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    const noVarsTheme = $jXEQt.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $lyEQv.default) in theme ? theme[0, $lyEQv.default] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $7rM61.jsx)((0, $0f38c8a8f2f68c02$export$2e2bcd8739ae039), {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $a2887729f2708b79$export$50ec01b133c61652), {
        theme: theme,
        ...props
    });
}


const $83c547d0d4be915e$var$theme = (0, $8sdmv.default)({
    palette: {
        primary: {
            main: '#f5df4d'
        },
        secondary: {
            main: '#939597'
        }
    }
});
const $83c547d0d4be915e$var$Themed = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7rM61.jsx)((0, $dAPbx.default), {
        injectFirst: true,
        children: /*#__PURE__*/ (0, $7rM61.jsxs)((0, $f4664ba7086ec4aa$export$2e2bcd8739ae039), {
            theme: $83c547d0d4be915e$var$theme,
            children: [
                /*#__PURE__*/ (0, $7rM61.jsx)((0, $3abb06978ddc4590$export$2e2bcd8739ae039), {}),
                children
            ]
        })
    });
};
var $83c547d0d4be915e$export$2e2bcd8739ae039 = $83c547d0d4be915e$var$Themed;



const $bc13ce4feb9d2333$var$About = /*#__PURE__*/ (0, $jXEQt.lazy)(()=>(parcelRequire("hrh4V")));

const $bc13ce4feb9d2333$var$History = /*#__PURE__*/ (0, $jXEQt.lazy)(()=>(parcelRequire("cFYuO")));

const $bc13ce4feb9d2333$var$Home = /*#__PURE__*/ (0, $jXEQt.lazy)(()=>(parcelRequire("c7ZIy")));

const $bc13ce4feb9d2333$var$Repeatable = /*#__PURE__*/ (0, $jXEQt.lazy)(()=>(parcelRequire("9Es5b")));

const $bc13ce4feb9d2333$var$Template = /*#__PURE__*/ (0, $jXEQt.lazy)(()=>(parcelRequire("94Evl")));
function $bc13ce4feb9d2333$var$App() {
    const isGuest = (0, $4EGLj.useSelector)((0, $gi5DA.selectIsGuest));
    return /*#__PURE__*/ (0, $7rM61.jsxs)((0, $83c547d0d4be915e$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $df8cf38ef266cdfe$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7rM61.jsx)((0, $48d0fad962f4c1ae$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7rM61.jsxs)((0, $4a0fd26d5ccde34c$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $a530c20420a15eba$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $621415f2107ea2be$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $jXEQt.Suspense), {
                                fallback: /*#__PURE__*/ (0, $7rM61.jsx)((0, $9e8f868fa914def9$export$2e2bcd8739ae039), {}),
                                children: /*#__PURE__*/ (0, $7rM61.jsxs)((0, $4Tpzr.Routes), {
                                    children: [
                                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $4Tpzr.Route), {
                                            path: "about",
                                            element: /*#__PURE__*/ (0, $7rM61.jsx)($bc13ce4feb9d2333$var$About, {})
                                        }),
                                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $4Tpzr.Route), {
                                            path: "repeatable/:repeatableId",
                                            element: /*#__PURE__*/ (0, $7rM61.jsx)($bc13ce4feb9d2333$var$Repeatable, {})
                                        }),
                                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $4Tpzr.Route), {
                                            path: "template/:templateId",
                                            element: /*#__PURE__*/ (0, $7rM61.jsx)($bc13ce4feb9d2333$var$Template, {})
                                        }),
                                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $4Tpzr.Route), {
                                            path: "template/:templateId/from/:repeatableId",
                                            element: /*#__PURE__*/ (0, $7rM61.jsx)($bc13ce4feb9d2333$var$Template, {})
                                        }),
                                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $4Tpzr.Route), {
                                            path: "history",
                                            element: /*#__PURE__*/ (0, $7rM61.jsx)($bc13ce4feb9d2333$var$History, {})
                                        }),
                                        /*#__PURE__*/ (0, $7rM61.jsx)((0, $4Tpzr.Route), {
                                            path: "*",
                                            element: /*#__PURE__*/ (0, $7rM61.jsx)($bc13ce4feb9d2333$var$Home, {})
                                        })
                                    ]
                                })
                            })
                        }),
                        isGuest && /*#__PURE__*/ (0, $7rM61.jsx)((0, $1MCB7.default), {
                            align: "center",
                            variant: "caption",
                            color: "textSecondary",
                            display: "block",
                            children: "Data only stored in this browser. Create an account to enable access from other devices."
                        })
                    ]
                })
            })
        ]
    });
}
var $bc13ce4feb9d2333$export$2e2bcd8739ae039 = $bc13ce4feb9d2333$var$App;



var $4EGLj = parcelRequire("4EGLj");
const $b80123aa3453b856$var$container = document.getElementById('root');
if ($b80123aa3453b856$var$container) {
    const root = (0, $bb6cb2ce16bd7b19$exports.createRoot)($b80123aa3453b856$var$container);
    root.render(/*#__PURE__*/ (0, $7rM61.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jXEQt))).StrictMode, {
        children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $bw3ua.Provider), {
            store: (0, $4EGLj.default),
            children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $4Tpzr.BrowserRouter), {
                children: /*#__PURE__*/ (0, $7rM61.jsx)((0, $bc13ce4feb9d2333$export$2e2bcd8739ae039), {})
            })
        })
    }));
}


//# sourceMappingURL=client.54e30b9a.js.map
